webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.BrowserSpriteSymbol = factory());
}(this, (function () { 'use strict';

var SpriteSymbol = function SpriteSymbol(ref) {
  var id = ref.id;
  var viewBox = ref.viewBox;
  var content = ref.content;

  this.id = id;
  this.viewBox = viewBox;
  this.content = content;
};

/**
 * @return {string}
 */
SpriteSymbol.prototype.stringify = function stringify () {
  return this.content;
};

/**
 * @return {string}
 */
SpriteSymbol.prototype.toString = function toString () {
  return this.stringify();
};

SpriteSymbol.prototype.destroy = function destroy () {
    var this$1 = this;

  ['id', 'viewBox', 'content'].forEach(function (prop) { return delete this$1[prop]; });
};

/**
 * @param {string} content
 * @return {Element}
 */
var parse = function (content) {
  var hasImportNode = !!document.importNode;
  var doc = new DOMParser().parseFromString(content, 'image/svg+xml').documentElement;

  /**
   * Fix for browser which are throwing WrongDocumentError
   * if you insert an element which is not part of the document
   * @see http://stackoverflow.com/a/7986519/4624403
   */
  if (hasImportNode) {
    return document.importNode(doc, true);
  }

  return doc;
};

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};





function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var deepmerge = createCommonjsModule(function (module, exports) {
(function (root, factory) {
    if (false) {
        undefined(factory);
    } else {
        module.exports = factory();
    }
}(commonjsGlobal, function () {

function isMergeableObject(val) {
    var nonNullObject = val && typeof val === 'object';

    return nonNullObject
        && Object.prototype.toString.call(val) !== '[object RegExp]'
        && Object.prototype.toString.call(val) !== '[object Date]'
}

function emptyTarget(val) {
    return Array.isArray(val) ? [] : {}
}

function cloneIfNecessary(value, optionsArgument) {
    var clone = optionsArgument && optionsArgument.clone === true;
    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
}

function defaultArrayMerge(target, source, optionsArgument) {
    var destination = target.slice();
    source.forEach(function(e, i) {
        if (typeof destination[i] === 'undefined') {
            destination[i] = cloneIfNecessary(e, optionsArgument);
        } else if (isMergeableObject(e)) {
            destination[i] = deepmerge(target[i], e, optionsArgument);
        } else if (target.indexOf(e) === -1) {
            destination.push(cloneIfNecessary(e, optionsArgument));
        }
    });
    return destination
}

function mergeObject(target, source, optionsArgument) {
    var destination = {};
    if (isMergeableObject(target)) {
        Object.keys(target).forEach(function (key) {
            destination[key] = cloneIfNecessary(target[key], optionsArgument);
        });
    }
    Object.keys(source).forEach(function (key) {
        if (!isMergeableObject(source[key]) || !target[key]) {
            destination[key] = cloneIfNecessary(source[key], optionsArgument);
        } else {
            destination[key] = deepmerge(target[key], source[key], optionsArgument);
        }
    });
    return destination
}

function deepmerge(target, source, optionsArgument) {
    var array = Array.isArray(source);
    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
    var arrayMerge = options.arrayMerge || defaultArrayMerge;

    if (array) {
        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument)
    } else {
        return mergeObject(target, source, optionsArgument)
    }
}

deepmerge.all = function deepmergeAll(array, optionsArgument) {
    if (!Array.isArray(array) || array.length < 2) {
        throw new Error('first argument should be an array with at least two elements')
    }

    // we are sure there are at least 2 values, so it is safe to have no initial value
    return array.reduce(function(prev, next) {
        return deepmerge(prev, next, optionsArgument)
    })
};

return deepmerge

}));
});

var namespaces_1 = createCommonjsModule(function (module, exports) {
var namespaces = {
  svg: {
    name: 'xmlns',
    uri: 'http://www.w3.org/2000/svg'
  },
  xlink: {
    name: 'xmlns:xlink',
    uri: 'http://www.w3.org/1999/xlink'
  }
};

exports.default = namespaces;
module.exports = exports.default;
});

/**
 * @param {Object} attrs
 * @return {string}
 */
var objectToAttrsString = function (attrs) {
  return Object.keys(attrs).map(function (attr) {
    var value = attrs[attr].toString().replace(/"/g, '&quot;');
    return (attr + "=\"" + value + "\"");
  }).join(' ');
};

var svg = namespaces_1.svg;
var xlink = namespaces_1.xlink;

var defaultAttrs = {};
defaultAttrs[svg.name] = svg.uri;
defaultAttrs[xlink.name] = xlink.uri;

/**
 * @param {string} [content]
 * @param {Object} [attributes]
 * @return {string}
 */
var wrapInSvgString = function (content, attributes) {
  if ( content === void 0 ) content = '';

  var attrs = deepmerge(defaultAttrs, attributes || {});
  var attrsRendered = objectToAttrsString(attrs);
  return ("<svg " + attrsRendered + ">" + content + "</svg>");
};

var BrowserSpriteSymbol = (function (SpriteSymbol$$1) {
  function BrowserSpriteSymbol () {
    SpriteSymbol$$1.apply(this, arguments);
  }

  if ( SpriteSymbol$$1 ) BrowserSpriteSymbol.__proto__ = SpriteSymbol$$1;
  BrowserSpriteSymbol.prototype = Object.create( SpriteSymbol$$1 && SpriteSymbol$$1.prototype );
  BrowserSpriteSymbol.prototype.constructor = BrowserSpriteSymbol;

  var prototypeAccessors = { isMounted: {} };

  prototypeAccessors.isMounted.get = function () {
    return !!this.node;
  };

  /**
   * @param {Element} node
   * @return {BrowserSpriteSymbol}
   */
  BrowserSpriteSymbol.createFromExistingNode = function createFromExistingNode (node) {
    return new BrowserSpriteSymbol({
      id: node.getAttribute('id'),
      viewBox: node.getAttribute('viewBox'),
      content: node.outerHTML
    });
  };

  BrowserSpriteSymbol.prototype.destroy = function destroy () {
    if (this.isMounted) {
      this.unmount();
    }
    SpriteSymbol$$1.prototype.destroy.call(this);
  };

  /**
   * @param {Element|string} target
   * @return {Element}
   */
  BrowserSpriteSymbol.prototype.mount = function mount (target) {
    if (this.isMounted) {
      return this.node;
    }

    var mountTarget = typeof target === 'string' ? document.querySelector(target) : target;
    var node = this.render();
    this.node = node;

    mountTarget.appendChild(node);

    return node;
  };

  /**
   * @return {Element}
   */
  BrowserSpriteSymbol.prototype.render = function render () {
    var content = this.stringify();
    return parse(wrapInSvgString(content)).childNodes[0];
  };

  BrowserSpriteSymbol.prototype.unmount = function unmount () {
    this.node.parentNode.removeChild(this.node);
  };

  Object.defineProperties( BrowserSpriteSymbol.prototype, prototypeAccessors );

  return BrowserSpriteSymbol;
}(SpriteSymbol));

return BrowserSpriteSymbol;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.BrowserSprite = factory());
}(this, (function () { 'use strict';

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};





function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var index = createCommonjsModule(function (module, exports) {
(function (root, factory) {
    if (false) {
        undefined(factory);
    } else {
        module.exports = factory();
    }
}(commonjsGlobal, function () {

function isMergeableObject(val) {
    var nonNullObject = val && typeof val === 'object';

    return nonNullObject
        && Object.prototype.toString.call(val) !== '[object RegExp]'
        && Object.prototype.toString.call(val) !== '[object Date]'
}

function emptyTarget(val) {
    return Array.isArray(val) ? [] : {}
}

function cloneIfNecessary(value, optionsArgument) {
    var clone = optionsArgument && optionsArgument.clone === true;
    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
}

function defaultArrayMerge(target, source, optionsArgument) {
    var destination = target.slice();
    source.forEach(function(e, i) {
        if (typeof destination[i] === 'undefined') {
            destination[i] = cloneIfNecessary(e, optionsArgument);
        } else if (isMergeableObject(e)) {
            destination[i] = deepmerge(target[i], e, optionsArgument);
        } else if (target.indexOf(e) === -1) {
            destination.push(cloneIfNecessary(e, optionsArgument));
        }
    });
    return destination
}

function mergeObject(target, source, optionsArgument) {
    var destination = {};
    if (isMergeableObject(target)) {
        Object.keys(target).forEach(function (key) {
            destination[key] = cloneIfNecessary(target[key], optionsArgument);
        });
    }
    Object.keys(source).forEach(function (key) {
        if (!isMergeableObject(source[key]) || !target[key]) {
            destination[key] = cloneIfNecessary(source[key], optionsArgument);
        } else {
            destination[key] = deepmerge(target[key], source[key], optionsArgument);
        }
    });
    return destination
}

function deepmerge(target, source, optionsArgument) {
    var array = Array.isArray(source);
    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
    var arrayMerge = options.arrayMerge || defaultArrayMerge;

    if (array) {
        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument)
    } else {
        return mergeObject(target, source, optionsArgument)
    }
}

deepmerge.all = function deepmergeAll(array, optionsArgument) {
    if (!Array.isArray(array) || array.length < 2) {
        throw new Error('first argument should be an array with at least two elements')
    }

    // we are sure there are at least 2 values, so it is safe to have no initial value
    return array.reduce(function(prev, next) {
        return deepmerge(prev, next, optionsArgument)
    })
};

return deepmerge

}));
});

//      
// An event handler can take an optional event argument
// and should not return a value
                                          
// An array of all currently registered event handlers for a type
                                            
// A map of event types and their corresponding event handlers.
                        
                                   
  

/** Mitt: Tiny (~200b) functional event emitter / pubsub.
 *  @name mitt
 *  @returns {Mitt}
 */
function mitt(all                 ) {
	all = all || Object.create(null);

	return {
		/**
		 * Register an event handler for the given type.
		 *
		 * @param  {String} type	Type of event to listen for, or `"*"` for all events
		 * @param  {Function} handler Function to call in response to given event
		 * @memberOf mitt
		 */
		on: function on(type        , handler              ) {
			(all[type] || (all[type] = [])).push(handler);
		},

		/**
		 * Remove an event handler for the given type.
		 *
		 * @param  {String} type	Type of event to unregister `handler` from, or `"*"`
		 * @param  {Function} handler Handler function to remove
		 * @memberOf mitt
		 */
		off: function off(type        , handler              ) {
			if (all[type]) {
				all[type].splice(all[type].indexOf(handler) >>> 0, 1);
			}
		},

		/**
		 * Invoke all handlers for the given type.
		 * If present, `"*"` handlers are invoked after type-matched handlers.
		 *
		 * @param {String} type  The event type to invoke
		 * @param {Any} [evt]  Any value (object is recommended and powerful), passed to each handler
		 * @memberof mitt
		 */
		emit: function emit(type        , evt     ) {
			(all[type] || []).map(function (handler) { handler(evt); });
			(all['*'] || []).map(function (handler) { handler(type, evt); });
		}
	};
}

var namespaces_1 = createCommonjsModule(function (module, exports) {
var namespaces = {
  svg: {
    name: 'xmlns',
    uri: 'http://www.w3.org/2000/svg'
  },
  xlink: {
    name: 'xmlns:xlink',
    uri: 'http://www.w3.org/1999/xlink'
  }
};

exports.default = namespaces;
module.exports = exports.default;
});

/**
 * @param {Object} attrs
 * @return {string}
 */
var objectToAttrsString = function (attrs) {
  return Object.keys(attrs).map(function (attr) {
    var value = attrs[attr].toString().replace(/"/g, '&quot;');
    return (attr + "=\"" + value + "\"");
  }).join(' ');
};

var svg = namespaces_1.svg;
var xlink = namespaces_1.xlink;

var defaultAttrs = {};
defaultAttrs[svg.name] = svg.uri;
defaultAttrs[xlink.name] = xlink.uri;

/**
 * @param {string} [content]
 * @param {Object} [attributes]
 * @return {string}
 */
var wrapInSvgString = function (content, attributes) {
  if ( content === void 0 ) content = '';

  var attrs = index(defaultAttrs, attributes || {});
  var attrsRendered = objectToAttrsString(attrs);
  return ("<svg " + attrsRendered + ">" + content + "</svg>");
};

var svg$1 = namespaces_1.svg;
var xlink$1 = namespaces_1.xlink;

var defaultConfig = {
  attrs: ( obj = {
    style: ['position: absolute', 'width: 0', 'height: 0'].join('; ')
  }, obj[svg$1.name] = svg$1.uri, obj[xlink$1.name] = xlink$1.uri, obj )
};
var obj;

var Sprite = function Sprite(config) {
  this.config = index(defaultConfig, config || {});
  this.symbols = [];
};

/**
 * Add new symbol. If symbol with the same id exists it will be replaced.
 * @param {SpriteSymbol} symbol
 * @return {boolean} `true` - symbol was added, `false` - replaced
 */
Sprite.prototype.add = function add (symbol) {
  var ref = this;
    var symbols = ref.symbols;
  var existing = this.find(symbol.id);

  if (existing) {
    symbols[symbols.indexOf(existing)] = symbol;
    return false;
  }

  symbols.push(symbol);
  return true;
};

/**
 * Remove symbol & destroy it
 * @param {string} id
 * @return {boolean} `true` - symbol was found & successfully destroyed, `false` - otherwise
 */
Sprite.prototype.remove = function remove (id) {
  var ref = this;
    var symbols = ref.symbols;
  var symbol = this.find(id);

  if (symbol) {
    symbols.splice(symbols.indexOf(symbol), 1);
    symbol.destroy();
    return true;
  }

  return false;
};

/**
 * @param {string} id
 * @return {SpriteSymbol|null}
 */
Sprite.prototype.find = function find (id) {
  return this.symbols.filter(function (s) { return s.id === id; })[0] || null;
};

/**
 * @param {string} id
 * @return {boolean}
 */
Sprite.prototype.has = function has (id) {
  return this.find(id) !== null;
};

/**
 * @return {string}
 */
Sprite.prototype.stringify = function stringify () {
  var ref = this.config;
    var attrs = ref.attrs;
  var stringifiedSymbols = this.symbols.map(function (s) { return s.stringify(); }).join('');
  return wrapInSvgString(stringifiedSymbols, attrs);
};

/**
 * @return {string}
 */
Sprite.prototype.toString = function toString () {
  return this.stringify();
};

Sprite.prototype.destroy = function destroy () {
  this.symbols.forEach(function (s) { return s.destroy(); });
};

var SpriteSymbol = function SpriteSymbol(ref) {
  var id = ref.id;
  var viewBox = ref.viewBox;
  var content = ref.content;

  this.id = id;
  this.viewBox = viewBox;
  this.content = content;
};

/**
 * @return {string}
 */
SpriteSymbol.prototype.stringify = function stringify () {
  return this.content;
};

/**
 * @return {string}
 */
SpriteSymbol.prototype.toString = function toString () {
  return this.stringify();
};

SpriteSymbol.prototype.destroy = function destroy () {
    var this$1 = this;

  ['id', 'viewBox', 'content'].forEach(function (prop) { return delete this$1[prop]; });
};

/**
 * @param {string} content
 * @return {Element}
 */
var parse = function (content) {
  var hasImportNode = !!document.importNode;
  var doc = new DOMParser().parseFromString(content, 'image/svg+xml').documentElement;

  /**
   * Fix for browser which are throwing WrongDocumentError
   * if you insert an element which is not part of the document
   * @see http://stackoverflow.com/a/7986519/4624403
   */
  if (hasImportNode) {
    return document.importNode(doc, true);
  }

  return doc;
};

var BrowserSpriteSymbol = (function (SpriteSymbol$$1) {
  function BrowserSpriteSymbol () {
    SpriteSymbol$$1.apply(this, arguments);
  }

  if ( SpriteSymbol$$1 ) BrowserSpriteSymbol.__proto__ = SpriteSymbol$$1;
  BrowserSpriteSymbol.prototype = Object.create( SpriteSymbol$$1 && SpriteSymbol$$1.prototype );
  BrowserSpriteSymbol.prototype.constructor = BrowserSpriteSymbol;

  var prototypeAccessors = { isMounted: {} };

  prototypeAccessors.isMounted.get = function () {
    return !!this.node;
  };

  /**
   * @param {Element} node
   * @return {BrowserSpriteSymbol}
   */
  BrowserSpriteSymbol.createFromExistingNode = function createFromExistingNode (node) {
    return new BrowserSpriteSymbol({
      id: node.getAttribute('id'),
      viewBox: node.getAttribute('viewBox'),
      content: node.outerHTML
    });
  };

  BrowserSpriteSymbol.prototype.destroy = function destroy () {
    if (this.isMounted) {
      this.unmount();
    }
    SpriteSymbol$$1.prototype.destroy.call(this);
  };

  /**
   * @param {Element|string} target
   * @return {Element}
   */
  BrowserSpriteSymbol.prototype.mount = function mount (target) {
    if (this.isMounted) {
      return this.node;
    }

    var mountTarget = typeof target === 'string' ? document.querySelector(target) : target;
    var node = this.render();
    this.node = node;

    mountTarget.appendChild(node);

    return node;
  };

  /**
   * @return {Element}
   */
  BrowserSpriteSymbol.prototype.render = function render () {
    var content = this.stringify();
    return parse(wrapInSvgString(content)).childNodes[0];
  };

  BrowserSpriteSymbol.prototype.unmount = function unmount () {
    this.node.parentNode.removeChild(this.node);
  };

  Object.defineProperties( BrowserSpriteSymbol.prototype, prototypeAccessors );

  return BrowserSpriteSymbol;
}(SpriteSymbol));

var defaultConfig$1 = {
  /**
   * Should following options be automatically configured:
   * - `syncUrlsWithBaseTag`
   * - `locationChangeAngularEmitter`
   * - `moveGradientsOutsideSymbol`
   * @type {boolean}
   */
  autoConfigure: true,

  /**
   * Default mounting selector
   * @type {string}
   */
  mountTo: 'body',

  /**
   * Fix disappearing SVG elements when <base href> exists.
   * Executes when sprite mounted.
   * @see http://stackoverflow.com/a/18265336/796152
   * @see https://github.com/everdimension/angular-svg-base-fix
   * @see https://github.com/angular/angular.js/issues/8934#issuecomment-56568466
   * @type {boolean}
   */
  syncUrlsWithBaseTag: false,

  /**
   * Should sprite listen custom location change event
   * @type {boolean}
   */
  listenLocationChangeEvent: true,

  /**
   * Custom window event name which should be emitted to update sprite urls
   * @type {string}
   */
  locationChangeEvent: 'locationChange',

  /**
   * Emit location change event in Angular automatically
   * @type {boolean}
   */
  locationChangeAngularEmitter: false,

  /**
   * Selector to find symbols usages when updating sprite urls
   * @type {string}
   */
  usagesToUpdate: 'use[*|href]',

  /**
   * Fix Firefox bug when gradients and patterns don't work if they are within a symbol.
   * Executes when sprite is rendered, but not mounted.
   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=306674
   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=353575
   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=1235364
   * @type {boolean}
   */
  moveGradientsOutsideSymbol: false
};

/**
 * @param {*} arrayLike
 * @return {Array}
 */
var arrayFrom = function (arrayLike) {
  return Array.prototype.slice.call(arrayLike, 0);
};

var ua = navigator.userAgent;

var browser = {
  isChrome: /chrome/i.test(ua),
  isFirefox: /firefox/i.test(ua),

  // https://msdn.microsoft.com/en-us/library/ms537503(v=vs.85).aspx
  isIE: /msie/i.test(ua) || /trident/i.test(ua),
  isEdge: /edge/i.test(ua)
};

/**
 * @param {string} name
 * @param {*} data
 */
var dispatchEvent = function (name, data) {
  var event = document.createEvent('CustomEvent');
  event.initCustomEvent(name, false, false, data);
  window.dispatchEvent(event);
};

/**
 * IE doesn't evaluate <style> tags in SVGs that are dynamically added to the page.
 * This trick will trigger IE to read and use any existing SVG <style> tags.
 * @see https://github.com/iconic/SVGInjector/issues/23
 * @see https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/10898469/
 *
 * @param {Element} node DOM Element to search <style> tags in
 * @return {Array<HTMLStyleElement>}
 */
var evalStylesIEWorkaround = function (node) {
  var updatedNodes = [];

  arrayFrom(node.querySelectorAll('style'))
    .forEach(function (style) {
      style.textContent += '';
      updatedNodes.push(style);
    });

  return updatedNodes;
};

/**
 * @param {string} [url] If not provided - current URL will be used
 * @return {string}
 */
var getUrlWithoutFragment = function (url) {
  return (url || window.location.href).split('#')[0];
};

/* global angular */
/**
 * @param {string} eventName
 */
var locationChangeAngularEmitter = function (eventName) {
  angular.module('ng').run(['$rootScope', function ($rootScope) {
    $rootScope.$on('$locationChangeSuccess', function (e, newUrl, oldUrl) {
      dispatchEvent(eventName, { oldUrl: oldUrl, newUrl: newUrl });
    });
  }]);
};

var defaultSelector = 'linearGradient, radialGradient, pattern';

/**
 * @param {Element} svg
 * @param {string} [selector]
 * @return {Element}
 */
var moveGradientsOutsideSymbol = function (svg, selector) {
  if ( selector === void 0 ) selector = defaultSelector;

  arrayFrom(svg.querySelectorAll('symbol')).forEach(function (symbol) {
    arrayFrom(symbol.querySelectorAll(selector)).forEach(function (node) {
      symbol.parentNode.insertBefore(node, symbol);
    });
  });
  return svg;
};

/**
 * @param {NodeList} nodes
 * @param {Function} [matcher]
 * @return {Attr[]}
 */
function selectAttributes(nodes, matcher) {
  var attrs = arrayFrom(nodes).reduce(function (acc, node) {
    if (!node.attributes) {
      return acc;
    }

    var arrayfied = arrayFrom(node.attributes);
    var matched = matcher ? arrayfied.filter(matcher) : arrayfied;
    return acc.concat(matched);
  }, []);

  return attrs;
}

/**
 * @param {NodeList|Node} nodes
 * @param {boolean} [clone=true]
 * @return {string}
 */

var xLinkNS = namespaces_1.xlink.uri;
var xLinkAttrName = 'xlink:href';

// eslint-disable-next-line no-useless-escape
var specialUrlCharsPattern = /[{}|\\\^\[\]`"<>]/g;

function encoder(url) {
  return url.replace(specialUrlCharsPattern, function (match) {
    return ("%" + (match[0].charCodeAt(0).toString(16).toUpperCase()));
  });
}

/**
 * @param {NodeList} nodes
 * @param {string} startsWith
 * @param {string} replaceWith
 * @return {NodeList}
 */
function updateReferences(nodes, startsWith, replaceWith) {
  arrayFrom(nodes).forEach(function (node) {
    var href = node.getAttribute(xLinkAttrName);
    if (href && href.indexOf(startsWith) === 0) {
      var newUrl = href.replace(startsWith, replaceWith);
      node.setAttributeNS(xLinkNS, xLinkAttrName, newUrl);
    }
  });

  return nodes;
}

/**
 * List of SVG attributes to update url() target in them
 */
var attList = [
  'clipPath',
  'colorProfile',
  'src',
  'cursor',
  'fill',
  'filter',
  'marker',
  'markerStart',
  'markerMid',
  'markerEnd',
  'mask',
  'stroke',
  'style'
];

var attSelector = attList.map(function (attr) { return ("[" + attr + "]"); }).join(',');

/**
 * Update URLs in svg image (like `fill="url(...)"`) and update referencing elements
 * @param {Element} svg
 * @param {NodeList} references
 * @param {string|RegExp} startsWith
 * @param {string} replaceWith
 * @return {void}
 *
 * @example
 * const sprite = document.querySelector('svg.sprite');
 * const usages = document.querySelectorAll('use');
 * updateUrls(sprite, usages, '#', 'prefix#');
 */
var updateUrls = function (svg, references, startsWith, replaceWith) {
  var startsWithEncoded = encoder(startsWith);
  var replaceWithEncoded = encoder(replaceWith);

  var nodes = svg.querySelectorAll(attSelector);
  var attrs = selectAttributes(nodes, function (ref) {
    var localName = ref.localName;
    var value = ref.value;

    return attList.indexOf(localName) !== -1 && value.indexOf(("url(" + startsWithEncoded)) !== -1;
  });

  attrs.forEach(function (attr) { return attr.value = attr.value.replace(startsWithEncoded, replaceWithEncoded); });
  updateReferences(references, startsWithEncoded, replaceWithEncoded);
};

/**
 * Internal emitter events
 * @enum
 * @private
 */
var Events = {
  MOUNT: 'mount',
  SYMBOL_MOUNT: 'symbol_mount'
};

var BrowserSprite = (function (Sprite$$1) {
  function BrowserSprite(cfg) {
    var this$1 = this;
    if ( cfg === void 0 ) cfg = {};

    Sprite$$1.call(this, index(defaultConfig$1, cfg));

    var emitter = mitt();
    this._emitter = emitter;
    this.node = null;

    var ref = this;
    var config = ref.config;

    if (config.autoConfigure) {
      this._autoConfigure(cfg);
    }

    if (config.syncUrlsWithBaseTag) {
      var baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
      emitter.on(Events.MOUNT, function () { return this$1.updateUrls('#', baseUrl); });
    }

    var handleLocationChange = this._handleLocationChange.bind(this);
    this._handleLocationChange = handleLocationChange;

    // Provide way to update sprite urls externally via dispatching custom window event
    if (config.listenLocationChangeEvent) {
      window.addEventListener(config.locationChangeEvent, handleLocationChange);
    }

    // Emit location change event in Angular automatically
    if (config.locationChangeAngularEmitter) {
      locationChangeAngularEmitter(config.locationChangeEvent);
    }

    // After sprite mounted
    emitter.on(Events.MOUNT, function (spriteNode) {
      if (config.moveGradientsOutsideSymbol) {
        moveGradientsOutsideSymbol(spriteNode);
      }
    });

    // After symbol mounted into sprite
    emitter.on(Events.SYMBOL_MOUNT, function (symbolNode) {
      if (config.moveGradientsOutsideSymbol) {
        moveGradientsOutsideSymbol(symbolNode.parentNode);
      }

      if (browser.isIE || browser.isEdge) {
        evalStylesIEWorkaround(symbolNode);
      }
    });
  }

  if ( Sprite$$1 ) BrowserSprite.__proto__ = Sprite$$1;
  BrowserSprite.prototype = Object.create( Sprite$$1 && Sprite$$1.prototype );
  BrowserSprite.prototype.constructor = BrowserSprite;

  var prototypeAccessors = { isMounted: {} };

  /**
   * @return {boolean}
   */
  prototypeAccessors.isMounted.get = function () {
    return !!this.node;
  };

  /**
   * Automatically configure following options
   * - `syncUrlsWithBaseTag`
   * - `locationChangeAngularEmitter`
   * - `moveGradientsOutsideSymbol`
   * @param {Object} cfg
   * @private
   */
  BrowserSprite.prototype._autoConfigure = function _autoConfigure (cfg) {
    var ref = this;
    var config = ref.config;

    if (typeof cfg.syncUrlsWithBaseTag === 'undefined') {
      config.syncUrlsWithBaseTag = typeof document.getElementsByTagName('base')[0] !== 'undefined';
    }

    if (typeof cfg.locationChangeAngularEmitter === 'undefined') {
      config.locationChangeAngularEmitter = 'angular' in window;
    }

    if (typeof cfg.moveGradientsOutsideSymbol === 'undefined') {
      config.moveGradientsOutsideSymbol = browser.isFirefox;
    }
  };

  /**
   * @param {Event} event
   * @param {Object} event.detail
   * @param {string} event.detail.oldUrl
   * @param {string} event.detail.newUrl
   * @private
   */
  BrowserSprite.prototype._handleLocationChange = function _handleLocationChange (event) {
    var ref = event.detail;
    var oldUrl = ref.oldUrl;
    var newUrl = ref.newUrl;
    this.updateUrls(oldUrl, newUrl);
  };

  /**
   * Add new symbol. If symbol with the same id exists it will be replaced.
   * If sprite already mounted - `symbol.mount(sprite.node)` will be called.
   * @fires Events#SYMBOL_MOUNT
   * @param {BrowserSpriteSymbol} symbol
   * @return {boolean} `true` - symbol was added, `false` - replaced
   */
  BrowserSprite.prototype.add = function add (symbol) {
    var sprite = this;
    var isNewSymbol = Sprite$$1.prototype.add.call(this, symbol);

    if (this.isMounted && isNewSymbol) {
      symbol.mount(sprite.node);
      this._emitter.emit(Events.SYMBOL_MOUNT, symbol.node);
    }

    return isNewSymbol;
  };

  /**
   * Attach to existing DOM node
   * @param {string|Element} target
   * @return {Element|null} attached DOM Element. null if node to attach not found.
   */
  BrowserSprite.prototype.attach = function attach (target) {
    var this$1 = this;

    var sprite = this;

    if (sprite.isMounted) {
      return sprite.node;
    }

    /** @type Element */
    var node = typeof target === 'string' ? document.querySelector(target) : target;
    sprite.node = node;

    // Already added symbols needs to be mounted
    this.symbols.forEach(function (symbol) {
      symbol.mount(sprite.node);
      this$1._emitter.emit(Events.SYMBOL_MOUNT, symbol.node);
    });

    // Create symbols from existing DOM nodes, add and mount them
    arrayFrom(node.querySelectorAll('symbol'))
      .forEach(function (symbolNode) {
        var symbol = BrowserSpriteSymbol.createFromExistingNode(symbolNode);
        symbol.node = symbolNode; // hack to prevent symbol mounting to sprite when adding
        sprite.add(symbol);
      });

    this._emitter.emit(Events.MOUNT, node);

    return node;
  };

  BrowserSprite.prototype.destroy = function destroy () {
    var ref = this;
    var config = ref.config;
    var symbols = ref.symbols;
    var _emitter = ref._emitter;

    symbols.forEach(function (s) { return s.destroy(); });

    _emitter.off('*');
    window.removeEventListener(config.locationChangeEvent, this._handleLocationChange);

    if (this.isMounted) {
      this.unmount();
    }
  };

  /**
   * @fires Events#MOUNT
   * @param {string|Element} [target]
   * @param {boolean} [prepend=false]
   * @return {Element|null} rendered sprite node. null if mount node not found.
   */
  BrowserSprite.prototype.mount = function mount (target, prepend) {
    if ( target === void 0 ) target = this.config.mountTo;
    if ( prepend === void 0 ) prepend = false;

    var sprite = this;

    if (sprite.isMounted) {
      return sprite.node;
    }

    var mountNode = typeof target === 'string' ? document.querySelector(target) : target;
    var node = sprite.render();
    this.node = node;

    if (prepend && mountNode.childNodes[0]) {
      mountNode.insertBefore(node, mountNode.childNodes[0]);
    } else {
      mountNode.appendChild(node);
    }

    this._emitter.emit(Events.MOUNT, node);

    return node;
  };

  /**
   * @return {Element}
   */
  BrowserSprite.prototype.render = function render () {
    return parse(this.stringify());
  };

  /**
   * Detach sprite from the DOM
   */
  BrowserSprite.prototype.unmount = function unmount () {
    this.node.parentNode.removeChild(this.node);
  };

  /**
   * Update URLs in sprite and usage elements
   * @param {string} oldUrl
   * @param {string} newUrl
   * @return {boolean} `true` - URLs was updated, `false` - sprite is not mounted
   */
  BrowserSprite.prototype.updateUrls = function updateUrls$1 (oldUrl, newUrl) {
    if (!this.isMounted) {
      return false;
    }

    var usages = document.querySelectorAll(this.config.usagesToUpdate);

    updateUrls(
      this.node,
      usages,
      ((getUrlWithoutFragment(oldUrl)) + "#"),
      ((getUrlWithoutFragment(newUrl)) + "#")
    );

    return true;
  };

  Object.defineProperties( BrowserSprite.prototype, prototypeAccessors );

  return BrowserSprite;
}(Sprite));

var ready$1 = createCommonjsModule(function (module) {
/*!
  * domready (c) Dustin Diaz 2014 - License MIT
  */
!function (name, definition) {

  { module.exports = definition(); }

}('domready', function () {

  var fns = [], listener
    , doc = document
    , hack = doc.documentElement.doScroll
    , domContentLoaded = 'DOMContentLoaded'
    , loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState);


  if (!loaded)
  { doc.addEventListener(domContentLoaded, listener = function () {
    doc.removeEventListener(domContentLoaded, listener);
    loaded = 1;
    while (listener = fns.shift()) { listener(); }
  }); }

  return function (fn) {
    loaded ? setTimeout(fn, 0) : fns.push(fn);
  }

});
});

var spriteNodeId = '__SVG_SPRITE_NODE__';
var spriteGlobalVarName = '__SVG_SPRITE__';
var isSpriteExists = !!window[spriteGlobalVarName];

// eslint-disable-next-line import/no-mutable-exports
var sprite;

if (isSpriteExists) {
  sprite = window[spriteGlobalVarName];
} else {
  sprite = new BrowserSprite({ attrs: { id: spriteNodeId } });
  window[spriteGlobalVarName] = sprite;
}

var loadSprite = function () {
  /**
   * Check for page already contains sprite node
   * If found - attach to and reuse it's content
   * If not - render and mount the new sprite
   */
  var existing = document.getElementById(spriteNodeId);

  if (existing) {
    sprite.attach(existing);
  } else {
    sprite.mount(document.body, true);
  }
};

if (document.body) {
  loadSprite();
} else {
  ready$1(loadSprite);
}

var sprite$1 = sprite;

return sprite$1;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Snappy = {

  init: function init() {
    document.addEventListener('DOMContentLoaded', this.onDOMLoaded.bind(this));
    (0, _jquery2.default)(window).on('content:updated', this.renderComponents.bind(this));
  },

  onDOMLoaded: function onDOMLoaded(event) {
    this.renderComponents();
  },

  renderComponents: function renderComponents() {
    var _this = this;

    var _loop = function _loop(key) {
      var elements = document.querySelectorAll('[data-' + _this.Component[key].tagName + ']:not([data-defer-snappy])');
      elements = Array.prototype.slice.call(elements);

      elements.forEach(function (element) {
        var isInited = element.getAttribute('data-' + this.Component[key].tagName + '-inited');

        if (typeof isInited === 'string') {
          return;
        }

        var component = new this.Component[key](element);
        element.component = component;
        element.setAttribute('data-' + this.Component[key].tagName + '-inited', '');
        component.render();
      }.bind(_this));
    };

    for (var key in this.Component) {
      _loop(key);
    }
  },

  Component: {},

  BaseComponent: function BaseComponent(element) {
    _classCallCheck(this, BaseComponent);

    this.element = element;

    if (_jquery2.default) {
      this.$element = (0, _jquery2.default)(element);
      this.$window = (0, _jquery2.default)(window);
      this.$body = (0, _jquery2.default)('body');
    }
  }

};

exports.default = Snappy;

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _modernizr = __webpack_require__(32);

var _modernizr2 = _interopRequireDefault(_modernizr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resized = false,
    resizeTimer = null,
    timeoutTime = 150,
    App = {};

function initResize() {
    setGlobalVars();
    (0, _jquery2.default)(window).on('resize', resizeProcessing);
    (0, _jquery2.default)(window).on('orientationchange', resizeProcessing);

    App.resize = resizeAfterProcessing.bind(this, true);
}

function setGlobalVars() {
    App.isTouch = _modernizr2.default.touchevents;
    App.isWinPhone = !!('ontouchstart' in window || navigator.msMaxTouchPoints) && navigator.userAgent.match(/Windows Phone/i);
    App.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    resizeAfterProcessing(true);
}

function resizeProcessing() {
    if (resizeTimer !== null) {
        clearTimeout(resizeTimer);
    }
    resized = true;
    resizeAfterProcessing();
}

function resizeAfterProcessing(notTrigger) {
    if (resized === true) {
        resized = false;
        resizeTimer = setTimeout(resizeAfterProcessing, timeoutTime);
        return;
    }

    var $window = (0, _jquery2.default)(window),
        width = $window.outerWidth(),
        height = $window.outerHeight();
    if (width == App.width && height == App.height) {
        return;
    }

    _extends(App, {
        width: width,
        height: height,
        orientation: typeof window.orientation === "undefined" || Math.abs(window.orientation) === 90 ? "landscape" : "portrait",
        isWidest: _modernizr2.default.mq('only screen and (min-width:1500px)'),
        isDesktop: _modernizr2.default.mq('only screen and (min-width:1025px)'),
        isTablet: _modernizr2.default.mq('only screen and (min-width:769px)'),
        isPhoneLandscape: _modernizr2.default.mq('only screen and (min-width:641px)')
    });

    if (typeof notTrigger != 'undefined' && notTrigger === true) {
        return;
    }

    $window.trigger('resize:finished');
}

initResize();

exports.default = App;

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, exports) {

;(function(window){
var hadGlobal = 'Modernizr' in window;
var oldGlobal = window.Modernizr;
/*! modernizr 3.5.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-appearance-csstransforms3d-customevent-flexbox-flexboxlegacy-smil-touchevents-mq-prefixed-setclasses-shiv !*/
!function(e,t,n){function r(e,t){return typeof e===t}function o(){var e,t,n,o,i,a,s;for(var l in S)if(S.hasOwnProperty(l)){if(e=[],t=S[l],t.name&&(e.push(t.name.toLowerCase()),t.options&&t.options.aliases&&t.options.aliases.length))for(n=0;n<t.options.aliases.length;n++)e.push(t.options.aliases[n].toLowerCase());for(o=r(t.fn,"function")?t.fn():t.fn,i=0;i<e.length;i++)a=e[i],s=a.split("."),1===s.length?Modernizr[s[0]]=o:(!Modernizr[s[0]]||Modernizr[s[0]]instanceof Boolean||(Modernizr[s[0]]=new Boolean(Modernizr[s[0]])),Modernizr[s[0]][s[1]]=o),x.push((o?"":"no-")+s.join("-"))}}function i(e){var t=b.className,n=Modernizr._config.classPrefix||"";if(E&&(t=t.baseVal),Modernizr._config.enableJSClass){var r=new RegExp("(^|\\s)"+n+"no-js(\\s|$)");t=t.replace(r,"$1"+n+"js$2")}Modernizr._config.enableClasses&&(t+=" "+n+e.join(" "+n),E?b.className.baseVal=t:b.className=t)}function a(e,t){return!!~(""+e).indexOf(t)}function s(){return"function"!=typeof t.createElement?t.createElement(arguments[0]):E?t.createElementNS.call(t,"http://www.w3.org/2000/svg",arguments[0]):t.createElement.apply(t,arguments)}function l(){var e=t.body;return e||(e=s(E?"svg":"body"),e.fake=!0),e}function u(e,n,r,o){var i,a,u,c,f="modernizr",d=s("div"),p=l();if(parseInt(r,10))for(;r--;)u=s("div"),u.id=o?o[r]:f+(r+1),d.appendChild(u);return i=s("style"),i.type="text/css",i.id="s"+f,(p.fake?p:d).appendChild(i),p.appendChild(d),i.styleSheet?i.styleSheet.cssText=e:i.appendChild(t.createTextNode(e)),d.id=f,p.fake&&(p.style.background="",p.style.overflow="hidden",c=b.style.overflow,b.style.overflow="hidden",b.appendChild(p)),a=n(d,e),p.fake?(p.parentNode.removeChild(p),b.style.overflow=c,b.offsetHeight):d.parentNode.removeChild(d),!!a}function c(e){return e.replace(/([A-Z])/g,function(e,t){return"-"+t.toLowerCase()}).replace(/^ms-/,"-ms-")}function f(t,n,r){var o;if("getComputedStyle"in e){o=getComputedStyle.call(e,t,n);var i=e.console;if(null!==o)r&&(o=o.getPropertyValue(r));else if(i){var a=i.error?"error":"log";i[a].call(i,"getComputedStyle returning null, its possible modernizr test results are inaccurate")}}else o=!n&&t.currentStyle&&t.currentStyle[r];return o}function d(t,r){var o=t.length;if("CSS"in e&&"supports"in e.CSS){for(;o--;)if(e.CSS.supports(c(t[o]),r))return!0;return!1}if("CSSSupportsRule"in e){for(var i=[];o--;)i.push("("+c(t[o])+":"+r+")");return i=i.join(" or "),u("@supports ("+i+") { #modernizr { position: absolute; } }",function(e){return"absolute"==f(e,null,"position")})}return n}function p(e){return e.replace(/([a-z])-([a-z])/g,function(e,t,n){return t+n.toUpperCase()}).replace(/^-/,"")}function m(e,t,o,i){function l(){c&&(delete z.style,delete z.modElem)}if(i=r(i,"undefined")?!1:i,!r(o,"undefined")){var u=d(e,o);if(!r(u,"undefined"))return u}for(var c,f,m,h,v,g=["modernizr","tspan","samp"];!z.style&&g.length;)c=!0,z.modElem=s(g.shift()),z.style=z.modElem.style;for(m=e.length,f=0;m>f;f++)if(h=e[f],v=z.style[h],a(h,"-")&&(h=p(h)),z.style[h]!==n){if(i||r(o,"undefined"))return l(),"pfx"==t?h:!0;try{z.style[h]=o}catch(y){}if(z.style[h]!=v)return l(),"pfx"==t?h:!0}return l(),!1}function h(e,t){return function(){return e.apply(t,arguments)}}function v(e,t,n){var o;for(var i in e)if(e[i]in t)return n===!1?e[i]:(o=t[e[i]],r(o,"function")?h(o,n||t):o);return!1}function g(e,t,n,o,i){var a=e.charAt(0).toUpperCase()+e.slice(1),s=(e+" "+_.join(a+" ")+a).split(" ");return r(t,"string")||r(t,"undefined")?m(s,t,o,i):(s=(e+" "+N.join(a+" ")+a).split(" "),v(s,t,n))}function y(e,t,r){return g(e,n,n,t,r)}var S=[],C={_version:"3.5.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,t){var n=this;setTimeout(function(){t(n[e])},0)},addTest:function(e,t,n){S.push({name:e,fn:t,options:n})},addAsyncTest:function(e){S.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=C,Modernizr=new Modernizr;var x=[],b=t.documentElement,E="svg"===b.nodeName.toLowerCase();E||!function(e,t){function n(e,t){var n=e.createElement("p"),r=e.getElementsByTagName("head")[0]||e.documentElement;return n.innerHTML="x<style>"+t+"</style>",r.insertBefore(n.lastChild,r.firstChild)}function r(){var e=S.elements;return"string"==typeof e?e.split(" "):e}function o(e,t){var n=S.elements;"string"!=typeof n&&(n=n.join(" ")),"string"!=typeof e&&(e=e.join(" ")),S.elements=n+" "+e,u(t)}function i(e){var t=y[e[v]];return t||(t={},g++,e[v]=g,y[g]=t),t}function a(e,n,r){if(n||(n=t),f)return n.createElement(e);r||(r=i(n));var o;return o=r.cache[e]?r.cache[e].cloneNode():h.test(e)?(r.cache[e]=r.createElem(e)).cloneNode():r.createElem(e),!o.canHaveChildren||m.test(e)||o.tagUrn?o:r.frag.appendChild(o)}function s(e,n){if(e||(e=t),f)return e.createDocumentFragment();n=n||i(e);for(var o=n.frag.cloneNode(),a=0,s=r(),l=s.length;l>a;a++)o.createElement(s[a]);return o}function l(e,t){t.cache||(t.cache={},t.createElem=e.createElement,t.createFrag=e.createDocumentFragment,t.frag=t.createFrag()),e.createElement=function(n){return S.shivMethods?a(n,e,t):t.createElem(n)},e.createDocumentFragment=Function("h,f","return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&("+r().join().replace(/[\w\-:]+/g,function(e){return t.createElem(e),t.frag.createElement(e),'c("'+e+'")'})+");return n}")(S,t.frag)}function u(e){e||(e=t);var r=i(e);return!S.shivCSS||c||r.hasCSS||(r.hasCSS=!!n(e,"article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}mark{background:#FF0;color:#000}template{display:none}")),f||l(e,r),e}var c,f,d="3.7.3",p=e.html5||{},m=/^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i,h=/^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i,v="_html5shiv",g=0,y={};!function(){try{var e=t.createElement("a");e.innerHTML="<xyz></xyz>",c="hidden"in e,f=1==e.childNodes.length||function(){t.createElement("a");var e=t.createDocumentFragment();return"undefined"==typeof e.cloneNode||"undefined"==typeof e.createDocumentFragment||"undefined"==typeof e.createElement}()}catch(n){c=!0,f=!0}}();var S={elements:p.elements||"abbr article aside audio bdi canvas data datalist details dialog figcaption figure footer header hgroup main mark meter nav output picture progress section summary template time video",version:d,shivCSS:p.shivCSS!==!1,supportsUnknownElements:f,shivMethods:p.shivMethods!==!1,type:"default",shivDocument:u,createElement:a,createDocumentFragment:s,addElements:o};e.html5=S,u(t),"object"==typeof module&&module.exports&&(module.exports=S)}("undefined"!=typeof e?e:this,t);var w="Moz O ms Webkit",_=C._config.usePrefixes?w.split(" "):[];C._cssomPrefixes=_;var T={elem:s("modernizr")};Modernizr._q.push(function(){delete T.elem});var z={style:T.elem.style};Modernizr._q.unshift(function(){delete z.style});var N=C._config.usePrefixes?w.toLowerCase().split(" "):[];C._domPrefixes=N,C.testAllProps=g;var j=function(t){var r,o=D.length,i=e.CSSRule;if("undefined"==typeof i)return n;if(!t)return!1;if(t=t.replace(/^@/,""),r=t.replace(/-/g,"_").toUpperCase()+"_RULE",r in i)return"@"+t;for(var a=0;o>a;a++){var s=D[a],l=s.toUpperCase()+"_"+r;if(l in i)return"@-"+s.toLowerCase()+"-"+t}return!1};C.atRule=j;var k=(C.prefixed=function(e,t,n){return 0===e.indexOf("@")?j(e):(-1!=e.indexOf("-")&&(e=p(e)),t?g(e,t,n):g(e,"pfx"))},function(){var t=e.matchMedia||e.msMatchMedia;return t?function(e){var n=t(e);return n&&n.matches||!1}:function(t){var n=!1;return u("@media "+t+" { #modernizr { position: absolute; } }",function(t){n="absolute"==(e.getComputedStyle?e.getComputedStyle(t,null):t.currentStyle).position}),n}}());C.mq=k,C.testAllProps=y;var P=C.testStyles=u,F="CSS"in e&&"supports"in e.CSS,M="supportsCSS"in e;Modernizr.addTest("supports",F||M),Modernizr.addTest("csstransforms3d",function(){var e=!!y("perspective","1px",!0),t=Modernizr._config.usePrefixes;if(e&&(!t||"webkitPerspective"in b.style)){var n,r="#modernizr{width:0;height:0}";Modernizr.supports?n="@supports (perspective: 1px)":(n="@media (transform-3d)",t&&(n+=",(-webkit-transform-3d)")),n+="{#modernizr{width:7px;height:18px;margin:0;padding:0;border:0}}",P(r+n,function(t){e=7===t.offsetWidth&&18===t.offsetHeight})}return e}),Modernizr.addTest("flexboxlegacy",y("boxDirection","reverse",!0)),Modernizr.addTest("flexbox",y("flexBasis","1px",!0));var D=C._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];C._prefixes=D,Modernizr.addTest("touchevents",function(){var n;if("ontouchstart"in e||e.DocumentTouch&&t instanceof DocumentTouch)n=!0;else{var r=["@media (",D.join("touch-enabled),("),"heartz",")","{#modernizr{top:9px;position:absolute}}"].join("");P(r,function(e){n=9===e.offsetTop})}return n}),Modernizr.addTest("appearance",y("appearance"));var L={}.toString;Modernizr.addTest("smil",function(){return!!t.createElementNS&&/SVGAnimate/.test(L.call(t.createElementNS("http://www.w3.org/2000/svg","animate")))}),Modernizr.addTest("customevent","CustomEvent"in e&&"function"==typeof e.CustomEvent),o(),i(x),delete C.addTest,delete C.addAsyncTest;for(var q=0;q<Modernizr._q.length;q++)Modernizr._q[q]();e.Modernizr=Modernizr}(window,document);
module.exports = window.Modernizr;
if (hadGlobal) { window.Modernizr = oldGlobal; }
else { delete window.Modernizr; }
})(window);

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ('data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7');
//# sourceMappingURL=gif.js.map

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_platform__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_platform__);

// sugar for https://github.com/bestiejs/platform.js
// make sure to ALWAYS reference the layout engine,
// even if it is not necessary for the condition,
// as this makes grepping for this stuff simpler



// deep clone of original platform
var platform = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0_platform___default.a));

// operating system
var os = platform.os.family || '';
var ANDROID = os === 'Android';
var WINDOWS = os.slice(0, 7) === 'Windows';
var OSX = os === 'OS X';
var IOS = os === 'iOS';

// layout
var BLINK = platform.layout === 'Blink';
var GECKO = platform.layout === 'Gecko';
var TRIDENT = platform.layout === 'Trident';
var EDGE = platform.layout === 'EdgeHTML';
var WEBKIT = platform.layout === 'WebKit';

// browser version (not layout engine version!)
var version = parseFloat(platform.version);
var majorVersion = Math.floor(version);
platform.majorVersion = majorVersion;

platform.is = {
  // operating system
  ANDROID: ANDROID,
  WINDOWS: WINDOWS,
  OSX: OSX,
  IOS: IOS,
  // layout
  BLINK: BLINK, // "Chrome", "Chrome Mobile", "Opera"
  GECKO: GECKO, // "Firefox"
  TRIDENT: TRIDENT, // "Internet Explorer"
  EDGE: EDGE, // "Microsoft Edge"
  WEBKIT: WEBKIT, // "Safari"
  // INTERNET EXPLORERS
  IE9: TRIDENT && majorVersion === 9,
  IE10: TRIDENT && majorVersion === 10,
  IE11: TRIDENT && majorVersion === 11
};

/* harmony default export */ __webpack_exports__["a"] = (platform);
//# sourceMappingURL=platform.js.map

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./DeleteIcon.svg": 89,
	"./Icon_info.svg": 90,
	"./Icon_info_hover.svg": 91,
	"./My_Account_Icon.svg": 92,
	"./Switch_Memberships.svg": 93,
	"./account.svg": 94,
	"./apple.svg": 95,
	"./arrow-enquiry.svg": 96,
	"./arrow-left-v.svg": 97,
	"./arrow-red.svg": 98,
	"./arrow-right-circle.svg": 99,
	"./arrow-right-v.svg": 100,
	"./arrow-right.svg": 101,
	"./arrow.svg": 102,
	"./aya.svg": 103,
	"./bootroom.svg": 104,
	"./bye_tag.svg": 105,
	"./calendar.svg": 106,
	"./camera.svg": 107,
	"./carousel-right-arrow.svg": 108,
	"./check.svg": 109,
	"./chevron-down-thin.svg": 110,
	"./chevron-down.svg": 111,
	"./chevron-left-thin.svg": 112,
	"./chevron-left-white.svg": 113,
	"./chevron-left.svg": 114,
	"./chevron-right-circle.svg": 115,
	"./chevron-right-thin.svg": 116,
	"./chevron-right-white.svg": 117,
	"./chevron-right.svg": 118,
	"./close-thin.svg": 119,
	"./close.svg": 120,
	"./cw-pause.svg": 121,
	"./cw-play.svg": 122,
	"./doc.svg": 123,
	"./down-arrow-information-black.svg": 124,
	"./down-arrow-information.svg": 125,
	"./download-icon.svg": 126,
	"./download.svg": 127,
	"./edit.svg": 128,
	"./email-faq.svg": 129,
	"./external.svg": 130,
	"./facebook.svg": 131,
	"./fail.svg": 132,
	"./gif.svg": 133,
	"./google-calendar.svg": 134,
	"./google-plus.svg": 135,
	"./hive-learning.svg": 136,
	"./icon_email_gold.svg": 137,
	"./icon_phone_gold.svg": 138,
	"./image-icon.svg": 139,
	"./info.svg": 140,
	"./instagram.svg": 141,
	"./jpg.svg": 142,
	"./like.svg": 143,
	"./linkedin.svg": 144,
	"./lion-mask.svg": 145,
	"./lion.svg": 146,
	"./map-maker-faq.svg": 147,
	"./minus-faq.svg": 148,
	"./minus-icon.svg": 149,
	"./minus.svg": 150,
	"./notice.svg": 151,
	"./np_email.svg": 152,
	"./np_phone.svg": 153,
	"./outlook.svg": 154,
	"./pdf.svg": 155,
	"./phone-faq.svg": 156,
	"./play-circle.svg": 157,
	"./play.svg": 158,
	"./plus-icon.svg": 159,
	"./plus.svg": 160,
	"./png.svg": 161,
	"./quote-close.svg": 162,
	"./quote-open.svg": 163,
	"./quote-square-close.svg": 164,
	"./quote-square-open.svg": 165,
	"./r-arrow-bold.svg": 166,
	"./reddit.svg": 167,
	"./redirect-icon-cwm.svg": 168,
	"./reply.svg": 169,
	"./report.svg": 170,
	"./search.svg": 171,
	"./snapchat.svg": 172,
	"./squad-stats-bg.svg": 173,
	"./stacked-lions.svg": 174,
	"./status_error_warning.svg": 175,
	"./status_success_tick.svg": 176,
	"./thefa.svg": 177,
	"./tick.svg": 178,
	"./tiktok.svg": 179,
	"./twitter-faq.svg": 180,
	"./twitter-old.svg": 181,
	"./twitter.svg": 182,
	"./user.svg": 183,
	"./verified.svg": 184,
	"./whatsapp.svg": 185,
	"./xls.svg": 186,
	"./yahoo.svg": 187,
	"./youtube.svg": 188,
	"./yt-play.svg": 189
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.BackToTop = function (_Snappy$BaseComponent) {
	_inherits(BackToTop, _Snappy$BaseComponent);

	_createClass(BackToTop, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-back-to-top';
		}
	}]);

	function BackToTop(element) {
		_classCallCheck(this, BackToTop);

		return _possibleConstructorReturn(this, (BackToTop.__proto__ || Object.getPrototypeOf(BackToTop)).call(this, element));
	}

	_createClass(BackToTop, [{
		key: 'setVars',
		value: function setVars() {
			this.$backToTopButton = this.$element.find('.fa-back-to-top__button');
		}
	}, {
		key: 'addEventListeners',
		value: function addEventListeners() {
			this.$backToTopButton.on('click', this.onBackToTopButtonClick.bind(this));
		}
	}, {
		key: 'render',
		value: function render() {
			this.setVars();
			this.addEventListeners();
		}
	}, {
		key: 'onBackToTopButtonClick',
		value: function onBackToTopButtonClick() {
			(0, _jquery2.default)('body, html').animate({ scrollTop: 0 }, 800);
		}
	}]);

	return BackToTop;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.Breadcrumbs = function (_Snappy$BaseComponent) {
	_inherits(Breadcrumbs, _Snappy$BaseComponent);

	_createClass(Breadcrumbs, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-breadcrumbs';
		}
	}]);

	function Breadcrumbs(element) {
		_classCallCheck(this, Breadcrumbs);

		return _possibleConstructorReturn(this, (Breadcrumbs.__proto__ || Object.getPrototypeOf(Breadcrumbs)).call(this, element));
	}

	_createClass(Breadcrumbs, [{
		key: 'render',
		value: function render() {}
	}]);

	return Breadcrumbs;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(76);

var _resize = __webpack_require__(17);

var _resize2 = _interopRequireDefault(_resize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.Carousel = function (_Snappy$BaseComponent) {
    _inherits(Carousel, _Snappy$BaseComponent);

    _createClass(Carousel, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-carousel';
        }
    }]);

    function Carousel(element) {
        _classCallCheck(this, Carousel);

        return _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, element));
    }

    _createClass(Carousel, [{
        key: 'setVars',
        value: function setVars() {
            this.isOn = true;
            this.paused = true;
            this.$carousel = this.$element.find('.carousel');
            this.options = {
                arrows: this.$element.data('carouselArrows'),
                autoplay: this.$element.data('carouselAutoplay'),
                autoplaySpeed: this.$element.data('carouselAutoplaySpeed'),
                pauseOnHover: this.$element.data('carouselPauseOnHover'),
                dots: this.$element.data('carouselDots'),
                slidesToShow: this.$element.data('carouselSlidesToShow') || 1,
                slidesToScroll: this.$element.data('carouselSlidesToScroll') || 1,
                speed: this.$element.data('carouselSpeed'),
                fade: this.$element.data('carouselFade'),
                appendDots: this.$element.find(this.$element.data('carouselDotsContainer')),
                mobileFirst: this.$element.data('carouselMobileFirst'),
                adaptiveHeight: this.$element.data('carouselAdaptiveHeight'),
                accessibility: this.$element.data('carouselAccessibility') || false,
                touchThreshold: 10,
                variableWidth: this.$element.data('carouselVariableWidth'),
                centerMode: this.$element.data('carouselCenterMode'),
                infinite: this.$element.data('carouselInfinite'),
                draggable: this.$element.data('carouselDraggable'),

                //here are not slick options
                arrowsTheme: this.$element.data('carouselArrowsTheme'),
                dynamicArrowsColor: this.$element.data('carouselDynamicArrowsColor'),
                mobileOn: this.$element.data('mobileOn') !== undefined ? this.$element.data('mobileOn') : true,
                tabletOn: this.$element.data('tabletOn') !== undefined ? this.$element.data('tabletOn') : true,
                desktopOn: this.$element.data('desktopOn') !== undefined ? this.$element.data('desktopOn') : true
            };

            if (this.$element.data('carouselResponsive')) {
                if (this.$element.data('carouselResponsiveUnslick') !== undefined) {
                    this.options.responsive = [{
                        breakpoint: parseInt(this.$element.data('carouselResponsiveBreakpoint'), 10),
                        settings: 'unslick'
                    }];
                } else {
                    this.options.responsive = this.getResponsiveBreakpointConfig(this.$element.data('carouselResponsiveBreakpoint'), this.$element.data('carouselResponsiveSlidesToShow'), this.$element.data('carouselResponsiveSlidesToScroll'));
                }
            }
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            (0, _jquery2.default)(window).on('resize:finished', this.onResize.bind(this));

            if (this.options.dynamicArrowsColor) {
                this.$carousel.on('afterChange', this.setArrowsColor.bind(this));
            }

            this.$carousel.on('swipe', this.swipeHandler.bind(this));
        }
    }, {
        key: 'getResponsiveBreakpointConfig',
        value: function getResponsiveBreakpointConfig(breakpoints, slidesToShow, slidesToScroll) {
            var responsiveBreakpoints = [];

            breakpoints = breakpoints.toString().split(',');

            slidesToShow = slidesToShow ? slidesToShow = slidesToShow.toString().split(',') : [];
            slidesToScroll = slidesToScroll ? slidesToScroll.toString().split(',') : [];

            _jquery2.default.each(breakpoints, function (i, breakpoint) {
                responsiveBreakpoints.push({
                    breakpoint: parseInt(breakpoint, 10),
                    settings: {
                        slidesToShow: parseFloat(slidesToShow[i], 10) || 1,
                        slidesToScroll: parseFloat(slidesToScroll[i], 10) || 1
                    }
                });
            });

            return responsiveBreakpoints;
        }
    }, {
        key: 'initCarousel',
        value: function initCarousel() {
            this.setArrowsTheme();

            if (this.$element.data('carouselDeferInit')) {
                return false;
            }

            if (this.$carousel.hasClass('slick-initialized') && !this.isOn) {
                this.$carousel.slick('unslick');
            }

            if (!this.$carousel.hasClass('slick-initialized') && this.isOn) {
                this.$carousel.slick(this.options);
            }
            this.setArrowsColor();
        }
    }, {
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();
            this.onResize();
        }
    }, {
        key: 'setArrowsTheme',
        value: function setArrowsTheme() {
            if (!this.options.arrowsTheme) {
                return;
            }
            switch (this.options.arrowsTheme) {
                case 'cfa':
                    this.options.prevArrow = '<button\n                class="slick-prev"\n                type="button"\n                title="Previous Slide"\n                aria-label="Previous Slide"\n                data-gtm-on = "click"\n                data-gtm-category="' + Carousel.currentSection + '"\n                data-gtm-action="Carousel Arrow"\n                data-gtm-label = "Previous Slide">\n                        <svg class="icon icon-arrow" width="12" height="20" aria-hidden="true" focusable="false">\n                            <use xlink:href="#icon-chevron-left"></use>\n                        </svg>\n                    </button>';
                    this.options.nextArrow = '<button\n                class="slick-next"\n                type="button"\n                title="Next Slide"\n                aria-label="Next Slide"\n                data-gtm-on = "click"\n                data-gtm-category="' + Carousel.currentSection + '"\n                data-gtm-action="Carousel Arrow"\n                data-gtm-label = "Next Slide">\n                        <svg class="icon icon-arrow" width="12" height="20" aria-hidden="true" focusable="false">\n                            <use xlink:href="#icon-chevron-right"></use>\n                        </svg>\n                    </button>';
                    break;

                case 'edu':
                    this.options.prevArrow = '<button\n                class="slick-prev js-arrow-left"\n                title="Previous Slide test"\n                aria-label="Previous Slide "\n                data-gtm-on = "click"\n                data-gtm-event-category="' + Carousel.currentSection + '"\n                data-gtm-event-action="Carousel Arrow"\n                data-gtm-event-label = "Previous Slide"\n                tabindex="-1">\n                        <svg class="icon icon-arrow" width="16" height="28" aria-hidden="true" focusable="false">\n                            <use xlink:href="#icon-chevron-left-thin"></use>\n                        </svg>\n                    </button>';
                    this.options.nextArrow = '<button\n                class="slick-next js-arrow-right"\n                title="Next Slide test"\n                aria-label="Next Slide"\n                data-gtm-on = "click"\n                data-gtm-event-category="' + Carousel.currentSection + '"\n                data-gtm-event-action="Carousel Arrow"\n                data-gtm-event-label = "Next Slide"\n                tabindex="-1">\n                        <svg class="icon icon-arrow" width="16" height="28" aria-hidden="true" focusable="false">\n                            <use xlink:href="#icon-chevron-right-thin"></use>\n                        </svg>\n                    </button>';
                    break;
            }
        }
    }, {
        key: 'setArrowsColor',
        value: function setArrowsColor() {
            if (!this.options.dynamicArrowsColor) {
                return;
            }

            var $activeSlide = this.$carousel.find('.slick-active');
            var activeArrowColor = $activeSlide.data('arrowColor');
            this.$element.removeClass('white-arrows blue-arrows');

            switch (activeArrowColor) {
                case 'white':
                case 'opposite-blue':
                    this.$element.addClass('white-arrows');
                    break;
                case 'blue':
                case 'opposite-white':
                    this.$element.addClass('blue-arrows');
                    break;
            }
        }
    }, {
        key: 'onResize',
        value: function onResize() {
            var isMobileOn = !_resize2.default.isTablet && this.options.mobileOn,
                isTabletOn = _resize2.default.isTablet && !_resize2.default.isDesktop && this.options.tabletOn,
                isDesktopOn = _resize2.default.isDesktop && this.options.desktopOn;
            this.isOn = isMobileOn || isTabletOn || isDesktopOn;

            this.initCarousel();
        }
    }, {
        key: 'swipeHandler',
        value: function swipeHandler(e, slick, direction) {
            (0, _jquery2.default)(window).trigger('gtm:send', [Carousel.currentSection, 'Carousel', 'Swipe ' + direction]);
        }
    }], [{
        key: 'currentSection',
        get: function get() {
            var mainNode = document.querySelector('#main-content');
            if (mainNode) {
                return mainNode.hasAttribute('data-current-section') ? mainNode.getAttribute('data-current-section') : '';
            }
            return '';
        }
    }]);

    return Carousel;
}(_snappy2.default.BaseComponent);

(0, _jquery2.default)(function () {
    (0, _jquery2.default)(window).resize(function () {
        (0, _jquery2.default)('div.strip-carousel .carousel').slick('resize');
    });
    var ele1 = (0, _jquery2.default)(".hero-bleed-container .fa-carousel .slick-track").find(".carousel__slide");
    var btnEle = document.getElementById("close-btn");
    if (btnEle) {
        if (ele1 && ele1.length <= 1) {
            btnEle.style.display = "none";
        } else {
            btnEle.style.display = "block";
        }
    }

    // remove aria-live from slick-list
    setTimeout(function () {
        if (document.getElementsByClassName('slick-list')[0]) document.getElementsByClassName('slick-list')[0].removeAttribute('aria-live');
        if (document.getElementsByClassName('slick-list')[1]) document.getElementsByClassName('slick-list')[1].removeAttribute('aria-live');
    }, 500);
});
(0, _jquery2.default)(function () {
    var paused = true;
    (0, _jquery2.default)(".close-btn").click(function () {
        if (paused) {
            (0, _jquery2.default)('.carousel').slick('slickPause');
            if ((0, _jquery2.default)(this).hasClass("pause-image")) (0, _jquery2.default)(this).removeClass('pause-image');
            (0, _jquery2.default)(this).addClass('play-image');
        } else {
            (0, _jquery2.default)('.carousel').slick('slickPlay');
            if ((0, _jquery2.default)(this).hasClass("play-image")) (0, _jquery2.default)(this).removeClass('play-image');
            (0, _jquery2.default)(this).addClass('pause-image');
        }
        paused = !paused;
    });
});

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.Cookie = function (_Snappy$BaseComponent) {
    _inherits(Cookie, _Snappy$BaseComponent);

    _createClass(Cookie, [{
        key: 'setVars',
        value: function setVars() {
            this.$button = this.$element.find('.accept-cta');
            this.cookieVisibilityKey = 'fa-cookie-visible';
            this.isCookieMessageVisible = this.getCookieMessageVisibility();
            this.activeClass = 'active';
            this.surveyVisibilityKey = 'fa-survey-visible';
            var surveyUniqueID = (0, _jquery2.default)('.SurveyUniqueID');
            if (surveyUniqueID.length) {
                this.SurveyUniqueID = surveyUniqueID.text();
            }
            this.surveyAlreadyActionedByUserKey = 'fa-survey-actioned' + this.SurveyUniqueID;
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            this.$button.on('click', this.acceptCookies.bind(this));
        }
    }, {
        key: 'getCookieMessageVisibility',
        value: function getCookieMessageVisibility() {
            var visible = JSON.parse(localStorage.getItem(this.cookieVisibilityKey));

            if (visible === null) {
                // no preference stored, so message should be shown
                visible = true;
            }

            return visible;
        }
    }, {
        key: 'setCookieMessageVisibility',
        value: function setCookieMessageVisibility(visible) {
            localStorage.setItem(this.cookieVisibilityKey, visible);
        }
    }, {
        key: 'hideCookieMessage',
        value: function hideCookieMessage() {
            this.$element.removeClass(this.activeClass);
        }
    }], [{
        key: 'tagName',
        get: function get() {
            return 'fa-cookie';
        }
    }]);

    function Cookie(element) {
        _classCallCheck(this, Cookie);

        return _possibleConstructorReturn(this, (Cookie.__proto__ || Object.getPrototypeOf(Cookie)).call(this, element));
    }

    _createClass(Cookie, [{
        key: 'render',
        value: function render() {

            this.setVars();
            this.setEventListeners();
            this.showCookieMessage();
        }
    }, {
        key: 'showCookieMessage',
        value: function showCookieMessage() {

            if (this.isCookieMessageVisible) {
                this.$element.addClass(this.activeClass);
            } else {
                //alert("show survey");
                this.displaySurvey();
            }
        }
    }, {
        key: 'acceptCookies',
        value: function acceptCookies() {

            this.hideCookieMessage();
            this.setCookieMessageVisibility(false);
            this.displaySurvey();
        }
    }, {
        key: 'displaySurvey',
        value: function displaySurvey() {
            if (this.getSurveyAlreadyActionedByUser()) return; //User has already seen and accepted/declined the survey        

            var surveyVisible = localStorage.getItem(this.surveyVisibilityKey);
            if (surveyVisible != null && surveyVisible == 'True') {
                //alert("survey triggered in past");
                //user has already accepted the cookie in past and survey has been triggered
                this.incrementCurrentUserNumberAjax();
                this.getDisplaySurveyAfterTimeInSecondsAndDisplay();
            } else {
                //Triggered when user accepts the cookie
                //OR            
                //if cookie message has been accepted in another session and survey has not been shown yet
                //alert("accept cookie");
                var cookieAccepted = localStorage.getItem(this.cookieVisibilityKey);
                if (cookieAccepted != null && cookieAccepted != "True") //cookie has been accepted
                    {
                        var surveyEnabled = (0, _jquery2.default)('.survey-Enabled'); //Is survey enabled
                        if (surveyEnabled.length && surveyEnabled.text().toLowerCase() == "true") {
                            var displayToCurrentVisitor = (0, _jquery2.default)('.survey-DisplayToCurrentVisitor'); //Should survey be shown to current visitor
                            if (displayToCurrentVisitor.length && displayToCurrentVisitor.text().toLowerCase() == "true") {
                                localStorage.setItem(this.surveyVisibilityKey, "True"); //set survey localstorage to visible                
                                this.incrementCurrentUserNumberAjax();
                                this.getDisplaySurveyAfterTimeInSecondsAndDisplay();
                            }
                        }
                    }
            }
        }

        //Ajax call to get information from server

    }, {
        key: 'getDisplaySurveyAfterTimeInSecondsAndDisplay',
        value: function getDisplaySurveyAfterTimeInSecondsAndDisplay() {
            var serviceURL = (0, _jquery2.default)(".DisplaySurveyAfterInSecondsUrl").text();
            var displayAfterTimeInSurveyItemInSeconds = (0, _jquery2.default)('.survey-DisplayAfterTime').text();
            _jquery2.default.ajax({
                type: "GET",
                url: serviceURL,
                dataType: "json",
                data: { displayAfterTimeInSurveyItemInSeconds: displayAfterTimeInSurveyItemInSeconds },
                success: successFunc,
                error: errorFunc
            });
            function successFunc(returnedData) {
                var displayAfterTime = parseInt(returnedData);
                //alert('successCookie' + displayAfterTime);
                var survey = (0, _jquery2.default)('.fa-survey');
                setTimeout(function () {
                    survey.addClass('active');
                }, displayAfterTime);
            }

            function errorFunc(error, status) {
                //alert('error' + JSON.stringify(error));
                var survey = (0, _jquery2.default)('.fa-survey');
                survey.addClass('active'); //survey will be displayed immediately
            }
        }

        //Ajax call to increment user number

    }, {
        key: 'incrementCurrentUserNumberAjax',
        value: function incrementCurrentUserNumberAjax() {
            if (this.getCookie("sessionNew") != "false") {
                var successFunc = function successFunc(data, status) {
                    //alert('success' + data);
                };

                var errorFunc = function errorFunc(error, status) {
                    //alert('error' + JSON.stringify(status + "     " + error));
                };

                var serviceURL = (0, _jquery2.default)(".incrementCurrentUserNumberUrl").text();
                var websiteName = (0, _jquery2.default)('.SurveyWebsiteName').text();
                //alert(websiteName);
                _jquery2.default.ajax({
                    type: "GET",
                    url: serviceURL,
                    dataType: "json",
                    data: { websiteName: websiteName },
                    contentType: "application/json; charset=utf-8",
                    success: successFunc,
                    error: errorFunc
                });
            }
        }

        //This is browser document.cookie and not fa website cookie(which is based on concept of localstorage)

    }, {
        key: 'getCookie',
        value: function getCookie(cname) {
            var name = cname + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }
    }, {
        key: 'getSurveyAlreadyActionedByUser',
        value: function getSurveyAlreadyActionedByUser() {

            var actioned = localStorage.getItem(this.surveyAlreadyActionedByUserKey);
            if (actioned != null && actioned == "True") {
                return true;
            }
            return false;
        }
    }]);

    return Cookie;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.FeaturedEvent = function (_Snappy$BaseComponent) {
    _inherits(FeaturedEvent, _Snappy$BaseComponent);

    _createClass(FeaturedEvent, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-featured-event';
        }
    }]);

    function FeaturedEvent(element) {
        _classCallCheck(this, FeaturedEvent);

        return _possibleConstructorReturn(this, (FeaturedEvent.__proto__ || Object.getPrototypeOf(FeaturedEvent)).call(this, element));
    }

    _createClass(FeaturedEvent, [{
        key: 'setVars',
        value: function setVars() {}
    }, {
        key: 'render',
        value: function render() {}
    }]);

    return FeaturedEvent;
}(_snappy2.default.BaseComponent);

(0, _jquery2.default)(function () {
    var CWFeaturedEvent = new _snappy2.default.Component.FeaturedEvent();

    (0, _jquery2.default)('.expand').click(function () {
        (0, _jquery2.default)(this).parent().next().next().fadeIn("fast");
        (0, _jquery2.default)(this).parent().closest('.featured-event').addClass('overlay-active');
    });

    (0, _jquery2.default)('.exit').click(function () {
        (0, _jquery2.default)(this).parent().fadeOut("fast");
        (0, _jquery2.default)(this).parent().closest('.featured-event').removeClass('overlay-active');
    });

    (0, _jquery2.default)('.featured-event').hover(function () {
        (0, _jquery2.default)(this).toggleClass('has-focus');
    });
});

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _handlebars = __webpack_require__(21);

var _handlebars2 = _interopRequireDefault(_handlebars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

__webpack_require__(75);

_snappy2.default.Component.Footer = function (_Snappy$BaseComponent) {
	_inherits(Footer, _Snappy$BaseComponent);

	_createClass(Footer, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-footer';
		}
	}]);

	function Footer(element) {
		_classCallCheck(this, Footer);

		return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this, element));
	}

	_createClass(Footer, [{
		key: 'setVars',
		value: function setVars() {
			this.$newsletterForm = this.$element.find('.fa-footer__newsletter__form');
			this.$socialSelect = this.$element.find('.fa-dropdown__select');
			this.$newsletterResponseTemplate = (0, _jquery2.default)('#newsletter-response-template');
			this.activeClass = 'active';
			this.inactiveClass = 'inactive';
			this.submittedClass = 'submitted';
			this.errorClass = 'fa-input-field--error';
			this.messageClass = 'fa-input-field__error-message';
		}
	}, {
		key: 'setEventListeners',
		value: function setEventListeners() {
			this.$socialSelect.on('change', this.onSocialSelectChange.bind(this));
			this.$newsletterForm.on('submit', this.validateNewsletterForm.bind(this));

			if (this.$newsletterForm.length) {
				this.$window.on('modal:modalHasOpened', this.setNewsletterEventListeners.bind(this));
			}
		}
	}, {
		key: 'setNewsletterEventListeners',
		value: function setNewsletterEventListeners(event, modal) {
			modal.$element.find('.fa-footer__modal-form').on('submit', this.submitNewsletterSignup.bind(this, modal));
		}
	}, {
		key: 'validateNewsletterForm',
		value: function validateNewsletterForm(event) {
			var $emailField = this.$newsletterForm.find('input[type=email]');
			this.$newsletterForm.validate({
				rules: {
					'Email': {
						required: true,
						email: true
					}
				}
			});

			if ($emailField.valid()) {
				this.openNewsletterModal();
			} else {
				$emailField.focus();
			}

			event.preventDefault();
		}
	}, {
		key: 'handleValidationResponse',
		value: function handleValidationResponse(response) {
			if (response.success) {
				this.removeValidationError(response);
				this.openNewsletterModal();
			} else {
				this.showValidationError(response);
			}
		}
	}, {
		key: 'showValidationError',
		value: function showValidationError(response) {
			var $element = (0, _jquery2.default)('#' + response.element);

			$element.addClass(this.errorClass).parent().addClass(this.errorClass).find('.' + this.messageClass).text(response.message);
		}
	}, {
		key: 'removeValidationError',
		value: function removeValidationError(response) {
			var $element = (0, _jquery2.default)('#' + response.element);

			$element.removeClass(this.errorClass).parent('[data-fa-input-field]').removeClass(this.errorClass).find('.' + this.messageClass).text('');
		}
	}, {
		key: 'submitNewsletterSignup',
		value: function submitNewsletterSignup(modal, event) {
			var url = modal.$element.find('.fa-footer__modal-form').attr('action');
			var emailAddress = this.$newsletterForm.find('input[type=email]').val();
			var categories = modal.$element.find('input:checked').map(function (i, el) {
				return el.value;
			}).get().join();
			event.preventDefault();
			_jquery2.default.ajax({
				"url": url,
				"type": "post",
				"data": {
					"emailAddress": emailAddress,
					"categories": categories
				}
			}).always(this.handleNewsletterResponse.bind(this, modal));
		}
	}, {
		key: 'handleNewsletterResponse',
		value: function handleNewsletterResponse(modal, response) {
			var template = this.getNewsletterResponseTemplate();
			var responseHtml = template(response);
			var $error = (0, _jquery2.default)('.fa-footer__newsletter__modal-content').children('.' + this.messageClass);

			if (response.success) {
				this.closeNewsletterModal(modal);
				this.$newsletterForm.addClass(this.submittedClass).after(responseHtml);
			} else {
				$error.text(response.message).addClass(this.activeClass);
				$error[0].focus();
			}
		}
	}, {
		key: 'getNewsletterResponseTemplate',
		value: function getNewsletterResponseTemplate() {
			var template = void 0;

			if (this.$newsletterResponseTemplate) {
				template = _handlebars2.default.compile(this.$newsletterResponseTemplate.html());
			}

			return template;
		}
	}, {
		key: 'openNewsletterModal',
		value: function openNewsletterModal() {
			var $button = this.$newsletterForm.find('button');
			this.$window.trigger('modal:openModal', {
				$view: (0, _jquery2.default)($button.data('modal-template')),
				title: $button.data('modal-title'),
				$prevElement: $button
			});
		}
	}, {
		key: 'closeNewsletterModal',
		value: function closeNewsletterModal(modal) {
			modal.closeModal();
		}
	}, {
		key: 'hideSocialChannels',
		value: function hideSocialChannels() {
			this.$element.find('.fa-footer__social-channels__channel').addClass(this.inactiveClass);
		}
	}, {
		key: 'onSocialSelectChange',
		value: function onSocialSelectChange(event) {
			var section = event && event.currentTarget && event.currentTarget.value;
			if (section) {
				this.hideSocialChannels();
				this.$element.find('[data-social-section="' + section + '"]').removeClass(this.inactiveClass);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			this.setVars();
			this.setEventListeners();
			this.onSocialSelectChange({
				currentTarget: {
					value: this.$socialSelect.val()
				}
			});
		}
	}]);

	return Footer;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.InputField = function (_Snappy$BaseComponent) {
	_inherits(InputField, _Snappy$BaseComponent);

	_createClass(InputField, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-input-field';
		}
	}]);

	function InputField(element) {
		_classCallCheck(this, InputField);

		return _possibleConstructorReturn(this, (InputField.__proto__ || Object.getPrototypeOf(InputField)).call(this, element));
	}

	_createClass(InputField, [{
		key: 'render',
		value: function render() {}
	}]);

	return InputField;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.Modal = function (_Snappy$BaseComponent) {
    _inherits(Modal, _Snappy$BaseComponent);

    _createClass(Modal, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-modal';
        }
    }]);

    function Modal(element) {
        _classCallCheck(this, Modal);

        var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, element));

        _this.modalIsOpen = false;
        _this.modalOpenClass = 'fa-modal--modal-open';
        return _this;
    }

    _createClass(Modal, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.initModalService();

            (0, _jquery2.default)(function () {
                for (var child in document.body.children) {
                    if (!document.body.children.hasOwnProperty(child)) continue;

                    if (document.body.children[child].nodeName === 'svg') {
                        document.body.children[child].setAttribute('focusable', 'false');
                    }
                }
            });
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.focusableElements = [];
            this.$modalContents = this.$element.find('.js-modal-contents');
            this.$modalCloseButton = this.$element.find('.js-modal-close');
            this.$modalTitle = this.$element.find('.js-modal-title');
            this.$modalVideoDuration = this.$element.find('.js-modal-video-duration');
            this.$modalBase = this.$element.find('.js-modal-base');
            this.fullscreenClass = 'fullscreen';
        }
    }, {
        key: 'initModalService',
        value: function initModalService() {
            this.$window.on('modal:openModal', this.onOpenModalEvent.bind(this));
            this.$window.on('keyup', this.onKeyupEvent.bind(this));
            this.$modalCloseButton.on('click', this.onCloseModalButtonClick.bind(this));
            this.$modalBase.on('click', this.onModalBaseClick.bind(this));
        }
    }, {
        key: 'onOpenModalEvent',
        value: function onOpenModalEvent(event, options) {
            this.modalIsOpen = true;
            this.$previousFocusedElement = options.$prevElement;
            this.openModal(options);
        }
    }, {
        key: 'onKeyupEvent',
        value: function onKeyupEvent(event) {
            if (event && event.keyCode === 27 && this.modalIsOpen) {
                this.closeModal();
            }
        }
    }, {
        key: 'onCloseModalButtonClick',
        value: function onCloseModalButtonClick() {
            this.closeModal();
        }
    }, {
        key: 'openModal',
        value: function openModal(options) {
            var $template = options && options.$view;
            var title = options && options.title;
            var isFullscreen = options && options.fullscreen;
            var videoDuration = options && options.videoDuration;
            this.isUnclosable = options && options.unclosable;
            this.unclosableBase = options && options.unclosableBase;

            this.$body.addClass(this.modalOpenClass);
            this.$body.trigger('body:block');
            this.toggleFocusable(false);
            if ($template) {
                this.$modalContents.append($template.html());
                this.$modalTitle.text(title);
                this.$element.attr('tabindex', '0').focus();
                this.$window.trigger('modal:modalHasOpened', [this]);

                if (isFullscreen) {
                    this.$element.addClass(this.fullscreenClass);
                }
                if (this.$modalVideoDuration.length && videoDuration) {
                    this.$modalVideoDuration.text(videoDuration);
                }
            }

            (0, _jquery2.default)(window).trigger('content:updated');
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            if (this.isUnclosable) {
                this.redirect();
                return;
            }
            this.toggleFocusable(true);
            this.modalIsOpen = false;
            this.$body.removeClass(this.modalOpenClass);
            this.$body.trigger('body:unblock');
            this.$modalContents.empty();
            this.$modalVideoDuration.empty();
            this.$previousFocusedElement.focus();
            this.$element.removeClass(this.fullscreenClass);
        }
    }, {
        key: 'onModalBaseClick',
        value: function onModalBaseClick() {
            this.closeModal();
        }
    }, {
        key: 'toggleFocusable',
        value: function toggleFocusable(shouldFocus) {
            var focusableSelectors = ['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'iframe', 'object', 'embed', '[contenteditable]'].join(',');

            if (!shouldFocus) {
                this.focusableElements = (0, _jquery2.default)('body').children(':not([data-fa-modal])').find(focusableSelectors).toArray();
            }

            this.focusableElements.forEach(function (element) {
                element.setAttribute('tabindex', shouldFocus ? '0' : '-1');
            });
        }
    }, {
        key: 'redirect',
        value: function redirect() {
            this.$modalCloseButton.attr('disabled', '');
            var redirectUrl = void 0;
            var matches = document.referrer.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i);
            var domain = matches && matches[1];
            if (domain && domain.indexOf('thefa.com') > -1) {
                redirectUrl = document.referrer;
            } else {
                redirectUrl = window.location.protocol + '//' + window.location.hostname + this.unclosableBase;
            }

            window.location.href = redirectUrl;
        }
    }]);

    return Modal;
}(_snappy2.default.BaseComponent);

_snappy2.default.Component.ModalTrigger = function (_Snappy$BaseComponent2) {
    _inherits(ModalTrigger, _Snappy$BaseComponent2);

    _createClass(ModalTrigger, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-modal-trigger';
        }
    }]);

    function ModalTrigger(element) {
        _classCallCheck(this, ModalTrigger);

        return _possibleConstructorReturn(this, (ModalTrigger.__proto__ || Object.getPrototypeOf(ModalTrigger)).call(this, element));
    }

    _createClass(ModalTrigger, [{
        key: 'render',
        value: function render() {
            this.addEventListeners();
        }
    }, {
        key: 'addEventListeners',
        value: function addEventListeners() {
            this.$element.on('click', this.onModalTriggerClick.bind(this));
        }
    }, {
        key: 'onModalTriggerClick',
        value: function onModalTriggerClick(event) {
            var $view = this.$body.find(this.$element.data('modal-template'));
            var modalTitle = this.$element.data('modal-title');
            var $prevElement = event && (0, _jquery2.default)(event.currentTarget);
            this.$window.trigger('modal:openModal', {
                $view: $view,
                title: modalTitle,
                $prevElement: $prevElement
            });
        }
    }]);

    return ModalTrigger;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.RowStrip = function (_Snappy$BaseComponent) {
    _inherits(RowStrip, _Snappy$BaseComponent);

    _createClass(RowStrip, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-row-strip';
        }
    }]);

    function RowStrip(element) {
        _classCallCheck(this, RowStrip);

        var _this = _possibleConstructorReturn(this, (RowStrip.__proto__ || Object.getPrototypeOf(RowStrip)).call(this, element));

        _this.backgroundImage = new Image();
        return _this;
    }

    _createClass(RowStrip, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setStripDisplayRules();
            this.setEventListeners();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.options = {
                images: {
                    small: this.$element.data('smallImage'),
                    large: this.$element.data('largeImage')
                },
                backgroundColor: this.$element.data('backgroundColor')
            };
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            window.addEventListener('fa.viewportResize', this.setRelevantBackground.bind(this));
            document.addEventListener("DOMContentLoaded", this.changeTitleColor());
        }
    }, {
        key: 'setStripDisplayRules',
        value: function setStripDisplayRules() {
            if (this.options.images.small && this.options.images.large) {
                this.setRelevantBackground();
            } else {
                this.setStripColor();
            }
        }
    }, {
        key: 'setRelevantBackground',
        value: function setRelevantBackground() {

            /**
            * This functionality has a bug which results in the '--loaded' class not being added to elements with class '.fa-row-strip'.
            * This bug causes many components tobe left hidden on mobile
            *
            * The CSS transition for the 'fa-row-strip' class has been temporarily disabled until a fix can be found
            */

            this.imageToRequest = window.globalConfigs.viewportIsBelowLarge ? this.options.images.small : this.options.images.large;

            if (this.imageToRequest !== this.cachedImagePath) {
                this.backgroundImage.src = this.imageToRequest;
                this.backgroundImage.onload = this.onImageLoadedSuccess.bind(this);
                this.backgroundImage.onerror = this.fallbackToDefault.bind(this);

                this.cachedImagePath = this.imageToRequest;
            }
        }
    }, {
        key: 'onImageLoadedSuccess',
        value: function onImageLoadedSuccess() {
            this.$element.css({
                backgroundImage: 'url(' + this.imageToRequest + ')'
            });

            this.setStripReady();
        }
    }, {
        key: 'fallbackToDefault',
        value: function fallbackToDefault() {
            this.setStripReady();
        }
    }, {
        key: 'setStripReady',
        value: function setStripReady() {
            this.$element.addClass('fa-row-strip--loaded');
        }
    }, {
        key: 'setStripColor',
        value: function setStripColor() {
            var backgroundColor = this.options.backgroundColor;

            if (backgroundColor) {
                this.$element.css({
                    backgroundColor: backgroundColor
                });
            }

            this.setStripReady();
        }
    }, {
        key: 'changeTitleColor',
        value: function changeTitleColor() {
            var _this2 = this;

            if (this.options.backgroundColor && document.body.classList.contains('ws-theme')) {
                var links = this.$element.find('.fa-row-heading__link') ? this.$element.find('.fa-row-heading__link') : null;
                console.log("link", links);
                if (this.lightOrDark(this.options.backgroundColor) === 'light') {
                    this.$element.find('.fa-row-heading__title').css('color', '#011e41');
                    this.$element.find('.fa-row-heading__intro ').css('color', '#011e41');
                    this.$element.find('.fa-row-heading__title span').css('fill', '#011e41');

                    if (links) {
                        this.$element.find('.fa-row-heading__link').css('color', '#011e41');
                        links.map(function (i, link) {
                            link.addEventListener('mouseover', function (e) {
                                console.log(e.currentTarget);
                                e.currentTarget.style.color = '#007b85';
                                _this2.$element.find('.fa-row-heading__title .icon').css('color', '#007b85');
                            });

                            link.addEventListener('mouseleave', function (e) {
                                e.currentTarget.style.color = '#011e41';
                                _this2.$element.find('.fa-row-heading__title .icon').css('color', '#011e41');
                            });
                        });
                    }
                } else {
                    this.$element.find('.fa-row-heading__title').css('color', '#fff');
                    this.$element.find('.fa-row-heading__title span').css('fill', '#fff');
                    this.$element.find('.fa-row-heading__intro').css('color', '#fff');

                    if (links) {
                        this.$element.find('.fa-row-heading__link').css('color', '#fff');
                        links.map(function (i, link) {
                            link.addEventListener('mouseover', function (e) {
                                e.currentTarget.style.color = '#3bffcc';
                                _this2.$element.find('.fa-row-heading__title .icon').css('color', '#3bffcc');
                            });

                            link.addEventListener('mouseleave', function (e) {
                                e.currentTarget.style.color = '#fff';
                                _this2.$element.find('.fa-row-heading__title .icon').css('color', '#fff');
                            });
                        });
                    }
                }
            }
        }
    }, {
        key: 'lightOrDark',
        value: function lightOrDark(color) {
            var r, g, b, hsp;
            if (this.options.backgroundColor && document.body.classList.contains('ws-theme')) {
                if (color.match(/^rgb/)) {

                    color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

                    r = color[1];
                    g = color[2];
                    b = color[3];
                } else {
                    color = +("0x" + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));

                    r = color >> 16;
                    g = color >> 8 & 255;
                    b = color & 255;
                }

                // HSP equation from http://alienryderflex.com/hsp.html
                hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

                if (hsp > 140.5) {

                    return 'light';
                } else {

                    return 'dark';
                }
            }
        }
    }]);

    return RowStrip;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.SubNavigation = function (_Snappy$BaseComponent) {
	_inherits(SubNavigation, _Snappy$BaseComponent);

	_createClass(SubNavigation, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-sub-navigation';
		}
	}]);

	function SubNavigation(element) {
		_classCallCheck(this, SubNavigation);

		var _this = _possibleConstructorReturn(this, (SubNavigation.__proto__ || Object.getPrototypeOf(SubNavigation)).call(this, element));

		_this.adjustmentCount = 0;
		return _this;
	}

	_createClass(SubNavigation, [{
		key: 'render',
		value: function render() {
			this.setVars();
			this.addListeners();

			if (window.matchMedia('(min-width: 992px)').matches) {
				this.calculateMenuItemsPosition();
			}
		}
	}, {
		key: 'setVars',
		value: function setVars() {
			this.$mainMenu = this.$element.find('.fa-sub-navigation__section-links');
			this.$mainMenuItems = this.$mainMenu.find('.section-links__list');
			this.$innerContent = this.$element.find('.fa-sub-navigation__inner-content');
			this.$moreMenu = this.$element.find('.section-links__more-dropdown');
			this.$moreBtn = this.$element.find('.section-links__more-text');
			this.$moreBtnParent = this.$element.find('.section-links__more-list-item');
		}
	}, {
		key: 'addListeners',
		value: function addListeners() {
			var throttledViewportResizeHandler = (0, _underscore.throttle)(this.onViewportResize.bind(this), 100);
			var throttledOnScrollHandler = (0, _underscore.throttle)(this.onDocumentScroll.bind(this), 50);

			this.$window.on('resize', throttledViewportResizeHandler);
			this.$window.on('scroll', throttledOnScrollHandler);
			this.$moreBtn.on('mouseover focus', this.onMoreBtnHover.bind(this));
			this.$moreBtn.on('mouseout focusout', this.onMoreBtnBlur.bind(this));
			this.$moreMenu.on('mouseout focusout', this.onMoreBtnBlur.bind(this));
		}
	}, {
		key: 'onViewportResize',
		value: function onViewportResize() {
			if (window.matchMedia('(min-width: 992px)').matches) {
				this.calculateMenuItemsPosition();
			}
		}
	}, {
		key: 'onDocumentScroll',
		value: function onDocumentScroll() {
			this.stickySubNavIsActive = this.$window.scrollTop() > 40;

			this.toggleStickySubNav();
		}
	}, {
		key: 'onMoreBtnHover',
		value: function onMoreBtnHover() {
			this.$moreBtnParent.addClass('active');
		}
	}, {
		key: 'onMoreBtnBlur',
		value: function onMoreBtnBlur(event) {
			var toElement = event.toElement || event.relatedTarget;
			var toElementIsInContainingElementChildren = _jquery2.default.contains(this.$moreMenu[0], toElement);

			if (!toElementIsInContainingElementChildren) {
				this.$moreBtnParent.removeClass('active');
			}
		}
	}, {
		key: 'calculateMenuItemsPosition',
		value: function calculateMenuItemsPosition() {
			// need to show/hide ul if has content/empty
			this.mainMenuWidth = this.$mainMenu.width();
			this.availableSpace = this.$innerContent.width() - 160;
			this.viewportIsTooNarrow = this.mainMenuWidth > this.availableSpace;

			this.toggleMoreButtonVisibility();

			if (this.viewportIsTooNarrow) {
				this.moveListItemToMoreDropdown();
			} else {
				if (this.cachedMainMenu < this.availableSpace) {
					var $listItem = this.$moreMenu.find('.section-links__list-item').last();

					$listItem.insertBefore(this.$mainMenuItems.find('.section-links__more-list-item'));
					this.calculateMenuItemsPosition();
				}
			}
		}
	}, {
		key: 'toggleMoreButtonVisibility',
		value: function toggleMoreButtonVisibility() {
			this.$element.toggleClass('fa-sub-navigation--viewport-narrow', this.viewportIsTooNarrow || this.adjustmentCount > 0);
		}
	}, {
		key: 'moveListItemToMoreDropdown',
		value: function moveListItemToMoreDropdown() {
			var $listItem = this.$mainMenu.find('.section-links__list > .section-links__list-item:not(.section-links__more-list-item)').last();
			var $clonedListItem = $listItem.clone();

			this.$moreMenu.append($clonedListItem[0]);
			$listItem.remove();
			this.adjustmentCount += 1;
			this.cachedMainMenu = this.mainMenuWidth;

			this.calculateMenuItemsPosition();
		}
	}, {
		key: 'toggleStickySubNav',
		value: function toggleStickySubNav() {
			this.$body.toggleClass('sticky-subnav--active', this.stickySubNavIsActive);
		}
	}]);

	return SubNavigation;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.Textarea = function (_Snappy$BaseComponent) {
	_inherits(Textarea, _Snappy$BaseComponent);

	_createClass(Textarea, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-textarea';
		}
	}]);

	function Textarea(element) {
		_classCallCheck(this, Textarea);

		return _possibleConstructorReturn(this, (Textarea.__proto__ || Object.getPrototypeOf(Textarea)).call(this, element));
	}

	_createClass(Textarea, [{
		key: 'render',
		value: function render() {}
	}]);

	return Textarea;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.ServerValidation = function (_Snappy$BaseComponent) {
  _inherits(ServerValidation, _Snappy$BaseComponent);

  _createClass(ServerValidation, null, [{
    key: 'tagName',
    get: function get() {
      return 'fa-form-validation';
    }
  }]);

  function ServerValidation(element) {
    _classCallCheck(this, ServerValidation);

    return _possibleConstructorReturn(this, (ServerValidation.__proto__ || Object.getPrototypeOf(ServerValidation)).call(this, element));
  }

  _createClass(ServerValidation, [{
    key: 'setVars',
    value: function setVars() {
      this.errorClass = 'fa-input-field--error';
      this.messageClass = 'fa-input-field__error-message';
    }
  }, {
    key: 'setEventListeners',
    value: function setEventListeners() {
      this.$element.on('submit', this.validateForm.bind(this));
    }
  }, {
    key: 'validateForm',
    value: function validateForm(event) {
      event.preventDefault();

      /* TEMP - expected JSON format from server
      {
          "success": false,
          "fields": [
            {
              "success": false,
              "element": "email-field",
              "message": "Please enter an email address"
            },
            {
              "success": true,
              "element": "text-field"
            },
            {
              "success": false,
              "element": "dropdown-field",
              "message": "Please choose an option"
            }
          ]
      }
      */
      _jquery2.default.ajax({
        "url": this.$element.attr('action'),
        "method": this.$element.attr('method'),
        "data": this.$element.serialize()
      }).always(this.handleValidationResponse.bind(this));
    }
  }, {
    key: 'handleValidationResponse',
    value: function handleValidationResponse(response) {
      var _this2 = this;

      if (!response.success) {
        _jquery2.default.each(response.fields, function (i, field) {
          if (!field.success) {
            _this2.showValidationError(field);
          } else {
            _this2.removeValidationError(field);
          }
        });
      } else {
        this.$element.off().submit();
      }
    }
  }, {
    key: 'showValidationError',
    value: function showValidationError(field) {
      var $element = this.$element.find('[name=' + field.element + ']');

      $element.addClass(this.errorClass).parent().addClass(this.errorClass).find('.' + this.messageClass).text(field.message);
    }
  }, {
    key: 'removeValidationError',
    value: function removeValidationError(field) {
      var $element = this.$element.find('[name=' + field.element + ']');

      $element.removeClass(this.errorClass).parent().removeClass(this.errorClass).find('.' + this.messageClass).text('');
    }
  }, {
    key: 'render',
    value: function render() {
      this.setVars();
      this.setEventListeners();
    }
  }]);

  return ServerValidation;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var jQuery = __webpack_require__(4);
window.$ = window.jQuery = jQuery;

__webpack_require__(83);
__webpack_require__(82);
__webpack_require__(74);

jQuery.noConflict(true);

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _underscore = __webpack_require__(31);

window.globalConfigs = {};

window.addEventListener('resize', (0, _underscore.throttle)(onViewportResize, 100));

window.opta_settings = {
  subscription_id: '996cf5a7e7d89eba508208bbb2604497',
  language: 'en_GB',
  timezone: 'Europe/London'
};

function CustomEvent(event, params) {
  var evt = document.createEvent('CustomEvent');

  params = params || { bubbles: false, cancelable: false, detail: undefined };
  evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);

  return evt;
}

CustomEvent.prototype = window.Event.prototype;
window.CustomEvent = CustomEvent;

var resizeEvent = new CustomEvent('fa.viewportResize');

function onViewportResize() {
  globalConfigs.viewportIsBelowLarge = window.matchMedia('(max-width: 991px)').matches;

  broadcastWindowResizeEvent();
}

function broadcastWindowResizeEvent() {
  window.dispatchEvent(resizeEvent);
}

onViewportResize();

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _picturefill = __webpack_require__(190);

var _picturefill2 = _interopRequireDefault(_picturefill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _picturefill2.default)();

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Production steps of ECMA-262, Edition 6, 22.1.2.1
if (!Array.from) {
  Array.from = function () {
    var toStr = Object.prototype.toString;
    var isCallable = function isCallable(fn) {
      return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
    };
    var toInteger = function toInteger(value) {
      var number = Number(value);
      if (isNaN(number)) {
        return 0;
      }
      if (number === 0 || !isFinite(number)) {
        return number;
      }
      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
    };
    var maxSafeInteger = Math.pow(2, 53) - 1;
    var toLength = function toLength(value) {
      var len = toInteger(value);
      return Math.min(Math.max(len, 0), maxSafeInteger);
    };

    // The length property of the from method is 1.
    return function from(arrayLike /*, mapFn, thisArg */) {
      // 1. Let C be the this value.
      var C = this;

      // 2. Let items be ToObject(arrayLike).
      var items = Object(arrayLike);

      // 3. ReturnIfAbrupt(items).
      if (arrayLike == null) {
        throw new TypeError("Array.from requires an array-like object - not null or undefined");
      }

      // 4. If mapfn is undefined, then let mapping be false.
      var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
      var T;
      if (typeof mapFn !== 'undefined') {
        // 5. else
        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
        if (!isCallable(mapFn)) {
          throw new TypeError('Array.from: when provided, the second argument must be a function');
        }

        // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
        if (arguments.length > 2) {
          T = arguments[2];
        }
      }

      // 10. Let lenValue be Get(items, "length").
      // 11. Let len be ToLength(lenValue).
      var len = toLength(items.length);

      // 13. If IsConstructor(C) is true, then
      // 13. a. Let A be the result of calling the [[Construct]] internal method
      // of C with an argument list containing the single item len.
      // 14. a. Else, Let A be ArrayCreate(len).
      var A = isCallable(C) ? Object(new C(len)) : new Array(len);

      // 16. Let k be 0.
      var k = 0;
      // 17. Repeat, while k < len… (also steps a - h)
      var kValue;
      while (k < len) {
        kValue = items[k];
        if (mapFn) {
          A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }
        k += 1;
      }
      // 18. Let putStatus be Put(A, "length", len, true).
      A.length = len;
      // 20. Return A.
      return A;
    };
  }();
}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _handlebars = __webpack_require__(21);

var _handlebars2 = _interopRequireDefault(_handlebars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_handlebars2.default.registerHelper('ifCond', function (v1, operator, v2, options) {

    switch (operator) {
        case '==':
            return v1 == v2 ? options.fn(this) : options.inverse(this);
        case '===':
            return v1 === v2 ? options.fn(this) : options.inverse(this);
        case '&&':
            return v1 && v2 ? options.fn(this) : options.inverse(this);
        case '||':
            return v1 || v2 ? options.fn(this) : options.inverse(this);
        default:
            return options.inverse(this);
    }
});

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! npm.im/object-fit-images 3.2.0 */


var OFI = 'bfred-it:object-fit-images';
var propRegex = /(object-fit|object-position)\s*:\s*([-\w\s%]+)/g;
var testImg = typeof Image === 'undefined' ? {style: {'object-position': 1}} : new Image();
var supportsObjectFit = 'object-fit' in testImg.style;
var supportsObjectPosition = 'object-position' in testImg.style;
var supportsOFI = 'background-size' in testImg.style;
var supportsCurrentSrc = typeof testImg.currentSrc === 'string';
var nativeGetAttribute = testImg.getAttribute;
var nativeSetAttribute = testImg.setAttribute;
var autoModeEnabled = false;

function createPlaceholder(w, h) {
	return ("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h + "'%3E%3C/svg%3E");
}

function polyfillCurrentSrc(el) {
	if (el.srcset && !supportsCurrentSrc && window.picturefill) {
		var pf = window.picturefill._;
		// parse srcset with picturefill where currentSrc isn't available
		if (!el[pf.ns] || !el[pf.ns].evaled) {
			// force synchronous srcset parsing
			pf.fillImg(el, {reselect: true});
		}

		if (!el[pf.ns].curSrc) {
			// force picturefill to parse srcset
			el[pf.ns].supported = false;
			pf.fillImg(el, {reselect: true});
		}

		// retrieve parsed currentSrc, if any
		el.currentSrc = el[pf.ns].curSrc || el.src;
	}
}

function getStyle(el) {
	var style = getComputedStyle(el).fontFamily;
	var parsed;
	var props = {};
	while ((parsed = propRegex.exec(style)) !== null) {
		props[parsed[1]] = parsed[2];
	}
	return props;
}

function setPlaceholder(img, width, height) {
	// Default: fill width, no height
	var placeholder = createPlaceholder(width || 1, height || 0);

	// Only set placeholder if it's different
	if (nativeGetAttribute.call(img, 'src') !== placeholder) {
		nativeSetAttribute.call(img, 'src', placeholder);
	}
}

function onImageReady(img, callback) {
	// naturalWidth is only available when the image headers are loaded,
	// this loop will poll it every 100ms.
	if (img.naturalWidth) {
		callback(img);
	} else {
		setTimeout(onImageReady, 100, img, callback);
	}
}

function fixOne(el) {
	var style = getStyle(el);
	var ofi = el[OFI];
	style['object-fit'] = style['object-fit'] || 'fill'; // default value

	// Avoid running where unnecessary, unless OFI had already done its deed
	if (!ofi.img) {
		// fill is the default behavior so no action is necessary
		if (style['object-fit'] === 'fill') {
			return;
		}

		// Where object-fit is supported and object-position isn't (Safari < 10)
		if (
			!ofi.skipTest && // unless user wants to apply regardless of browser support
			supportsObjectFit && // if browser already supports object-fit
			!style['object-position'] // unless object-position is used
		) {
			return;
		}
	}

	// keep a clone in memory while resetting the original to a blank
	if (!ofi.img) {
		ofi.img = new Image(el.width, el.height);
		ofi.img.srcset = nativeGetAttribute.call(el, "data-ofi-srcset") || el.srcset;
		ofi.img.src = nativeGetAttribute.call(el, "data-ofi-src") || el.src;

		// preserve for any future cloneNode calls
		// https://github.com/bfred-it/object-fit-images/issues/53
		nativeSetAttribute.call(el, "data-ofi-src", el.src);
		if (el.srcset) {
			nativeSetAttribute.call(el, "data-ofi-srcset", el.srcset);
		}

		setPlaceholder(el, el.naturalWidth || el.width, el.naturalHeight || el.height);

		// remove srcset because it overrides src
		if (el.srcset) {
			el.srcset = '';
		}
		try {
			keepSrcUsable(el);
		} catch (err) {
			if (window.console) {
				console.log('http://bit.ly/ofi-old-browser');
			}
		}
	}

	polyfillCurrentSrc(ofi.img);

	el.style.backgroundImage = "url(\"" + ((ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"')) + "\")";
	el.style.backgroundPosition = style['object-position'] || 'center';
	el.style.backgroundRepeat = 'no-repeat';

	if (/scale-down/.test(style['object-fit'])) {
		onImageReady(ofi.img, function () {
			if (ofi.img.naturalWidth > el.width || ofi.img.naturalHeight > el.height) {
				el.style.backgroundSize = 'contain';
			} else {
				el.style.backgroundSize = 'auto';
			}
		});
	} else {
		el.style.backgroundSize = style['object-fit'].replace('none', 'auto').replace('fill', '100% 100%');
	}

	onImageReady(ofi.img, function (img) {
		setPlaceholder(el, img.naturalWidth, img.naturalHeight);
	});
}

function keepSrcUsable(el) {
	var descriptors = {
		get: function get(prop) {
			return el[OFI].img[prop ? prop : 'src'];
		},
		set: function set(value, prop) {
			el[OFI].img[prop ? prop : 'src'] = value;
			nativeSetAttribute.call(el, ("data-ofi-" + prop), value); // preserve for any future cloneNode
			fixOne(el);
			return value;
		}
	};
	Object.defineProperty(el, 'src', descriptors);
	Object.defineProperty(el, 'currentSrc', {
		get: function () { return descriptors.get('currentSrc'); }
	});
	Object.defineProperty(el, 'srcset', {
		get: function () { return descriptors.get('srcset'); },
		set: function (ss) { return descriptors.set(ss, 'srcset'); }
	});
}

function hijackAttributes() {
	function getOfiImageMaybe(el, name) {
		return el[OFI] && el[OFI].img && (name === 'src' || name === 'srcset') ? el[OFI].img : el;
	}
	if (!supportsObjectPosition) {
		HTMLImageElement.prototype.getAttribute = function (name) {
			return nativeGetAttribute.call(getOfiImageMaybe(this, name), name);
		};

		HTMLImageElement.prototype.setAttribute = function (name, value) {
			return nativeSetAttribute.call(getOfiImageMaybe(this, name), name, String(value));
		};
	}
}

function fix(imgs, opts) {
	var startAutoMode = !autoModeEnabled && !imgs;
	opts = opts || {};
	imgs = imgs || 'img';

	if ((supportsObjectPosition && !opts.skipTest) || !supportsOFI) {
		return false;
	}

	// use imgs as a selector or just select all images
	if (typeof imgs === 'string') {
		imgs = document.querySelectorAll(imgs);
	} else if (!('length' in imgs)) {
		imgs = [imgs];
	}

	// apply fix to all
	for (var i = 0; i < imgs.length; i++) {
		imgs[i][OFI] = imgs[i][OFI] || {
			skipTest: opts.skipTest
		};
		fixOne(imgs[i]);
	}

	if (startAutoMode) {
		document.body.addEventListener('load', function (e) {
			if (e.target.tagName === 'IMG') {
				fix(e.target, {
					skipTest: opts.skipTest
				});
			}
		}, true);
		autoModeEnabled = true;
		imgs = 'img'; // reset to a generic selector for watchMQ
	}

	// if requested, watch media queries for object-fit change
	if (opts.watchMQ) {
		window.addEventListener('resize', fix.bind(null, imgs, {
			skipTest: opts.skipTest
		}));
	}
}

fix.supportsObjectFit = supportsObjectFit;
fix.supportsObjectPosition = supportsObjectPosition;

hijackAttributes();

module.exports = fix;


/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* ========================================================================
                                                                                                                                                                                                                                                                               * Bootstrap: modal.js v3.3.6
                                                                                                                                                                                                                                                                               * http://getbootstrap.com/javascript/#modals
                                                                                                                                                                                                                                                                               * ========================================================================
                                                                                                                                                                                                                                                                               * Copyright 2011-2015 Twitter, Inc.
                                                                                                                                                                                                                                                                               * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
                                                                                                                                                                                                                                                                               * ======================================================================== */

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

+function ($) {
    'use strict';

    // MODAL CLASS DEFINITION
    // ======================

    var Modal = function Modal(element, options) {
        this.options = options;
        this.$body = $(document.body);
        this.$element = $(element);
        this.$dialog = this.$element.find('.modal-dialog');
        this.$backdrop = null;
        this.isShown = null;
        this.originalBodyPad = null;
        this.scrollbarWidth = 0;
        this.ignoreBackdropClick = false;

        if (this.options.remote) {
            this.$element.find('.modal-content').load(this.options.remote, $.proxy(function () {
                this.$element.trigger('loaded.bs.modal');
            }, this));
        }
    };

    Modal.VERSION = '3.3.6';

    Modal.TRANSITION_DURATION = 300;
    Modal.BACKDROP_TRANSITION_DURATION = 150;

    Modal.DEFAULTS = {
        backdrop: true,
        keyboard: true,
        show: true
    };

    Modal.prototype.toggle = function (_relatedTarget) {
        return this.isShown ? this.hide() : this.show(_relatedTarget);
    };

    Modal.prototype.show = function (_relatedTarget) {
        var that = this;
        var e = $.Event('show.bs.modal', { relatedTarget: _relatedTarget });

        this.$element.trigger(e);

        if (this.isShown || e.isDefaultPrevented()) return;

        this.isShown = true;

        this.checkScrollbar();
        this.setScrollbar();
        this.$body.addClass('modal-open');

        this.escape();
        this.resize();

        this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this));

        this.$dialog.on('mousedown.dismiss.bs.modal', function () {
            that.$element.one('mouseup.dismiss.bs.modal', function (e) {
                if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true;
            });
        });

        this.backdrop(function () {
            var transition = $.support.transition && that.$element.hasClass('fade');

            if (!that.$element.parent().length) {
                that.$element.appendTo(that.$body); // don't move modals dom position
            }

            that.$element.show().scrollTop(0);

            that.adjustDialog();

            if (transition) {
                that.$element[0].offsetWidth; // force reflow
            }

            that.$element.addClass('in');

            that.enforceFocus();

            var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget });

            transition ? that.$dialog // wait for modal to slide in
            .one('bsTransitionEnd', function () {
                that.$element.trigger('focus').trigger(e);
            }).emulateTransitionEnd(Modal.TRANSITION_DURATION) : that.$element.trigger('focus').trigger(e);
        });
    };

    Modal.prototype.hide = function (e) {
        if (e) e.preventDefault();

        e = $.Event('hide.bs.modal');

        this.$element.trigger(e);

        if (!this.isShown || e.isDefaultPrevented()) return;

        this.isShown = false;

        this.escape();
        this.resize();

        $(document).off('focusin.bs.modal');

        this.$element.removeClass('in').off('click.dismiss.bs.modal').off('mouseup.dismiss.bs.modal');

        this.$dialog.off('mousedown.dismiss.bs.modal');

        $.support.transition && this.$element.hasClass('fade') ? this.$element.one('bsTransitionEnd', $.proxy(this.hideModal, this)).emulateTransitionEnd(Modal.TRANSITION_DURATION) : this.hideModal();
    };

    Modal.prototype.enforceFocus = function () {
        $(document).off('focusin.bs.modal') // guard against infinite focus loop
        .on('focusin.bs.modal', $.proxy(function (e) {
            if (this.$element[0] !== e.target && !this.$element.has(e.target).length) {
                this.$element.trigger('focus');
            }
        }, this));
    };

    Modal.prototype.escape = function () {
        if (this.isShown && this.options.keyboard) {
            this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
                e.which == 27 && this.hide();
            }, this));
        } else if (!this.isShown) {
            this.$element.off('keydown.dismiss.bs.modal');
        }
    };

    Modal.prototype.resize = function () {
        if (this.isShown) {
            $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this));
        } else {
            $(window).off('resize.bs.modal');
        }
    };

    Modal.prototype.hideModal = function () {
        var that = this;
        this.$element.hide();
        this.backdrop(function () {
            that.$body.removeClass('modal-open');
            that.resetAdjustments();
            that.resetScrollbar();
            that.$element.trigger('hidden.bs.modal');
        });
    };

    Modal.prototype.removeBackdrop = function () {
        this.$backdrop && this.$backdrop.remove();
        this.$backdrop = null;
    };

    Modal.prototype.backdrop = function (callback) {
        var that = this;
        var animate = this.$element.hasClass('fade') ? 'fade' : '';

        if (this.isShown && this.options.backdrop) {
            var doAnimate = $.support.transition && animate;

            this.$backdrop = $(document.createElement('div')).addClass('modal-backdrop ' + animate).appendTo(this.$body);

            this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
                if (this.ignoreBackdropClick) {
                    this.ignoreBackdropClick = false;
                    return;
                }
                if (e.target !== e.currentTarget) return;
                this.options.backdrop == 'static' ? this.$element[0].focus() : this.hide();
            }, this));

            if (doAnimate) this.$backdrop[0].offsetWidth; // force reflow

            this.$backdrop.addClass('in');

            if (!callback) return;

            doAnimate ? this.$backdrop.one('bsTransitionEnd', callback).emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) : callback();
        } else if (!this.isShown && this.$backdrop) {
            this.$backdrop.removeClass('in');

            var callbackRemove = function callbackRemove() {
                that.removeBackdrop();
                callback && callback();
            };
            $.support.transition && this.$element.hasClass('fade') ? this.$backdrop.one('bsTransitionEnd', callbackRemove).emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) : callbackRemove();
        } else if (callback) {
            callback();
        }
    };

    // these following methods are used to handle overflowing modals

    Modal.prototype.handleUpdate = function () {
        this.adjustDialog();
    };

    Modal.prototype.adjustDialog = function () {
        var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight;

        this.$element.css({
            paddingLeft: !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
            paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
        });
    };

    Modal.prototype.resetAdjustments = function () {
        this.$element.css({
            paddingLeft: '',
            paddingRight: ''
        });
    };

    Modal.prototype.checkScrollbar = function () {
        var fullWindowWidth = window.innerWidth;
        if (!fullWindowWidth) {
            // workaround for missing window.innerWidth in IE8
            var documentElementRect = document.documentElement.getBoundingClientRect();
            fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left);
        }
        this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth;
        this.scrollbarWidth = this.measureScrollbar();
    };

    Modal.prototype.setScrollbar = function () {
        var bodyPad = parseInt(this.$body.css('padding-right') || 0, 10);
        this.originalBodyPad = document.body.style.paddingRight || '';
        if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth);
    };

    Modal.prototype.resetScrollbar = function () {
        this.$body.css('padding-right', this.originalBodyPad);
    };

    Modal.prototype.measureScrollbar = function () {
        // thx walsh
        var scrollDiv = document.createElement('div');
        scrollDiv.className = 'modal-scrollbar-measure';
        this.$body.append(scrollDiv);
        var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        this.$body[0].removeChild(scrollDiv);
        return scrollbarWidth;
    };

    // MODAL PLUGIN DEFINITION
    // =======================

    function Plugin(option, _relatedTarget) {
        return this.each(function () {
            var $this = $(this);
            var data = $this.data('bs.modal');
            var options = $.extend({}, Modal.DEFAULTS, $this.data(), (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option);

            if (!data) $this.data('bs.modal', data = new Modal(this, options));
            if (typeof option == 'string') data[option](_relatedTarget);else if (options.show) data.show(_relatedTarget);
        });
    }

    var old = $.fn.modal;

    $.fn.modal = Plugin;
    $.fn.modal.Constructor = Modal;

    // MODAL NO CONFLICT
    // =================

    $.fn.modal.noConflict = function () {
        $.fn.modal = old;
        return this;
    };

    // MODAL DATA-API
    // ==============

    $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
        var $this = $(this);
        var href = $this.attr('href');
        var $target = $($this.attr('data-target') || href && href.replace(/.*(?=#[^\s]+$)/, '')); // strip for ie7
        var option = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data());

        if ($this.is('a')) e.preventDefault();

        $target.one('show.bs.modal', function (showEvent) {
            if (showEvent.isDefaultPrevented()) return; // only register focus restorer if modal will actually get shown
            $target.one('hidden.bs.modal', function () {
                $this.is(':visible') && $this.trigger('focus');
            });
        });
        Plugin.call($target, option, this);
    });
}(_jquery2.default);

/***/ }),
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__element_focus_svg_foreign_object_hack__ = __webpack_require__(519);
/* harmony export (immutable) */ __webpack_exports__["a"] = generate;
/* unused harmony export focus */
/* harmony export (immutable) */ __webpack_exports__["b"] = validate;



function generate(element) {
  return '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' + element + '</svg>';
}

function focus(element) {
  if (element.focus) {
    return;
  }

  try {
    HTMLElement.prototype.focus.call(element);
  } catch (e) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__element_focus_svg_foreign_object_hack__["a" /* default */])(element);
  }
}

function validate(element, focusTarget, _document) {
  focus(focusTarget);
  return _document.activeElement === focusTarget;
}
//# sourceMappingURL=svg.js.map

/***/ }),
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* ========================================================================
 * Bootstrap: collapse.js v3.3.7
 * http://getbootstrap.com/javascript/#collapse
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

/* jshint latedef: false */

+function ($) {
  'use strict';

  // COLLAPSE PUBLIC CLASS DEFINITION
  // ================================

  var Collapse = function Collapse(element, options) {
    this.$element = $(element);
    this.options = $.extend({}, Collapse.DEFAULTS, options);
    this.$trigger = $('[data-toggle="collapse"][href="#' + element.id + '"],' + '[data-toggle="collapse"][data-target="#' + element.id + '"]');
    this.transitioning = null;

    if (this.options.parent) {
      this.$parent = this.getParent();
    } else {
      this.addAriaAndCollapsedClass(this.$element, this.$trigger);
    }

    if (this.options.toggle) this.toggle();
  };

  Collapse.VERSION = '3.3.7';

  Collapse.TRANSITION_DURATION = 350;

  Collapse.DEFAULTS = {
    toggle: true
  };

  Collapse.prototype.dimension = function () {
    var hasWidth = this.$element.hasClass('width');
    return hasWidth ? 'width' : 'height';
  };

  Collapse.prototype.show = function () {
    if (this.transitioning || this.$element.hasClass('in')) return;

    var activesData;
    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing');

    if (actives && actives.length) {
      activesData = actives.data('bs.collapse');
      if (activesData && activesData.transitioning) return;
    }

    var startEvent = $.Event('show.bs.collapse');
    this.$element.trigger(startEvent);
    if (startEvent.isDefaultPrevented()) return;

    if (actives && actives.length) {
      Plugin.call(actives, 'hide');
      activesData || actives.data('bs.collapse', null);
    }

    var dimension = this.dimension();

    this.$element.removeClass('collapse').addClass('collapsing')[dimension](0).attr('aria-expanded', true);

    this.$trigger.removeClass('collapsed').attr('aria-expanded', true);

    this.transitioning = 1;

    var complete = function complete() {
      this.$element.removeClass('collapsing').addClass('collapse in')[dimension]('');
      this.transitioning = 0;
      this.$element.trigger('shown.bs.collapse');
    };

    if (!$.support.transition) return complete.call(this);

    var scrollSize = $.camelCase(['scroll', dimension].join('-'));

    this.$element.one('bsTransitionEnd', $.proxy(complete, this)).emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize]);
  };

  Collapse.prototype.hide = function () {
    if (this.transitioning || !this.$element.hasClass('in')) return;

    var startEvent = $.Event('hide.bs.collapse');
    this.$element.trigger(startEvent);
    if (startEvent.isDefaultPrevented()) return;

    var dimension = this.dimension();

    this.$element[dimension](this.$element[dimension]())[0].offsetHeight;

    this.$element.addClass('collapsing').removeClass('collapse in').attr('aria-expanded', false);

    this.$trigger.addClass('collapsed').attr('aria-expanded', false);

    this.transitioning = 1;

    var complete = function complete() {
      this.transitioning = 0;
      this.$element.removeClass('collapsing').addClass('collapse').trigger('hidden.bs.collapse');
    };

    if (!$.support.transition) return complete.call(this);

    this.$element[dimension](0).one('bsTransitionEnd', $.proxy(complete, this)).emulateTransitionEnd(Collapse.TRANSITION_DURATION);
  };

  Collapse.prototype.toggle = function () {
    this[this.$element.hasClass('in') ? 'hide' : 'show']();
  };

  Collapse.prototype.getParent = function () {
    return $(this.options.parent).find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]').each($.proxy(function (i, element) {
      var $element = $(element);
      this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element);
    }, this)).end();
  };

  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
    var isOpen = $element.hasClass('in');

    $element.attr('aria-expanded', isOpen);
    $trigger.toggleClass('collapsed', !isOpen).attr('aria-expanded', isOpen);
  };

  function getTargetFromTrigger($trigger) {
    var href;
    var target = $trigger.attr('data-target') || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, ''); // strip for ie7

    return $(target);
  }

  // COLLAPSE PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data('bs.collapse');
      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option);

      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false;
      if (!data) $this.data('bs.collapse', data = new Collapse(this, options));
      if (typeof option == 'string') data[option]();
    });
  }

  var old = $.fn.collapse;

  $.fn.collapse = Plugin;
  $.fn.collapse.Constructor = Collapse;

  // COLLAPSE NO CONFLICT
  // ====================

  $.fn.collapse.noConflict = function () {
    $.fn.collapse = old;
    return this;
  };

  // COLLAPSE DATA-API
  // =================

  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
    var $this = $(this);

    if (!$this.attr('data-target')) e.preventDefault();

    var $target = getTargetFromTrigger($this);
    var data = $target.data('bs.collapse');
    var option = data ? 'toggle' : $this.data();

    Plugin.call($target, option);
  });
}(jQuery);

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* ========================================================================
 * Bootstrap: transition.js v3.3.7
 * http://getbootstrap.com/javascript/#transitions
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  'use strict';

  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
  // ============================================================

  function transitionEnd() {
    var el = document.createElement('bootstrap');

    var transEndEventNames = {
      WebkitTransition: 'webkitTransitionEnd',
      MozTransition: 'transitionend',
      OTransition: 'oTransitionEnd otransitionend',
      transition: 'transitionend'
    };

    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return { end: transEndEventNames[name] };
      }
    }

    return false; // explicit for ie8 (  ._.)
  }

  // http://blog.alexmaccaw.com/css-transitions
  $.fn.emulateTransitionEnd = function (duration) {
    var called = false;
    var $el = this;
    $(this).one('bsTransitionEnd', function () {
      called = true;
    });
    var callback = function callback() {
      if (!called) $($el).trigger($.support.transition.end);
    };
    setTimeout(callback, duration);
    return this;
  };

  $(function () {
    $.support.transition = transitionEnd();

    if (!$.support.transition) return;

    $.event.special.bsTransitionEnd = {
      bindType: $.support.transition.end,
      delegateType: $.support.transition.end,
      handle: function handle(e) {
        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments);
      }
    };
  });
}(jQuery);

/***/ }),
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-DeleteIcon",
  "use": "icon-DeleteIcon-usage",
  "viewBox": "0 0 15.423 16.98",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.423 16.98\" id=\"icon-DeleteIcon\">\n  <g id=\"icon-DeleteIcon_np_bin_5055046_000000\" transform=\"translate(-15.8 -12.403)\">\n    <path id=\"icon-DeleteIcon_Path_322\" data-name=\"Path 322\" d=\"M31.223,15.089a1.132,1.132,0,0,0-1.129-1.129H26.12A1.672,1.672,0,0,0,24.471,12.4h-1.9A1.676,1.676,0,0,0,20.9,13.96H16.929A1.129,1.129,0,0,0,16.7,16.2l1.761,12.894a.342.342,0,0,0,.339.294H28.22a.342.342,0,0,0,.339-.294L30.32,16.2a1.136,1.136,0,0,0,.9-1.106Zm-8.649-2.01h1.9a.979.979,0,0,1,.971.88H21.6a.98.98,0,0,1,.971-.88Zm5.351,15.626H19.12L17.4,16.218H29.642Zm2.19-13.187H16.952a.452.452,0,1,1,0-.9H30.116a.452.452,0,0,1,.452.452A.468.468,0,0,1,30.116,15.518Z\" fill=\"#005999\" />\n    <path id=\"icon-DeleteIcon_Path_323\" data-name=\"Path 323\" d=\"M48.839,44.178a.347.347,0,0,0,.339-.339v-9.8a.339.339,0,0,0-.677,0v9.778a.353.353,0,0,0,.339.362Z\" transform=\"translate(-25.316 -16.488)\" fill=\"#005999\" />\n    <path id=\"icon-DeleteIcon_Path_324\" data-name=\"Path 324\" d=\"M34.776,44.376h.045a.33.33,0,0,0,.294-.362l-.971-9.733a.329.329,0,0,0-.655.068l.971,9.733a.292.292,0,0,0,.317.294Z\" transform=\"translate(-13.692 -16.709)\" fill=\"#005999\" />\n    <path id=\"icon-DeleteIcon_Path_325\" data-name=\"Path 325\" d=\"M59.739,44.2h.045a.344.344,0,0,0,.339-.316l.971-9.733a.329.329,0,0,0-.655-.068l-.971,9.733a.3.3,0,0,0,.272.384Z\" transform=\"translate(-33.8 -16.554)\" fill=\"#005999\" />\n  </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-Icon_info",
  "use": "icon-Icon_info-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-Icon_info\">\n  <circle id=\"icon-Icon_info_Ellipse_32\" data-name=\"Ellipse 32\" cx=\"8\" cy=\"8\" r=\"8\" transform=\"translate(0)\" fill=\"#f5f5f5\" />\n  <g id=\"icon-Icon_info_np_info_3012852_000000\" transform=\"translate(-3.125 -3.125)\">\n    <path id=\"icon-Icon_info_Union_7\" data-name=\"Union 7\" d=\"M0,8a8,8,0,1,1,8,8A7.989,7.989,0,0,1,0,8ZM1.067,8A6.933,6.933,0,1,0,8,1.067,6.92,6.92,0,0,0,1.067,8Zm6.4,3.734v-4.8a.533.533,0,0,1,1.067,0v4.8a.533.533,0,0,1-1.067,0Zm0-6.933V3.733a.533.533,0,1,1,1.067,0V4.8a.533.533,0,1,1-1.067,0Z\" transform=\"translate(3.125 3.126)\" fill=\"#505050\" />\n  </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-Icon_info_hover",
  "use": "icon-Icon_info_hover-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-Icon_info_hover\">\n  <g id=\"icon-Icon_info_hover_Group_1136\" data-name=\"Group 1136\" transform=\"translate(-51 -1445)\">\n    <path id=\"icon-Icon_info_hover_Path_328\" data-name=\"Path 328\" d=\"M8,0A8,8,0,1,1,0,8,8,8,0,0,1,8,0Z\" transform=\"translate(51 1445)\" fill=\"#2d2d2d\" />\n    <g id=\"icon-Icon_info_hover_np_info_3012852_000000\" transform=\"translate(47.875 1441.875)\">\n      <path id=\"icon-Icon_info_hover_Union_7\" data-name=\"Union 7\" d=\"M8,12.267a.5.5,0,0,1-.533-.533v-4.8a.533.533,0,1,1,1.067,0v4.8A.5.5,0,0,1,8,12.267ZM8,5.333A.5.5,0,0,1,7.467,4.8V3.733a.533.533,0,1,1,1.067,0V4.8A.5.5,0,0,1,8,5.333Z\" transform=\"translate(3.125 3.126)\" fill=\"#ededed\" />\n    </g>\n  </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-My_Account_Icon",
  "use": "icon-My_Account_Icon-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-My_Account_Icon\">\n  <path id=\"icon-My_Account_Icon_Vector\" d=\"M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm0,22a9.927,9.927,0,0,1-6.441-2.363,6.8,6.8,0,0,1,12.881.01A9.958,9.958,0,0,1,12,22ZM9.306,9.361a2.725,2.725,0,1,1,2.725,2.723A2.727,2.727,0,0,1,9.306,9.361Zm10.648,8.7A8.639,8.639,0,0,0,14.5,13.386a4.726,4.726,0,1,0-4.968-.01,8.69,8.69,0,0,0-5.489,4.666A9.907,9.907,0,0,1,2,12a10,10,0,1,1,17.95,6.057Z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-Switch_Memberships",
  "use": "icon-Switch_Memberships-usage",
  "viewBox": "0 0 20 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 24\" id=\"icon-Switch_Memberships\">\n  <path id=\"icon-Switch_Memberships_Switch_memebership_icon\" data-name=\"Switch memebership icon\" d=\"M12.866.352a1.286,1.286,0,0,1,1.767,0l5,4.8a1.168,1.168,0,0,1,0,1.7l-5,4.8a1.288,1.288,0,0,1-1.767,0,1.166,1.166,0,0,1,0-1.7L15.733,7.2H1.249a1.2,1.2,0,1,1,0-2.4H15.733L12.866,2.048a1.165,1.165,0,0,1,0-1.7Zm-5.733,12a1.166,1.166,0,0,1,0,1.7L4.267,16.8H18.751a1.2,1.2,0,1,1,0,2.4H4.267l2.867,2.752a1.165,1.165,0,0,1,0,1.7,1.285,1.285,0,0,1-1.767,0l-5-4.8a1.168,1.168,0,0,1,0-1.7l5-4.8a1.288,1.288,0,0,1,1.767,0Z\" transform=\"translate(0 0)\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-account",
  "use": "icon-account-usage",
  "viewBox": "0 0 12 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12 10\" id=\"icon-account\">\n<path id=\"icon-account_Icon\" d=\"M6,6.8c-1.3,0-2.4-1-2.4-2.3S4.7,2.1,6,2.1s2.4,1,2.4,2.3S7.3,6.8,6,6.8 M0,5.8C0,7.5,0.7,8.9,1.9,10\n\tC2.6,8.5,4.2,7.5,6,7.5s3.4,1,4.1,2.5C11.3,8.9,12,7.5,12,5.8C12,2.6,9.3,0,6,0S0,2.6,0,5.8z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-apple",
  "use": "icon-apple-usage",
  "viewBox": "-10 0 720 880",
  "content": "<symbol xmlns:svg=\"http://www.w3.org/2000/svg\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-10 0 720 880\" id=\"icon-apple\">\n    <g transform=\"matrix(54.85,0,0,-54.85,-2485.383,4815.859)\" id=\"icon-apple_g186\">\n        <path d=\"m 56.105,79.364 c -0.018,2.008 1.64,2.972 1.715,3.019 -0.933,1.365 -2.385,1.552 -2.903,1.574 -1.235,0.125 -2.411,-0.727 -3.037,-0.727 -0.626,0 -1.594,0.709 -2.618,0.689 -1.348,-0.02 -2.589,-0.783 -3.283,-1.989 -1.399,-2.427 -0.357,-6.024 1.005,-7.994 0.667,-0.963 1.461,-2.048 2.505,-2.008 1.006,0.04 1.386,0.65 2.6,0.65 1.214,0 1.556,-0.65 2.619,-0.631 1.081,0.021 1.767,0.984 2.429,1.95 0.764,1.118 1.08,2.2 1.098,2.257 -0.024,0.01 -2.108,0.809 -2.13,3.21\" id=\"icon-apple_path188\" />\n    </g>\n    <path d=\"M 482.4387,139.3374 C 512.8252,102.533 533.3389,51.3572 527.6888,0.3487 483.9152,2.1058 430.9332,29.5295 399.5032,66.3339 c -28.1373,32.5275 -52.8196,84.6335 -46.131,134.6035 48.8183,3.7847 98.675,-24.8497 129.0665,-61.6\" id=\"icon-apple_path190\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-arrow-enquiry",
  "use": "icon-arrow-enquiry-usage",
  "viewBox": "0 0 13.545 8.578",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13.545 8.578\" id=\"icon-arrow-enquiry\">\n  <path id=\"icon-arrow-enquiry_np_arrow_1569918_000000\" d=\"M33.545,35.289a.528.528,0,0,0-.127-.31l-3.612-3.838a.452.452,0,0,0-.638-.018.466.466,0,0,0-.018.638l2.9,3.076h-11.6a.451.451,0,1,0,0,.9h11.6l-2.9,3.076a.473.473,0,0,0,.018.638.452.452,0,0,0,.638-.018L33.418,35.6a.4.4,0,0,0,.127-.31Z\" transform=\"translate(-20 -31)\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-arrow-left-v",
  "use": "icon-arrow-left-v-usage",
  "viewBox": "0 0 45 45",
  "content": "<symbol viewBox=\"0 0 45 45\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-left-v\">\n<path d=\"M17.6171 21.6452L24.5241 14.7382C24.9957 14.2666 25.7609 14.2666 26.2336 14.7382C26.7052 15.2098 26.7052 15.976 26.2336 16.4477L20.1814 22.4998L26.2336 28.552C26.7052 29.0236 26.7052 29.7899 26.2336 30.2615C25.7609 30.7331 24.9957 30.7331 24.5241 30.2615L17.6171 23.3545C17.1444 22.8829 17.1444 22.1166 17.6171 21.645V21.6452Z\" fill=\"#202020\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-arrow-red",
  "use": "icon-arrow-red-usage",
  "viewBox": "0 0 100 90",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 90\" id=\"icon-arrow-red\">\n    <style>#icon-arrow-red .a{fill:#e11917;}</style>\n    <title>  Page 1</title>\n    <desc>Arrow</desc>\n    <g class=\"a\">\n        <path d=\"M50.5 56C53.3 53.2 56.2 50.4 59 47.6L57.7 46.3 51.4 52.5 51.4 35 49.6 35 49.6 52.5 43.3 46.3 42 47.6\" />\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-arrow-right-circle",
  "use": "icon-arrow-right-circle-usage",
  "viewBox": "0 0 35 35",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 35 35\" id=\"icon-arrow-right-circle\">\n<path d=\"M17.5,35C7.9,35,0,27.1,0,17.5S7.9,0,17.5,0S35,7.9,35,17.5S27.1,35,17.5,35z M17.5,5C10.6,5,5,10.6,5,17.5\n\tS10.6,30,17.5,30S30,24.4,30,17.5S24.4,5,17.5,5z M16.3,26.4l-3.6-3.5l5.4-5.4L12.6,12l3.5-3.5l9,9L16.3,26.4z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-arrow-right-v",
  "use": "icon-arrow-right-v-usage",
  "viewBox": "0 0 28 27",
  "content": "<symbol viewBox=\"0 0 28 27\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-right-v\">\n<path d=\"M18.7719 14.3354L12.0219 21.0854C11.561 21.5463 10.8132 21.5463 10.3513 21.0854C9.89039 20.6245 9.89039 19.8757 10.3513 19.4148L16.2659 13.5002L10.3513 7.58557C9.89039 7.12468 9.89039 6.37583 10.3513 5.91494C10.8132 5.45405 11.561 5.45405 12.0219 5.91494L18.7719 12.6649C19.2339 13.1258 19.2339 13.8747 18.7719 14.3356V14.3354Z\" fill=\"#202020\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-arrow-right",
  "use": "icon-arrow-right-usage",
  "viewBox": "0 0 28.345 21.221",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28.345 21.221\" id=\"icon-arrow-right\">\n  <path id=\"icon-arrow-right_Path_18\" data-name=\"Path 18\" d=\"M12.5,45.832H37.045V49H12.5Z\" transform=\"translate(-12.5 -36.806)\" fill=\"#222\" />\n  <path id=\"icon-arrow-right_Path_19\" data-name=\"Path 19\" d=\"M55.55,43.3l-2.218-2.218,8.394-8.392L53.332,24.3l2.218-2.218,10.609,10.61Z\" transform=\"translate(-37.814 -22.082)\" fill=\"#222\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-arrow",
  "use": "icon-arrow-usage",
  "viewBox": "0 0 100 90",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 90\" id=\"icon-arrow\">\n    <style>#icon-arrow .a{fill:#FFF;}</style>\n    <title>  Page 1</title>\n    <desc>Arrow</desc>\n    <g class=\"a\">\n        <path d=\"M50.5 56C53.3 53.2 56.2 50.4 59 47.6L57.7 46.3 51.4 52.5 51.4 35 49.6 35 49.6 52.5 43.3 46.3 42 47.6\" />\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-aya",
  "use": "icon-aya-usage",
  "viewBox": "0 0 68.34 65",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 68.34 65\" id=\"icon-aya\">\n  <defs>\n    <linearGradient id=\"icon-aya_linear-gradient\" x1=\"-266.32\" y1=\"422.78\" x2=\"-266.32\" y2=\"422.54\" gradientTransform=\"matrix(64.82, 0, 0, -61.65, 17295.63, 26085.06)\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"#ccd0d7\" stop-opacity=\"0.4\" />\n      <stop offset=\"1\" stop-color=\"#9da3ae\" stop-opacity=\"0.4\" />\n    </linearGradient>\n  </defs>\n  <title>aya</title>\n  <g>\n    <polygon points=\"16.65 29.77 20.95 29.77 18.78 23.93 16.65 29.77\" fill=\"none\" />\n    <polygon points=\"43.17 29.77 47.47 29.77 45.3 23.93 43.17 29.77\" fill=\"none\" />\n    <path d=\"M53.14,3H15.25L3.53,39.06,34.17,61.29,64.82,39.06ZM23.34,36,22,32.42H15.67L14.37,36H11l6.13-15.75H20.5L26.8,36Zm10.43-6.61V36H30.6V29.37l-5.77-9.12h3.73l3.71,6.23,3.63-6.23h3.66Zm14.72,3H42.2L40.9,36H37.52l6.13-15.75H47L53.32,36H49.87Z\" transform=\"translate(0)\" fill=\"none\" />\n    <path d=\"M55.32,0H13.07L0,40.21,34.17,65,68.34,40.21ZM3.53,39.06,15.25,3H53.14L64.82,39.06,34.17,61.29Z\" transform=\"translate(0)\" fill=\"url(#icon-aya_linear-gradient)\" />\n    <path d=\"M17.13,20.25,11,36h3.37l1.3-3.58H22L23.34,36H26.8L20.5,20.25Zm-.48,9.52,2.13-5.84,2.17,5.84Z\" transform=\"translate(0)\" fill=\"#9da3ae\" />\n    <polygon points=\"35.9 20.25 32.27 26.48 28.56 20.25 24.84 20.25 30.6 29.37 30.6 36 33.77 36 33.77 29.39 39.56 20.25 35.9 20.25\" fill=\"#9da3ae\" />\n    <path d=\"M47,20.25H43.66L37.52,36H40.9l1.3-3.58h6.29L49.87,36h3.46Zm-3.85,9.52,2.13-5.84,2.17,5.84Z\" transform=\"translate(0)\" fill=\"#9da3ae\" />\n  </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-bootroom",
  "use": "icon-bootroom-usage",
  "viewBox": "0 0 332 29.4",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 332 29.4\" id=\"icon-bootroom\"><title>bootroom</title><g id=\"icon-bootroom_Group\"><path id=\"icon-bootroom_The\" d=\"M0,29V22l1.2.1v2.7H9v1.5H1.2V29ZM0,12.9V11.5H9v1.4H5v4.2H9v1.4H0V17.1H3.8V12.9ZM0,7V0L1.2.1V5.2H3.7V.7H4.9V5.2H7.7V.1H8.9V7Z\" /></g><path d=\"M234.3,5.3A9.7,9.7,0,1,0,244,15a9.71,9.71,0,0,0-9.7-9.7m0,24.1A14.4,14.4,0,1,1,248.7,15a14.4,14.4,0,0,1-14.4,14.4\" /><path d=\"M276.6,5.3a9.7,9.7,0,1,0,9.7,9.7,9.71,9.71,0,0,0-9.7-9.7m0,24.1A14.4,14.4,0,1,1,291,15a14.4,14.4,0,0,1-14.4,14.4\" /><path d=\"M193.2,14.7h2.1c3.9,0,5.7-.4,5.7-4.5v-.1c0-3.2-1.7-4.4-5.4-4.4h-2.4Zm2-13.4c6,0,11,1.4,11,8.6v.2c0,3.9-1.6,6.8-4.8,8l5.4,10.6h-5.1L197.2,19h-4v9.7h-4.9V1.3Z\" /><path d=\"M310.2,1.3c2.4,5.1,6,13.4,8.1,17.9,2.1-4.6,5.8-12.8,8.2-17.9h4c.6,8.5,1.3,19.5,1.5,27.4h-4.8c-.1-5-.3-11.1-.7-18-2,4.7-4.5,10.3-6.7,15.3h-3c-2.2-5-4.3-9.9-6.7-15.3-.4,6.9-.6,12.9-.7,18h-4.7c.3-7.8.9-18.9,1.5-27.4Z\" /><path d=\"M72,5.3A9.7,9.7,0,1,0,81.7,15,9.71,9.71,0,0,0,72,5.3m0,24.1A14.4,14.4,0,1,1,86.4,15,14.4,14.4,0,0,1,72,29.4\" /><path d=\"M114.4,5.3a9.7,9.7,0,1,0,9.7,9.7,9.71,9.71,0,0,0-9.7-9.7m0,24.1A14.4,14.4,0,1,1,128.8,15a14.4,14.4,0,0,1-14.4,14.4\" /><path d=\"M29.8,24.4h3.3c3.4,0,5.9-.2,5.9-3.9,0-3-2.2-3.8-5.2-3.8H29.7v7.7Zm0-12h3.1c3,0,4.4-.9,4.4-3.5,0-2.2-.9-3.2-4.3-3.2H29.8ZM32.1,1.3c5.9,0,10.1.8,10.1,6.9a5.62,5.62,0,0,1-3.8,5.7V14A6.39,6.39,0,0,1,44,20.7c0,7.2-5.4,8-10.9,8H24.8V1.3Z\" /><polygon points=\"161.6 1.3 161.2 5.7 154.2 5.7 154.2 28.7 149.4 28.7 149.4 5.7 142.2 5.7 142.2 1.3 161.6 1.3\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-bye_tag",
  "use": "icon-bye_tag-usage",
  "viewBox": "0 0 29 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 29 18\" id=\"icon-bye_tag\">\n<path d=\"M27,1c0.6,0,1,0.4,1,1v14c0,0.6-0.4,1-1,1H2c-0.6,0-1-0.4-1-1V2c0-0.6,0.4-1,1-1H27 M27,0H2C0.9,0,0,0.9,0,2v14\n\tc0,1.1,0.9,2,2,2h25c1.1,0,2-0.9,2-2V2C29,0.9,28.1,0,27,0L27,0z\" />\n<g>\n\t<path d=\"M6.4,4.3c2,0,3.5,0.3,3.5,2.4c0,0.9-0.4,1.7-1.3,2v0c1.2,0.2,1.9,1.1,1.9,2.3c0,2.5-1.8,2.8-3.8,2.8H3.9V4.3H6.4z M5.6,8.1\n\t\th1.1c1,0,1.5-0.3,1.5-1.2c0-0.7-0.3-1.1-1.5-1.1H5.6V8.1z M5.6,12.2h1.1c1.2,0,2-0.1,2-1.3c0-1-0.8-1.3-1.8-1.3H5.6V12.2z\" />\n\t<path d=\"M12.7,4.3c0.6,1.8,1.1,3.3,1.8,4.6h0.1c0.7-1.4,1.2-2.9,1.8-4.6H18c-0.7,2.2-1.7,4.4-2.7,6.3v3.1h-1.7v-3.1\n\t\tc-1-1.9-2-4.2-2.7-6.3H12.7z\" />\n\t<path d=\"M25.1,4.3L25,5.8H21v2.3h3.4v1.5H21v2.5H25v1.5h-5.6V4.3H25.1z\" />\n</g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-calendar",
  "use": "icon-calendar-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12 12\" id=\"icon-calendar\">\n<path d=\"M1,2v9h10V2H1z M0,1h12v11H0V1z M2,5h2v2H2V5z M2,8h2v2H2V8z M5,5h2v2H5V5z M5,8h2v2H5V8z M8,5h2v2H8V5z M1,2h10v2H1V2z\n\t M8,8h2v2H8V8z M2,0h2v1H2V0z M8,0h2v1H8V0z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-camera",
  "use": "icon-camera-usage",
  "viewBox": "0 0 49 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 49 40\" id=\"icon-camera\">\n  <title>camera</title>\n  <path d=\"M24.79,11.43A10.68,10.68,0,0,0,14,22a10.77,10.77,0,0,0,21.53,0A10.68,10.68,0,0,0,24.79,11.43Zm0,17.14A6.57,6.57,0,1,1,31.56,22,6.68,6.68,0,0,1,24.79,28.57ZM46.62,8.1a8.08,8.08,0,0,0-5.75-2.38H36L33.86,1.63A3,3,0,0,0,31.19,0h-14a3,3,0,0,0-2.67,1.63L12.46,5.71H7.84A7.85,7.85,0,0,0,0,13.56V30A10,10,0,0,0,10,40H39A10,10,0,0,0,49,30V13.85A8.08,8.08,0,0,0,46.62,8.1ZM45,30a6,6,0,0,1-6,6H10a6,6,0,0,1-6-6V13.56A3.85,3.85,0,0,1,7.84,9.71h5.23a3,3,0,0,0,2.67-1.63L17.83,4H30.58l2.09,4.08a3,3,0,0,0,2.67,1.63h5.53A4.14,4.14,0,0,1,45,13.85Z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-carousel-right-arrow",
  "use": "icon-carousel-right-arrow-usage",
  "viewBox": "0 0 16.366 30.991",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.366 30.991\" id=\"icon-carousel-right-arrow\">\n  <path id=\"icon-carousel-right-arrow_np_chevron_933251_000000\" d=\"M50.209,34.9l-1.124-1.314L36.93,19.406l-3.086,2.627L44.875,34.9,33.843,47.77,36.93,50.4,49.086,36.215Z\" transform=\"translate(-33.843 -19.406)\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-check",
  "use": "icon-check-usage",
  "viewBox": "0 0 50 50",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\" id=\"icon-check\">\n  <title>check</title>\n  <g>\n    <path d=\"M25,43.75A18.75,18.75,0,1,0,6.25,25,18.75,18.75,0,0,0,25,43.75ZM25,50A25,25,0,1,1,50,25,25,25,0,0,1,25,50Z\" />\n    <path d=\"M22.35,28.38l10-15.88,5.12,3.71L24.05,37.5,12.5,29.38l3.39-5.54Z\" />\n  </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-chevron-down-thin",
  "use": "icon-chevron-down-thin-usage",
  "viewBox": "0 0 28 15.8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 15.8\" id=\"icon-chevron-down-thin\"><title>chevron-down-thin</title><polygon id=\"icon-chevron-down-thin_Page-1\" points=\"28 1.5 26.6 0 14 12.9 14 12.9 14 12.9 1.4 0 0 1.5 12.6 14.4 14 15.8 14 15.8 14.8 15 28 1.5\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-chevron-down",
  "use": "icon-chevron-down-usage",
  "viewBox": "0 0 13 7.82",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 7.82\" id=\"icon-chevron-down\"><title>chevron-down</title><path d=\"M6.5,7.82,0,1.74,1.73,0,6.5,4.35,11.27,0,13,1.74Z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-chevron-left-thin",
  "use": "icon-chevron-left-thin-usage",
  "viewBox": "0 0 16 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 28\" id=\"icon-chevron-left-thin\">\n<polygon id=\"icon-chevron-left-thin_Page-1\" points=\"14.3,28 15.8,26.6 2.9,14 2.9,14 2.9,14 15.8,1.4 14.3,0 1.4,12.6 0,14 0,14 0.8,14.8 \" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-chevron-left-white",
  "use": "icon-chevron-left-white-usage",
  "viewBox": "0 0 16.366 30.991",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.366 30.991\" id=\"icon-chevron-left-white\">\n  <path id=\"icon-chevron-left-white_np_chevron_933251_000000\" d=\"M50.209,34.9l-1.124-1.314L36.93,19.406l-3.086,2.627L44.875,34.9,33.843,47.77,36.93,50.4,49.086,36.215Z\" transform=\"translate(50.209 50.397) rotate(180)\" fill=\"#d7d7d7\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-chevron-left",
  "use": "icon-chevron-left-usage",
  "viewBox": "0 0 7.82 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7.82 13\" id=\"icon-chevron-left\"><path d=\"M0,6.5,6.08,0,7.82,1.73,3.47,6.5l4.35,4.77L6.08,13Z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-chevron-right-circle",
  "use": "icon-chevron-right-circle-usage",
  "viewBox": "0 0 63 63",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 63 63\" id=\"icon-chevron-right-circle\">\n<path d=\"M28.3,47.2l-5-4.9l10.8-10.8L23.2,20.5l5-5L44,31.4L28.3,47.2z M63,31.5C63,14.1,48.9,0,31.5,0S0,14.1,0,31.5\n\tS14.1,63,31.5,63S63,48.9,63,31.5z M56,31.5C56,45,45,56,31.5,56S7,45,7,31.5C7,18,18,7,31.5,7S56,18,56,31.5z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-chevron-right-thin",
  "use": "icon-chevron-right-thin-usage",
  "viewBox": "0 0 16 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 28\" id=\"icon-chevron-right-thin\">\n<polygon id=\"icon-chevron-right-thin_Page-1\" points=\"1.4,0 0,1.4 12.9,14 12.9,14 12.9,14 0,26.6 1.4,28 14.3,15.4 15.8,14 15.8,14 15,13.2 \" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-chevron-right-white",
  "use": "icon-chevron-right-white-usage",
  "viewBox": "0 0 16.366 30.991",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.366 30.991\" id=\"icon-chevron-right-white\">\n  <path id=\"icon-chevron-right-white_np_chevron_933251_000000\" d=\"M50.209,34.9l-1.124-1.314L36.93,19.406l-3.086,2.627L44.875,34.9,33.843,47.77,36.93,50.4,49.086,36.215Z\" transform=\"translate(-33.843 -19.406)\" fill=\"#d7d7d7\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-chevron-right",
  "use": "icon-chevron-right-usage",
  "viewBox": "0 0 7.82 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7.82 13\" id=\"icon-chevron-right\"><path d=\"M7.82,6.5,1.74,13,0,11.27,4.35,6.5,0,1.73,1.74,0Z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-close-thin",
  "use": "icon-close-thin-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 36 36\" id=\"icon-close-thin\">\n<g>\n\t<polygon points=\"36,32.6 32.6,36 18,21.4 3.5,35.8 0.1,32.4 14.6,18 0,3.4 3.4,0 18,14.6 32.4,0.2 35.8,3.6 21.4,18 \t\" />\n</g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 10.2 10.2",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 10.2 10.2\" id=\"icon-close\">\n<path d=\"M0,1.3L1.3,0l8.8,8.8l-1.3,1.3L0,1.3z M1.3,10.2L0,8.8L8.8,0l1.3,1.3L1.3,10.2z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-cw-pause",
  "use": "icon-cw-pause-usage",
  "viewBox": "0 0 16 20",
  "content": "<symbol viewBox=\"0 0 16 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cw-pause\">\n<path d=\"M10.6667 19.3334V0.666687H16V19.3334H10.6667ZM0 19.3334V0.666687H5.33333V19.3334H0Z\" fill=\"#BABABA\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-cw-play",
  "use": "icon-cw-play-usage",
  "viewBox": "0 0 16 20",
  "content": "<symbol viewBox=\"0 0 16 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cw-play\">\n<path d=\"M0.666663 0.666705L15.3333 10L0.666661 19.3334L0.666663 0.666705Z\" fill=\"#BABABA\" fill-opacity=\"0.729412\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-doc",
  "use": "icon-doc-usage",
  "viewBox": "0 0 21 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 24\" id=\"icon-doc\"><path d=\"M19.67,8.58H19.1V5.8a.42.42,0,0,0,0-.05A.47.47,0,0,0,19,5.44L14.41.16h0L14.32.08l0,0L14.2,0H2.83A.94.94,0,0,0,1.9.94V8.58H1.33A1.34,1.34,0,0,0,0,9.93v7a1.34,1.34,0,0,0,1.33,1.35H1.9v4.79a.94.94,0,0,0,.93.94H18.17a.94.94,0,0,0,.93-.94V18.27h.57A1.34,1.34,0,0,0,21,16.93v-7a1.34,1.34,0,0,0-1.33-1.35ZM2.83.94H13.6V5.76a.47.47,0,0,0,.46.47h4.11V8.58H2.83ZM14,13c0,2.14-1.28,3.44-3.17,3.44a3,3,0,0,1-3-3.32,3.14,3.14,0,0,1,3.14-3.42A3,3,0,0,1,14,13ZM1.43,16.35V9.94a12.8,12.8,0,0,1,2-.14A4.1,4.1,0,0,1,6,10.5,2.9,2.9,0,0,1,7.13,13,3.33,3.33,0,0,1,6.06,15.6a4.6,4.6,0,0,1-3,.84A12.48,12.48,0,0,1,1.43,16.35Zm16.74,6.46H2.83V18.27H18.17Zm.07-7.55A3.61,3.61,0,0,0,19.46,15l.22,1.15a4.1,4.1,0,0,1-1.65.28,3.08,3.08,0,0,1-3.38-3.26,3.3,3.3,0,0,1,3.52-3.47,3.76,3.76,0,0,1,1.59.29l-.3,1.17A3.12,3.12,0,0,0,18.23,11a2,2,0,0,0-2.06,2.16,1.94,1.94,0,0,0,2.07,2.13ZM5.58,13a1.86,1.86,0,0,0-2-2.07,3,3,0,0,0-.66.06v4.27a2.62,2.62,0,0,0,.51,0A2,2,0,0,0,5.58,13Zm3.75.13c0,1.28.59,2.18,1.57,2.18s1.55-.95,1.55-2.22-.55-2.18-1.56-2.18S9.33,11.86,9.33,13.13Z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-down-arrow-information-black",
  "use": "icon-down-arrow-information-black-usage",
  "viewBox": "0 0 19.000000 10.000000",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19.000000 10.000000\" preserveAspectRatio=\"xMidYMid meet\" id=\"icon-down-arrow-information-black\">\n\n<g transform=\"translate(0.000000,10.000000) scale(0.100000,-0.100000)\" fill=\"#000000\" stroke=\"none\">\n<path d=\"M5 91 c-3 -5 15 -26 40 -46 49 -41 47 -41 107 14 42 37 22 45 -23 9\nl-39 -31 -39 31 c-22 18 -42 28 -46 23z\" />\n</g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-down-arrow-information",
  "use": "icon-down-arrow-information-usage",
  "viewBox": "0 0 18.148 9.584",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18.148 9.584\" id=\"icon-down-arrow-information\">\n  <path id=\"icon-down-arrow-information_np_chevron_933251_000000\" d=\"M43.427,28.48l-.658-.769-7.118-8.3-1.807,1.539L40.3,28.48l-6.46,7.535,1.807,1.539,7.118-8.3Z\" transform=\"translate(37.554 -33.843) rotate(90)\" fill=\"#d7d7d7\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-download-icon",
  "use": "icon-download-icon-usage",
  "viewBox": "656 34 32 35",
  "content": "<symbol viewBox=\"656 34 32 35\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-download-icon\">\n    <!-- Generator: Sketch 39.1 (31720) - http://www.bohemiancoding.com/sketch -->\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-download-icon_Download-Icon\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(658.000000, 37.000000)\">\n        <g id=\"icon-download-icon_arrow\" transform=\"translate(5.000000, 0.000000)\" stroke=\"#FFFFFF\" stroke-width=\"5\">\n            <polyline id=\"icon-download-icon_Path-54\" transform=\"translate(9.086830, 9.323114) rotate(-585.000000) translate(-9.086830, -9.323114) \" points=\"2.99729208 3.27024615 15.1763678 3.27024615 15.1763678 15.3759812\" />\n            <path d=\"M9,1.5 L9,15.6245155\" id=\"icon-download-icon_Line\" stroke-linecap=\"square\" />\n        </g>\n        <polyline id=\"icon-download-icon_Path-6\" stroke=\"#FFFFFF\" stroke-width=\"5\" points=\"0.5 22 0.5 29.2495446 27.5 29.2495446 27.5 22\" />\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 14 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 16\" id=\"icon-download\"><path d=\"M12.56,14.08H6.87C5,14,3,14,1.18,14a1,1,0,0,0-1,.7,1,1,0,0,0,.49,1.11A1,1,0,0,0,1,16H12.9A1,1,0,0,0,14,15.12,1,1,0,0,0,13.14,14a1,1,0,0,0-.53.09Zm.88-8.75a1.06,1.06,0,0,0-1.47.1C10.69,6.74,9.42,7.94,8.14,9.25c-.1,0-.1.1-.2.2h-.1V.94A1.2,1.2,0,0,0,7.72.5,1,1,0,0,0,6.38.14h0A.87.87,0,0,0,5.89,1V9.55c-.1-.1-.2-.1-.2-.2C4.51,8.29,3.44,7,2.26,6l-.59-.6a1,1,0,0,0-1.37.1l-.1.1a.87.87,0,0,0,.1,1.21h0L.59,7C2.45,9,4.32,10.76,6.28,12.47a1,1,0,0,0,1.47,0l.2-.2c1.47-1.51,2.94-2.92,4.41-4.43l1.18-1.21a1,1,0,0,0-.1-1.27Z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-edit",
  "use": "icon-edit-usage",
  "viewBox": "0 0 34 34",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 34 34\" id=\"icon-edit\">\n<path d=\"M15.9,24.7L7,28l3.3-8.9L15.9,24.7z M17.1,23.6l-5.6-5.6L24,5.5l5.6,5.6L17.1,23.6z M30.7,10l-5.6-5.6l2.8-2.8l5.6,5.6\n\tL30.7,10z M0,0h16v2H0V0z M0,0h2v34H0V0z M32,17h2v17h-2V17z M0,32h33v2H0V32z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-email-faq",
  "use": "icon-email-faq-usage",
  "viewBox": "0 0 14 9.692",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 9.692\" id=\"icon-email-faq\">\n  <path id=\"icon-email-faq_np_email_1740173_000000\" d=\"M12.077,23a1.038,1.038,0,0,0-.572.174l6.063,5.744a.6.6,0,0,0,.875,0L24.5,23.174A1.038,1.038,0,0,0,23.923,23Zm-1.01.74a1.144,1.144,0,0,0-.067.376v7.46a1.141,1.141,0,0,0,.174.611l4.285-4.28Zm13.865,0L20.552,27.9l4.274,4.285A1.141,1.141,0,0,0,25,31.576v-7.46a1.144,1.144,0,0,0-.067-.376Zm-4.9,4.661-1.094,1.038a1.355,1.355,0,0,1-1.862,0l-1.094-1.032-4.24,4.229a1.049,1.049,0,0,0,.337.056H23.923a1.049,1.049,0,0,0,.337-.056Z\" transform=\"translate(-11 -23)\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-external",
  "use": "icon-external-usage",
  "viewBox": "0 0 14.01 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14.01 10\" id=\"icon-external\"><path d=\"M1.9,5.7a.86.86,0,0,1-.6-.3.64.64,0,0,1,0-.6L2.5,1.7a.55.55,0,0,1,.6-.4H8.4a.55.55,0,0,1,.5.3.66.66,0,0,1,.1.6L7.8,5.3a.68.68,0,0,1-.6.4H6.5L6,7H7.2A2,2,0,0,0,9,5.8l1.2-3.1A1.91,1.91,0,0,0,10,.9,1.92,1.92,0,0,0,8.4,0H3.1A2,2,0,0,0,1.3,1.2L.1,4.3A2.25,2.25,0,0,0,.3,6.1,1.92,1.92,0,0,0,1.9,7H3.3l.5-1.3ZM13.7,3.9A2.2,2.2,0,0,0,12.1,3H10.7l-.5,1.3h1.9a.55.55,0,0,1,.5.3.66.66,0,0,1,.1.6L11.5,8.3a.55.55,0,0,1-.6.4H5.6a.55.55,0,0,1-.5-.3c-.2-.1-.2-.4-.1-.6L6.2,4.7a.68.68,0,0,1,.6-.4h.7L8,3H6.8A1.92,1.92,0,0,0,5,4.3l-1.2,3A2.54,2.54,0,0,0,4,9.2a2.09,2.09,0,0,0,1.6.8h5.3a2,2,0,0,0,1.8-1.2l1.2-3.1A2.25,2.25,0,0,0,13.7,3.9Z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-facebook",
  "use": "icon-facebook-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-facebook\"><path d=\"M30.23,0H1.77A1.77,1.77,0,0,0,0,1.77V30.23A1.77,1.77,0,0,0,1.77,32H17.09V19.61H12.92V14.78h4.17V11.22c0-4.13,2.52-6.38,6.21-6.38A34.22,34.22,0,0,1,27,5V9.34H24.47c-2,0-2.39,1-2.39,2.35v3.08h4.78l-.62,4.83H22.08V32h8.15A1.77,1.77,0,0,0,32,30.23V1.77A1.77,1.77,0,0,0,30.23,0\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-fail",
  "use": "icon-fail-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-fail\">\n  <title>fail</title>\n  <g>\n    <path d=\"M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0ZM8,14a6,6,0,1,1,6-6A6,6,0,0,1,8,14Z\" />\n    <polygon points=\"10.12 4.46 8 6.59 5.88 4.46 4.46 5.88 6.59 8 4.46 10.12 5.88 11.54 8 9.41 10.12 11.54 11.54 10.12 9.41 8 11.54 5.88 10.12 4.46\" />\n  </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-gif",
  "use": "icon-gif-usage",
  "viewBox": "0 0 21 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 24\" id=\"icon-gif\"><path d=\"M19.67,8.58H19.1V5.8a.41.41,0,0,0,0-.05A.46.46,0,0,0,19,5.45L14.41.16h0L14.32.08l0,0L14.2,0H2.83A.94.94,0,0,0,1.9.94V8.58H1.33A1.34,1.34,0,0,0,0,9.93H0v7a1.34,1.34,0,0,0,1.33,1.35H1.9v4.79a.94.94,0,0,0,.93.94H18.17a.94.94,0,0,0,.93-.94V18.27h.57A1.34,1.34,0,0,0,21,16.93v-7a1.34,1.34,0,0,0-1.33-1.35ZM18.17,22.8H2.83V18.27H18.17ZM7,15.82a2.16,2.16,0,0,0,.77-.1V14.24H6.69V13H9.28v3.7A7.69,7.69,0,0,1,7,17.1a3.84,3.84,0,0,1-2.82-.95,3.42,3.42,0,0,1-1-2.55c0-2.34,1.69-3.67,4-3.67a4.73,4.73,0,0,1,1.93.34l-.33,1.27a3.81,3.81,0,0,0-1.62-.3,2.11,2.11,0,0,0-2.3,2.27A2.1,2.1,0,0,0,7,15.82ZM10.5,17V10h1.58v7Zm7-4.12V14.2H15V17H13.44V10h4.24v1.3H15v1.61h2.5Zm.66-4.32H2.83V.94H13.6V5.76a.47.47,0,0,0,.46.47h4.11Z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-google-calendar",
  "use": "icon-google-calendar-usage",
  "viewBox": "4 4 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"4 4 40 40\" id=\"icon-google-calendar\">\n\n<g id=\"icon-google-calendar_Layer_3\">\n\t<path style=\"fill-rule:evenodd;clip-rule:evenodd;fill:#C7C7C7;\" d=\"M38,5c-6.302,0-21.698,0-28,0C8.895,5,8,5.895,8,7   c0,3.047,0,3,0,3h32c0,0,0,0.047,0-3C40,5.895,39.105,5,38,5z M14,8c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1s1,0.448,1,1   C15,7.552,14.552,8,14,8z M34,8c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1s1,0.448,1,1C35,7.552,34.552,8,34,8z\" />\n\t<path style=\"fill-rule:evenodd;clip-rule:evenodd;fill:#1976D2;\" d=\"M44,11c0.103-0.582-1.409-2-2-2C34.889,9,13.111,9,6,9   c-1,0-2.103,1.418-2,2c0.823,4.664,3,15,3,15h34C41,26,43.177,15.664,44,11z\" />\n\t<path style=\"fill-rule:evenodd;clip-rule:evenodd;fill:#1E88E5;\" d=\"M41,26H7c0,0-2.177,10.336-3,15c0,1.146,0.792,2,2,2   c7.111,0,28.889,0,36,0c0.591,0,2-0.5,2-2C43.177,36.336,41,26,41,26z\" />\n\t<path style=\"fill-rule:evenodd;clip-rule:evenodd;fill:#FAFAFA;\" d=\"M20.534,26c0.984,0.325,1.687,0.85,2.105,1.557   c0.433,0.732,0.65,1.55,0.65,2.457c0,1.582-0.519,2.826-1.556,3.733c-1.037,0.906-2.363,1.36-3.977,1.36   c-1.582,0-2.892-0.427-3.93-1.282c-1.038-0.855-1.536-2.014-1.497-3.476l0.036-0.072h2.242c0,0.914,0.28,1.642,0.841,2.182   c0.56,0.541,1.33,0.811,2.308,0.811c0.994,0,1.773-0.27,2.337-0.811c0.564-0.541,0.847-1.34,0.847-2.397   c0-1.073-0.25-1.864-0.751-2.373c-0.501-0.509-1.292-0.763-2.373-0.763h-2.051V26H20.534z\" />\n\t<rect x=\"31.637\" y=\"26\" style=\"fill-rule:evenodd;clip-rule:evenodd;fill:#FAFAFA;\" width=\"2.349\" height=\"8.856\" />\n\t<path style=\"fill-rule:evenodd;clip-rule:evenodd;fill:#E0E0E0;\" d=\"M14.727,22.036h-2.254l-0.024-0.072   c-0.04-1.312,0.435-2.427,1.425-3.345c0.99-0.918,2.284-1.377,3.882-1.377c1.606,0,2.886,0.427,3.84,1.282   c0.954,0.855,1.431,2.073,1.431,3.655c0,0.716-0.217,1.429-0.65,2.141c-0.433,0.712-1.083,1.254-1.95,1.628L20.534,26h-4.77v-0.911   h2.051c1.042,0,1.779-0.26,2.212-0.781c0.433-0.521,0.65-1.246,0.65-2.176c0-0.994-0.246-1.749-0.739-2.266   c-0.493-0.517-1.22-0.775-2.182-0.775c-0.914,0-1.648,0.268-2.2,0.805C15.022,20.414,14.746,21.098,14.727,22.036z\" />\n\t<polygon style=\"fill-rule:evenodd;clip-rule:evenodd;fill:#E0E0E0;\" points=\"33.986,26 31.637,26 31.637,19.782 28.083,19.83    28.083,18.136 33.986,17.492  \" />\n\t<path style=\"fill-rule:evenodd;clip-rule:evenodd;fill:#1976D2;\" d=\"M6,9c-1.438,0-2.103,1.418-2,2c0.823,4.664,3,15,3,15\" />\n\t<path style=\"fill-rule:evenodd;clip-rule:evenodd;fill:#1976D2;\" d=\"M41,26c0,0,2.177-10.336,3-15c0-1.625-1.409-2-2-2\" />\n</g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-google-plus",
  "use": "icon-google-plus-usage",
  "viewBox": "0 0 46.4 29.7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 46.4 29.7\" id=\"icon-google-plus\">\n<path d=\"M46.4,16.5L46.4,16.5h-5.1v5.1h-3.4v-5.1h-5.1v-3.4h5.1V8h3.4v5.1h5.1V16.5L46.4,16.5z M14.9,12.7v5.1h8.4\n\tc-0.3,2.2-2.5,6.4-8.4,6.4c-5.1,0-9.2-4.2-9.2-9.4c0-5.2,4.1-9.4,9.2-9.4c2.9,0,4.8,1.2,5.9,2.3l4-3.9C22.2,1.5,18.9,0,14.9,0\n\tC6.6,0,0,6.6,0,14.9s6.6,14.9,14.9,14.9c8.6,0,14.3-6,14.3-14.5c0-1-0.1-1.7-0.2-2.5C28.9,12.7,14.9,12.7,14.9,12.7z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-hive-learning",
  "use": "icon-hive-learning-usage",
  "viewBox": "0 0 554 93",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 554 93\" id=\"icon-hive-learning\">\n  <title>hive-learning</title>\n  <path d=\"M279,16h4V67.11a5.26,5.26,0,0,0,1.3,3.75,4.66,4.66,0,0,0,3.58,1.39A12.81,12.81,0,0,0,290,72a10.79,10.79,0,0,0,2.24-.61L293,74.7a15.87,15.87,0,0,1-3.3.94,18.8,18.8,0,0,1-3.38.37A7,7,0,0,1,281,73.92a7.7,7.7,0,0,1-2-5.58V16m56.47,29.43a21.72,21.72,0,0,0-4.27-6.94,20.42,20.42,0,0,0-6.52-4.73,20,20,0,0,0-16.31,0,20.05,20.05,0,0,0-6.48,4.69,22.36,22.36,0,0,0-4.31,6.94A22.73,22.73,0,0,0,296,53.8a23.25,23.25,0,0,0,1.57,8.57,22.8,22.8,0,0,0,4.35,7.06,20.3,20.3,0,0,0,6.56,4.82A19.31,19.31,0,0,0,316.7,76h0a20.63,20.63,0,0,0,5.64-.78,20.4,20.4,0,0,0,5-2.16,17.72,17.72,0,0,0,4-3.31,13.56,13.56,0,0,0,2.62-4.2l-3.54-1a12.09,12.09,0,0,1-2.22,3.31A14.16,14.16,0,0,1,325,70.45a17.31,17.31,0,0,1-3.91,1.67,15.15,15.15,0,0,1-4.27.61,14.9,14.9,0,0,1-6.2-1.31,16.45,16.45,0,0,1-5.11-3.59,19.36,19.36,0,0,1-3.67-5.43,19.1,19.1,0,0,1-1.69-6.82h36.73a2.29,2.29,0,0,0,.08-.78v-1A23,23,0,0,0,335.47,45.43Zm-35.36,6.9a20.89,20.89,0,0,1,1.57-6.82,17,17,0,0,1,3.54-5.39,16.26,16.26,0,0,1,5.11-3.51,15.84,15.84,0,0,1,12.41,0,16.27,16.27,0,0,1,5.11,3.51,18.37,18.37,0,0,1,3.63,5.35,19.48,19.48,0,0,1,1.65,6.86Zm77.13,17.14V48.74q0-7.84-4.32-12.29T361.08,32q-7.2,0-15.2,5.55l1.52,2.78a32.68,32.68,0,0,1,6.92-3.76,18,18,0,0,1,6.44-1.31,12,12,0,0,1,9.12,3.55q3.36,3.55,3.36,9.59v4.16a32.84,32.84,0,0,0-6.12-1.67,38.1,38.1,0,0,0-6.76-.61,25,25,0,0,0-7,.94,17.56,17.56,0,0,0-5.48,2.61,12.44,12.44,0,0,0-3.56,4A10.19,10.19,0,0,0,343,62.86,12.92,12.92,0,0,0,344,68,12.26,12.26,0,0,0,347,72.2,14.24,14.24,0,0,0,351.32,75a14,14,0,0,0,5.36,1h0a23.1,23.1,0,0,0,9.68-2,18.77,18.77,0,0,0,7.36-5.88v3.51a4.66,4.66,0,0,0,1.12,2.65,3.23,3.23,0,0,0,2.56,1.1q.38,0,.76,0a8.19,8.19,0,0,0,.84-.12V71.51Q377.24,71.51,377.24,69.47Zm-4-6.53A5.53,5.53,0,0,1,372,66.2a14.6,14.6,0,0,1-6,4.73,20,20,0,0,1-8.52,1.8h0a11.29,11.29,0,0,1-4.2-.78,10.67,10.67,0,0,1-3.4-2.12,9.4,9.4,0,0,1-2.24-3.22,10.1,10.1,0,0,1-.8-4,7.69,7.69,0,0,1,1-3.88,8.81,8.81,0,0,1,2.84-3,15,15,0,0,1,4.4-1.92,21.76,21.76,0,0,1,5.68-.69,36,36,0,0,1,6.48.57,31.74,31.74,0,0,1,6,1.72ZM407,36.87a16.82,16.82,0,0,0-10,3.42,17.06,17.06,0,0,0-6,8.94V76H387V33.17h3.9V43.71a20.66,20.66,0,0,1,5.81-7.37,14.78,14.78,0,0,1,7.77-3.25q.73-.08,1.46-.08H407v3.87M449,75h-4V51.43q0-8.21-2.28-11.95t-7.24-3.74a14.78,14.78,0,0,0-5.23,1,17.64,17.64,0,0,0-4.84,2.76,20.07,20.07,0,0,0-3.92,4.19A17.26,17.26,0,0,0,419,48.83V75h-4V32.73h3.76V42.81a20,20,0,0,1,7.4-7.84,21.1,21.1,0,0,1,5-2.2A19.27,19.27,0,0,1,436.6,32q6.8,0,9.6,4.84T449,50.7V75m9,0h4V33h-4Zm0-51.57h4V16h-4ZM505,75h-4V51.43q0-8.21-2.28-11.95t-7.24-3.74a14.8,14.8,0,0,0-5.24,1,17.64,17.64,0,0,0-4.84,2.76,19.91,19.91,0,0,0-3.92,4.19A17.28,17.28,0,0,0,475,48.83V75h-4V32.73h3.76V42.81a20,20,0,0,1,7.4-7.84,21.1,21.1,0,0,1,5-2.2A19.27,19.27,0,0,1,492.6,32q6.8,0,9.6,4.84T505,50.7V75m45.26-42.27V41.9a27.59,27.59,0,0,0-7-7A16.34,16.34,0,0,0,533.67,32a17.84,17.84,0,0,0-8,1.78,19.37,19.37,0,0,0-6.22,4.83,22.33,22.33,0,0,0-4,7A24.42,24.42,0,0,0,514,53.9a22.05,22.05,0,0,0,1.51,8,23.18,23.18,0,0,0,4.15,6.94,20.13,20.13,0,0,0,6.3,4.87,17.75,17.75,0,0,0,8,1.83h0a17.86,17.86,0,0,0,9-2.47,19.5,19.5,0,0,0,6.91-6.61v9.25a13.76,13.76,0,0,1-1.26,6.08,12.59,12.59,0,0,1-3.41,4.34,14.92,14.92,0,0,1-5,2.64,20.65,20.65,0,0,1-6.14.89,21.67,21.67,0,0,1-9.19-2,15.15,15.15,0,0,1-6.83-6.29l-2.77,1.87a22.07,22.07,0,0,0,3.05,4,17,17,0,0,0,4,3.08,19.71,19.71,0,0,0,5.16,1.95,28.86,28.86,0,0,0,6.59.69,26.08,26.08,0,0,0,7.6-1.09A19,19,0,0,0,548,88.66a15.75,15.75,0,0,0,4.35-5.39A16.63,16.63,0,0,0,554,75.72v-43Zm-.32,28a10.4,10.4,0,0,1-1.67,4.06,15.49,15.49,0,0,1-3.41,3.65,18.52,18.52,0,0,1-4.64,2.64,14.12,14.12,0,0,1-5.24,1h0a15.23,15.23,0,0,1-6.59-1.46,16.91,16.91,0,0,1-5.37-4,19.14,19.14,0,0,1-3.58-5.76,18.44,18.44,0,0,1-1.3-6.9,20.78,20.78,0,0,1,1.1-6.61,19,19,0,0,1,3.17-5.88,16.41,16.41,0,0,1,5.08-4.22,14.17,14.17,0,0,1,6.83-1.62,14.36,14.36,0,0,1,4.84.85,18.38,18.38,0,0,1,4.47,2.31,17.5,17.5,0,0,1,3.7,3.53,18.29,18.29,0,0,1,2.6,4.5ZM75.66,21.07h0L39.84.4a2.43,2.43,0,0,0-2.67,0L1.34,21.07A2.75,2.75,0,0,0,0,23.33V64.67a2.58,2.58,0,0,0,1.34,2.27L37.16,87.6a2.43,2.43,0,0,0,2.67,0L75.66,66.93A2.75,2.75,0,0,0,77,64.67V23.33A2.58,2.58,0,0,0,75.66,21.07ZM39.3,3.33,71.52,22,30.35,30.27Zm3.48,27.33L52,41.07,47.73,54.13,34.09,57.07l-9.36-10.4,4.41-13.2Zm-7-26.27L22.59,44.13l-19-21.2ZM2.94,26.4,30.88,57.73h0L2.94,63.6ZM37.7,84.53,5.35,66l41.31-8.67h0ZM41,83.6,54.28,43.47l19,21.47Zm33.15-22L46.12,30l28.07-5.6ZM259,53.17a23.31,23.31,0,0,0-1.54-8.43h0A20.85,20.85,0,0,0,253,37.68a22.1,22.1,0,0,0-7.06-4.85A22.59,22.59,0,0,0,236.71,31a23.55,23.55,0,0,0-9.35,1.78,21.29,21.29,0,0,0-7.14,4.9,22.27,22.27,0,0,0-4.59,7.22A23.33,23.33,0,0,0,214,53.58a23,23,0,0,0,1.63,8.63,21.86,21.86,0,0,0,4.59,7.14,21.51,21.51,0,0,0,7.14,4.86A23.34,23.34,0,0,0,236.63,76a24,24,0,0,0,12.15-3.11,19.07,19.07,0,0,0,7.56-8.24h0A1.17,1.17,0,0,0,255.25,63h-5.51c-1.46,0-2.6,1.75-3.18,2.37a11.69,11.69,0,0,1-2.67,2.12,12.83,12.83,0,0,1-3.3,1.33,14.71,14.71,0,0,1-3.63.46,12.86,12.86,0,0,1-8.89-3.53,13.67,13.67,0,0,1-2.92-4,14.81,14.81,0,0,1-1.38-5.23h31.9A3.33,3.33,0,0,0,259,53.17Zm-35.48-3a15.12,15.12,0,0,1,1.34-5.06,12.47,12.47,0,0,1,2.84-3.95,13.13,13.13,0,0,1,8.94-3.45,13.43,13.43,0,0,1,4.92.91,12.88,12.88,0,0,1,4.09,2.53,13.1,13.1,0,0,1,2.88,3.95,14.57,14.57,0,0,1,1.38,5.06ZM139,16h-3.49a3,3,0,0,0-3,3V41.15H102.41V19a3,3,0,0,0-3-3H96a3,3,0,0,0-3,3h0V73a3,3,0,0,0,3,3h3.49a3,3,0,0,0,3-3V49.44h30.18V73a3,3,0,0,0,3,3H139a3,3,0,0,0,3-3V19a3,3,0,0,0-3-3m18.87,16h-3.82A3,3,0,0,0,151,35V73a3,3,0,0,0,3.09,3h3.82A3,3,0,0,0,161,73V35A3,3,0,0,0,157.91,32Zm0-16h-3.82A3,3,0,0,0,151,18.85v3.3A3,3,0,0,0,154.09,25h3.82A3,3,0,0,0,161,22.15v-3.3A3,3,0,0,0,157.91,16Zm43.31,17.93L190,64.22,178.78,33.93A3,3,0,0,0,176,32h-3.07a3,3,0,0,0-2.75,4l14.42,38.07A2.94,2.94,0,0,0,187.37,76h5.26a2.94,2.94,0,0,0,2.75-1.91L209.81,36a3,3,0,0,0-2.75-4H204a3,3,0,0,0-2.76,1.93\" transform=\"translate(0 0)\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-icon_email_gold",
  "use": "icon-icon_email_gold-usage",
  "viewBox": "0 0 22.736 18.327",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22.736 18.327\" id=\"icon-icon_email_gold\">\n  <path id=\"icon-icon_email_gold_np_email_5520895_000000\" d=\"M21.28,26.42l9.143-4.586v10.5a1.888,1.888,0,0,1-1.885,1.886H9.572a1.887,1.887,0,0,1-1.885-1.886v-10.5L16.83,26.42a4.918,4.918,0,0,0,4.45,0Zm7.259-10.526H9.572A1.887,1.887,0,0,0,7.687,17.78v2.105l9.922,4.978a3.2,3.2,0,0,0,2.891,0l9.922-4.978V17.78a1.886,1.886,0,0,0-1.884-1.886Z\" transform=\"translate(-7.687 -15.894)\" fill=\"#a19568\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-icon_phone_gold",
  "use": "icon-icon_phone_gold-usage",
  "viewBox": "0 0 22.239 22.239",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22.239 22.239\" id=\"icon-icon_phone_gold\">\n  <path id=\"icon-icon_phone_gold_np_phone_5518539_000000\" d=\"M11.182,8.136l3.976,3.976a.548.548,0,0,1,.029.743c-.682.8-1.723,2.012-2.256,2.656a1.624,1.624,0,0,0-.359,1.349.67.67,0,0,0,.02.078,12.868,12.868,0,0,0,3.282,4.635,12.17,12.17,0,0,0,5.16,3.326.481.481,0,0,0,.067.014,1.636,1.636,0,0,0,1.409-.461l2.106-2.106a.544.544,0,0,1,.772,0l3.919,3.919a.547.547,0,0,1,0,.773c-.57.569-1.364,1.363-2.062,2.058h0a3.821,3.821,0,0,1-3.536,1.027,21.862,21.862,0,0,1-10.338-6.045A21.931,21.931,0,0,1,7.32,13.738,3.827,3.827,0,0,1,8.348,10.2L10.41,8.136a.547.547,0,0,1,.772,0Z\" transform=\"translate(-7.228 -7.977)\" fill=\"#a19568\" fill-rule=\"evenodd\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-image-icon",
  "use": "icon-image-icon-usage",
  "viewBox": "0 0 16.039 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.039 16\" id=\"icon-image-icon\">\n  <g id=\"icon-image-icon_Image_Icon_\" data-name=\"Image Icon \" transform=\"translate(-12356.48 -2104.601)\">\n    <path id=\"icon-image-icon_Path_299\" data-name=\"Path 299\" d=\"M1061.98,151.6h16.04V140.4h-16.04Zm1.44-9.857h13.16v8.513h-13.16Z\" transform=\"translate(11294.5 1969)\" fill=\"#505050\" />\n    <path id=\"icon-image-icon_Path_300\" data-name=\"Path 300\" d=\"M1063.18,138h13.64v1.44h-13.64Z\" transform=\"translate(11294.5 1969)\" fill=\"#505050\" />\n    <path id=\"icon-image-icon_Path_301\" data-name=\"Path 301\" d=\"M1064.38,135.6h11.24v1.44h-11.24Z\" transform=\"translate(11294.5 1969)\" fill=\"#505050\" />\n  </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-info",
  "use": "icon-info-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-info\">\n  <title>info</title>\n  <path d=\"M8,14A6,6,0,1,0,2,8,6,6,0,0,0,8,14Zm0,2a8,8,0,1,1,8-8A8,8,0,0,1,8,16ZM7,9.15V8.95a1.31,1.31,0,0,1,.54-1.1c.35-.3.93-.59.93-1a.46.46,0,0,0-.51-.45c-.32,0-.64.16-.64.46V7H5.71V6.76C5.71,5.55,6.86,5,8,5c1.4,0,2.17.66,2.17,1.75a1.66,1.66,0,0,1-.81,1.43c-.28.19-.79.37-.79.76v.22Zm-.1,2.08V9.56H8.64v1.67Z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-instagram",
  "use": "icon-instagram-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol role=\"img\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-instagram\"><title>Instagram</title><path d=\"M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-jpg",
  "use": "icon-jpg-usage",
  "viewBox": "0 0 21 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 24\" id=\"icon-jpg\"><path d=\"M9.52,10.92a2.63,2.63,0,0,0-.65.06v2.07a2.37,2.37,0,0,0,.53,0c.83,0,1.35-.43,1.35-1.15S10.3,10.92,9.52,10.92ZM19.67,8.58H19.1V5.8a.41.41,0,0,0,0-.05.47.47,0,0,0-.11-.3L14.41.16h0L14.32.08l0,0L14.2,0H2.83A.94.94,0,0,0,1.9.94V8.58H1.33A1.34,1.34,0,0,0,0,9.93v7a1.34,1.34,0,0,0,1.33,1.35H1.9v4.79a.94.94,0,0,0,.93.94H18.17a.94.94,0,0,0,.93-.94V18.27h.57A1.34,1.34,0,0,0,21,16.93v-7A1.34,1.34,0,0,0,19.67,8.58ZM2.83.94H13.6V5.76a.47.47,0,0,0,.46.47h4.11V8.58H2.83Zm9.47,11a2.26,2.26,0,0,1-.64,1.67,3.2,3.2,0,0,1-2.26.74,3.9,3.9,0,0,1-.54,0V16.8H7.32V9.86a12.65,12.65,0,0,1,2.12-.15,3.3,3.3,0,0,1,2.12.56A2.06,2.06,0,0,1,12.3,11.91ZM2.39,16.75l.18-1.28a2.55,2.55,0,0,0,.8.13c.66,0,1.07-.3,1.07-1.4V9.77H6v4.44c0,2-.95,2.7-2.47,2.7A4,4,0,0,1,2.39,16.75ZM18.17,22.8H2.83V18.27H18.17V22.8Zm.93-6.33a7.69,7.69,0,0,1-2.32.4A3.84,3.84,0,0,1,14,15.92a3.42,3.42,0,0,1-1-2.55c0-2.34,1.69-3.67,4-3.67a4.73,4.73,0,0,1,1.93.34l-.33,1.27a3.81,3.81,0,0,0-1.62-.3,2.11,2.11,0,0,0-2.3,2.27,2.1,2.1,0,0,0,2.18,2.3,2.07,2.07,0,0,0,.77-.1V14H16.52V12.77H19.1v3.7Z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-like",
  "use": "icon-like-usage",
  "viewBox": "0 0 15 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 15 16\" id=\"icon-like\">\n<path id=\"icon-like_Stroke-1\" d=\"M13.1,8.3c0.1,0,0.2-0.1,0.3-0.1c0.2-0.1,0.3-0.3,0.3-0.6c0-0.4-0.3-0.6-1-0.6H8.8c-0.3,0-0.6-0.3-0.5-0.6\n\tc0-0.1,0-0.2,0.1-0.3c0.1-0.2,0.1-0.5,0.2-0.8c0.1-0.5,0.2-0.9,0.2-1.3c0-0.3,0-0.6,0-0.8c0-1.3-0.4-1.9-1-2.1\n\tc-0.2,1.7-1.1,3.7-2.4,5C5,6.5,4.5,6.8,4,7.2C3.4,7.5,2.8,7.8,2.2,8C2,8.1,1.8,8.1,1.6,8.2C1.5,8.3,1.5,8.5,1.4,8.8\n\tC1.1,9.5,1,10.4,1,11.4c0,1,0.2,1.7,0.5,2.2c0.1,0.2,0.2,0.3,0.3,0.4h1.9c0.5,0,0.9,0.1,1.5,0.3c0.1,0,0.2,0.1,0.3,0.1\n\tc0,0,0.3,0.1,0.3,0.1C6.6,14.9,7.2,15,8,15h2.9c1.7,0,2-0.2,2-0.6c0-0.2-0.1-0.3-0.2-0.3c-0.1,0-0.2-0.1-0.2-0.1c-0.6-0.1-0.6-1,0-1\n\tc0.1,0,0.4,0,0.6-0.1c0.3-0.1,0.5-0.3,0.5-0.6c0-0.3-0.1-0.4-0.3-0.5c-0.1-0.1-0.2-0.1-0.3-0.1c-0.7,0-0.6-1,0.1-1\n\tc0.1,0,0.3,0,0.4-0.1c0.2-0.1,0.3-0.2,0.3-0.6c0-0.3-0.1-0.5-0.4-0.6c-0.2-0.1-0.3-0.1-0.4-0.1C12.6,9.3,12.5,8.4,13.1,8.3z\n\t M12.7,5.9c1.2,0,2,0.6,2,1.6c0,0.4-0.1,0.8-0.4,1C14.8,8.9,15,9.4,15,10c0,0.6-0.2,1-0.6,1.3c0.2,0.3,0.3,0.6,0.3,1\n\tc0,0.7-0.3,1.2-0.9,1.4c0.1,0.2,0.2,0.4,0.2,0.7c0,1.2-0.9,1.6-3,1.6H8c-1,0-1.7-0.2-2.6-0.6c-0.1,0-0.3-0.1-0.3-0.1\n\tc-0.1,0-0.2-0.1-0.3-0.1C4.3,15,4,15,3.6,15H1.5c-0.1,0-0.2,0-0.3-0.1c-0.2-0.1-0.4-0.4-0.7-0.8C0.2,13.4,0,12.5,0,11.4\n\tc0-1.1,0.2-2.1,0.4-2.9c0.2-0.5,0.3-0.8,0.4-1C0.9,7.4,1,7.3,1.2,7.3c0.1,0,0.4-0.1,0.7-0.2C2.4,6.8,3,6.6,3.5,6.3\n\tC4,6,4.4,5.7,4.7,5.4c1.2-1.2,2-3.1,2.1-4.6c0-0.5,0.5-0.9,1-0.8c1.2,0.2,2,1.1,2,3.1c0,0.3,0,0.6-0.1,0.9c0,0.4-0.1,0.9-0.2,1.4\n\tc0,0.2-0.1,0.4-0.1,0.5H12.7z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-linkedin",
  "use": "icon-linkedin-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-linkedin\">\n  <title>linledin</title>\n  <path d=\"M14.82,0H1.18A1.17,1.17,0,0,0,0,1.15V14.85A1.17,1.17,0,0,0,1.18,16H14.82A1.17,1.17,0,0,0,16,14.85V1.15A1.17,1.17,0,0,0,14.82,0ZM4.75,13.63H2.37V6H4.75ZM3.56,5A1.38,1.38,0,1,1,3.48,2.2h.07A1.38,1.38,0,0,1,3.56,5Zm10.08,8.68H11.26V9.92c0-.89,0-2-1.23-2s-1.42,1-1.42,2v3.78H6.24V6H8.51V7h0a2.49,2.49,0,0,1,2.25-1.23c2.4,0,2.85,1.58,2.85,3.64Z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-lion-mask",
  "use": "icon-lion-mask-usage",
  "viewBox": "0 0 237 301",
  "content": "<symbol viewBox=\"0 0 237 301\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-lion-mask\">\n    <defs>\n        <rect id=\"icon-lion-mask_path-1\" x=\"0\" y=\"0\" width=\"237\" height=\"301\" />\n        <path d=\"M1777.52809,850.895076 C1614.90351,781.854751 1636.01968,709.571339 1636.01968,709.571339 C1636.01968,709.571339 1760.36926,826.623899 2139.63965,833.577825 C2139.63965,833.577825 2138.49712,879.188928 2076.06266,890.903539 C2051.63314,895.872114 1898.1904,909.665627 1901.14022,1015.02436 C1872.21326,1002.19754 1869.72045,971.564924 1870.67603,966.128596 C1837.85405,963.633914 1821.66119,982.177717 1805.86301,998.50749 C1782.2852,1022.82025 1767.04791,1025.08625 1767.04791,1025.08625 C1767.04791,1025.08625 1783.13691,980.119605 1754.98895,980.119605 C1733.64428,980.119605 1715.32214,1027.34186 1715.32214,1027.34186 C1715.32214,1027.34186 1689.8955,1008.76687 1696.33525,981.554047 C1664.46885,969.070242 1643.24882,1018.30903 1643.24882,1018.30903 C1643.24882,1018.30903 1623.53486,985.555933 1647.08151,962.56328 C1647.08151,962.56328 1609.2116,954.808977 1575.04974,997.644746 C1557.82859,1019.15098 1538.93518,1034.95064 1513.20732,1027.59132 C1508.51254,1026.09452 1504.49288,1025.09664 1501.32494,1023.44392 C1483.39749,1041.50957 1488.3104,1063.66027 1488.3104,1063.66027 C1480.05297,1054.5131 1465.00264,1037.34137 1475.21277,1009.8375 C1476.51111,1006.50087 1478.3911,1002.94595 1480.36458,999.702859 C1469.68705,972.479641 1494.89557,943.063182 1494.89557,943.063182 C1494.89557,943.063182 1491.47835,945.630626 1477.93409,950.401705 C1448.95519,960.245305 1428.12986,951.690624 1418.37674,934.664419 C1392.56579,939.050902 1383.64361,960.245305 1383.64361,960.245305 C1382.18948,947.907023 1379.71744,925.538041 1404.00155,908.657359 C1406.27624,907.16055 1409.07026,905.726108 1411.71887,904.572317 C1412.10318,880.841655 1425.72014,869.490852 1472.20063,859.356206 C1462.28133,853.452125 1447.89575,838.33851 1456.15317,816.489253 C1435.47325,803.184282 1415.65543,811.738963 1415.65543,811.738963 C1423.22733,802.051281 1437.39479,784.287066 1466.14518,789.193274 C1469.21964,789.796155 1472.41875,790.627716 1475.35819,792.072553 C1490.7305,783.070908 1507.76469,787.769226 1518.42145,791.625589 C1550.74486,803.184282 1596.74756,845.510721 1596.74756,845.510721 C1596.74756,845.510721 1640.25745,837.37182 1681.20183,839.481906 C1715.63374,840.989109 1777.52809,850.895076 1777.52809,850.895076 Z M2613.01875,778.783174 C2613.01875,778.783174 2590.92624,741.518861 2603.02674,786.339981 C2611.12837,817.118121 2583.03234,832.096607 2583.03234,832.096607 C2583.03234,832.096607 2588.33995,806.245465 2574.87878,809.94591 C2557.37719,817.731397 2585.31742,888.642733 2540.83118,912.768387 C2540.83118,912.768387 2548.38231,888.642733 2529.47851,889.100092 C2515.16564,890.835975 2516.07967,915.418987 2504.2596,934.7008 C2483.24731,970.613827 2465.07058,964.481067 2465.07058,964.481067 C2465.07058,964.481067 2474.29397,943.099563 2462.79589,933.037679 C2451.52632,923.349997 2425.34145,934.305809 2426.93061,969.948578 C2426.93061,969.948578 2415.49486,969.480825 2405.95986,959.959456 C2396.72609,950.583609 2396.12366,939.762926 2396.12366,939.762926 C2396.12366,939.762926 2379.78538,931.894283 2371.82916,984.220238 C2365.7841,1025.04987 2334.60323,1071.9291 2299.34038,1070.86886 C2286.08695,1094.22532 2298.06281,1114.8896 2298.06281,1114.8896 C2287.5307,1108.66329 2267.85829,1097.33328 2269.21894,1067.62577 C2269.21894,1065.34938 2269.52016,1062.85469 2270.06027,1060.36001 C2266.79884,1057.18969 2263.99443,1053.17741 2262.48836,1047.45003 C2257.81435,1032.61707 2266.94426,1014.68654 2271.56634,1006.75553 C2268.83464,1010.2273 2262.04173,1015.1543 2247.28223,1019.83182 C2233.88339,1024.29107 2219.49781,1020.21642 2209.28768,1010.44558 C2184.31805,1021.71323 2182.18878,1045.83888 2182.18878,1045.83888 C2177.27587,1034.644 2167.90706,1013.85498 2185.9176,990.737595 C2188.63892,987.182673 2191.78609,984.064321 2195.51491,981.569639 C2195.06829,979.449159 2195.06829,977.484597 2195.51491,975.364117 C2196.81325,953.535649 2206.19244,946.883164 2222.89426,938.474007 C2211.11574,936.218398 2200.2928,930.387079 2194.82939,920.034149 C2167.59546,917.071714 2153.59419,936.738124 2153.59419,936.738124 C2155.04833,924.243925 2157.52036,901.874943 2184.76468,891.210177 C2187.48599,890.243488 2190.67471,889.100092 2193.62453,888.892201 C2193.78033,888.050246 2193.93613,887.062768 2194.38276,886.387125 C2211.62469,837.844771 2349.27964,907.924546 2356.32182,859.319825 C2370.16729,763.503246 2061.25641,805.237198 1860.20104,751.185754 C1670.25944,699.920038 1647.09709,651.533602 1647.09709,651.533602 C1369.82411,682.457264 1343.72233,904.910139 1090.87886,1002.15077 C926.218491,1065.80673 818.529174,1052.04441 724.695716,1035.87055 C660.672091,1025.04987 665.138372,1074.12234 610.20311,1055.43302 C629.958615,1051.28561 637.28124,1032.01419 623.581181,1023.23083 C599.826796,1007.89893 593.844056,1047.1278 545.961364,1045.83888 C580.154384,1015.38297 552.390732,993.970287 552.390732,993.970287 C552.390732,993.970287 522.487419,1063.23929 464.446533,1045.83888 C464.446533,1045.83888 484.503253,1038.14695 492.594493,1017.02531 C497.278896,1004.33361 493.196922,997.535604 493.196922,997.535604 C493.196922,997.535604 443.39269,1047.1278 389.527258,1026.48431 C389.527258,1026.48431 400.942243,1024.20791 408.077906,1017.78411 C417.810245,1008.93838 419.929132,999.042807 416.15876,993.752002 C410.1137,984.906276 397.774299,994.96816 384.603962,1000.55001 C370.758489,1006.75553 347.388412,1011.97358 333.439072,1000.55001 C333.439072,1000.55001 391.500731,982.952108 348.364762,961.7681 C325.649046,950.344535 285.940688,945.594245 239.751028,971.81959 C223.350427,980.966757 165.75617,1013.85498 142.365319,988.8354 C119.514576,1000.55001 117.322982,1022.92939 117.322982,1022.92939 C112.5451,1011.20438 103.238616,990.197081 122.090478,967.277189 C123.606937,965.177499 125.79853,962.755578 127.834324,960.998906 C124.811794,941.488414 139.415496,928.734352 153.634889,920.553874 C124.126272,919.27535 86.2251992,915.263069 78.726001,882.073404 C50.578041,878.206647 34.0839597,896.875184 34.0839597,896.875184 C37.1168764,883.196011 42.9230423,857.365657 75.4022567,848.9565 C77.7392644,848.041783 80.3151663,847.750737 82.8079746,847.303773 C88.9465149,827.990777 110.955935,818.781242 136.559153,824.529405 C142.73924,825.963847 152.139204,827.554207 159.243708,828.635236 C153.344062,820.756199 133.432756,803.657232 144.037578,785.20698 C120.106618,768.419849 96.1341121,778.783174 96.1341121,778.783174 C104.755074,767.525921 121.114128,747.100712 154.330798,752.921637 C160.687459,754.283317 167.563456,756.632476 173.234594,760.26016 C191.941043,754.428841 222.747999,758.160469 261.625421,795.78859 C290.46929,821.816439 315.667427,845.869331 437.503431,856.35739 C495.62741,859.527715 558.279991,854.777425 608.603558,831.867928 C569.404148,795.78859 556.607732,835.339694 505.827151,811.442719 C505.827151,811.442719 520.586653,808.646596 526.808287,799.499429 C530.89026,793.241935 532.552132,778.783174 518.86246,772.879093 C486.383246,759.19992 476.100412,805.995997 476.100412,805.995997 C451.587797,773.346846 472.080759,744.616425 472.080759,744.616425 C472.080759,744.616425 451.203489,735.760303 426.919382,741.872274 C391.874653,750.728396 389.683059,773.346846 389.683059,773.346846 C371.07009,756.185512 378.257688,733.421539 384.063853,725.636052 C384.063853,725.636052 352.301321,710.647171 334.820504,749.304348 C334.820504,749.304348 314.535276,714.524323 346.090074,698.485596 C361.005377,690.627348 358.502182,678.455378 358.502182,678.455378 C357.453125,678.902342 329.595993,699.920038 276.758844,699.920038 C236.738885,699.920038 217.056086,674.07929 219.102266,674.380731 C263.993589,682.997779 266.933025,650.234288 266.933025,650.234288 C266.933025,650.234288 199.959576,632.480468 101.358623,659.932364 C60.414247,671.511847 45.8832521,659.932364 37.7193051,642.90616 C9.8621727,649.049314 1.98905326,672.935895 1.98905326,672.935895 C-0.431048096,659.932364 -4.95964978,635.962628 19.3971643,616.67042 C22.2742805,614.331656 25.8265323,612.294332 29.1606634,610.53766 C28.1012198,581.817634 73.272983,557.317777 104.910875,559.126422 C104.910875,559.126422 21.6718519,513.837549 47.1815898,472.57135 C24.3308473,459.328746 2.98617657,468.330391 2.98617657,468.330391 C11.6694587,457.135505 27.9454193,436.575168 61.0270624,442.614377 C64.7247279,443.310809 68.6612877,444.599728 72.4524336,446.023776 C101.514423,425.30752 151.069374,458.809021 175.218454,479.057523 C175.218454,479.057523 168.789086,444.599728 189.593649,427.947726 C173.930503,407.241865 150.934347,408.135792 150.934347,408.135792 C162.359718,401.556069 183.392788,388.708456 210.335891,404.747183 C215.093,407.605673 219.548895,411.545191 223.02844,415.630233 C249.213313,417.137437 261.625421,437.084498 271.555107,478.08044 C295.911921,581.817634 489.042242,621.597417 547.903677,625.214706 C570.837513,690.772871 552.141451,733.639824 552.141451,733.639824 C595.360514,740.760062 616.24817,738.192618 616.24817,738.192618 C616.24817,738.192618 632.21253,812.502959 678.152909,834.050775 C678.152909,834.050775 684.800397,809.32224 686.161055,816.057881 C697.305985,868.913956 749.135624,894.245373 749.135624,894.245373 C749.135624,894.245373 781.521358,883.944415 815.340457,854.174543 C848.640221,824.758085 829.424824,866.419274 829.424824,866.419274 C829.424824,866.419274 905.091941,850.910668 954.740372,761.767363 C972.304284,730.168058 969.873796,729.783461 975.326814,775.540087 C1052.97779,712.549366 1081.49967,638.301392 1076.73218,604.041093 C1165.88123,638.301392 1467.52142,426.887486 1763.01268,417.594795 C1950.47186,411.753081 2028.56947,465.596635 2121.36425,497.95474 C2213.68125,530.468762 2268.83464,546.434727 2288.13313,514.897788 C2305.93593,486.177762 2302.14479,424.839767 2168.72761,406.483066 C2070.35516,392.793498 1941.78858,389.540017 1874.42044,384.311579 C1828.94746,380.704685 1690.39925,370.258204 1693.03747,243.008632 C1694.30465,167.326216 1743.36104,142.59768 1743.36104,142.59768 L1735.24903,168.376061 C1735.24903,168.376061 1758.08938,146.069446 1777.94876,136.017956 C1800.5606,124.438474 1827.1194,122.858509 1827.1194,122.858509 C1827.1194,122.858509 1853.53278,44.068135 1919.91419,44.9100902 C1972.42935,45.7416508 2002.90393,39.6712579 2023.72926,19.2668379 C2056.49931,-12.4779908 2094.49386,5.9618671 2094.49386,5.9618671 C2094.49386,5.9618671 2070.35516,11.949104 2051.5864,49.6603805 C2029.62891,93.2133708 1990.13867,93.2133708 1990.13867,93.2133708 C1990.13867,93.2133708 2008.74125,117.422181 2059.53222,84.2117265 C2134.35802,45.4194211 2173.32892,111.663623 2173.32892,111.663623 C2173.32892,111.663623 2143.45677,99.57481 2113.55345,112.422422 C2089.33167,122.858509 2083.15158,151.069205 2061.10061,163.989579 C2026.47135,184.102952 1999.65289,181.691426 1999.65289,181.691426 C1999.65289,181.691426 2004.12956,200.962845 2061.10061,189.00916 C2130.35914,174.134619 2151.41298,212.38641 2151.41298,212.38641 C2151.41298,212.38641 2129.36201,205.494851 2107.95502,210.733683 C2087.04659,215.712653 2067.70656,232.271104 2043.48477,243.008632 C1953.97218,282.549342 1791.02561,179.934755 1777.63715,252.145405 C1772.88005,276.655655 1792.77058,307.506556 1880.40318,319.834443 C1984.68565,334.262021 2041.67748,326.331011 2189.46985,345.685586 C2240.92557,352.109392 2309.69592,378.719334 2347.01534,414.777883 C2450.38378,514.076622 2363.50942,578.18995 2363.50942,578.18995 C2363.50942,578.18995 2378.70516,545.831846 2364.65195,529.730752 C2364.65195,529.730752 2368.1315,572.37942 2318.63887,596.723359 C2228.88738,640.338716 2017.08177,546.434727 2017.08177,546.434727 C2017.08177,546.434727 1975.53497,668.320733 2312.43801,699.473075 C2451.29781,712.549366 2521.0549,687.228344 2575.32541,706.957121 C2616.571,721.769295 2613.01875,778.783174 2613.01875,778.783174 Z M601.368182,451.16386 C605.616343,432.121121 557.795971,434.595014 550.213679,351.823543 C550.068265,349.089787 588.59254,390.678216 614.777413,297.148429 C617.955744,284.519101 624.000804,259.873722 646.415305,253.896879 C632.777566,206.861729 662.597785,150.076529 662.597785,150.076529 C662.597785,150.076529 673.420728,157.716493 689.385087,162.030214 C703.843375,166.177623 722.913358,166.271173 731.53432,180.095869 C731.53432,180.095869 752.120762,171.780263 770.899917,139.422158 C789.803713,106.897741 821.368898,107.65654 821.368898,107.65654 C821.368898,107.65654 812.218214,151.521366 838.849716,152.508844 C858.13782,153.267643 870.861529,141.532243 898.864075,128.154511 C927.687171,113.934823 963.780957,115.223742 963.780957,115.223742 C963.780957,115.223742 931.166716,165.429218 958.868047,180.636384 C999.054194,202.402485 1025.76879,158.558448 1058.00911,168.98414 C1058.00911,168.98414 1030.07927,210.874009 1056.10834,237.109748 C1084.4121,265.247682 1117.86767,212.391607 1117.86767,212.391607 C1117.86767,212.391607 1138.44372,286.639581 1121.64843,327.386054 C1118.4701,335.327458 1106.3592,353.632188 1106.3592,353.632188 C1106.3592,353.632188 1132.62717,398.848299 1119.01021,445.810688 C1092.44102,539.714677 1118.6259,566.480537 1118.6259,566.480537 C1118.6259,566.480537 1053.91675,587.196792 1047.71589,525.796431 C1046.95766,515.505867 1035.75041,518.166861 1035.75041,540.556633 C1035.75041,565.784104 1057.24049,637.620552 995.564262,704.301324 C985.052921,652.443121 956.063638,671.049291 938.510113,703.095561 C884.634295,801.832996 858.366327,799.650149 858.366327,799.650149 C858.366327,799.650149 875.317424,749.070471 838.247287,788.236979 C784.74539,844.647976 754.468156,845.708216 754.468156,845.708216 C754.468156,845.708216 720.950272,821.592957 700.810458,755.577434 C693.103526,730.18365 674.854092,767.759798 674.854092,767.759798 C674.854092,767.759798 646.259504,738.790303 652.221471,677.473097 C652.221471,677.473097 631.281881,700.985475 598.958467,700.226676 C598.958467,700.226676 610.466932,682.763902 594.938814,635.136265 C579.431469,588.631234 598.574159,568.455493 589.267675,538.352997 C578.600533,503.957568 552.332566,499.862132 551.055002,441.954326 C551.055002,441.954326 595.468536,477.326838 601.368182,451.16386 Z M706.034969,656.445007 L706.034969,656.891971 C706.34657,686.110934 731.233106,703.480158 756.888258,709.373844 C762.725584,710.881048 768.542136,711.795764 774.296369,711.795764 L774.452169,711.795764 C797.915727,711.795764 818.647582,697.950279 826.209101,673.460817 C833.697912,648.65952 831.350518,615.979186 857.545778,596.489482 C881.840272,577.83134 905.968579,576.396898 922.171832,556.418652 L929.878765,546.886888 L918.069085,549.693405 C918.069085,549.693405 911.037289,551.356527 895.072929,552.853336 C889.786098,553.248327 881.237843,554.298173 871.837879,554.298173 C860.0282,554.298173 847.107143,552.853336 837.333258,548.85145 C827.642466,544.392206 822.127127,538.727199 821.815526,527.61547 C821.815526,525.432623 822.282928,523.073069 822.667236,520.276947 C823.85132,515.505867 826.593409,513.395782 831.734826,511.743055 C836.94895,510.433347 843.461411,509.996778 849.288351,509.913622 C865.346191,509.404291 869.646285,496.910092 869.272364,490.403129 C869.272364,487.451089 868.804962,485.403371 868.804962,485.195481 L867.527398,480.341245 L863.071503,482.326596 C863.071503,482.326596 859.810079,483.688277 854.814076,485.195481 C849.454538,486.411638 841.944953,487.835686 833.542112,487.835686 C828.712296,487.835686 823.425465,487.451089 818.117861,486.16217 C806.91061,483.688277 797.978047,478.012875 792.306908,472.867594 C786.407262,467.587183 783.602853,463.263068 783.602853,463.263068 L779.988281,458.128181 L776.487963,462.961627 C776.259455,463.502142 772.707203,468.637029 772.707203,475.674111 C772.707203,479.2914 773.849741,483.688277 776.861884,487.679768 C780.362202,492.076645 785.950247,495.174209 788.671563,497.585735 C794.051874,501.608409 798.289648,506.213177 798.289648,510.672421 C797.978047,511.743055 797.915727,512.792901 797.531419,514.061031 C792.83663,528.000066 784.361082,531.232758 773.69394,531.700511 C758.020408,531.700511 739.178932,521.711389 735.855188,519.881955 C728.35599,514.91338 722.913358,510.225457 719.361107,506.816058 C716.026976,503.198769 714.811731,500.995133 714.811731,500.995133 L709.140593,492.076645 L706.948999,502.575099 L706.948999,504.466899 C706.948999,509.684942 709.140593,525.120787 729.498527,552.853336 C735.47088,560.576456 737.662474,568.455493 737.662474,575.773227 C738.109102,602.695004 706.720491,629.751909 706.034969,656.445007 Z M715.725761,320.743963 C715.725761,321.876964 715.569961,323.301012 715.569961,325.130445 C715.725761,336.845056 718.156249,367.550434 745.005872,384.701373 L746.595037,385.772008 C759.090238,393.245659 773.226539,394.472211 782.771917,394.472211 L789.429792,394.472211 C789.045484,397.403463 787.684826,403.307543 784.049481,413.452584 C781.72286,418.431553 781.172365,422.890797 781.172365,426.903077 C781.172365,439.147808 789.201285,444.137172 789.959514,444.365852 L793.511766,446.257652 L795.474852,442.848253 C795.474852,442.629969 812.353242,416.394229 815.926267,391.977529 C816.217094,389.171012 816.435215,386.905009 816.435215,384.483089 C816.217094,357.343027 793.979167,347.353904 793.605246,346.906941 L724.585617,313.249522 L722.300543,311.887842 L716.639791,308.561599 L715.788081,318.238886 L715.725761,320.743963 Z M873.510138,405.116188 C866.16674,423.951037 865.543538,447.078818 865.543538,455.633499 C865.543538,457.598061 865.720112,458.793429 865.720112,458.793429 L865.720112,462.89926 L869.874792,462.89926 L869.947499,462.89926 C870.2591,462.961627 870.633022,462.961627 870.861529,462.961627 C874.870796,462.961627 887.667211,459.105265 890.544328,439.677928 C892.289293,429.179475 894.096579,423.711963 895.072929,420.479271 C901.575004,425.073644 917.466657,434.595014 935.40449,434.750931 L936.235426,434.750931 L938.894421,434.595014 C975.819144,432.495323 993.611563,398.401335 995.865477,393.713412 L997.080721,391.281097 L997.080721,391.062812 L998.368672,388.713653 L1001.32888,382.518526 L991.554996,382.736811 L915.119262,377.36285 L913.156176,377.36285 C906.654101,377.144566 883.647558,379.712009 873.510138,405.116188 Z M753.099189,688.267794 C702.858716,671.854866 739.097916,624.902871 745.527284,612.12802 C752.122839,598.521609 758.095192,581.588954 753.857418,566.225871 C752.652561,561.226112 747.718878,549.501107 740.759788,540.967216 C765.802125,553.98114 788.528227,551.486458 802.145192,544.98989 C812.874654,568.419112 851.471635,572.202713 870.91554,569.624875 C863.499435,575.757635 822.191525,578.158767 814.7131,637.313914 C813.414762,648.342488 808.57456,706.707652 753.099189,688.267794 Z\" id=\"icon-lion-mask_path-3\" />\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g>\n            <mask id=\"icon-lion-mask_mask-2\" fill=\"white\">\n                <use xlink:href=\"#icon-lion-mask_path-1\" />\n            </mask>\n            <use fill=\"#004F9E\" fill-rule=\"evenodd\" xlink:href=\"#icon-lion-mask_path-1\" />\n            <g mask=\"url(#icon-lion-mask_mask-2)\" fill=\"#E11917\" fill-rule=\"evenodd\">\n                <rect id=\"icon-lion-mask_Rectangle-3-Copy\" x=\"0\" y=\"0\" width=\"237\" height=\"301\" />\n            </g>\n            <g stroke-width=\"1\" fill-rule=\"evenodd\" mask=\"url(#icon-lion-mask_mask-2)\">\n                <g transform=\"translate(832.811350, -147.927393) rotate(-4.000000) translate(-832.811350, 147.927393) translate(-473.825415, -705.683180)\">\n                    <mask id=\"icon-lion-mask_mask-4\" fill=\"white\">\n                        <use xlink:href=\"#icon-lion-mask_path-3\" />\n                    </mask>\n                    <use stroke=\"none\" fill=\"#E30521\" fill-rule=\"evenodd\" xlink:href=\"#icon-lion-mask_path-3\" />\n                    <g id=\"icon-lion-mask_Colour/paleblue\" stroke=\"none\" fill=\"none\" mask=\"url(#icon-lion-mask_mask-4)\" fill-rule=\"evenodd\">\n                        <g transform=\"translate(0.000000, -9.754630)\" fill=\"#EFF3F8\">\n                            <rect x=\"0\" y=\"0\" width=\"2617\" height=\"1133\" rx=\"1\" />\n                        </g>\n                    </g>\n                </g>\n            </g>\n        </g>\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-lion",
  "use": "icon-lion-usage",
  "viewBox": "0 0 3453 1684",
  "content": "<symbol viewBox=\"0 0 3453 1684\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-lion\">\n    <defs>\n        <path d=\"M2281.8,1090.39652 C2073.04,1001.85683 2100.14667,909.158096 2100.14667,909.158096 C2100.14667,909.158096 2259.77333,1059.27033 2746.64,1068.18828 C2746.64,1068.18828 2745.17333,1126.68153 2665.02667,1141.70475 C2633.66667,1148.07662 2436.69333,1165.76589 2440.48,1300.88156 C2403.34667,1284.432 2400.14667,1245.14768 2401.37333,1238.17595 C2359.24,1234.97668 2338.45333,1258.75789 2318.17333,1279.69976 C2287.90667,1310.87927 2268.34667,1313.78527 2268.34667,1313.78527 C2268.34667,1313.78527 2289,1256.1185 2252.86667,1256.1185 C2225.46667,1256.1185 2201.94667,1316.67794 2201.94667,1316.67794 C2201.94667,1316.67794 2169.30667,1292.85674 2177.57333,1257.95808 C2136.66667,1241.94842 2109.42667,1305.09393 2109.42667,1305.09393 C2109.42667,1305.09393 2084.12,1263.09023 2114.34667,1233.60367 C2114.34667,1233.60367 2065.73333,1223.65928 2021.88,1278.59334 C1999.77333,1306.17368 1975.52,1326.4357 1942.49333,1316.99787 C1936.46667,1315.07831 1931.30667,1313.7986 1927.24,1311.67909 C1904.22667,1334.84711 1910.53333,1363.25392 1910.53333,1363.25392 C1899.93333,1351.52328 1880.61333,1329.50167 1893.72,1294.22976 C1895.38667,1289.95074 1897.8,1285.39178 1900.33333,1281.23274 C1886.62667,1246.32075 1918.98667,1208.59607 1918.98667,1208.59607 C1918.98667,1208.59607 1914.6,1211.88865 1897.21333,1218.00724 C1860.01333,1230.63101 1833.28,1219.6602 1820.76,1197.82521 C1787.62667,1203.45058 1776.17333,1230.63101 1776.17333,1230.63101 C1774.30667,1214.80798 1771.13333,1186.12122 1802.30667,1164.47286 C1805.22667,1162.5533 1808.81333,1160.71372 1812.21333,1159.23406 C1812.70667,1128.80104 1830.18667,1114.24438 1889.85333,1101.24736 C1877.12,1093.67577 1858.65333,1074.29355 1869.25333,1046.27331 C1842.70667,1029.21056 1817.26667,1040.18137 1817.26667,1040.18137 C1826.98667,1027.75756 1845.17333,1004.97611 1882.08,1011.268 C1886.02667,1012.04116 1890.13333,1013.10758 1893.90667,1014.96049 C1913.64,1003.41647 1935.50667,1009.44176 1949.18667,1014.38729 C1990.68,1029.21056 2049.73333,1083.49144 2049.73333,1083.49144 C2049.73333,1083.49144 2105.58667,1073.05383 2158.14667,1075.75988 C2202.34667,1077.69277 2281.8,1090.39652 2281.8,1090.39652 Z M3354.31333,997.917734 C3354.31333,997.917734 3325.95333,950.128697 3341.48667,1007.60884 C3351.88667,1047.07979 3315.82,1066.28872 3315.82,1066.28872 C3315.82,1066.28872 3322.63333,1033.13632 3305.35333,1037.8819 C3282.88667,1047.86628 3318.75333,1138.80541 3261.64667,1169.74498 C3261.64667,1169.74498 3271.34,1138.80541 3247.07333,1139.39194 C3228.7,1141.6181 3229.87333,1173.1442 3214.7,1197.87186 C3187.72667,1243.92796 3164.39333,1236.0631 3164.39333,1236.0631 C3164.39333,1236.0631 3176.23333,1208.64272 3161.47333,1195.73902 C3147.00667,1183.3152 3113.39333,1197.36531 3115.43333,1243.07483 C3115.43333,1243.07483 3100.75333,1242.47496 3088.51333,1230.26443 C3076.66,1218.24052 3075.88667,1204.36371 3075.88667,1204.36371 C3075.88667,1204.36371 3054.91333,1194.27269 3044.7,1261.37729 C3036.94,1313.73861 2996.91333,1373.85816 2951.64667,1372.49847 C2934.63333,1402.4516 2950.00667,1428.95218 2950.00667,1428.95218 C2936.48667,1420.96735 2911.23333,1406.43735 2912.98,1368.33942 C2912.98,1365.42009 2913.36667,1362.22083 2914.06,1359.02156 C2909.87333,1354.95583 2906.27333,1349.81034 2904.34,1342.46536 C2898.34,1323.44306 2910.06,1300.44833 2915.99333,1290.27733 C2912.48667,1294.72964 2903.76667,1301.04819 2884.82,1307.04682 C2867.62,1312.7655 2849.15333,1307.54004 2836.04667,1295.00958 C2803.99333,1309.4596 2801.26,1340.39917 2801.26,1340.39917 C2794.95333,1326.04246 2782.92667,1299.38191 2806.04667,1269.73538 C2809.54,1265.17642 2813.58,1261.17734 2818.36667,1257.97807 C2817.79333,1255.2587 2817.79333,1252.73928 2818.36667,1250.0199 C2820.03333,1222.02632 2832.07333,1213.49494 2853.51333,1202.71075 C2838.39333,1199.81808 2824.5,1192.3398 2817.48667,1179.06284 C2782.52667,1175.26372 2764.55333,1200.4846 2764.55333,1200.4846 C2766.42,1184.46161 2769.59333,1155.77485 2804.56667,1142.09799 C2808.06,1140.85828 2812.15333,1139.39194 2815.94,1139.12534 C2816.14,1138.04559 2816.34,1136.77921 2816.91333,1135.91274 C2839.04667,1073.66036 3015.75333,1163.53307 3024.79333,1101.20071 C3042.56667,978.322229 2646.02,1031.84328 2387.92667,962.525853 C2144.1,896.780936 2114.36667,834.728505 2114.36667,834.728505 C1758.43333,874.386073 1724.92667,1159.66729 1400.35333,1284.37202 C1188.98,1366.00662 1050.74,1348.35734 930.286667,1327.61543 C848.1,1313.73861 853.833333,1376.67084 783.313333,1352.70301 C808.673333,1347.38423 818.073333,1322.6699 800.486667,1311.40582 C769.993333,1291.74366 762.313333,1342.05212 700.846667,1340.39917 C744.74,1301.34146 709.1,1273.88109 709.1,1273.88109 C709.1,1273.88109 670.713333,1362.71405 596.206667,1340.39917 C596.206667,1340.39917 621.953333,1330.53476 632.34,1303.44764 C638.353333,1287.17138 633.113333,1278.45338 633.113333,1278.45338 C633.113333,1278.45338 569.18,1342.05212 500.033333,1315.57819 C500.033333,1315.57819 514.686667,1312.65886 523.846667,1304.42075 C536.34,1293.07669 539.06,1280.38627 534.22,1273.60116 C526.46,1262.25709 510.62,1275.1608 493.713333,1282.31916 C475.94,1290.27733 445.94,1296.96913 428.033333,1282.31916 C428.033333,1282.31916 502.566667,1259.751 447.193333,1232.5839 C418.033333,1217.93393 367.06,1211.84199 307.766667,1245.47428 C286.713333,1257.20492 212.78,1299.38191 182.753333,1267.29594 C153.42,1282.31916 150.606667,1311.01924 150.606667,1311.01924 C144.473333,1295.98269 132.526667,1269.0422 156.726667,1239.64894 C158.673333,1236.95623 161.486667,1233.85028 164.1,1231.59746 C160.22,1206.57653 178.966667,1190.22028 197.22,1179.72936 C159.34,1178.08973 110.686667,1172.94425 101.06,1130.38068 C64.9266667,1125.42182 43.7533333,1149.36299 43.7533333,1149.36299 C47.6466667,1131.82035 55.1,1098.69461 96.7933333,1087.91042 C99.7933333,1086.73736 103.1,1086.36411 106.3,1085.79091 C114.18,1061.02326 142.433333,1049.21263 175.3,1056.58428 C183.233333,1058.42385 195.3,1060.46339 204.42,1061.84973 C196.846667,1051.74539 171.286667,1029.81708 184.9,1006.15584 C154.18,984.62745 123.406667,997.917734 123.406667,997.917734 C134.473333,983.481046 155.473333,957.287055 198.113333,964.752009 C206.273333,966.498275 215.1,969.510917 222.38,974.163183 C246.393333,966.684899 285.94,971.470468 335.846667,1019.72606 C372.873333,1053.10507 405.22,1083.95133 561.62,1097.40158 C636.233333,1101.46731 716.66,1095.37538 781.26,1065.99545 C730.94,1019.72606 714.513333,1070.44776 649.326667,1039.80146 C649.326667,1039.80146 668.273333,1036.21561 676.26,1024.48497 C681.5,1016.46015 683.633333,997.917734 666.06,990.346138 C624.366667,972.803495 611.166667,1032.81639 611.166667,1032.81639 C579.7,990.946 606.006667,954.101119 606.006667,954.101119 C606.006667,954.101119 579.206667,942.743725 548.033333,950.581927 C503.046667,961.939321 500.233333,990.946 500.233333,990.946 C476.34,968.937716 485.566667,939.744413 493.02,929.760037 C493.02,929.760037 452.246667,910.53778 429.806667,960.113073 C429.806667,960.113073 403.766667,915.509972 444.273333,894.941358 C463.42,884.86367 460.206667,869.253917 460.206667,869.253917 C458.86,869.827119 423.1,896.780936 355.273333,896.780936 C303.9,896.780936 278.633333,863.641872 281.26,864.02845 C338.886667,875.079248 342.66,833.06222 342.66,833.06222 C342.66,833.06222 256.686667,810.29411 130.113333,845.499367 C77.5533333,860.349294 58.9,845.499367 48.42,823.664376 C12.66,831.542569 2.55333333,862.175541 2.55333333,862.175541 C-0.553333333,845.499367 -6.36666667,814.759752 24.9,790.018761 C28.5933333,787.01945 33.1533333,784.406716 37.4333333,782.153899 C36.0733333,745.322349 94.06,713.90289 134.673333,716.222358 C134.673333,716.222358 27.82,658.142349 60.5666667,605.221156 C31.2333333,588.238385 3.83333333,599.782404 3.83333333,599.782404 C14.98,585.425697 35.8733333,559.058413 78.34,566.803303 C83.0866667,567.696431 88.14,569.349385 93.0066667,571.175633 C130.313333,544.608394 193.926667,587.571872 224.926667,613.539248 C224.926667,613.539248 216.673333,569.349385 243.38,547.994284 C223.273333,521.440376 193.753333,522.58678 193.753333,522.58678 C208.42,514.148716 235.42,497.672495 270.006667,518.24111 C276.113333,521.906936 281.833333,526.95911 286.3,532.197908 C319.913333,534.130798 335.846667,559.711596 348.593333,612.286202 C379.86,745.322349 627.78,796.337312 703.34,800.976248 C732.78,885.050294 708.78,940.024349 708.78,940.024349 C764.26,949.155587 791.073333,945.863009 791.073333,945.863009 C791.073333,945.863009 811.566667,1041.16115 870.54,1068.79481 C870.54,1068.79481 879.073333,1037.08208 880.82,1045.7201 C895.126667,1113.50455 961.66,1145.99043 961.66,1145.99043 C961.66,1145.99043 1003.23333,1132.78013 1046.64667,1094.60222 C1089.39333,1056.87754 1064.72667,1110.30528 1064.72667,1110.30528 C1064.72667,1110.30528 1161.86,1090.41651 1225.59333,976.096073 C1248.14,935.572037 1245.02,935.078817 1252.02,993.758688 C1351.7,912.97722 1388.31333,817.759064 1382.19333,773.822477 C1496.63333,817.759064 1883.84667,546.634596 2263.16667,534.71733 C2503.80667,527.225716 2604.06,596.276541 2723.18,637.773688 C2841.68667,679.470789 2912.48667,699.946092 2937.26,659.502037 C2960.11333,622.670486 2955.24667,544.008532 2783.98,520.467266 C2657.7,502.911294 2492.66,498.738917 2406.18,492.033789 C2347.80667,487.408183 2169.95333,474.011257 2173.34,310.822028 C2174.96667,213.764294 2237.94,182.051569 2237.94,182.051569 L2227.52667,215.110651 C2227.52667,215.110651 2256.84667,186.503881 2282.34,173.613505 C2311.36667,158.763578 2345.46,156.737376 2345.46,156.737376 C2345.46,156.737376 2379.36667,55.6938899 2464.58,56.7736422 C2531.99333,57.8400642 2571.11333,50.0551835 2597.84667,23.8878532 C2639.91333,-16.8228073 2688.68667,6.82510092 2688.68667,6.82510092 C2688.68667,6.82510092 2657.7,14.5033394 2633.60667,62.865578 C2605.42,118.719431 2554.72667,118.719431 2554.72667,118.719431 C2554.72667,118.719431 2578.60667,149.765642 2643.80667,107.175413 C2739.86,57.4268257 2789.88667,142.38067 2789.88667,142.38067 C2789.88667,142.38067 2751.54,126.87756 2713.15333,143.35378 C2682.06,156.737376 2674.12667,192.915743 2645.82,209.485275 C2601.36667,235.279358 2566.94,232.186734 2566.94,232.186734 C2566.94,232.186734 2572.68667,256.901064 2645.82,241.571248 C2734.72667,222.495624 2761.75333,271.551037 2761.75333,271.551037 C2761.75333,271.551037 2733.44667,262.713064 2705.96667,269.431523 C2679.12667,275.816725 2654.3,297.051853 2623.20667,310.822028 C2508.3,361.530394 2299.12667,229.933917 2281.94,322.539339 C2275.83333,353.972128 2301.36667,393.536385 2413.86,409.346092 C2547.72667,427.848514 2620.88667,417.677514 2810.60667,442.498486 C2876.66,450.736596 2964.94,484.862101 3012.84667,531.104826 C3145.54,658.448945 3034.02,740.670083 3034.02,740.670083 C3034.02,740.670083 3053.52667,699.172936 3035.48667,678.524339 C3035.48667,678.524339 3039.95333,733.218459 2976.42,764.437963 C2861.20667,820.371798 2589.31333,699.946092 2589.31333,699.946092 C2589.31333,699.946092 2535.98,856.256899 2968.46,896.207734 C3146.71333,912.97722 3236.26,880.50467 3305.92667,905.805532 C3358.87333,924.801174 3354.31333,997.917734 3354.31333,997.917734 Z M771.972,577.767454 C777.425333,553.34639 716.038667,556.518995 706.305333,450.370014 C706.118667,446.864151 755.572,500.198583 789.185333,380.252766 C793.265333,364.056482 801.025333,332.450399 829.798667,324.785491 C812.292,264.465995 850.572,191.642702 850.572,191.642702 C850.572,191.642702 864.465333,201.440454 884.958667,206.972518 C903.518667,212.291298 927.998667,212.411271 939.065333,230.140537 C939.065333,230.140537 965.492,219.476317 989.598667,177.97917 C1013.86533,136.268739 1054.38533,137.241849 1054.38533,137.241849 C1054.38533,137.241849 1042.63867,193.49561 1076.82533,194.761986 C1101.58533,195.735096 1117.91867,180.685216 1153.86533,163.529151 C1190.86533,145.293335 1237.19867,146.946289 1237.19867,146.946289 C1237.19867,146.946289 1195.332,211.331518 1230.892,230.833711 C1282.47867,258.747307 1316.772,202.520206 1358.15867,215.890472 C1358.15867,215.890472 1322.30533,269.611482 1355.71867,303.257096 C1392.052,339.342151 1434.99867,271.557702 1434.99867,271.557702 C1434.99867,271.557702 1461.412,366.775858 1439.852,419.030537 C1435.772,429.214867 1420.22533,452.689482 1420.22533,452.689482 C1420.22533,452.689482 1453.94533,510.676179 1436.46533,570.902362 C1402.35867,691.328069 1435.972,725.653528 1435.972,725.653528 C1435.972,725.653528 1352.90533,752.220766 1344.94533,673.47883 C1343.972,660.281858 1329.58533,663.694408 1329.58533,692.407821 C1329.58533,724.760399 1357.172,816.885931 1277.99867,902.399647 C1264.50533,835.894904 1227.292,859.756096 1204.75867,900.853335 C1135.59867,1027.47762 1101.87867,1024.67826 1101.87867,1024.67826 C1101.87867,1024.67826 1123.63867,959.813142 1076.052,1010.04162 C1007.372,1082.38502 968.505333,1083.74471 968.505333,1083.74471 C968.505333,1083.74471 925.478667,1052.81847 899.625333,968.157894 C889.732,935.592032 866.305333,983.780977 866.305333,983.780977 C866.305333,983.780977 829.598667,946.6295 837.252,867.994206 C837.252,867.994206 810.372,898.147289 768.878667,897.174179 C768.878667,897.174179 783.652,874.779317 763.718667,813.699995 C743.812,754.060344 768.385333,728.18628 756.438667,689.581803 C742.745333,645.471922 709.025333,640.219794 707.385333,565.95683 C707.385333,565.95683 764.398667,611.319757 771.972,577.767454 Z M906.332,841.02706 L906.332,841.600261 C906.732,879.071665 938.678667,901.346555 971.612,908.904821 C979.105333,910.837711 986.572,912.010775 993.958667,912.010775 L994.158667,912.010775 C1024.27867,912.010775 1050.892,894.254849 1060.59867,862.84872 C1070.212,831.042683 1067.19867,789.132298 1100.82533,764.138032 C1132.012,740.210188 1162.98533,738.37061 1183.78533,712.749821 L1193.67867,700.525959 L1178.51867,704.125133 C1178.51867,704.125133 1169.492,706.257977 1148.99867,708.177537 C1142.212,708.684087 1131.23867,710.030445 1119.172,710.030445 C1104.012,710.030445 1087.42533,708.177537 1074.87867,703.045381 C1062.43867,697.326693 1055.35867,690.061693 1054.95867,675.811628 C1054.95867,673.012271 1055.55867,669.986298 1056.052,666.400454 C1057.572,660.281858 1061.092,657.575812 1067.692,655.456298 C1074.38533,653.776683 1082.74533,653.216812 1090.22533,653.11017 C1110.83867,652.456986 1116.35867,636.433995 1115.87867,628.089243 C1115.87867,624.303445 1115.27867,621.677381 1115.27867,621.410775 L1113.63867,615.185537 L1107.91867,617.731619 C1107.91867,617.731619 1103.732,619.477885 1097.31867,621.410775 C1090.43867,622.970417 1080.79867,624.796665 1070.012,624.796665 C1063.812,624.796665 1057.02533,624.303445 1050.212,622.650491 C1035.82533,619.477885 1024.35867,612.199555 1017.07867,605.601069 C1009.50533,598.829289 1005.90533,593.283894 1005.90533,593.283894 L1001.26533,586.698739 L996.772,592.897317 C996.478667,593.590491 991.918667,600.175647 991.918667,609.200243 C991.918667,613.839179 993.385333,619.477885 997.252,624.596711 C1001.74533,630.235417 1008.91867,634.207839 1012.412,637.300463 C1019.31867,642.45928 1024.75867,648.364592 1024.75867,654.08328 C1024.35867,655.456298 1024.27867,656.802656 1023.78533,658.42895 C1017.75867,676.304849 1006.87867,680.450564 993.185333,681.050427 C973.065333,681.050427 948.878667,668.240032 944.612,665.893904 C934.985333,659.522032 927.998667,653.510078 923.438667,649.137748 C919.158667,644.498812 917.598667,641.672794 917.598667,641.672794 L910.318667,630.235417 L907.505333,643.698995 L907.505333,646.125106 C907.505333,652.816904 910.318667,672.612362 936.452,708.177537 C944.118667,718.081931 946.932,728.18628 946.932,737.570794 C947.505333,772.096206 907.212,806.794913 906.332,841.02706 Z M918.772,410.512491 C918.772,411.965491 918.572,413.791739 918.572,416.137867 C918.772,431.161087 921.892,470.53872 956.358667,492.533674 L958.398667,493.906693 C974.438667,503.491161 992.585333,505.064133 1004.83867,505.064133 L1013.38533,505.064133 C1012.892,508.823271 1011.14533,516.394867 1006.47867,529.405216 C1003.492,535.790417 1002.78533,541.509106 1002.78533,546.654592 C1002.78533,562.357656 1013.092,568.756188 1014.06533,569.049454 L1018.62533,571.475564 L1021.14533,567.103234 C1021.14533,566.823298 1042.812,533.177683 1047.39867,501.864867 C1047.772,498.265693 1048.052,495.359693 1048.052,492.253739 C1047.772,457.44839 1019.22533,444.637995 1018.74533,444.064794 L930.145333,400.901362 L927.212,399.155096 L919.945333,394.889408 L918.852,407.299894 L918.772,410.512491 Z M1121.31867,518.714335 C1111.892,542.868794 1111.092,572.528656 1111.092,583.499472 C1111.092,586.018894 1111.31867,587.551876 1111.31867,587.551876 L1111.31867,592.817335 L1116.652,592.817335 L1116.74533,592.817335 C1117.14533,592.897317 1117.62533,592.897317 1117.91867,592.897317 C1123.06533,592.897317 1139.492,587.951784 1143.18533,563.0375 C1145.42533,549.573922 1147.74533,542.562197 1148.99867,538.416482 C1157.34533,544.308463 1177.74533,556.518995 1200.772,556.71895 L1201.83867,556.71895 L1205.252,556.518995 C1252.652,553.82628 1275.492,510.102977 1278.38533,504.091023 L1279.94533,500.971739 L1279.94533,500.691803 L1281.59867,497.679161 L1285.39867,489.734317 L1272.852,490.014252 L1174.732,483.1225 L1172.212,483.1225 C1163.86533,482.842564 1134.332,486.135142 1121.31867,518.714335 Z M966.748,881.837697 C902.254667,860.789193 948.774667,800.576339 957.028,784.193431 C965.494667,766.744101 973.161333,745.029083 967.721333,725.326936 C966.174667,718.915073 959.841333,703.878523 950.908,692.934367 C983.054667,709.623872 1012.228,706.424606 1029.708,698.093183 C1043.48133,728.139624 1093.028,732.991844 1117.988,729.685936 C1108.468,737.550798 1055.44133,740.630092 1045.84133,816.492688 C1044.17467,830.63611 1037.96133,905.485606 966.748,881.837697 Z\" id=\"icon-lion_path-1\" />\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g transform=\"translate(1726.585683, 841.921158) rotate(-4.000000) translate(-1726.585683, -841.921158) translate(46.585683, 115.421158)\">\n            <g transform=\"translate(0.000000, 13.330275)\">\n                <mask id=\"icon-lion_mask-2\" fill=\"white\">\n                    <use xlink:href=\"#icon-lion_path-1\" />\n                </mask>\n                <use fill=\"#E30521\" xlink:href=\"#icon-lion_path-1\" />\n                <g mask=\"url(#icon-lion_mask-2)\" fill=\"#E11917\">\n                    <g transform=\"translate(0.000000, -13.330275)\">\n                        <rect x=\"0\" y=\"0\" width=\"3360\" height=\"1453\" rx=\"1\" />\n                    </g>\n                </g>\n            </g>\n        </g>\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-map-maker-faq",
  "use": "icon-map-maker-faq-usage",
  "viewBox": "0 0 14 20.363",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 20.363\" id=\"icon-map-maker-faq\">\n  <path id=\"icon-map-maker-faq_np_map-marker_888711_000000\" d=\"M34.082,16.668a6.98,6.98,0,0,0-7,7c0,3.881,7,13.363,7,13.363s7-9.482,7-13.363A6.98,6.98,0,0,0,34.082,16.668Zm0,10.181a3.182,3.182,0,1,1,3.182-3.182A3.151,3.151,0,0,1,34.082,26.849Z\" transform=\"translate(-27.082 -16.668)\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-minus-faq",
  "use": "icon-minus-faq-usage",
  "viewBox": "0 0 16 1.6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 1.6\" id=\"icon-minus-faq\">\n  <path id=\"icon-minus-faq_np_minus_705084_000000\" d=\"M20.8,47a.8.8,0,1,0,0,1.6H35.2a.8.8,0,0,0,0-1.6Z\" transform=\"translate(-20 -47)\" fill=\"#695225\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-minus-icon",
  "use": "icon-minus-icon-usage",
  "viewBox": "0 0 15.575 2.245",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.575 2.245\" id=\"icon-minus-icon\">\n  <path id=\"icon-minus-icon_np_minus_2076551_000000\" d=\"M1.132,45.038h13.31a1.122,1.122,0,1,0,0-2.245H1.132a1.122,1.122,0,1,0,0,2.245Z\" transform=\"translate(0 -42.793)\" fill=\"#4c4c4c\" fill-rule=\"evenodd\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-minus",
  "use": "icon-minus-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\" id=\"icon-minus\"><path d=\"M12.5,0A12.5,12.5,0,1,0,25,12.5,12.52,12.52,0,0,0,12.5,0Zm0,22A9.5,9.5,0,1,1,22,12.5,9.51,9.51,0,0,1,12.5,22Z\" /><polygon points=\"18.12 11 18.12 14 6.88 13.99 6.88 11 18.12 11\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-notice",
  "use": "icon-notice-usage",
  "viewBox": "0 0 16 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 14\" id=\"icon-notice\">\n  <title>notice</title>\n  <path d=\"M8,0,0,14H16ZM8,2l6.28,11H1.72Zm-.79,8.42H8.84V12H7.21ZM8.85,5V6.84l-.36,3H7.57l-.37-3V5Z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-np_email",
  "use": "icon-np_email-usage",
  "viewBox": "0 0 22.736 18.327",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22.736 18.327\" id=\"icon-np_email\">\n  <path id=\"icon-np_email_np_email_5520895_000000\" d=\"M21.28,26.42l9.143-4.586v10.5a1.888,1.888,0,0,1-1.885,1.886H9.572a1.887,1.887,0,0,1-1.885-1.886v-10.5L16.83,26.42a4.918,4.918,0,0,0,4.45,0Zm7.259-10.526H9.572A1.887,1.887,0,0,0,7.687,17.78v2.105l9.922,4.978a3.2,3.2,0,0,0,2.891,0l9.922-4.978V17.78a1.886,1.886,0,0,0-1.884-1.886Z\" transform=\"translate(-7.687 -15.894)\" fill=\"#202020\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-np_phone",
  "use": "icon-np_phone-usage",
  "viewBox": "0 0 22.239 22.239",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22.239 22.239\" id=\"icon-np_phone\">\n  <path id=\"icon-np_phone_np_phone_5518539_000000\" d=\"M11.182,8.136l3.976,3.976a.548.548,0,0,1,.029.743c-.682.8-1.723,2.012-2.256,2.656a1.624,1.624,0,0,0-.359,1.349.67.67,0,0,0,.02.078,12.868,12.868,0,0,0,3.282,4.635,12.17,12.17,0,0,0,5.16,3.326.481.481,0,0,0,.067.014,1.636,1.636,0,0,0,1.409-.461l2.106-2.106a.544.544,0,0,1,.772,0l3.919,3.919a.547.547,0,0,1,0,.773c-.57.569-1.364,1.363-2.062,2.058h0a3.821,3.821,0,0,1-3.536,1.027,21.862,21.862,0,0,1-10.338-6.045A21.931,21.931,0,0,1,7.32,13.738,3.827,3.827,0,0,1,8.348,10.2L10.41,8.136a.547.547,0,0,1,.772,0Z\" transform=\"translate(-7.228 -7.977)\" fill=\"#202020\" fill-rule=\"evenodd\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-outlook",
  "use": "icon-outlook-usage",
  "viewBox": "12 12 37 37",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"12 12 37 37\" id=\"icon-outlook\">\n\n    <g stroke=\"none\" stroke-width=\"1\">\n        <g fill=\"#0072C6\" transform=\"translate(13.000000, 12.000000)\">\n            <path d=\"M22,8 L22,15.3641625 L24.4012995,16.9846178 C24.4646305,17.0044139 24.6018474,17.0058287 24.6651784,16.9846178 L35,9.51723249 C35,8.63347624 34.2307922,8 33.7967131,8 L22,8 Z\" id=\"icon-outlook_path3\" /><path d=\"M22.0013192,17.3927246 L24.1923898,18.9414533 C24.5010656,19.1749163 24.8730597,18.9414533 24.8730597,18.9414533 C24.5023848,19.1749163 35,12 35,12 L35,24.9924895 C35,26.4068412 34.1201421,27 33.1307973,27 L22,27 L22,17.3927246 L22.0013192,17.3927246 Z\" id=\"icon-outlook_path5\" /><path d=\"M10.5517241,14 C9.77103448,14 9.14896552,14.3677843 8.68965517,15.1019703 C8.23034483,15.8361562 8,16.8081576 8,18.0179744 C8,19.2457656 8.23034483,20.2163844 8.68965517,20.9298306 C9.14896552,21.6446595 9.75172414,22 10.4965517,22 C11.2648276,22 11.8744828,21.6529554 12.3241379,20.9588662 C12.7737931,20.264777 13,19.3010716 13,18.0691324 C13,16.7846526 12.782069,15.7849983 12.3448276,15.0701694 C11.9075862,14.3567231 11.3103448,14 10.5517241,14 Z\" id=\"icon-outlook_path25\" /><path d=\"M1.2033385e-15,4.05633803 L1.2033385e-15,31.6056338 L21,36 L21,0 L0,4.05633803 L1.2033385e-15,4.05633803 Z M14.0523871,22.488338 C13.1649677,23.6538592 12.0079355,24.2379718 10.5799355,24.2379718 C9.18851613,24.2379718 8.05587097,23.6727887 7.17929032,22.5437746 C6.30406452,21.4134085 5.86509677,19.9423099 5.86509677,18.1277746 C5.86509677,16.211831 6.30948387,14.6623099 7.1996129,13.4792113 C8.08974194,12.2961127 9.26845161,11.7038873 10.7357419,11.7038873 C12.1217419,11.7038873 13.2435484,12.2690704 14.0984516,13.4021408 C14.9547097,14.5352113 15.3828387,16.0279437 15.3828387,17.8816901 C15.3841935,19.7868169 14.9398065,21.3228169 14.0523871,22.488338 Z\" id=\"icon-outlook_path27\" />\n        </g>\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-pdf",
  "use": "icon-pdf-usage",
  "viewBox": "0 0 21 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 24\" id=\"icon-pdf\"><path d=\"M5.55,12.3c0-.65-.44-1-1.23-1a2.65,2.65,0,0,0-.65.06V13.4a2.4,2.4,0,0,0,.52,0C5,13.44,5.55,13,5.55,12.3Zm4.84-1a3.23,3.23,0,0,0-.71.06v4.6a2.82,2.82,0,0,0,.55,0,2.17,2.17,0,0,0,2.35-2.46A2,2,0,0,0,10.39,11.29Zm9.28-2.7H19.1V5.8a.41.41,0,0,0,0-.05.47.47,0,0,0-.11-.3L14.41.16h0L14.32.08l0,0L14.2,0H2.83A.94.94,0,0,0,1.9.94V8.58H1.33A1.34,1.34,0,0,0,0,9.93v7a1.34,1.34,0,0,0,1.33,1.35H1.9v4.79a.94.94,0,0,0,.93.94H18.17a.94.94,0,0,0,.93-.94V18.27h.57A1.34,1.34,0,0,0,21,16.93v-7A1.34,1.34,0,0,0,19.67,8.58ZM2.83.94H13.6V5.76a.47.47,0,0,0,.46.47h4.11V8.58H2.83ZM14.24,13.47a3.58,3.58,0,0,1-1.15,2.85,4.94,4.94,0,0,1-3.2.91,13.49,13.49,0,0,1-1.78-.1v-6.9a13.88,13.88,0,0,1,2.12-.15,4.43,4.43,0,0,1,2.84.75A3.12,3.12,0,0,1,14.24,13.47ZM2.12,17.15V10.21a12.75,12.75,0,0,1,2.12-.15,3.3,3.3,0,0,1,2.12.56,2.06,2.06,0,0,1,.74,1.63,2.26,2.26,0,0,1-.64,1.67,3.19,3.19,0,0,1-2.26.74,3.88,3.88,0,0,1-.54,0v2.51H2.12ZM18.17,22.8H2.83V18.27H18.17V22.8Zm1.35-11.38H16.85V13h2.49v1.29H16.85v2.83H15.27v-7h4.24Z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-phone-faq",
  "use": "icon-phone-faq-usage",
  "viewBox": "0 0 14 13.997",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 13.997\" id=\"icon-phone-faq\">\n  <path id=\"icon-phone-faq_np_phone_56382_000000\" d=\"M18.858,16.771a3.669,3.669,0,0,1-3.26,2.235c-.179,0-2.957.147-6.952-3.642A11.078,11.078,0,0,1,5,8.413c-.033-.607.14-2.129,2.234-3.26.259-.14.774-.2.907-.069.059.059,1.817,2.951,1.863,3.047a.647.647,0,0,1,.069.283.822.822,0,0,1-.283.5,4.862,4.862,0,0,1-.614.545,6.035,6.035,0,0,0-.614.525.754.754,0,0,0-.283.456c.013.309.266,1.413,2.191,3.106a14.848,14.848,0,0,0,2.943,2.2.674.674,0,0,0,.223.049.755.755,0,0,0,.456-.282c.185-.188.806-1.04,1.005-1.229A.82.82,0,0,1,15.6,14a.644.644,0,0,1,.282.069c.1.046,2.992,1.741,3.047,1.8.15.153.044.634-.069.906\" transform=\"translate(-5.001 -5.01)\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-play-circle",
  "use": "icon-play-circle-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12 12\" id=\"icon-play-circle\">\n<path d=\"M6,11c2.8,0,5-2.3,5-5S8.8,1,6,1S1,3.2,1,6S3.2,11,6,11z M6,12c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S9.3,12,6,12z M4.2,2.6\n\tL9,6L4.2,9.4V2.6z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 60 60",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 60 60\" id=\"icon-play\"><title>play</title><path d=\"M30,60A30,30,0,1,1,60,30,30,30,0,0,1,30,60Zm0-4.44A25.56,25.56,0,1,0,4.44,30,25.57,25.57,0,0,0,30,55.56Z\" fill=\"#fff\" fill-opacity=\"0.4\" /><path d=\"M30,55.56A25.56,25.56,0,1,0,4.44,30,25.57,25.57,0,0,0,30,55.56Z\" fill=\"#091a34\" fill-opacity=\"0.4\" /><path d=\"M21.56,14.2,44,29.88,21.56,45.73Z\" fill=\"#fff\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-plus-icon",
  "use": "icon-plus-icon-usage",
  "viewBox": "0 0 15.575 15.575",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.575 15.575\" id=\"icon-plus-icon\">\n  <path id=\"icon-plus-icon_np_minus_2076551_000000\" d=\"M1.132,45.038h13.31a1.122,1.122,0,1,0,0-2.245H1.132a1.122,1.122,0,1,0,0,2.245Z\" transform=\"translate(15.575 51.703) rotate(180)\" fill=\"#4c4c4c\" fill-rule=\"evenodd\" />\n  <path id=\"icon-plus-icon_np_minus_2076551_000000-2\" data-name=\"np_minus_2076551_000000\" d=\"M1.132,45.038h13.31a1.122,1.122,0,1,0,0-2.245H1.132a1.122,1.122,0,1,0,0,2.245Z\" transform=\"translate(51.703) rotate(90)\" fill=\"#4c4c4c\" fill-rule=\"evenodd\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\" id=\"icon-plus\"><path d=\"M12.5,0A12.5,12.5,0,1,0,25,12.5,12.52,12.52,0,0,0,12.5,0Zm0,22A9.5,9.5,0,1,1,22,12.5,9.51,9.51,0,0,1,12.5,22Z\" /><polygon class=\"plus-1\" id=\"icon-plus_plus-1\" points=\"18.12 11 18.12 14 6.88 13.99 6.88 11 18.12 11\" /><polygon class=\"plus-2\" id=\"icon-plus_plus-2\" points=\"11 6.88 14 6.88 13.99 18.12 11 18.12 11 6.88\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-png",
  "use": "icon-png-usage",
  "viewBox": "0 0 21 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 24\" id=\"icon-png\"><path d=\"M5,12.06c0-.61-.42-1-1.16-1a2.48,2.48,0,0,0-.61.06v2a2.24,2.24,0,0,0,.5,0C4.47,13.14,5,12.74,5,12.06ZM19.67,8.58H19.1V5.8a.41.41,0,0,0,0-.05.47.47,0,0,0-.11-.3L14.41.16h0L14.32.08l0,0L14.2,0H2.83A.94.94,0,0,0,1.9.94V8.58H1.33A1.34,1.34,0,0,0,0,9.93v7a1.34,1.34,0,0,0,1.33,1.35H1.9v4.79a.94.94,0,0,0,.93.94H18.17a.94.94,0,0,0,.93-.94V18.27h.57A1.34,1.34,0,0,0,21,16.93v-7A1.34,1.34,0,0,0,19.67,8.58ZM2.83.94H13.6V5.76a.47.47,0,0,0,.46.47h4.11V8.58H2.83Zm5.9,13.69v2H7.37V10H9.1l1.36,2.43a19.25,19.25,0,0,1,1.07,2.27h0a24.92,24.92,0,0,1-.13-2.76V10H12.8v6.63H11.24l-1.4-2.56A24.73,24.73,0,0,1,8.7,11.73h0C8.71,12.62,8.73,13.55,8.73,14.63Zm-7,2V10.09a12,12,0,0,1,2-.14,3.11,3.11,0,0,1,2,.53A2,2,0,0,1,6.43,12a2.13,2.13,0,0,1-.6,1.57,3,3,0,0,1-2.13.7,3.73,3.73,0,0,1-.51,0v2.37H1.72ZM18.17,22.8H2.83V18.27H18.17V22.8Zm1.38-6.48a7.26,7.26,0,0,1-2.19.37,3.62,3.62,0,0,1-2.66-.9,3.23,3.23,0,0,1-.92-2.41c0-2.2,1.59-3.46,3.74-3.46a4.46,4.46,0,0,1,1.82.32L19,11.46a3.59,3.59,0,0,0-1.53-.29,2,2,0,0,0-2.17,2.14,2,2,0,0,0,2.06,2.17,2,2,0,0,0,.73-.1V14h-1V12.83h2.44v3.49Z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-quote-close",
  "use": "icon-quote-close-usage",
  "viewBox": "0 0 33 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 33 25\" id=\"icon-quote-close\"><path d=\"M20.93,25l-.8-1.64a32.27,32.27,0,0,0,4.72-3.88q3.2-3.29,3.2-6,0-1.64-1.45-1.64H25a5.3,5.3,0,0,1-3.42-1.1,5.63,5.63,0,0,1-2-4.71A5.87,5.87,0,0,1,21.3,1.62,5.91,5.91,0,0,1,25.59,0a6.4,6.4,0,0,1,5.56,2.57A9.89,9.89,0,0,1,33,8.51a15.49,15.49,0,0,1-4.58,10.9A33.72,33.72,0,0,1,20.93,25ZM1.31,25l-.8-1.64a32.27,32.27,0,0,0,4.72-3.88q3.2-3.29,3.2-6,0-1.64-1.45-1.64H5.38A5.3,5.3,0,0,1,2,10.75,5.63,5.63,0,0,1,0,6,5.87,5.87,0,0,1,1.67,1.62,5.91,5.91,0,0,1,6,0a6.4,6.4,0,0,1,5.56,2.57,9.89,9.89,0,0,1,1.85,5.93A15.49,15.49,0,0,1,8.8,19.4,33.72,33.72,0,0,1,1.31,25Z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-quote-open",
  "use": "icon-quote-open-usage",
  "viewBox": "0 0 33 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 33 25\" id=\"icon-quote-open\"><path d=\"M12.07,0l.8,1.64A32.27,32.27,0,0,0,8.14,5.53q-3.2,3.29-3.2,6,0,1.64,1.45,1.64H8a5.3,5.3,0,0,1,3.42,1.1,5.63,5.63,0,0,1,2,4.71,5.87,5.87,0,0,1-1.67,4.42A5.91,5.91,0,0,1,7.41,25a6.4,6.4,0,0,1-5.56-2.57A9.89,9.89,0,0,1,0,16.49,15.49,15.49,0,0,1,4.58,5.6,33.72,33.72,0,0,1,12.07,0ZM31.69,0l.8,1.64a32.27,32.27,0,0,0-4.72,3.88q-3.2,3.29-3.2,6,0,1.64,1.45,1.64h1.6A5.3,5.3,0,0,1,31,14.25,5.63,5.63,0,0,1,33,19a5.66,5.66,0,0,1-6,6,6.4,6.4,0,0,1-5.56-2.57,9.89,9.89,0,0,1-1.85-5.93A15.49,15.49,0,0,1,24.2,5.6,33.72,33.72,0,0,1,31.69,0Z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-quote-square-close",
  "use": "icon-quote-square-close-usage",
  "viewBox": "0 0 16 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 12\" id=\"icon-quote-square-close\">\n<path id=\"icon-quote-square-close__x201C_-copy\" d=\"M16,0v6.4L13.3,12h-3.3l1.3-5.3H9V0H16z M7,0v6.4L4.3,12H1.1l1.3-5.3H0V0H7z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-quote-square-open",
  "use": "icon-quote-square-open-usage",
  "viewBox": "0 0 16 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 12\" id=\"icon-quote-square-open\">\n<path id=\"icon-quote-square-open__x201C_-copy\" d=\"M0,12V5.6L2.7,0h3.3L4.6,5.3H7V12H0z M9,12V5.6L11.7,0h3.3l-1.3,5.3H16V12H9z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-r-arrow-bold",
  "use": "icon-r-arrow-bold-usage",
  "viewBox": "0 0 28.345 21.221",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28.345 21.221\" id=\"icon-r-arrow-bold\">\n  <path id=\"icon-r-arrow-bold_Path_18\" data-name=\"Path 18\" d=\"M12.5,45.832H37.045V49H12.5Z\" transform=\"translate(-12.5 -36.806)\" fill=\"#222\" />\n  <path id=\"icon-r-arrow-bold_Path_19\" data-name=\"Path 19\" d=\"M55.55,43.3l-2.218-2.218,8.394-8.392L53.332,24.3l2.218-2.218,10.609,10.61Z\" transform=\"translate(-37.813 -22.082)\" fill=\"#222\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-reddit",
  "use": "icon-reddit-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol role=\"img\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-reddit\"><title>Reddit</title><path d=\"M12 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0zm5.01 4.744c.688 0 1.25.561 1.25 1.249a1.25 1.25 0 0 1-2.498.056l-2.597-.547-.8 3.747c1.824.07 3.48.632 4.674 1.488.308-.309.73-.491 1.207-.491.968 0 1.754.786 1.754 1.754 0 .716-.435 1.333-1.01 1.614a3.111 3.111 0 0 1 .042.52c0 2.694-3.13 4.87-7.004 4.87-3.874 0-7.004-2.176-7.004-4.87 0-.183.015-.366.043-.534A1.748 1.748 0 0 1 4.028 12c0-.968.786-1.754 1.754-1.754.463 0 .898.196 1.207.49 1.207-.883 2.878-1.43 4.744-1.487l.885-4.182a.342.342 0 0 1 .14-.197.35.35 0 0 1 .238-.042l2.906.617a1.214 1.214 0 0 1 1.108-.701zM9.25 12C8.561 12 8 12.562 8 13.25c0 .687.561 1.248 1.25 1.248.687 0 1.248-.561 1.248-1.249 0-.688-.561-1.249-1.249-1.249zm5.5 0c-.687 0-1.248.561-1.248 1.25 0 .687.561 1.248 1.249 1.248.688 0 1.249-.561 1.249-1.249 0-.687-.562-1.249-1.25-1.249zm-5.466 3.99a.327.327 0 0 0-.231.094.33.33 0 0 0 0 .463c.842.842 2.484.913 2.961.913.477 0 2.105-.056 2.961-.913a.361.361 0 0 0 .029-.463.33.33 0 0 0-.464 0c-.547.533-1.684.73-2.512.73-.828 0-1.979-.196-2.512-.73a.326.326 0 0 0-.232-.095z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-redirect-icon-cwm",
  "use": "icon-redirect-icon-cwm-usage",
  "viewBox": "0 0 14.559 14.559",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14.559 14.559\" id=\"icon-redirect-icon-cwm\">\n  <path id=\"icon-redirect-icon-cwm_np_external_1355974_000000\" d=\"M14.56.125c0-.029,0-.029-.029-.058,0-.029,0-.029-.029-.058,0-.029-.029-.029-.029-.058s-.029-.029-.029-.058a.5.5,0,0,0-.175-.175L14.24-.31c-.029,0-.029-.029-.058-.029s-.029,0-.058-.029c-.029,0-.029,0-.058-.029h-5.3a.584.584,0,0,0-.582.582.584.584,0,0,0,.582.582H12.58L11.415,1.931H.583A.584.584,0,0,0,0,2.513V13.579a.584.584,0,0,0,.582.582H11.648a.584.584,0,0,0,.582-.582V2.8L13.4,1.64V5.454a.582.582,0,1,0,1.165,0V.125ZM11.066,13.054h-9.9v-9.9H10.25L5.708,7.7a.563.563,0,0,0,0,.816.563.563,0,0,0,.816,0l4.542-4.542Z\" transform=\"translate(-0.001 0.398)\" fill=\"#005999\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-reply",
  "use": "icon-reply-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-reply\">\n<path d=\"M2.8,16l-0.3-3.2H0V0h16v12.8H7.3L2.8,16z M1,11.8h2.4l0.2,2.4l3.3-2.4H15V1H1V11.8z M3,5h2v2H3V5z M7,5h2v2H7V5z M11,5h2v2\n\th-2V5z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-report",
  "use": "icon-report-usage",
  "viewBox": "0 0 16 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 14\" id=\"icon-report\">\n<path d=\"M16,14H0L8,0L16,14z M1.7,13h12.6L8,2L1.7,13z M7.6,9.8l-0.4-3V5h1.6v1.8l-0.4,3H7.6z M7.2,12v-1.6h1.6V12H7.2z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 24.96 33.7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24.96 33.7\" id=\"icon-search\"><path d=\"M23.08,19.1a12.51,12.51,0,0,0-4-17.2,12.45,12.45,0,0,0-17.2,4,12.51,12.51,0,0,0,4,17.2,12.29,12.29,0,0,0,6.6,1.9,8.63,8.63,0,0,0,2.8-.4L19,33.7h4.4l-4.3-10.6A11.78,11.78,0,0,0,23.08,19.1Zm-15.2.8A8.75,8.75,0,0,1,4,14.4a8.12,8.12,0,0,1,1.1-6.6,8.63,8.63,0,0,1,7.4-4.1A9.4,9.4,0,0,1,17.08,5,8.75,8.75,0,0,1,21,10.5a8.12,8.12,0,0,1-1.1,6.6,8.63,8.63,0,0,1-7.4,4.1A7.68,7.68,0,0,1,7.88,19.9Z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-snapchat",
  "use": "icon-snapchat-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol role=\"img\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-snapchat\"><title>Snapchat</title><path d=\"M12.206.793c.99 0 4.347.276 5.93 3.821.529 1.193.403 3.219.299 4.847l-.003.06c-.012.18-.022.345-.03.51.075.045.203.09.401.09.3-.016.659-.12 1.033-.301.165-.088.344-.104.464-.104.182 0 .359.029.509.09.45.149.734.479.734.838.015.449-.39.839-1.213 1.168-.089.029-.209.075-.344.119-.45.135-1.139.36-1.333.81-.09.224-.061.524.12.868l.015.015c.06.136 1.526 3.475 4.791 4.014.255.044.435.27.42.509 0 .075-.015.149-.045.225-.24.569-1.273.988-3.146 1.271-.059.091-.12.375-.164.57-.029.179-.074.36-.134.553-.076.271-.27.405-.555.405h-.03c-.135 0-.313-.031-.538-.074-.36-.075-.765-.135-1.273-.135-.3 0-.599.015-.913.074-.6.104-1.123.464-1.723.884-.853.599-1.826 1.288-3.294 1.288-.06 0-.119-.015-.18-.015h-.149c-1.468 0-2.427-.675-3.279-1.288-.599-.42-1.107-.779-1.707-.884-.314-.045-.629-.074-.928-.074-.54 0-.958.089-1.272.149-.211.043-.391.074-.54.074-.374 0-.523-.224-.583-.42-.061-.192-.09-.389-.135-.567-.046-.181-.105-.494-.166-.57-1.918-.222-2.95-.642-3.189-1.226-.031-.063-.052-.15-.055-.225-.015-.243.165-.465.42-.509 3.264-.54 4.73-3.879 4.791-4.02l.016-.029c.18-.345.224-.645.119-.869-.195-.434-.884-.658-1.332-.809-.121-.029-.24-.074-.346-.119-1.107-.435-1.257-.93-1.197-1.273.09-.479.674-.793 1.168-.793.146 0 .27.029.383.074.42.194.789.3 1.104.3.234 0 .384-.06.465-.105l-.046-.569c-.098-1.626-.225-3.651.307-4.837C7.392 1.077 10.739.807 11.727.807l.419-.015h.06z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-squad-stats-bg",
  "use": "icon-squad-stats-bg-usage",
  "viewBox": "0 0 1736 334",
  "content": "<symbol viewBox=\"0 0 1736 334\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-squad-stats-bg\">\n    <defs>\n        <path d=\"M4218.43846,1186.24272 C4288.99061,1220.52337 4273.91141,1291.03341 4273.91141,1291.03341 C4273.91141,1291.03341 4268.57122,1281.28977 4259.22589,1278.34127 C4249.48688,1275.49443 4242.50355,1279.93414 4242.50355,1279.93414 C4273.05561,1309.50396 4240.00462,1362.6449 4240.00462,1362.6449 C4223.2994,1320.73879 4192.25098,1336.14221 4192.25098,1336.14221 C4192.25098,1336.14221 4205.08798,1360.18781 4209.21293,1384.8265 C4215.80259,1428.20687 4183.6074,1449.91399 4183.6074,1449.91399 C4183.6074,1449.91399 4185.11361,1405.29661 4147.49264,1414.6505 C4128.92178,1419.22577 4089.74325,1452.4897 4106.32866,1550.62083 C4106.32866,1550.62083 4078.51516,1546.29974 4058.79753,1528.67647 C4038.85739,1510.81596 4029.63186,1484.31327 4029.63186,1484.31327 C4029.63186,1484.31327 4017.9074,1621.50367 3929.46903,1607.42199 C3954.04761,1580.08897 3939.84133,1543.09705 3939.84133,1543.09705 C3939.84133,1543.09705 3905.93453,1555.06054 3890.70129,1571.93821 C3883.08467,1580.95319 3875.98153,1597.96643 3872.23313,1629.63748 C3862.1518,1723.07472 3827.47479,1760.77836 3783.21281,1769.43748 C3776.45199,1770.89479 3761.37279,1771.36927 3746.68727,1769.43748 C3724.11126,1800.95603 3736.69152,1832.88127 3736.69152,1832.88127 C3721.61233,1820.30774 3693.6619,1796.92301 3704.03419,1751.6617 C3704.03419,1750.42468 3704.39363,1749.18767 3704.90711,1747.95065 C3703.26397,1746.35777 3701.41545,1744.3921 3699.90924,1741.93501 C3688.18478,1723.44752 3699.05344,1700.50337 3702.52799,1693.74214 C3700.28579,1696.82621 3691.69356,1703.96025 3659.48125,1715.55094 C3617.99206,1731.44577 3591.03436,1716.78796 3575.57861,1693.74214 C3537.8036,1708.14577 3531.31664,1743.2737 3531.31664,1743.2737 C3524.70986,1724.93872 3513.63581,1690.28527 3546.54988,1657.49581 C3549.90461,1653.78476 3553.87553,1650.32788 3558.25722,1647.24381 C3557.14468,1637.51712 3556.75101,1607.42199 3586.6869,1578.73334 C3588.33003,1576.6321 3589.18583,1576.00512 3582.93849,1574.63254 C3568.33855,1570.70119 3548.26148,1563.05879 3542.06549,1537.28476 C3503.77699,1535.82745 3483.18645,1561.83872 3483.18645,1561.83872 C3486.42137,1542.58868 3491.67598,1507.1049 3536.29739,1492.09123 C3539.90887,1490.60003 3543.7942,1489.83748 3547.25163,1489.00716 C3599.78064,1409.95661 3743.67485,1468.77428 3743.67485,1468.77428 C3745.30087,1468.53705 3771.52258,1462.60614 3791.30868,1438.93334 C3822.87058,1400.97552 3821.99767,1357.10374 3749.52852,1351.66425 C3600.39681,1340.80221 3018.53839,1336.26083 2714.98613,1093.19523 C2714.98613,1093.19523 2487.18929,1052.50919 2145.87913,1365.72897 C1641.17964,1828.94992 1347.00695,1741.93501 1191.52521,1723.07472 C1116.67694,1714.05974 1061.83727,1729.22592 1017.66088,1771.62345 C990.360857,1712.09407 1060.19414,1664.51123 1060.19414,1664.51123 C1011.55047,1658.58032 937.249909,1652.93748 903.445809,1714.05974 C878.387985,1690.1497 883.728177,1647.00657 883.728177,1647.00657 C883.728177,1647.00657 816.633457,1699.01217 765.131413,1673.62788 C765.131413,1673.62788 806.552133,1644.68505 785.841773,1625.57057 C768.879817,1609.52323 734.836093,1603.86345 690.437189,1688.53988 C690.437189,1688.53988 666.115353,1669.69654 672.123069,1634.07719 C676.230909,1609.16737 687.082453,1597.55974 687.082453,1597.55974 C687.082453,1597.55974 647.544493,1630.24752 593.697557,1623.21516 C593.697557,1623.21516 642.426809,1596.10243 620.723721,1573.17523 C590.428401,1541.36861 474.690009,1536.5561 398.626505,1579.20781 C372.832693,1594.00119 319.208265,1659.34287 246.756237,1612.25145 C246.636425,1612.25145 246.122945,1612.37007 245.746393,1612.37007 C192.019269,1624.33356 180.277693,1670.79799 180.277693,1670.79799 C174.543833,1648.48083 163.692289,1607.2017 204.736457,1569.97254 C207.355205,1567.39683 210.846869,1564.77028 214.201605,1562.19457 C208.347933,1530.15072 232.909393,1509.18919 256.717749,1495.26003 C201.980781,1493.32825 92.3699172,1491.46425 93.7563132,1416.87036 C93.7563132,1416.87036 93.9788212,1415.00636 94.6121132,1411.54948 C51.6167212,1404.05959 23.5464812,1429.95225 23.5464812,1429.95225 C31.0090572,1408.14345 44.2226092,1367.05072 98.9938092,1358.20519 C101.236005,1357.81545 103.341273,1357.45959 105.840209,1357.20541 C125.403797,1307.41967 235.528141,1322.9417 246.756237,1324.8057 C233.919237,1301.60737 228.288073,1275.86723 256.717749,1247.75472 C256.238501,1246.00934 255.605209,1244.06061 254.989033,1242.34912 C237.410901,1194.64767 192.755257,1189.07261 192.755257,1189.07261 C213.089065,1180.95574 250.384829,1166.28097 290.145297,1199.68047 C295.382793,1203.88294 300.260853,1209.44105 304.231765,1214.84665 C325.318677,1205.72999 351.249417,1209.18687 397.000485,1268.6993 C453.757141,1336.63363 440.303965,1362.40767 673.218493,1381.38657 C849.325017,1383.7081 912.192085,1345.4961 912.192085,1345.4961 C912.192085,1345.4961 860.142329,1345.4961 848.315173,1316.53632 C848.315173,1316.53632 867.536441,1318.40032 880.373441,1302.23436 C888.982789,1291.03341 886.603665,1270.44468 866.663525,1258.22701 C825.876097,1233.57137 797.703161,1330.22825 797.703161,1330.22825 C746.560553,1301.38708 763.779249,1244.67065 763.779249,1244.67065 C763.779249,1244.67065 744.951649,1254.66847 722.872009,1260.19268 C665.122625,1274.25741 635.700221,1241.97632 635.700221,1241.97632 C635.700221,1241.97632 709.162093,1235.06257 704.164221,1200.42607 C704.164221,1200.42607 601.297061,1245.78905 524.086785,1187.10694 C524.086785,1187.10694 619.628297,1175.51625 594.929909,1143.98076 C581.596545,1127.34032 551.284109,1151.62316 452.148237,1140.54083 C386.662421,1133.49152 372.593069,1095.78788 372.593069,1095.78788 C431.814429,1103.04054 451.018581,1088.61996 450.385289,1069.52243 C449.751997,1046.35799 413.859745,1055.61021 373.825421,1047.20527 C317.599361,1034.98759 284.411437,1004.18076 155.596421,1058.54177 C127.782921,1070.50527 83.4011332,1070.87807 55.5876332,1030.80207 C15.0398292,1042.91807 3.2126732,1077.6393 3.2126732,1077.6393 C-0.9122828,1056.69472 -7.7586828,1017.63545 32.1558292,986.08301 C34.2610972,984.33763 36.1267412,983.354793 38.0095012,982.236393 C38.3689372,924.299884 119.293385,908.523665 133.773521,900.779593 C133.773521,900.779593 32.9945132,819.153338 81.9976212,750.62592 C81.5183732,749.998938 81.2616332,749.541411 81.0391252,748.914429 C47.9710132,705.398502 0.5939252,713.176465 0.5939252,713.176465 C18.9251612,698.874502 52.7121452,672.490429 103.341273,694.672029 C113.816265,699.501484 124.924549,706.008538 132.387125,714.159302 C179.028225,671.151738 255.981761,739.052175 292.284797,775.78992 C292.284797,775.78992 272.943717,693.316393 320.064065,666.695084 C301.116653,623.653629 260.089601,618.502211 260.089601,618.502211 C280.183785,610.605629 317.958797,596.066429 357.240017,628.974502 C366.225917,636.599956 374.561409,646.597775 378.943105,656.968393 C459.627929,680.268393 446.893625,752.981338 452.148237,825.084247 C457.522661,901.508247 702.675129,981.507738 903.925057,1018.61828 C908.289637,1074.69079 937.729157,1122.13807 958.062965,1174.41479 C994.229073,1255.87159 985.722421,1333.68512 985.722421,1333.68512 C985.722421,1333.68512 1035.63268,1300.15007 1058.56812,1301.60737 C1079.15867,1302.47159 1065.32894,1336.26083 1074.67427,1381.74243 C1083.50613,1426.35981 1126.02227,1452.8625 1126.02227,1452.8625 L1138.63677,1425.98701 C1138.63677,1425.98701 1155.85546,1481.70367 1210.59243,1517.83137 C1210.59243,1517.83137 1259.35591,1425.49559 1294.01581,1432.64657 C1320.20329,1437.69632 1322.18875,1496.12425 1322.18875,1496.12425 C1576.10461,1372.86301 1558.26974,1135.71137 1583.94374,1266.63196 C1583.94374,1266.63196 1755.2749,1171.70352 1749.79778,935.043302 C1936.72161,983.473411 2217.04746,721.903375 2841.55895,719.327665 C3078.39305,718.582065 3407.10583,836.064902 3571.23115,892.747447 C3734.70607,949.836684 3839.71273,948.345484 3874.11589,892.747447 C3904.78776,843.198938 3890.95803,765.317629 3655.13378,732.884029 C3480.53347,709.092611 3282.7752,698.874502 3163.68207,689.605338 C3082.63781,683.725265 2949.08167,672.981847 2879.74475,592.101193 C2837.34842,543.196611 2817.40828,477.092393 2826.10321,413.140247 C2842.70573,285.659593 2915.41449,226.147156 2917.38283,222.334429 C2917.38283,222.334429 2906.92496,240.330502 2907.66095,253.531011 C2907.66095,253.531011 2963.54469,202.592975 3030.99884,202.592975 C3030.99884,202.592975 2979.3941,218.877556 2967.03635,253.531011 C2967.03635,253.531011 2998.82076,231.451084 3046.11227,217.996393 C3098.31607,202.592975 3119.07778,202.592975 3119.07778,202.592975 C3119.07778,202.592975 3118.54718,94.853775 3245.12,102.88592 C3536.29739,120.627811 3525.48008,0.9420655 3525.48008,0.9420655 C3525.48008,0.9420655 3576.34883,29.0376291 3561.25252,81.9243927 C3535.6641,176.090284 3413.98646,163.65232 3413.98646,163.65232 C3413.98646,163.65232 3475.45001,211.963811 3549.90461,181.394211 C3628.43282,148.994502 3650.64939,61.0814836 3650.64939,61.0814836 C3650.64939,61.0814836 3732.94312,293.437556 3481.3208,351.391011 C3394.38864,371.725556 3326.57505,339.918938 3326.57505,339.918938 C3326.57505,339.918938 3335.38979,399.465265 3425.95054,391.839811 C3460.85007,389.094647 3494.02087,378.876538 3526.06203,365.540465 C3556.37446,353.102502 3604.1281,323.905484 3678.97637,338.30912 C3678.97637,338.30912 3644.29935,353.949775 3601.03011,388.603229 C3543.28072,434.440684 3494.65417,461.570356 3413.59279,479.464756 C3268.07256,511.491665 3115.31226,431.644684 3123.06581,310.467738 C3123.06581,310.467738 2971.52074,313.043447 2952.05985,424.595375 C2940.09577,492.156902 2982.37229,558.362793 3144.35811,581.154429 C3329.15956,607.521556 3808.78411,571.410793 4030.8471,754.811447 C4110.19687,820.288684 4088.63071,891.290138 4088.63071,891.290138 C4088.63071,891.290138 4076.39277,848.028393 4055.69953,830.252611 C4035.26303,812.629338 4023.52145,813.62912 4023.52145,813.62912 C4023.52145,813.62912 4080.02137,844.063156 4080.02137,928.63792 C4080.02137,985.32047 4028.38239,1023.27828 4028.38239,1023.27828 C4028.38239,1023.27828 4047.94598,983.863156 4043.20485,955.750647 C4039.23394,930.976393 4025.91769,921.215811 4025.91769,921.215811 C4025.91769,921.215811 4022.52872,1144.9297 3609.2629,1065.09967 C3457.3584,1035.97043 3357.10999,985.82883 3357.10999,985.82883 C3339.41205,974.746502 3376.55377,1143.37072 3840.08928,1189.07261 C3909.16945,1195.98636 3977.01728,1189.58097 4037.35118,1183.41283 C4114.42453,1175.39763 4178.67799,1167.39937 4218.43846,1186.24272 Z M3499.63321,1397.9694 C3499.63321,1397.9694 3538.05863,1485.84852 3419.47898,1504.72576 C3378.79425,1511.26671 3131.63921,1513.33405 3119.16165,1685.17791 C3072.81152,1661.75929 3066.17051,1611.36351 3067.81365,1602.60271 C2887.35966,1612.82081 2879.99978,1702.07252 2879.99978,1702.07252 C2879.99978,1702.07252 2847.32533,1679.63674 2865.77638,1605.07674 C2874.12899,1571.76198 2791.95507,1683.70365 2770.61142,1610.60096 C2716.74737,1621.58161 2722.36142,1689.499 2722.36142,1689.499 C2722.36142,1689.499 2684.32967,1680.11121 2684.58641,1620.7174 C2684.58641,1620.7174 2687.56459,1581.25143 2657.13234,1613.68503 C2641.0433,1631.79972 2637.05527,1653.13405 2636.54179,1652.50707 C2605.75011,1631.42692 2599.17757,1581.25143 2599.17757,1581.25143 C2590.07185,1620.7174 2516.96942,1703.52983 2446.65689,1673.21441 L2446.51996,1673.21441 C2438.16735,1705.13965 2453.98254,1729.04969 2453.98254,1729.04969 C2436.02785,1719.57718 2402.89128,1701.81834 2402.89128,1654.72692 C2402.89128,1646.37281 2404.26056,1637.71369 2406.86219,1629.59681 C2379.20273,1558.34118 2449.75489,1525.29754 2429.55801,1533.58387 C2347.5039,1567.5934 2295.48838,1537.00685 2287.76906,1494.35514 C2252.0822,1495.59216 2232.77535,1519.77332 2232.77535,1519.77332 C2236.04451,1499.91325 2242.00088,1463.05689 2287.76906,1448.02627 L2287.76906,1447.77209 L2287.76906,1447.67041 C2294.49565,1414.72845 2321.57316,1389.71696 2402.89128,1378.61769 C2389.79754,1350.89492 2396.50701,1326.84932 2411.08984,1310.22583 C2411.82583,1308.59907 2413.09241,1308.1246 2413.8284,1307.36205 C2382.81421,1285.68881 2350.61901,1296.16111 2350.61901,1296.16111 C2364.46586,1281.62191 2389.79754,1253.8822 2436.52422,1266.20154 C2447.92347,1269.28561 2459.75063,1274.72511 2467.58976,1282.23194 C2488.67667,1279.02925 2512.36521,1280.38489 2536.82398,1284.57041 C2625.84429,1299.3638 2676.33649,1374.92358 2676.33649,1374.92358 C2676.33649,1374.92358 2705.51927,1376.1606 2772.59688,1381.09172 C2829.13103,1385.75172 2873.35877,1398.32525 2873.35877,1398.32525 C2664.23548,1316.37703 2718.86975,1185.59201 2718.86975,1185.59201 C2718.86975,1185.59201 2926.1274,1381.09172 3499.63321,1397.9694 Z M853.817967,808.928451 C853.817967,808.928451 951.943995,858.138051 968.409587,764.938051 C968.409587,764.938051 875.640867,784.28976 860.784179,649.675069 C859.791451,645.252305 929.248179,771.953469 974.519999,504.588087 C978.268403,483.643505 992.731423,442.466051 1029.25697,432.112378 C1028.40117,300.818996 1126.03083,231.444305 1127.2803,231.698487 C1180.54529,248.20336 1186.39896,306.749905 1186.39896,306.749905 C1186.39896,306.749905 1217.43027,303.072742 1228.43586,266.572233 C1253.37387,182.40416 1326.93844,190.148233 1326.93844,190.148233 C1302.47968,244.865105 1351.10623,282.721251 1351.10623,282.721251 C1351.10623,282.721251 1422.94208,235.782342 1469.95974,222.209033 C1514.23883,209.381324 1562.74557,221.090633 1573.34038,224.293324 C1544.29452,247.711942 1532.19351,281.992596 1546.65653,306.749905 C1563.49868,335.099651 1608.51376,339.793542 1647.65805,317.374705 C1670.25117,304.665615 1685.84384,285.449469 1691.81733,266.09776 C1721.89014,347.944305 1683.96108,392.053324 1683.96108,392.053324 C1760.77769,424.961396 1785.33915,356.806778 1785.33915,356.806778 C1785.33915,356.806778 1823.50783,448.871433 1802.55785,517.263287 C1790.9532,557.220669 1758.89493,578.165251 1758.89493,578.165251 C1758.89493,578.165251 1832.71624,580.164815 1812.39955,672.483651 C1778.85219,827.043142 1815.89121,868.101978 1815.89121,868.101978 C1815.89121,868.101978 1803.29384,878.455651 1767.28177,868.593396 C1731.08143,858.748087 1695.54862,838.888015 1695.54862,838.888015 C1708.16311,1094.54409 1615.87364,1149.51514 1615.87364,1149.51514 C1615.87364,1149.51514 1596.54967,1114.50583 1583.21631,1100.71223 C1513.72535,1028.21958 1549.89146,1267.8622 1358.3463,1387.66656 C1358.3463,1387.66656 1326.30515,1360.90969 1302.47968,1356.60554 C1265.57758,1349.6918 1215.9583,1411.44103 1215.9583,1411.44103 C1169.3172,1376.56729 1206.21929,1302.83761 1206.21929,1302.83761 C1206.21929,1302.83761 1166.56152,1311.97121 1151.3454,1335.27121 C1141.24696,1349.81041 1136.00946,1356.60554 1136.00946,1356.60554 C1136.00946,1356.60554 1139.24438,1349.33594 1138.74802,1297.53369 C1137.61836,1257.2374 1118.92769,1238.63129 1088.99181,1238.25849 C1067.54546,1238.13987 1044.98657,1250.83201 1044.98657,1250.83201 C1044.98657,1250.83201 1045.72256,1202.26634 1012.67156,1131.51907 C980.767339,1054.46809 948.589259,991.12598 972.397615,888.080669 C972.397615,888.080669 889.984075,944.881833 853.817967,808.928451 Z M1148.60684,1102.16954 L1148.60684,1102.79652 C1149.34282,1150.12518 1190.25006,1178.59354 1232.04734,1188.4558 C1242.00885,1190.92983 1251.71362,1192.26852 1260.73375,1192.26852 L1261.58955,1192.26852 C1300.23748,1192.26852 1334.04158,1169.73107 1346.51914,1129.90925 C1358.85978,1089.4774 1355.36812,1036.11616 1398.51755,1004.54678 C1438.27802,974.23136 1478.31234,971.757324 1504.85926,939.103433 L1516.96027,923.801687 L1497.91016,928.37696 C1497.91016,928.37696 1486.42533,930.850996 1460.39189,933.325033 C1451.64562,934.189251 1437.28529,935.392378 1421.58992,935.392378 C1402.64251,935.392378 1381.05923,933.325033 1364.97019,926.88576 C1349.49733,919.98896 1339.77544,910.380887 1339.77544,892.147578 C1339.77544,888.453469 1340.03218,884.742415 1341.14472,880.556887 C1342.75362,872.423069 1347.51187,868.966196 1356.00141,866.746342 C1364.09728,863.916451 1375.05152,863.797833 1384.5509,863.441978 C1411.09781,862.425251 1418.33788,842.090705 1417.58478,831.381178 C1417.58478,826.687287 1416.95148,823.230415 1416.60916,823.010124 L1414.60659,815.215215 L1407.2296,818.316233 C1407.2296,818.316233 1402.38577,820.654705 1393.39987,823.010124 C1384.91033,824.941905 1372.84355,827.415942 1358.72285,827.415942 C1350.7468,827.415942 1342.27438,826.687287 1333.40829,824.586051 C1314.83743,820.654705 1300.37441,811.012742 1290.75522,802.760305 C1280.67389,794.287578 1276.54894,787.238269 1276.54894,787.238269 L1270.31871,778.867215 L1264.70466,787.119651 C1264.44792,787.729687 1258.59425,795.880451 1258.59425,807.58976 C1258.59425,813.622342 1260.3572,820.654705 1265.57758,827.297324 C1271.5853,834.719433 1280.29734,838.888015 1284.90154,843.19216 C1293.39108,850.241469 1300.63115,857.121324 1300.37441,864.662051 C1300.37441,866.373542 1300.37441,868.101978 1299.50149,870.304887 C1292.14161,892.77456 1278.05514,898.55296 1260.10046,898.92576 C1233.91298,899.179942 1203.10418,882.52256 1198.22612,879.557105 C1185.28642,871.796087 1176.30052,863.916451 1170.78917,858.138051 C1165.31205,852.461324 1163.18967,849.004451 1162.59061,849.004451 L1153.84433,834.312742 L1150.45536,851.325978 C1150.45536,851.95296 1149.97612,852.952742 1149.97612,854.426996 C1149.97612,863.289469 1153.84433,888.199287 1187.01514,933.325033 C1196.87396,946.373033 1200.48543,958.590705 1200.48543,970.910051 C1201.35835,1015.01907 1149.83919,1058.68751 1148.60684,1102.16954 Z M1164.57606,555.373615 C1164.31932,557.220669 1164.31932,559.084669 1164.31932,562.389033 C1164.31932,581.401833 1168.80372,631.289251 1212.68914,659.164524 L1215.56463,661.028524 C1235.89844,673.347869 1259.48428,675.313542 1275.19677,675.313542 C1279.30461,675.313542 1283.0359,674.957687 1286.15101,674.957687 C1285.67176,680.007433 1283.0359,689.751069 1276.80568,706.137324 C1273.69056,714.525324 1272.57802,721.676305 1272.57802,728.081687 C1272.57802,747.924815 1285.89427,755.821396 1286.76719,756.431433 L1292.51816,759.634124 L1296.11252,754.09296 C1296.24945,753.601542 1323.56659,710.593978 1329.43738,670.738269 C1330.17336,666.705251 1330.80666,662.638342 1330.80666,658.774778 C1330.17336,614.530196 1293.39108,598.025324 1292.75779,597.906705 L1178.78234,542.817033 L1175.68435,540.834415 L1165.6886,535.157687 L1164.67876,551.188087 L1164.57606,555.373615 Z M1411.47436,774.800305 L1411.47436,780.205905 L1411.86803,786.611287 L1418.83424,786.611287 L1419.09098,786.611287 C1419.60446,786.763796 1419.82697,786.763796 1420.08371,786.763796 C1426.58779,786.763796 1448.03414,780.832887 1452.3816,748.907651 C1455.75346,731.894415 1458.3722,722.40496 1460.39189,717.728015 C1471.2092,724.980669 1497.39668,740.519651 1526.81909,740.756887 L1528.18837,740.756887 L1532.19351,740.401033 C1593.17782,737.096669 1622.49753,681.363069 1626.2117,673.839287 L1627.71791,670.145178 L1628.09446,669.890996 L1630.33666,665.468233 L1634.95798,655.86016 L1619.3653,655.944887 L1493.42577,647.573833 C1493.42577,647.573833 1491.66282,647.217978 1489.78006,647.217978 C1478.80871,647.217978 1441.41025,651.030705 1424.44829,692.818196 C1412.60402,722.760815 1411.47436,760.98976 1411.47436,774.800305 Z M1226.07214,1154.46152 C1143.28205,1127.33185 1203.11958,1050.67061 1213.49188,1029.96327 C1224.82267,1007.76472 1234.8013,980.058902 1227.2018,955.38632 C1225.07941,946.879702 1217.47991,927.900793 1205.61852,914.090247 C1247.38156,935.407629 1284.45482,930.866247 1306.89389,920.851484 C1324.84858,958.589011 1388.43452,964.740211 1420.21893,960.571629 C1408.27196,970.925302 1340.03047,974.263556 1327.45021,1071.0221 C1325.46475,1088.98428 1317.59139,1183.91272 1226.07214,1154.46152 Z\" id=\"icon-squad-stats-bg_path-1\" />\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <rect fill=\"#E11917\" fill-rule=\"nonzero\" x=\"0\" y=\"-25\" width=\"1737\" height=\"556\" rx=\"1\" />\n        <g transform=\"translate(-326.000000, -1438.000000)\">\n            <g fill=\"#E30521\">\n                <path d=\"M4218.43846,1186.24272 C4288.99061,1220.52337 4273.91141,1291.03341 4273.91141,1291.03341 C4273.91141,1291.03341 4268.57122,1281.28977 4259.22589,1278.34127 C4249.48688,1275.49443 4242.50355,1279.93414 4242.50355,1279.93414 C4273.05561,1309.50396 4240.00462,1362.6449 4240.00462,1362.6449 C4223.2994,1320.73879 4192.25098,1336.14221 4192.25098,1336.14221 C4192.25098,1336.14221 4205.08798,1360.18781 4209.21293,1384.8265 C4215.80259,1428.20687 4183.6074,1449.91399 4183.6074,1449.91399 C4183.6074,1449.91399 4185.11361,1405.29661 4147.49264,1414.6505 C4128.92178,1419.22577 4089.74325,1452.4897 4106.32866,1550.62083 C4106.32866,1550.62083 4078.51516,1546.29974 4058.79753,1528.67647 C4038.85739,1510.81596 4029.63186,1484.31327 4029.63186,1484.31327 C4029.63186,1484.31327 4017.9074,1621.50367 3929.46903,1607.42199 C3954.04761,1580.08897 3939.84133,1543.09705 3939.84133,1543.09705 C3939.84133,1543.09705 3905.93453,1555.06054 3890.70129,1571.93821 C3883.08467,1580.95319 3875.98153,1597.96643 3872.23313,1629.63748 C3862.1518,1723.07472 3827.47479,1760.77836 3783.21281,1769.43748 C3776.45199,1770.89479 3761.37279,1771.36927 3746.68727,1769.43748 C3724.11126,1800.95603 3736.69152,1832.88127 3736.69152,1832.88127 C3721.61233,1820.30774 3693.6619,1796.92301 3704.03419,1751.6617 C3704.03419,1750.42468 3704.39363,1749.18767 3704.90711,1747.95065 C3703.26397,1746.35777 3701.41545,1744.3921 3699.90924,1741.93501 C3688.18478,1723.44752 3699.05344,1700.50337 3702.52799,1693.74214 C3700.28579,1696.82621 3691.69356,1703.96025 3659.48125,1715.55094 C3617.99206,1731.44577 3591.03436,1716.78796 3575.57861,1693.74214 C3537.8036,1708.14577 3531.31664,1743.2737 3531.31664,1743.2737 C3524.70986,1724.93872 3513.63581,1690.28527 3546.54988,1657.49581 C3549.90461,1653.78476 3553.87553,1650.32788 3558.25722,1647.24381 C3557.14468,1637.51712 3556.75101,1607.42199 3586.6869,1578.73334 C3588.33003,1576.6321 3589.18583,1576.00512 3582.93849,1574.63254 C3568.33855,1570.70119 3548.26148,1563.05879 3542.06549,1537.28476 C3503.77699,1535.82745 3483.18645,1561.83872 3483.18645,1561.83872 C3486.42137,1542.58868 3491.67598,1507.1049 3536.29739,1492.09123 C3539.90887,1490.60003 3543.7942,1489.83748 3547.25163,1489.00716 C3599.78064,1409.95661 3743.67485,1468.77428 3743.67485,1468.77428 C3745.30087,1468.53705 3771.52258,1462.60614 3791.30868,1438.93334 C3822.87058,1400.97552 3821.99767,1357.10374 3749.52852,1351.66425 C3600.39681,1340.80221 3018.53839,1336.26083 2714.98613,1093.19523 C2714.98613,1093.19523 2487.18929,1052.50919 2145.87913,1365.72897 C1641.17964,1828.94992 1347.00695,1741.93501 1191.52521,1723.07472 C1116.67694,1714.05974 1061.83727,1729.22592 1017.66088,1771.62345 C990.360857,1712.09407 1060.19414,1664.51123 1060.19414,1664.51123 C1011.55047,1658.58032 937.249909,1652.93748 903.445809,1714.05974 C878.387985,1690.1497 883.728177,1647.00657 883.728177,1647.00657 C883.728177,1647.00657 816.633457,1699.01217 765.131413,1673.62788 C765.131413,1673.62788 806.552133,1644.68505 785.841773,1625.57057 C768.879817,1609.52323 734.836093,1603.86345 690.437189,1688.53988 C690.437189,1688.53988 666.115353,1669.69654 672.123069,1634.07719 C676.230909,1609.16737 687.082453,1597.55974 687.082453,1597.55974 C687.082453,1597.55974 647.544493,1630.24752 593.697557,1623.21516 C593.697557,1623.21516 642.426809,1596.10243 620.723721,1573.17523 C590.428401,1541.36861 474.690009,1536.5561 398.626505,1579.20781 C372.832693,1594.00119 319.208265,1659.34287 246.756237,1612.25145 C246.636425,1612.25145 246.122945,1612.37007 245.746393,1612.37007 C192.019269,1624.33356 180.277693,1670.79799 180.277693,1670.79799 C174.543833,1648.48083 163.692289,1607.2017 204.736457,1569.97254 C207.355205,1567.39683 210.846869,1564.77028 214.201605,1562.19457 C208.347933,1530.15072 232.909393,1509.18919 256.717749,1495.26003 C201.980781,1493.32825 92.3699172,1491.46425 93.7563132,1416.87036 C93.7563132,1416.87036 93.9788212,1415.00636 94.6121132,1411.54948 C51.6167212,1404.05959 23.5464812,1429.95225 23.5464812,1429.95225 C31.0090572,1408.14345 44.2226092,1367.05072 98.9938092,1358.20519 C101.236005,1357.81545 103.341273,1357.45959 105.840209,1357.20541 C125.403797,1307.41967 235.528141,1322.9417 246.756237,1324.8057 C233.919237,1301.60737 228.288073,1275.86723 256.717749,1247.75472 C256.238501,1246.00934 255.605209,1244.06061 254.989033,1242.34912 C237.410901,1194.64767 192.755257,1189.07261 192.755257,1189.07261 C213.089065,1180.95574 250.384829,1166.28097 290.145297,1199.68047 C295.382793,1203.88294 300.260853,1209.44105 304.231765,1214.84665 C325.318677,1205.72999 351.249417,1209.18687 397.000485,1268.6993 C453.757141,1336.63363 440.303965,1362.40767 673.218493,1381.38657 C849.325017,1383.7081 912.192085,1345.4961 912.192085,1345.4961 C912.192085,1345.4961 860.142329,1345.4961 848.315173,1316.53632 C848.315173,1316.53632 867.536441,1318.40032 880.373441,1302.23436 C888.982789,1291.03341 886.603665,1270.44468 866.663525,1258.22701 C825.876097,1233.57137 797.703161,1330.22825 797.703161,1330.22825 C746.560553,1301.38708 763.779249,1244.67065 763.779249,1244.67065 C763.779249,1244.67065 744.951649,1254.66847 722.872009,1260.19268 C665.122625,1274.25741 635.700221,1241.97632 635.700221,1241.97632 C635.700221,1241.97632 709.162093,1235.06257 704.164221,1200.42607 C704.164221,1200.42607 601.297061,1245.78905 524.086785,1187.10694 C524.086785,1187.10694 619.628297,1175.51625 594.929909,1143.98076 C581.596545,1127.34032 551.284109,1151.62316 452.148237,1140.54083 C386.662421,1133.49152 372.593069,1095.78788 372.593069,1095.78788 C431.814429,1103.04054 451.018581,1088.61996 450.385289,1069.52243 C449.751997,1046.35799 413.859745,1055.61021 373.825421,1047.20527 C317.599361,1034.98759 284.411437,1004.18076 155.596421,1058.54177 C127.782921,1070.50527 83.4011332,1070.87807 55.5876332,1030.80207 C15.0398292,1042.91807 3.2126732,1077.6393 3.2126732,1077.6393 C-0.9122828,1056.69472 -7.7586828,1017.63545 32.1558292,986.08301 C34.2610972,984.33763 36.1267412,983.354793 38.0095012,982.236393 C38.3689372,924.299884 119.293385,908.523665 133.773521,900.779593 C133.773521,900.779593 32.9945132,819.153338 81.9976212,750.62592 C81.5183732,749.998938 81.2616332,749.541411 81.0391252,748.914429 C47.9710132,705.398502 0.5939252,713.176465 0.5939252,713.176465 C18.9251612,698.874502 52.7121452,672.490429 103.341273,694.672029 C113.816265,699.501484 124.924549,706.008538 132.387125,714.159302 C179.028225,671.151738 255.981761,739.052175 292.284797,775.78992 C292.284797,775.78992 272.943717,693.316393 320.064065,666.695084 C301.116653,623.653629 260.089601,618.502211 260.089601,618.502211 C280.183785,610.605629 317.958797,596.066429 357.240017,628.974502 C366.225917,636.599956 374.561409,646.597775 378.943105,656.968393 C459.627929,680.268393 446.893625,752.981338 452.148237,825.084247 C457.522661,901.508247 702.675129,981.507738 903.925057,1018.61828 C908.289637,1074.69079 937.729157,1122.13807 958.062965,1174.41479 C994.229073,1255.87159 985.722421,1333.68512 985.722421,1333.68512 C985.722421,1333.68512 1035.63268,1300.15007 1058.56812,1301.60737 C1079.15867,1302.47159 1065.32894,1336.26083 1074.67427,1381.74243 C1083.50613,1426.35981 1126.02227,1452.8625 1126.02227,1452.8625 L1138.63677,1425.98701 C1138.63677,1425.98701 1155.85546,1481.70367 1210.59243,1517.83137 C1210.59243,1517.83137 1259.35591,1425.49559 1294.01581,1432.64657 C1320.20329,1437.69632 1322.18875,1496.12425 1322.18875,1496.12425 C1576.10461,1372.86301 1558.26974,1135.71137 1583.94374,1266.63196 C1583.94374,1266.63196 1755.2749,1171.70352 1749.79778,935.043302 C1936.72161,983.473411 2217.04746,721.903375 2841.55895,719.327665 C3078.39305,718.582065 3407.10583,836.064902 3571.23115,892.747447 C3734.70607,949.836684 3839.71273,948.345484 3874.11589,892.747447 C3904.78776,843.198938 3890.95803,765.317629 3655.13378,732.884029 C3480.53347,709.092611 3282.7752,698.874502 3163.68207,689.605338 C3082.63781,683.725265 2949.08167,672.981847 2879.74475,592.101193 C2837.34842,543.196611 2817.40828,477.092393 2826.10321,413.140247 C2842.70573,285.659593 2915.41449,226.147156 2917.38283,222.334429 C2917.38283,222.334429 2906.92496,240.330502 2907.66095,253.531011 C2907.66095,253.531011 2963.54469,202.592975 3030.99884,202.592975 C3030.99884,202.592975 2979.3941,218.877556 2967.03635,253.531011 C2967.03635,253.531011 2998.82076,231.451084 3046.11227,217.996393 C3098.31607,202.592975 3119.07778,202.592975 3119.07778,202.592975 C3119.07778,202.592975 3118.54718,94.853775 3245.12,102.88592 C3536.29739,120.627811 3525.48008,0.9420655 3525.48008,0.9420655 C3525.48008,0.9420655 3576.34883,29.0376291 3561.25252,81.9243927 C3535.6641,176.090284 3413.98646,163.65232 3413.98646,163.65232 C3413.98646,163.65232 3475.45001,211.963811 3549.90461,181.394211 C3628.43282,148.994502 3650.64939,61.0814836 3650.64939,61.0814836 C3650.64939,61.0814836 3732.94312,293.437556 3481.3208,351.391011 C3394.38864,371.725556 3326.57505,339.918938 3326.57505,339.918938 C3326.57505,339.918938 3335.38979,399.465265 3425.95054,391.839811 C3460.85007,389.094647 3494.02087,378.876538 3526.06203,365.540465 C3556.37446,353.102502 3604.1281,323.905484 3678.97637,338.30912 C3678.97637,338.30912 3644.29935,353.949775 3601.03011,388.603229 C3543.28072,434.440684 3494.65417,461.570356 3413.59279,479.464756 C3268.07256,511.491665 3115.31226,431.644684 3123.06581,310.467738 C3123.06581,310.467738 2971.52074,313.043447 2952.05985,424.595375 C2940.09577,492.156902 2982.37229,558.362793 3144.35811,581.154429 C3329.15956,607.521556 3808.78411,571.410793 4030.8471,754.811447 C4110.19687,820.288684 4088.63071,891.290138 4088.63071,891.290138 C4088.63071,891.290138 4076.39277,848.028393 4055.69953,830.252611 C4035.26303,812.629338 4023.52145,813.62912 4023.52145,813.62912 C4023.52145,813.62912 4080.02137,844.063156 4080.02137,928.63792 C4080.02137,985.32047 4028.38239,1023.27828 4028.38239,1023.27828 C4028.38239,1023.27828 4047.94598,983.863156 4043.20485,955.750647 C4039.23394,930.976393 4025.91769,921.215811 4025.91769,921.215811 C4025.91769,921.215811 4022.52872,1144.9297 3609.2629,1065.09967 C3457.3584,1035.97043 3357.10999,985.82883 3357.10999,985.82883 C3339.41205,974.746502 3376.55377,1143.37072 3840.08928,1189.07261 C3909.16945,1195.98636 3977.01728,1189.58097 4037.35118,1183.41283 C4114.42453,1175.39763 4178.67799,1167.39937 4218.43846,1186.24272 Z M3499.63321,1397.9694 C3499.63321,1397.9694 3538.05863,1485.84852 3419.47898,1504.72576 C3378.79425,1511.26671 3131.63921,1513.33405 3119.16165,1685.17791 C3072.81152,1661.75929 3066.17051,1611.36351 3067.81365,1602.60271 C2887.35966,1612.82081 2879.99978,1702.07252 2879.99978,1702.07252 C2879.99978,1702.07252 2847.32533,1679.63674 2865.77638,1605.07674 C2874.12899,1571.76198 2791.95507,1683.70365 2770.61142,1610.60096 C2716.74737,1621.58161 2722.36142,1689.499 2722.36142,1689.499 C2722.36142,1689.499 2684.32967,1680.11121 2684.58641,1620.7174 C2684.58641,1620.7174 2687.56459,1581.25143 2657.13234,1613.68503 C2641.0433,1631.79972 2637.05527,1653.13405 2636.54179,1652.50707 C2605.75011,1631.42692 2599.17757,1581.25143 2599.17757,1581.25143 C2590.07185,1620.7174 2516.96942,1703.52983 2446.65689,1673.21441 L2446.51996,1673.21441 C2438.16735,1705.13965 2453.98254,1729.04969 2453.98254,1729.04969 C2436.02785,1719.57718 2402.89128,1701.81834 2402.89128,1654.72692 C2402.89128,1646.37281 2404.26056,1637.71369 2406.86219,1629.59681 C2379.20273,1558.34118 2449.75489,1525.29754 2429.55801,1533.58387 C2347.5039,1567.5934 2295.48838,1537.00685 2287.76906,1494.35514 C2252.0822,1495.59216 2232.77535,1519.77332 2232.77535,1519.77332 C2236.04451,1499.91325 2242.00088,1463.05689 2287.76906,1448.02627 L2287.76906,1447.77209 L2287.76906,1447.67041 C2294.49565,1414.72845 2321.57316,1389.71696 2402.89128,1378.61769 C2389.79754,1350.89492 2396.50701,1326.84932 2411.08984,1310.22583 C2411.82583,1308.59907 2413.09241,1308.1246 2413.8284,1307.36205 C2382.81421,1285.68881 2350.61901,1296.16111 2350.61901,1296.16111 C2364.46586,1281.62191 2389.79754,1253.8822 2436.52422,1266.20154 C2447.92347,1269.28561 2459.75063,1274.72511 2467.58976,1282.23194 C2488.67667,1279.02925 2512.36521,1280.38489 2536.82398,1284.57041 C2625.84429,1299.3638 2676.33649,1374.92358 2676.33649,1374.92358 C2676.33649,1374.92358 2705.51927,1376.1606 2772.59688,1381.09172 C2829.13103,1385.75172 2873.35877,1398.32525 2873.35877,1398.32525 C2664.23548,1316.37703 2718.86975,1185.59201 2718.86975,1185.59201 C2718.86975,1185.59201 2926.1274,1381.09172 3499.63321,1397.9694 Z M853.817967,808.928451 C853.817967,808.928451 951.943995,858.138051 968.409587,764.938051 C968.409587,764.938051 875.640867,784.28976 860.784179,649.675069 C859.791451,645.252305 929.248179,771.953469 974.519999,504.588087 C978.268403,483.643505 992.731423,442.466051 1029.25697,432.112378 C1028.40117,300.818996 1126.03083,231.444305 1127.2803,231.698487 C1180.54529,248.20336 1186.39896,306.749905 1186.39896,306.749905 C1186.39896,306.749905 1217.43027,303.072742 1228.43586,266.572233 C1253.37387,182.40416 1326.93844,190.148233 1326.93844,190.148233 C1302.47968,244.865105 1351.10623,282.721251 1351.10623,282.721251 C1351.10623,282.721251 1422.94208,235.782342 1469.95974,222.209033 C1514.23883,209.381324 1562.74557,221.090633 1573.34038,224.293324 C1544.29452,247.711942 1532.19351,281.992596 1546.65653,306.749905 C1563.49868,335.099651 1608.51376,339.793542 1647.65805,317.374705 C1670.25117,304.665615 1685.84384,285.449469 1691.81733,266.09776 C1721.89014,347.944305 1683.96108,392.053324 1683.96108,392.053324 C1760.77769,424.961396 1785.33915,356.806778 1785.33915,356.806778 C1785.33915,356.806778 1823.50783,448.871433 1802.55785,517.263287 C1790.9532,557.220669 1758.89493,578.165251 1758.89493,578.165251 C1758.89493,578.165251 1832.71624,580.164815 1812.39955,672.483651 C1778.85219,827.043142 1815.89121,868.101978 1815.89121,868.101978 C1815.89121,868.101978 1803.29384,878.455651 1767.28177,868.593396 C1731.08143,858.748087 1695.54862,838.888015 1695.54862,838.888015 C1708.16311,1094.54409 1615.87364,1149.51514 1615.87364,1149.51514 C1615.87364,1149.51514 1596.54967,1114.50583 1583.21631,1100.71223 C1513.72535,1028.21958 1549.89146,1267.8622 1358.3463,1387.66656 C1358.3463,1387.66656 1326.30515,1360.90969 1302.47968,1356.60554 C1265.57758,1349.6918 1215.9583,1411.44103 1215.9583,1411.44103 C1169.3172,1376.56729 1206.21929,1302.83761 1206.21929,1302.83761 C1206.21929,1302.83761 1166.56152,1311.97121 1151.3454,1335.27121 C1141.24696,1349.81041 1136.00946,1356.60554 1136.00946,1356.60554 C1136.00946,1356.60554 1139.24438,1349.33594 1138.74802,1297.53369 C1137.61836,1257.2374 1118.92769,1238.63129 1088.99181,1238.25849 C1067.54546,1238.13987 1044.98657,1250.83201 1044.98657,1250.83201 C1044.98657,1250.83201 1045.72256,1202.26634 1012.67156,1131.51907 C980.767339,1054.46809 948.589259,991.12598 972.397615,888.080669 C972.397615,888.080669 889.984075,944.881833 853.817967,808.928451 Z M1148.60684,1102.16954 L1148.60684,1102.79652 C1149.34282,1150.12518 1190.25006,1178.59354 1232.04734,1188.4558 C1242.00885,1190.92983 1251.71362,1192.26852 1260.73375,1192.26852 L1261.58955,1192.26852 C1300.23748,1192.26852 1334.04158,1169.73107 1346.51914,1129.90925 C1358.85978,1089.4774 1355.36812,1036.11616 1398.51755,1004.54678 C1438.27802,974.23136 1478.31234,971.757324 1504.85926,939.103433 L1516.96027,923.801687 L1497.91016,928.37696 C1497.91016,928.37696 1486.42533,930.850996 1460.39189,933.325033 C1451.64562,934.189251 1437.28529,935.392378 1421.58992,935.392378 C1402.64251,935.392378 1381.05923,933.325033 1364.97019,926.88576 C1349.49733,919.98896 1339.77544,910.380887 1339.77544,892.147578 C1339.77544,888.453469 1340.03218,884.742415 1341.14472,880.556887 C1342.75362,872.423069 1347.51187,868.966196 1356.00141,866.746342 C1364.09728,863.916451 1375.05152,863.797833 1384.5509,863.441978 C1411.09781,862.425251 1418.33788,842.090705 1417.58478,831.381178 C1417.58478,826.687287 1416.95148,823.230415 1416.60916,823.010124 L1414.60659,815.215215 L1407.2296,818.316233 C1407.2296,818.316233 1402.38577,820.654705 1393.39987,823.010124 C1384.91033,824.941905 1372.84355,827.415942 1358.72285,827.415942 C1350.7468,827.415942 1342.27438,826.687287 1333.40829,824.586051 C1314.83743,820.654705 1300.37441,811.012742 1290.75522,802.760305 C1280.67389,794.287578 1276.54894,787.238269 1276.54894,787.238269 L1270.31871,778.867215 L1264.70466,787.119651 C1264.44792,787.729687 1258.59425,795.880451 1258.59425,807.58976 C1258.59425,813.622342 1260.3572,820.654705 1265.57758,827.297324 C1271.5853,834.719433 1280.29734,838.888015 1284.90154,843.19216 C1293.39108,850.241469 1300.63115,857.121324 1300.37441,864.662051 C1300.37441,866.373542 1300.37441,868.101978 1299.50149,870.304887 C1292.14161,892.77456 1278.05514,898.55296 1260.10046,898.92576 C1233.91298,899.179942 1203.10418,882.52256 1198.22612,879.557105 C1185.28642,871.796087 1176.30052,863.916451 1170.78917,858.138051 C1165.31205,852.461324 1163.18967,849.004451 1162.59061,849.004451 L1153.84433,834.312742 L1150.45536,851.325978 C1150.45536,851.95296 1149.97612,852.952742 1149.97612,854.426996 C1149.97612,863.289469 1153.84433,888.199287 1187.01514,933.325033 C1196.87396,946.373033 1200.48543,958.590705 1200.48543,970.910051 C1201.35835,1015.01907 1149.83919,1058.68751 1148.60684,1102.16954 Z M1164.57606,555.373615 C1164.31932,557.220669 1164.31932,559.084669 1164.31932,562.389033 C1164.31932,581.401833 1168.80372,631.289251 1212.68914,659.164524 L1215.56463,661.028524 C1235.89844,673.347869 1259.48428,675.313542 1275.19677,675.313542 C1279.30461,675.313542 1283.0359,674.957687 1286.15101,674.957687 C1285.67176,680.007433 1283.0359,689.751069 1276.80568,706.137324 C1273.69056,714.525324 1272.57802,721.676305 1272.57802,728.081687 C1272.57802,747.924815 1285.89427,755.821396 1286.76719,756.431433 L1292.51816,759.634124 L1296.11252,754.09296 C1296.24945,753.601542 1323.56659,710.593978 1329.43738,670.738269 C1330.17336,666.705251 1330.80666,662.638342 1330.80666,658.774778 C1330.17336,614.530196 1293.39108,598.025324 1292.75779,597.906705 L1178.78234,542.817033 L1175.68435,540.834415 L1165.6886,535.157687 L1164.67876,551.188087 L1164.57606,555.373615 Z M1411.47436,774.800305 L1411.47436,780.205905 L1411.86803,786.611287 L1418.83424,786.611287 L1419.09098,786.611287 C1419.60446,786.763796 1419.82697,786.763796 1420.08371,786.763796 C1426.58779,786.763796 1448.03414,780.832887 1452.3816,748.907651 C1455.75346,731.894415 1458.3722,722.40496 1460.39189,717.728015 C1471.2092,724.980669 1497.39668,740.519651 1526.81909,740.756887 L1528.18837,740.756887 L1532.19351,740.401033 C1593.17782,737.096669 1622.49753,681.363069 1626.2117,673.839287 L1627.71791,670.145178 L1628.09446,669.890996 L1630.33666,665.468233 L1634.95798,655.86016 L1619.3653,655.944887 L1493.42577,647.573833 C1493.42577,647.573833 1491.66282,647.217978 1489.78006,647.217978 C1478.80871,647.217978 1441.41025,651.030705 1424.44829,692.818196 C1412.60402,722.760815 1411.47436,760.98976 1411.47436,774.800305 Z M1226.07214,1154.46152 C1143.28205,1127.33185 1203.11958,1050.67061 1213.49188,1029.96327 C1224.82267,1007.76472 1234.8013,980.058902 1227.2018,955.38632 C1225.07941,946.879702 1217.47991,927.900793 1205.61852,914.090247 C1247.38156,935.407629 1284.45482,930.866247 1306.89389,920.851484 C1324.84858,958.589011 1388.43452,964.740211 1420.21893,960.571629 C1408.27196,970.925302 1340.03047,974.263556 1327.45021,1071.0221 C1325.46475,1088.98428 1317.59139,1183.91272 1226.07214,1154.46152 Z\" />\n            </g>\n            <g>\n                <mask id=\"icon-squad-stats-bg_mask-2\" fill=\"white\">\n                    <use xlink:href=\"#icon-squad-stats-bg_path-1\" />\n                </mask>\n                <g mask=\"url(#icon-squad-stats-bg_mask-2)\" fill=\"#FFFFFF\">\n                    <g transform=\"translate(0.000000, -16.000000)\">\n                        <rect x=\"0\" y=\"0\" width=\"4279\" height=\"1847\" />\n                    </g>\n                </g>\n            </g>\n        </g>\n        <rect fill=\"#FFFFFF\" fill-rule=\"nonzero\" x=\"609\" y=\"-67\" width=\"643\" height=\"166\" rx=\"6\" />\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-stacked-lions",
  "use": "icon-stacked-lions-usage",
  "viewBox": "0 0 54 122",
  "content": "<symbol viewBox=\"0 0 54 122\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-stacked-lions\">\n    <defs>\n        <path d=\"M53.2357272,16.1245 C54.1260792,16.5842727 53.9357832,17.5299545 53.9357832,17.5299545 C53.9357832,17.5299545 53.8683912,17.3992727 53.7504552,17.3597273 C53.6275512,17.3215455 53.5394232,17.3810909 53.5394232,17.3810909 C53.9249832,17.7776818 53.5078872,18.4904091 53.5078872,18.4904091 C53.2970712,17.9283636 52.9052472,18.1349545 52.9052472,18.1349545 C52.9052472,18.1349545 53.0672472,18.4574545 53.1193032,18.7879091 C53.2024632,19.3697273 52.7961672,19.6608636 52.7961672,19.6608636 C52.7961672,19.6608636 52.8151752,19.0624545 52.3404072,19.1879091 C52.1060472,19.2492727 51.6116232,19.6954091 51.8209272,21.0115455 C51.8209272,21.0115455 51.4699272,20.9535909 51.2210952,20.7172273 C50.9694552,20.4776818 50.8530312,20.1222273 50.8530312,20.1222273 C50.8530312,20.1222273 50.7050712,21.9622273 49.5889992,21.7733636 C49.8991752,21.4067727 49.7198952,20.9106364 49.7198952,20.9106364 C49.7198952,20.9106364 49.2919992,21.0710909 49.0997592,21.2974545 C49.0036392,21.4183636 48.9139992,21.6465455 48.8666952,22.0713182 C48.7394712,23.3245 48.3018552,23.8301818 47.7432792,23.9463182 C47.6579592,23.9658636 47.4676632,23.9722273 47.2823352,23.9463182 C46.9974312,24.3690455 47.1561912,24.7972273 47.1561912,24.7972273 C46.9658952,24.6285909 46.6131672,24.3149545 46.7440632,23.7079091 C46.7440632,23.6913182 46.7485992,23.6747273 46.7550792,23.6581364 C46.7343432,23.6367727 46.7110152,23.6104091 46.6920072,23.5774545 C46.5440472,23.3295 46.6812072,23.0217727 46.7250552,22.9310909 C46.6967592,22.9724545 46.5883272,23.0681364 46.1818152,23.2235909 C45.6582312,23.4367727 45.3180312,23.2401818 45.1229832,22.9310909 C44.6462712,23.1242727 44.5644072,23.5954091 44.5644072,23.5954091 C44.4810312,23.3495 44.3412792,22.8847273 44.7566472,22.4449545 C44.7989832,22.3951818 44.8490952,22.3488182 44.9043912,22.3074545 C44.8903512,22.177 44.8853832,21.7733636 45.2631672,21.3885909 C45.2839032,21.3604091 45.2947032,21.352 45.2158632,21.3335909 C45.0316152,21.2808636 44.7782472,21.1783636 44.7000552,20.8326818 C44.2168632,20.8131364 43.9570152,21.162 43.9570152,21.162 C43.9978392,20.9038182 44.0641512,20.4279091 44.6272632,20.2265455 C44.6728392,20.2065455 44.7218712,20.1963182 44.7655032,20.1851818 C45.4284072,19.1249545 47.2443192,19.9138182 47.2443192,19.9138182 C47.2648392,19.9106364 47.5957512,19.8310909 47.8454472,19.5135909 C48.2437512,19.0045 48.2327352,18.4160909 47.3181912,18.3431364 C45.4361832,18.1974545 38.0932632,18.1365455 34.2625032,14.8765455 C34.2625032,14.8765455 31.3877592,14.3308636 27.0805032,18.5317727 C20.7113112,24.7445 16.9989192,23.5774545 15.0367752,23.3245 C14.0922072,23.2035909 13.4001432,23.407 12.8426472,23.9756364 C12.4981272,23.1772273 13.3794072,22.5390455 13.3794072,22.5390455 C12.7655352,22.4595 11.8278792,22.3838182 11.4012792,23.2035909 C11.0850552,22.8829091 11.1524472,22.3042727 11.1524472,22.3042727 C11.1524472,22.3042727 10.3057272,23.0017727 9.6557832,22.6613182 C9.6557832,22.6613182 10.1785032,22.2731364 9.9171432,22.0167727 C9.7030872,21.8015455 9.2734632,21.7256364 8.7131592,22.8613182 C8.7131592,22.8613182 8.4062232,22.6085909 8.4820392,22.1308636 C8.5338792,21.7967727 8.6708232,21.6410909 8.6708232,21.6410909 C8.6708232,21.6410909 8.1718632,22.0795 7.4923272,21.9851818 C7.4923272,21.9851818 8.1072792,21.6215455 7.8333912,21.3140455 C7.4510712,20.8874545 5.9904792,20.8229091 5.0305752,21.3949545 C4.7050632,21.5933636 4.0283352,22.4697273 3.1140072,21.8381364 C3.1124952,21.8381364 3.1060152,21.8397273 3.1012632,21.8397273 C2.4232392,22.0001818 2.2750632,22.6233636 2.2750632,22.6233636 C2.2027032,22.3240455 2.0657592,21.7704091 2.5837272,21.2710909 C2.6167752,21.2365455 2.6608392,21.2013182 2.7031752,21.1667727 C2.6293032,20.737 2.9392632,20.4558636 3.2397192,20.2690455 C2.5489512,20.2431364 1.1656872,20.2181364 1.1831832,19.2176818 C1.1831832,19.2176818 1.1859912,19.1926818 1.1939832,19.1463182 C0.6513912,19.0458636 0.2971512,19.3931364 0.2971512,19.3931364 C0.3913272,19.1006364 0.5580792,18.5495 1.2492792,18.4308636 C1.2775752,18.4256364 1.3041432,18.4208636 1.3356792,18.4174545 C1.5825672,17.7497273 2.9723112,17.9579091 3.1140072,17.9829091 C2.9520072,17.6717727 2.8809432,17.3265455 3.2397192,16.9495 C3.2336712,16.9260909 3.2256792,16.8999545 3.2179032,16.877 C2.9960712,16.2372273 2.4325272,16.1624545 2.4325272,16.1624545 C2.6891352,16.0535909 3.1597992,15.8567727 3.6615672,16.3047273 C3.7276632,16.3610909 3.7892232,16.4356364 3.8393352,16.5081364 C4.1054472,16.3858636 4.4326872,16.4322273 5.0100552,17.2304091 C5.7263112,18.1415455 5.5565352,18.4872273 8.4958632,18.7417727 C10.7182872,18.7729091 11.5116552,18.2604091 11.5116552,18.2604091 C11.5116552,18.2604091 10.8547992,18.2604091 10.7055432,17.872 C10.7055432,17.872 10.9481112,17.897 11.1101112,17.6801818 C11.2187592,17.5299545 11.1887352,17.2538182 10.9370952,17.0899545 C10.4223672,16.7592727 10.0668312,18.0556364 10.0668312,18.0556364 C9.4214232,17.6688182 9.6387192,16.9081364 9.6387192,16.9081364 C9.6387192,16.9081364 9.4011192,17.0422273 9.1224792,17.1163182 C8.3936952,17.3049545 8.0223912,16.872 8.0223912,16.872 C8.0223912,16.872 8.9494632,16.7792727 8.8863912,16.3147273 C8.8863912,16.3147273 7.5882312,16.9231364 6.6138552,16.1360909 C6.6138552,16.1360909 7.8195672,15.9806364 7.5078792,15.5576818 C7.3396152,15.3345 6.9570792,15.6601818 5.7060072,15.5115455 C4.8795912,15.417 4.7020392,14.9113182 4.7020392,14.9113182 C5.4493992,15.0085909 5.6917512,14.8151818 5.6837592,14.5590455 C5.6757672,14.2483636 5.2228152,14.3724545 4.7175912,14.2597273 C4.0080312,14.0958636 3.5892072,13.6826818 1.9635912,14.4117727 C1.6125912,14.5722273 1.0525032,14.5772273 0.7015032,14.0397273 C0.1897992,14.2022273 0.0405432,14.6679091 0.0405432,14.6679091 C-0.0115128,14.387 -0.0979128,13.8631364 0.4057992,13.4399545 C0.4323672,13.4165455 0.4559112,13.4033636 0.4796712,13.3883636 C0.4842072,12.6113182 1.5054552,12.3997273 1.6881912,12.2958636 C1.6881912,12.2958636 0.4163832,11.2010909 1.0347912,10.282 C1.0287432,10.2735909 1.0255032,10.2674545 1.0226952,10.2590455 C0.6053832,9.67540909 0.0074952,9.77972727 0.0074952,9.77972727 C0.2388312,9.58790909 0.6652152,9.23404545 1.3041432,9.53154545 C1.4363352,9.59631818 1.5765192,9.68359091 1.6706952,9.79290909 C2.2592952,9.21609091 3.2304312,10.1267727 3.6885672,10.6195 C3.6885672,10.6195 3.4444872,9.51336364 4.0391352,9.15631818 C3.8000232,8.57904545 3.2822712,8.50995455 3.2822712,8.50995455 C3.5358552,8.40404545 4.0125672,8.20904545 4.5082872,8.65040909 C4.6216872,8.75268182 4.7268792,8.88677273 4.7821752,9.02586364 C5.8003992,9.33836364 5.6396952,10.3135909 5.7060072,11.2806364 C5.7738312,12.3056364 8.8675992,13.3785909 11.4073272,13.8763182 C11.4624072,14.6283636 11.8339272,15.2647273 12.0905352,15.9658636 C12.5469432,17.0583636 12.4395912,18.102 12.4395912,18.102 C12.4395912,18.102 13.0694472,17.6522273 13.3588872,17.6717727 C13.6187352,17.6833636 13.4442072,18.1365455 13.5621432,18.7465455 C13.6735992,19.3449545 14.2101432,19.7004091 14.2101432,19.7004091 L14.3693352,19.3399545 C14.3693352,19.3399545 14.5866312,20.0872273 15.2773992,20.5717727 C15.2773992,20.5717727 15.8927832,19.3333636 16.3301832,19.4292727 C16.6606632,19.497 16.6857192,20.2806364 16.6857192,20.2806364 C19.8900792,18.6274545 19.6650072,15.4467727 19.9890072,17.2026818 C19.9890072,17.2026818 22.1511672,15.9295 22.0820472,12.7554091 C24.4409832,13.4049545 27.9786312,9.89677273 35.8598232,9.86222727 C38.8486152,9.85222727 42.9968952,11.4279091 45.0681192,12.1881364 C47.1311352,12.9538182 48.4562952,12.9338182 48.8904552,12.1881364 C49.2775272,11.5235909 49.1029992,10.4790455 46.1269512,10.0440455 C43.9235352,9.72495455 41.4278712,9.58790909 39.9249432,9.46359091 C38.9021832,9.38472727 37.2167352,9.24063636 36.3417192,8.15586364 C35.8066872,7.49995455 35.5550472,6.61336364 35.6647752,5.75563636 C35.8742952,4.04586364 36.7918632,3.24768182 36.8167032,3.19654545 C36.8167032,3.19654545 36.6847272,3.43790909 36.6940152,3.61495455 C36.6940152,3.61495455 37.3992552,2.93177273 38.2505112,2.93177273 C38.2505112,2.93177273 37.5992712,3.15018182 37.4433192,3.61495455 C37.4433192,3.61495455 37.8444312,3.31881818 38.4412392,3.13836364 C39.1000392,2.93177273 39.3620472,2.93177273 39.3620472,2.93177273 C39.3620472,2.93177273 39.3553512,1.48677273 40.9526712,1.5945 C44.6272632,1.83245455 44.4907512,0.227227273 44.4907512,0.227227273 C44.4907512,0.227227273 45.1327032,0.604045455 44.9421912,1.31336364 C44.6192712,2.57631818 43.0837272,2.4095 43.0837272,2.4095 C43.0837272,2.4095 43.8593832,3.05745455 44.7989832,2.64745455 C45.7899912,2.21290909 46.0703592,1.03381818 46.0703592,1.03381818 C46.0703592,1.03381818 47.1088872,4.15018182 43.9334712,4.92745455 C42.8364072,5.20018182 41.9806152,4.77359091 41.9806152,4.77359091 C41.9806152,4.77359091 42.0918552,5.57222727 43.2347112,5.46995455 C43.6751352,5.43313636 44.0937432,5.29609091 44.4980952,5.11722727 C44.8806312,4.95040909 45.4832712,4.55881818 46.4278392,4.752 C46.4278392,4.752 45.9902232,4.96177273 45.4441752,5.42654545 C44.7153912,6.04131818 44.1017352,6.40518182 43.0787592,6.64518182 C41.2423272,7.07472727 39.3145272,6.00381818 39.4123752,4.37859091 C39.4123752,4.37859091 37.4999112,4.41313636 37.2543192,5.90927273 C37.1033352,6.81540909 37.6368552,7.70336364 39.6810792,8.00904545 C42.0132312,8.36268182 48.0659832,7.87836364 50.8683672,10.3381364 C51.8697432,11.2163182 51.5975832,12.1685909 51.5975832,12.1685909 C51.5975832,12.1685909 51.4431432,11.5883636 51.1819992,11.3499545 C50.9240952,11.1135909 50.7759192,11.127 50.7759192,11.127 C50.7759192,11.127 51.4889352,11.5351818 51.4889352,12.6695 C51.4889352,13.4297273 50.8372632,13.9388182 50.8372632,13.9388182 C50.8372632,13.9388182 51.0841512,13.4101818 51.0243192,13.0331364 C50.9742072,12.7008636 50.8061592,12.5699545 50.8061592,12.5699545 C50.8061592,12.5699545 50.7633912,15.5704091 45.5480712,14.4997273 C43.6310712,14.1090455 42.3659592,13.4365455 42.3659592,13.4365455 C42.1426152,13.2879091 42.6113352,15.5495 48.4610472,16.1624545 C49.3328232,16.2551818 50.1890472,16.1692727 50.9504472,16.0865455 C51.9230952,15.9790455 52.7339592,15.8717727 53.2357272,16.1245 Z M44.1645696,18.9641818 C44.1645696,18.9641818 44.6494896,20.1428182 43.1530416,20.396 C42.6396096,20.4837273 39.5205696,20.5114545 39.3631056,22.8162273 C38.7781776,22.5021364 38.6943696,21.8262273 38.7151056,21.7087273 C36.4378176,21.8457727 36.3449376,23.0428182 36.3449376,23.0428182 C36.3449376,23.0428182 35.9325936,22.7419091 36.1654416,21.7419091 C36.2708496,21.2950909 35.2338336,22.7964545 34.9644816,21.816 C34.2847296,21.9632727 34.3555776,22.8741818 34.3555776,22.8741818 C34.3555776,22.8741818 33.8756256,22.7482727 33.8788656,21.9516818 C33.8788656,21.9516818 33.9164496,21.4223636 33.5324016,21.8573636 C33.3293616,22.1003182 33.2790336,22.3864545 33.2725536,22.3780455 C32.8839696,22.0953182 32.8010256,21.4223636 32.8010256,21.4223636 C32.6861136,21.9516818 31.7635776,23.0623636 30.8762496,22.6557727 L30.8745216,22.6557727 C30.7691136,23.0839545 30.9686976,23.4046364 30.9686976,23.4046364 C30.7421136,23.2775909 30.3239376,23.0394091 30.3239376,22.4078182 C30.3239376,22.2957727 30.3412176,22.1796364 30.3740496,22.0707727 C30.0249936,21.1150909 30.9153456,20.6719091 30.6604656,20.7830455 C29.6249616,21.2391818 28.9685376,20.8289545 28.8711216,20.2569091 C28.4207616,20.2735 28.1771136,20.5978182 28.1771136,20.5978182 C28.2183696,20.3314545 28.2935376,19.8371364 28.8711216,19.6355455 L28.8711216,19.6321364 L28.8711216,19.6307727 C28.9560096,19.1889545 29.2977216,18.8535 30.3239376,18.7046364 C30.1586976,18.3328182 30.2433696,18.0103182 30.4274016,17.7873636 C30.4366896,17.7655455 30.4526736,17.7591818 30.4619616,17.7489545 C30.0705696,17.4582727 29.6642736,17.5987273 29.6642736,17.5987273 C29.8390176,17.4037273 30.1586976,17.0316818 30.7483776,17.1969091 C30.8922336,17.2382727 31.0414896,17.3112273 31.1404176,17.4119091 C31.4065296,17.3689545 31.7054736,17.3871364 32.0141376,17.4432727 C33.1375536,17.6416818 33.7747536,18.6550909 33.7747536,18.6550909 C33.7747536,18.6550909 34.1430336,18.6716818 34.9895376,18.7378182 C35.7029856,18.8003182 36.2611296,18.9689545 36.2611296,18.9689545 C33.6220416,17.8698636 34.3115136,16.1157727 34.3115136,16.1157727 C34.3115136,16.1157727 36.9270576,18.7378182 44.1645696,18.9641818 Z M10.7749872,11.0639545 C10.7749872,11.0639545 12.0133152,11.7239545 12.2211072,10.4739545 C12.2211072,10.4739545 11.0503872,10.7335 10.8628992,8.92804545 C10.8503712,8.86872727 11.7268992,10.5680455 12.2982192,6.98213636 C12.3455232,6.70122727 12.5280432,6.14895455 12.9889872,6.01009091 C12.9781872,4.24918182 14.2102512,3.31872727 14.2260192,3.32213636 C14.8982112,3.5435 14.9720832,4.32872727 14.9720832,4.32872727 C14.9720832,4.32872727 15.3636912,4.27940909 15.5025792,3.78986364 C15.8172912,2.661 16.7456592,2.76486364 16.7456592,2.76486364 C16.4369952,3.49872727 17.0506512,4.00645455 17.0506512,4.00645455 C17.0506512,4.00645455 17.9572032,3.37690909 18.5505552,3.19486364 C19.1093472,3.02281818 19.7214912,3.17986364 19.8551952,3.22281818 C19.4886432,3.53690909 19.3359312,3.99668182 19.5184512,4.32872727 C19.7309952,4.70895455 20.2990752,4.77190909 20.7930672,4.47122727 C21.0781872,4.30077273 21.2749632,4.04304545 21.3503472,3.7835 C21.7298592,4.88122727 21.2512032,5.47281818 21.2512032,5.47281818 C22.2206112,5.91418182 22.5305712,5.00009091 22.5305712,5.00009091 C22.5305712,5.00009091 23.0122512,6.23486364 22.7478672,7.15213636 C22.6014192,7.68804545 22.1968512,7.96895455 22.1968512,7.96895455 C22.1968512,7.96895455 23.1284592,7.99577273 22.8720672,9.23395455 C22.4487072,11.3069091 22.9161312,11.8575909 22.9161312,11.8575909 C22.9161312,11.8575909 22.7571552,11.9964545 22.3026912,11.8641818 C21.8458512,11.7321364 21.3974352,11.4657727 21.3974352,11.4657727 C21.5566272,14.8946364 20.3919552,15.6319091 20.3919552,15.6319091 C20.3919552,15.6319091 20.1480912,15.1623636 19.9798272,14.9773636 C19.1028672,14.0050909 19.5592752,17.2191818 17.1420192,18.826 C17.1420192,18.826 16.7376672,18.4671364 16.4369952,18.4094091 C15.9712992,18.3166818 15.3451152,19.1448636 15.3451152,19.1448636 C14.7565152,18.6771364 15.2222112,17.6882727 15.2222112,17.6882727 C15.2222112,17.6882727 14.7217392,17.8107727 14.5297152,18.1232727 C14.4022752,18.3182727 14.3361792,18.4094091 14.3361792,18.4094091 C14.3361792,18.4094091 14.3770032,18.3119091 14.3707392,17.6171364 C14.3564832,17.0766818 14.1206112,16.8271364 13.7428272,16.8221364 C13.4721792,16.8205455 13.1874912,16.9907727 13.1874912,16.9907727 C13.1874912,16.9907727 13.1967792,16.3394091 12.7796832,15.3905455 C12.3770592,14.3571364 11.9709792,13.5075909 12.2714352,12.1255455 C12.2714352,12.1255455 11.2313952,12.8873636 10.7749872,11.0639545 Z M14.4951552,14.9969091 L14.4951552,15.0053182 C14.5044432,15.6400909 15.0206832,16.0219091 15.5481552,16.1541818 C15.6738672,16.1873636 15.7963392,16.2053182 15.9101712,16.2053182 L15.9209712,16.2053182 C16.4086992,16.2053182 16.8352992,15.9030455 16.9927632,15.3689545 C17.1484992,14.8266818 17.1044352,14.111 17.6489712,13.6875909 C18.1507392,13.281 18.6559632,13.2478182 18.9909792,12.8098636 L19.1436912,12.6046364 L18.9032832,12.666 C18.9032832,12.666 18.7583472,12.6991818 18.4298112,12.7323636 C18.3194352,12.7439545 18.1382112,12.7600909 17.9401392,12.7600909 C17.7010272,12.7600909 17.4286512,12.7323636 17.2256112,12.646 C17.0303472,12.5535 16.9076592,12.4246364 16.9076592,12.1800909 C16.9076592,12.1305455 16.9108992,12.0807727 16.9249392,12.0246364 C16.9452432,11.9155455 17.0052912,11.8691818 17.1124272,11.8394091 C17.2145952,11.8014545 17.3528352,11.7998636 17.4727152,11.7950909 C17.8077312,11.7814545 17.8990992,11.5087273 17.8895952,11.3650909 C17.8895952,11.3021364 17.8816032,11.2557727 17.8772832,11.2528182 L17.8520112,11.1482727 L17.7589152,11.1898636 C17.7589152,11.1898636 17.6977872,11.2212273 17.5843872,11.2528182 C17.4772512,11.2787273 17.3249712,11.3119091 17.1467712,11.3119091 C17.0461152,11.3119091 16.9391952,11.3021364 16.8273072,11.2739545 C16.5929472,11.2212273 16.4104272,11.0919091 16.2890352,10.9812273 C16.1618112,10.8675909 16.1097552,10.7730455 16.1097552,10.7730455 L16.0311312,10.6607727 L15.9602832,10.7714545 C15.9570432,10.7796364 15.8831712,10.8889545 15.8831712,11.046 C15.8831712,11.1269091 15.9054192,11.2212273 15.9712992,11.3103182 C16.0471152,11.4098636 16.1570592,11.4657727 16.2151632,11.5235 C16.3222992,11.6180455 16.4136672,11.7103182 16.4104272,11.8114545 C16.4104272,11.8344091 16.4104272,11.8575909 16.3994112,11.8871364 C16.3065312,12.1885 16.1287632,12.266 15.9021792,12.271 C15.5716992,12.2744091 15.1828992,12.051 15.1213392,12.0112273 C14.9580432,11.9071364 14.8446432,11.8014545 14.7750912,11.7239545 C14.7059712,11.6478182 14.6791872,11.6014545 14.6716272,11.6014545 L14.5612512,11.4044091 L14.5184832,11.6325909 C14.5184832,11.641 14.5124352,11.6544091 14.5124352,11.6741818 C14.5124352,11.7930455 14.5612512,12.1271364 14.9798592,12.7323636 C15.1042752,12.9073636 15.1498512,13.0712273 15.1498512,13.2364545 C15.1608672,13.8280455 14.5107072,14.4137273 14.4951552,14.9969091 Z M14.6966832,7.66327273 C14.6934432,7.68804545 14.6934432,7.71304545 14.6934432,7.75736364 C14.6934432,8.01236364 14.7500352,8.68145455 15.3038592,9.05531818 L15.3401472,9.08031818 C15.5967552,9.24554545 15.8944032,9.27190909 16.0926912,9.27190909 C16.1445312,9.27190909 16.1916192,9.26713636 16.2309312,9.26713636 C16.2248832,9.33486364 16.1916192,9.46554545 16.1129952,9.68531818 C16.0736832,9.79781818 16.0596432,9.89372727 16.0596432,9.97963636 C16.0596432,10.2457727 16.2276912,10.3516818 16.2387072,10.3598636 L16.3112832,10.4028182 L16.3566432,10.3285 C16.3583712,10.3219091 16.7031072,9.74509091 16.7771952,9.21054545 C16.7864832,9.15645455 16.7944752,9.10190909 16.7944752,9.05009091 C16.7864832,8.45668182 16.3222992,8.23531818 16.3143072,8.23372727 L14.8759632,7.49486364 L14.8368672,7.46827273 L14.7107232,7.39213636 L14.6979792,7.60713636 L14.6966832,7.66327273 Z M17.8124832,10.6062273 L17.8124832,10.6787273 L17.8174512,10.7646364 L17.9053632,10.7646364 L17.9086032,10.7646364 C17.9150832,10.7666818 17.9178912,10.7666818 17.9211312,10.7666818 C18.0032112,10.7666818 18.2738592,10.6871364 18.3287232,10.2589545 C18.3712752,10.0307727 18.4043232,9.9035 18.4298112,9.84077273 C18.5663232,9.93804545 18.8968032,10.1464545 19.2681072,10.1496364 L19.2853872,10.1496364 L19.3359312,10.1448636 C20.1055392,10.1005455 20.4755472,9.35304545 20.5224192,9.25213636 L20.5414272,9.20259091 L20.5461792,9.19918182 L20.5744752,9.13986364 L20.6327952,9.011 L20.4360192,9.01213636 L18.8466912,8.89986364 C18.8466912,8.89986364 18.8244432,8.89509091 18.8006832,8.89509091 C18.6622272,8.89509091 18.1902672,8.94622727 17.9762112,9.50668182 C17.8267392,9.90827273 17.8124832,10.421 17.8124832,10.6062273 Z M15.4727496,15.69825 C14.4279576,15.3343864 15.1830936,14.3062045 15.3139896,14.0284773 C15.4569816,13.73075 15.5829096,13.3591591 15.4870056,13.02825 C15.4602216,12.9141591 15.3643176,12.6596136 15.2146296,12.4743864 C15.7416696,12.7602955 16.2095256,12.6993864 16.4927016,12.5650682 C16.7192856,13.0712045 17.5217256,13.1537045 17.9228376,13.0977955 C17.7720696,13.2366591 16.9108776,13.2814318 16.7521176,14.5791591 C16.7270616,14.8200682 16.6277016,16.09325 15.4727496,15.69825 Z\" id=\"icon-stacked-lions_path-1\" />\n        <path d=\"M36.6717857,18.7611239 C33.3167143,17.2377294 33.7523571,15.6427752 33.7523571,15.6427752 C33.7523571,15.6427752 36.3177857,18.2255734 44.1424286,18.3790138 C44.1424286,18.3790138 44.1188571,19.3854358 42.8307857,19.643922 C42.3267857,19.753555 39.1611429,20.0579128 39.222,22.3826835 C38.6252143,22.099656 38.5737857,21.4237385 38.5935,21.3037844 C37.9163571,21.2487385 37.5822857,21.6579128 37.2563571,22.0182339 C36.7699286,22.5547018 36.4555714,22.6047018 36.4555714,22.6047018 C36.4555714,22.6047018 36.7875,21.6125 36.2067857,21.6125 C35.7664286,21.6125 35.3884286,22.6544725 35.3884286,22.6544725 C35.3884286,22.6544725 34.8638571,22.2446101 34.9967143,21.6441514 C34.3392857,21.3686927 33.9015,22.4551606 33.9015,22.4551606 C33.9015,22.4551606 33.4947857,21.7324541 33.9805714,21.2251147 C33.9805714,21.2251147 33.1992857,21.0540138 32.4945,21.9991972 C32.1392143,22.4737385 31.7494286,22.8223624 31.2186429,22.6599771 C31.1217857,22.6269495 31.0388571,22.6049312 30.9735,22.5684633 C30.6036429,22.9670872 30.705,23.4558486 30.705,23.4558486 C30.5346429,23.2540138 30.2241429,22.8751147 30.4347857,22.2682339 C30.4615714,22.1946101 30.5003571,22.1161697 30.5410714,22.0446101 C30.3207857,21.443922 30.8408571,20.7948394 30.8408571,20.7948394 C30.8408571,20.7948394 30.7703571,20.8514908 30.4909286,20.9567661 C29.8930714,21.1739679 29.4634286,20.9852064 29.2622143,20.6095183 C28.7297143,20.7063073 28.5456429,21.1739679 28.5456429,21.1739679 C28.5156429,20.9017202 28.4646429,20.4081422 28.9656429,20.0356651 C29.0125714,20.0026376 29.0702143,19.9709862 29.1248571,19.9455275 C29.1327857,19.4219037 29.4137143,19.171445 30.3726429,18.9478211 C30.168,18.8175459 29.8712143,18.4840596 30.0415714,18.0019495 C29.6149286,17.7083716 29.2060714,17.897133 29.2060714,17.897133 C29.3622857,17.6833716 29.6545714,17.2913991 30.2477143,17.399656 C30.3111429,17.4129587 30.3771429,17.4313073 30.4377857,17.4631881 C30.7549286,17.2645642 31.1063571,17.3682339 31.3262143,17.4533257 C31.9930714,17.7083716 32.9421429,18.6423165 32.9421429,18.6423165 C32.9421429,18.6423165 33.8397857,18.4627294 34.6845,18.509289 C35.3948571,18.5425459 36.6717857,18.7611239 36.6717857,18.7611239 Z M53.9086071,17.1699541 C53.9086071,17.1699541 53.4528214,16.3477064 53.7024643,17.3366972 C53.8696071,18.0158257 53.2899643,18.3463303 53.2899643,18.3463303 C53.2899643,18.3463303 53.3994643,17.7759174 53.12175,17.8575688 C52.7606786,18.0293578 53.3371071,19.5940367 52.4193214,20.1263761 C52.4193214,20.1263761 52.5751071,19.5940367 52.1851071,19.6041284 C51.8898214,19.6424312 51.9086786,20.1848624 51.6648214,20.6103211 C51.2313214,21.4027523 50.8563214,21.2674312 50.8563214,21.2674312 C50.8563214,21.2674312 51.0466071,20.7956422 50.8093929,20.5736239 C50.5768929,20.3598624 50.0366786,20.6016055 50.0694643,21.3880734 C50.0694643,21.3880734 49.8335357,21.3777523 49.6368214,21.1676606 C49.4463214,20.9607798 49.4338929,20.7220183 49.4338929,20.7220183 C49.4338929,20.7220183 49.0968214,20.5483945 48.9326786,21.7029817 C48.8079643,22.6038991 48.1646786,23.6383028 47.4371786,23.6149083 C47.16375,24.1302752 47.4108214,24.5862385 47.4108214,24.5862385 C47.1935357,24.4488532 46.7876786,24.1988532 46.81575,23.5433486 C46.81575,23.4931193 46.8219643,23.4380734 46.8331071,23.3830275 C46.7658214,23.3130734 46.7079643,23.2245413 46.6768929,23.0981651 C46.5804643,22.7708716 46.7688214,22.3752294 46.8641786,22.2002294 C46.8078214,22.2768349 46.6676786,22.3855505 46.3631786,22.4887615 C46.08675,22.587156 45.7899643,22.4972477 45.5793214,22.2816514 C45.0641786,22.5302752 45.02025,23.0626147 45.02025,23.0626147 C44.9188929,22.8155963 44.7256071,22.3568807 45.0971786,21.846789 C45.1533214,21.7683486 45.21825,21.6995413 45.2951786,21.6444954 C45.2859643,21.5977064 45.2859643,21.5543578 45.2951786,21.5075688 C45.3219643,21.0259174 45.5154643,20.8791284 45.8600357,20.693578 C45.6170357,20.6438073 45.39375,20.5151376 45.2810357,20.2866972 C44.7191786,20.2213303 44.4303214,20.6552752 44.4303214,20.6552752 C44.4603214,20.3795872 44.5113214,19.8860092 45.0733929,19.6506881 C45.1295357,19.6293578 45.1953214,19.6041284 45.2561786,19.5995413 C45.2593929,19.5809633 45.2626071,19.5591743 45.2718214,19.5442661 C45.6275357,18.4731651 48.4674643,20.0194954 48.61275,18.9470183 C48.8983929,16.8327982 42.5253214,17.7536697 38.3773929,16.5610092 C34.45875,15.4298165 33.9808929,14.362156 33.9808929,14.362156 C28.2605357,15.0444954 27.7220357,19.9529817 22.5056786,22.0986239 C19.1086071,23.503211 16.8868929,23.1995413 14.9510357,22.8426606 C13.6301786,22.6038991 13.7223214,23.6866972 12.5889643,23.2743119 C12.9965357,23.1827982 13.1476071,22.7575688 12.8649643,22.5637615 C12.3748929,22.2254587 12.2514643,23.091055 11.2636071,23.0626147 C11.9690357,22.3905963 11.39625,21.9181193 11.39625,21.9181193 C11.39625,21.9181193 10.7793214,23.4465596 9.58189286,23.0626147 C9.58189286,23.0626147 9.99567857,22.8928899 10.1626071,22.4268349 C10.25925,22.146789 10.1750357,21.996789 10.1750357,21.996789 C10.1750357,21.996789 9.14753571,23.091055 8.03625,22.6355505 C8.03625,22.6355505 8.27175,22.5853211 8.41896429,22.443578 C8.61975,22.2483945 8.66346429,22.0300459 8.58567857,21.9133028 C8.46096429,21.7181193 8.20639286,21.9401376 7.93467857,22.0633028 C7.64903571,22.2002294 7.16689286,22.315367 6.87910714,22.0633028 C6.87910714,22.0633028 8.07696429,21.675 7.18703571,21.2075688 C6.71839286,20.9555046 5.89917857,20.8506881 4.94625,21.4293578 C4.60789286,21.6311927 3.41967857,22.3568807 2.93710714,21.8048165 C2.46567857,22.0633028 2.42046429,22.5571101 2.42046429,22.5571101 C2.32189286,22.2983945 2.12989286,21.8348624 2.51882143,21.3291284 C2.55010714,21.2827982 2.59532143,21.2293578 2.63732143,21.1905963 C2.57496429,20.7600917 2.87625,20.4786697 3.16960714,20.2981651 C2.56082143,20.2699541 1.77889286,20.181422 1.62417857,19.4490826 C1.04346429,19.3637615 0.703178571,19.7756881 0.703178571,19.7756881 C0.76575,19.4738532 0.885535714,18.9038991 1.55560714,18.7183486 C1.60382143,18.6981651 1.65696429,18.6917431 1.70839286,18.6818807 C1.83503571,18.2557339 2.28910714,18.0525229 2.81732143,18.1793578 C2.94482143,18.2110092 3.13875,18.2461009 3.28532143,18.2699541 C3.16360714,18.0961009 2.75282143,17.7188073 2.97160714,17.3116972 C2.47789286,16.9412844 1.98332143,17.1699541 1.98332143,17.1699541 C2.16117857,16.9215596 2.49867857,16.4708716 3.18396429,16.5993119 C3.31510714,16.6293578 3.45696429,16.6811927 3.57396429,16.7612385 C3.95989286,16.6325688 4.59546429,16.7149083 5.39753571,17.5451835 C5.99260714,18.1194954 6.51246429,18.6502294 9.02603571,18.8816514 C10.2251786,18.9516055 11.51775,18.846789 12.5559643,18.3412844 C11.74725,17.5451835 11.48325,18.4178899 10.4356071,17.8905963 C10.4356071,17.8905963 10.7401071,17.8288991 10.8684643,17.6270642 C10.9526786,17.4889908 10.9869643,17.1699541 10.7045357,17.0396789 C10.0344643,16.737844 9.82232143,17.7704128 9.82232143,17.7704128 C9.31660714,17.05 9.73939286,16.416055 9.73939286,16.416055 C9.73939286,16.416055 9.30867857,16.2206422 8.80767857,16.3555046 C8.08467857,16.5509174 8.03946429,17.05 8.03946429,17.05 C7.65546429,16.6713303 7.80375,16.1690367 7.92353571,15.9972477 C7.92353571,15.9972477 7.26825,15.6665138 6.90760714,16.5194954 C6.90760714,16.5194954 6.48910714,15.7520642 7.14010714,15.3981651 C7.44782143,15.2247706 7.39617857,14.9561927 7.39617857,14.9561927 C7.37453571,14.966055 6.79982143,15.4298165 5.70975,15.4298165 C4.88410714,15.4298165 4.47803571,14.859633 4.52025,14.8662844 C5.44639286,15.056422 5.50703571,14.3334862 5.50703571,14.3334862 C5.50703571,14.3334862 4.12532143,13.9417431 2.09110714,14.5474771 C1.24639286,14.8029817 0.946607143,14.5474771 0.778178571,14.171789 C0.203464286,14.3073394 0.0410357143,14.8344037 0.0410357143,14.8344037 C-0.00889285714,14.5474771 -0.102321429,14.018578 0.400178571,13.5928899 C0.459535714,13.5412844 0.532821429,13.4963303 0.601607143,13.4575688 C0.57975,12.8238532 1.51167857,12.2832569 2.16439286,12.3231651 C2.16439286,12.3231651 0.447107143,11.3238532 0.973392857,10.4133028 C0.501964286,10.1211009 0.0616071429,10.3197248 0.0616071429,10.3197248 C0.24075,10.0727064 0.576535714,9.6190367 1.25903571,9.75229358 C1.33532143,9.76766055 1.41653571,9.79610092 1.49475,9.82752294 C2.09432143,9.37041284 3.11667857,10.109633 3.61489286,10.556422 C3.61489286,10.556422 3.48225,9.79610092 3.91146429,9.42866972 C3.58832143,8.97178899 3.11389286,8.99151376 3.11389286,8.99151376 C3.34960714,8.84633028 3.78353571,8.56284404 4.33939286,8.91674312 C4.43753571,8.97981651 4.52946429,9.06674312 4.60125,9.15688073 C5.14146429,9.19013761 5.39753571,9.63027523 5.60239286,10.5348624 C6.10489286,12.8238532 10.0893214,13.7016055 11.3036786,13.781422 C11.7768214,15.2279817 11.3911071,16.1738532 11.3911071,16.1738532 C12.28275,16.3309633 12.7136786,16.2743119 12.7136786,16.2743119 C12.7136786,16.2743119 13.0430357,17.9139908 13.9908214,18.3894495 C13.9908214,18.3894495 14.1279643,17.8438073 14.1560357,17.9924312 C14.3859643,19.1587156 15.45525,19.7176606 15.45525,19.7176606 C15.45525,19.7176606 16.1233929,19.490367 16.8211071,18.8334862 C17.5081071,18.1844037 17.1116786,19.1036697 17.1116786,19.1036697 C17.1116786,19.1036697 18.67275,18.7614679 19.6970357,16.7944954 C20.0593929,16.0972477 20.00925,16.0887615 20.12175,17.0983945 C21.72375,15.7084862 22.3121786,14.0701835 22.2138214,13.3142202 C24.0530357,14.0701835 30.2761071,9.40527523 36.3723214,9.20022936 C40.23975,9.07133028 41.8509643,10.2594037 43.7653929,10.9733945 C45.6699643,11.6908257 46.8078214,12.0431193 47.2059643,11.3472477 C47.57325,10.7135321 47.4950357,9.36009174 44.7425357,8.95504587 C42.7130357,8.65298165 40.0606071,8.58119266 38.67075,8.46582569 C37.7326071,8.38623853 34.87425,8.15573394 34.9286786,5.34793578 C34.9548214,3.67798165 35.9668929,3.13233945 35.9668929,3.13233945 L35.7995357,3.70114679 C35.7995357,3.70114679 36.27075,3.20894495 36.6804643,2.98715596 C37.1469643,2.73165138 37.6948929,2.69678899 37.6948929,2.69678899 C37.6948929,2.69678899 38.2398214,0.958256881 39.6093214,0.976834862 C40.69275,0.995183486 41.3214643,0.861238532 41.7511071,0.411009174 C42.4271786,-0.289449541 43.2110357,0.117431193 43.2110357,0.117431193 C43.2110357,0.117431193 42.7130357,0.249541284 42.3258214,1.08165138 C41.8728214,2.04266055 41.0581071,2.04266055 41.0581071,2.04266055 C41.0581071,2.04266055 41.4418929,2.57683486 42.48975,1.8440367 C44.0334643,0.988073394 44.8374643,2.44977064 44.8374643,2.44977064 C44.8374643,2.44977064 44.2211786,2.18302752 43.60425,2.46651376 C43.1045357,2.69678899 42.9770357,3.31926606 42.5221071,3.6043578 C41.8076786,4.04816514 41.2543929,3.99495413 41.2543929,3.99495413 C41.2543929,3.99495413 41.34675,4.42018349 42.5221071,4.15642202 C43.9509643,3.82821101 44.3853214,4.67224771 44.3853214,4.67224771 C44.3853214,4.67224771 43.9303929,4.52018349 43.48875,4.63577982 C43.0573929,4.7456422 42.6583929,5.11100917 42.1586786,5.34793578 C40.3119643,6.22041284 36.95025,3.95619266 36.6740357,5.54954128 C36.5758929,6.09036697 36.98625,6.77110092 38.7941786,7.04311927 C40.9456071,7.36146789 42.1213929,7.18646789 45.1704643,7.61353211 C46.2320357,7.75527523 47.6508214,8.34243119 48.42075,9.13807339 C50.5533214,11.3291284 48.7610357,12.7438073 48.7610357,12.7438073 C48.7610357,12.7438073 49.0745357,12.0298165 48.7846071,11.6745413 C48.7846071,11.6745413 48.8563929,12.6155963 47.8353214,13.1527523 C45.9836786,14.1151376 41.6139643,12.0431193 41.6139643,12.0431193 C41.6139643,12.0431193 40.7568214,14.7325688 47.7073929,15.4199541 C50.5721786,15.7084862 52.0113214,15.1497706 53.1309643,15.5850917 C53.9818929,15.9119266 53.9086071,17.1699541 53.9086071,17.1699541 Z M12.4066929,9.94094037 C12.4943357,9.52075688 11.5077643,9.57534404 11.3513357,7.74896789 C11.3483357,7.68864679 12.1431214,8.60630734 12.6833357,6.54254587 C12.7489071,6.26387615 12.8736214,5.72006881 13.33605,5.58818807 C13.0546929,4.55034404 13.6699071,3.29736239 13.6699071,3.29736239 C13.6699071,3.29736239 13.8931929,3.46594037 14.22255,3.56112385 C14.5208357,3.65263761 14.9142643,3.65470183 15.0921214,3.95974771 C15.0921214,3.95974771 15.5168357,3.77626147 15.9042643,3.06227064 C16.2942643,2.34461009 16.9454786,2.36135321 16.9454786,2.36135321 C16.9454786,2.36135321 16.7566929,3.32924312 17.3061214,3.35103211 C17.70405,3.36777523 17.96655,3.10883028 18.5442643,2.81364679 C19.1389071,2.49988532 19.88355,2.52832569 19.88355,2.52832569 C19.88355,2.52832569 19.2106929,3.63612385 19.7821929,3.97167431 C20.6112643,4.45194954 21.1624071,3.48451835 21.82755,3.71456422 C21.82755,3.71456422 21.2513357,4.63887615 21.7883357,5.21777523 C22.3722643,5.83864679 23.0624786,4.67236239 23.0624786,4.67236239 C23.0624786,4.67236239 23.4869786,6.31066514 23.1404786,7.20974771 C23.0749071,7.38497706 22.82505,7.78887615 22.82505,7.78887615 C22.82505,7.78887615 23.3669786,8.78658257 23.08605,9.8228211 C22.5379071,11.8948394 23.0781214,12.4854358 23.0781214,12.4854358 C23.0781214,12.4854358 21.7431214,12.9425459 21.6151929,11.5877294 C21.59955,11.3606651 21.3683357,11.4193807 21.3683357,11.9134174 C21.3683357,12.4700688 21.8116929,14.0551606 20.5392643,15.5264908 C20.3224071,14.3822248 19.7243357,14.7927752 19.3621929,15.4998853 C18.2506929,17.678555 17.7087643,17.6303899 17.7087643,17.6303899 C17.7087643,17.6303899 18.0584786,16.5143349 17.2936929,17.378555 C16.1899071,18.6232798 15.5652643,18.6466743 15.5652643,18.6466743 C15.5652643,18.6466743 14.8737643,18.1145642 14.4582643,16.6579128 C14.2992643,16.0975917 13.9227643,16.9267202 13.9227643,16.9267202 C13.9227643,16.9267202 13.3328357,16.2875 13.4558357,14.9345183 C13.4558357,14.9345183 13.0238357,15.4533257 12.3569786,15.4365826 C12.3569786,15.4365826 12.5944071,15.0512615 12.27405,14.000344 C11.9541214,12.9741972 12.34905,12.5290138 12.15705,11.8647936 C11.9369786,11.1058486 11.39505,11.0154817 11.3686929,9.73772936 C11.3686929,9.73772936 12.2849786,10.5182339 12.4066929,9.94094037 Z M14.56605,14.4705275 L14.56605,14.4803899 C14.5724786,15.1251147 15.0859071,15.5083716 15.6151929,15.6384174 C15.7356214,15.6716743 15.8556214,15.6918578 15.9743357,15.6918578 L15.97755,15.6918578 C16.4616214,15.6918578 16.8893357,15.3863532 17.0453357,14.8459862 C17.1998357,14.2987385 17.1514071,13.5776376 17.6918357,13.1475917 C18.19305,12.7358945 18.6908357,12.7042431 19.0251214,12.2634174 L19.1841214,12.0530963 L18.9404786,12.1150229 C18.9404786,12.1150229 18.7954071,12.1517202 18.46605,12.1847477 C18.3569786,12.1934633 18.1806214,12.2166284 17.9866929,12.2166284 C17.74305,12.2166284 17.4764786,12.1847477 17.2748357,12.096445 C17.0749071,11.9980505 16.9611214,11.8730505 16.9546929,11.627867 C16.9546929,11.5797018 16.9643357,11.5276376 16.9722643,11.4659404 C16.9966929,11.3606651 17.0532643,11.3141055 17.1593357,11.2776376 C17.2669071,11.2487385 17.4012643,11.2391055 17.5214786,11.2372706 C17.8527643,11.2260321 17.9414786,10.950344 17.9337643,10.8067661 C17.9337643,10.7416284 17.9241214,10.696445 17.9241214,10.6918578 L17.8977643,10.5847477 L17.8058357,10.628555 C17.8058357,10.628555 17.73855,10.6586009 17.6354786,10.6918578 C17.5249071,10.7186927 17.3699786,10.7501147 17.1966214,10.7501147 C17.0969786,10.7501147 16.9879071,10.7416284 16.8784071,10.7131881 C16.6471929,10.6586009 16.4629071,10.5333716 16.3459071,10.4198394 C16.2241929,10.3033257 16.1663357,10.2079128 16.1663357,10.2079128 L16.0917643,10.0946101 L16.01955,10.2012615 C16.0148357,10.2131881 15.94155,10.3264908 15.94155,10.4817661 C15.94155,10.5615826 15.9651214,10.6586009 16.0272643,10.7466743 C16.0994786,10.8436927 16.2147643,10.9120413 16.2709071,10.9652523 C16.3819071,11.0540138 16.4693357,11.1556193 16.4693357,11.2540138 C16.4629071,11.2776376 16.4616214,11.3008028 16.4536929,11.3287844 C16.3568357,11.6363532 16.1819786,11.7076835 15.9619071,11.7180046 C15.63855,11.7180046 15.2498357,11.4975917 15.1812643,11.4572248 C15.02655,11.3475917 14.9142643,11.2441514 14.8409786,11.168922 C14.7721929,11.0891055 14.7471214,11.0404817 14.7471214,11.0404817 L14.6301214,10.8436927 L14.5849071,11.075344 L14.5849071,11.1170872 C14.5849071,11.2322248 14.6301214,11.5728211 15.0501214,12.1847477 C15.1733357,12.3551606 15.21855,12.5290138 15.21855,12.6904817 C15.2277643,13.2845183 14.5801929,13.8815367 14.56605,14.4705275 Z M14.7659786,7.06318807 C14.7659786,7.08818807 14.7627643,7.11961009 14.7627643,7.15997706 C14.7659786,7.4184633 14.8161214,8.09598624 15.37005,8.47442661 L15.4028357,8.49805046 C15.6606214,8.66295872 15.9522643,8.69002294 16.1491929,8.69002294 L16.28655,8.69002294 C16.2786214,8.75470183 16.25055,8.88497706 16.17555,9.10883028 C16.12755,9.21869266 16.1161929,9.31708716 16.1161929,9.40561927 C16.1161929,9.67580275 16.2818357,9.7858945 16.2974786,9.79094037 L16.3707643,9.83268349 L16.4112643,9.75745413 C16.4112643,9.75263761 16.7594786,9.17373853 16.8331929,8.63497706 C16.8391929,8.57305046 16.8436929,8.52305046 16.8436929,8.46961009 C16.8391929,7.87075688 16.3804071,7.65034404 16.3726929,7.64048165 L14.9487643,6.8978211 L14.9016214,6.86777523 L14.7848357,6.79438073 L14.7672643,7.00791284 L14.7659786,7.06318807 Z M18.0211929,8.92488532 C17.8696929,9.34048165 17.8568357,9.85080275 17.8568357,10.0395642 C17.8568357,10.0829128 17.8604786,10.109289 17.8604786,10.109289 L17.8604786,10.1998853 L17.9461929,10.1998853 L17.9476929,10.1998853 C17.9541214,10.2012615 17.9618357,10.2012615 17.96655,10.2012615 C18.0492643,10.2012615 18.3132643,10.1161697 18.3726214,9.6875 C18.4086214,9.45584862 18.4459071,9.33520642 18.46605,9.26387615 C18.6001929,9.36525229 18.92805,9.57534404 19.2981214,9.5787844 L19.3152643,9.5787844 L19.3701214,9.57534404 C20.1319071,9.52901376 20.4989786,8.77672018 20.5454786,8.67327982 L20.57055,8.61961009 L20.57055,8.61479358 L20.5971214,8.56295872 L20.6581929,8.42626147 L20.45655,8.43107798 L18.8796214,8.3125 L18.8391214,8.3125 C18.7049786,8.30768349 18.2303357,8.36433486 18.0211929,8.92488532 Z M15.5370214,15.1727064 C14.5005214,14.8105505 15.2481643,13.7745413 15.3808071,13.4926606 C15.5168786,13.1924312 15.6400929,12.8188073 15.5526643,12.4798165 C15.5278071,12.3694954 15.4260214,12.1107798 15.28245,11.9224771 C15.7990929,12.209633 16.26795,12.1545872 16.5488786,12.0112385 C16.7702357,12.528211 17.5665214,12.6116972 17.9676643,12.5548165 C17.8146643,12.6901376 16.96245,12.7431193 16.8081643,14.0483945 C16.7813786,14.2917431 16.6815214,15.5795872 15.5370214,15.1727064 Z\" id=\"icon-stacked-lions_path-3\" />\n        <path d=\"M39.5755807,22.3525 C39.0164964,22.0639679 38.9204241,21.4240596 38.9384241,21.3132798 C36.7762554,21.5020413 36.7170506,22.6465367 36.7170506,22.6465367 C36.7170506,22.6465367 36.3169301,22.3703899 36.5166651,21.4098394 C36.6049301,20.9775 35.6572193,22.4385092 35.3765928,21.5075459 C34.7340145,21.6669495 34.8235807,22.536445 34.8235807,22.536445 C34.8235807,22.536445 34.364906,22.4284174 34.3492916,21.664656 C34.3492916,21.664656 34.3720627,21.1619037 34.0190024,21.5882798 C33.828159,21.8208486 33.7886892,22.0967661 33.7826169,22.0891972 C33.4067855,21.8309404 33.3139663,21.1901147 33.3139663,21.1901147 C33.2152916,21.6953899 32.3647373,22.783922 31.5154843,22.4167202 L31.511147,22.4167202 C31.4222313,22.8249771 31.6193639,23.1258945 31.6193639,23.1258945 C31.4009783,23.0119037 30.9997735,22.7967661 30.9854602,22.1905734 C30.9824241,22.086445 30.9947855,21.9758945 31.0238458,21.8706193 C30.6701349,20.9674083 31.5057253,20.5203899 31.2665205,20.6355275 C30.2904,21.0976835 29.6606169,20.721078 29.5545687,20.1777294 C29.1279904,20.2015826 28.9050506,20.5190138 28.9050506,20.5190138 C28.9349783,20.262133 28.9954843,19.7914908 29.5404723,19.5843807 L29.5404723,19.5825459 C29.609653,19.1543349 29.9247614,18.8254358 30.9004482,18.6586927 C30.7358458,18.3050229 30.8067614,17.9963073 30.9748337,17.7786468 C30.9850265,17.7625917 30.9997735,17.7511239 31.0084482,17.7414908 C30.6297976,17.4733716 30.2472434,17.6197018 30.2472434,17.6197018 C30.4070747,17.4272706 30.7063518,17.0655734 31.2678217,17.2054817 C31.403147,17.2412615 31.5469301,17.311445 31.6464723,17.4022706 C31.8947855,17.3563991 32.1777976,17.3658028 32.474906,17.4098394 C33.5468819,17.5706193 34.1755807,18.5252064 34.1755807,18.5252064 C34.1755807,18.5252064 34.5256048,18.5268119 35.3312675,18.5717661 C36.0085446,18.6132798 36.5424723,18.7586927 36.5424723,18.7586927 C34.0109783,17.7763532 34.6253639,16.0843807 34.6253639,16.0843807 C34.6253639,16.0843807 37.1709542,18.5222248 44.0519422,18.5559404 C44.0519422,18.5559404 44.5346892,19.6676376 43.1220145,19.9437844 C42.6338458,20.0424083 39.674906,20.1481422 39.5755807,22.3525 Z M22.8166699,10.3833257 C22.7075855,11.1305734 22.5646699,12.351445 23.1495614,13.0982339 C23.1495614,13.0982339 22.6262602,13.3730046 22.2935855,13.1502982 C21.829706,12.8372248 21.8999711,12.1076376 21.6796337,12.1544266 C21.4504048,12.2062615 21.6267181,12.8576376 21.7882843,13.6275917 C22.150453,15.3363073 20.9058506,16.2684174 20.9058506,16.2684174 C20.9058506,16.2684174 20.8600916,15.1725459 20.4974892,15.4289679 C20.1643807,15.6727752 20.2821398,16.698922 19.713947,17.048922 C19.2650313,17.3305734 18.9993687,17.7718578 18.9024289,18.2463991 C18.9024289,18.2463991 18.6079229,17.5269037 18.4671759,18.1945642 C18.3565735,18.7225459 18.306694,18.851445 18.0945976,18.9734633 C18.0945976,18.9734633 18.0896096,18.5060321 17.850188,18.4789679 C17.5439711,18.4438761 17.4507181,19.0030505 17.1416819,19.3906651 C16.6300916,20.0390596 15.7409349,19.8587844 15.4223566,19.8071789 C15.4223566,19.8071789 15.3555614,19.1415826 15.1243807,19.1321789 C14.8680434,19.1220872 14.9803807,19.8856193 14.9803807,19.8856193 C13.7945494,20.0530505 13.5479711,18.3106193 13.0561157,17.7195642 C12.7366699,17.3340138 12.2589108,17.8106193 12.2589108,17.8106193 C12.2589108,17.8106193 12.2248627,17.5842431 12.3387181,16.9640596 C12.4658024,16.2672706 12.3426217,16.104656 12.0897542,15.6963991 C11.8885012,15.3691055 11.3235614,14.927133 11.7297542,13.3147477 C11.7297542,13.3147477 10.9412241,13.9234633 10.6900916,11.9597018 C10.6900916,11.9597018 11.7520916,12.7025917 11.9639711,11.4326376 C11.9639711,11.4326376 10.9596578,12.361078 10.7764048,10.5308028 C10.7714169,10.4711697 11.479706,11.4819495 11.8056578,8.51887615 C11.9234169,7.47575688 12.3053205,6.83928899 13.0923325,6.83493119 C13.1140193,5.27598624 13.7791518,4.56084862 13.7938988,4.55947248 C14.6633205,4.52965596 15.2538506,6.42575688 15.4845976,5.03745413 C15.6765253,3.9087844 16.7133687,3.89525229 16.7133687,3.89525229 C16.3984771,4.6381422 16.7652,4.96979358 17.1291036,5.03103211 C17.8330554,5.15190367 17.7773205,3.97644495 18.9232482,3.75947248 C19.3877783,6.66428899 21.4536578,5.13676606 21.5323807,4.87300459 C21.5659952,5.79869266 21.1825735,6.18516055 21.1825735,6.18516055 C21.8123566,6.94135321 22.3840193,5.93538991 22.3840193,5.93538991 C22.3840193,5.93538991 22.8685012,7.19341743 22.6000193,8.12300459 C22.4456096,8.6587844 22.0385494,8.94272936 22.0385494,8.94272936 C22.0385494,8.94272936 23.0426458,8.8734633 22.8166699,10.3833257 Z M53.8448747,17.487156 C53.8448747,17.487156 53.4065855,16.7149083 53.6457904,17.6529817 C53.8058386,18.2889908 53.2513084,18.6043578 53.2513084,18.6043578 C53.2513084,18.6043578 53.3560554,18.0633028 53.0897422,18.1408257 C52.7455735,18.3045872 53.2948988,19.7855505 52.4168024,20.2876147 C52.4168024,20.2876147 52.5662241,19.7855505 52.1925614,19.7981651 C51.9099831,19.8316514 51.9297181,20.3461009 51.6948506,20.7470183 C51.2804169,21.5002294 50.9202,21.3711009 50.9202,21.3711009 C50.9202,21.3711009 51.1028024,20.9222477 50.8770434,20.7169725 C50.6543205,20.5103211 50.1353566,20.737844 50.1665855,21.4763761 C50.1665855,21.4763761 49.9395253,21.4697248 49.7541036,21.2745413 C49.5702,21.0738532 49.5582723,20.8543578 49.5582723,20.8543578 C49.5582723,20.8543578 49.2351398,20.6869266 49.0796458,21.781422 C48.9588506,22.6305046 48.3425133,23.6139908 47.6428988,23.5873853 C47.3859108,24.0816514 47.6220795,24.5075688 47.6220795,24.5075688 C47.4125855,24.3816514 47.0252602,24.1399083 47.0508506,23.5256881 C47.0508506,23.4766055 47.0571398,23.4197248 47.0688506,23.3681193 C47.004441,23.3048165 46.9476217,23.2194954 46.919212,23.0997706 C46.8266096,22.7949541 47.0072602,22.4176606 47.0972602,22.2529817 C47.0432602,22.3229358 46.9101036,22.4286697 46.6186337,22.5247706 C46.3555735,22.6213303 46.0686578,22.5295872 45.8682723,22.3272936 C45.3733807,22.5644495 45.3330434,23.0662844 45.3330434,23.0662844 C45.235453,22.833945 45.0491639,22.3970183 45.4046096,21.915367 C45.4568747,21.8444954 45.5228024,21.7779817 45.5943687,21.7229358 C45.5887301,21.6818807 45.5887301,21.6373853 45.5943687,21.5979358 C45.619959,21.1369266 45.8053807,21.0011468 46.1356699,20.8211009 C45.9053566,20.7770642 45.687188,20.6552752 45.5796217,20.4376147 C45.0430916,20.3821101 44.7661518,20.7894495 44.7661518,20.7894495 C44.7932602,20.5341743 44.8424892,20.0619266 45.3835735,19.8380734 C45.4360554,19.8174312 45.4976458,19.7981651 45.5572843,19.7889908 C45.5598867,19.7699541 45.564441,19.7559633 45.5737663,19.7383028 C45.9146819,18.7231651 48.6331157,20.1853211 48.7686578,19.1699541 C49.0436458,17.1729358 42.2886578,18.0442661 38.3143446,16.9137615 C34.5662241,15.843578 34.1068988,13.9055046 34.1068988,13.9055046 C34.1068988,13.9055046 31.0592602,12.3034404 28.4562,17.5172018 C23.1099831,28.2243119 13.935188,23.5740826 13.935188,23.5740826 C12.6717181,23.3451835 12.7584651,24.7245413 11.6730434,24.3344037 C12.063188,24.2458716 12.2097904,23.8399083 11.9391398,23.6568807 C11.4711398,23.3396789 11.3503446,24.1557339 10.4037181,24.1291284 C11.079694,23.4928899 10.5308024,23.0477064 10.5308024,23.0477064 C10.5308024,23.0477064 9.94005542,24.4922018 8.79499518,24.1291284 C8.79499518,24.1291284 9.18926024,23.9681193 9.34800723,23.5305046 C9.44386265,23.2639908 9.36297108,23.1231651 9.36297108,23.1231651 C9.36297108,23.1231651 8.37926024,24.1557339 7.31465783,23.7263761 C7.31465783,23.7263761 7.5388988,23.6756881 7.68094699,23.5447248 C7.87395904,23.3614679 7.91429639,23.1582569 7.83947711,23.0428899 C7.72128434,22.8550459 7.4762241,23.0667431 7.21598313,23.1832569 C6.94251325,23.3144495 6.48036867,23.4247706 6.20364578,23.1832569 C6.20364578,23.1832569 7.3521759,22.8139908 6.50118795,22.3731651 C6.05140482,22.1318807 5.26612771,22.0387615 4.35745301,22.5848624 C4.03128434,22.7745413 2.89186265,23.4646789 2.42993494,22.9401376 C1.98015181,23.181422 1.93677831,23.6506881 1.93677831,23.6506881 C1.84092289,23.4105505 1.65701928,22.968578 2.02916386,22.487156 C2.06082651,22.4444954 2.10398313,22.3986239 2.14432048,22.3575688 C2.08164578,21.9502294 2.37463373,21.6883028 2.6528747,21.5133028 C2.06971807,21.4876147 1.32195904,21.3993119 1.17253735,20.7094037 C0.617790361,20.6291284 0.291838554,21.018578 0.291838554,21.018578 C0.350175904,20.7300459 0.46533253,20.1965596 1.10812771,20.016055 C1.15453735,20.0022936 1.20398313,19.9942661 1.25364578,19.9848624 C1.37726024,19.583945 1.80969398,19.3864679 2.31499518,19.5061927 C2.43904337,19.5350917 2.62294699,19.5692661 2.76477831,19.5963303 C2.64658554,19.4259174 2.25665783,19.078211 2.4642,18.690367 C1.98882651,18.3380734 1.51800723,18.5513761 1.51800723,18.5513761 C1.68868193,18.3178899 2.01116386,17.8912844 2.66610361,18.0162844 C2.79318795,18.0396789 2.92634458,18.0917431 3.0415012,18.1678899 C3.41082651,18.0428899 4.01935663,18.1252294 4.78923614,18.9080275 C5.35612771,19.4545872 5.85709157,19.9561927 8.26258554,20.1738532 C9.40938072,20.2419725 10.2651398,20.0892202 11.5153807,19.8426606 C11.4329711,19.2768349 10.6340313,19.2360092 10.6340313,19.2360092 C10.6340313,19.2360092 10.0109711,19.1853211 9.89624819,18.8022936 C9.89624819,18.8022936 10.1254771,18.8461009 10.2924651,18.6538991 C10.4074048,18.5174312 10.3965614,18.2541284 10.1692843,18.0772936 C9.70323614,17.7243119 9.27969398,18.9298165 9.27969398,18.9298165 C8.69697108,18.5100917 8.9535253,17.8045872 8.9535253,17.8045872 C8.9535253,17.8045872 8.71800723,17.9135321 8.45060964,17.962844 C7.7468747,18.087844 7.42374217,17.6486239 7.42374217,17.6486239 C7.42374217,17.6486239 8.30986265,17.6284404 8.27928434,17.1844037 C8.27928434,17.1844037 7.00865783,17.6594037 6.14205542,16.8369266 C6.14205542,16.8369266 7.29297108,16.781422 7.02557349,16.3557339 C6.8835253,16.1272936 6.49836867,16.4098624 5.32338072,16.1736239 C4.54873012,16.0192661 4.41253735,15.5233945 4.41253735,15.5233945 C5.11670602,15.6724771 5.35677831,15.5082569 5.36870602,15.2626147 C5.38128434,14.965367 4.94473012,15.0504587 4.47716386,14.9048165 C3.81268193,14.6938073 3.44509157,14.2683486 1.85458554,14.8394495 C1.5108506,14.9633028 0.981477108,14.9272936 0.684585542,14.3883028 C0.187525301,14.5020642 0.0168506024,14.9341743 0.0168506024,14.9341743 C-0.0132939759,14.662844 -0.0601373494,14.1568807 0.44733253,13.7926606 C0.471404819,13.7740826 0.496344578,13.7619266 0.519549398,13.7495413 C0.579404819,13.0103211 1.56007952,12.8873853 1.74007952,12.8036697 C1.74007952,12.8036697 0.613019277,11.6623853 1.26101928,10.8344037 C1.25559759,10.8261468 1.25321205,10.8213303 1.25060964,10.8130734 C0.89733253,10.2256881 0.32393494,10.2784404 0.32393494,10.2784404 C0.55446506,10.1123853 0.983212048,9.80986239 1.56918795,10.1438073 C1.68868193,10.2107798 1.81641687,10.3075688 1.89839277,10.4220183 C2.49586265,9.9146789 3.35140482,10.8568807 3.7508747,11.3612385 C3.7508747,11.3612385 3.59798313,10.287844 4.18612771,9.99334862 C3.99962169,9.42568807 3.51362169,9.32155963 3.51362169,9.32155963 C3.76128434,9.23669725 4.22386265,9.08600917 4.66258554,9.54885321 C4.76451325,9.65229358 4.85473012,9.79082569 4.89745301,9.92614679 C5.84191084,10.3016055 5.62244096,11.2183486 5.61658554,12.143578 C5.61094699,13.1247706 8.46774217,14.3827982 10.837453,15.056422 C10.837453,15.056422 10.9654048,15.9362385 11.3173807,16.2516055 C11.8450193,16.7236239 11.8174771,17.5940367 11.6665373,18.9142202 C11.6665373,18.9142202 12.5595976,18.2091743 12.7654048,18.6557339 C12.9716458,19.1027523 13.177453,19.7908257 14.0015494,20.4043578 C14.0015494,20.4043578 14.9655253,21.0268349 16.2248747,20.7284404 C17.328947,20.5052752 17.3593084,19.7818807 17.5148024,19.7802752 C17.6492602,19.7818807 17.6208506,20.0672018 17.6208506,20.0672018 C17.7776458,20.0045872 18.3677422,20.0110092 18.5861277,19.412156 C18.7537663,18.9518349 18.9942723,19.4094037 18.9942723,19.4094037 C19.1983446,18.646789 19.4408024,18.2334862 19.9343928,17.8800459 C20.4579108,17.5016055 20.3082723,17.2646789 20.5173325,17.2236239 C20.6307542,17.2048165 20.6296699,17.5392202 20.6296699,17.5392202 C20.6296699,17.5392202 22.3676458,16.4043578 22.6148747,14.2327982 C24.8544651,14.8573394 27.7409711,9.27178899 35.2298386,9.23990826 C35.3606096,9.23944954 35.4928988,9.24266055 35.6271398,9.24770642 C39.9445373,9.2940367 42.355453,10.9071101 44.4545133,11.6809633 C47.4273325,12.7763761 49.611188,12.3951835 50.0219349,11.9137615 C50.4142482,11.4486239 50.7870434,9.91513761 47.7339831,9.34357798 C45.4748747,8.92178899 42.5189711,9.09701835 39.8668988,8.35298165 C38.9595253,8.09816514 36.9220554,7.90366972 36.1810193,6.84426606 C35.6707301,6.11490826 35.8680795,4.60229358 36.1270193,4.18394495 C36.3913807,3.76857798 37.2072361,3.07729358 37.2952843,2.15321101 C37.4518627,2.41422018 37.534706,2.86261468 37.521694,3.1309633 C38.0313325,2.88990826 38.8120554,3.01582569 38.8120554,3.01582569 C38.8120554,3.01582569 39.2160795,1.21055046 40.8742482,1.15665138 C44.1450434,1.06146789 43.2135976,0 43.2135976,0 C43.2135976,0 43.6009229,0.238990826 43.7286578,0.451834862 C44.0316217,0.967889908 43.8229952,1.40183486 43.1001759,1.78188073 C42.5194048,2.08211009 42.114947,1.91720183 42.114947,1.91720183 C42.114947,1.91720183 43.0221036,2.4690367 43.9633084,1.65940367 C44.6405855,1.09059633 44.4523446,0.386238532 44.4523446,0.386238532 C44.4523446,0.386238532 45.6763446,2.29105505 44.0485373,3.39288991 C42.7946096,4.23853211 42.2246819,3.91536697 42.2246819,3.91536697 C42.2246819,3.91536697 42.4506578,4.25 43.4961759,4.05665138 C44.0903928,3.95022936 44.3048747,3.70366972 44.5770434,3.46055046 C45.246947,2.86834862 46.1716699,3.35963303 46.1716699,3.35963303 C46.1716699,3.35963303 45.4492843,3.61926606 44.9745614,4.18600917 C43.6347542,5.77981651 41.5955494,5.78165138 40.3962723,5.25481651 C39.2906819,4.76857798 37.8899349,4.27889908 37.7715253,5.35114679 C37.611694,6.51261468 40.4819349,7.05389908 42.0197422,7.37844037 C45.5735494,8.12889908 47.1117904,7.43325688 50.7968024,8.4337156 C54.3842241,9.40779817 53.2567301,11.4915138 53.2567301,11.4915138 C53.2567301,11.4915138 52.6030916,10.0057339 52.0468265,10.0309633 C52.0468265,10.0309633 52.7132602,11.9293578 52.3350434,13.0736239 C52.147453,13.6715596 51.7295494,13.7488532 51.7295494,13.7488532 C52.0830434,12.9841743 51.7078627,12.890367 51.7078627,12.890367 C51.7078627,12.890367 51.2175253,14.1896789 48.9180795,14.4408257 C47.0202723,14.6488532 42.4808024,12.9956422 42.4808024,12.9956422 L41.3953807,12.7376147 C41.3253325,13.1993119 42.0082482,15.2582569 47.9074771,15.837156 C50.6467301,16.1087156 52.027959,15.5811927 53.1005855,15.9908257 C53.9136217,16.3013761 53.8448747,17.487156 53.8448747,17.487156 Z M20.2084048,10.2970872 L20.2695614,10.1649771 L20.0687422,10.1780505 L18.501441,10.1161239 L18.4942843,10.1158945 C18.450694,10.1147477 17.886188,10.1108486 17.6662843,10.7498394 C17.5825735,11.0058028 17.5541639,11.2911239 17.5459229,11.5156651 C17.5378988,11.7347018 17.5500434,11.8950229 17.5500434,11.8986927 L17.5541639,11.9853899 L17.6378747,11.9794266 C17.7016337,11.9853899 17.9913687,11.9280505 18.0332241,11.4817202 C18.0687904,11.2562615 18.0950313,11.1285092 18.1191036,11.0658945 C18.2455373,11.152133 18.5430795,11.3275917 18.8850795,11.3434174 C18.9085012,11.3443349 18.9468867,11.3438761 18.9687904,11.3429587 L19.021706,11.3337844 C19.7764048,11.2619954 20.1225253,10.514289 20.1587422,10.4122248 L20.1823807,10.3555734 L20.2084048,10.2970872 Z M18.7710072,13.9821789 L18.9150072,13.7785092 L18.6777542,13.8418119 C18.6777542,13.8418119 18.5320193,13.8902064 18.208453,13.9308028 C18.0622843,13.9459404 17.7877301,13.982867 17.5149108,13.9718578 C17.2967422,13.9631422 17.0722843,13.9273624 16.9228627,13.8347018 C16.776694,13.7404358 16.6903807,13.6175 16.6947181,13.3872248 C16.6960193,13.3562615 16.7012241,13.3179587 16.706212,13.2759862 C16.720959,13.1688761 16.7788627,13.1291972 16.886212,13.0890596 C16.9855373,13.0544266 17.1221639,13.0463991 17.2392723,13.0321789 C17.5389831,13.0115367 17.6419952,12.7789679 17.6361398,12.6344725 C17.6393928,12.5505275 17.6231277,12.4883716 17.6235614,12.4844725 L17.5925494,12.3830963 L17.5034169,12.4273624 C17.5034169,12.4273624 17.1956819,12.5844725 16.7957783,12.5663532 C16.7285494,12.5636009 16.6613205,12.5567202 16.5852,12.5422706 C16.3520675,12.4982339 16.1705494,12.3775917 16.0471518,12.2686468 C15.9237542,12.1594725 15.8615133,12.0649771 15.8610795,12.0688761 L15.7888627,11.9601606 L15.7212,12.0727752 C15.7136096,12.0782798 15.6535373,12.1736927 15.6483325,12.3158945 C15.6450795,12.4044266 15.6685012,12.5129128 15.7435373,12.6083257 C15.8200916,12.7016743 15.9309108,12.7583257 15.9929349,12.8145183 C16.1115614,12.9016743 16.2009108,12.9975459 16.1933205,13.105344 C16.192453,13.1225459 16.1922361,13.1397477 16.1857301,13.1647477 C16.0935614,13.4915826 15.8910072,13.558555 15.6450795,13.5580963 C15.3345253,13.5454817 14.9912241,13.364289 14.9307181,13.3273624 C14.7648145,13.2301147 14.6518265,13.1353899 14.5817783,13.0594725 C14.5060916,12.9851606 14.4800675,12.9397477 14.4800675,12.9436468 L14.361441,12.7544266 L14.3243566,12.9778211 L14.323706,12.9968578 C14.3206699,13.0773624 14.3412723,13.4168119 14.8188145,14.0493807 C14.9595614,14.2415826 15.0025012,14.4184174 14.9955614,14.6025917 C14.9901398,15.1523624 14.4362602,15.7165826 14.4089349,16.2631422 L14.4072,16.3170413 C14.433441,16.9447936 14.9539229,17.3099312 15.4813446,17.4179587 C15.5717783,17.4390596 15.6624289,17.452133 15.7496096,17.4560321 L15.7572,17.4560321 C16.2772482,17.4773624 16.7346217,17.1592431 16.8807904,16.5918119 C17.0172,16.0454817 16.9480193,15.3390596 17.4706699,14.8968578 C17.9553687,14.4821789 18.4524289,14.432867 18.7710072,13.9821789 Z M14.3757542,9.04983945 C14.3707663,9.19020642 14.3798747,9.99616972 15.0150795,10.4000688 L15.0523807,10.4230046 C15.2558024,10.5408945 15.4802602,10.5769037 15.662212,10.5844725 C15.7747663,10.5888303 15.873441,10.5812615 15.933947,10.5757569 C15.9296096,10.6408945 15.9046699,10.7709404 15.8365735,10.9908945 C15.8077301,11.0821789 15.7921157,11.164289 15.7895133,11.2408945 C15.7786699,11.5369954 15.9640916,11.6502982 15.9784048,11.6564908 L16.0532241,11.6941055 L16.0978988,11.6225459 C16.0983325,11.6154358 16.4177783,11.0301147 16.4737301,10.5016743 C16.4780675,10.4748394 16.4793687,10.4443349 16.4802361,10.4191055 C16.4999711,9.7778211 15.9981398,9.55373853 15.9875133,9.54708716 L14.544694,8.8658945 L14.5030554,8.84158257 L14.385947,8.76933486 L14.3783566,8.98080275 L14.376188,9.03470183 L14.3757542,9.04983945 Z M16.3005614,13.8319725 C16.5356458,14.3260092 17.3313325,14.3812844 17.7308024,14.3069725 C17.5818145,14.448945 16.7325614,14.5280734 16.6184892,15.8156881 C16.6022241,16.0537615 16.5399831,17.3221101 15.3966578,16.9698165 C14.3498386,16.6505505 15.0635494,15.5987156 15.1867301,15.3232569 C15.3157663,15.0207339 15.4242,14.646422 15.3231398,14.3191284 C15.2925614,14.2143119 15.1884651,13.9677523 15.0401277,13.7888532 C15.5660313,14.046422 16.0238386,13.980367 16.3005614,13.8319725 Z\" id=\"icon-stacked-lions_path-5\" />\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g transform=\"translate(-775.000000, -2927.000000)\">\n            <g transform=\"translate(646.000000, 2865.000000)\">\n                <g transform=\"translate(129.000000, 62.000000)\">\n                    <g id=\"icon-stacked-lions_Lion-1\">\n                        <mask id=\"icon-stacked-lions_mask-2\" fill=\"white\">\n                            <use xlink:href=\"#icon-stacked-lions_path-1\" />\n                        </mask>\n                        <use fill=\"#E30521\" fill-rule=\"evenodd\" xlink:href=\"#icon-stacked-lions_path-1\" />\n                        <g id=\"icon-stacked-lions_Colour/red\" mask=\"url(#icon-stacked-lions_mask-2)\" fill=\"#E11917\" fill-rule=\"evenodd\">\n                            <rect x=\"0\" y=\"0\" width=\"54\" height=\"25\" />\n                        </g>\n                    </g>\n                    <g transform=\"translate(0.000000, 49.000000)\">\n                        <g transform=\"translate(0.000000, 0.229358)\">\n                            <mask id=\"icon-stacked-lions_mask-4\" fill=\"white\">\n                                <use xlink:href=\"#icon-stacked-lions_path-3\" />\n                            </mask>\n                            <use fill=\"#E30521\" xlink:href=\"#icon-stacked-lions_path-3\" />\n                            <g mask=\"url(#icon-stacked-lions_mask-4)\" fill=\"#E11917\">\n                                <g transform=\"translate(0.000000, -0.229358)\">\n                                    <rect x=\"0\" y=\"0\" width=\"54\" height=\"25\" />\n                                </g>\n                            </g>\n                        </g>\n                    </g>\n                    <g transform=\"translate(0.000000, 97.000000)\">\n                        <g transform=\"translate(0.000000, 0.229358)\">\n                            <mask id=\"icon-stacked-lions_mask-6\" fill=\"white\">\n                                <use xlink:href=\"#icon-stacked-lions_path-5\" />\n                            </mask>\n                            <use fill=\"#E30521\" xlink:href=\"#icon-stacked-lions_path-5\" />\n                            <g mask=\"url(#icon-stacked-lions_mask-6)\" fill=\"#E11917\">\n                                <g transform=\"translate(0.000000, -0.229358)\">\n                                    <rect x=\"0\" y=\"0\" width=\"54\" height=\"25\" />\n                                </g>\n                            </g>\n                        </g>\n                    </g>\n                </g>\n            </g>\n        </g>\n    </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-status_error_warning",
  "use": "icon-status_error_warning-usage",
  "viewBox": "0 0 25.465 25.465",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25.465 25.465\" id=\"icon-status_error_warning\">\n  <path id=\"icon-status_error_warning_np_warning_2849764_000000\" d=\"M17.519,4.8A12.733,12.733,0,1,0,30.266,17.519,12.7,12.7,0,0,0,17.519,4.8Zm0,20.26a1.238,1.238,0,1,1,1.238-1.238A1.213,1.213,0,0,1,17.519,25.06Zm1.266-5.15a1.238,1.238,0,1,1-2.475,0V11.188a1.238,1.238,0,1,1,2.475,0Z\" transform=\"translate(-4.801 -4.801)\" fill=\"#c83532\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-status_success_tick",
  "use": "icon-status_success_tick-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\" id=\"icon-status_success_tick\">\n  <path id=\"icon-status_success_tick_np_tick_801900_000000\" d=\"M14.5,2A12.5,12.5,0,1,0,27,14.5,12.5,12.5,0,0,0,14.5,2Zm6.432,9.479-7.343,7.37a1.327,1.327,0,0,1-.911.391,1.221,1.221,0,0,1-.911-.391l-3.7-3.7A1.308,1.308,0,0,1,9.917,13.3l2.761,2.761L19.11,9.631a1.29,1.29,0,0,1,1.849,0,1.313,1.313,0,0,1-.027,1.848Z\" transform=\"translate(-2 -2)\" fill=\"#3d7e40\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-thefa",
  "use": "icon-thefa-usage",
  "viewBox": "0 0 44 80",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 80\" id=\"icon-thefa\">\n  <title>thefa</title>\n  <path d=\"M20,79c-.15,0-.26,0-.38,0a2.25,2.25,0,0,0-.44,0h-.41c-.15,0-.26,0-.41,0h-.74a.82.82,0,0,0-.26,0h-.21c0-.06-.06-.14-.09-.2-.12-.23-.21-.46-.32-.66a0,0,0,0,0,0,0,.42.42,0,0,1-.12-.26.16.16,0,0,1-.09-.14.21.21,0,0,0-.06-.11l-.09-.17-.18-.4s0-.06,0-.09,0,0,0-.06-.09-.17-.15-.26a.06.06,0,0,0-.06-.06v1.29a.92.92,0,0,1,0,.29,3.07,3.07,0,0,0,0,.52v.29H15l-.85,0h-.77a1.12,1.12,0,0,1-.32,0,.1.1,0,0,1-.06,0V78.8a3,3,0,0,1,0-.52V78.2a.22.22,0,0,1,0-.11v-.23a.68.68,0,0,1,0-.34v-1c0-.2,0-.37,0-.57v-.14c0-.14,0-.29,0-.43v-.89a4.65,4.65,0,0,1,0-.66v-.86c0-.17,0-.34,0-.52v-.52a1,1,0,0,0,0-.32V71h.32a1.45,1.45,0,0,0,.5,0,.27.27,0,0,1,.15,0h.15c.06,0,.15,0,.27,0a.83.83,0,0,0,.26,0H15a.27.27,0,0,1,.21,0l.12,0h.06a.66.66,0,0,0,.24,0h.12a1.25,1.25,0,0,0,.32,0h1.21a.81.81,0,0,1,.26,0,2,2,0,0,1,.41,0,1.5,1.5,0,0,1,.32.11c.15.09.26.2.41.29a1.13,1.13,0,0,1,.3.23l0,0c.06.11.15.14.24.23a.88.88,0,0,1,.21.26,1.2,1.2,0,0,0,.15.2.1.1,0,0,0,0,.06.21.21,0,0,1,.06.11.1.1,0,0,0,0,.06,2.62,2.62,0,0,1,.15.52.67.67,0,0,0,.06.23.78.78,0,0,1,0,.37v.09a.67.67,0,0,1,0,.34c0,.06,0,.09,0,.14s-.06.2-.06.29,0,.09,0,.11-.06.11-.09.17-.17.27-.26.4l0,0,0,0a.52.52,0,0,1-.15.2l-.18.17-.12.11a1.68,1.68,0,0,0-.24.23.71.71,0,0,0,.12.26s0,0,0,.06.15.29.21.43,0,.09.06.14l.18.34a1.49,1.49,0,0,1,.15.32,1.26,1.26,0,0,1,.09.2c.09.11.12.29.21.43s0,.06.06.09,0,.06.06.11.06.09.06.11,0,.09.06.11,0,0,0,.06A.21.21,0,0,0,20,79M15.91,74.7h.15l.32-.09c.06,0,.09-.06.12-.06a.24.24,0,0,0,.15-.14c0-.06,0-.09.06-.14v-.09c0-.06,0-.11,0-.2v-.2a1.68,1.68,0,0,0,0-.37.43.43,0,0,0-.09-.2s0,0-.06-.06l-.12-.09a.38.38,0,0,0-.29-.11h0a.33.33,0,0,0-.23,0s0,.06,0,.09v1.55s0,.06.06.11M4.83,74.63l-1.68.05c-.05.05-.05.14-.08.22v.86c0,.4,0,.81,0,1.21v.51a.59.59,0,0,1,0,.22v.08A.53.53,0,0,1,3,78H2.82a2.49,2.49,0,0,1-.43,0H1.25a.17.17,0,0,0-.11,0L1,78h-1S0,78,0,78v-.51a.4.4,0,0,1,0-.19V76c0-.19,0-.4,0-.59v-.65a6.58,6.58,0,0,1,0-.73.16.16,0,0,0,0-.11v-.38a1.66,1.66,0,0,1,0-.35,1.7,1.7,0,0,0,0-.38V72.6a3.84,3.84,0,0,1,0-.57v-.86a1,1,0,0,0,0-.27.74.74,0,0,1,0-.24v-.35A1,1,0,0,0,0,70v-.49a1.54,1.54,0,0,1,0-.35v-.08l.24-.05.19,0H.73a4.83,4.83,0,0,1,.62,0,.47.47,0,0,0,.19,0h.38a2.05,2.05,0,0,1,.41,0H3.74l.54,0h.05c.08.05.16,0,.27,0A2.05,2.05,0,0,1,5,69l.46,0a.76.76,0,0,0,.24,0h.43a.46.46,0,0,1,.19,0H7c0,.14-.08.27-.11.4a.81.81,0,0,1-.11.22l-.08.19-.08.22c-.05.16-.14.35-.19.51s-.14.32-.19.49a.81.81,0,0,1-.11.22H5a4,4,0,0,0-.57,0,.46.46,0,0,0-.19,0H3.12s0,0-.05,0v1a.1.1,0,0,0,.08,0h.76a.35.35,0,0,1,.16,0,1.32,1.32,0,0,0,.46,0h.19l.54,0h.41a.2.2,0,0,1,0,.11,1.67,1.67,0,0,1-.11.22s0,0,0,0-.05.08-.08.14a1.91,1.91,0,0,1-.11.27,1.87,1.87,0,0,0-.14.35,1.85,1.85,0,0,1-.08.22s0,.05,0,.08S5,73.92,5,74s-.14.32-.19.46,0,.11-.05.13.08,0,.05.05m7.15.19v.33a.82.82,0,0,1,0,.25.38.38,0,0,1,0,.17v.25c0,.17,0,.33-.05.5s0,.06,0,.06a2.2,2.2,0,0,0-.1.44.41.41,0,0,1-.05.17,1.67,1.67,0,0,1-.1.33s0,.06-.05.08,0,.06-.05.11a.61.61,0,0,1-.08.14,1.13,1.13,0,0,0-.1.19,2.53,2.53,0,0,1-.23.28c-.05,0-.08.08-.1.11l0,0a2.26,2.26,0,0,1-.26.22.46.46,0,0,0-.18.14s0,0-.05,0a1.71,1.71,0,0,0-.31.17s-.08,0-.1.06a1.8,1.8,0,0,1-.36.11c-.08,0-.15,0-.26,0H9.07a1.46,1.46,0,0,1-.36,0,.71.71,0,0,1-.23-.06l-.15-.06c-.05,0-.08,0-.13,0s-.08,0-.1,0H8a.94.94,0,0,1-.39-.14.09.09,0,0,1-.05,0,1.93,1.93,0,0,0-.34-.17,1.27,1.27,0,0,1-.36-.31.48.48,0,0,0-.1-.14.71.71,0,0,1-.13-.17.38.38,0,0,1-.08-.11l-.13-.22a1.07,1.07,0,0,1-.16-.31c0-.08-.05-.19-.08-.28s-.05-.14-.08-.22,0-.08,0-.11,0-.06,0-.08,0-.14,0-.19A2.29,2.29,0,0,0,6,75.93a2.52,2.52,0,0,1,0-.44V74.16c0-.19.08-.39.1-.58v0a1.25,1.25,0,0,1,.05-.31.52.52,0,0,1,0-.28c.05-.11.08-.19.13-.3a.41.41,0,0,0,.05-.17v-.06A1.25,1.25,0,0,1,6.64,72a.48.48,0,0,0,.1-.14,1.1,1.1,0,0,1,.31-.3l.1-.08.08-.06a4,4,0,0,1,.8-.3h.08a.7.7,0,0,1,.23-.06A1.25,1.25,0,0,1,8.68,71l.41,0h.28a1.2,1.2,0,0,0,.31,0l.23,0a.36.36,0,0,1,.15.06c.05,0,.08.06.13.06a2.57,2.57,0,0,1,.49.19l.23.17a5.75,5.75,0,0,1,.41.44,1.15,1.15,0,0,1,.13.19s0,0,0,0a.89.89,0,0,0,.15.36.17.17,0,0,1,0,.11.17.17,0,0,0,0,.11,3,3,0,0,1,.13.44c0,.11.05.19.08.31s0,.17.05.25,0,.08,0,.11a1.56,1.56,0,0,1,0,.36v.39a.43.43,0,0,0,0,.17m-2.52-.91a.33.33,0,0,0-.08-.22l0,0a1.29,1.29,0,0,0-.1-.19.26.26,0,0,0-.13-.11.41.41,0,0,0-.31.06.27.27,0,0,0-.1.14c-.05.08-.08.17-.13.25s0,.06,0,.08a1.39,1.39,0,0,0-.1.44.27.27,0,0,1,0,.14.21.21,0,0,1,0,.11.22.22,0,0,1,0,.14c0,.06,0,.14,0,.19v.42c0,.14.05.28.05.42v.06a.5.5,0,0,1,0,.19.39.39,0,0,0,0,.17,1.05,1.05,0,0,0,.1.25s0,.06.05.08l.08.08a.5.5,0,0,0,.31.17.37.37,0,0,0,.39-.17l0,0a.35.35,0,0,0,.1-.22c0-.08,0-.17.05-.22s0-.22.05-.36a.82.82,0,0,1,0-.25V75c0-.08,0-.14,0-.22a1,1,0,0,0,0-.28.67.67,0,0,1,0-.22,1.93,1.93,0,0,0-.1-.42M44,73.3c0-.08,0-.16,0-.24v-.57a1.1,1.1,0,0,0,0-.3v0c0-.14,0-.27,0-.41a1.1,1.1,0,0,0,0-.3V71a1.12,1.12,0,0,0,0-.3V70.4a4,4,0,0,0,0-.57V68.34c0-.06,0-.14,0-.19v-.06h-.85l-.55,0h-.52c-.3,0-.63,0-.93,0a3.58,3.58,0,0,1-.55,0h-.22l-1.17,0h-.33a2.37,2.37,0,0,0-.44,0h-.38c-.08,0-.14,0-.22,0h-.08l-.3,0a1.09,1.09,0,0,1-.3,0h-1a1.83,1.83,0,0,0-.55,0h-.52a4.67,4.67,0,0,0-.63,0,.25.25,0,0,0-.14,0H34a.45.45,0,0,1-.19,0c-.14,0-.27,0-.41,0h-.6a.92.92,0,0,1-.27,0c-.08,0-.14,0-.22,0h-.22a1.8,1.8,0,0,1-.38,0H30a1.7,1.7,0,0,0-.35,0h-1a1.58,1.58,0,0,1-.35,0l-.33,0h-.49l-.16,0h-.57l-.38,0L26,68H24.63c-.06,0-.11,0-.16,0h-.93a1.35,1.35,0,0,1-.33,0,1.55,1.55,0,0,0-.35,0c-.06,0-.11,0-.16,0h-.06a.93.93,0,0,1-.27,0h-.06a2.68,2.68,0,0,0-.46,0H21v.3a.66.66,0,0,1,0,.32c0,.05,0,.11,0,.16v.46a.87.87,0,0,1,0,.27.2.2,0,0,0,0,.14v.14s0,.08,0,.14V70a1.49,1.49,0,0,0,0,.35v.11c0,.08-.06.14,0,.22a.58.58,0,0,0,0,.22v.3a.57.57,0,0,0,0,.22v1.25a2.33,2.33,0,0,1,0,.43v.32a.3.3,0,0,1,0,.22v.49a.53.53,0,0,1,0,.35,2,2,0,0,1,0,.41v1.28a.59.59,0,0,0,0,.22,1.13,1.13,0,0,1,0,.14v.6a.74.74,0,0,1,0,.24.89.89,0,0,1,0,.27,3,3,0,0,0,0,.49c0,.11,0,.24,0,.35v.76a.92.92,0,0,1,0,.27v.43h1.17l.46,0h.55l.25,0h2.21L26,80h.49L27,80h2.43c.05,0,.11,0,.16,0H32c.05,0,.11,0,.16,0h.63l.11,0H34c.06,0,.08,0,.14,0h.71a.47.47,0,0,0,.27,0c.06,0,.08,0,.11,0h.49a.21.21,0,0,0,.14,0h.22l.41,0h2.18a3,3,0,0,0,.49,0h2.1l.19,0h.25a1.34,1.34,0,0,0,.33,0h.35a2.1,2.1,0,0,1,.41,0h.22l.27,0a2.51,2.51,0,0,0,.44,0s.06,0,.06,0v0c0-.19,0-.38,0-.54a1.51,1.51,0,0,1,0-.35v-.08a1.13,1.13,0,0,1,0-.3v-.3a1.78,1.78,0,0,1,0-.38V75a2.49,2.49,0,0,1,0-.43V74.3c0-.08,0-.16,0-.22s0-.19,0-.3.06-.3.06-.49m-13.3,5.15h-.41a.25.25,0,0,0-.14,0,.21.21,0,0,0-.11,0,.46.46,0,0,0-.19,0h-.06l-.44,0h-.14a.69.69,0,0,1-.22,0,1.34,1.34,0,0,1-.33,0h-.41s0,0,0-.05-.06-.24-.08-.38,0-.05,0-.08v0c0-.08,0-.16-.06-.22s0,0,0-.05a.38.38,0,0,1-.06-.16s0-.05,0-.08,0-.11-.06-.19,0-.08,0-.11a.14.14,0,0,0-.06-.11.61.61,0,0,1-.22,0l-.52,0h-.22a.45.45,0,0,0-.19,0h-.85c-.05,0-.08,0-.14,0a.09.09,0,0,0,0,.05,1.7,1.7,0,0,0-.08.22.24.24,0,0,0,0,.14s0,0,0,.05,0,.08-.06.14a.69.69,0,0,1-.14.33,3.06,3.06,0,0,1-.11.49c-.08,0-.14,0-.22,0-.44,0-.87,0-1.31,0-.06,0-.14,0-.19,0h-.93a.46.46,0,0,1-.19,0s0-.05,0-.08,0-.08,0-.11v0c0-.05,0-.08.06-.14a.21.21,0,0,0,0-.14s0-.08,0-.11a.09.09,0,0,1,0-.05v-.08c.08-.08.08-.22.11-.33s0-.16.05-.22,0,0,0-.05a1,1,0,0,0,.08-.3l.08-.22.08-.24v0A.73.73,0,0,1,23.1,76a2.17,2.17,0,0,1,.14-.38c0-.05,0-.08.05-.14s0,0,0-.05c.05-.24.11-.46.16-.68a.79.79,0,0,0,.06-.27.64.64,0,0,0,.06-.22l.08-.38a3.84,3.84,0,0,1,.14-.54l.16-.57a.38.38,0,0,0,.05-.16,4.2,4.2,0,0,1,.19-.79c0-.11,0-.19.05-.3l.08-.35c0-.05,0-.11.06-.16l.08-.41c0-.11,0-.22.05-.33a.5.5,0,0,1,.06-.19c.05-.14.08-.3.14-.43a.21.21,0,0,1,.06-.11h0a.5.5,0,0,0,.27,0,.35.35,0,0,1,.16,0h.87a2.53,2.53,0,0,1,.44,0h.22a.61.61,0,0,1,.22,0h.36a.46.46,0,0,1,.19,0s0,0,.06,0a.18.18,0,0,0,.16,0h.49s0,0,.06,0a.08.08,0,0,0,.05,0l0,0h.16a.09.09,0,0,1,0,.05c0,.08.05.19.08.27a.1.1,0,0,0,0,.08c0,.05,0,.08,0,.14l.08.25s0,0,0,.05a2.34,2.34,0,0,1,.11.41.2.2,0,0,0,.05.11A.1.1,0,0,1,29,71v0a1.53,1.53,0,0,1,.11.32c.11.41.25.79.35,1.19,0,.11.05.25.08.35.05.27.14.57.22.84l.08.33s0,.06,0,.06a1.52,1.52,0,0,1,.11.32c0,.14.08.3.11.43s0,.14.05.19v0a3.84,3.84,0,0,1,.14.54c.05.19.08.41.14.6s.06.22.08.35a.79.79,0,0,1,.06.24,1.7,1.7,0,0,0,.11.35c0,.06,0,.08,0,.14s0,.14.06.19.06.16.08.27v.08c0,.08,0,.16,0,.22a1.11,1.11,0,0,1,.08.43.5.5,0,0,0-.27-.05m6.12-1.87s0,0,0,.05-.11.32-.16.46l-.08.25c-.06.11-.08.24-.14.35s0,.05,0,.08a2.92,2.92,0,0,1-.22.51l-.08.16H34.13c-.25,0-.52,0-.76,0h-.06a.25.25,0,0,1-.14,0h-.76l-.16,0a.21.21,0,0,0-.14,0,1.58,1.58,0,0,0-.35,0,.34.34,0,0,1,0-.16V78a1.54,1.54,0,0,1,0-.35v0a2.06,2.06,0,0,1,0-.41V77c0-.11,0-.19,0-.3V76.5a.74.74,0,0,1,0-.24V74.17a.6.6,0,0,0,0-.22v-.68a.34.34,0,0,0,0-.16v-.05a1.33,1.33,0,0,0,0-.33,4.39,4.39,0,0,0,0-.6v-.89a.34.34,0,0,1,0-.16h.06A.54.54,0,0,1,32,71a3.31,3.31,0,0,1,.52,0h.41a.26.26,0,0,0,.19-.06.34.34,0,0,0,.17,0h.93a.35.35,0,0,1,.16,0h.35a.1.1,0,0,1,.08,0,1.8,1.8,0,0,1,0,.38v.11a.17.17,0,0,0,0,.11.53.53,0,0,1,0,.22v.41a6.9,6.9,0,0,0,0,.76v.54a.35.35,0,0,0,0,.16,1.1,1.1,0,0,1,0,.3v.38a2.8,2.8,0,0,1,0,.46c0,.11,0,.19,0,.3V76a.66.66,0,0,1,0,.32v.11a.76.76,0,0,1,.25,0c.08,0,.14,0,.22,0h.9l.16,0H37c-.11-.05-.14,0-.16.08m5.81-.11a3.18,3.18,0,0,0-.19.54,1.27,1.27,0,0,1-.16.41.17.17,0,0,0,0,.11l-.08.16a3.51,3.51,0,0,0-.22.71v0a.1.1,0,0,1-.08,0l-.16,0h-3a1.35,1.35,0,0,1-.33,0,.75.75,0,0,0-.24,0h-.36l-.16,0c0-.11,0-.19,0-.3,0-.27,0-.54,0-.81v-.46a.68.68,0,0,1,0-.22,1.68,1.68,0,0,1,0-.38V76a.6.6,0,0,1,0-.22v-.6c0-.14,0-.27,0-.41v-.27a1.06,1.06,0,0,1,0-.3v-.79s0-.08,0-.11v-.19s0,0,0-.05a2.26,2.26,0,0,0,0-.43v-.51a.73.73,0,0,0,0-.24v-.16c0-.05,0-.11,0-.14a1.32,1.32,0,0,1,0-.32v-.22h.46a3.7,3.7,0,0,1,.55,0,3.34,3.34,0,0,0,.52,0h.33a1.34,1.34,0,0,1,.33,0h.63a2.19,2.19,0,0,1,0,.73v0c0,.11,0,.22,0,.33v.05a1.33,1.33,0,0,1,0,.33,2.63,2.63,0,0,0,0,.46v.3a.35.35,0,0,1,0,.16v0a3.28,3.28,0,0,0,0,.51,1.54,1.54,0,0,1,0,.35v.54c0,.05,0,.14,0,.19v1.06a1,1,0,0,0,0,.27H42a.54.54,0,0,0,.22,0h.33c.05,0,.08,0,.08,0m-15.76-3v0a1.31,1.31,0,0,1-.08-.3,1.07,1.07,0,0,0-.08-.28v0s0-.09,0-.12,0-.12,0-.16,0-.21-.05-.3a1.2,1.2,0,0,0-.11-.28h0s0,0-.05.09,0,0,0,.09l-.08.26v0s0,.09,0,.14,0,.09,0,.14,0,.14,0,.21a.6.6,0,0,0-.05.21l-.08.37c0,.12-.05.23-.08.37S26,74,26,74h1l-.08-.28a.84.84,0,0,0-.05-.21M0,11V39A21.54,21.54,0,0,0,5.36,53.71C9.1,57.92,14.69,61.06,22,63c7.32-2,12.9-5.08,16.64-9.29A21.54,21.54,0,0,0,44,39V11ZM42.87,39c0,11.18-7.26,19.08-20.87,22.83C8.39,58.11,1.15,50.21,1.15,39V12.12H42.87ZM22,46.22c0-.09,0-.17,0-.2a.36.36,0,0,0-.25,0,1.25,1.25,0,0,0-.51.4s-.05.06-.05.09A1.16,1.16,0,0,0,21,47s.35-.2.61-.37c0,0,0-.06.1-.09s.2-.2.25-.32M20.27,45A1.42,1.42,0,0,0,20,46.19c.19.77.63.81.73.81s0-.07,0-.1A1.34,1.34,0,0,1,21,46.4a6.64,6.64,0,0,0-.08-.7c-.06-.25-.19-.53-.25-.7-.08.07-.19.07-.4,0M22,44.16a1.62,1.62,0,0,1-.13-.73v-.07a1,1,0,0,0-1.45-.11,1.34,1.34,0,0,0-.29,1.56c.13,0,.42.07.51.18a6.24,6.24,0,0,1,.61-.51,4.05,4.05,0,0,1,.74-.33M20.52,45a.79.79,0,0,0-.52,0,.73.73,0,0,0,.45.37c.25.11.4.07.48,0a.21.21,0,0,0,.08-.15s0-.07,0-.07a.66.66,0,0,0-.4-.18h0m2.18,1A4.1,4.1,0,0,0,22,46a7.12,7.12,0,0,0-.78.24.82.82,0,0,1-.14.26s0,0-.05.07a1.27,1.27,0,0,0,1.08.38c.7-.07.89-.5.92-.61l-.05,0c-.08-.12-.19-.24-.24-.33m.88-1c-.06,0-.11.1-.15.1a.82.82,0,0,1-.37.17,3.31,3.31,0,0,0-.06.53,4.49,4.49,0,0,0,0,.6,1.43,1.43,0,0,1,.24.4s0,0,0,.07,0,.1.06.13c.17,0,.54-.07.62-.87S23.67,45,23.58,45M24,43.85c0-.06.21-.56-.63-.78a1.93,1.93,0,0,0-1.33.11s0,.06,0,.09a.48.48,0,0,1,0,.39,3.71,3.71,0,0,0,.59.21l.63.13c.11,0,.28-.06.46-.09a.91.91,0,0,1,.28-.06m-1.49-.47a.16.16,0,0,0,0-.13.37.37,0,0,0-.26-.26s-.17.08-.17.38v0a1,1,0,0,0,.17.51.27.27,0,0,0,.13.05s.09-.05.13-.08a.71.71,0,0,0,0-.54m1.23,1.87c.15-.09.33-.22.3-.25a2.49,2.49,0,0,0-.37,0,.39.39,0,0,0-.17.06,1.86,1.86,0,0,0-.32.16.28.28,0,0,0-.12.19c0,.06,0,.06.1.06a2,2,0,0,0,.42-.16.25.25,0,0,0,.17-.09m0,1.21a1.56,1.56,0,0,0-.43-.38.22.22,0,0,0-.12-.06S23,46,23,46s0,.06,0,.13,0,.06,0,.13a2.56,2.56,0,0,0,.35.44l.08.06,0,0A.8.8,0,0,0,24,47a.61.61,0,0,0-.16-.35s-.08-.1-.12-.13,0-.06,0-.06M22,45.35a.59.59,0,0,1-.39.63.44.44,0,0,1-.59-.31A.59.59,0,0,1,21.4,45a.42.42,0,0,1,.59.31m15,.88c0-.09,0-.17,0-.2a.36.36,0,0,0-.25,0,1.25,1.25,0,0,0-.51.4s-.05.06-.05.09A1.16,1.16,0,0,0,36,47s.35-.2.61-.37c0,0,0-.06.1-.09a2.54,2.54,0,0,1,.25-.32M35.27,45A1.42,1.42,0,0,0,35,46.19c.19.77.63.81.73.81s0-.07,0-.1A1.34,1.34,0,0,1,36,46.4a6.64,6.64,0,0,0-.08-.7c-.06-.25-.19-.53-.25-.7-.06.07-.19.07-.4,0M38,44.16a1.62,1.62,0,0,1-.13-.73v-.07a1,1,0,0,0-1.45-.11,1.34,1.34,0,0,0-.29,1.56c.13,0,.42.07.51.18a6.24,6.24,0,0,1,.61-.51,3.28,3.28,0,0,1,.74-.33M35.53,45a.79.79,0,0,0-.53,0,.73.73,0,0,0,.45.37c.25.11.4.07.47,0a.21.21,0,0,0,.08-.15s0-.07,0-.07a.66.66,0,0,0-.4-.18h0m3.18,1A4.1,4.1,0,0,0,38,46a7.12,7.12,0,0,0-.78.24.82.82,0,0,1-.13.26s0,0-.05.07a1.27,1.27,0,0,0,1.08.38c.7-.07.89-.5.92-.61l-.05,0A1.89,1.89,0,0,1,38.7,46m-.12-1c-.06,0-.11.1-.15.1a.82.82,0,0,1-.37.17,3.31,3.31,0,0,0-.06.53,4.49,4.49,0,0,0,0,.6,1.43,1.43,0,0,1,.24.4s0,0,0,.07,0,.1.06.13c.17,0,.54-.07.62-.87S38.67,45,38.58,45M40,43.85c0-.06.21-.56-.63-.78a1.93,1.93,0,0,0-1.33.11s0,.06,0,.09a.48.48,0,0,1,0,.39,3.71,3.71,0,0,0,.6.21l.63.13c.11,0,.28-.06.46-.09a.91.91,0,0,1,.28-.06m-2.49-.47a.16.16,0,0,0,0-.13.37.37,0,0,0-.26-.26s-.17.08-.17.38v0a1,1,0,0,0,.17.51.27.27,0,0,0,.13.05s.09-.05.13-.08a.71.71,0,0,0,0-.54m1.23,1.87c.15-.09.33-.22.3-.25a2.49,2.49,0,0,0-.37,0,.39.39,0,0,0-.17.06,1.86,1.86,0,0,0-.32.16.28.28,0,0,0-.12.19c0,.06,0,.06.1.06a2,2,0,0,0,.42-.16.3.3,0,0,0,.17-.09m0,1.21a1.56,1.56,0,0,0-.43-.38.22.22,0,0,0-.12-.06S38,46,38,46s0,.06,0,.13,0,.06,0,.13a2.56,2.56,0,0,0,.35.44l.08.06,0,0A.8.8,0,0,0,39,47a.61.61,0,0,0-.15-.35s-.08-.1-.12-.13,0-.06,0-.06M38,45.35a.59.59,0,0,1-.39.63.44.44,0,0,1-.59-.31A.59.59,0,0,1,37.4,45a.42.42,0,0,1,.59.31M6,46.22C6,46.14,6,46,6,46a.36.36,0,0,0-.25,0,1.25,1.25,0,0,0-.51.4s-.05.06-.05.09A1.16,1.16,0,0,0,5,47s.35-.2.61-.37c.05,0,.05-.06.1-.09A1,1,0,0,0,6,46.22M4.27,45A1.42,1.42,0,0,0,4,46.19c.19.77.63.81.73.81s0-.07,0-.1A1.34,1.34,0,0,1,5,46.4a6.64,6.64,0,0,0-.08-.7c-.06-.25-.19-.53-.25-.7-.06.07-.19.07-.4,0M7,44.16a1.62,1.62,0,0,1-.13-.73v-.07a1,1,0,0,0-1.45-.11,1.34,1.34,0,0,0-.29,1.56c.13,0,.42.07.51.18a6.24,6.24,0,0,1,.61-.51A4.05,4.05,0,0,1,7,44.16M4.53,45a.79.79,0,0,0-.53,0,.73.73,0,0,0,.45.37c.25.11.4.07.47,0A.21.21,0,0,0,5,45.28s0-.07-.05-.07a.66.66,0,0,0-.4-.18h0M7.7,46A4.1,4.1,0,0,0,7,46a7.12,7.12,0,0,0-.78.24.82.82,0,0,1-.14.26s0,0-.05.07A1.27,1.27,0,0,0,7.08,47c.7-.07.89-.5.92-.61l-.05,0A1.89,1.89,0,0,1,7.7,46m.88-1c-.06,0-.11.1-.15.1a.82.82,0,0,1-.37.17A3.19,3.19,0,0,0,8,45.8a4.66,4.66,0,0,0,0,.6,1.42,1.42,0,0,1,.24.4s0,0,0,.07,0,.1.06.13c.17,0,.54-.07.63-.87S8.65,45,8.58,45M9,43.85c0-.06.21-.56-.63-.78A1.93,1.93,0,0,0,7,43.18s0,.06,0,.09a.48.48,0,0,1,0,.39,3.71,3.71,0,0,0,.6.21l.63.13c.11,0,.28-.06.46-.09A1.16,1.16,0,0,1,9,43.85m-2.49-.47a.16.16,0,0,0,0-.13A.37.37,0,0,0,6.17,43s-.17.08-.17.39v0a1,1,0,0,0,.17.51A.27.27,0,0,0,6.3,44s.09-.05.13-.08a.71.71,0,0,0,0-.54M8.7,45.25C8.85,45.16,9,45,9,45a2.49,2.49,0,0,0-.37,0,.39.39,0,0,0-.18.06,1.86,1.86,0,0,0-.32.16.28.28,0,0,0-.12.19c0,.06.05.06.1.06a2,2,0,0,0,.42-.16.39.39,0,0,0,.17-.09m-1,1.21a1.56,1.56,0,0,0-.43-.38A.22.22,0,0,0,7.15,46S7,46,7,46s0,.06,0,.13,0,.06,0,.13a2.56,2.56,0,0,0,.35.44l.08.06,0,0A.8.8,0,0,0,8,47a.61.61,0,0,0-.16-.35s-.08-.1-.12-.13a.09.09,0,0,1,0-.06M7,45.35A.59.59,0,0,1,6.6,46,.44.44,0,0,1,6,45.66.59.59,0,0,1,6.4,45a.42.42,0,0,1,.59.31M22,32.22c0-.09,0-.17,0-.2a.36.36,0,0,0-.25,0,1.25,1.25,0,0,0-.51.4s-.05.06-.05.09A1.16,1.16,0,0,0,21,33s.35-.2.61-.37c0,0,0-.06.1-.09s.2-.23.25-.32M20.27,31A1.42,1.42,0,0,0,20,32.19c.19.77.63.81.73.81s0-.07,0-.1A1.34,1.34,0,0,1,21,32.4a6.64,6.64,0,0,0-.08-.7c-.06-.25-.19-.53-.25-.7-.08.07-.19.1-.4,0M22,30.16a1.62,1.62,0,0,1-.13-.73v-.07a1,1,0,0,0-1.45-.11,1.34,1.34,0,0,0-.29,1.56c.13,0,.42.07.51.18a6.24,6.24,0,0,1,.61-.51c.23-.11.55-.25.74-.33M20.52,30a.79.79,0,0,0-.52,0,.73.73,0,0,0,.45.37c.25.11.4.07.48,0a.21.21,0,0,0,.08-.15s0-.07,0-.07a.66.66,0,0,0-.4-.18h0m2.18,2A4.1,4.1,0,0,0,22,32a7.12,7.12,0,0,0-.78.24.82.82,0,0,1-.14.26s0,0-.05.07a1.27,1.27,0,0,0,1.08.38c.7-.07.89-.5.92-.61l-.05,0c-.08-.12-.19-.24-.24-.33m.88-2c-.06,0-.11.1-.15.1a.82.82,0,0,1-.37.16,3.22,3.22,0,0,0-.06.56,4.35,4.35,0,0,0,0,.59,1.39,1.39,0,0,1,.24.39s0,0,0,.07l.06.13c.17,0,.54-.07.62-.85S23.67,30,23.58,30m.38-.15c0-.06.21-.56-.63-.78a1.93,1.93,0,0,0-1.33.11s0,.06,0,.09a.48.48,0,0,1,0,.39,3.71,3.71,0,0,0,.59.2l.63.13c.11,0,.28-.06.46-.09a2.5,2.5,0,0,1,.28-.06m-1.49-.47a.16.16,0,0,0,0-.13.37.37,0,0,0-.26-.26s-.17.08-.17.39v0a1,1,0,0,0,.17.51.27.27,0,0,0,.13.05s.09-.05.13-.08a.74.74,0,0,0,0-.54m1.23.86c.15-.09.33-.22.3-.25a2.49,2.49,0,0,0-.37,0,.39.39,0,0,0-.17.06,1.86,1.86,0,0,0-.32.16.28.28,0,0,0-.12.19c0,.06,0,.06.1.06a2,2,0,0,0,.42-.16l.17-.09m0,2.21a1.56,1.56,0,0,0-.43-.38.22.22,0,0,0-.12-.06S23,32,23,32s0,.06,0,.13,0,.06,0,.13a2.56,2.56,0,0,0,.35.44l.08.06,0,0A.8.8,0,0,0,24,33a.61.61,0,0,0-.16-.35s-.08-.1-.12-.13,0,0,0-.06M22,31.33a.6.6,0,0,1-.39.64.44.44,0,0,1-.59-.32A.6.6,0,0,1,21.4,31a.46.46,0,0,1,.59.32M6,32.22C6,32.14,6,32,6,32a.36.36,0,0,0-.25,0,1.25,1.25,0,0,0-.51.4s-.05.06-.05.09A1.16,1.16,0,0,0,5,33s.35-.2.61-.37c.05,0,.05-.06.1-.09A2.52,2.52,0,0,0,6,32.22M4.27,31A1.42,1.42,0,0,0,4,32.19c.19.77.63.81.73.81s0-.07,0-.1A1.34,1.34,0,0,1,5,32.4a6.64,6.64,0,0,0-.08-.7c-.06-.25-.19-.53-.25-.7-.06.07-.19.1-.4,0M7,30.16a1.62,1.62,0,0,1-.13-.73v-.07a1,1,0,0,0-1.45-.11,1.34,1.34,0,0,0-.29,1.56c.13,0,.42.07.51.18a6.24,6.24,0,0,1,.61-.51c.22-.11.55-.25.74-.33M4.53,30a.79.79,0,0,0-.53,0,.73.73,0,0,0,.45.37c.25.11.4.07.47,0A.21.21,0,0,0,5,30.28s0-.07-.05-.07a.66.66,0,0,0-.4-.18h0M6.7,32A4.1,4.1,0,0,0,6,32a7.12,7.12,0,0,0-.78.24.82.82,0,0,1-.14.26s0,0-.05.07A1.27,1.27,0,0,0,6.08,33c.7-.07.89-.5.92-.61l-.05,0c-.08-.12-.19-.24-.24-.33m.88-2c-.06,0-.11.1-.15.1a.82.82,0,0,1-.37.16,3.22,3.22,0,0,0-.06.56,4.35,4.35,0,0,0,0,.59,1.39,1.39,0,0,1,.24.39s0,0,0,.07l.06.13c.17,0,.54-.07.62-.85S7.67,30,7.58,30M8,29.85c0-.06.21-.56-.63-.78A1.93,1.93,0,0,0,6,29.18s0,.06,0,.09a.48.48,0,0,1,0,.39,3.71,3.71,0,0,0,.6.2l.63.13c.11,0,.28-.06.46-.09A2.5,2.5,0,0,1,8,29.85m-1.49-.47a.16.16,0,0,0,0-.13A.37.37,0,0,0,6.17,29s-.17.08-.17.39v0a1,1,0,0,0,.17.51A.27.27,0,0,0,6.3,30s.09-.05.13-.08a.74.74,0,0,0,0-.54m1.23.86C7.85,30.16,8,30,8,30a2.49,2.49,0,0,0-.37,0,.39.39,0,0,0-.18.06,1.86,1.86,0,0,0-.32.16.28.28,0,0,0-.12.19c0,.06.05.06.1.06a2,2,0,0,0,.42-.16l.17-.09m0,2.21a1.56,1.56,0,0,0-.43-.38A.22.22,0,0,0,7.15,32S7,32,7,32s0,.06,0,.13,0,.06,0,.13a2.56,2.56,0,0,0,.35.44l.08.06,0,0A.8.8,0,0,0,8,33a.61.61,0,0,0-.16-.35s-.08-.1-.12-.13,0,0,0-.06M7,31.33A.6.6,0,0,1,6.6,32,.44.44,0,0,1,6,31.65.6.6,0,0,1,6.4,31a.46.46,0,0,1,.59.32m31,.89c0-.09,0-.17,0-.2a.36.36,0,0,0-.25,0,1.25,1.25,0,0,0-.51.4s-.05.06-.05.09A1.16,1.16,0,0,0,37,33s.35-.2.61-.37c0,0,0-.06.1-.09a2.52,2.52,0,0,0,.25-.32M36.27,31A1.42,1.42,0,0,0,36,32.19c.19.77.63.81.73.81s0-.07,0-.1A1.34,1.34,0,0,1,37,32.4a6.64,6.64,0,0,0-.08-.7c-.06-.25-.19-.53-.25-.7-.06.07-.19.1-.4,0M38,30.16a1.62,1.62,0,0,1-.13-.73v-.07a1,1,0,0,0-1.45-.11,1.34,1.34,0,0,0-.29,1.56c.13,0,.42.07.51.18a6.24,6.24,0,0,1,.61-.51c.26-.11.55-.25.74-.33M36.53,30a.79.79,0,0,0-.53,0,.73.73,0,0,0,.45.37c.25.11.4.07.47,0a.21.21,0,0,0,.08-.15s0-.07,0-.07a.66.66,0,0,0-.4-.18h0m2.18,2A4.1,4.1,0,0,0,38,32a7.12,7.12,0,0,0-.78.24.82.82,0,0,1-.13.26s0,0-.05.07a1.27,1.27,0,0,0,1.08.38c.7-.07.89-.5.92-.61l-.05,0A1.89,1.89,0,0,1,38.7,32m.88-2c-.06,0-.11.1-.15.1a.82.82,0,0,1-.37.16,3.22,3.22,0,0,0-.06.56,4.35,4.35,0,0,0,0,.59,1.39,1.39,0,0,1,.24.39s0,0,0,.07l.06.13c.17,0,.54-.07.62-.85S39.67,30,39.58,30m.38-.15c0-.06.21-.56-.63-.78a1.93,1.93,0,0,0-1.33.11s0,.06,0,.09a.48.48,0,0,1,0,.39,3.71,3.71,0,0,0,.6.2l.63.13c.11,0,.28-.06.46-.09a1.54,1.54,0,0,1,.28-.06m-1.48-.47a.16.16,0,0,0,0-.13.37.37,0,0,0-.26-.26s-.17.08-.17.39v0a1,1,0,0,0,.17.51.29.29,0,0,0,.13.05s.09-.05.13-.08a1,1,0,0,0,0-.54m1.22.86c.15-.09.33-.22.3-.25a2.49,2.49,0,0,0-.37,0,.39.39,0,0,0-.17.06,1.86,1.86,0,0,0-.32.16.28.28,0,0,0-.12.19c0,.06,0,.06.1.06a2,2,0,0,0,.42-.16l.17-.09m0,2.21a1.56,1.56,0,0,0-.43-.38.22.22,0,0,0-.12-.06S39,32,39,32s0,.06,0,.13,0,.06,0,.13a2.56,2.56,0,0,0,.35.44l.08.06,0,0A.8.8,0,0,0,40,33a.61.61,0,0,0-.15-.35s-.08-.1-.12-.13,0,0,0-.06M38,31.33a.6.6,0,0,1-.39.64.44.44,0,0,1-.59-.32A.6.6,0,0,1,37.4,31a.47.47,0,0,1,.59.32M22,18.22c0-.09,0-.17,0-.2a.36.36,0,0,0-.25,0,1.25,1.25,0,0,0-.51.4s-.05.06-.05.09A1.16,1.16,0,0,0,21,19s.35-.2.61-.37c0,0,0-.06.1-.09s.2-.2.25-.32M20.27,16A1.42,1.42,0,0,0,20,17.19c.19.77.63.81.73.81s0-.07,0-.1A1.34,1.34,0,0,1,21,17.4a6.64,6.64,0,0,0-.08-.7c-.06-.25-.19-.53-.25-.7-.08.07-.19.1-.4,0m1.73.16a1.62,1.62,0,0,1-.13-.73v-.07a1,1,0,0,0-1.45-.11,1.34,1.34,0,0,0-.29,1.56c.13,0,.42.07.51.18a6.24,6.24,0,0,1,.61-.51c.23-.11.55-.25.74-.33M20.52,16a.79.79,0,0,0-.52,0,.73.73,0,0,0,.45.37c.25.11.4.07.48,0a.21.21,0,0,0,.08-.15s0-.07,0-.07a.66.66,0,0,0-.4-.18h0m2.18,1A4.1,4.1,0,0,0,22,17a7.12,7.12,0,0,0-.78.24.82.82,0,0,1-.14.26s0,0-.05.07a1.27,1.27,0,0,0,1.08.38c.7-.07.89-.5.92-.61l-.05,0c-.08-.12-.19-.24-.24-.33m.88-1c-.06,0-.11.1-.15.1a.82.82,0,0,1-.37.17,3.31,3.31,0,0,0-.06.53,4.49,4.49,0,0,0,0,.6,1.43,1.43,0,0,1,.24.4s0,0,0,.07,0,.1.06.13c.17,0,.54-.07.62-.87S23.67,16,23.58,16m.38-.15c0-.06.21-.56-.63-.78a1.93,1.93,0,0,0-1.33.11s0,.06,0,.09a.48.48,0,0,1,0,.39,3.71,3.71,0,0,0,.59.2l.63.13c.11,0,.28-.06.46-.09a.91.91,0,0,1,.28-.06m-1.49-.47a.16.16,0,0,0,0-.13.37.37,0,0,0-.26-.26s-.17.08-.17.39v.05a1,1,0,0,0,.17.51.27.27,0,0,0,.13.05s.09-.05.13-.08a.74.74,0,0,0,0-.54m1.23.86c.15-.09.33-.22.3-.25a2.49,2.49,0,0,0-.37,0,.39.39,0,0,0-.17.06,1.86,1.86,0,0,0-.32.16.28.28,0,0,0-.12.19c0,.06,0,.06.1.06a2,2,0,0,0,.42-.16.25.25,0,0,0,.17-.09m0,1.21a1.56,1.56,0,0,0-.43-.38.22.22,0,0,0-.12-.06S23,17,23,17s0,.06,0,.13,0,.06,0,.13a2.56,2.56,0,0,0,.35.44l.08.06,0,0A.8.8,0,0,0,24,18a.61.61,0,0,0-.16-.35s-.08-.09-.12-.13,0,0,0-.06M22,16.34a.59.59,0,0,1-.39.63.44.44,0,0,1-.59-.32A.59.59,0,0,1,21.4,16a.44.44,0,0,1,.59.32M6,18.22C6,18.14,6,18,6,18a.36.36,0,0,0-.25,0,1.25,1.25,0,0,0-.51.4s-.05.06-.05.09A1.16,1.16,0,0,0,5,19s.35-.2.61-.37c.05,0,.05-.06.1-.09A1,1,0,0,0,6,18.22M4.27,16A1.42,1.42,0,0,0,4,17.19c.19.77.63.81.73.81s0-.07,0-.1A1.34,1.34,0,0,1,5,17.4a6.64,6.64,0,0,0-.08-.7c-.06-.25-.19-.53-.25-.7-.06.07-.19.1-.4,0M7,16.16a1.62,1.62,0,0,1-.13-.73v-.07a1,1,0,0,0-1.45-.11,1.34,1.34,0,0,0-.29,1.56c.13,0,.42.07.51.18a6.24,6.24,0,0,1,.61-.51c.22-.11.55-.25.74-.33M4.53,16a.75.75,0,0,0-.53.07s.07.21.45.35.4.07.47,0A.19.19,0,0,0,5,16.3s0-.07-.05-.07a.68.68,0,0,0-.4-.17s0,0,0,0M6.7,17A4.1,4.1,0,0,0,6,17a7.12,7.12,0,0,0-.78.24.82.82,0,0,1-.14.26s0,0-.05.07A1.27,1.27,0,0,0,6.08,18c.7-.07.89-.5.92-.61l-.05,0c-.08-.12-.19-.24-.24-.33m.88-1c-.06,0-.11.1-.15.1a.82.82,0,0,1-.37.17A3.31,3.31,0,0,0,7,16.8a4.49,4.49,0,0,0,0,.6,1.43,1.43,0,0,1,.24.4s0,0,0,.07,0,.1.06.13c.17,0,.54-.07.62-.87S7.67,16,7.58,16M8,15.85c0-.06.21-.56-.63-.78A1.93,1.93,0,0,0,6,15.18s0,.06,0,.09a.48.48,0,0,1,0,.39,3.71,3.71,0,0,0,.6.2l.63.13c.11,0,.28-.06.46-.09A.91.91,0,0,1,8,15.85m-1.49-.47a.16.16,0,0,0,0-.13A.37.37,0,0,0,6.17,15s-.17.08-.17.38v.05a1,1,0,0,0,.17.51A.27.27,0,0,0,6.3,16s.09-.05.13-.08a.74.74,0,0,0,0-.54m1.23.86C7.85,16.16,8,16,8,16a2.49,2.49,0,0,0-.37,0,.39.39,0,0,0-.18.06,1.86,1.86,0,0,0-.32.16.28.28,0,0,0-.12.19c0,.06.05.06.1.06a2,2,0,0,0,.42-.16.25.25,0,0,0,.17-.09m0,1.21a1.56,1.56,0,0,0-.43-.38A.22.22,0,0,0,7.15,17S7,17,7,17s0,.06,0,.13,0,.06,0,.13a2.56,2.56,0,0,0,.35.44l.08.06,0,0A.8.8,0,0,0,8,18a.61.61,0,0,0-.16-.35s-.08-.09-.12-.13,0,0,0-.06M7,16.34A.59.59,0,0,1,6.6,17,.44.44,0,0,1,6,16.66.59.59,0,0,1,6.4,16a.44.44,0,0,1,.59.32m31,1.88c0-.09,0-.17,0-.2a.36.36,0,0,0-.25,0,1.25,1.25,0,0,0-.51.4s-.05.06-.05.09A1.16,1.16,0,0,0,37,19s.35-.2.61-.37c0,0,0-.06.1-.09a1,1,0,0,0,.25-.32M36.27,16A1.42,1.42,0,0,0,36,17.19c.19.77.63.81.73.81s0-.07,0-.1A1.34,1.34,0,0,1,37,17.4a6.64,6.64,0,0,0-.08-.7c-.06-.25-.19-.53-.25-.7-.06.07-.19.1-.4,0m1.73.16a1.62,1.62,0,0,1-.13-.73v-.07a1,1,0,0,0-1.45-.11,1.34,1.34,0,0,0-.29,1.56c.13,0,.42.07.51.18a6.24,6.24,0,0,1,.61-.51c.26-.11.55-.25.74-.33M36.53,16a.79.79,0,0,0-.53,0,.73.73,0,0,0,.45.37c.25.11.4.07.47,0a.21.21,0,0,0,.08-.15s0-.07,0-.07a.66.66,0,0,0-.4-.18h0m2.18,1A4.1,4.1,0,0,0,38,17a7.12,7.12,0,0,0-.78.24.82.82,0,0,1-.13.26s0,0-.05.07a1.27,1.27,0,0,0,1.08.38c.7-.07.89-.5.92-.61l-.05,0A1.89,1.89,0,0,1,38.7,17m.88-1c-.06,0-.11.1-.15.1a.82.82,0,0,1-.37.17,3.31,3.31,0,0,0-.06.53,4.49,4.49,0,0,0,0,.6,1.43,1.43,0,0,1,.24.4s0,0,0,.07,0,.1.06.13c.17,0,.54-.07.62-.87S39.67,16,39.58,16m.38-.15c0-.06.21-.56-.63-.78a1.93,1.93,0,0,0-1.33.11s0,.06,0,.09a.48.48,0,0,1,0,.39,3.71,3.71,0,0,0,.6.2l.63.13c.11,0,.28-.06.46-.09a.75.75,0,0,1,.28-.06m-1.48-.47a.16.16,0,0,0,0-.13.37.37,0,0,0-.26-.26s-.17.08-.17.39v.05a1,1,0,0,0,.17.51.29.29,0,0,0,.13.05s.09-.05.13-.08a1,1,0,0,0,0-.54m1.22.86c.15-.09.33-.22.3-.25a2.49,2.49,0,0,0-.37,0,.39.39,0,0,0-.17.06,1.86,1.86,0,0,0-.32.16.28.28,0,0,0-.12.19c0,.06,0,.06.1.06a2,2,0,0,0,.42-.16.3.3,0,0,0,.17-.09m0,1.21a1.56,1.56,0,0,0-.43-.38.22.22,0,0,0-.12-.06S39,17,39,17s0,.06,0,.13,0,.06,0,.13a2.56,2.56,0,0,0,.35.44l.08.06,0,0A.8.8,0,0,0,40,18a.61.61,0,0,0-.15-.35s-.08-.09-.12-.13,0,0,0-.06M38,16.34a.59.59,0,0,1-.39.63.44.44,0,0,1-.59-.32A.59.59,0,0,1,37.4,16a.45.45,0,0,1,.59.32M22,58.22c0-.09,0-.17,0-.2a.36.36,0,0,0-.25,0,1.25,1.25,0,0,0-.51.4s-.05.06-.05.09A1.16,1.16,0,0,0,21,59s.35-.2.61-.37c0,0,0-.06.1-.09s.2-.2.25-.32M20.27,57A1.42,1.42,0,0,0,20,58.19c.19.77.63.81.73.81s0-.07,0-.1A1.34,1.34,0,0,1,21,58.4a6.64,6.64,0,0,0-.08-.7c-.06-.25-.19-.53-.25-.7-.08.07-.19.1-.4,0m1.73.16a1.62,1.62,0,0,1-.13-.73v-.07a1,1,0,0,0-1.45-.11,1.34,1.34,0,0,0-.29,1.56c.13,0,.42.07.51.18a6.24,6.24,0,0,1,.61-.51c.23-.11.55-.26.74-.33M20.52,57a.79.79,0,0,0-.52,0,.73.73,0,0,0,.45.37c.25.11.4.07.48,0a.21.21,0,0,0,.08-.15s0-.07,0-.07a.66.66,0,0,0-.4-.18s0,0,0,0m2.18,1A4.1,4.1,0,0,0,22,58a7.12,7.12,0,0,0-.78.24.82.82,0,0,1-.14.26s0,0-.05.07a1.27,1.27,0,0,0,1.08.38c.7-.07.89-.5.92-.61l-.05,0c-.08-.12-.19-.24-.24-.33m.88-1c-.06,0-.11.1-.15.1a.82.82,0,0,1-.37.17,3.31,3.31,0,0,0-.06.53,4.49,4.49,0,0,0,0,.6,1.43,1.43,0,0,1,.24.4s0,0,0,.07,0,.1.06.13c.17,0,.54-.07.62-.87S23.67,57,23.58,57m.38-.15c0-.06.21-.56-.63-.78a1.93,1.93,0,0,0-1.33.11s0,.06,0,.09a.48.48,0,0,1,0,.39,3.71,3.71,0,0,0,.59.21l.63.13c.11,0,.28-.06.46-.09a2.5,2.5,0,0,1,.28-.06m-1.49-.47a.16.16,0,0,0,0-.13.37.37,0,0,0-.26-.26s-.17.08-.17.38v0a1,1,0,0,0,.17.51.27.27,0,0,0,.13.05s.09-.05.13-.08a.74.74,0,0,0,0-.54m1.23.87c.15-.09.33-.22.3-.25a2.49,2.49,0,0,0-.37,0,.39.39,0,0,0-.17.06,1.86,1.86,0,0,0-.32.16.28.28,0,0,0-.12.19c0,.06,0,.06.1.06a2,2,0,0,0,.42-.16l.17-.09m0,1.21a1.56,1.56,0,0,0-.43-.38.22.22,0,0,0-.12-.06S23,58,23,58s0,.06,0,.13,0,.06,0,.13a2.56,2.56,0,0,0,.35.44l.08.06,0,0A.8.8,0,0,0,24,59a.61.61,0,0,0-.16-.35s-.08-.1-.12-.13,0,0,0-.06M22,57.34a.59.59,0,0,1-.39.63.44.44,0,0,1-.59-.32A.59.59,0,0,1,21.4,57a.44.44,0,0,1,.59.32m13.93-9.43s.61-.86-1.55-1.69c-1.61-.62-3.83-.48-5.24-.7-1.19-.16-1.3-.43-1.25-.7.14-.64,1.25-.21,1.94.13a2.82,2.82,0,0,0,3.05-.35,2,2,0,0,1,.83-.43,1.06,1.06,0,0,0-1.05,0,1.28,1.28,0,0,1-.75.29c-.69.05-.83-.16-.83-.16s.36.24,1.22-.19c1.14-.56.44-1.77.44-1.77a.73.73,0,0,1-.39.73,1.1,1.1,0,0,1-1.22,0,.78.78,0,0,0,.64,0c.5-.19.67-.43.5-.75A1.46,1.46,0,0,0,32,42s.56.7-1.61.54a1.52,1.52,0,0,0-1.47,1,1.59,1.59,0,0,0-.83,0,1.1,1.1,0,0,0-.08-.59,2.65,2.65,0,0,1-.75,1.13,1.16,1.16,0,0,0-.08,1.56,3.06,3.06,0,0,0,2.11.72c.92.05,2.41.13,3.74.32,1.8.24,1.5,1.07,1.28,1.34s-.67.3-1.91-.13a11.37,11.37,0,0,0-5.19-1.08c-3.61.13-6.19,2.69-7.49,2.55a1.56,1.56,0,0,1,.06.51,2.05,2.05,0,0,1-.94,1.37s-.06-.19-.11-.16,0,.19-.31.4a1.38,1.38,0,0,0-.53.83s-.14-.3-.25,0-.28.35-.39.38,0-.16-.08-.16-.17.7-1.41.59l-.08,0c-.91.16-1.08-.73-1.41-1s-.47.16-.47.16a.84.84,0,0,1-.17-.54c0-.35.08-.48-.06-.72a1.44,1.44,0,0,1-.42-1.26c-.22,0-.67-.16-.83-1.42,0-.08.17,0,.17,0,0-.19-.22-.27-.25-.48a2,2,0,0,1,.08-1.16c.28-.32,1.05-.46.69-1.1a.43.43,0,0,1-.11.19.26.26,0,0,1-.19.08.22.22,0,0,1-.22-.24c0-.08.06-.13.14-.22a1.09,1.09,0,0,0-.33.05c0-.13.28-.91-.39-1.07a.51.51,0,0,1-.06.29.33.33,0,0,1-.14.13.25.25,0,0,1-.31-.16.27.27,0,0,1,.06-.24s0-.05,0-.11c-.64.08-.5.89-.5,1,0-.19-.42-.7-.78-.46l0,0a.26.26,0,0,1,.11.13.21.21,0,0,1,0,.19.21.21,0,0,1-.28.16.37.37,0,0,1-.19-.16l0,0c-.14.16-.11.48.25.72a3.28,3.28,0,0,1,.64,2.18c-.11.27-.39-.11-.39-.11a1,1,0,0,0,.22.73c.47.65.61.94.28.83a.6.6,0,0,1-.22-.13,1.12,1.12,0,0,0,.44.67c.17.13.14.22,0,.19a.7.7,0,0,1-.25-.11,2.68,2.68,0,0,0,.33.59,2.55,2.55,0,0,0,.69.67,2.47,2.47,0,0,1-1-.38c-.89-.51-.53-.86-.78-1.45s-.42-.67-.69-.7h0a.24.24,0,0,1,0,.13.25.25,0,0,1-.06.19.23.23,0,0,1-.33,0A.49.49,0,0,1,8.82,49a.45.45,0,0,0-.22.51A1.79,1.79,0,0,0,7.88,49a.66.66,0,0,0-.45.08h0s0,0,.05,0a.19.19,0,0,1,.08.16.22.22,0,0,1-.22.24.35.35,0,0,1-.22-.11l0,0c-.17.27-.11.78.8,1.07a.78.78,0,0,0-.58.38.57.57,0,0,1,.3.05.33.33,0,0,1,.14.13.24.24,0,0,1-.17.29.29.29,0,0,1-.25-.05s0,0-.05,0c.11.46.47.51.8.51a5.07,5.07,0,0,1,2.44.62.8.8,0,0,0-.47.22.48.48,0,0,0-.14.35.92.92,0,0,1,.47-.16c.36-.05.44.08.44.08a.55.55,0,0,0-.33.73,1.91,1.91,0,0,1,.56-.35c.28-.08.58-.08.72.11s-.55.48-.55.48a3.07,3.07,0,0,0,1.61.16s-.78.13-.78.62a1.61,1.61,0,0,1,1.44,0A7.26,7.26,0,0,0,19,54.49c2.91-1.15,3-3.57,7-4.86a5.86,5.86,0,0,0,2.19,1.42,21.9,21.9,0,0,0,2.61.65c.58.13,1.58.35,1,1.4a2.17,2.17,0,0,1-.8.83,4.82,4.82,0,0,1-.78-.24c-.25-.08-.44,0-.53.13a.49.49,0,0,1,.19,0c.06,0,.11.05.11.13a.23.23,0,0,1-.14.27.32.32,0,0,1-.22,0h0a.33.33,0,0,0,.28.32s-.31.11-.31.38l.17-.05a.2.2,0,0,1,.17.35h0c-.06.05-.14.05-.22.08l0,0c.17.22.69.05.69.05a.52.52,0,0,0,0,.46c0-.08.06-.16.11-.19a.17.17,0,0,1,.17-.08.22.22,0,0,1,.22.21.27.27,0,0,1-.11.19l0,0h.08a1.05,1.05,0,0,0,.78-.78c.19-.62.42-.72.42-.72s.53-.48.33.38a.6.6,0,0,0,.44-.67s.42.19.55.08,0-.54.19-.81.36.05.28.3a.51.51,0,0,0,.33-.48c0-.27-.08-.56.17-.78s.22.08.19.27c0,0,.25,0,.28-.4,0-.24,0-.32,0-.38s.17.22.17.22a.63.63,0,0,0-.22-.78c-.75-.48-2.69-.16-3.86-1.91-.42-.65-.11-.94-.11-.94a8,8,0,0,0,3.16.78c1.33-.19,1.36-.89,1.36-.89s.22.05,0,.46a.49.49,0,0,0,.33-.38,1,1,0,0,0-.22-1,.36.36,0,0,1,.39.38m-28.08,4c.13-.05.18-.31.16-.58a.62.62,0,0,0-.13-.26.31.31,0,0,0-.29-.1h0c-.39.1-.5.68-.55,1,0,0,.24-.42.57-.16,0,0,0,0,.05.05s.13.1.21.05M6.8,50c.13,0,.2-.2.2-.44a.42.42,0,0,0-.07-.3s0,0-.05,0a.88.88,0,0,0-.25-.2c-.37-.1-.55.4-.62.64a.39.39,0,0,1,.57.1l0,0c.05.1.13.2.2.2m1.76-.06a.27.27,0,0,0,.37,0A.33.33,0,0,0,9,49.67s0-.1,0-.13a.86.86,0,0,0-.12-.23A.74.74,0,0,0,8,49a.75.75,0,0,1,.47.6.42.42,0,0,0,.09.3M12,45.78c0,.13.19.22.39.22a.69.69,0,0,0,.34-.08.45.45,0,0,0,.19-.17.1.1,0,0,0,0-.1c.15-.37-.29-.55-.53-.65,0,0,.24.3-.24.58-.1.08-.19.13-.19.2m-.95-.94c.05.13.31.18.58.16a.62.62,0,0,0,.26-.13.31.31,0,0,0,.1-.29v0c-.1-.39-.68-.5-1-.55,0,0,.37.21.21.52,0,0-.05.05-.05.1s-.16.13-.1.21M9.74,46c.13,0,.23-.08.25-.26a.6.6,0,0,0,0-.3c0-.08-.08-.13-.1-.21l-.15-.13c-.35-.26-.58,0-.71.21,0,0,.3-.08.53.38l0,0a.47.47,0,0,0,.18.26m20.11,8.45a.23.23,0,0,0,.15-.28.29.29,0,0,0-.12-.14.47.47,0,0,0-.21,0h-.12a.67.67,0,0,0-.56.5.65.65,0,0,1,.61-.11h0a.19.19,0,0,0,.2.06m.07.63a.27.27,0,0,0-.21-.07.52.52,0,0,0-.21.07l-.18.1A.74.74,0,0,0,29,56a.77.77,0,0,1,.61-.45.41.41,0,0,0,.28-.1.26.26,0,0,0,0-.37h0M31,56.22c0-.11-.21-.22-.41-.22a.65.65,0,0,0-.31.08.78.78,0,0,0-.21.19s-.05.06-.05.08c-.1.36.31.56.57.64,0,0-.21-.28.16-.56l.05,0c.1-.06.21-.11.21-.19m-1.66-3.6C27,52.19,26.55,51.89,25.6,51c-.08.05-.47.68.52,1.62a2,2,0,0,0,.76.49,7,7,0,0,0-1.56,0c-.41-.11-.71-.62-1.26-.84a.48.48,0,0,0-.46,0,.57.57,0,0,1,.16.11.13.13,0,0,1,.05.16.19.19,0,0,1-.22.19.28.28,0,0,1-.19-.11l-.06-.05a.64.64,0,0,0,.19.51.53.53,0,0,0-.55.4.85.85,0,0,1,.22-.05.24.24,0,0,1,.16.08.21.21,0,0,1,0,.3.3.3,0,0,1-.22.05H23a0,0,0,0,0,0,0c.16.51,1,.13,1,.13s-.41.3-.19.65a.63.63,0,0,1,.08-.13.17.17,0,0,1,.16-.08.22.22,0,0,1,.22.22.27.27,0,0,1-.11.19s0,.05-.05.08c.55.22,1-.62,1-.65a.69.69,0,0,0,.46.73.45.45,0,0,1,.19-.43,1.23,1.23,0,0,1,.74-.14c-.08.3,0,.43.19.49,0-.62,1.23-.65,1.23-.65a.5.5,0,0,0,.33.33.74.74,0,0,1,.25-.54c.25-.19.68-.22,1.15-.46s.46-.87-.3-1M25,54.22c0-.11-.21-.22-.41-.22a.65.65,0,0,0-.31.08.68.68,0,0,0-.16.14c-.05.06-.05.08-.1.14-.1.36.31.56.57.64a.37.37,0,0,1,.1-.53c.05,0,.05-.06.1-.08s.21-.11.21-.17m-1.1-.68a.33.33,0,0,0,0-.42.24.24,0,0,0-.2-.12.59.59,0,0,0-.27.08.12.12,0,0,0-.07,0A.84.84,0,0,0,23,54a.74.74,0,0,1,.51-.38h.14a.3.3,0,0,0,.24-.08M23.78,53c.11,0,.22-.16.22-.37a1.3,1.3,0,0,0-.06-.32.45.45,0,0,0-.17-.21.11.11,0,0,0-.11-.05c-.36-.16-.56.27-.67.54,0,0,.28-.21.53.16,0,0,0,.05.06.11s.11.16.19.16m-3.94-5.42c.11-.83-.48-.77-.48-.77a.93.93,0,0,0,.29-.47,2.29,2.29,0,0,0-.16-1.21s-.3.58-.67.17a.94.94,0,0,0,.16-.74c0,.14-1.17,1-1.5-.55-.64.14-.59.8-1,.74-.21,0-.43-.19-.27-.6a.73.73,0,0,0-.67.66c-.11.77-.48-.25-1-.22a1.86,1.86,0,0,0-.35,1.26c-.45,0-.64.38-.69,1-.13,1.65-.53,1.1-.53,1.13.13,1,.69.47.69.47-.11.72-.72.33-.72.33.19,1.07.61.72.61.72-.19.91.13,1.13.24,1.29a.71.71,0,0,1,.16.69,1.48,1.48,0,0,0,0,.47s.27-.28.45-.06S14.9,53.1,15.56,53c0,0-.08-.41.05-.41s.19.36.19.36a.94.94,0,0,0,1-.28c.16-.22.21-.52.37-.52s.13.28.13.28.13-.14.19-.44.24,0,.24,0a1,1,0,0,1,.43-.69c.32-.19.21-.77.4-.91s.24.44.24.44a1.47,1.47,0,0,0,.45-1.49c-.11-.41-.21-.77-.08-.8s.11.36.37.52S20,49,20,49A2.72,2.72,0,0,1,19.84,47.58ZM15.06,47v-.06l0,0,.43.19-.08.08a.27.27,0,0,0,.11.36.25.25,0,0,0,.35-.11.35.35,0,0,0,0-.17.45.45,0,0,1,.27.47,2.48,2.48,0,0,1-.19.63s-.13-.06-.08-.3.05-.3.05-.3a1,1,0,0,1-.53-.06l0,0A1.07,1.07,0,0,1,15.06,47Zm1.87,3.13c-.32.28-.27.72-.32,1a.62.62,0,0,1-.75.47.69.69,0,0,1-.61-.55c0-.36.56-.85.19-1.32s-.29-.55-.29-.55a.87.87,0,0,0,.29.22c.08,0,.67.33.8-.14A.24.24,0,0,0,16.1,49a.27.27,0,0,1-.13-.11.28.28,0,0,1,0-.25.78.78,0,0,0,.45.28,1,1,0,0,0,.56-.08.18.18,0,0,1-.16.25c-.13,0-.32,0-.35.19-.08.55.69.44.93.41a1.61,1.61,0,0,0,.27-.06C17.49,49.8,17.19,49.83,16.93,50.1Zm1.44-2.53,0,0a.89.89,0,0,1-.61.52h0A.79.79,0,0,1,17.2,48s-.05,0-.08.3-.19.28-.19.28a2.31,2.31,0,0,1,.05-.66.42.42,0,0,1,.43-.33.41.41,0,0,0-.05.17.27.27,0,0,0,.29.25.26.26,0,0,0,.24-.3c0-.06,0-.08,0-.11h.51v0Zm-3,4.39c.81.21.84-.6.84-.72a1,1,0,0,1,.75-1c-.29.06-.84,0-1-.27a1.09,1.09,0,0,1-.88,0,2.72,2.72,0,0,1,.23.33,1.07,1.07,0,0,1-.06.63c-.13.15-.62.82.13,1M33,39.9c-5.46-.21-6.83-1.9-6.83-1.9s-.62,1.14,1.88,2.31c0,0-.83-.15-1.32-.17a5.39,5.39,0,0,0-1.16.09,4.31,4.31,0,0,0-1.08-.79.69.69,0,0,0-.59,0c.05,0,.13.06.16.12a.26.26,0,0,1,.08.18.25.25,0,0,1-.24.26c-.08,0-.14-.06-.22-.12s-.05,0-.08-.06a.55.55,0,0,0,.21.64c-.65.15-.83.32-.83.67a.57.57,0,0,1,.22-.06.47.47,0,0,1,.19.06.29.29,0,0,1,0,.35c-.05.06-.13.06-.24.09h-.05a.59.59,0,0,0,.81.23l.24-.09a1,1,0,0,0-.19.85.63.63,0,0,1,.11-.15.37.37,0,0,1,.19-.06.24.24,0,0,1,.19.29.39.39,0,0,1-.16.21l-.05.06c.05,0,.11,0,.16.06.35.12.65-.2.89-.53.48-.64.94-.44.94-.44a.62.62,0,0,0,0,.76s.27-.67.7-.5a.65.65,0,0,0,.3.64s.22-.67.51-.67.19.64.19.64a1.07,1.07,0,0,0,.54-.38,1,1,0,0,1,.86-.47.88.88,0,0,0,.46.73c0-1.58,2-1.79,2.37-1.84a1,1,0,0,0,.89-1m-9.2.1c.13,0,.2-.21.2-.41a.45.45,0,0,0-.08-.31.72.72,0,0,0-.15-.21.14.14,0,0,0-.12,0c-.37-.15-.55.36-.65.56a.37.37,0,0,1,.52.1c0,.05,0,.05.08.1s.13.21.2.21m.13,1.47a.31.31,0,0,0,0-.4.19.19,0,0,0-.22-.07.92.92,0,0,0-.25.07s-.09,0-.13.07A.82.82,0,0,0,23,42a.71.71,0,0,1,.57-.43h.06c.13,0,.22,0,.28-.1m1.06.78c0-.13-.09-.23-.31-.26a.56.56,0,0,0-.31.05.34.34,0,0,0-.17.13l-.13.13c-.22.36.09.59.31.69,0,0-.13-.28.31-.51l.09-.05c.09-.05.22-.1.22-.18M14.35,37.95c.76.26.84-.52.87-.65a1,1,0,0,1,.79-.88c-.27,0-.81,0-.95-.34a1,1,0,0,1-.84-.08.76.76,0,0,1,.16.34.79.79,0,0,1-.14.6c-.05.16-.57.78.11,1m4.56-5a2.84,2.84,0,0,0-.06-1.54s-.46.72-.84.32,0-.93,0-.93c-.44-.13-.82.45-1.36.16-.38-.21.05-.88.05-.88a2,2,0,0,0-.9.19c-.38.19-.57.34-.82.32s-.24-.61-.24-.61a.9.9,0,0,0-.71.43,1.56,1.56,0,0,1-.55.56c-.11-.19-.38-.19-.57-.24a1.38,1.38,0,0,1-.38-.16A2.2,2.2,0,0,0,12.34,32c-.3.08-.38.42-.44.58-.35,1.28-.9.69-.9.74.11,1.12.76,1.09.71,1.36s-.71-.13-.71-.13c0,.8.38.85.52,1.3s-.14.69.08,1.3.05.88.05.88a1.11,1.11,0,0,0,.74-.32,1.58,1.58,0,0,0,.3,1.22s.24-.51.35-.16A2.32,2.32,0,0,0,13.78,40s.41,0,1.15-.77c.52-.53.27.16.27.16s.35,0,1.12-1.3c.25-.42.66-.69.79,0a2.5,2.5,0,0,0,.55-2.21c0-.29.16-.35.16-.21.08.83,1,.56,1,.56s-.35-.37,0-1.62a1.76,1.76,0,0,0-.16-1.25s.22-.29.27-.4Zm-5.59-.05v-.05l0,0,.49.24s-.08.05-.11.11a.27.27,0,0,0,.11.4.29.29,0,0,0,.41-.11.23.23,0,0,0,0-.19.54.54,0,0,1,.27.56,2.19,2.19,0,0,1-.27.66s-.16-.08-.05-.35.08-.35.08-.35a1,1,0,0,1-.6-.11l0,0A1,1,0,0,1,13.32,32.93Zm1.88,3.62c-.38.29-.35.74-.46,1.06a.72.72,0,0,1-.9.43.74.74,0,0,1-.65-.67c0-.4.74-.9.33-1.44s-.3-.64-.3-.64a.94.94,0,0,0,.3.27c.08.05.76.42.93-.08.05-.13-.06-.21-.14-.29a.69.69,0,0,1-.16-.13.21.21,0,0,1,0-.27.86.86,0,0,0,.52.35,1.14,1.14,0,0,0,.65-.05.22.22,0,0,1-.22.27c-.16,0-.38,0-.41.19-.14.61.79.56,1.06.53l.33,0C15.88,36.28,15.55,36.3,15.2,36.54Zm1.91-2.63,0,0a.91.91,0,0,1-.74.51h0a1.07,1.07,0,0,1-.57-.21s-.05,0-.11.32-.24.27-.24.27a2.49,2.49,0,0,1,.11-.72.5.5,0,0,1,.52-.32A.38.38,0,0,0,16,34a.3.3,0,0,0,.6,0c0-.05,0-.08,0-.13l.55.05h0Zm22.89,5s.05-.81-.52-1c-.74-.28-1.73.08-3.67-.11-4.68-.44-4.11-2.17-4.11-2.17s3,1.33,4.19.69a1,1,0,0,0,.63-.94c.19.22,0,.67,0,.67s1.21-.89-.22-2.3a4.25,4.25,0,0,0-2.19-1c-2.06-.28-2.85-.17-4.3-.36-1.23-.17-1.51-.61-1.42-.94.19-1,2.47.42,3.7-.14a5.44,5.44,0,0,1,.9-.44,1.11,1.11,0,0,1,.6,0s-.3-.53-1.26-.33c-.8.17-.85-.11-.85-.11a1.59,1.59,0,0,0,.85-.25c.3-.19.38-.58.74-.72a1,1,0,0,1,.82,0,1.15,1.15,0,0,0-1.59-.39c-.71.47-1,.14-1,.14a1,1,0,0,0,.85-.61c.27-.53.6-.61.6-.61a.9.9,0,0,0-1,.19,2,2,0,0,1-1.45.36c-.93,0-1.29,1.11-1.29,1.11a2.08,2.08,0,0,0-.68.19,3.39,3.39,0,0,0-.6.44l.11-.36a1.6,1.6,0,0,0-.71,1.42c0,1.8,1.89,1.94,2.52,2,.93.08,2.74.11,4.11.31,1.86.25,1.92,1.14,1.67,1.53s-1,.22-2.33-.25a10.33,10.33,0,0,0-5-1.14C24,34,19.67,37,18.41,36.23a2.73,2.73,0,0,1-1.12,2.36c0-.75-.27-.64-.52-.19-.69,1.25-1.4,1.39-1.4,1.39s.14-.42-.33,0a2,2,0,0,1-1,.47A2.29,2.29,0,0,1,13.21,39c0-.08-.14.25-.14.25-.55-.28-.69-1.17-.69-1.17a1.43,1.43,0,0,1-.88.08s.33-.39-.06-1.36c-.77,0-3.75-.53-4.11-2.08-.14-.58-.3-.86-.68-.89l.08.11a.54.54,0,0,1,0,.22.24.24,0,0,1-.31.15h0a.29.29,0,0,1-.16-.19s0-.06-.05-.08c-.3.22-.19.72-.19.72-.33-.28-1-.75-1.42-.47a1.23,1.23,0,0,1,.19.11.25.25,0,0,1,.08.19.28.28,0,0,1-.27.28c-.11,0-.16-.06-.25-.14l-.11-.08c-.36.58.8,1.22.8,1.22-.44,0-1.07.33-1,.72a.5.5,0,0,1,.19-.06.25.25,0,0,1,.22.42.33.33,0,0,1-.25.08H4.11c.11.25.33.42.88.25a4.69,4.69,0,0,1,2.3-.14s-.05.47-.66.33a.91.91,0,0,0,.79.36,2.14,2.14,0,0,0,1.15-.3.28.28,0,0,1-.16.28c-.44.22-.16.72-.16.72.25-.56.69-.33.69-.33a.5.5,0,0,0,.08.67s0-.31.52-.44a1.17,1.17,0,0,1,.63,0,.77.77,0,0,0,.06.86s.14-.67.6-.47a.27.27,0,0,1,.11.39.46.46,0,0,1-.3.17c.71.33.88-.22,1.42.28A4.89,4.89,0,0,1,9.67,40c-1.7-.14-2.06-.5-2.44-.86-.55-.53-1-.58-1.23-.5l.08.06a.25.25,0,0,1,.08.19.28.28,0,0,1-.27.28c-.11,0-.16-.06-.25-.14L5.59,39c-.14.28.14.5.22.61l-.33-.06a.58.58,0,0,0-.74.33.83.83,0,0,1,.27,0,.28.28,0,0,1,.16.14.28.28,0,0,1-.14.36.25.25,0,0,1-.27,0s-.05,0-.11,0c.11.47.63.53,1,.56a.58.58,0,0,0-.36.58.34.34,0,0,1,.19-.11.23.23,0,0,1,.19,0,.23.23,0,0,1,.08.33.31.31,0,0,1-.22.14l-.08,0c.33.36,1.12-.11,1.37-.25a1.59,1.59,0,0,1,1.51-.14c.6.31-.22.56-.22.56a.73.73,0,0,0,.71,0c.19-.08.36-.22.44-.08s0,.22-.11.33a.68.68,0,0,1-.25.11A1.56,1.56,0,0,0,10.41,42a.36.36,0,0,1,0,.28.74.74,0,0,1-.38.42c.82.25,1.23-.72,1.23-.72s.38.31-.08.72c.66,0,.74-.53,1.07-.33s.08.39-.19.44c.77.28.71-.44,1.59-.28A8.59,8.59,0,0,0,18.74,42c3.53-1.36,3.89-4.52,7.75-4.94,0,0,.33.69,3,1.42,2.8.78,7.1.17,6.9,1.53-.11.69-2-.31-2.25.39v0a.3.3,0,0,1,.22,0,.22.22,0,0,1,.16.11.27.27,0,0,1-.08.33c-.08.06-.16,0-.25,0h0a.53.53,0,0,0,.38.25.57.57,0,0,0-.38.53v.08l.14-.08a.23.23,0,0,1,.19,0,.23.23,0,0,1,.11.31c0,.08-.11.11-.22.14h0a.53.53,0,0,0,.52.14c.22-.06.3-.14.33-.19a.92.92,0,0,0-.14.58.45.45,0,0,0,.11.19,1.8,1.8,0,0,1,.08-.22.25.25,0,0,1,.16-.11.25.25,0,0,1,.27.19.45.45,0,0,1-.08.25,0,0,0,0,1,0,0c.49,0,.93-.64,1-1.22.11-.75.33-.64.33-.64a.43.43,0,0,0,.14.28.46.46,0,0,0,.3.14c0-.5.36-.67.49-.53s0,.44,0,.44.25.08.55-.42c.16-.28.16-.61.36-.64s.16.33.16.33c.63-.33.25-1.33.47-1.44s.11.31.11.31a.59.59,0,0,0,.27-.64c-.11-.56.22,0,.22,0M4.93,36.44a.26.26,0,0,0,0-.38A.31.31,0,0,0,4.68,36a.61.61,0,0,0-.22.06l-.16.09A.8.8,0,0,0,4,37a.76.76,0,0,1,.56-.44h.06a.59.59,0,0,0,.28-.12M4.78,35c.11,0,.22-.17.22-.42a.51.51,0,0,0-.07-.3.4.4,0,0,0-.15-.17s-.09,0-.13-.08c-.37-.13-.54.3-.65.55a.32.32,0,0,1,.48.08s.07.08.09.13.15.21.22.21M6.7,35c.12.08.24,0,.29-.19a.44.44,0,0,0,0-.3s0-.11-.07-.15a.5.5,0,0,0-.17-.19.46.46,0,0,0-.72.08.59.59,0,0,1,.48.38s0,.08,0,.11.07.22.17.26M6,41.36A.23.23,0,0,0,5.85,41a.42.42,0,0,0-.26,0,1.06,1.06,0,0,0-.26.11l-.11.08a.54.54,0,0,0-.07.78s0-.31.49-.48l.11,0c.08,0,.19-.06.23-.14M5.78,40c.11,0,.22-.17.22-.42a.51.51,0,0,0-.07-.3s0-.08-.07-.08A.55.55,0,0,0,5.65,39c-.37-.13-.54.3-.65.55,0,0,.26-.21.52.13,0,0,0,0,0,.08s.15.21.22.21m-.92.76A.53.53,0,0,0,5,40.24a.31.31,0,0,0-.14-.2.51.51,0,0,0-.24,0,.1.1,0,0,0-.09,0c-.41.16-.45.68-.5,1a.61.61,0,0,1,.55-.32.12.12,0,0,1,.1,0,.13.13,0,0,0,.22,0m30-.09a.48.48,0,0,0,.08-.49c0-.08-.08-.16-.17-.16s-.14,0-.23,0-.08,0-.11,0c-.4.21-.43.7-.46.94a.65.65,0,0,1,.6-.37h0c.11.08.2.08.26,0M35,42.32c.07-.11,0-.24-.15-.3a.42.42,0,0,0-.26,0l-.18.08c-.07,0-.11.08-.18.14a.56.56,0,0,0-.07.76s0-.33.51-.49h0c.15-.08.26-.11.29-.19m1-.14c0-.12-.25-.2-.5-.17a.42.42,0,0,0-.3.1.23.23,0,0,0-.15.2.1.1,0,0,1,0,.1c0,.37.45.52.75.6,0,0-.3-.25,0-.55,0,0,0,0,0,0s.15-.17.15-.25M4.73,21c.11,0,.24-.07.26-.26a.44.44,0,0,0,0-.3s0-.07,0-.11a.46.46,0,0,0-.2-.22c-.35-.26-.57,0-.7.22,0,0,.33-.08.55.41.07.11.11.22.18.26m28.2,5c-4.72-.15-6.27-2-6.27-2s-.8,1.32,1.17,2.21a3.9,3.9,0,0,0-.83-.15c-.56-.06-.8-.06-.8-.06a1.79,1.79,0,0,0-1.15-.82,1.9,1.9,0,0,0-.56,0l0,0a.19.19,0,0,1,.05.2.23.23,0,0,1-.24.24c-.08,0-.13-.06-.21-.15L24,25.38l0,0A.62.62,0,0,0,24,26c-.67.09-.91.32-1,.65a.63.63,0,0,1,.32,0c.05,0,.11.06.16.12a.3.3,0,0,1-.08.35.33.33,0,0,1-.24,0H23c.05.38.48.68,1.17.35a.86.86,0,0,0-.19.88c0-.06,0-.09.05-.12a.18.18,0,0,1,.16-.12.22.22,0,0,1,.27.21.34.34,0,0,1-.08.26l-.08.18c.59.26,1.17-.47,1.25-.85a1,1,0,0,0,.32.65.73.73,0,0,1,.16-.35c.24-.29.24.06.24.06,0,.56.32.65.32.65s-.05-.62.4-.74c.19.68.85-.35.77-.06-.16.68.11.88.11.88s.05-.82,1.55-.91a.91.91,0,0,0,.43.76c.11-1.59,2.14-1.59,2.48-1.65,1-.21.59-1.18.59-1.18m-8.16,0c.13,0,.23-.14.23-.36a1.06,1.06,0,0,0-.05-.32l0,0a.77.77,0,0,0-.26-.23c-.36-.18-.56.23-.67.41a.4.4,0,0,1,.49.14l.08.14c.08.18.13.27.2.27m-1.14.7a.25.25,0,0,0,.25,0,.46.46,0,0,0,.08-.51c0-.09-.08-.17-.16-.17a.45.45,0,0,0-.33,0A1.14,1.14,0,0,0,23,27s.17-.34.47-.34a.33.33,0,0,0,.17,0M25,28.18c-.05-.13-.26-.2-.52-.18a.44.44,0,0,0-.31.1c-.05,0-.05.08-.1.1a.27.27,0,0,0-.05.2c0,.38.52.51.83.59a.32.32,0,0,1-.1-.43c.05,0,.05-.1.16-.15s.16-.15.1-.23m-6.15-8c.16-.8-.42-.83-.42-.83a1,1,0,0,0,.34-.53,2.79,2.79,0,0,0-.13-1.39.57.57,0,0,1-.82.3,1.1,1.1,0,0,0,.05-1.08.84.84,0,0,1-.37.44c-.32.19-.69.17-.82-.08a.62.62,0,0,1,.21-.72,1.54,1.54,0,0,0-.85,0,5,5,0,0,0-1,.53.74.74,0,0,1-.21-.8.78.78,0,0,0-.8.67.42.42,0,0,1-.34.33.79.79,0,0,0-.48-.64,2.19,2.19,0,0,0-.8,1.72.78.78,0,0,0-.45.64c-.37,2.3-.93,1.22-.93,1.25.13,1.16.87,1,.87,1-.13.8-.93.39-.93.39.29,1.16,1,.69,1,.69a2.34,2.34,0,0,0,.13,2.19,3.17,3.17,0,0,1,.26,1.14,1.52,1.52,0,0,1,.5-.17c.24,0,.16.28.19.64s.21.64.21.64a1.31,1.31,0,0,1,.11-.22c.13-.19.19-.17.19-.17a1.18,1.18,0,0,0,.32.91s.53-.83.85-.78.32.53.32.53c1.56-1,1.77-3.3,2.07-2.49a1.14,1.14,0,0,1,.08.39s1-.58.85-2.8a1.3,1.3,0,0,0,.48.28.74.74,0,0,0,.48,0A2.6,2.6,0,0,1,18.84,20.18Zm-5.27-.91v-.06l0,0,.48.25s-.08.06-.11.11a.32.32,0,0,0,.11.42.29.29,0,0,0,.4-.11.26.26,0,0,0,0-.19.57.57,0,0,1,.27.58,2.36,2.36,0,0,1-.27.69s-.16-.08-.05-.36.08-.36.08-.36a.91.91,0,0,1-.58-.11l0,0A1,1,0,0,1,13.57,19.27ZM15.42,23c-.37.31-.35.78-.45,1.11a.69.69,0,0,1-.87.47.73.73,0,0,1-.64-.69c0-.42.69-.94.32-1.5s-.29-.67-.29-.67a.88.88,0,0,0,.32.28c.08.06.74.44.9-.11.05-.14-.05-.22-.13-.31a.7.7,0,0,1-.16-.14.23.23,0,0,1,0-.28,1,1,0,0,0,.5.36,1,1,0,0,0,.64-.06.22.22,0,0,1-.21.28c-.16,0-.37,0-.4.19-.13.64.77.55,1,.53l.32-.06C16.11,22.73,15.77,22.76,15.42,23Zm1.83-2.77,0,0a.89.89,0,0,1-.72.53h0a1,1,0,0,1-.56-.22s-.05,0-.11.33-.21.28-.21.28a2,2,0,0,1,.11-.75.53.53,0,0,1,.5-.36.4.4,0,0,0-.05.19.29.29,0,1,0,.58,0c0-.06,0-.08,0-.14l.53,0h0ZM14.37,24c.76.24.84-.53.84-.69a1,1,0,0,1,.79-.9c-.27,0-.81,0-.95-.32a1,1,0,0,1-.84-.05.9.9,0,0,1,.19.34,1,1,0,0,1-.11.61c-.14.13-.62.77.08,1M4.93,22.44a.27.27,0,0,0,0-.38A.31.31,0,0,0,4.68,22a.68.68,0,0,0-.31.12s0,0-.06,0A.8.8,0,0,0,4,23a.82.82,0,0,1,.5-.44s.06,0,.13,0a.36.36,0,0,0,.28-.09M6.63,20c.1.1.26,0,.34-.1a.45.45,0,0,0,0-.27s0,0,0-.07a1,1,0,0,0-.18-.3.56.56,0,0,0-.78-.1.74.74,0,0,1,.49.5s0,0,0,.07a.34.34,0,0,0,.1.27m-1,5c.11.1.27,0,.35-.1a.44.44,0,0,0,0-.27l-.08-.2c0-.07-.08-.1-.11-.17a.59.59,0,0,0-.8-.1.72.72,0,0,1,.51.57s0,0,0,.07a.32.32,0,0,0,.08.2m-.77,2A.61.61,0,0,0,5,26.34a.38.38,0,0,0-.14-.26.22.22,0,0,0-.28,0h0c-.39.13-.48.71-.53,1,0,0,.21-.35.5-.26,0,0,.07,0,.11,0s.16.18.23.13m1,.14A.34.34,0,0,0,5.66,27a.66.66,0,0,0-.3.11s-.06.05-.09.05a.68.68,0,0,0-.21.84.79.79,0,0,1,.59-.49.6.6,0,0,0,.27-.11.22.22,0,0,0,0-.35M39.5,24A3.5,3.5,0,0,0,38,24a8.52,8.52,0,0,1-1.68.05c-3.94-.38-4.26-1.82-4.1-1.71a8.76,8.76,0,0,0,2.15.68c3.52.68,3.52-1.22,3.52-1.22a.44.44,0,0,1,.14.3,1.27,1.27,0,0,1-.14.57,1.14,1.14,0,0,0,.44-.82,1.12,1.12,0,0,0-.47-1,.49.49,0,0,1,.28.14,1.32,1.32,0,0,1,.28.52,1.13,1.13,0,0,0-.49-1.17c-1.87-1.55-5.94-1.25-7.51-1.47-1.38-.19-1.73-.76-1.62-1.33.17-1,1.46-1,1.46-1-.06,1,1.24,1.71,2.48,1.44a3.78,3.78,0,0,0,1.6-.76,3.19,3.19,0,0,1,.66-.43,2,2,0,0,0-1.29.25,3,3,0,0,1-.85.22c-.77.05-.85-.43-.85-.43a2.23,2.23,0,0,0,1.32.11,1.82,1.82,0,0,0,1.43-2.47,1.71,1.71,0,0,1-.85,1,1.21,1.21,0,0,1-1.15-.14s1,.11,1.27-.71a.58.58,0,0,0-.3-.68s.08,1-2.37.87c-1.07-.06-1.07.84-1.07.84a2.47,2.47,0,0,0-.61.14,2.4,2.4,0,0,0-.69.3c.11-.3.55-.44.55-.44a1.74,1.74,0,0,0-1,.44.79.79,0,0,1,.08-.27,2.62,2.62,0,0,0-.77,1.63A1.83,1.83,0,0,0,28.19,19a3.45,3.45,0,0,0,2.42.82c1,.08,2.7.16,4.18.35,2,.27,2.12.92,1.87,1.36s-1.18.49-2.56,0a22,22,0,0,0-6.19-1.47c-5.31,0-7.68,2.23-9.27,1.82a3.07,3.07,0,0,1-1.4,2.8c-.22-1.11-.06.9-2.23,2,0,0,0-.49-.25-.54s-.72.73-.72.73a1.52,1.52,0,0,1-.61-.79l-.11.22a1,1,0,0,1-.44-.6c-.08-.38,0-.68-.14-.68a2,2,0,0,0-.63.27,2.88,2.88,0,0,0-.22-1.36,5.46,5.46,0,0,1-.47-1.33c-1.71-.33-3.8-1-3.82-1.63s.05-1.22-.63-1.41c0,0,0,0,0,.06a.22.22,0,0,1,0,.22.26.26,0,0,1-.36.08.37.37,0,0,1-.14-.22s0,0,0-.05c-.38.22-.22.92-.22.92-.3-.3-1-.9-1.35-.52,0,0,.05.05.05.08a.29.29,0,0,1,.05.22.28.28,0,0,1-.33.19.33.33,0,0,1-.19-.19c-.5.57.36,1.28.36,1.28s-.8.19-.83.68a.59.59,0,0,1,.27-.11.23.23,0,0,1,.19.06.25.25,0,0,1,0,.35.34.34,0,0,1-.25.08l-.11,0a.74.74,0,0,0,.85.24,2.19,2.19,0,0,1,1.84-.11c.33.08.63,0,.66.19s-.16.27-.66.22c0,0,.11.33.69.38.85.08,1.1-.11,1.21,0s-.6.35-.6.35a1.7,1.7,0,0,0,1.54.11c.06.3-.58.35-.58.35a.78.78,0,0,0,.74.16,2.3,2.3,0,0,0,.36-.14.66.66,0,0,0,.27.73s.25-.82.58-.6a.26.26,0,0,1,.11.38.31.31,0,0,1-.27.11c.11.24.55.24.55.24a4.11,4.11,0,0,1-2,.3c-2-.16-1.87-.38-2.34-1s-.61-.54-.8-.46c0,.05.08.11.08.16a.21.21,0,0,1,0,.22.26.26,0,0,1-.36.08.36.36,0,0,1-.14-.19.47.47,0,0,0-.08.65c-.11,0-1-.14-1.21.27a1.25,1.25,0,0,1,.33,0,.25.25,0,0,1,.16.16.28.28,0,0,1-.16.35.34.34,0,0,1-.28-.06.25.25,0,0,0-.14,0V26c0,.63.91.65,1.38.68a.57.57,0,0,0-.36.57.49.49,0,0,1,.28-.11.22.22,0,0,1,.22.05.28.28,0,0,1,.05.38.27.27,0,0,1-.25.11c.61.41,1.07-.16,1.29-.27a2,2,0,0,1,1.87-.06c.19.19-.22.43-.22.43a1.14,1.14,0,0,0,.8-.22,1,1,0,0,0-.14.3.48.48,0,0,0,.16.46c.39-.71.66-.68.8-.54s-.17.41-.17.41c.44.22,1-.22,1-.22a.71.71,0,0,0,.16.57c.27-.51.91-.46,1.32-.41,0,0-.6.41-.36.9a1.69,1.69,0,0,1,1.49-.41c1.32.16,3.83.9,8.09-3,2.89-2.66,4.82-2.31,4.82-2.31,2.59,2.07,7.51,2.09,8.78,2.2.6.06.63.41.36.73a.75.75,0,0,1-.41.25s-1.21-.49-1.65.16a.31.31,0,0,1,.22,0c.06,0,.11.05.17.11a.22.22,0,0,1-.08.3.38.38,0,0,1-.25,0h-.11a.43.43,0,0,0,.36.33c.06,0,.06,0,0,0a.76.76,0,0,0-.25.57.41.41,0,0,1,.19-.08.24.24,0,0,1,.19,0,.2.2,0,0,1,.06.3c-.06.08-.11.08-.22.11a.1.1,0,0,0-.06,0,.56.56,0,0,0,.72.19c.28-.11.36-.16.36-.19a.48.48,0,0,0,0,.41s0,0,.06.06a.85.85,0,0,1,.14-.27.24.24,0,0,1,.17-.08.22.22,0,0,1,.22.25c0,.08-.06.14-.14.22s0,.06-.06.08a1.09,1.09,0,0,0,.3,0c.38-.08.66-.38.77-1.2a.77.77,0,0,1,.17-.49,1.5,1.5,0,0,1,.41-.25.61.61,0,0,1-.08.54c.74.11.85-1,.85-1a1.18,1.18,0,0,0,.25.38.77.77,0,0,0,.41.19c-.14-.84.19-1.11.36-1.14.33-.08.3.3.3.3a.57.57,0,0,0,.22-.54,1.23,1.23,0,0,0-.14-.41s.28-.14.41.22c0,0,.28-.46,0-.71a.34.34,0,0,1,.14,0,.31.31,0,0,1,.14.11.91.91,0,0,0-.49-.9m-5.62,3.64A.43.43,0,0,0,34,27.2c0-.08-.09-.17-.18-.17a.23.23,0,0,0-.24,0s-.06,0-.09,0A1.06,1.06,0,0,0,33,28a.65.65,0,0,1,.53-.34h.12a.23.23,0,0,0,.24,0m.06.71a.2.2,0,0,0-.07-.33.35.35,0,0,0-.24,0c-.07,0-.14.06-.24.09l-.14.09a.65.65,0,0,0-.17.81.72.72,0,0,1,.49-.48.13.13,0,0,0,.07,0,.36.36,0,0,0,.31-.12m2.06.86c0-.13-.15-.2-.41-.23a.54.54,0,0,0-.31.08.62.62,0,0,0-.26.26v0c-.15.36.26.54.51.64,0,0-.2-.26.15-.51,0,0,0-.05.1-.08s.2-.1.2-.18M32.58,3.14l-.85,2.51h1.76l-.85-2.51ZM21.6,4.4a1.05,1.05,0,0,0-1,1h2.09A1.05,1.05,0,0,0,21.6,4.4ZM0,10H44V0H0ZM12.8,3H11.26V8.31H9.71V3H8V1.63h5.28L12.8,3Zm5.72,5.34h-1.4V5.71A1.71,1.71,0,0,0,17,5a.69.69,0,0,0-.66-.43,2,2,0,0,0-1.16.57V8.29h-1.4V1.63h1.4V3.94a2.3,2.3,0,0,1,1.57-.57,1.6,1.6,0,0,1,1.62,1.06,3.13,3.13,0,0,1,.14,1Zm5.39-2H20.53c.08.63.52,1,1.38,1a4.78,4.78,0,0,0,1.68-.31L23.2,8.17a3.64,3.64,0,0,1-1.46.26,2.33,2.33,0,0,1-2.48-2.57,2.29,2.29,0,0,1,2.37-2.54C23.2,3.34,24.08,4.63,23.91,6.34ZM27,5.89V8.34H25.45V1.63h5L30,3H27V4.46h2.48l-.52,1.4H27Zm7.37,2.43L33.93,7H31.26l-.44,1.31H29.31l2.45-6.68h1.76l2.4,6.68H34.34Z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-tick",
  "use": "icon-tick-usage",
  "viewBox": "0 0 16 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 15\" id=\"icon-tick\">\n    <polygon points=\"6.3,9.5 12.7,0 16,2.2 7.4,15 0,10.1 2.2,6.8 \" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-tiktok",
  "use": "icon-tiktok-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol role=\"img\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tiktok\"><title>TikTok</title><path d=\"M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-twitter-faq",
  "use": "icon-twitter-faq-usage",
  "viewBox": "0 0 14 11.379",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 11.379\" id=\"icon-twitter-faq\">\n  <path id=\"icon-twitter-faq_twitter\" d=\"M13.973,3.6a5.833,5.833,0,0,1-1.648.452,2.892,2.892,0,0,0,1.262-1.588,5.928,5.928,0,0,1-1.824.691A2.87,2.87,0,0,0,6.872,5.771,8.13,8.13,0,0,1,.957,2.78,2.813,2.813,0,0,0,.568,4.224,2.87,2.87,0,0,0,1.844,6.614a2.861,2.861,0,0,1-1.3-.359v.035A2.872,2.872,0,0,0,2.847,9.1a2.914,2.914,0,0,1-1.29.05,2.879,2.879,0,0,0,2.686,1.993,5.756,5.756,0,0,1-3.56,1.228A6.092,6.092,0,0,1,0,12.337a8.164,8.164,0,0,0,4.408,1.289,8.107,8.107,0,0,0,8.165-8.158c0-.122,0-.245-.009-.367A5.8,5.8,0,0,0,14,3.613Z\" transform=\"translate(0 -2.246)\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-twitter-old",
  "use": "icon-twitter-old-usage",
  "viewBox": "0 0 32 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 26\" id=\"icon-twitter-old\"><path d=\"M10.05,26C22.13,26,28.73,16,28.73,7.33c0-.28,0-.56,0-.84A13.37,13.37,0,0,0,32,3.08a13.32,13.32,0,0,1-3.78,1A6.6,6.6,0,0,0,31.12.49a13.07,13.07,0,0,1-4.17,1.59A6.57,6.57,0,0,0,15.58,6.56a7.25,7.25,0,0,0,.17,1.5A18.65,18.65,0,0,1,2.22,1.2a6.58,6.58,0,0,0,2,8.76,6.65,6.65,0,0,1-3-.82v.09a6.58,6.58,0,0,0,5.26,6.44,6.61,6.61,0,0,1-3,.12,6.57,6.57,0,0,0,6.13,4.56,13.18,13.18,0,0,1-8.16,2.81A12.65,12.65,0,0,1,0,23.07,18.69,18.69,0,0,0,10.05,26\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-twitter",
  "use": "icon-twitter-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-twitter\">\n  <path id=\"icon-twitter_X_logo_HOVER_CLCIKED_\" data-name=\"X logo HOVER/CLCIKED \" d=\"M9.522,6.775,15.479,0H14.067L8.9,5.883,4.764,0H0L6.247,8.9,0,16H1.412L6.873,9.788,11.236,16H16L9.522,6.775Zm-1.933,2.2-.633-.886L1.92,1.04H4.088L8.152,6.728l.633.886,5.283,7.394H11.9L7.589,8.974Z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 12 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 10\" id=\"icon-user\"><title>user</title><path d=\"M6,0A5.9,5.9,0,0,0,0,5.8,5.69,5.69,0,0,0,1.86,10,4.6,4.6,0,0,1,6,7.48,4.6,4.6,0,0,1,10.14,10,5.69,5.69,0,0,0,12,5.8,5.9,5.9,0,0,0,6,0ZM6,6.81A2.38,2.38,0,0,1,3.58,4.47,2.38,2.38,0,0,1,6,2.13,2.38,2.38,0,0,1,8.42,4.47,2.38,2.38,0,0,1,6,6.81Z\" fill=\"#6b7685\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-verified",
  "use": "icon-verified-usage",
  "viewBox": "0 0 23.87 23.74",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23.87 23.74\" id=\"icon-verified\">\n  <title>verified</title>\n  <g>\n    <path d=\"M11.93,21.14l-2.49,2.6L8.22,20.35,4.88,21.71l.26-3.59L1.54,18l1.7-3.18L0,13.25,2.85,11,.52,8.29,4,7.43,3,4l3.55.64L7.05,1l3,2L11.93,0l1.9,3.06,3-2,.49,3.57L20.85,4l-1,3.46,3.5.86L21,11l2.84,2.21-3.24,1.57L22.33,18l-3.6.11L19,21.71l-3.34-1.36-1.22,3.39Z\" fill=\"#48c2c5\" />\n    <path d=\"M11,13.42l3.61-5.36,1.85,1.25L11.59,16.5,7.43,13.76l1.22-1.87Z\" fill=\"#fff\" />\n  </g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-whatsapp",
  "use": "icon-whatsapp-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol role=\"img\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-whatsapp\"><title>WhatsApp</title><path d=\"M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-xls",
  "use": "icon-xls-usage",
  "viewBox": "0 0 21 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 24\" id=\"icon-xls\"><path d=\"M19.67,8.58H19.1V5.8a.46.46,0,0,0,0-.05.47.47,0,0,0-.11-.3L14.41.16h0L14.32.08l0,0L14.2,0H2.83A.94.94,0,0,0,1.9.94V8.58H1.33A1.34,1.34,0,0,0,0,9.93v7a1.34,1.34,0,0,0,1.33,1.35H1.9v4.79a.94.94,0,0,0,.93.94H18.17a.94.94,0,0,0,.93-.94V18.27h.57A1.34,1.34,0,0,0,21,16.93v-7A1.34,1.34,0,0,0,19.67,8.58ZM2.83.94H13.6V5.76a.47.47,0,0,0,.46.47h4.11V8.58H2.83Zm10.43,14.5V16.8H8.83V9.62h1.61v5.82ZM1.84,16.8,3.9,13.17l-2-3.55H3.76l.62,1.31c.21.44.37.79.54,1.19h0c.17-.46.31-.78.48-1.19L6,9.62H7.86l-2,3.51L8,16.8H6.11l-.64-1.3c-.26-.5-.43-.87-.63-1.29h0c-.15.42-.33.79-.55,1.29l-.59,1.3H1.84Zm16.33,6H2.83V18.27H18.17V22.8Zm-2.22-5.89a4.6,4.6,0,0,1-2-.44l.33-1.34a4.06,4.06,0,0,0,1.78.45c.74,0,1.13-.31,1.13-.78s-.34-.7-1.19-1C14.8,13.37,14,12.71,14,11.66c0-1.23,1-2.16,2.69-2.16a4.31,4.31,0,0,1,1.81.36l-.36,1.31a3.34,3.34,0,0,0-1.49-.34c-.7,0-1,.32-1,.69s.4.66,1.32,1c1.25.47,1.84,1.13,1.84,2.14C18.82,15.89,17.9,16.91,15.95,16.91Z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-yahoo",
  "use": "icon-yahoo-usage",
  "viewBox": "0 0 342 449",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 342 449\" id=\"icon-yahoo\">\n<g>\n\t<path fill=\"#6A1B9A\" d=\"M330.7,0h-53.3c-3.9,0-7.5,2.1-9.3,5.5l-97.3,175.2L73.3,5.5C71.5,2.1,67.9,0,64,0H10.7C4.8,0,0,4.8,0,10.7\n\t\tc0,1.8,0.5,3.7,1.4,5.3l137.1,242.6L128,436.7c-0.3,5.9,4.1,10.9,10,11.3c0.2,0,0.4,0,0.6,0h64c5.9,0,10.7-4.8,10.7-10.6\n\t\tc0-0.2,0-0.4,0-0.6l-10.5-178.2L340,15.9c2.9-5.1,1.1-11.6-4-14.5C334.3,0.5,332.5,0,330.7,0z\" />\n</g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-youtube",
  "use": "icon-youtube-usage",
  "viewBox": "0 0 32 22.5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 22.5\" id=\"icon-youtube\"><path d=\"M31.68,4.86A6.92,6.92,0,0,0,30.4,1.68,4.58,4.58,0,0,0,27.2.32C22.72,0,16,0,16,0h0S9.28,0,4.8.32A4.58,4.58,0,0,0,1.6,1.68,6.92,6.92,0,0,0,.32,4.86,48.4,48.4,0,0,0,0,10v2.46a48.4,48.4,0,0,0,.32,5.18A6.92,6.92,0,0,0,1.6,20.82a5.42,5.42,0,0,0,3.52,1.36c2.56.24,10.88.32,10.88.32s6.72,0,11.2-.34a4.58,4.58,0,0,0,3.2-1.36,6.92,6.92,0,0,0,1.28-3.18A48.46,48.46,0,0,0,32,12.46V10a48.46,48.46,0,0,0-.32-5.18M12.7,15.4v-9l8.64,4.52Z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-yt-play",
  "use": "icon-yt-play-usage",
  "viewBox": "0 0 12 14",
  "content": "<symbol viewBox=\"0 0 12 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-yt-play\">\n<path d=\"M0 12.312C0.0276982 13.6161 1.27948 14.4049 2.37571 13.7844L11.1935 8.44611C11.674 8.15586 12 7.62159 12 6.9969C12 6.37221 11.674 5.83795 11.1935 5.54769L2.37571 0.216665C1.27948 -0.40383 0.0276819 0.377573 0 1.68165V12.312Z\" fill=\"white\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_node_array__ = __webpack_require__(567);



/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var context = _ref.context,
      _ref$label = _ref.label,
      label = _ref$label === undefined ? 'context-to-element' : _ref$label,
      resolveDocument = _ref.resolveDocument,
      defaultToDocument = _ref.defaultToDocument;

  var element = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_node_array__["a" /* default */])(context)[0];

  if (resolveDocument && element && element.nodeType === Node.DOCUMENT_NODE) {
    element = element.documentElement;
  }

  if (!element && defaultToDocument) {
    return document.documentElement;
  }

  if (!element) {
    throw new TypeError(label + ' requires valid options.context');
  }

  if (element.nodeType !== Node.ELEMENT_NODE && element.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) {
    throw new TypeError(label + ' requires options.context to be an Element');
  }

  return element;
});
//# sourceMappingURL=context-to-element.js.map

/***/ }),
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = matches;
var proto = window.Element.prototype;
var nativeMatches = proto.matches || proto.matchesSelector || proto.webkitMatchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector;

/**
 * Tests if a DOM elements matches any of the test DOM elements or selectors.
 * @param {Element} element The DOM element to test.
 * @param {Element|string|Array<Element|string>} test A DOM element, a CSS
 *     selector, or an array of DOM elements or CSS selectors to match against.
 * @return {boolean} True of any part of the test matches.
 */
function matches(element, test) {
  // Validate input.
  if (element && element.nodeType == 1 && test) {
    // if test is a string or DOM element test it.
    if (typeof test == 'string' || test.nodeType == 1) {
      return element == test || matchesSelector(element, /** @type {string} */test);
    } else if ('length' in test) {
      // if it has a length property iterate over the items
      // and return true if any match.
      for (var i = 0, item; item = test[i]; i++) {
        if (element == item || matchesSelector(element, item)) return true;
      }
    }
  }
  // Still here? Return false
  return false;
}

/**
 * Tests whether a DOM element matches a selector. This polyfills the native
 * Element.prototype.matches method across browsers.
 * @param {!Element} element The DOM element to test.
 * @param {string} selector The CSS selector to test element against.
 * @return {boolean} True if the selector matches.
 */
function matchesSelector(element, selector) {
  if (typeof selector != 'string') return false;
  if (nativeMatches) return nativeMatches.call(element, selector);
  var nodes = element.parentNode.querySelectorAll(selector);
  for (var i = 0, node; node = nodes[i]; i++) {
    if (node == element) return true;
  }
  return false;
}

/***/ }),
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */
/***/ (function(module, exports) {

(function(window, factory) {
	var lazySizes = factory(window, window.document);
	window.lazySizes = lazySizes;
	if(typeof module == 'object' && module.exports){
		module.exports = lazySizes;
	}
}(window, function l(window, document) {
	'use strict';
	/*jshint eqnull:true */
	if(!document.getElementsByClassName){return;}

	var lazysizes, lazySizesConfig;

	var docElem = document.documentElement;

	var Date = window.Date;

	var supportPicture = window.HTMLPictureElement;

	var _addEventListener = 'addEventListener';

	var _getAttribute = 'getAttribute';

	var addEventListener = window[_addEventListener];

	var setTimeout = window.setTimeout;

	var requestAnimationFrame = window.requestAnimationFrame || setTimeout;

	var requestIdleCallback = window.requestIdleCallback;

	var regPicture = /^picture$/i;

	var loadEvents = ['load', 'error', 'lazyincluded', '_lazyloaded'];

	var regClassCache = {};

	var forEach = Array.prototype.forEach;

	var hasClass = function(ele, cls) {
		if(!regClassCache[cls]){
			regClassCache[cls] = new RegExp('(\\s|^)'+cls+'(\\s|$)');
		}
		return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
	};

	var addClass = function(ele, cls) {
		if (!hasClass(ele, cls)){
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
		}
	};

	var removeClass = function(ele, cls) {
		var reg;
		if ((reg = hasClass(ele,cls))) {
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
		}
	};

	var addRemoveLoadEvents = function(dom, fn, add){
		var action = add ? _addEventListener : 'removeEventListener';
		if(add){
			addRemoveLoadEvents(dom, fn);
		}
		loadEvents.forEach(function(evt){
			dom[action](evt, fn);
		});
	};

	var triggerEvent = function(elem, name, detail, noBubbles, noCancelable){
		var event = document.createEvent('CustomEvent');

		if(!detail){
			detail = {};
		}

		detail.instance = lazysizes;

		event.initCustomEvent(name, !noBubbles, !noCancelable, detail);

		elem.dispatchEvent(event);
		return event;
	};

	var updatePolyfill = function (el, full){
		var polyfill;
		if( !supportPicture && ( polyfill = (window.picturefill || lazySizesConfig.pf) ) ){
			polyfill({reevaluate: true, elements: [el]});
		} else if(full && full.src){
			el.src = full.src;
		}
	};

	var getCSS = function (elem, style){
		return (getComputedStyle(elem, null) || {})[style];
	};

	var getWidth = function(elem, parent, width){
		width = width || elem.offsetWidth;

		while(width < lazySizesConfig.minSize && parent && !elem._lazysizesWidth){
			width =  parent.offsetWidth;
			parent = parent.parentNode;
		}

		return width;
	};

	var rAF = (function(){
		var running, waiting;
		var firstFns = [];
		var secondFns = [];
		var fns = firstFns;

		var run = function(){
			var runFns = fns;

			fns = firstFns.length ? secondFns : firstFns;

			running = true;
			waiting = false;

			while(runFns.length){
				runFns.shift()();
			}

			running = false;
		};

		var rafBatch = function(fn, queue){
			if(running && !queue){
				fn.apply(this, arguments);
			} else {
				fns.push(fn);

				if(!waiting){
					waiting = true;
					(document.hidden ? setTimeout : requestAnimationFrame)(run);
				}
			}
		};

		rafBatch._lsFlush = run;

		return rafBatch;
	})();

	var rAFIt = function(fn, simple){
		return simple ?
			function() {
				rAF(fn);
			} :
			function(){
				var that = this;
				var args = arguments;
				rAF(function(){
					fn.apply(that, args);
				});
			}
		;
	};

	var throttle = function(fn){
		var running;
		var lastTime = 0;
		var gDelay = 125;
		var RIC_DEFAULT_TIMEOUT = 666;
		var rICTimeout = RIC_DEFAULT_TIMEOUT;
		var run = function(){
			running = false;
			lastTime = Date.now();
			fn();
		};
		var idleCallback = requestIdleCallback ?
			function(){
				requestIdleCallback(run, {timeout: rICTimeout});
				if(rICTimeout !== RIC_DEFAULT_TIMEOUT){
					rICTimeout = RIC_DEFAULT_TIMEOUT;
				}
			}:
			rAFIt(function(){
				setTimeout(run);
			}, true)
		;

		return function(isPriority){
			var delay;
			if((isPriority = isPriority === true)){
				rICTimeout = 44;
			}

			if(running){
				return;
			}

			running =  true;

			delay = gDelay - (Date.now() - lastTime);

			if(delay < 0){
				delay = 0;
			}

			if(isPriority || (delay < 9 && requestIdleCallback)){
				idleCallback();
			} else {
				setTimeout(idleCallback, delay);
			}
		};
	};

	//based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
	var debounce = function(func) {
		var timeout, timestamp;
		var wait = 99;
		var run = function(){
			timeout = null;
			func();
		};
		var later = function() {
			var last = Date.now() - timestamp;

			if (last < wait) {
				setTimeout(later, wait - last);
			} else {
				(requestIdleCallback || run)(run);
			}
		};

		return function() {
			timestamp = Date.now();

			if (!timeout) {
				timeout = setTimeout(later, wait);
			}
		};
	};


	var loader = (function(){
		var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;

		var eLvW, elvH, eLtop, eLleft, eLright, eLbottom;

		var defaultExpand, preloadExpand, hFac;

		var regImg = /^img$/i;
		var regIframe = /^iframe$/i;

		var supportScroll = ('onscroll' in window) && !(/glebot/.test(navigator.userAgent));

		var shrinkExpand = 0;
		var currentExpand = 0;

		var isLoading = 0;
		var lowRuns = -1;

		var resetPreloading = function(e){
			isLoading--;
			if(e && e.target){
				addRemoveLoadEvents(e.target, resetPreloading);
			}

			if(!e || isLoading < 0 || !e.target){
				isLoading = 0;
			}
		};

		var isNestedVisible = function(elem, elemExpand){
			var outerRect;
			var parent = elem;
			var visible = getCSS(document.body, 'visibility') == 'hidden' || getCSS(elem, 'visibility') != 'hidden';

			eLtop -= elemExpand;
			eLbottom += elemExpand;
			eLleft -= elemExpand;
			eLright += elemExpand;

			while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
				visible = ((getCSS(parent, 'opacity') || 1) > 0);

				if(visible && getCSS(parent, 'overflow') != 'visible'){
					outerRect = parent.getBoundingClientRect();
					visible = eLright > outerRect.left &&
						eLleft < outerRect.right &&
						eLbottom > outerRect.top - 1 &&
						eLtop < outerRect.bottom + 1
					;
				}
			}

			return visible;
		};

		var checkElements = function() {
			var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal, beforeExpandVal;

			var lazyloadElems = lazysizes.elements;

			if((loadMode = lazySizesConfig.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)){

				i = 0;

				lowRuns++;

				if(preloadExpand == null){
					if(!('expand' in lazySizesConfig)){
						lazySizesConfig.expand = docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370;
					}

					defaultExpand = lazySizesConfig.expand;
					preloadExpand = defaultExpand * lazySizesConfig.expFactor;
				}

				if(currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden){
					currentExpand = preloadExpand;
					lowRuns = 0;
				} else if(loadMode > 1 && lowRuns > 1 && isLoading < 6){
					currentExpand = defaultExpand;
				} else {
					currentExpand = shrinkExpand;
				}

				for(; i < eLlen; i++){

					if(!lazyloadElems[i] || lazyloadElems[i]._lazyRace){continue;}

					if(!supportScroll){unveilElement(lazyloadElems[i]);continue;}

					if(!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)){
						elemExpand = currentExpand;
					}

					if(beforeExpandVal !== elemExpand){
						eLvW = innerWidth + (elemExpand * hFac);
						elvH = innerHeight + elemExpand;
						elemNegativeExpand = elemExpand * -1;
						beforeExpandVal = elemExpand;
					}

					rect = lazyloadElems[i].getBoundingClientRect();

					if ((eLbottom = rect.bottom) >= elemNegativeExpand &&
						(eLtop = rect.top) <= elvH &&
						(eLright = rect.right) >= elemNegativeExpand * hFac &&
						(eLleft = rect.left) <= eLvW &&
						(eLbottom || eLright || eLleft || eLtop) &&
						(lazySizesConfig.loadHidden || getCSS(lazyloadElems[i], 'visibility') != 'hidden') &&
						((isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4)) || isNestedVisible(lazyloadElems[i], elemExpand))){
						unveilElement(lazyloadElems[i]);
						loadedSomething = true;
						if(isLoading > 9){break;}
					} else if(!loadedSomething && isCompleted && !autoLoadElem &&
						isLoading < 4 && lowRuns < 4 && loadMode > 2 &&
						(preloadElems[0] || lazySizesConfig.preloadAfterLoad) &&
						(preloadElems[0] || (!elemExpandVal && ((eLbottom || eLright || eLleft || eLtop) || lazyloadElems[i][_getAttribute](lazySizesConfig.sizesAttr) != 'auto')))){
						autoLoadElem = preloadElems[0] || lazyloadElems[i];
					}
				}

				if(autoLoadElem && !loadedSomething){
					unveilElement(autoLoadElem);
				}
			}
		};

		var throttledCheckElements = throttle(checkElements);

		var switchLoadingClass = function(e){
			addClass(e.target, lazySizesConfig.loadedClass);
			removeClass(e.target, lazySizesConfig.loadingClass);
			addRemoveLoadEvents(e.target, rafSwitchLoadingClass);
			triggerEvent(e.target, 'lazyloaded');
		};
		var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
		var rafSwitchLoadingClass = function(e){
			rafedSwitchLoadingClass({target: e.target});
		};

		var changeIframeSrc = function(elem, src){
			try {
				elem.contentWindow.location.replace(src);
			} catch(e){
				elem.src = src;
			}
		};

		var handleSources = function(source){
			var customMedia;

			var sourceSrcset = source[_getAttribute](lazySizesConfig.srcsetAttr);

			if( (customMedia = lazySizesConfig.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) ){
				source.setAttribute('media', customMedia);
			}

			if(sourceSrcset){
				source.setAttribute('srcset', sourceSrcset);
			}
		};

		var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg){
			var src, srcset, parent, isPicture, event, firesLoad;

			if(!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented){

				if(sizes){
					if(isAuto){
						addClass(elem, lazySizesConfig.autosizesClass);
					} else {
						elem.setAttribute('sizes', sizes);
					}
				}

				srcset = elem[_getAttribute](lazySizesConfig.srcsetAttr);
				src = elem[_getAttribute](lazySizesConfig.srcAttr);

				if(isImg) {
					parent = elem.parentNode;
					isPicture = parent && regPicture.test(parent.nodeName || '');
				}

				firesLoad = detail.firesLoad || (('src' in elem) && (srcset || src || isPicture));

				event = {target: elem};

				if(firesLoad){
					addRemoveLoadEvents(elem, resetPreloading, true);
					clearTimeout(resetPreloadingTimer);
					resetPreloadingTimer = setTimeout(resetPreloading, 2500);

					addClass(elem, lazySizesConfig.loadingClass);
					addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
				}

				if(isPicture){
					forEach.call(parent.getElementsByTagName('source'), handleSources);
				}

				if(srcset){
					elem.setAttribute('srcset', srcset);
				} else if(src && !isPicture){
					if(regIframe.test(elem.nodeName)){
						changeIframeSrc(elem, src);
					} else {
						elem.src = src;
					}
				}

				if(isImg && (srcset || isPicture)){
					updatePolyfill(elem, {src: src});
				}
			}

			if(elem._lazyRace){
				delete elem._lazyRace;
			}
			removeClass(elem, lazySizesConfig.lazyClass);

			rAF(function(){
				if( !firesLoad || (elem.complete && elem.naturalWidth > 1)){
					if(firesLoad){
						resetPreloading(event);
					} else {
						isLoading--;
					}
					switchLoadingClass(event);
				}
			}, true);
		});

		var unveilElement = function (elem){
			var detail;

			var isImg = regImg.test(elem.nodeName);

			//allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
			var sizes = isImg && (elem[_getAttribute](lazySizesConfig.sizesAttr) || elem[_getAttribute]('sizes'));
			var isAuto = sizes == 'auto';

			if( (isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesConfig.errorClass)){return;}

			detail = triggerEvent(elem, 'lazyunveilread').detail;

			if(isAuto){
				 autoSizer.updateElem(elem, true, elem.offsetWidth);
			}

			elem._lazyRace = true;
			isLoading++;

			lazyUnveil(elem, detail, isAuto, sizes, isImg);
		};

		var onload = function(){
			if(isCompleted){return;}
			if(Date.now() - started < 999){
				setTimeout(onload, 999);
				return;
			}
			var afterScroll = debounce(function(){
				lazySizesConfig.loadMode = 3;
				throttledCheckElements();
			});

			isCompleted = true;

			lazySizesConfig.loadMode = 3;

			throttledCheckElements();

			addEventListener('scroll', function(){
				if(lazySizesConfig.loadMode == 3){
					lazySizesConfig.loadMode = 2;
				}
				afterScroll();
			}, true);
		};

		return {
			_: function(){
				started = Date.now();

				lazysizes.elements = document.getElementsByClassName(lazySizesConfig.lazyClass);
				preloadElems = document.getElementsByClassName(lazySizesConfig.lazyClass + ' ' + lazySizesConfig.preloadClass);
				hFac = lazySizesConfig.hFac;

				addEventListener('scroll', throttledCheckElements, true);

				addEventListener('resize', throttledCheckElements, true);

				if(window.MutationObserver){
					new MutationObserver( throttledCheckElements ).observe( docElem, {childList: true, subtree: true, attributes: true} );
				} else {
					docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
					docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
					setInterval(throttledCheckElements, 999);
				}

				addEventListener('hashchange', throttledCheckElements, true);

				//, 'fullscreenchange'
				['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend', 'webkitAnimationEnd'].forEach(function(name){
					document[_addEventListener](name, throttledCheckElements, true);
				});

				if((/d$|^c/.test(document.readyState))){
					onload();
				} else {
					addEventListener('load', onload);
					document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
					setTimeout(onload, 20000);
				}

				if(lazysizes.elements.length){
					checkElements();
					rAF._lsFlush();
				} else {
					throttledCheckElements();
				}
			},
			checkElems: throttledCheckElements,
			unveil: unveilElement
		};
	})();


	var autoSizer = (function(){
		var autosizesElems;

		var sizeElement = rAFIt(function(elem, parent, event, width){
			var sources, i, len;
			elem._lazysizesWidth = width;
			width += 'px';

			elem.setAttribute('sizes', width);

			if(regPicture.test(parent.nodeName || '')){
				sources = parent.getElementsByTagName('source');
				for(i = 0, len = sources.length; i < len; i++){
					sources[i].setAttribute('sizes', width);
				}
			}

			if(!event.detail.dataAttr){
				updatePolyfill(elem, event.detail);
			}
		});
		var getSizeElement = function (elem, dataAttr, width){
			var event;
			var parent = elem.parentNode;

			if(parent){
				width = getWidth(elem, parent, width);
				event = triggerEvent(elem, 'lazybeforesizes', {width: width, dataAttr: !!dataAttr});

				if(!event.defaultPrevented){
					width = event.detail.width;

					if(width && width !== elem._lazysizesWidth){
						sizeElement(elem, parent, event, width);
					}
				}
			}
		};

		var updateElementsSizes = function(){
			var i;
			var len = autosizesElems.length;
			if(len){
				i = 0;

				for(; i < len; i++){
					getSizeElement(autosizesElems[i]);
				}
			}
		};

		var debouncedUpdateElementsSizes = debounce(updateElementsSizes);

		return {
			_: function(){
				autosizesElems = document.getElementsByClassName(lazySizesConfig.autosizesClass);
				addEventListener('resize', debouncedUpdateElementsSizes);
			},
			checkElems: debouncedUpdateElementsSizes,
			updateElem: getSizeElement
		};
	})();

	var init = function(){
		if(!init.i){
			init.i = true;
			autoSizer._();
			loader._();
		}
	};

	(function(){
		var prop;

		var lazySizesDefaults = {
			lazyClass: 'lazyload',
			loadedClass: 'lazyloaded',
			loadingClass: 'lazyloading',
			preloadClass: 'lazypreload',
			errorClass: 'lazyerror',
			//strictClass: 'lazystrict',
			autosizesClass: 'lazyautosizes',
			srcAttr: 'data-src',
			srcsetAttr: 'data-srcset',
			sizesAttr: 'data-sizes',
			//preloadAfterLoad: false,
			minSize: 40,
			customMedia: {},
			init: true,
			expFactor: 1.5,
			hFac: 0.8,
			loadMode: 2,
			loadHidden: true,
		};

		lazySizesConfig = window.lazySizesConfig || window.lazysizesConfig || {};

		for(prop in lazySizesDefaults){
			if(!(prop in lazySizesConfig)){
				lazySizesConfig[prop] = lazySizesDefaults[prop];
			}
		}

		window.lazySizesConfig = lazySizesConfig;

		setTimeout(function(){
			if(lazySizesConfig.init){
				init();
			}
		});
	})();

	lazysizes = {
		cfg: lazySizesConfig,
		autoSizer: autoSizer,
		loader: loader,
		init: init,
		uP: updatePolyfill,
		aC: addClass,
		rC: removeClass,
		hC: hasClass,
		fire: triggerEvent,
		gW: getWidth,
		rAF: rAF,
	};

	return lazysizes;
}
));


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Accordion = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(208);

var _resize = __webpack_require__(17);

var _resize2 = _interopRequireDefault(_resize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Accordion = exports.Accordion = function (_Snappy$BaseComponent) {
    _inherits(Accordion, _Snappy$BaseComponent);

    _createClass(Accordion, null, [{
        key: 'tagName',
        get: function get() {
            return 'cfa-accordion';
        }
    }]);

    function Accordion(element) {
        _classCallCheck(this, Accordion);

        return _possibleConstructorReturn(this, (Accordion.__proto__ || Object.getPrototypeOf(Accordion)).call(this, element));
    }

    _createClass(Accordion, [{
        key: 'render',
        value: function render() {
            this.setVars();

            this.onResize();

            this.$window.on('resize:finished', this.bindedResize = this.onResize.bind(this));

            if (this.isOpened) {
                this.$accordionLink.attr('aria-expanded', true);
            }
        }
    }, {
        key: 'onResize',
        value: function onResize() {
            if (this.isOn && !this.isListenersAdded) {
                this.setEventListeners();
            } else if (!this.isOn && this.isListenersAdded) {
                this.removeEventListeners();
            }
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            var _this2 = this;

            this.settings = _extends({}, _snappy2.default.Component.Accordion._settings, this.$element.data(), typeof settings == 'undefined' ? {} : settings);

            this.$accordionLink = this.$element.find('.js-accordion-link').filter(function (index, el) {
                return (0, _jquery2.default)(el).parents('[data-cfa-accordion]').first().is(_this2.$element) ? true : false;
            });
            this.$accordionContent = this.$element.find('.js-accordion-content').filter(function (index, el) {
                return (0, _jquery2.default)(el).parents('[data-cfa-accordion]').first().is(_this2.$element) ? true : false;
            });
            this.$lazyContent = this.$accordionContent.find('.js-accordion-lazy-content');
            this.preloader = this.$element.find('.js-cfa-preloader');
            this.isOpened = this.$element.hasClass('is-opened');
            this.isAnimating = false;
            this.type = this.$element.data('type');
            this.url = this.$element.data('url');
            this.hasContent = !(this.type === 'lazy');
            this.isLoading = false;
            this.isExperienceEditor = (0, _jquery2.default)('body').hasClass('is-experience-editor');
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {

            if (!this.isOpened) {
                this.$accordionContent.css({
                    'max-height': 0,
                    'overflow': 'hidden',
                    'display': 'none'
                });
            }

            this.$accordionLink.on('click', this.clickListener = this.clickProcess.bind(this));
            this.$accordionLink.on('keydown', this.keydownListener = this.keydownProcess.bind(this));
            this.isListenersAdded = true;
        }
    }, {
        key: 'removeEventListeners',
        value: function removeEventListeners() {
            this.$accordionContent.css({
                'max-height': '',
                'overflow': '',
                'display': ''
            });
            this.$accordionLink.off('click', this.clickListener);
            this.$accordionLink.off('keydown', this.keydownListener);
            this.isListenersAdded = false;
        }
    }, {
        key: 'clickProcess',
        value: function clickProcess(e) {
            if (typeof e !== 'undefined' && typeof e.preventDefault === "function") {
                e.preventDefault();
            }
            if (this.isAnimating) {
                return;
            }

            if (this.type === 'lazy' && !this.hasContent && !this.isOpened) {
                this.downloadContent();
                return;
            }

            this[this.isOpened ? "close" : "open"]();
            this.isAnimating = true;
        }
    }, {
        key: 'keydownProcess',
        value: function keydownProcess(event) {
            var keyCode = event.which;

            switch (keyCode) {
                case 13:
                case 32:
                    if (!this.isExperienceEditor) {
                        this.clickProcess(event);
                    }
                    break;
                default:
                    break;
            }
        }
    }, {
        key: 'open',
        value: function open() {
            if (this.isOpened) {
                this.animationComplete();
                return;
            }

            var $accordionChildren = this.$accordionContent.children();
            if (!$accordionChildren.length) return;

            this.$accordionContent.css({
                'display': 'block'
            });

            this.isOpened = true;
            this.$accordionLink.attr('aria-expanded', true);
            this.tween = new _gsap.TimelineLite({ onComplete: this.animationComplete.bind(this) });
            this.tween.fromTo(this.$accordionContent, this.settings.time, {
                maxHeight: this.$accordionContent.css('max-height')
            }, {
                maxHeight: $accordionChildren.first().outerHeight()
            });
            this.tween.play();
        }
    }, {
        key: 'close',
        value: function close() {
            if (!this.isOpened) {
                this.animationComplete();
                return;
            }
            this.isOpened = false;
            this.$accordionLink.attr('aria-expanded', false);

            this.$accordionContent.css({
                'max-height': this.$accordionContent.children().first().outerHeight(),
                'overflow': 'hidden'
            });
            this.$element.removeClass('is-opened');
            this.tween = new _gsap.TimelineLite({ onComplete: this.animationComplete.bind(this) });
            this.tween.to(this.$accordionContent, this.settings.time, { maxHeight: 0 });
            this.tween.play();
        }
    }, {
        key: 'animationComplete',
        value: function animationComplete() {
            if (this.settings.erase) {
                this.$accordionContent.css({
                    'max-height': '',
                    'overflow': ''
                });
            } else {
                this.$accordionContent.css('max-height', this.isOpened ? 'none' : '0');
                this.$accordionContent.css('overflow', this.isOpened ? 'visible' : 'hidden');
                this.$accordionContent.css('display', this.isOpened ? 'block' : 'none');
            }

            if (this.isOpened) {
                this.$element.addClass('is-opened');
            }
            this.isAnimating = false;
        }
    }, {
        key: 'downloadContent',
        value: function downloadContent() {
            var _this3 = this;

            this.$lazyContent.html('');
            this.isLoading = true;
            this.toggleLoading();
            this.preloader.css({
                'height': '100px',
                'max-height': '100px'
            });

            _jquery2.default.ajax({
                url: this.url,
                type: "GET",
                dataType: "html"
            }).done(function (data) {
                _this3.$lazyContent.html(data);
                _this3.hasContent = true;
            }).fail(function () {
                _this3.$lazyContent.html('<div class="no-data">Error getting data from Server. Please contact site administrator or try to reopen accordion again later.</div>');
            }).always(function () {
                _this3.preloader.css({
                    'height': 'auto'
                });

                _this3.isLoading = false;
                _this3.toggleLoading();
                _this3.open();
            });
        }
    }, {
        key: 'toggleLoading',
        value: function toggleLoading() {
            this.preloader.toggleClass('cfa-preloader--active', this.isLoading);
        }
    }, {
        key: 'isOn',
        get: function get() {
            var isOnMobile = !_resize2.default.isTablet && this.settings.mobile.toString() != 'false',
                isOnTablet = _resize2.default.isTablet && !_resize2.default.isDesktop && this.settings.tablet.toString() != 'false',
                isOnDesktop = _resize2.default.isDesktop && this.settings.desktop.toString() != 'false',
                isOn = isOnMobile || isOnTablet || isOnDesktop;

            return isOn;
        }
    }]);

    return Accordion;
}(_snappy2.default.BaseComponent);

;

_snappy2.default.Component.Accordion = Accordion;

_snappy2.default.Component.Accordion._settings = {
    erase: false,
    time: 0.5,
    mobile: true,
    tablet: true,
    desktop: true
};

exports.default = _snappy2.default.Component.Accordion;

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/*!
 * Glide.js v3.4.1
 * (c) 2013-2019 Jędrzej Chałubek <jedrzej.chalubek@gmail.com> (http://jedrzejchalubek.com/)
 * Released under the MIT License.
 */

var defaults = {
  /**
   * Type of the movement.
   *
   * Available types:
   * `slider` - Rewinds slider to the start/end when it reaches the first or last slide.
   * `carousel` - Changes slides without starting over when it reaches the first or last slide.
   *
   * @type {String}
   */
  type: 'slider',

  /**
   * Start at specific slide number defined with zero-based index.
   *
   * @type {Number}
   */
  startAt: 0,

  /**
   * A number of slides visible on the single viewport.
   *
   * @type {Number}
   */
  perView: 1,

  /**
   * Focus currently active slide at a specified position in the track.
   *
   * Available inputs:
   * `center` - Current slide will be always focused at the center of a track.
   * `0,1,2,3...` - Current slide will be focused on the specified zero-based index.
   *
   * @type {String|Number}
   */
  focusAt: 0,

  /**
   * A size of the gap added between slides.
   *
   * @type {Number}
   */
  gap: 10,

  /**
   * Change slides after a specified interval. Use `false` for turning off autoplay.
   *
   * @type {Number|Boolean}
   */
  autoplay: false,

  /**
   * Stop autoplay on mouseover event.
   *
   * @type {Boolean}
   */
  hoverpause: true,

  /**
   * Allow for changing slides with left and right keyboard arrows.
   *
   * @type {Boolean}
   */
  keyboard: true,

  /**
   * Stop running `perView` number of slides from the end. Use this
   * option if you don't want to have an empty space after
   * a slider. Works only with `slider` type and a
   * non-centered `focusAt` setting.
   *
   * @type {Boolean}
   */
  bound: false,

  /**
   * Minimal swipe distance needed to change the slide. Use `false` for turning off a swiping.
   *
   * @type {Number|Boolean}
   */
  swipeThreshold: 80,

  /**
   * Minimal mouse drag distance needed to change the slide. Use `false` for turning off a dragging.
   *
   * @type {Number|Boolean}
   */
  dragThreshold: 120,

  /**
   * A maximum number of slides to which movement will be made on swiping or dragging. Use `false` for unlimited.
   *
   * @type {Number|Boolean}
   */
  perTouch: false,

  /**
   * Moving distance ratio of the slides on a swiping and dragging.
   *
   * @type {Number}
   */
  touchRatio: 0.5,

  /**
   * Angle required to activate slides moving on swiping or dragging.
   *
   * @type {Number}
   */
  touchAngle: 45,

  /**
   * Duration of the animation in milliseconds.
   *
   * @type {Number}
   */
  animationDuration: 400,

  /**
   * Allows looping the `slider` type. Slider will rewind to the first/last slide when it's at the start/end.
   *
   * @type {Boolean}
   */
  rewind: true,

  /**
   * Duration of the rewinding animation of the `slider` type in milliseconds.
   *
   * @type {Number}
   */
  rewindDuration: 800,

  /**
   * Easing function for the animation.
   *
   * @type {String}
   */
  animationTimingFunc: 'cubic-bezier(.165, .840, .440, 1)',

  /**
   * Throttle costly events at most once per every wait milliseconds.
   *
   * @type {Number}
   */
  throttle: 10,

  /**
   * Moving direction mode.
   *
   * Available inputs:
   * - 'ltr' - left to right movement,
   * - 'rtl' - right to left movement.
   *
   * @type {String}
   */
  direction: 'ltr',

  /**
   * The distance value of the next and previous viewports which
   * have to peek in the current view. Accepts number and
   * pixels as a string. Left and right peeking can be
   * set up separately with a directions object.
   *
   * For example:
   * `100` - Peek 100px on the both sides.
   * { before: 100, after: 50 }` - Peek 100px on the left side and 50px on the right side.
   *
   * @type {Number|String|Object}
   */
  peek: 0,

  /**
   * Collection of options applied at specified media breakpoints.
   * For example: display two slides per view under 800px.
   * `{
   *   '800px': {
   *     perView: 2
   *   }
   * }`
   */
  breakpoints: {},

  /**
   * Collection of internally used HTML classes.
   *
   * @todo Refactor `slider` and `carousel` properties to single `type: { slider: '', carousel: '' }` object
   * @type {Object}
   */
  classes: {
    direction: {
      ltr: 'glide--ltr',
      rtl: 'glide--rtl'
    },
    slider: 'glide--slider',
    carousel: 'glide--carousel',
    swipeable: 'glide--swipeable',
    dragging: 'glide--dragging',
    cloneSlide: 'glide__slide--clone',
    activeNav: 'glide__bullet--active',
    activeSlide: 'glide__slide--active',
    disabledArrow: 'glide__arrow--disabled'
  }
};

/**
 * Outputs warning message to the bowser console.
 *
 * @param  {String} msg
 * @return {Void}
 */
function warn(msg) {
  console.error("[Glide warn]: " + msg);
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

/**
 * Converts value entered as number
 * or string to integer value.
 *
 * @param {String} value
 * @returns {Number}
 */
function toInt(value) {
  return parseInt(value);
}

/**
 * Converts value entered as number
 * or string to flat value.
 *
 * @param {String} value
 * @returns {Number}
 */
function toFloat(value) {
  return parseFloat(value);
}

/**
 * Indicates whether the specified value is a string.
 *
 * @param  {*}   value
 * @return {Boolean}
 */
function isString(value) {
  return typeof value === 'string';
}

/**
 * Indicates whether the specified value is an object.
 *
 * @param  {*} value
 * @return {Boolean}
 *
 * @see https://github.com/jashkenas/underscore
 */
function isObject(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);

  return type === 'function' || type === 'object' && !!value; // eslint-disable-line no-mixed-operators
}

/**
 * Indicates whether the specified value is a number.
 *
 * @param  {*} value
 * @return {Boolean}
 */
function isNumber(value) {
  return typeof value === 'number';
}

/**
 * Indicates whether the specified value is a function.
 *
 * @param  {*} value
 * @return {Boolean}
 */
function isFunction(value) {
  return typeof value === 'function';
}

/**
 * Indicates whether the specified value is undefined.
 *
 * @param  {*} value
 * @return {Boolean}
 */
function isUndefined(value) {
  return typeof value === 'undefined';
}

/**
 * Indicates whether the specified value is an array.
 *
 * @param  {*} value
 * @return {Boolean}
 */
function isArray(value) {
  return value.constructor === Array;
}

/**
 * Creates and initializes specified collection of extensions.
 * Each extension receives access to instance of glide and rest of components.
 *
 * @param {Object} glide
 * @param {Object} extensions
 *
 * @returns {Object}
 */
function mount(glide, extensions, events) {
  var components = {};

  for (var name in extensions) {
    if (isFunction(extensions[name])) {
      components[name] = extensions[name](glide, components, events);
    } else {
      warn('Extension must be a function');
    }
  }

  for (var _name in components) {
    if (isFunction(components[_name].mount)) {
      components[_name].mount();
    }
  }

  return components;
}

/**
 * Defines getter and setter property on the specified object.
 *
 * @param  {Object} obj         Object where property has to be defined.
 * @param  {String} prop        Name of the defined property.
 * @param  {Object} definition  Get and set definitions for the property.
 * @return {Void}
 */
function define(obj, prop, definition) {
  Object.defineProperty(obj, prop, definition);
}

/**
 * Sorts aphabetically object keys.
 *
 * @param  {Object} obj
 * @return {Object}
 */
function sortKeys(obj) {
  return Object.keys(obj).sort().reduce(function (r, k) {
    r[k] = obj[k];

    return r[k], r;
  }, {});
}

/**
 * Merges passed settings object with default options.
 *
 * @param  {Object} defaults
 * @param  {Object} settings
 * @return {Object}
 */
function mergeOptions(defaults, settings) {
  var options = _extends({}, defaults, settings);

  // `Object.assign` do not deeply merge objects, so we
  // have to do it manually for every nested object
  // in options. Although it does not look smart,
  // it's smaller and faster than some fancy
  // merging deep-merge algorithm script.
  if (settings.hasOwnProperty('classes')) {
    options.classes = _extends({}, defaults.classes, settings.classes);

    if (settings.classes.hasOwnProperty('direction')) {
      options.classes.direction = _extends({}, defaults.classes.direction, settings.classes.direction);
    }
  }

  if (settings.hasOwnProperty('breakpoints')) {
    options.breakpoints = _extends({}, defaults.breakpoints, settings.breakpoints);
  }

  return options;
}

var EventsBus = function () {
  /**
   * Construct a EventBus instance.
   *
   * @param {Object} events
   */
  function EventsBus() {
    var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    classCallCheck(this, EventsBus);

    this.events = events;
    this.hop = events.hasOwnProperty;
  }

  /**
   * Adds listener to the specifed event.
   *
   * @param {String|Array} event
   * @param {Function} handler
   */


  createClass(EventsBus, [{
    key: 'on',
    value: function on(event, handler) {
      if (isArray(event)) {
        for (var i = 0; i < event.length; i++) {
          this.on(event[i], handler);
        }
      }

      // Create the event's object if not yet created
      if (!this.hop.call(this.events, event)) {
        this.events[event] = [];
      }

      // Add the handler to queue
      var index = this.events[event].push(handler) - 1;

      // Provide handle back for removal of event
      return {
        remove: function remove() {
          delete this.events[event][index];
        }
      };
    }

    /**
     * Runs registered handlers for specified event.
     *
     * @param {String|Array} event
     * @param {Object=} context
     */

  }, {
    key: 'emit',
    value: function emit(event, context) {
      if (isArray(event)) {
        for (var i = 0; i < event.length; i++) {
          this.emit(event[i], context);
        }
      }

      // If the event doesn't exist, or there's no handlers in queue, just leave
      if (!this.hop.call(this.events, event)) {
        return;
      }

      // Cycle through events queue, fire!
      this.events[event].forEach(function (item) {
        item(context || {});
      });
    }
  }]);
  return EventsBus;
}();

var Glide = function () {
  /**
   * Construct glide.
   *
   * @param  {String} selector
   * @param  {Object} options
   */
  function Glide(selector) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, Glide);

    this._c = {};
    this._t = [];
    this._e = new EventsBus();

    this.disabled = false;
    this.selector = selector;
    this.settings = mergeOptions(defaults, options);
    this.index = this.settings.startAt;
  }

  /**
   * Initializes glide.
   *
   * @param {Object} extensions Collection of extensions to initialize.
   * @return {Glide}
   */


  createClass(Glide, [{
    key: 'mount',
    value: function mount$$1() {
      var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this._e.emit('mount.before');

      if (isObject(extensions)) {
        this._c = mount(this, extensions, this._e);
      } else {
        warn('You need to provide a object on `mount()`');
      }

      this._e.emit('mount.after');

      return this;
    }

    /**
     * Collects an instance `translate` transformers.
     *
     * @param  {Array} transformers Collection of transformers.
     * @return {Void}
     */

  }, {
    key: 'mutate',
    value: function mutate() {
      var transformers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (isArray(transformers)) {
        this._t = transformers;
      } else {
        warn('You need to provide a array on `mutate()`');
      }

      return this;
    }

    /**
     * Updates glide with specified settings.
     *
     * @param {Object} settings
     * @return {Glide}
     */

  }, {
    key: 'update',
    value: function update() {
      var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.settings = mergeOptions(this.settings, settings);

      if (settings.hasOwnProperty('startAt')) {
        this.index = settings.startAt;
      }

      this._e.emit('update');

      return this;
    }

    /**
     * Change slide with specified pattern. A pattern must be in the special format:
     * `>` - Move one forward
     * `<` - Move one backward
     * `={i}` - Go to {i} zero-based slide (eq. '=1', will go to second slide)
     * `>>` - Rewinds to end (last slide)
     * `<<` - Rewinds to start (first slide)
     *
     * @param {String} pattern
     * @return {Glide}
     */

  }, {
    key: 'go',
    value: function go(pattern) {
      this._c.Run.make(pattern);

      return this;
    }

    /**
     * Move track by specified distance.
     *
     * @param {String} distance
     * @return {Glide}
     */

  }, {
    key: 'move',
    value: function move(distance) {
      this._c.Transition.disable();
      this._c.Move.make(distance);

      return this;
    }

    /**
     * Destroy instance and revert all changes done by this._c.
     *
     * @return {Glide}
     */

  }, {
    key: 'destroy',
    value: function destroy() {
      this._e.emit('destroy');

      return this;
    }

    /**
     * Start instance autoplaying.
     *
     * @param {Boolean|Number} interval Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Glide}
     */

  }, {
    key: 'play',
    value: function play() {
      var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (interval) {
        this.settings.autoplay = interval;
      }

      this._e.emit('play');

      return this;
    }

    /**
     * Stop instance autoplaying.
     *
     * @return {Glide}
     */

  }, {
    key: 'pause',
    value: function pause() {
      this._e.emit('pause');

      return this;
    }

    /**
     * Sets glide into a idle status.
     *
     * @return {Glide}
     */

  }, {
    key: 'disable',
    value: function disable() {
      this.disabled = true;

      return this;
    }

    /**
     * Sets glide into a active status.
     *
     * @return {Glide}
     */

  }, {
    key: 'enable',
    value: function enable() {
      this.disabled = false;

      return this;
    }

    /**
     * Adds cuutom event listener with handler.
     *
     * @param  {String|Array} event
     * @param  {Function} handler
     * @return {Glide}
     */

  }, {
    key: 'on',
    value: function on(event, handler) {
      this._e.on(event, handler);

      return this;
    }

    /**
     * Checks if glide is a precised type.
     *
     * @param  {String} name
     * @return {Boolean}
     */

  }, {
    key: 'isType',
    value: function isType(name) {
      return this.settings.type === name;
    }

    /**
     * Gets value of the core options.
     *
     * @return {Object}
     */

  }, {
    key: 'settings',
    get: function get$$1() {
      return this._o;
    }

    /**
     * Sets value of the core options.
     *
     * @param  {Object} o
     * @return {Void}
     */
    ,
    set: function set$$1(o) {
      if (isObject(o)) {
        this._o = o;
      } else {
        warn('Options must be an `object` instance.');
      }
    }

    /**
     * Gets current index of the slider.
     *
     * @return {Object}
     */

  }, {
    key: 'index',
    get: function get$$1() {
      return this._i;
    }

    /**
     * Sets current index a slider.
     *
     * @return {Object}
     */
    ,
    set: function set$$1(i) {
      this._i = toInt(i);
    }

    /**
     * Gets type name of the slider.
     *
     * @return {String}
     */

  }, {
    key: 'type',
    get: function get$$1() {
      return this.settings.type;
    }

    /**
     * Gets value of the idle status.
     *
     * @return {Boolean}
     */

  }, {
    key: 'disabled',
    get: function get$$1() {
      return this._d;
    }

    /**
     * Sets value of the idle status.
     *
     * @return {Boolean}
     */
    ,
    set: function set$$1(status) {
      this._d = !!status;
    }
  }]);
  return Glide;
}();

function Run (Glide, Components, Events) {
  var Run = {
    /**
     * Initializes autorunning of the glide.
     *
     * @return {Void}
     */
    mount: function mount() {
      this._o = false;
    },


    /**
     * Makes glides running based on the passed moving schema.
     *
     * @param {String} move
     */
    make: function make(move) {
      var _this = this;

      if (!Glide.disabled) {
        Glide.disable();

        this.move = move;

        Events.emit('run.before', this.move);

        this.calculate();

        Events.emit('run', this.move);

        Components.Transition.after(function () {
          if (_this.isStart()) {
            Events.emit('run.start', _this.move);
          }

          if (_this.isEnd()) {
            Events.emit('run.end', _this.move);
          }

          if (_this.isOffset('<') || _this.isOffset('>')) {
            _this._o = false;

            Events.emit('run.offset', _this.move);
          }

          Events.emit('run.after', _this.move);

          Glide.enable();
        });
      }
    },


    /**
     * Calculates current index based on defined move.
     *
     * @return {Void}
     */
    calculate: function calculate() {
      var move = this.move,
          length = this.length;
      var steps = move.steps,
          direction = move.direction;


      var countableSteps = isNumber(toInt(steps)) && toInt(steps) !== 0;

      switch (direction) {
        case '>':
          if (steps === '>') {
            Glide.index = length;
          } else if (this.isEnd()) {
            if (!(Glide.isType('slider') && !Glide.settings.rewind)) {
              this._o = true;

              Glide.index = 0;
            }
          } else if (countableSteps) {
            Glide.index += Math.min(length - Glide.index, -toInt(steps));
          } else {
            Glide.index++;
          }
          break;

        case '<':
          if (steps === '<') {
            Glide.index = 0;
          } else if (this.isStart()) {
            if (!(Glide.isType('slider') && !Glide.settings.rewind)) {
              this._o = true;

              Glide.index = length;
            }
          } else if (countableSteps) {
            Glide.index -= Math.min(Glide.index, toInt(steps));
          } else {
            Glide.index--;
          }
          break;

        case '=':
          Glide.index = steps;
          break;

        default:
          warn('Invalid direction pattern [' + direction + steps + '] has been used');
          break;
      }
    },


    /**
     * Checks if we are on the first slide.
     *
     * @return {Boolean}
     */
    isStart: function isStart() {
      return Glide.index === 0;
    },


    /**
     * Checks if we are on the last slide.
     *
     * @return {Boolean}
     */
    isEnd: function isEnd() {
      return Glide.index === this.length;
    },


    /**
     * Checks if we are making a offset run.
     *
     * @param {String} direction
     * @return {Boolean}
     */
    isOffset: function isOffset(direction) {
      return this._o && this.move.direction === direction;
    }
  };

  define(Run, 'move', {
    /**
     * Gets value of the move schema.
     *
     * @returns {Object}
     */
    get: function get() {
      return this._m;
    },


    /**
     * Sets value of the move schema.
     *
     * @returns {Object}
     */
    set: function set(value) {
      var step = value.substr(1);

      this._m = {
        direction: value.substr(0, 1),
        steps: step ? toInt(step) ? toInt(step) : step : 0
      };
    }
  });

  define(Run, 'length', {
    /**
     * Gets value of the running distance based
     * on zero-indexing number of slides.
     *
     * @return {Number}
     */
    get: function get() {
      var settings = Glide.settings;
      var length = Components.Html.slides.length;

      // If the `bound` option is acitve, a maximum running distance should be
      // reduced by `perView` and `focusAt` settings. Running distance
      // should end before creating an empty space after instance.

      if (Glide.isType('slider') && settings.focusAt !== 'center' && settings.bound) {
        return length - 1 - (toInt(settings.perView) - 1) + toInt(settings.focusAt);
      }

      return length - 1;
    }
  });

  define(Run, 'offset', {
    /**
     * Gets status of the offsetting flag.
     *
     * @return {Boolean}
     */
    get: function get() {
      return this._o;
    }
  });

  return Run;
}

/**
 * Returns a current time.
 *
 * @return {Number}
 */
function now() {
  return new Date().getTime();
}

/**
 * Returns a function, that, when invoked, will only be triggered
 * at most once during a given window of time.
 *
 * @param {Function} func
 * @param {Number} wait
 * @param {Object=} options
 * @return {Function}
 *
 * @see https://github.com/jashkenas/underscore
 */
function throttle(func, wait, options) {
  var timeout = void 0,
      context = void 0,
      args = void 0,
      result = void 0;
  var previous = 0;
  if (!options) options = {};

  var later = function later() {
    previous = options.leading === false ? 0 : now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };

  var throttled = function throttled() {
    var at = now();
    if (!previous && options.leading === false) previous = at;
    var remaining = wait - (at - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = at;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };

  throttled.cancel = function () {
    clearTimeout(timeout);
    previous = 0;
    timeout = context = args = null;
  };

  return throttled;
}

var MARGIN_TYPE = {
  ltr: ['marginLeft', 'marginRight'],
  rtl: ['marginRight', 'marginLeft']
};

function Gaps (Glide, Components, Events) {
  var Gaps = {
    /**
     * Applies gaps between slides. First and last
     * slides do not receive it's edge margins.
     *
     * @param {HTMLCollection} slides
     * @return {Void}
     */
    apply: function apply(slides) {
      for (var i = 0, len = slides.length; i < len; i++) {
        var style = slides[i].style;
        var direction = Components.Direction.value;

        if (i !== 0) {
          style[MARGIN_TYPE[direction][0]] = this.value / 2 + 'px';
        } else {
          style[MARGIN_TYPE[direction][0]] = '';
        }

        if (i !== slides.length - 1) {
          style[MARGIN_TYPE[direction][1]] = this.value / 2 + 'px';
        } else {
          style[MARGIN_TYPE[direction][1]] = '';
        }
      }
    },


    /**
     * Removes gaps from the slides.
     *
     * @param {HTMLCollection} slides
     * @returns {Void}
    */
    remove: function remove(slides) {
      for (var i = 0, len = slides.length; i < len; i++) {
        var style = slides[i].style;

        style.marginLeft = '';
        style.marginRight = '';
      }
    }
  };

  define(Gaps, 'value', {
    /**
     * Gets value of the gap.
     *
     * @returns {Number}
     */
    get: function get() {
      return toInt(Glide.settings.gap);
    }
  });

  define(Gaps, 'grow', {
    /**
     * Gets additional dimentions value caused by gaps.
     * Used to increase width of the slides wrapper.
     *
     * @returns {Number}
     */
    get: function get() {
      return Gaps.value * (Components.Sizes.length - 1);
    }
  });

  define(Gaps, 'reductor', {
    /**
     * Gets reduction value caused by gaps.
     * Used to subtract width of the slides.
     *
     * @returns {Number}
     */
    get: function get() {
      var perView = Glide.settings.perView;

      return Gaps.value * (perView - 1) / perView;
    }
  });

  /**
   * Apply calculated gaps:
   * - after building, so slides (including clones) will receive proper margins
   * - on updating via API, to recalculate gaps with new options
   */
  Events.on(['build.after', 'update'], throttle(function () {
    Gaps.apply(Components.Html.wrapper.children);
  }, 30));

  /**
   * Remove gaps:
   * - on destroying to bring markup to its inital state
   */
  Events.on('destroy', function () {
    Gaps.remove(Components.Html.wrapper.children);
  });

  return Gaps;
}

/**
 * Finds siblings nodes of the passed node.
 *
 * @param  {Element} node
 * @return {Array}
 */
function siblings(node) {
  if (node && node.parentNode) {
    var n = node.parentNode.firstChild;
    var matched = [];

    for (; n; n = n.nextSibling) {
      if (n.nodeType === 1 && n !== node) {
        matched.push(n);
      }
    }

    return matched;
  }

  return [];
}

/**
 * Checks if passed node exist and is a valid element.
 *
 * @param  {Element} node
 * @return {Boolean}
 */
function exist(node) {
  if (node && node instanceof window.HTMLElement) {
    return true;
  }

  return false;
}

var TRACK_SELECTOR = '[data-glide-el="track"]';

function Html (Glide, Components) {
  var Html = {
    /**
     * Setup slider HTML nodes.
     *
     * @param {Glide} glide
     */
    mount: function mount() {
      this.root = Glide.selector;
      this.track = this.root.querySelector(TRACK_SELECTOR);
      this.slides = Array.prototype.slice.call(this.wrapper.children).filter(function (slide) {
        return !slide.classList.contains(Glide.settings.classes.cloneSlide);
      });
    }
  };

  define(Html, 'root', {
    /**
     * Gets node of the glide main element.
     *
     * @return {Object}
     */
    get: function get() {
      return Html._r;
    },


    /**
     * Sets node of the glide main element.
     *
     * @return {Object}
     */
    set: function set(r) {
      if (isString(r)) {
        r = document.querySelector(r);
      }

      if (exist(r)) {
        Html._r = r;
      } else {
        warn('Root element must be a existing Html node');
      }
    }
  });

  define(Html, 'track', {
    /**
     * Gets node of the glide track with slides.
     *
     * @return {Object}
     */
    get: function get() {
      return Html._t;
    },


    /**
     * Sets node of the glide track with slides.
     *
     * @return {Object}
     */
    set: function set(t) {
      if (exist(t)) {
        Html._t = t;
      } else {
        warn('Could not find track element. Please use ' + TRACK_SELECTOR + ' attribute.');
      }
    }
  });

  define(Html, 'wrapper', {
    /**
     * Gets node of the slides wrapper.
     *
     * @return {Object}
     */
    get: function get() {
      return Html.track.children[0];
    }
  });

  return Html;
}

function Peek (Glide, Components, Events) {
  var Peek = {
    /**
     * Setups how much to peek based on settings.
     *
     * @return {Void}
     */
    mount: function mount() {
      this.value = Glide.settings.peek;
    }
  };

  define(Peek, 'value', {
    /**
     * Gets value of the peek.
     *
     * @returns {Number|Object}
     */
    get: function get() {
      return Peek._v;
    },


    /**
     * Sets value of the peek.
     *
     * @param {Number|Object} value
     * @return {Void}
     */
    set: function set(value) {
      if (isObject(value)) {
        value.before = toInt(value.before);
        value.after = toInt(value.after);
      } else {
        value = toInt(value);
      }

      Peek._v = value;
    }
  });

  define(Peek, 'reductor', {
    /**
     * Gets reduction value caused by peek.
     *
     * @returns {Number}
     */
    get: function get() {
      var value = Peek.value;
      var perView = Glide.settings.perView;

      if (isObject(value)) {
        return value.before / perView + value.after / perView;
      }

      return value * 2 / perView;
    }
  });

  /**
   * Recalculate peeking sizes on:
   * - when resizing window to update to proper percents
   */
  Events.on(['resize', 'update'], function () {
    Peek.mount();
  });

  return Peek;
}

function Move (Glide, Components, Events) {
  var Move = {
    /**
     * Constructs move component.
     *
     * @returns {Void}
     */
    mount: function mount() {
      this._o = 0;
    },


    /**
     * Calculates a movement value based on passed offset and currently active index.
     *
     * @param  {Number} offset
     * @return {Void}
     */
    make: function make() {
      var _this = this;

      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.offset = offset;

      Events.emit('move', {
        movement: this.value
      });

      Components.Transition.after(function () {
        Events.emit('move.after', {
          movement: _this.value
        });
      });
    }
  };

  define(Move, 'offset', {
    /**
     * Gets an offset value used to modify current translate.
     *
     * @return {Object}
     */
    get: function get() {
      return Move._o;
    },


    /**
     * Sets an offset value used to modify current translate.
     *
     * @return {Object}
     */
    set: function set(value) {
      Move._o = !isUndefined(value) ? toInt(value) : 0;
    }
  });

  define(Move, 'translate', {
    /**
     * Gets a raw movement value.
     *
     * @return {Number}
     */
    get: function get() {
      return Components.Sizes.slideWidth * Glide.index;
    }
  });

  define(Move, 'value', {
    /**
     * Gets an actual movement value corrected by offset.
     *
     * @return {Number}
     */
    get: function get() {
      var offset = this.offset;
      var translate = this.translate;

      if (Components.Direction.is('rtl')) {
        return translate + offset;
      }

      return translate - offset;
    }
  });

  /**
   * Make movement to proper slide on:
   * - before build, so glide will start at `startAt` index
   * - on each standard run to move to newly calculated index
   */
  Events.on(['build.before', 'run'], function () {
    Move.make();
  });

  return Move;
}

function Sizes (Glide, Components, Events) {
  var Sizes = {
    /**
     * Setups dimentions of slides.
     *
     * @return {Void}
     */
    setupSlides: function setupSlides() {
      var width = this.slideWidth + 'px';
      var slides = Components.Html.slides;

      for (var i = 0; i < slides.length; i++) {
        slides[i].style.width = width;
      }
    },


    /**
     * Setups dimentions of slides wrapper.
     *
     * @return {Void}
     */
    setupWrapper: function setupWrapper(dimention) {
      Components.Html.wrapper.style.width = this.wrapperSize + 'px';
    },


    /**
     * Removes applied styles from HTML elements.
     *
     * @returns {Void}
     */
    remove: function remove() {
      var slides = Components.Html.slides;

      for (var i = 0; i < slides.length; i++) {
        slides[i].style.width = '';
      }

      Components.Html.wrapper.style.width = '';
    }
  };

  define(Sizes, 'length', {
    /**
     * Gets count number of the slides.
     *
     * @return {Number}
     */
    get: function get() {
      return Components.Html.slides.length;
    }
  });

  define(Sizes, 'width', {
    /**
     * Gets width value of the glide.
     *
     * @return {Number}
     */
    get: function get() {
      return Components.Html.root.offsetWidth;
    }
  });

  define(Sizes, 'wrapperSize', {
    /**
     * Gets size of the slides wrapper.
     *
     * @return {Number}
     */
    get: function get() {
      return Sizes.slideWidth * Sizes.length + Components.Gaps.grow + Components.Clones.grow;
    }
  });

  define(Sizes, 'slideWidth', {
    /**
     * Gets width value of the single slide.
     *
     * @return {Number}
     */
    get: function get() {
      return Sizes.width / Glide.settings.perView - Components.Peek.reductor - Components.Gaps.reductor;
    }
  });

  /**
   * Apply calculated glide's dimensions:
   * - before building, so other dimentions (e.g. translate) will be calculated propertly
   * - when resizing window to recalculate sildes dimensions
   * - on updating via API, to calculate dimensions based on new options
   */
  Events.on(['build.before', 'resize', 'update'], function () {
    Sizes.setupSlides();
    Sizes.setupWrapper();
  });

  /**
   * Remove calculated glide's dimensions:
   * - on destoting to bring markup to its inital state
   */
  Events.on('destroy', function () {
    Sizes.remove();
  });

  return Sizes;
}

function Build (Glide, Components, Events) {
  var Build = {
    /**
     * Init glide building. Adds classes, sets
     * dimensions and setups initial state.
     *
     * @return {Void}
     */
    mount: function mount() {
      Events.emit('build.before');

      this.typeClass();
      this.activeClass();

      Events.emit('build.after');
    },


    /**
     * Adds `type` class to the glide element.
     *
     * @return {Void}
     */
    typeClass: function typeClass() {
      Components.Html.root.classList.add(Glide.settings.classes[Glide.settings.type]);
    },


    /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */
    activeClass: function activeClass() {
      var classes = Glide.settings.classes;
      var slide = Components.Html.slides[Glide.index];

      if (slide) {
        slide.classList.add(classes.activeSlide);

        siblings(slide).forEach(function (sibling) {
          sibling.classList.remove(classes.activeSlide);
        });
      }
    },


    /**
     * Removes HTML classes applied at building.
     *
     * @return {Void}
     */
    removeClasses: function removeClasses() {
      var classes = Glide.settings.classes;

      Components.Html.root.classList.remove(classes[Glide.settings.type]);

      Components.Html.slides.forEach(function (sibling) {
        sibling.classList.remove(classes.activeSlide);
      });
    }
  };

  /**
   * Clear building classes:
   * - on destroying to bring HTML to its initial state
   * - on updating to remove classes before remounting component
   */
  Events.on(['destroy', 'update'], function () {
    Build.removeClasses();
  });

  /**
   * Remount component:
   * - on resizing of the window to calculate new dimentions
   * - on updating settings via API
   */
  Events.on(['resize', 'update'], function () {
    Build.mount();
  });

  /**
   * Swap active class of current slide:
   * - after each move to the new index
   */
  Events.on('move.after', function () {
    Build.activeClass();
  });

  return Build;
}

function Clones (Glide, Components, Events) {
  var Clones = {
    /**
     * Create pattern map and collect slides to be cloned.
     */
    mount: function mount() {
      this.items = [];

      if (Glide.isType('carousel')) {
        this.items = this.collect();
      }
    },


    /**
     * Collect clones with pattern.
     *
     * @return {Void}
     */
    collect: function collect() {
      var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var slides = Components.Html.slides;
      var _Glide$settings = Glide.settings,
          perView = _Glide$settings.perView,
          classes = _Glide$settings.classes;


      var peekIncrementer = +!!Glide.settings.peek;
      var part = perView + peekIncrementer;
      var start = slides.slice(0, part);
      var end = slides.slice(-part);

      for (var r = 0; r < Math.max(1, Math.floor(perView / slides.length)); r++) {
        for (var i = 0; i < start.length; i++) {
          var clone = start[i].cloneNode(true);

          clone.classList.add(classes.cloneSlide);

          items.push(clone);
        }

        for (var _i = 0; _i < end.length; _i++) {
          var _clone = end[_i].cloneNode(true);

          _clone.classList.add(classes.cloneSlide);

          items.unshift(_clone);
        }
      }

      return items;
    },


    /**
     * Append cloned slides with generated pattern.
     *
     * @return {Void}
     */
    append: function append() {
      var items = this.items;
      var _Components$Html = Components.Html,
          wrapper = _Components$Html.wrapper,
          slides = _Components$Html.slides;


      var half = Math.floor(items.length / 2);
      var prepend = items.slice(0, half).reverse();
      var append = items.slice(half, items.length);
      var width = Components.Sizes.slideWidth + 'px';

      for (var i = 0; i < append.length; i++) {
        wrapper.appendChild(append[i]);
      }

      for (var _i2 = 0; _i2 < prepend.length; _i2++) {
        wrapper.insertBefore(prepend[_i2], slides[0]);
      }

      for (var _i3 = 0; _i3 < items.length; _i3++) {
        items[_i3].style.width = width;
      }
    },


    /**
     * Remove all cloned slides.
     *
     * @return {Void}
     */
    remove: function remove() {
      var items = this.items;


      for (var i = 0; i < items.length; i++) {
        Components.Html.wrapper.removeChild(items[i]);
      }
    }
  };

  define(Clones, 'grow', {
    /**
     * Gets additional dimentions value caused by clones.
     *
     * @return {Number}
     */
    get: function get() {
      return (Components.Sizes.slideWidth + Components.Gaps.value) * Clones.items.length;
    }
  });

  /**
   * Append additional slide's clones:
   * - while glide's type is `carousel`
   */
  Events.on('update', function () {
    Clones.remove();
    Clones.mount();
    Clones.append();
  });

  /**
   * Append additional slide's clones:
   * - while glide's type is `carousel`
   */
  Events.on('build.before', function () {
    if (Glide.isType('carousel')) {
      Clones.append();
    }
  });

  /**
   * Remove clones HTMLElements:
   * - on destroying, to bring HTML to its initial state
   */
  Events.on('destroy', function () {
    Clones.remove();
  });

  return Clones;
}

var EventsBinder = function () {
  /**
   * Construct a EventsBinder instance.
   */
  function EventsBinder() {
    var listeners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    classCallCheck(this, EventsBinder);

    this.listeners = listeners;
  }

  /**
   * Adds events listeners to arrows HTML elements.
   *
   * @param  {String|Array} events
   * @param  {Element|Window|Document} el
   * @param  {Function} closure
   * @param  {Boolean|Object} capture
   * @return {Void}
   */


  createClass(EventsBinder, [{
    key: 'on',
    value: function on(events, el, closure) {
      var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      if (isString(events)) {
        events = [events];
      }

      for (var i = 0; i < events.length; i++) {
        this.listeners[events[i]] = closure;

        el.addEventListener(events[i], this.listeners[events[i]], capture);
      }
    }

    /**
     * Removes event listeners from arrows HTML elements.
     *
     * @param  {String|Array} events
     * @param  {Element|Window|Document} el
     * @param  {Boolean|Object} capture
     * @return {Void}
     */

  }, {
    key: 'off',
    value: function off(events, el) {
      var capture = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (isString(events)) {
        events = [events];
      }

      for (var i = 0; i < events.length; i++) {
        el.removeEventListener(events[i], this.listeners[events[i]], capture);
      }
    }

    /**
     * Destroy collected listeners.
     *
     * @returns {Void}
     */

  }, {
    key: 'destroy',
    value: function destroy() {
      delete this.listeners;
    }
  }]);
  return EventsBinder;
}();

function Resize (Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();

  var Resize = {
    /**
     * Initializes window bindings.
     */
    mount: function mount() {
      this.bind();
    },


    /**
     * Binds `rezsize` listener to the window.
     * It's a costly event, so we are debouncing it.
     *
     * @return {Void}
     */
    bind: function bind() {
      Binder.on('resize', window, throttle(function () {
        Events.emit('resize');
      }, Glide.settings.throttle));
    },


    /**
     * Unbinds listeners from the window.
     *
     * @return {Void}
     */
    unbind: function unbind() {
      Binder.off('resize', window);
    }
  };

  /**
   * Remove bindings from window:
   * - on destroying, to remove added EventListener
   */
  Events.on('destroy', function () {
    Resize.unbind();
    Binder.destroy();
  });

  return Resize;
}

var VALID_DIRECTIONS = ['ltr', 'rtl'];
var FLIPED_MOVEMENTS = {
  '>': '<',
  '<': '>',
  '=': '='
};

function Direction (Glide, Components, Events) {
  var Direction = {
    /**
     * Setups gap value based on settings.
     *
     * @return {Void}
     */
    mount: function mount() {
      this.value = Glide.settings.direction;
    },


    /**
     * Resolves pattern based on direction value
     *
     * @param {String} pattern
     * @returns {String}
     */
    resolve: function resolve(pattern) {
      var token = pattern.slice(0, 1);

      if (this.is('rtl')) {
        return pattern.split(token).join(FLIPED_MOVEMENTS[token]);
      }

      return pattern;
    },


    /**
     * Checks value of direction mode.
     *
     * @param {String} direction
     * @returns {Boolean}
     */
    is: function is(direction) {
      return this.value === direction;
    },


    /**
     * Applies direction class to the root HTML element.
     *
     * @return {Void}
     */
    addClass: function addClass() {
      Components.Html.root.classList.add(Glide.settings.classes.direction[this.value]);
    },


    /**
     * Removes direction class from the root HTML element.
     *
     * @return {Void}
     */
    removeClass: function removeClass() {
      Components.Html.root.classList.remove(Glide.settings.classes.direction[this.value]);
    }
  };

  define(Direction, 'value', {
    /**
     * Gets value of the direction.
     *
     * @returns {Number}
     */
    get: function get() {
      return Direction._v;
    },


    /**
     * Sets value of the direction.
     *
     * @param {String} value
     * @return {Void}
     */
    set: function set(value) {
      if (VALID_DIRECTIONS.indexOf(value) > -1) {
        Direction._v = value;
      } else {
        warn('Direction value must be `ltr` or `rtl`');
      }
    }
  });

  /**
   * Clear direction class:
   * - on destroy to bring HTML to its initial state
   * - on update to remove class before reappling bellow
   */
  Events.on(['destroy', 'update'], function () {
    Direction.removeClass();
  });

  /**
   * Remount component:
   * - on update to reflect changes in direction value
   */
  Events.on('update', function () {
    Direction.mount();
  });

  /**
   * Apply direction class:
   * - before building to apply class for the first time
   * - on updating to reapply direction class that may changed
   */
  Events.on(['build.before', 'update'], function () {
    Direction.addClass();
  });

  return Direction;
}

/**
 * Reflects value of glide movement.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */
function Rtl (Glide, Components) {
  return {
    /**
     * Negates the passed translate if glide is in RTL option.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function modify(translate) {
      if (Components.Direction.is('rtl')) {
        return -translate;
      }

      return translate;
    }
  };
}

/**
 * Updates glide movement with a `gap` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */
function Gap (Glide, Components) {
  return {
    /**
     * Modifies passed translate value with number in the `gap` settings.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function modify(translate) {
      return translate + Components.Gaps.value * Glide.index;
    }
  };
}

/**
 * Updates glide movement with width of additional clones width.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */
function Grow (Glide, Components) {
  return {
    /**
     * Adds to the passed translate width of the half of clones.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function modify(translate) {
      return translate + Components.Clones.grow / 2;
    }
  };
}

/**
 * Updates glide movement with a `peek` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */
function Peeking (Glide, Components) {
  return {
    /**
     * Modifies passed translate value with a `peek` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function modify(translate) {
      if (Glide.settings.focusAt >= 0) {
        var peek = Components.Peek.value;

        if (isObject(peek)) {
          return translate - peek.before;
        }

        return translate - peek;
      }

      return translate;
    }
  };
}

/**
 * Updates glide movement with a `focusAt` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */
function Focusing (Glide, Components) {
  return {
    /**
     * Modifies passed translate value with index in the `focusAt` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function modify(translate) {
      var gap = Components.Gaps.value;
      var width = Components.Sizes.width;
      var focusAt = Glide.settings.focusAt;
      var slideWidth = Components.Sizes.slideWidth;

      if (focusAt === 'center') {
        return translate - (width / 2 - slideWidth / 2);
      }

      return translate - slideWidth * focusAt - gap * focusAt;
    }
  };
}

/**
 * Applies diffrent transformers on translate value.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */
function mutator (Glide, Components, Events) {
  /**
   * Merge instance transformers with collection of default transformers.
   * It's important that the Rtl component be last on the list,
   * so it reflects all previous transformations.
   *
   * @type {Array}
   */
  var TRANSFORMERS = [Gap, Grow, Peeking, Focusing].concat(Glide._t, [Rtl]);

  return {
    /**
     * Piplines translate value with registered transformers.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    mutate: function mutate(translate) {
      for (var i = 0; i < TRANSFORMERS.length; i++) {
        var transformer = TRANSFORMERS[i];

        if (isFunction(transformer) && isFunction(transformer().modify)) {
          translate = transformer(Glide, Components, Events).modify(translate);
        } else {
          warn('Transformer should be a function that returns an object with `modify()` method');
        }
      }

      return translate;
    }
  };
}

function Translate (Glide, Components, Events) {
  var Translate = {
    /**
     * Sets value of translate on HTML element.
     *
     * @param {Number} value
     * @return {Void}
     */
    set: function set(value) {
      var transform = mutator(Glide, Components).mutate(value);

      Components.Html.wrapper.style.transform = 'translate3d(' + -1 * transform + 'px, 0px, 0px)';
    },


    /**
     * Removes value of translate from HTML element.
     *
     * @return {Void}
     */
    remove: function remove() {
      Components.Html.wrapper.style.transform = '';
    }
  };

  /**
   * Set new translate value:
   * - on move to reflect index change
   * - on updating via API to reflect possible changes in options
   */
  Events.on('move', function (context) {
    var gap = Components.Gaps.value;
    var length = Components.Sizes.length;
    var width = Components.Sizes.slideWidth;

    if (Glide.isType('carousel') && Components.Run.isOffset('<')) {
      Components.Transition.after(function () {
        Events.emit('translate.jump');

        Translate.set(width * (length - 1));
      });

      return Translate.set(-width - gap * length);
    }

    if (Glide.isType('carousel') && Components.Run.isOffset('>')) {
      Components.Transition.after(function () {
        Events.emit('translate.jump');

        Translate.set(0);
      });

      return Translate.set(width * length + gap * length);
    }

    return Translate.set(context.movement);
  });

  /**
   * Remove translate:
   * - on destroying to bring markup to its inital state
   */
  Events.on('destroy', function () {
    Translate.remove();
  });

  return Translate;
}

function Transition (Glide, Components, Events) {
  /**
   * Holds inactivity status of transition.
   * When true transition is not applied.
   *
   * @type {Boolean}
   */
  var disabled = false;

  var Transition = {
    /**
     * Composes string of the CSS transition.
     *
     * @param {String} property
     * @return {String}
     */
    compose: function compose(property) {
      var settings = Glide.settings;

      if (!disabled) {
        return property + ' ' + this.duration + 'ms ' + settings.animationTimingFunc;
      }

      return property + ' 0ms ' + settings.animationTimingFunc;
    },


    /**
     * Sets value of transition on HTML element.
     *
     * @param {String=} property
     * @return {Void}
     */
    set: function set() {
      var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';

      Components.Html.wrapper.style.transition = this.compose(property);
    },


    /**
     * Removes value of transition from HTML element.
     *
     * @return {Void}
     */
    remove: function remove() {
      Components.Html.wrapper.style.transition = '';
    },


    /**
     * Runs callback after animation.
     *
     * @param  {Function} callback
     * @return {Void}
     */
    after: function after(callback) {
      setTimeout(function () {
        callback();
      }, this.duration);
    },


    /**
     * Enable transition.
     *
     * @return {Void}
     */
    enable: function enable() {
      disabled = false;

      this.set();
    },


    /**
     * Disable transition.
     *
     * @return {Void}
     */
    disable: function disable() {
      disabled = true;

      this.set();
    }
  };

  define(Transition, 'duration', {
    /**
     * Gets duration of the transition based
     * on currently running animation type.
     *
     * @return {Number}
     */
    get: function get() {
      var settings = Glide.settings;

      if (Glide.isType('slider') && Components.Run.offset) {
        return settings.rewindDuration;
      }

      return settings.animationDuration;
    }
  });

  /**
   * Set transition `style` value:
   * - on each moving, because it may be cleared by offset move
   */
  Events.on('move', function () {
    Transition.set();
  });

  /**
   * Disable transition:
   * - before initial build to avoid transitioning from `0` to `startAt` index
   * - while resizing window and recalculating dimentions
   * - on jumping from offset transition at start and end edges in `carousel` type
   */
  Events.on(['build.before', 'resize', 'translate.jump'], function () {
    Transition.disable();
  });

  /**
   * Enable transition:
   * - on each running, because it may be disabled by offset move
   */
  Events.on('run', function () {
    Transition.enable();
  });

  /**
   * Remove transition:
   * - on destroying to bring markup to its inital state
   */
  Events.on('destroy', function () {
    Transition.remove();
  });

  return Transition;
}

/**
 * Test via a getter in the options object to see
 * if the passive property is accessed.
 *
 * @see https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
 */

var supportsPassive = false;

try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      supportsPassive = true;
    }
  });

  window.addEventListener('testPassive', null, opts);
  window.removeEventListener('testPassive', null, opts);
} catch (e) {}

var supportsPassive$1 = supportsPassive;

var START_EVENTS = ['touchstart', 'mousedown'];
var MOVE_EVENTS = ['touchmove', 'mousemove'];
var END_EVENTS = ['touchend', 'touchcancel', 'mouseup', 'mouseleave'];
var MOUSE_EVENTS = ['mousedown', 'mousemove', 'mouseup', 'mouseleave'];

function Swipe (Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();

  var swipeSin = 0;
  var swipeStartX = 0;
  var swipeStartY = 0;
  var disabled = false;
  var capture = supportsPassive$1 ? { passive: true } : false;

  var Swipe = {
    /**
     * Initializes swipe bindings.
     *
     * @return {Void}
     */
    mount: function mount() {
      this.bindSwipeStart();
    },


    /**
     * Handler for `swipestart` event. Calculates entry points of the user's tap.
     *
     * @param {Object} event
     * @return {Void}
     */
    start: function start(event) {
      if (!disabled && !Glide.disabled) {
        this.disable();

        var swipe = this.touches(event);

        swipeSin = null;
        swipeStartX = toInt(swipe.pageX);
        swipeStartY = toInt(swipe.pageY);

        this.bindSwipeMove();
        this.bindSwipeEnd();

        Events.emit('swipe.start');
      }
    },


    /**
     * Handler for `swipemove` event. Calculates user's tap angle and distance.
     *
     * @param {Object} event
     */
    move: function move(event) {
      if (!Glide.disabled) {
        var _Glide$settings = Glide.settings,
            touchAngle = _Glide$settings.touchAngle,
            touchRatio = _Glide$settings.touchRatio,
            classes = _Glide$settings.classes;


        var swipe = this.touches(event);

        var subExSx = toInt(swipe.pageX) - swipeStartX;
        var subEySy = toInt(swipe.pageY) - swipeStartY;
        var powEX = Math.abs(subExSx << 2);
        var powEY = Math.abs(subEySy << 2);
        var swipeHypotenuse = Math.sqrt(powEX + powEY);
        var swipeCathetus = Math.sqrt(powEY);

        swipeSin = Math.asin(swipeCathetus / swipeHypotenuse);

        if (swipeSin * 180 / Math.PI < touchAngle) {
          event.stopPropagation();

          Components.Move.make(subExSx * toFloat(touchRatio));

          Components.Html.root.classList.add(classes.dragging);

          Events.emit('swipe.move');
        } else {
          return false;
        }
      }
    },


    /**
     * Handler for `swipeend` event. Finitializes user's tap and decides about glide move.
     *
     * @param {Object} event
     * @return {Void}
     */
    end: function end(event) {
      if (!Glide.disabled) {
        var settings = Glide.settings;

        var swipe = this.touches(event);
        var threshold = this.threshold(event);

        var swipeDistance = swipe.pageX - swipeStartX;
        var swipeDeg = swipeSin * 180 / Math.PI;
        var steps = Math.round(swipeDistance / Components.Sizes.slideWidth);

        this.enable();

        if (swipeDistance > threshold && swipeDeg < settings.touchAngle) {
          // While swipe is positive and greater than threshold move backward.
          if (settings.perTouch) {
            steps = Math.min(steps, toInt(settings.perTouch));
          }

          if (Components.Direction.is('rtl')) {
            steps = -steps;
          }

          Components.Run.make(Components.Direction.resolve('<' + steps));
        } else if (swipeDistance < -threshold && swipeDeg < settings.touchAngle) {
          // While swipe is negative and lower than negative threshold move forward.
          if (settings.perTouch) {
            steps = Math.max(steps, -toInt(settings.perTouch));
          }

          if (Components.Direction.is('rtl')) {
            steps = -steps;
          }

          Components.Run.make(Components.Direction.resolve('>' + steps));
        } else {
          // While swipe don't reach distance apply previous transform.
          Components.Move.make();
        }

        Components.Html.root.classList.remove(settings.classes.dragging);

        this.unbindSwipeMove();
        this.unbindSwipeEnd();

        Events.emit('swipe.end');
      }
    },


    /**
     * Binds swipe's starting event.
     *
     * @return {Void}
     */
    bindSwipeStart: function bindSwipeStart() {
      var _this = this;

      var settings = Glide.settings;

      if (settings.swipeThreshold) {
        Binder.on(START_EVENTS[0], Components.Html.wrapper, function (event) {
          _this.start(event);
        }, capture);
      }

      if (settings.dragThreshold) {
        Binder.on(START_EVENTS[1], Components.Html.wrapper, function (event) {
          _this.start(event);
        }, capture);
      }
    },


    /**
     * Unbinds swipe's starting event.
     *
     * @return {Void}
     */
    unbindSwipeStart: function unbindSwipeStart() {
      Binder.off(START_EVENTS[0], Components.Html.wrapper, capture);
      Binder.off(START_EVENTS[1], Components.Html.wrapper, capture);
    },


    /**
     * Binds swipe's moving event.
     *
     * @return {Void}
     */
    bindSwipeMove: function bindSwipeMove() {
      var _this2 = this;

      Binder.on(MOVE_EVENTS, Components.Html.wrapper, throttle(function (event) {
        _this2.move(event);
      }, Glide.settings.throttle), capture);
    },


    /**
     * Unbinds swipe's moving event.
     *
     * @return {Void}
     */
    unbindSwipeMove: function unbindSwipeMove() {
      Binder.off(MOVE_EVENTS, Components.Html.wrapper, capture);
    },


    /**
     * Binds swipe's ending event.
     *
     * @return {Void}
     */
    bindSwipeEnd: function bindSwipeEnd() {
      var _this3 = this;

      Binder.on(END_EVENTS, Components.Html.wrapper, function (event) {
        _this3.end(event);
      });
    },


    /**
     * Unbinds swipe's ending event.
     *
     * @return {Void}
     */
    unbindSwipeEnd: function unbindSwipeEnd() {
      Binder.off(END_EVENTS, Components.Html.wrapper);
    },


    /**
     * Normalizes event touches points accorting to different types.
     *
     * @param {Object} event
     */
    touches: function touches(event) {
      if (MOUSE_EVENTS.indexOf(event.type) > -1) {
        return event;
      }

      return event.touches[0] || event.changedTouches[0];
    },


    /**
     * Gets value of minimum swipe distance settings based on event type.
     *
     * @return {Number}
     */
    threshold: function threshold(event) {
      var settings = Glide.settings;

      if (MOUSE_EVENTS.indexOf(event.type) > -1) {
        return settings.dragThreshold;
      }

      return settings.swipeThreshold;
    },


    /**
     * Enables swipe event.
     *
     * @return {self}
     */
    enable: function enable() {
      disabled = false;

      Components.Transition.enable();

      return this;
    },


    /**
     * Disables swipe event.
     *
     * @return {self}
     */
    disable: function disable() {
      disabled = true;

      Components.Transition.disable();

      return this;
    }
  };

  /**
   * Add component class:
   * - after initial building
   */
  Events.on('build.after', function () {
    Components.Html.root.classList.add(Glide.settings.classes.swipeable);
  });

  /**
   * Remove swiping bindings:
   * - on destroying, to remove added EventListeners
   */
  Events.on('destroy', function () {
    Swipe.unbindSwipeStart();
    Swipe.unbindSwipeMove();
    Swipe.unbindSwipeEnd();
    Binder.destroy();
  });

  return Swipe;
}

function Images (Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();

  var Images = {
    /**
     * Binds listener to glide wrapper.
     *
     * @return {Void}
     */
    mount: function mount() {
      this.bind();
    },


    /**
     * Binds `dragstart` event on wrapper to prevent dragging images.
     *
     * @return {Void}
     */
    bind: function bind() {
      Binder.on('dragstart', Components.Html.wrapper, this.dragstart);
    },


    /**
     * Unbinds `dragstart` event on wrapper.
     *
     * @return {Void}
     */
    unbind: function unbind() {
      Binder.off('dragstart', Components.Html.wrapper);
    },


    /**
     * Event handler. Prevents dragging.
     *
     * @return {Void}
     */
    dragstart: function dragstart(event) {
      event.preventDefault();
    }
  };

  /**
   * Remove bindings from images:
   * - on destroying, to remove added EventListeners
   */
  Events.on('destroy', function () {
    Images.unbind();
    Binder.destroy();
  });

  return Images;
}

function Anchors (Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();

  /**
   * Holds detaching status of anchors.
   * Prevents detaching of already detached anchors.
   *
   * @private
   * @type {Boolean}
   */
  var detached = false;

  /**
   * Holds preventing status of anchors.
   * If `true` redirection after click will be disabled.
   *
   * @private
   * @type {Boolean}
   */
  var prevented = false;

  var Anchors = {
    /**
     * Setups a initial state of anchors component.
     *
     * @returns {Void}
     */
    mount: function mount() {
      /**
       * Holds collection of anchors elements.
       *
       * @private
       * @type {HTMLCollection}
       */
      this._a = Components.Html.wrapper.querySelectorAll('a');

      this.bind();
    },


    /**
     * Binds events to anchors inside a track.
     *
     * @return {Void}
     */
    bind: function bind() {
      Binder.on('click', Components.Html.wrapper, this.click);
    },


    /**
     * Unbinds events attached to anchors inside a track.
     *
     * @return {Void}
     */
    unbind: function unbind() {
      Binder.off('click', Components.Html.wrapper);
    },


    /**
     * Handler for click event. Prevents clicks when glide is in `prevent` status.
     *
     * @param  {Object} event
     * @return {Void}
     */
    click: function click(event) {
      if (prevented) {
        event.stopPropagation();
        event.preventDefault();
      }
    },


    /**
     * Detaches anchors click event inside glide.
     *
     * @return {self}
     */
    detach: function detach() {
      prevented = true;

      if (!detached) {
        for (var i = 0; i < this.items.length; i++) {
          this.items[i].draggable = false;

          this.items[i].setAttribute('data-href', this.items[i].getAttribute('href'));

          this.items[i].removeAttribute('href');
        }

        detached = true;
      }

      return this;
    },


    /**
     * Attaches anchors click events inside glide.
     *
     * @return {self}
     */
    attach: function attach() {
      prevented = false;

      if (detached) {
        for (var i = 0; i < this.items.length; i++) {
          this.items[i].draggable = true;

          this.items[i].setAttribute('href', this.items[i].getAttribute('data-href'));
        }

        detached = false;
      }

      return this;
    }
  };

  define(Anchors, 'items', {
    /**
     * Gets collection of the arrows HTML elements.
     *
     * @return {HTMLElement[]}
     */
    get: function get() {
      return Anchors._a;
    }
  });

  /**
   * Detach anchors inside slides:
   * - on swiping, so they won't redirect to its `href` attributes
   */
  Events.on('swipe.move', function () {
    Anchors.detach();
  });

  /**
   * Attach anchors inside slides:
   * - after swiping and transitions ends, so they can redirect after click again
   */
  Events.on('swipe.end', function () {
    Components.Transition.after(function () {
      Anchors.attach();
    });
  });

  /**
   * Unbind anchors inside slides:
   * - on destroying, to bring anchors to its initial state
   */
  Events.on('destroy', function () {
    Anchors.attach();
    Anchors.unbind();
    Binder.destroy();
  });

  return Anchors;
}

var NAV_SELECTOR = '[data-glide-el="controls[nav]"]';
var CONTROLS_SELECTOR = '[data-glide-el^="controls"]';

function Controls (Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();

  var capture = supportsPassive$1 ? { passive: true } : false;

  var Controls = {
    /**
     * Inits arrows. Binds events listeners
     * to the arrows HTML elements.
     *
     * @return {Void}
     */
    mount: function mount() {
      /**
       * Collection of navigation HTML elements.
       *
       * @private
       * @type {HTMLCollection}
       */
      this._n = Components.Html.root.querySelectorAll(NAV_SELECTOR);

      /**
       * Collection of controls HTML elements.
       *
       * @private
       * @type {HTMLCollection}
       */
      this._c = Components.Html.root.querySelectorAll(CONTROLS_SELECTOR);

      this.addBindings();
    },


    /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */
    setActive: function setActive() {
      for (var i = 0; i < this._n.length; i++) {
        this.addClass(this._n[i].children);
      }
    },


    /**
     * Removes active class to current slide.
     *
     * @return {Void}
     */
    removeActive: function removeActive() {
      for (var i = 0; i < this._n.length; i++) {
        this.removeClass(this._n[i].children);
      }
    },


    /**
     * Toggles active class on items inside navigation.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */
    addClass: function addClass(controls) {
      var settings = Glide.settings;
      var item = controls[Glide.index];

      if (item) {
        item.classList.add(settings.classes.activeNav);

        siblings(item).forEach(function (sibling) {
          sibling.classList.remove(settings.classes.activeNav);
        });
      }
    },


    /**
     * Removes active class from active control.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */
    removeClass: function removeClass(controls) {
      var item = controls[Glide.index];

      if (item) {
        item.classList.remove(Glide.settings.classes.activeNav);
      }
    },


    /**
     * Adds handles to the each group of controls.
     *
     * @return {Void}
     */
    addBindings: function addBindings() {
      for (var i = 0; i < this._c.length; i++) {
        this.bind(this._c[i].children);
      }
    },


    /**
     * Removes handles from the each group of controls.
     *
     * @return {Void}
     */
    removeBindings: function removeBindings() {
      for (var i = 0; i < this._c.length; i++) {
        this.unbind(this._c[i].children);
      }
    },


    /**
     * Binds events to arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */
    bind: function bind(elements) {
      for (var i = 0; i < elements.length; i++) {
        Binder.on('click', elements[i], this.click);
        Binder.on('touchstart', elements[i], this.click, capture);
      }
    },


    /**
     * Unbinds events binded to the arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */
    unbind: function unbind(elements) {
      for (var i = 0; i < elements.length; i++) {
        Binder.off(['click', 'touchstart'], elements[i]);
      }
    },


    /**
     * Handles `click` event on the arrows HTML elements.
     * Moves slider in driection precised in
     * `data-glide-dir` attribute.
     *
     * @param {Object} event
     * @return {Void}
     */
    click: function click(event) {
      event.preventDefault();

      Components.Run.make(Components.Direction.resolve(event.currentTarget.getAttribute('data-glide-dir')));
    }
  };

  define(Controls, 'items', {
    /**
     * Gets collection of the controls HTML elements.
     *
     * @return {HTMLElement[]}
     */
    get: function get() {
      return Controls._c;
    }
  });

  /**
   * Swap active class of current navigation item:
   * - after mounting to set it to initial index
   * - after each move to the new index
   */
  Events.on(['mount.after', 'move.after'], function () {
    Controls.setActive();
  });

  /**
   * Remove bindings and HTML Classes:
   * - on destroying, to bring markup to its initial state
   */
  Events.on('destroy', function () {
    Controls.removeBindings();
    Controls.removeActive();
    Binder.destroy();
  });

  return Controls;
}

function Keyboard (Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();

  var Keyboard = {
    /**
     * Binds keyboard events on component mount.
     *
     * @return {Void}
     */
    mount: function mount() {
      if (Glide.settings.keyboard) {
        this.bind();
      }
    },


    /**
     * Adds keyboard press events.
     *
     * @return {Void}
     */
    bind: function bind() {
      Binder.on('keyup', document, this.press);
    },


    /**
     * Removes keyboard press events.
     *
     * @return {Void}
     */
    unbind: function unbind() {
      Binder.off('keyup', document);
    },


    /**
     * Handles keyboard's arrows press and moving glide foward and backward.
     *
     * @param  {Object} event
     * @return {Void}
     */
    press: function press(event) {
      if (event.keyCode === 39) {
        Components.Run.make(Components.Direction.resolve('>'));
      }

      if (event.keyCode === 37) {
        Components.Run.make(Components.Direction.resolve('<'));
      }
    }
  };

  /**
   * Remove bindings from keyboard:
   * - on destroying to remove added events
   * - on updating to remove events before remounting
   */
  Events.on(['destroy', 'update'], function () {
    Keyboard.unbind();
  });

  /**
   * Remount component
   * - on updating to reflect potential changes in settings
   */
  Events.on('update', function () {
    Keyboard.mount();
  });

  /**
   * Destroy binder:
   * - on destroying to remove listeners
   */
  Events.on('destroy', function () {
    Binder.destroy();
  });

  return Keyboard;
}

function Autoplay (Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();

  var Autoplay = {
    /**
     * Initializes autoplaying and events.
     *
     * @return {Void}
     */
    mount: function mount() {
      this.start();

      if (Glide.settings.hoverpause) {
        this.bind();
      }
    },


    /**
     * Starts autoplaying in configured interval.
     *
     * @param {Boolean|Number} force Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Void}
     */
    start: function start() {
      var _this = this;

      if (Glide.settings.autoplay) {
        if (isUndefined(this._i)) {
          this._i = setInterval(function () {
            _this.stop();

            Components.Run.make('>');

            _this.start();
          }, this.time);
        }
      }
    },


    /**
     * Stops autorunning of the glide.
     *
     * @return {Void}
     */
    stop: function stop() {
      this._i = clearInterval(this._i);
    },


    /**
     * Stops autoplaying while mouse is over glide's area.
     *
     * @return {Void}
     */
    bind: function bind() {
      var _this2 = this;

      Binder.on('mouseover', Components.Html.root, function () {
        _this2.stop();
      });

      Binder.on('mouseout', Components.Html.root, function () {
        _this2.start();
      });
    },


    /**
     * Unbind mouseover events.
     *
     * @returns {Void}
     */
    unbind: function unbind() {
      Binder.off(['mouseover', 'mouseout'], Components.Html.root);
    }
  };

  define(Autoplay, 'time', {
    /**
     * Gets time period value for the autoplay interval. Prioritizes
     * times in `data-glide-autoplay` attrubutes over options.
     *
     * @return {Number}
     */
    get: function get() {
      var autoplay = Components.Html.slides[Glide.index].getAttribute('data-glide-autoplay');

      if (autoplay) {
        return toInt(autoplay);
      }

      return toInt(Glide.settings.autoplay);
    }
  });

  /**
   * Stop autoplaying and unbind events:
   * - on destroying, to clear defined interval
   * - on updating via API to reset interval that may changed
   */
  Events.on(['destroy', 'update'], function () {
    Autoplay.unbind();
  });

  /**
   * Stop autoplaying:
   * - before each run, to restart autoplaying
   * - on pausing via API
   * - on destroying, to clear defined interval
   * - while starting a swipe
   * - on updating via API to reset interval that may changed
   */
  Events.on(['run.before', 'pause', 'destroy', 'swipe.start', 'update'], function () {
    Autoplay.stop();
  });

  /**
   * Start autoplaying:
   * - after each run, to restart autoplaying
   * - on playing via API
   * - while ending a swipe
   */
  Events.on(['run.after', 'play', 'swipe.end'], function () {
    Autoplay.start();
  });

  /**
   * Remount autoplaying:
   * - on updating via API to reset interval that may changed
   */
  Events.on('update', function () {
    Autoplay.mount();
  });

  /**
   * Destroy a binder:
   * - on destroying glide instance to clearup listeners
   */
  Events.on('destroy', function () {
    Binder.destroy();
  });

  return Autoplay;
}

/**
 * Sorts keys of breakpoint object so they will be ordered from lower to bigger.
 *
 * @param {Object} points
 * @returns {Object}
 */
function sortBreakpoints(points) {
  if (isObject(points)) {
    return sortKeys(points);
  } else {
    warn('Breakpoints option must be an object');
  }

  return {};
}

function Breakpoints (Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();

  /**
   * Holds reference to settings.
   *
   * @type {Object}
   */
  var settings = Glide.settings;

  /**
   * Holds reference to breakpoints object in settings. Sorts breakpoints
   * from smaller to larger. It is required in order to proper
   * matching currently active breakpoint settings.
   *
   * @type {Object}
   */
  var points = sortBreakpoints(settings.breakpoints);

  /**
   * Cache initial settings before overwritting.
   *
   * @type {Object}
   */
  var defaults = _extends({}, settings);

  var Breakpoints = {
    /**
     * Matches settings for currectly matching media breakpoint.
     *
     * @param {Object} points
     * @returns {Object}
     */
    match: function match(points) {
      if (typeof window.matchMedia !== 'undefined') {
        for (var point in points) {
          if (points.hasOwnProperty(point)) {
            if (window.matchMedia('(max-width: ' + point + 'px)').matches) {
              return points[point];
            }
          }
        }
      }

      return defaults;
    }
  };

  /**
   * Overwrite instance settings with currently matching breakpoint settings.
   * This happens right after component initialization.
   */
  _extends(settings, Breakpoints.match(points));

  /**
   * Update glide with settings of matched brekpoint:
   * - window resize to update slider
   */
  Binder.on('resize', window, throttle(function () {
    Glide.settings = mergeOptions(settings, Breakpoints.match(points));
  }, Glide.settings.throttle));

  /**
   * Resort and update default settings:
   * - on reinit via API, so breakpoint matching will be performed with options
   */
  Events.on('update', function () {
    points = sortBreakpoints(points);

    defaults = _extends({}, settings);
  });

  /**
   * Unbind resize listener:
   * - on destroying, to bring markup to its initial state
   */
  Events.on('destroy', function () {
    Binder.off('resize', window);
  });

  return Breakpoints;
}

var COMPONENTS = {
  // Required
  Html: Html,
  Translate: Translate,
  Transition: Transition,
  Direction: Direction,
  Peek: Peek,
  Sizes: Sizes,
  Gaps: Gaps,
  Move: Move,
  Clones: Clones,
  Resize: Resize,
  Build: Build,
  Run: Run,

  // Optional
  Swipe: Swipe,
  Images: Images,
  Anchors: Anchors,
  Controls: Controls,
  Keyboard: Keyboard,
  Autoplay: Autoplay,
  Breakpoints: Breakpoints
};

var Glide$1 = function (_Core) {
  inherits(Glide$$1, _Core);

  function Glide$$1() {
    classCallCheck(this, Glide$$1);
    return possibleConstructorReturn(this, (Glide$$1.__proto__ || Object.getPrototypeOf(Glide$$1)).apply(this, arguments));
  }

  createClass(Glide$$1, [{
    key: 'mount',
    value: function mount() {
      var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get(Glide$$1.prototype.__proto__ || Object.getPrototypeOf(Glide$$1.prototype), 'mount', this).call(this, _extends({}, COMPONENTS, extensions));
    }
  }]);
  return Glide$$1;
}(Glide);

/* harmony default export */ __webpack_exports__["default"] = (Glide$1);


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_shadowed__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shadow_host_parents__ = __webpack_require__(522);

// [0] always is the actual active element (even within web-components)
// [0+n] is the hierarchy of shadow-doms with [length -1] being the top most shadow-host




function walkToShadowedElement() {
  var list = [document.activeElement];

  while (list[0] && list[0].shadowRoot) {
    list.unshift(list[0].shadowRoot.activeElement);
  }

  return list;
}

function walkFromShadowedElement() {
  var hosts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shadow_host_parents__["a" /* default */])({ context: document.activeElement });
  return [document.activeElement].concat(hosts);
}

/* harmony default export */ __webpack_exports__["a"] = (function () {
  if (document.activeElement === null) {
    // IE10 does not redirect focus to <body> when the activeElement is removed
    document.body.focus();
  }

  // Firefox currently leaks the shadowed element
  // @browser-issue Gecko https://bugzilla.mozilla.org/show_bug.cgi?id=1117535
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__is_shadowed__["a" /* default */])(document.activeElement)) {
    return walkFromShadowedElement();
  }

  return walkToShadowedElement();
});
//# sourceMappingURL=active-elements.js.map

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_context_to_element__ = __webpack_require__(193);



/* harmony default export */ __webpack_exports__["a"] = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref.context;

  var element = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_context_to_element__["a" /* default */])({
    label: 'get/shadow-host',
    context: context
  });

  // walk up to the root
  var container = null;

  while (element) {
    container = element;
    element = element.parentNode;
  }

  // https://developer.mozilla.org/en-US/docs/Web/API/Node.nodeType
  // NOTE: Firefox 34 does not expose ShadowRoot.host (but 37 does)
  if (container.nodeType === container.DOCUMENT_FRAGMENT_NODE && container.host) {
    // the root is attached to a fragment node that has a host
    return container.host;
  }

  return null;
});
//# sourceMappingURL=shadow-host.js.map

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var combinator = void 0;

  // see https://dev.w3.org/csswg/css-scoping-1/#deep-combinator
  // https://bugzilla.mozilla.org/show_bug.cgi?id=1117572
  // https://code.google.com/p/chromium/issues/detail?id=446051
  try {
    document.querySelector('html >>> :first-child');
    combinator = '>>>';
  } catch (noArrowArrowArrow) {
    try {
      // old syntax supported at least up to Chrome 41
      // https://code.google.com/p/chromium/issues/detail?id=446051
      document.querySelector('html /deep/ :first-child');
      combinator = '/deep/';
    } catch (noDeep) {
      combinator = '';
    }
  }

  return combinator;
});
//# sourceMappingURL=css-shadow-piercing-deep-combinator.js.map

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtb' + 'G5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBpZD0ic3ZnIj48dGV4dCB4PSIxMCIgeT0iMjAiIGlkPSJ' + 'zdmctbGluay10ZXh0Ij50ZXh0PC90ZXh0Pjwvc3ZnPg==');
//# sourceMappingURL=svg.js.map

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/*
  The Singleton Decorator is intended to allow modules to initialize a ("singleton") component as if
  it was the only one using it. Every module gets to initialize and destruct the component by itself.
  Via simple reference counting the component keeps track of how many modules have initialized it,
  so it destructs only when the last module is gone. This decorator hides the component's singleton
  nature from the application in order to offer a homogenous API.

  engage() can return an object (result) with methods to expose to the consumer,
  upon initialization result.disengage is added and returned to the consumer.
*/

function destruct() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      force = _ref.force;

  if (force) {
    this.instances = 0;
  } else {
    this.instances--;
  }

  if (!this.instances) {
    this.disengage();
    this._result = null;
  }
}

function initialize() {
  if (this.instances) {
    this.instances++;
    return this._result;
  }

  this.instances++;
  this._result = this.engage() || {};
  this._result.disengage = destruct.bind(this);

  return this._result;
}

function noop() {}

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      engage = _ref2.engage,
      disengage = _ref2.disengage;

  var data = {
    engage: engage || noop,
    disengage: disengage || noop,
    instances: 0,
    _result: null
  };

  return initialize.bind(data);
});
//# sourceMappingURL=decorate-service.js.map

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = closest;

var _matches = __webpack_require__(209);

var _matches2 = _interopRequireDefault(_matches);

var _parents = __webpack_require__(246);

var _parents2 = _interopRequireDefault(_parents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Gets the closest parent element that matches the passed selector.
 * @param {Element} element The element whose parents to check.
 * @param {string} selector The CSS selector to match against.
 * @param {boolean=} shouldCheckSelf True if the selector should test against
 *     the passed element itself.
 * @return {Element|undefined} The matching element or undefined.
 */
function closest(element, selector) {
  var shouldCheckSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!(element && element.nodeType == 1 && selector)) return;
  var parentElements = (shouldCheckSelf ? [element] : []).concat((0, _parents2.default)(element));

  for (var i = 0, parent; parent = parentElements[i]; i++) {
    if ((0, _matches2.default)(parent, selector)) return parent;
  }
}

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parents;
/**
 * Returns an array of a DOM element's parent elements.
 * @param {!Element} element The DOM element whose parents to get.
 * @return {!Array} An array of all parent elemets, or an empty array if no
 *     parent elements are found.
 */
function parents(element) {
  var list = [];
  while (element && element.parentNode && element.parentNode.nodeType == 1) {
    element = /** @type {!Element} */element.parentNode;
    list.push(element);
  }
  return list;
}

/***/ }),
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(798);
var objectAssign = __webpack_require__(794);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 421 */,
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


document.addEventListener('DOMContentLoaded', function () {
    var videoElement = document.querySelector('.outter.hero-video video');
    var playPauseButton = document.querySelector('.outter.hero-video button');

    if (videoElement && playPauseButton) {
        playPauseButton.addEventListener('click', function () {
            playPauseButton.classList.toggle('playing');
            if (playPauseButton.classList.contains('playing')) {
                videoElement.pause();
            } else {
                videoElement.play();
            }
        });

        videoElement.addEventListener('ended', function () {
            playPauseButton.classList.remove('playing');
        });
    } else {
        console.error('Video element or Play/Pause button not found!');
    }
});

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _accordion = __webpack_require__(238);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.AlternateDropdown = function (_Snappy$BaseComponent) {
    _inherits(AlternateDropdown, _Snappy$BaseComponent);

    _createClass(AlternateDropdown, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-alternate-dropdown';
        }
    }]);

    function AlternateDropdown(element) {
        _classCallCheck(this, AlternateDropdown);

        return _possibleConstructorReturn(this, (AlternateDropdown.__proto__ || Object.getPrototypeOf(AlternateDropdown)).call(this, element));
    }

    _createClass(AlternateDropdown, [{
        key: 'render',
        value: function render() {
            this.accordion = this.element.querySelector('[data-cfa-accordion]').component;
            this.addListener();
            this.accordion.settings.time = 0;
        }
    }, {
        key: 'addListener',
        value: function addListener() {
            var body = document.querySelector('body');
            body.addEventListener('click', function (e) {
                var position = this.element.compareDocumentPosition(e.target);
                if (position !== 0 && position !== 20 && this.accordion.isOpened) {
                    this.accordion.close();
                }
            }.bind(this));
        }
    }]);

    return AlternateDropdown;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.ArticleTable = function (_Snappy$BaseComponent) {
    _inherits(ArticleTable, _Snappy$BaseComponent);

    _createClass(ArticleTable, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-article-table';
        }
    }]);

    function ArticleTable(element) {
        _classCallCheck(this, ArticleTable);

        return _possibleConstructorReturn(this, (ArticleTable.__proto__ || Object.getPrototypeOf(ArticleTable)).call(this, element));
    }

    _createClass(ArticleTable, [{
        key: 'setVars',
        value: function setVars() {
            this.$tableRows = this.$element.find('tbody tr');
            this.headingTitles = Array.from(this.$element.find('thead th')).map(function (cell) {
                return (0, _jquery2.default)(cell).text();
            });

            if (!this.headingTitles.length) {
                this.headingTitles = this.fetchFirstRowsCellData();
            }
        }
    }, {
        key: 'fetchFirstRowsCellData',
        value: function fetchFirstRowsCellData() {
            return this.$tableRows.first().find('td').map(function (cell, value) {
                return value.innerHTML;
            });
        }
    }, {
        key: 'setTableCellDataAttrs',
        value: function setTableCellDataAttrs() {
            var _this = this;

            this.$tableRows.each(function (i, row) {
                var $row = (0, _jquery2.default)(row);
                var $cells = $row.find('td');

                $cells.each(function (i, cell) {
                    cell.setAttribute('data-title', _this.headingTitles[i]);
                    (0, _jquery2.default)(cell).wrapInner('<span></span>');
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            this.setVars();

            this.setTableCellDataAttrs();
        }
    }]);

    return ArticleTable;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.Campaign = function (_Snappy$BaseComponent) {
	_inherits(Campaign, _Snappy$BaseComponent);

	_createClass(Campaign, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-campaign-unit';
		}
	}]);

	function Campaign(element) {
		_classCallCheck(this, Campaign);

		return _possibleConstructorReturn(this, (Campaign.__proto__ || Object.getPrototypeOf(Campaign)).call(this, element));
	}

	_createClass(Campaign, [{
		key: 'render',
		value: function render() {
			this.setVars();
			this.setAppearence();
		}
	}, {
		key: 'setVars',
		value: function setVars() {
			this.fontColor = this.$element.data('fontColor') || '#000';
			this.backgroundColor = this.$element.data('backgroundColor') || '#FFF';
			this.adType = this.$element.data('type');
			this.position = this.$element.data('position').toLowerCase();
			this.$title = this.$element.find('.fa-campaign-unit__title');
			this.$content = this.$element.find('.fa-content-promo__content');
			this.$colPositioner = this.$element.find('.col-positioner');
		}
	}, {
		key: 'setAppearence',
		value: function setAppearence() {
			if (this.adType === 'complex') {
				this.$content.css({
					backgroundColor: this.backgroundColor,
					borderColor: this.fontColor,
					color: this.fontColor
				});
			}

			this.$title.css('color', this.fontColor);

			if (this.position) {
				this.setPosition();
			}
		}
	}, {
		key: 'setPosition',
		value: function setPosition() {
			if (this.position === 'center') {
				this.$colPositioner.addClass('col-sm-offset-3');
			}

			if (this.position === 'right') {
				this.$colPositioner.addClass('col-sm-offset-5');
			}
		}
	}]);

	return Campaign;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _resize = __webpack_require__(17);

var _resize2 = _interopRequireDefault(_resize);

var _menuAim = __webpack_require__(571);

var _gsap = __webpack_require__(208);

var _focusWithin = __webpack_require__(524);

var _focusWithin2 = _interopRequireDefault(_focusWithin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.CFANav = function (_Snappy$BaseComponent) {
    _inherits(CFANav, _Snappy$BaseComponent);

    _createClass(CFANav, null, [{
        key: 'tagName',
        get: function get() {
            return 'cfa-nav';
        }
    }]);

    function CFANav(element) {
        _classCallCheck(this, CFANav);

        return _possibleConstructorReturn(this, (CFANav.__proto__ || Object.getPrototypeOf(CFANav)).call(this, element));
    }

    _createClass(CFANav, [{
        key: 'render',
        value: function render() {

            this.setVars();
            this.setEventListeners();

            if (_resize2.default.isDesktop) {
                this.initSticky();
                this.initMenuAim();
                this.initSearch();
                this.initKeyboardNavigation();
                this.switchTabOrder();
            } else {
                this.initMobile();
            }

            var handle = (0, _focusWithin2.default)();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.stickyElement = this.$element.find('.js-sticky-nav');
            this.stickyContainer = this.$element.find('.js-sticky-nav-container');

            this.navContainer = this.$element.find('.js-cfa-nav-container');
            this.mobileNavOpener = this.$element.find('.js-mobile-nav-opener');

            this.mainNav = this.$element.find('.js-cfa-main-nav');
            this.subNav = this.$element.find('.js-cfa-sub-nav');

            this.secondLevelMenu = this.$element.find('.js-cfa-second-level-menu');
            this.secondLevelMenuItem = this.$element.find('.js-cfa-nav-second-level-item');
            this.menuContent = this.$element.find('.js-cfa-menu-content');

            this.navSecondLevelMenu = this.$element.find('.js-cfa-nav-second-level-menu');

            this.thirdLevelMenu = this.$element.find('.js-cfa-nav-third-level-menu');
            this.menuItem = this.$element.find('.js-menu-item');

            this.navFeatured = this.$element.find('.cfa-menu__featured');
            this.menuItemForward = this.$element.find('.cfa-nav__item .cfa-nav__header .js-menu-item-forward').parent();

            this.menuItemForwardThirdLevel = this.$element.find('.cfa-menu__item .js-menu-item-forward').parent();
            this.menuItemBackward = this.$element.find('.js-menu-item-backward');

            this.firstLevelButtons = this.$element.find('.js-cfa-nav-first-level-button');
            this.secondLevelButtons = this.$element.find('.js-cfa-nav-second-level-button');
            this.activeFirstLevelItem = null;
            this.activeSecondLevelItem = null;

            this.isSearchOpened = false;
            this.search = this.$element.find('.js-cfa-search');
            this.openSearch = this.$element.find('.js-cfa-search-open');
            this.closeSearch = this.$element.find('.js-cfa-search-close');
            this.searchForm = this.$element.find('.js-cfa-search-form');
            this.searchInput = this.$element.find('.js-cfa-search-input');
            this.searchUrl = this.search.data('url');
            this.isGoogleSearch = this.search.is('[data-google-search]');

            this.isMobile = !_resize2.default.isDesktop;
            this.isRunning = false;
            this.isDesktopMenuOpened = false;
            this.isMobileMenuOpened = false;
            this.isMenuFocused = false;
            this.isSticky = false;
            this.translateValue = 0;
            this.scrollAmt = window.pageYOffset || document.documentElement.scrollTop;
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            var _this2 = this;

            this.$window.on('resize:finished', this.bindedResize = this.onResize.bind(this));
            if (!this.$body.hasClass('cw-new-theme')) {
                this.$body.on('body:block', this.onBodyBlock.bind(this));
                this.$body.on('body:unblock', this.onBodyUnblock.bind(this));
            }

            this.navContainer.on('transitionend', this.onNavTransitionEnd.bind(this));
            this.openSearch.on('click', this.onSearchOpen.bind(this));
            this.searchInput.on('keyup', this.onSearchKeyup.bind(this));

            (0, _jquery2.default)(document).on('show.bs.modal', '#IrSignInModal', this.onModalShow.bind(this));
            (0, _jquery2.default)(document).on('hidden.bs.modal', '#IrSignInModal', this.onModalHide.bind(this));

            (0, _jquery2.default)(document).ready(function () {
                (0, _jquery2.default)(_this2.menuItem).map(function (i, elem) {
                    if ((0, _jquery2.default)(elem).find('.js-cfa-nav-third-level-menu').length > 0) {
                        (0, _jquery2.default)(elem).addClass('has-third-level');
                    }
                    if ((0, _jquery2.default)(elem).find('.js-cfa-nav-second-level-menu').length > 0) {
                        (0, _jquery2.default)(elem).addClass('has-sec-level');
                    }
                });

                // this.$element.find('a').attr('tabindex', '0');
            });
        }
    }, {
        key: 'initKeyboardNavigation',
        value: function initKeyboardNavigation() {
            this.firstLevelButtons.on('click keypress', this.onClickFirstLevelButton.bind(this));
            this.secondLevelButtons.on('click keypress', this.onClickSecondLevelButton.bind(this));

            this.secondLevelButtons.keypress(function (e) {
                console.log("test");
                if (e.which === 32) {
                    console.log("test");
                    //Your code goes here
                }
            });
            //this.firstLevelButtons.on('KeyboardEvent.altKey ', this.onClickFirstLevelButton.bind(this));
            //this.secondLevelButtons.on('KeyboardEvent.altKey ', this.onClickSecondLevelButton.bind(this));
        }
    }, {
        key: 'onModalShow',
        value: function onModalShow() {
            if (this.clientHeight <= window.innerHeight) {
                return;
            }
            var scrollbarWidth = this.getScrollBarWidth();
            if (scrollbarWidth) {
                this.stickyElement.filter(function (index, el) {
                    return (0, _jquery2.default)(el).parents('.js-sticky-nav-container').hasClass('is-fixed');
                }).css('padding-right', scrollbarWidth);
            }
        }
    }, {
        key: 'onModalHide',
        value: function onModalHide() {
            this.stickyElement.filter(function (index, el) {
                return (0, _jquery2.default)(el).parents('.js-sticky-nav-container').hasClass('is-fixed');
            }).css('padding-right', 0);
        }
    }, {
        key: 'getScrollBarWidth',
        value: function getScrollBarWidth() {
            var inner = document.createElement('p');
            inner.style.width = '100%';
            inner.style.height = '200px';

            var outer = document.createElement('div');
            outer.style.position = 'absolute';
            outer.style.top = '0px';
            outer.style.left = '0px';
            outer.style.visibility = 'hidden';
            outer.style.width = '200px';
            outer.style.height = '150px';
            outer.style.overflow = 'hidden';
            outer.appendChild(inner);

            document.body.appendChild(outer);
            var w1 = inner.offsetWidth;
            outer.style.overflow = 'scroll';
            var w2 = inner.offsetWidth;
            if (w1 == w2) w2 = outer.clientWidth;

            document.body.removeChild(outer);

            return w1 - w2;
        }
    }, {
        key: 'onClickFirstLevelButton',
        value: function onClickFirstLevelButton(event) {
            if (event.which == 13 || event.type == "click") {
                var activeFirstLevelItem = (0, _jquery2.default)(event.target).parents('.js-cfa-nav-first-level-item');

                event.preventDefault();
                event.stopPropagation();

                if (this.activeFirstLevelItem) {
                    if (this.activeSecondLevelItem) {
                        this.deactivateThirdLevelMenu(this.activeSecondLevelItem);
                        this.closeThirdLevelMenu(this.activeSecondLevelItem);
                        this.activeSecondLevelItem = null;
                    }

                    this.deactivateSecondLevelMenu();
                    this.closeSecondLevelMenu();

                    if (activeFirstLevelItem[0] === this.activeFirstLevelItem[0]) {
                        this.activeFirstLevelItem = null;
                        return;
                    }
                }

                this.activeFirstLevelItem = activeFirstLevelItem;
                this.activateSecondLevelMenu(event.target);
            }
        }
    }, {
        key: 'onClickSecondLevelButton',
        value: function onClickSecondLevelButton(event) {
            if (event.which == 13 || event.type == "click") {
                var activeSecondLevelItem = (0, _jquery2.default)(event.target).parents('.js-cfa-nav-second-level-item');

                event.preventDefault();
                event.stopPropagation();

                if (this.activeSecondLevelItem) {
                    this.deactivateThirdLevelMenu();
                    this.closeThirdLevelMenu();

                    if (activeSecondLevelItem[0] === this.activeSecondLevelItem[0]) {
                        this.activeSecondLevelItem = null;
                        return;
                    }
                }

                this.activeSecondLevelItem = activeSecondLevelItem;
                this.activateThirdLevelMenu(event.target);
            }
        }
    }, {
        key: 'initSearch',
        value: function initSearch() {
            this.search.on('transitionend', this.onSearchTransitionEnd.bind(this));
            this.closeSearch.on('click', this.onSearchClose.bind(this));
        }
    }, {
        key: 'onSearchKeyup',
        value: function onSearchKeyup(e) {
            if (e && e.keyCode === 13) {
                this.onSearchSubmit();
            }
        }
    }, {
        key: 'onSearchSubmit',
        value: function onSearchSubmit() {
            var keyword = this.searchInput.val();

            if (keyword === '') {
                return;
            }

            if (this.isGoogleSearch) {
                var query = this.searchForm.serialize();
                window.location.href = this.searchForm.attr('action') + '?' + query;
            } else {
                window.location.href = this.searchUrl + '?keyword=' + keyword + '&page=1';
            }

            var currentSection = this.searchForm.data('currentSection');
            if (currentSection && !this.isSubmitTracked) {
                (0, _jquery2.default)(window).trigger('gtm:send', [currentSection, 'Search', keyword]);
                this.isSubmitTracked = true;
            }
        }
    }, {
        key: 'onSearchOpen',
        value: function onSearchOpen(e) {
            if (typeof e !== 'undefined' && typeof e.preventDefault === 'function') {
                e.preventDefault();
            }

            var inputValue = this.searchInput.val();

            if (this.isMobile) {
                if (inputValue !== '') {
                    this.onSearchSubmit();
                }

                return;
            }

            if (this.isSearchOpened && inputValue !== '') {
                this.onSearchSubmit();
            } else {
                this.isSearchOpened = true;
                this.search.addClass('cfa-search--opened');
                this.search.addClass('cfa-search--visible');
            }
        }
    }, {
        key: 'onSearchClose',
        value: function onSearchClose(e) {
            if (typeof e !== 'undefined' && typeof e.preventDefault === 'function') {
                e.preventDefault();
            }

            this.isSearchOpened = false;
            this.search.removeClass('cfa-search--opened');
            this.openSearch.focus();
        }
    }, {
        key: 'onSearchTransitionEnd',
        value: function onSearchTransitionEnd(e) {
            if (e.target !== this.search[0]) {
                return;
            }

            if (this.isSearchOpened) {
                this.searchInput.focus();
            } else {
                this.search.removeClass('cfa-search--visible');
            }
        }
    }, {
        key: 'initMenuAim',
        value: function initMenuAim() {
            this.mainNav.menuAim({
                rowSelector: '> ul > li',
                submenuDirection: 'below',
                tolerance: 0,
                activate: function (el) {
                    this.activateSecondLevelMenu(el);
                }.bind(this),
                deactivate: function (el) {
                    this.deactivateSecondLevelMenu(el);
                }.bind(this),
                exitMenu: this.closeSecondLevelMenu.bind(this)
            });

            this.subNav.menuAim({
                activate: function (el) {
                    this.activateThirdLevelMenu(el);
                }.bind(this),
                deactivate: function (el) {
                    this.deactivateThirdLevelMenu(el);
                }.bind(this),
                exitMenu: this.closeThirdLevelMenu.bind(this)
            });
        }
    }, {
        key: 'activateSecondLevelMenu',
        value: function activateSecondLevelMenu(triggerElem) {
            if (this.isSearchOpened) {
                return;
            }

            this.activeFirstLevelItem = (0, _jquery2.default)(triggerElem).hasClass('js-cfa-nav-first-level-item') ? (0, _jquery2.default)(triggerElem) : (0, _jquery2.default)(triggerElem).parents('.js-cfa-nav-first-level-item');
            this.activeFirstLevelItem.addClass('cfa-nav__item--active');

            var newMenu = this.activeFirstLevelItem.find('.js-cfa-nav-second-level-menu').get(0);

            if (newMenu && !this.isDesktopMenuOpened) {
                var newContent = newMenu.querySelector('.js-cfa-menu-content');

                this.tweenPromote(this.tween);
                this.tween = new _gsap.TimelineLite();
                this.tween.set(newMenu, { display: 'block' });
                this.tween.set(newContent, { autoAlpha: 1 });
                this.tween.to(newMenu, 0.2, {
                    autoAlpha: 1,
                    ease: Power0.easeNone
                });
                this.tween.play();

                //newMenu.style.pointerEvents = 'auto';

                this.isDesktopMenuOpened = true;
                this.currentDesktopMenu = newMenu;
            } else if (newMenu && this.isDesktopMenuOpened) {
                var oldMenu = this.currentDesktopMenu,
                    oldContent = oldMenu.querySelector('.js-cfa-menu-content'),
                    _newContent = newMenu.querySelector('.js-cfa-menu-content');

                this.tweenPromote(this.tween);
                this.tween = new _gsap.TimelineLite();
                this.tween.to(oldContent, 0.2, { autoAlpha: 0, ease: Power0.easeNone }).set(newMenu, { display: 'block', autoAlpha: 1 }).set(oldMenu, { display: 'none', autoAlpha: 0 }).to(_newContent, 0.2, { autoAlpha: 1, ease: Power0.easeNone });
                this.tween.play();

                //oldMenu.style.pointerEvents = 'none';
                //newMenu.style.pointerEvents = 'auto';

                this.currentDesktopMenu = newMenu;
            } else {
                this.closeSecondLevelMenu();
            }
        }
    }, {
        key: 'closeSecondLevelMenu',
        value: function closeSecondLevelMenu() {
            if (this.isDesktopMenuOpened) {
                this.tweenPromote(this.tween);
                this.tween = new _gsap.TimelineLite();
                this.tween.to(this.currentDesktopMenu, 0.2, {
                    autoAlpha: 0,
                    ease: Power0.easeNone
                }).set(this.currentDesktopMenu, { display: 'none' }).set(this.currentDesktopMenu.querySelector('.js-cfa-menu-content'), {
                    autoAlpha: 1
                });
                this.tween.play();

                this.currentDesktopMenu.style.pointerEvents = 'none';

                this.currentDesktopMenu = null;
                this.isDesktopMenuOpened = false;
            }

            return true;
        }
    }, {
        key: 'deactivateSecondLevelMenu',
        value: function deactivateSecondLevelMenu() {
            if (this.isSearchOpened) {
                return;
            }

            this.activeFirstLevelItem.removeClass('cfa-nav__item--active');
        }
    }, {
        key: 'activateThirdLevelMenu',
        value: function activateThirdLevelMenu(triggerElem) {
            this.activeSecondLevelItem = (0, _jquery2.default)(triggerElem).hasClass('js-cfa-nav-second-level-item') ? (0, _jquery2.default)(triggerElem) : (0, _jquery2.default)(triggerElem).parents('.js-cfa-nav-second-level-item');
            this.activeSecondLevelItem.addClass('cfa-menu__item--active');

            var newSubMenu = this.activeSecondLevelItem.find('.js-cfa-nav-third-level-menu')[0];

            if (newSubMenu && !this.isDesktopSubMenuOpened) {
                this.tweenPromote(this.tween);
                this.tween = new _gsap.TimelineLite();
                this.tween.set(newSubMenu, { display: 'block' }).set(this.currentDesktopMenu, {
                    height: newSubMenu.scrollHeight + 40 > this.currentDesktopMenu.scrollHeight ? newSubMenu.scrollHeight + 40 : 'auto'
                }).to(newSubMenu, 0.2, { autoAlpha: 1, ease: Power0.easeNone });
                this.tween.play();

                //newSubMenu.style.pointerEvents = 'auto';

                this.isDesktopSubMenuOpened = true;
                this.currentDesktopSubMenu = newSubMenu;
            } else if (newSubMenu && this.isDesktopSubMenuOpened) {
                var oldSubMenu = this.currentDesktopSubMenu;

                this.tweenPromote(this.tween);
                this.tween = new _gsap.TimelineLite();
                this.tween.set(newSubMenu, { display: 'block' }).set(this.currentDesktopMenu, {
                    height: newSubMenu.scrollHeight + 40 > this.currentDesktopMenu.scrollHeight ? newSubMenu.scrollHeight + 40 : 'auto'
                }).to(oldSubMenu, 0.2, { autoAlpha: 0, ease: Power0.easeNone }).set(oldSubMenu, { display: 'none' }).to(newSubMenu, 0.2, { autoAlpha: 1, ease: Power0.easeNone });
                this.tween.play();

                this.currentDesktopSubMenu = newSubMenu;
            } else {
                this.closeThirdLevelMenu();
            }
        }
    }, {
        key: 'deactivateThirdLevelMenu',
        value: function deactivateThirdLevelMenu(el) {
            if (!this.activeSecondLevelItem) return;

            this.activeSecondLevelItem.removeClass('cfa-menu__item--active');
            //this.activeSecondLevelItem.find('.cfa-menu__submenu').style.pointerEvents = 'none';

        }
    }, {
        key: 'closeThirdLevelMenu',
        value: function closeThirdLevelMenu() {
            if (this.isDesktopSubMenuOpened) {
                this.tweenPromote(this.tween);
                this.tween = new _gsap.TimelineLite();
                this.tween.to(this.currentDesktopSubMenu, 0.2, {
                    autoAlpha: 0,
                    ease: Power0.easeNone
                }).set(this.currentDesktopSubMenu, { display: 'none' }).set(this.currentDesktopMenu, { height: 'auto' });
                this.tween.play();

                //this.currentDesktopSubMenu.style.pointerEvents = 'none';

                this.currentDesktopSubMenu = null;
                this.isDesktopSubMenuOpened = false;
            }

            return true;
        }
    }, {
        key: 'tweenPromote',
        value: function tweenPromote(tween) {
            if (typeof tween === 'undefined' || tween == null) return;

            if (typeof tween.progress === 'function' && tween.progress() < 1) {
                tween.pause();
                tween.progress(1);
            }

            if (typeof tween.destroy === 'function') {
                tween.destroy();
            }
        }
    }, {
        key: 'destroyMenuAim',
        value: function destroyMenuAim() {
            this.mainNav.menuAim('destroy');
            this.subNav.menuAim('destroy');
            this.secondLevelMenu.removeAttr('style');
            this.menuContent.removeAttr('style');
            this.thirdLevelMenu.removeAttr('style');
        }
    }, {
        key: 'initSticky',
        value: function initSticky() {
            if (this.$body.hasClass('is-experience-editor') || !this.stickyContainer.length) {
                return;
            }

            this.getStickyData();
            this.onScroll();
            (0, _jquery2.default)(window).on('scroll', this.bindedScroll = this.onScroll.bind(this));
        }
    }, {
        key: 'destroySticky',
        value: function destroySticky() {
            this.deactivateSticky();
            (0, _jquery2.default)(window).off('scroll', this.bindedScroll);
        }
    }, {
        key: 'getStickyData',
        value: function getStickyData() {
            this.stickyOffset = this.stickyContainer.height();
            this.offset = this.stickyElement.offset().top;
        }
    }, {
        key: 'activateSticky',
        value: function activateSticky() {
            this.stickyContainer.addClass('is-fixed');
            this.stickyContainer.css('height', this.stickyOffset);
        }
    }, {
        key: 'deactivateSticky',
        value: function deactivateSticky() {
            this.stickyContainer.removeClass('is-fixed');
            this.stickyContainer.css('height', 'auto');
            this.stickyContainer.removeClass('nav-hide');
            this.isSticky = false;
        }
    }, {
        key: 'initMobile',
        value: function initMobile() {
            var _this3 = this;

            this.mobileNavOpener.on('click', this.bindedHamburgerClick = this.onHamburgerClick.bind(this));
            this.menuItemForward.on('click', this.bindedForwardClick = this.onForwardClick.bind(this));

            this.menuItemForwardThirdLevel.on('click', this.bindedForwardClickThirdLevel = this.onForwardClickThirdLevel.bind(this));
            this.menuItemBackward.on('click', this.bindedBackwardClick = this.onBackwardClick.bind(this));
            this.$element.find('.cfa-menu__list').on('click', function (e) {
                e.stopPropagation();
                console.log((0, _jquery2.default)(e.target).attr('class'));
                if (!(0, _jquery2.default)(e.target).hasClass('is-active') && (0, _jquery2.default)(e.target).hasClass('cfa-menu__list')) {
                    _this3.thirdLevelMenu.removeClass('is-active');
                    _this3.secondLevelMenuItem.removeClass('is-active');
                    _this3.secondLevelButtons.find('.cfa-menu__button-icon').removeClass('cfa-menu__button-icon__minus');
                    _this3.secondLevelMenuItem.removeClass('is-clicked');
                    _this3.secondLevelMenuItem.find('a').off('click.activateLink');
                }
            });

            (0, _jquery2.default)(document).ready(function () {
                if (_this3.isMobile) {
                    //this.$element.find('.cfa-menu__item.has-third-level .cfa-nav__link').removeAttr("href")

                    _this3.$element.find('.cfa-nav__item.has-sec-level .cfa-nav__link').removeAttr("href");

                    _this3.secondLevelButtons.empty();
                    _this3.secondLevelButtons.html('<div class="cfa-menu__button-icon"></div>');
                    if (_this3.navFeatured.children().length == 0) {
                        _this3.navFeatured.empty();
                    }
                }
            });
        }
    }, {
        key: 'onBodyBlock',
        value: function onBodyBlock() {
            this.pageOffset = this.$body.scrollTop();
            this.$body.addClass('is-blocked');
            this.$body.css('top', -this.pageOffset);
        }
    }, {
        key: 'onBodyUnblock',
        value: function onBodyUnblock() {
            this.$body.css('top', 'initial');
            this.$body.removeClass('is-blocked');
            window.scrollTo(0, this.pageOffset);
        }
    }, {
        key: 'destroyMobile',
        value: function destroyMobile() {
            this.resetMenu();
            this.mobileNavOpener.off('click', this.bindedHamburgerClick);
            this.menuItemForward.off('click', this.bindedForwardClick);
            this.menuItemForwardThirdLevel.off('click', this.bindedForwardClickThirdLevel);
            this.menuItemBackward.off('click', this.bindedBackwardClick);
            this.secondLevelMenuItem.find('a').off('click.activateLink');
        }
    }, {
        key: 'resetMenu',
        value: function resetMenu() {
            this.translateValue = 0;
            this.navContainer.css('transform', '');
            this.menuItem.removeClass('is-active');
            this.navFeatured.removeClass('is-hidden');
        }
    }, {
        key: 'onHamburgerClick',
        value: function onHamburgerClick() {
            var _this4 = this;

            this.isMobileMenuOpened = !this.isMobileMenuOpened;
            setTimeout(function () {
                _this4.navFeatured.toggleClass("is-shown");
            }, 100);

            this.resetMenu();
            this.toggleHamburger();
            this.toggleMenu();
            this.toggleBodyBlock();
        }
    }, {
        key: 'onNavTransitionEnd',
        value: function onNavTransitionEnd(e) {
            if (e.target !== this.navContainer[0]) {
                return;
            }

            this.isRunning = false;
            if (this.translateValue === -100) {
                this.subNav.find('li.is-active').removeClass('is-active');
            } else if (this.translateValue === 0) {
                this.mainNav.find('li.is-active').removeClass('is-active');
            }
        }
    }, {
        key: 'onForwardClick',
        value: function onForwardClick(e) {
            if (typeof e !== 'undefined' && typeof e.preventDefault === 'function') {
                e.preventDefault();
            }

            e.stopPropagation();

            var forwardLink = (0, _jquery2.default)(e.currentTarget);
            console.log(forwardLink.parent().attr('class'));
            if (!forwardLink.closest('.js-menu-item').hasClass('is-active')) {
                if (forwardLink.parent().hasClass('js-cfa-nav-first-level-item')) {
                    this.mainNav.find('li.is-active').removeClass('is-active');
                }
                this.navFeatured.addClass('is-hidden');
                this.secondLevelMenuItem.removeClass('is-clicked');
                this.secondLevelButtons.find('.cfa-menu__button-icon').removeClass('cfa-menu__button-icon__minus');
                forwardLink.closest('.js-menu-item').addClass('is-active');
                this.secondLevelMenuItem.find('a').off('click.activateLink');

                //this.translateValue -= 100;
                //this.navContainer.css('transform', 'translateX(' + this.translateValue + '%)');
            }
        }
    }, {
        key: 'onForwardClickThirdLevel',
        value: function onForwardClickThirdLevel(e) {
            if (typeof e !== 'undefined' && typeof e.preventDefault === 'function') {
                e.preventDefault();
            }
            e.stopPropagation();
            var forwardLink = (0, _jquery2.default)(e.currentTarget);

            if (forwardLink.closest('.js-menu-item').hasClass('is-active')) {
                this.secondLevelMenuItem.removeClass('is-active');
                this.secondLevelButtons.find('.cfa-menu__button-icon').removeClass('cfa-menu__button-icon__minus');
                this.secondLevelMenuItem.removeClass('is-clicked');
                //this.secondLevelMenuItem.find('a').off('click.activateLink');
            } else {
                //forwardLink.find('a').on('click.activateLink', () => {
                //    window.location.href = forwardLink.find('a').attr('href');
                //})
                if (forwardLink.parent().hasClass('js-cfa-nav-second-level-item')) {
                    this.thirdLevelMenu.removeClass('is-active');
                    this.secondLevelMenuItem.removeClass('is-clicked');
                }

                if (forwardLink.parent().hasClass('js-cfa-nav-second-level-item')) {
                    this.thirdLevelMenu.removeClass('is-active');
                    this.secondLevelMenuItem.removeClass('is-clicked');
                }

                this.secondLevelMenuItem.removeClass('is-active');
                this.secondLevelButtons.find('.cfa-menu__button-icon').removeClass('cfa-menu__button-icon__minus');
                forwardLink.closest('.js-menu-item').addClass('is-active');
                forwardLink.find('.cfa-menu__button-icon').addClass('cfa-menu__button-icon__minus');
                this.secondLevelMenuItem.addClass('is-clicked');
            }

            //if (forwardLink.find('.cfa-menu__button-icon').hasClass('cfa-menu__button-icon__minus')) {
            //    this.secondLevelMenuItem.removeClass('is-active');
            //    this.secondLevelButtons.find('.cfa-menu__button-icon').removeClass('cfa-menu__button-icon__minus');
            //    this.secondLevelMenuItem.removeClass('is-clicked');
            //    this.secondLevelMenuItem.find('a').off('click.activateLink');
            //} else {
            //    forwardLink.find('a').on('click.activateLink', () => {
            //        window.location.href = forwardLink.find('a').attr('href');
            //    })
            //    if (forwardLink.parent().hasClass('js-cfa-nav-second-level-item')) {
            //        this.thirdLevelMenu.removeClass('is-active');
            //        this.secondLevelMenuItem.removeClass('is-clicked');
            //    }
            //    if (!forwardLink.closest('.js-menu-item').hasClass('is-active')) {
            //        this.secondLevelMenuItem.removeClass('is-active');
            //        this.secondLevelButtons.find('.cfa-menu__button-icon').removeClass('cfa-menu__button-icon__minus');
            //        forwardLink.closest('.js-menu-item').addClass('is-active');
            //        forwardLink.find('.cfa-menu__button-icon').addClass('cfa-menu__button-icon__minus');
            //        this.secondLevelMenuItem.addClass('is-clicked');
            //    }

            //}

        }
    }, {
        key: 'onBackwardClick',
        value: function onBackwardClick(e) {
            if (typeof e !== 'undefined' && typeof e.preventDefault === 'function') {
                e.preventDefault();
            }

            if (this.isRunning) {
                return;
            } else {
                this.isRunning = true;
            }

            //const backwardLink = $(e.currentTarget);

            this.translateValue += 100;
            //this.navContainer.css('transform', 'translateX(' + this.translateValue + '%)');
        }
    }, {
        key: 'toggleHamburger',
        value: function toggleHamburger() {
            this.mobileNavOpener.toggleClass('is-active', this.isMobileMenuOpened);
        }
    }, {
        key: 'toggleMenu',
        value: function toggleMenu() {
            this.$element.toggleClass('is-mobile-active', this.isMobileMenuOpened);
        }
    }, {
        key: 'toggleBodyBlock',
        value: function toggleBodyBlock() {
            if (this.isMobileMenuOpened) {
                this.$body.trigger('body:block');
            } else {
                this.$body.trigger('body:unblock');
            }
        }
    }, {
        key: 'onScroll',
        value: function onScroll() {
            if (this.isSticky !== this.offset < window.pageYOffset) {
                this.isSticky = !this.isSticky;

                if (this.isSticky) {
                    this.activateSticky();
                } else {
                    this.deactivateSticky();
                }
            }
            this.headerSticky();
        }
    }, {
        key: 'headerSticky',
        value: function headerSticky() {
            // Make an enquiry sticky ribbon hide from 50% of the screen on membership pages only
            var wind_url = window.location.href;
            if ((0, _jquery2.default)(window).width() >= 1024) {
                if (parseInt(document.documentElement.scrollTop) >= parseInt(document.documentElement.scrollHeight / 1.4)) {
                    this.stickyContainer.addClass('nav-hide');
                } else {
                    this.stickyContainer.removeClass('nav-hide');

                    (0, _jquery2.default)(".cfa-header__main.js-sticky-nav-container .cfa-header__sticky.js-sticky-nav").show();
                }
            } else {
                this.stickyContainer.removeClass('nav-hide');
                (0, _jquery2.default)(".cfa-header__main.js-sticky-nav-container .cfa-header__sticky.js-sticky-nav").show();
            }
        }
    }, {
        key: 'onResize',
        value: function onResize() {
            var screenSize = void 0;

            if (_resize2.default.isDesktop) {
                screenSize = 'desktop';
            } else {
                screenSize = 'mobile';
            }

            this.onBreakpointChange(screenSize);
        }
    }, {
        key: 'onBreakpointChange',
        value: function onBreakpointChange(screenSize) {
            var wasMobile = this.isMobile;
            var isMobile = screenSize === 'mobile';

            if (isMobile && !wasMobile) {
                if (this.isSearchOpened) {
                    this.onSearchClose();
                }

                this.destroySticky();
                //this.destroyKeyboardNavigation();
                this.destroyMenuAim();
                this.initMobile();
            } else if (!isMobile && wasMobile) {
                if (this.isMobileMenuOpened) {
                    this.isMobileMenuOpened = false;
                    this.toggleMenu();
                    this.toggleHamburger();
                    this.toggleBodyBlock();
                }

                this.destroyMobile();
                this.initSticky();
                this.initMenuAim();
                this.initSearch();
                //this.initKeyboardNavigation();
            }

            this.isMobile = isMobile;
            this.switchTabOrder();
        }
    }, {
        key: 'switchTabOrder',
        value: function switchTabOrder() {
            if (this.isMobile) {
                this.mainNav.insertAfter(this.search);
            } else {
                this.search.insertAfter(this.mainNav);
            }
        }
    }]);

    return CFANav;
}(_snappy2.default.BaseComponent);

(0, _jquery2.default)(function () {
    var wind_url1 = window.location.href;
    if ((0, _jquery2.default)(window).width() < 1025) {
        (0, _jquery2.default)(window).scroll(function () {
            if ((0, _jquery2.default)(this).scrollTop() > 40) {

                (0, _jquery2.default)(".cw-new-theme .cfa-nav-mobile").css("margin-top", "0px");
                // $(".enquiry-ribbon").css({"top":"auto","bottom":"0","z-index":"2"});
                (0, _jquery2.default)(".cw-new-theme .cfa-header__content").css("margin-top", "0px");
                (0, _jquery2.default)(".cw-new-theme .cfa-menu").css("padding-top", "75px");
                (0, _jquery2.default)(".cw-new-theme .cfa-menu").css("margin-top", "0px");
            } else {
                // $(".enquiry-ribbon").css({"top":"0","bottom":"auto","z-index":"2"});
                (0, _jquery2.default)(".cw-new-theme .cfa-nav-mobile").css("margin-top", "40px");
                (0, _jquery2.default)(".cw-new-theme .cfa-header__content").css("margin-top", "38px");
                (0, _jquery2.default)(".cw-new-theme .cfa-menu").css("margin-top", "40px");
                (0, _jquery2.default)(".cw-new-theme .cfa-menu").css("padding-top", "73px");
                (0, _jquery2.default)(".enquiry-ribbon").show();
            }
        });
    }
    var CWCFANav = new _snappy2.default.Component.CFANav();

    var accountUser = (0, _jquery2.default)('.accountArea__userName');
    var accountDropdown = (0, _jquery2.default)('.accountArea__dropdownItems');

    (0, _jquery2.default)(accountUser).click(function (event) {
        event.preventDefault();
        (0, _jquery2.default)(this).toggleClass('active');
        (0, _jquery2.default)(accountDropdown).toggle();
    });
});

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.ClearField = function (_Snappy$BaseComponent) {
    _inherits(ClearField, _Snappy$BaseComponent);

    _createClass(ClearField, null, [{
        key: 'tagName',
        get: function get() {
            return 'cfa-clear-field';
        }
    }]);

    function ClearField(element) {
        _classCallCheck(this, ClearField);

        return _possibleConstructorReturn(this, (ClearField.__proto__ || Object.getPrototypeOf(ClearField)).call(this, element));
    }

    _createClass(ClearField, [{
        key: 'render',
        value: function render() {
            this.setVars();

            if (!this.input.length || !this.button.length) {
                return;
            }

            this.setEventListeners();
            this.checkInput();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.input = this.$element.find('.js-clear-input');
            this.button = this.$element.find('.js-clear-button');
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            this.button.on('click', this.onClick.bind(this));
            this.input.on('keyup blur', this.checkInput.bind(this));
        }
    }, {
        key: 'onClick',
        value: function onClick(e) {
            e.preventDefault();
            this.input.val('').focus();
            this.toggleClass(false);
        }
    }, {
        key: 'checkInput',
        value: function checkInput(e) {
            if (this.input.val().length === 0) {
                this.toggleClass(false);
            } else {
                this.toggleClass(true);
            }
        }
    }, {
        key: 'toggleClass',
        value: function toggleClass(bool) {
            this.button.toggleClass('is-visible', bool);
        }
    }]);

    return ClearField;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _queryString = __webpack_require__(420);

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.SearchResults = function (_Snappy$BaseComponent) {
    _inherits(SearchResults, _Snappy$BaseComponent);

    _createClass(SearchResults, null, [{
        key: 'tagName',
        get: function get() {
            return 'cfa-search-results';
        }
    }]);

    function SearchResults(element) {
        _classCallCheck(this, SearchResults);

        return _possibleConstructorReturn(this, (SearchResults.__proto__ || Object.getPrototypeOf(SearchResults)).call(this, element));
    }

    _createClass(SearchResults, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.$contentContainer = this.$element.find('.js-content-container');
            this.$searchInput = this.$element.find('.js-search-input');
            this.$submitButton = this.$element.find('.js-search-submit-button');
            this.$keyword = this.$searchInput.val();
            this.$handler = this.$element.data('url');
            this.$pages = this.$element.find('.js-content-page');
            this.$prevNextPage = this.$element.find('.js-content-page-prev-next');
            this.paramsArr = [];
            this.selectedValue = '';
            this.isLoading = false;
            this.currentPage = 1;
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            this.bindEventListeners();
            this.$window.on('popstate', this.onPopState.bind(this));
        }
    }, {
        key: 'bindEventListeners',
        value: function bindEventListeners() {
            this.unbindEventListeners();
            this.$searchInput.on('keyup', this.bindedKeyupListeners = this.onKeyup.bind(this));
            this.$submitButton.on('click', this.bindedSubmitListeners = this.onSubmit.bind(this));
            this.$pages.on('click', this.bindedPageListeners = this.changePage.bind(this));
            this.$prevNextPage.on('click', this.bindedPrevNextPageListeners = this.onPrevNextClick.bind(this));
        }
    }, {
        key: 'unbindEventListeners',
        value: function unbindEventListeners() {
            this.$searchInput.off('keyup', this.bindedKeyupListeners);
            this.$submitButton.off('click', this.bindedSubmitListeners);
            this.$pages.off('click', this.bindedPageListeners);
            this.$prevNextPage.off('click', this.bindedPrevNextPageListeners);
        }
    }, {
        key: 'changePage',
        value: function changePage(e) {
            e.preventDefault();
            var page = (0, _jquery2.default)(e.target).data('page-number');

            this.onPageChange(page);
        }
    }, {
        key: 'onPrevNextClick',
        value: function onPrevNextClick(e) {
            e.preventDefault();

            var link = (0, _jquery2.default)(e.target),
                linkType = void 0,
                page = void 0;

            if (!link.is('a')) {
                link = link.parents('a');
            }

            linkType = link.data('page-type');

            this.currentPage = this.$pages.filter('.is-active').data('page-number');

            page = linkType === 'prev' ? --this.currentPage : ++this.currentPage;

            this.onPageChange(page);
        }
    }, {
        key: 'onPageChange',
        value: function onPageChange(page) {
            this.paramsArr = [];

            if (this.$keyword !== 'null' && this.$keyword !== '') {
                this.paramsArr.push('keyword=' + this.$keyword);
            }

            if (page !== '') {
                this.paramsArr.push('page=' + page);
            }

            this.updateURLHash(this.$keyword, page);
            this.fetchData();
        }
    }, {
        key: 'fetchData',
        value: function fetchData() {
            var paramsStr = this.paramsArr.join('&'),
                url = this.$handler + '?' + paramsStr;

            this.isLoading = true;
            this.toggleLoading();

            //TODO: later remove commented setTimeout as it was added for testing
            // setTimeout(function(){
            _jquery2.default.ajax({
                url: url,
                type: "GET",
                dataType: "html",
                success: this.handleSuccess.bind(this),
                error: this.handleError.bind(this)
            });
            // }.bind(this), 3000);
        }
    }, {
        key: 'handleSuccess',
        value: function handleSuccess(response) {
            this.isLoading = false;
            this.toggleLoading();
            this.$contentContainer.empty().html(response);
            this.$window.trigger('content:updated');
            this.$pages = this.$contentContainer.find('.js-content-page');
            this.$prevNextPage = this.$contentContainer.find('.js-content-page-prev-next');
            this.$searchInput = this.$contentContainer.find('.js-search-input');
            this.$submitButton = this.$contentContainer.find('.js-search-submit-button');
            this.bindEventListeners();
            this.scrollToTop();
        }
    }, {
        key: 'handleError',
        value: function handleError(response) {
            console.log(response);
        }
    }, {
        key: 'toggleLoading',
        value: function toggleLoading() {
            var preloader = this.$element.find('.js-cfa-preloader');

            preloader.toggleClass('cfa-preloader--active', this.isLoading);
        }
    }, {
        key: 'scrollToTop',
        value: function scrollToTop() {
            (0, _jquery2.default)("html, body").animate({ scrollTop: 0 }, 200);
        }
    }, {
        key: 'onKeyup',
        value: function onKeyup(e) {
            if (event && event.keyCode === 13) {
                this.onSubmit();
            }
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(e) {
            var keyword = this.$searchInput.val();
            this.$keyword = keyword;

            if (keyword === '') {
                return;
            }

            this.paramsArr = [];
            this.currentPage = 1;

            if (keyword !== 'null' && keyword !== '') {
                this.paramsArr.push('keyword=' + keyword);
            }

            this.paramsArr.push('page=' + this.currentPage);

            this.updateURLHash(keyword, this.currentPage);
            this.fetchData();
        }
    }, {
        key: 'updateURLHash',
        value: function updateURLHash(keyword, page) {
            var parsedSearchString = _queryString2.default.parse(location.search);
            parsedSearchString['keyword'] = keyword;
            parsedSearchString['page'] = page;

            var convertedQuery = _queryString2.default.stringify(parsedSearchString),
                URL = location.pathname + '?' + convertedQuery + location.hash;

            if ('pushState' in history) {
                history.pushState({}, document.title, URL);
            }
        }
    }, {
        key: 'onPopState',
        value: function onPopState() {
            var parsedSearchString = _queryString2.default.parse(location.search);

            this.$keyword = parsedSearchString['keyword'];
            this.currentPage = parsedSearchString['page'];

            this.paramsArr = [];

            if (this.$keyword !== 'null' && this.$keyword !== '') {
                this.paramsArr.push('keyword=' + this.$keyword);
            }

            this.paramsArr.push('page=' + this.currentPage);

            this.fetchData();
        }
    }]);

    return SearchResults;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.NominationForm = function (_Snappy$BaseComponent) {
	_inherits(NominationForm, _Snappy$BaseComponent);

	_createClass(NominationForm, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-nomination-form';
		}
	}]);

	function NominationForm(element) {
		_classCallCheck(this, NominationForm);

		return _possibleConstructorReturn(this, (NominationForm.__proto__ || Object.getPrototypeOf(NominationForm)).call(this, element));
	}

	_createClass(NominationForm, [{
		key: 'render',
		value: function render() {}
	}]);

	return NominationForm;
}(_snappy2.default.BaseComponent);

(0, _jquery2.default)(function () {
	var CWNominationForm = new _snappy2.default.Component.NominationForm();

	if ((0, _jquery2.default)("input[type=checkbox].input-validation-error").length > 0 || (0, _jquery2.default)(".field-validation-error").length > 0) {
		(0, _jquery2.default)('html, body').animate({
			scrollTop: (0, _jquery2.default)('.fa-nomination-form__form').offset().top - 80
		}, 800);
	}

	function countWords(text) {
		text = text.replace(/(^\s*)|(\s*$)/gi, "");
		text = text.replace(/[ ]{2,}/gi, " ");
		text = text.replace(/\n /, "\n");
		return text.split(' ').length;
	}

	(0, _jquery2.default)("#ReasonForNomination").on("keydown", function (e) {
		var allowedKeys = [8, 46, 37, 38, 39, 40];
		var wordCount = countWords((0, _jquery2.default)("#ReasonForNomination").val());
		if (wordCount >= 310 && _jquery2.default.inArray(e.keyCode, allowedKeys) < 0) {
			return false;
		}
	});

	(0, _jquery2.default)(".fa-nomination-form__form button[type=submit]").on("click", function () {
		(0, _jquery2.default)("form.fa-nomination-form__form").submit();
		(0, _jquery2.default)(".fa-nomination-form__form button[type=submit]").attr("disabled", "disabled");
	});

	(0, _jquery2.default)(":not(input[type=checkbox]).input-validation-error").removeClass("input-validation-error").addClass("fa-input-field--error").parent("div").addClass("fa-input-field--error");

	(0, _jquery2.default)("input[type=checkbox].input-validation-error").siblings("label").css("color", "red");

	(0, _jquery2.default)(".field-validation-error").removeClass("field-validation-error").addClass("fa-input-field__error-message");
});

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.ComparisonTool = function (_Snappy$BaseComponent) {
    _inherits(ComparisonTool, _Snappy$BaseComponent);

    _createClass(ComparisonTool, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-comparison-tool';
        }
    }]);

    function ComparisonTool(element) {
        _classCallCheck(this, ComparisonTool);

        return _possibleConstructorReturn(this, (ComparisonTool.__proto__ || Object.getPrototypeOf(ComparisonTool)).call(this, element));
    }

    _createClass(ComparisonTool, [{
        key: 'setVars',
        value: function setVars() {}
    }, {
        key: 'equalHeight',
        value: function equalHeight() {
            var titleHeight = (0, _jquery2.default)('.membership-table__title').height();
            (0, _jquery2.default)('.placeholder__content').css('height', titleHeight);
        }
    }, {
        key: 'render',
        value: function render() {
            this.equalHeight();
            (0, _jquery2.default)('.errorMessageWrapper').hide();

            var btnAddToCompare = (0, _jquery2.default)('.add-to-compare');
            (0, _jquery2.default)(btnAddToCompare).on("click keypress", function (e) {
                if (e.which == 13 || e.type == "click") {
                    var stickItem = function stickItem() {

                        var orgElementPos = (0, _jquery2.default)('.original').offset();
                        var orgElementTop = orgElementPos.top;

                        if ((0, _jquery2.default)(window).scrollTop() >= orgElementTop) {
                            // scrolled past the original position; now only show the cloned, sticky element.
                            // Cloned element should always have same left position and width as original element.     
                            var orgElement = (0, _jquery2.default)('.original');
                            var coordsOrgElement = orgElement.offset();
                            var leftOrgElement = coordsOrgElement.left;
                            var widthOrgElement = orgElement.css('width');
                            if ((0, _jquery2.default)(window).width() >= 992) {
                                (0, _jquery2.default)('.cloned').css('left', leftOrgElement + 'px').css('top', 25).css('width', widthOrgElement).show();
                                (0, _jquery2.default)('.fa-sub-navigation').css('display', 'none');
                            } else {
                                (0, _jquery2.default)('.cloned').css('left', leftOrgElement + 'px').css('top', 10).css('width', widthOrgElement).show();
                                (0, _jquery2.default)('.fa-sub-navigation').css('display', 'block');
                            }
                        } else {
                            // not scrolled past the menu; only show the original menu.
                            (0, _jquery2.default)('.cloned').hide();
                            (0, _jquery2.default)('.fa-sub-navigation').css('display', 'block');
                        }
                    };

                    var col = (0, _jquery2.default)(this).parent().data('col');
                    var selectedItem = (0, _jquery2.default)('div[data-col=' + col + ']');
                    var clonedItem = (0, _jquery2.default)('.slick-slide.slick-cloned .list-item');

                    (0, _jquery2.default)(selectedItem).toggleClass('ticked selected');
                    (0, _jquery2.default)(clonedItem).removeClass('ticked');

                    //Display data for selected item/s
                    var currentSelection = (0, _jquery2.default)('.membership-table.original div.membership-table__data[data-col=' + col + ']');
                    (0, _jquery2.default)(currentSelection).toggle().toggleClass('current');
                    (0, _jquery2.default)(currentSelection).appendTo((0, _jquery2.default)(currentSelection).closest('.membership-table.original'));

                    // Create a clone of the membership table headers (right next to original)
                    (0, _jquery2.default)('.membership-table.cloned').remove();
                    var cloneData = (0, _jquery2.default)('.membership-table.original').clone();
                    (0, _jquery2.default)(cloneData).insertAfter('.membership-table.original').addClass('cloned').css({
                        'position': 'fixed',
                        'z-index': '1'
                    }).removeClass('original');

                    var clonedTable = (0, _jquery2.default)('.membership-table.cloned');
                    (0, _jquery2.default)(clonedTable).find('.membership-table__title').html(''); //Display blank for cloned table

                    var clonedTableData = (0, _jquery2.default)('.membership-table.cloned .membership-table__data');
                    (0, _jquery2.default)(clonedTableData).find('.list-item').addClass('selected');
                    (0, _jquery2.default)(clonedTableData).find('.availability-status, .price-details, ul').remove();

                    //Sticky Item
                    var scrollIntervalID = setInterval(stickItem, 10);


                    var selectCount = (0, _jquery2.default)('div.list-item.ticked').length;
                    console.log(selectCount);

                    //Membership Carousel
                    if ((0, _jquery2.default)(window).width() >= 768) {
                        if (selectCount == 3) {
                            (0, _jquery2.default)('.list-item:not(".selected")').css({ opacity: "0.65" });
                            (0, _jquery2.default)('.list-item:not(".selected") .add-to-compare').css({ cursor: "default" });
                        } else if (selectCount > 3) {
                            (0, _jquery2.default)('.errorMessageWrapper').show();

                            var col = (0, _jquery2.default)(this).parent().data('col');
                            var currentItem = (0, _jquery2.default)('div[data-col=' + col + ']');
                            (0, _jquery2.default)(currentItem).removeClass('selected ticked');
                            (0, _jquery2.default)('.membership-table.original div.membership-table__data[data-col=' + col + ']').removeClass('current').hide();
                            (0, _jquery2.default)('.membership-table.cloned div.membership-table__data[data-col=' + col + ']').removeClass('current').hide();
                        } else {
                            (0, _jquery2.default)('.list-item:not(".selected")').css({ opacity: "1" });
                            (0, _jquery2.default)('.list-item:not(".selected") .add-to-compare').css({ cursor: "pointer" });
                        }
                    }

                    if ((0, _jquery2.default)(window).width() < 768) {
                        if (selectCount == 2) {
                            (0, _jquery2.default)('.list-item:not(".selected")').css({ opacity: "0.65" });
                            (0, _jquery2.default)('.list-item:not(".selected") .add-to-compare').css({ cursor: "default" });
                        } else if (selectCount > 2) {
                            (0, _jquery2.default)('.errorMessageWrapper').show();
                            (0, _jquery2.default)('.errorMessageWrapper .errorMessage p').html('Please select a maximum of 2 memberships for comparison');
                            var col = (0, _jquery2.default)(this).parent().data('col');
                            var currentItem = (0, _jquery2.default)('div[data-col=' + col + ']');
                            (0, _jquery2.default)(currentItem).removeClass('selected ticked');
                            (0, _jquery2.default)('.membership-table.original div.membership-table__data[data-col=' + col + ']').removeClass('current').hide();
                            (0, _jquery2.default)('.membership-table.cloned div.membership-table__data[data-col=' + col + ']').removeClass('current').hide();
                        } else {
                            (0, _jquery2.default)('.list-item:not(".selected")').css({ opacity: "1" });
                            (0, _jquery2.default)('.list-item:not(".selected") .add-to-compare').css({ cursor: "pointer" });
                        }
                    }
                }
            });

            (0, _jquery2.default)('.errorMessage').click(function () {
                (0, _jquery2.default)(this).parent().hide();
            });

            //Placeholder
            if ((0, _jquery2.default)(window).width() >= 768) {
                (0, _jquery2.default)('.fa-comparison-tool .add-to-compare').click(function () {
                    var selectedMembership = (0, _jquery2.default)('.membership-table.original .membership-table__data.selected.current').length;
                    if (selectedMembership == 0) {
                        (0, _jquery2.default)('.fa-comparison-tool .placeholder').show();
                    }
                    if (selectedMembership == 1) {
                        (0, _jquery2.default)('.fa-comparison-tool .placeholder').hide();
                        (0, _jquery2.default)('.fa-comparison-tool .placeholder:lt(2)').show();
                    }
                    if (selectedMembership == 2) {
                        (0, _jquery2.default)('.fa-comparison-tool .placeholder').hide();
                        (0, _jquery2.default)('.fa-comparison-tool .placeholder:lt(1)').show();
                    }
                    if (selectedMembership == 3) {
                        (0, _jquery2.default)('.fa-comparison-tool .placeholder').hide();
                    }
                });
            }
            if ((0, _jquery2.default)(window).width() < 768) {
                (0, _jquery2.default)('.fa-comparison-tool .add-to-compare').click(function () {
                    var selectedMembership = (0, _jquery2.default)('.membership-table.original .membership-table__data.selected.current').length;
                    if (selectedMembership == 0) {
                        (0, _jquery2.default)('.fa-comparison-tool .placeholder:lt(2)').show();
                    }
                    if (selectedMembership == 1) {
                        (0, _jquery2.default)('.fa-comparison-tool .placeholder').hide();
                        (0, _jquery2.default)('.fa-comparison-tool .placeholder:lt(1)').show();
                    }
                    if (selectedMembership == 2) {
                        (0, _jquery2.default)('.fa-comparison-tool .placeholder').hide();
                    }
                });
            }

            //Hide Sticky Nav
            var comparisonToolSection = (0, _jquery2.default)('.fa-comparison-tool').closest('section');
            var nextSection = (0, _jquery2.default)(comparisonToolSection).next();
            var offsetNextSectionTop = (0, _jquery2.default)(nextSection).offset.top;

            (0, _jquery2.default)(window).scroll(function () {

                var clonedTable = (0, _jquery2.default)('.membership-table.cloned');

                if ((0, _jquery2.default)(window).scrollTop() >= offsetNextSectionTop - ((0, _jquery2.default)(window).width() < 768 ? 300 : 550)) {
                    (0, _jquery2.default)(clonedTable).find('.membership-table__data.ticked.selected.current').addClass('hiddenItem');
                } else {
                    (0, _jquery2.default)(clonedTable).find('.membership-table__data.ticked.selected.current').removeClass('hiddenItem');
                }
            });
        }
    }]);

    return ComparisonTool;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _handlebars = __webpack_require__(21);

var _handlebars2 = _interopRequireDefault(_handlebars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.ContactForm = function (_Snappy$BaseComponent) {
    _inherits(ContactForm, _Snappy$BaseComponent);

    _createClass(ContactForm, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-contact-form';
        }
    }]);

    function ContactForm(element) {
        _classCallCheck(this, ContactForm);

        return _possibleConstructorReturn(this, (ContactForm.__proto__ || Object.getPrototypeOf(ContactForm)).call(this, element));
    }

    _createClass(ContactForm, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.addEventListeners();
            localStorage.removeItem(this.$unsavedDataStorageNamespace);
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.$form = this.$element.find('.fa-contact-form__form');
            this.$messageContainer = this.$element.find('.message-container');
            this.errorClass = 'fa-input-field--error';
            this.messageClass = 'fa-input-field__error-message';
            this.$addFieldButton = this.$element.find('.js-add-field-button');
            this.$formItself = this.$element.find('[data-form-itself]');
            this.$thankYouMessage = this.$element.find('[data-thank-you-message]');
            this.$fileinputs = this.$element.find('.js-inputfile');
            this.$conditionalSelect = this.$element.find('[data-conditional-select]');
            this.$conditionalOptions = this.$element.find('[data-conditional-option]');
            this.$removeSectionButton = this.$element.find('[data-remove-section-button]');
            this.$addSectionButton = this.$element.find('[data-add-section-button]');
            this.$newSectionsPlaceholder = this.$element.find('[data-new-sections-placeholder]');
            this.$submitButton = this.$element.find(':submit');
            this.isProfile = this.$element[0].hasAttribute('data-profile-form');
            this.isHandleUnsavedData = this.$element.is('[data-unsaved-storage-namespace]');
            this.$unsavedDataStorageNamespace = this.$element.attr('data-unsaved-storage-namespace');
            this.$initialState = this.$form.serialize();
            this.$preloader = this.$element.find('.js-cfa-preloader');
            this.$avatar = this.$element.find('.js-avatar');

            if (window.FileReader) {
                this.fileReader = new FileReader();
            }
        }
    }, {
        key: 'addEventListeners',
        value: function addEventListeners() {
            this.$form.on('submit', this.onFormSubmission.bind(this));
            this.$addFieldButton.on('click', this.addField.bind(this));
            if (this.$fileinputs.length) {
                this.$fileinputs.on('change', this.onInputFileChange.bind(this));
            }
            if (this.$conditionalSelect.length) {
                this.$element.on('change', this.$conditionalSelect, this.onConditionalSelectChange.bind(this));
            }
            if (this.$addSectionButton.length) {
                this.$addSectionButton.on('click', this.onAddSectionButtonClick.bind(this));
            }
            if (this.$removeSectionButton.length) {
                this.$element.on('click', this.$removeSectionButton, this.onRemoveSectionButtonClick.bind(this));
            }

            this.$form.on('change', this.onFormChange.bind(this));

            if (this.isProfile) {
                this.fileReader.addEventListener('loadend', this.onFileReaderLoadFile.bind(this));
            }
        }
    }, {
        key: 'onAddSectionButtonClick',
        value: function onAddSectionButtonClick(e) {
            e.preventDefault();

            var $target = (0, _jquery2.default)(e.target);

            var $lastSectionIndex = this.getLastSectionIndex();

            var $templateType = $target.attr('data-add-section-template-type');

            var $templateSource = (0, _jquery2.default)('#' + $templateType + '-section-template').html();

            var $newSectionHtml = this.getNewSectionHtml($templateSource, $lastSectionIndex + 1);

            this.$newSectionsPlaceholder.append($newSectionHtml);

            this.$conditionalOptions = this.$element.find('[data-conditional-option]');
        }
    }, {
        key: 'onFormChange',
        value: function onFormChange(e) {
            if (this.isHandleUnsavedData) {
                this.handleUnsavedData();
            }

            this.removeValidationError({ element: e.target.name });
        }
    }, {
        key: 'isDirty',
        value: function isDirty() {
            return this.$form.serialize() !== this.$initialState;
        }
    }, {
        key: 'getLastSectionIndex',
        value: function getLastSectionIndex() {
            var $availableSections = this.$element.find('[data-section]');

            var sectionsIndexes = [];
            var maxIndex = null;

            $availableSections.each(function (index, el) {
                sectionsIndexes.push(parseInt((0, _jquery2.default)(el).attr('data-section-index')));
            });

            maxIndex = sectionsIndexes.reduce(function (a, b) {
                return Math.max(a, b);
            }, 0);

            return maxIndex;
        }
    }, {
        key: 'getNewSectionHtml',
        value: function getNewSectionHtml(template, index) {
            var sectionTemplateFn = _handlebars2.default.compile(template);
            return sectionTemplateFn({ sectionIndex: index });
        }
    }, {
        key: 'onRemoveSectionButtonClick',
        value: function onRemoveSectionButtonClick(e) {
            var $target = (0, _jquery2.default)(e.target);

            if (!$target[0].hasAttribute('data-remove-section-button')) return;

            var $sectionIndexToRemove = $target.attr('data-remove-section-button-index');

            this.$element.find('[data-section-index="' + $sectionIndexToRemove + '"]').remove();
        }
    }, {
        key: 'onConditionalSelectChange',
        value: function onConditionalSelectChange(e) {
            var $target = (0, _jquery2.default)(e.target);

            if (!$target[0].hasAttribute('data-conditional-select')) return;

            var $choosenOption = this.getInputValue($target);
            var $conditionalSelectGroup = $target.attr('data-conditional-group');

            $target.closest('.cfa-field').removeClass('fa-input-field--error').find('.cfa-field__error').text('');

            $target.removeClass('fa-input-field--error');

            this.$conditionalOptions.filter('[data-conditional-group="' + $conditionalSelectGroup + '"]').hide().find('[data-conditional-input]').val('');
            this.$element.find('[data-' + $choosenOption + ']').filter('[data-conditional-group="' + $conditionalSelectGroup + '"]').show();
        }
    }, {
        key: 'getInputValue',
        value: function getInputValue($input) {
            var type = $input.attr('type');

            if (type === 'radio') {
                return (0, _jquery2.default)('input[name=' + $input.attr("name") + ']:checked').val();
            }

            if (type === 'checkbox') return $input.is(':checked');

            return $input.val();
        }
    }, {
        key: 'toggleLoading',
        value: function toggleLoading() {
            if (this.$preloader.length) {
                this.$preloader.toggleClass('cfa-preloader--active', this.isLoading);
            }
        }
    }, {
        key: 'onFormSubmission',
        value: function onFormSubmission(event) {
            event.preventDefault();
            this.toggleLoading();
            if (this.$preloader.length) {
                this.$preloader.attr('aria-busy', true);
            }

            _jquery2.default.ajax({
                url: this.formAction = this.$form.attr('action'),
                method: this.formMethod = this.$form.attr('method'),
                data: new FormData(event.target),
                contentType: false,
                cache: false,
                processData: false
            }).fail(this.handleFailedResponse.bind(this)).always(this.handleValidationResponse.bind(this));
        }
    }, {
        key: 'handleFailedResponse',
        value: function handleFailedResponse(response) {
            var pathname = window.location.pathname;

            if (response.status === 403) {
                window.location = response.responseJSON.logOnUrl + '?ReturnUrl=' + pathname;
            }
        }
    }, {
        key: 'handleValidationResponse',
        value: function handleValidationResponse(response) {
            var _this2 = this;

            this.toggleLoading();
            if (this.$preloader.length) {
                this.$preloader.attr('aria-busy', false);
            }

            if (!response.success) {
                _jquery2.default.each(response.fields, function (i, field) {
                    if (!field.success) {
                        _this2.showValidationError(field);
                    } else {
                        _this2.removeValidationError(field);
                    }
                });
                this.scrollToError(this.$form.find('.fa-input-field--error:first'));
            } else {
                this.handleSuccess(response);
            }
        }
    }, {
        key: 'getEscapedSelector',
        value: function getEscapedSelector(field) {

            return field.element ? field.element.replace(/(:|\.|\[|\])/g, '\\$1') : null;
        }
    }, {
        key: 'showValidationError',
        value: function showValidationError(field) {

            var escapedSelector = this.getEscapedSelector(field);

            var $element = this.$form.find('[name=' + escapedSelector + ']');

            $element.addClass(this.errorClass)[$element.is(':checkbox') ? 'parents' : 'closest']('.cfa-field').addClass(this.errorClass).find('.' + this.messageClass).text(field.message);
        }
    }, {
        key: 'onInputFileChange',
        value: function onInputFileChange(e) {
            var label = e.target.nextElementSibling;
            var labelVal = label.innerHTML;
            var fileName = '';

            fileName = e.target.value.split('\\').pop();

            var filelabel = label.querySelector('.js-inputfile-label');

            if (this.isProfile) {
                filelabel.innerHTML = 'Change Photo';
                var file = e.target.files[0];
                this.showAvatar(file);
            } else {
                if (fileName && filelabel) {
                    filelabel.innerHTML = fileName;
                } else {
                    label.innerHTML = labelVal;
                }
            }
        }
    }, {
        key: 'showAvatar',
        value: function showAvatar(file) {
            if (window.File && window.FileReader && window.FileList && window.Blob) {
                if (file) {
                    this.fileReader.readAsDataURL(file);
                }
            }
        }
    }, {
        key: 'onFileReaderLoadFile',
        value: function onFileReaderLoadFile() {
            this.updateAvatar(this.fileReader.result);
        }
    }, {
        key: 'removeValidationError',
        value: function removeValidationError(field) {
            var escapedSelector = this.getEscapedSelector(field);

            var $element = this.$form.find('[name=' + escapedSelector + ']');

            $element.removeClass(this.errorClass)[$element.is(':checkbox') ? 'parents' : 'closest']('.cfa-field').removeClass(this.errorClass).find('.' + this.messageClass).text('');
        }
    }, {
        key: 'getNextIndex',
        value: function getNextIndex() {}
    }, {
        key: 'addNewSection',
        value: function addNewSection(template) {}
    }, {
        key: 'handleUnsavedData',
        value: function handleUnsavedData() {
            this.$form[this.isDirty() ? 'addClass' : 'removeClass']('is-dirty');

            var formName = this.$form.closest('.js-tab').attr('data-target');

            var unsavedData = {};

            unsavedData[formName] = this.isDirty();

            (0, _jquery2.default)(window).trigger('unsaved:changed', [this.$unsavedDataStorageNamespace, unsavedData]);

            if (this.isDirty()) {
                this.$submitButton.text('Save');
            }
        }
    }, {
        key: 'handleSuccess',
        value: function handleSuccess(response) {
            var _this3 = this;

            var activeClass = 'active';

            if (this.isHandleUnsavedData) {
                this.$initialState = this.$form.serialize();
                this.handleUnsavedData();
            }

            this.removeErrors();

            if (!this.isProfile) {
                this.resetForm();
            }

            this.$messageContainer.addClass(activeClass);

            if (this.$thankYouMessage.length && this.$formItself.length) {
                this.$form.css('height', this.$form.outerHeight());
                this.$formItself.fadeOut(function () {
                    _this3.$thankYouMessage.fadeIn(function () {
                        _this3.$form.wrapInner('<div/>');
                        var newHeight = _this3.$form.find('div:first').height();
                        _this3.$form.css('height', newHeight);
                    });
                });
            }

            // commented code below didn't work so now it's commented and is to be removed
            // $.each(response.fields, (i, field) => {
            //     this.removeValidationError(field);
            // });

            window.setTimeout(function () {
                this.$messageContainer.removeClass(activeClass);
            }.bind(this), 10000);

            if (this.isProfile) {
                this.$submitButton.text('Saved');
                this.updateAvatar(response.photo);
            }

            if (this.$body.hasClass('cfa-generic')) {
                (0, _jquery2.default)(window).trigger('gtm:send', ['Contact Us', 'Submit', 'Submit an enquiry']);
            }

            this.trackSubmission();
        }
    }, {
        key: 'updateAvatar',
        value: function updateAvatar(photoUrl) {
            this.$avatar.attr('src', photoUrl);
        }
    }, {
        key: 'trackSubmission',
        value: function trackSubmission() {
            var category = this.$element.attr('data-gtm-category');
            var action = this.$element.attr('data-gtm-action');
            var label = this.$element.attr('data-gtm-label') || '';

            if (category && action) {
                (0, _jquery2.default)(window).trigger('gtm:send', [category, action, label]);
            }
        }
    }, {
        key: 'removeErrors',
        value: function removeErrors() {
            var _this4 = this;

            this.$form.find('input, select, textarea').each(function (i, element) {
                (0, _jquery2.default)(element).removeClass(_this4.errorClass)[(0, _jquery2.default)(element).is(':checkbox') ? 'parents' : 'closest']('.cfa-field').removeClass(_this4.errorClass).find('.' + _this4.messageClass).text('');
            });
        }
    }, {
        key: 'addField',
        value: function addField(e) {
            e.preventDefault();

            var $clonedField = (0, _jquery2.default)(e.target).closest('[data-clonable]').find('[data-to-clone]').not('[data-cloned]').clone().val('').attr('data-cloned', '');

            (0, _jquery2.default)(e.target).closest('[data-clonable]').find('.js-added-fields-container').append($clonedField);
        }
    }, {
        key: 'resetForm',
        value: function resetForm() {
            this.$form.find('input, select, textarea').each(function (i, element) {
                element.value = '';
            });
        }
    }, {
        key: 'scrollToError',
        value: function scrollToError(el) {
            if (el.length) {
                (0, _jquery2.default)('html, body').animate({ scrollTop: el.offset().top - 100 }, 300);
            }
        }
    }]);

    return ContactForm;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _queryString = __webpack_require__(420);

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.ContentLoader = function (_Snappy$BaseComponent) {
    _inherits(ContentLoader, _Snappy$BaseComponent);

    _createClass(ContentLoader, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-content-loader';
        }
    }]);

    function ContentLoader(element) {
        _classCallCheck(this, ContentLoader);

        return _possibleConstructorReturn(this, (ContentLoader.__proto__ || Object.getPrototypeOf(ContentLoader)).call(this, element));
    }

    _createClass(ContentLoader, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.addEventListeners();
            this.selectFilterOption();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.$contentContainer = this.$element.find('.js-content-container');
            this.$contentFilter = this.$element.find('.js-content-filter');
            this.$contentFilterBtn = this.$element.find('.js-content-filter-btn');
            this.$preloader = this.$element.find('.js-cfa-preloader');
            this.$handler = this.$element.data('url');
            this.$queryParameter = this.$element.data('query-parameter');
            this.$pages = this.$element.find('.js-content-page');
            this.$prevNextPage = this.$element.find('.js-content-page-prev-next');
            this.paramsObj = {};
            this.selectedValue = '';
            this.isLoading = false;
            this.browserAddressWay = this.$element.data('browser-address');
            this.currentPage = 1;
            if (this.$contentFilter.length) {
                this.selectedOption = (0, _jquery2.default)(this.$contentFilter[0].options[this.$contentFilter[0].selectedIndex]);
            }

            this.shouldFocused = false;
        }
    }, {
        key: 'addEventListeners',
        value: function addEventListeners() {
            if (this.$contentFilter.length) {
                this.$contentFilter.on('change', this.onFilterChange.bind(this));
            }
            this.bindPageListeners();

            if (this.$contentFilterBtn) {
                this.$contentFilterBtn.on('click', this.onFilterChange.bind(this));
            }

            this.$window.on('contentLoader:loadByQueryString', this.loadByQueryString.bind(this));
            this.$window.on('contentLoader:setQueryString', this.setQueryString.bind(this));
            this.$window.on('popstate', this.onPopstate.bind(this));
        }
    }, {
        key: 'bindPageListeners',
        value: function bindPageListeners() {
            this.unbindPageListeners();
            this.$pages.on('click', this.bindedPageListeners = this.changePage.bind(this));
            this.$prevNextPage.on('click', this.bindedPrevNextPageListeners = this.onPrevNextClick.bind(this));
        }
    }, {
        key: 'unbindPageListeners',
        value: function unbindPageListeners() {
            this.$pages.off('click', this.bindedPageListeners);
            this.$prevNextPage.off('click', this.bindedPrevNextPageListeners);
        }
    }, {
        key: 'onFilterChange',
        value: function onFilterChange() {
            this.$preloader.attr('aria-busy', true);
            this.sendChosenFilter();
        }
    }, {
        key: 'changePage',
        value: function changePage(e) {
            e.preventDefault();
            var page = (0, _jquery2.default)(e.target).data('page-number');

            this.shouldFocused = true;
            this.onPageChange(page);
        }
    }, {
        key: 'onPrevNextClick',
        value: function onPrevNextClick(e) {
            e.preventDefault();

            var link = (0, _jquery2.default)(e.currentTarget),
                linkType = void 0,
                page = void 0;

            linkType = link.data('page-type');

            this.currentPage = this.$pages.filter('.is-active').data('page-number');

            page = linkType === 'prev' ? --this.currentPage : ++this.currentPage;

            this.shouldFocused = true;
            this.onPageChange(page);
        }
    }, {
        key: 'updatePageInParamsObj',
        value: function updatePageInParamsObj(page) {
            if (page !== '' && page !== 1) {
                this.paramsObj.page = page;
            }

            if (page === 1) {
                delete this.paramsObj.page;
            }
        }
    }, {
        key: 'onPageChange',
        value: function onPageChange(page) {

            this.updatePageInParamsObj(page);

            this.isPageChanged = true;
            this.updateBrowserAddress();
            this.fetchData();
        }
    }, {
        key: 'sendChosenFilter',
        value: function sendChosenFilter() {
            this.paramsObj = {};
            this.currentPage = 1;

            this.selectedOption = (0, _jquery2.default)(this.$contentFilter[0].options[this.$contentFilter[0].selectedIndex]);
            this.selectedValue = this.selectedOption.val();

            if (this.selectedValue !== 'null' && this.selectedValue !== '') {
                this.paramsObj[this.$queryParameter] = this.selectedValue;
            }
            this.updateBrowserAddress();

            this.fetchData();
        }
    }, {
        key: 'setParamsObj',
        value: function setParamsObj(obj) {
            this.paramsObj = obj;
        }
    }, {
        key: 'fetchData',
        value: function fetchData() {
            var paramsStr = _queryString2.default.stringify(this.paramsObj);
            var url = this.$handler + (this.$handler.indexOf('?') === -1 ? '?' : '&') + paramsStr;

            this.isLoading = true;
            this.toggleLoading();

            _jquery2.default.ajax({
                url: url,
                type: 'GET',
                dataType: 'html',
                success: this.handleSuccess.bind(this),
                error: this.handleError.bind(this)
            });
        }
    }, {
        key: 'loadByQueryString',
        value: function loadByQueryString(e, qs) {
            var parsedQs = _queryString2.default.parse(qs);
            this.setParamsObj(parsedQs);
            this.fetchData();
            this.updateBrowserAddress();
        }
    }, {
        key: 'setQueryString',
        value: function setQueryString(e, qs) {
            var parsedQs = _queryString2.default.parse(qs);
            this.setParamsObj(parsedQs);
        }
    }, {
        key: 'handleSuccess',
        value: function handleSuccess(response) {
            this.isLoading = false;
            this.toggleLoading();
            this.$contentContainer.empty().html(response);
            this.$window.trigger('content:updated');
            this.$pages = this.$contentContainer.find('.js-content-page');
            this.$prevNextPage = this.$contentContainer.find('.js-content-page-prev-next');
            this.bindPageListeners();

            if (this.shouldFocused) {
                this.shouldFocused = false;

                var $card = this.$contentContainer.find('a').first();

                if ($card.length) {
                    $card.focus();
                }
            }

            this.$preloader.attr('aria-busy', false);
        }
    }, {
        key: 'handleError',
        value: function handleError(response) {
            console.log(response);
        }
    }, {
        key: 'toggleLoading',
        value: function toggleLoading() {
            this.$preloader.toggleClass('cfa-preloader--active', this.isLoading);
        }
    }, {
        key: 'selectFilterOption',
        value: function selectFilterOption() {
            if (!this.selectedOption) return;

            var optionType = this.selectedOption.data('type');

            if (optionType) {
                if ('scrollRestoration' in history) {
                    history.scrollRestoration = 'manual';
                }

                window.scroll(0, this.$element.offset().top - 70);
            }
        }
    }, {
        key: 'updateURLHash',
        value: function updateURLHash() {
            var parsedSearchString = _queryString2.default.parse(location.search);

            if (this.$contentFilter.length) {
                var optionType = this.selectedOption.data('type');

                if (optionType) {
                    parsedSearchString[this.$queryParameter] = optionType;
                } else {
                    delete parsedSearchString[this.$queryParameter];
                }
            }

            if (this.paramsObj.page) {
                parsedSearchString.page = this.paramsObj.page;
            } else {
                delete parsedSearchString.page;
            }

            var URL = location.pathname,
                convertedQuiery = _queryString2.default.stringify(parsedSearchString);

            if (convertedQuiery) {
                URL += '?' + convertedQuiery;
            }

            URL += location.hash;

            this.changeHistory(document.title, URL);
        }
    }, {
        key: 'updateBrowserAddress',
        value: function updateBrowserAddress() {
            if (this.browserAddressWay === 'transmit') {
                this.transmitQsObjectToBA();
            } else {
                this.updateURLHash();
            }
        }

        // use query parameters from this.paramsObj (it is used for ajax call) to generate query string in browser address

    }, {
        key: 'transmitQsObjectToBA',
        value: function transmitQsObjectToBA() {
            var qs = _queryString2.default.stringify(this.paramsObj);
            var browserQs = qs ? '?' + qs : '';
            var url = '' + window.location.pathname + browserQs;
            this.changeHistory(document.title, url);
        }
    }, {
        key: 'changeHistory',
        value: function changeHistory(title, url) {
            if (this.isPageChanged) {
                window.history.pushState({}, title, url);
            } else {
                window.history.replaceState({}, title, url);
            }

            this.isPageChanged = false;
        }
    }, {
        key: 'onPopstate',
        value: function onPopstate() {
            if (window.location.hash) {
                return;
            }
            var qs = document.location.search;
            var parsedQs = _queryString2.default.parse(qs);

            var page = parsedQs.page || 1;
            this.updatePageInParamsObj(page);
            this.fetchData();
        }
    }]);

    return ContentLoader;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.ContentPromo = function (_Snappy$BaseComponent) {
	_inherits(ContentPromo, _Snappy$BaseComponent);

	_createClass(ContentPromo, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-content-promo';
		}
	}]);

	function ContentPromo(element) {
		_classCallCheck(this, ContentPromo);

		return _possibleConstructorReturn(this, (ContentPromo.__proto__ || Object.getPrototypeOf(ContentPromo)).call(this, element));
	}

	_createClass(ContentPromo, [{
		key: 'render',
		value: function render() {
			this.setVars();
			this.setEventListeners();
		}
	}, {
		key: 'setVars',
		value: function setVars() {
			this.$anchorableElement = this.$element.find('.fa-content-promo__block-link');
			this.elementHasFocusClass = 'fa-content-promo--has-focus';
		}
	}, {
		key: 'setEventListeners',
		value: function setEventListeners() {
			this.$anchorableElement.on('mouseover focus', this.onElementFocusState.bind(this));
			this.$anchorableElement.on('mouseout focusout', this.onElementBlur.bind(this));
		}
	}, {
		key: 'onElementFocusState',
		value: function onElementFocusState() {
			this.$element.addClass(this.elementHasFocusClass);
		}
	}, {
		key: 'onElementBlur',
		value: function onElementBlur(event) {
			var toElement = event.toElement || event.relatedTarget;
			var toElementIsRelated = _jquery2.default.contains(this.$element[0], toElement);

			if (!toElementIsRelated) {
				this.$element.removeClass(this.elementHasFocusClass);
			}
		}
	}]);

	return ContentPromo;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _handlebars = __webpack_require__(21);

var _handlebars2 = _interopRequireDefault(_handlebars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.ContentPromoHero = function (_Snappy$BaseComponent) {
  _inherits(ContentPromoHero, _Snappy$BaseComponent);

  _createClass(ContentPromoHero, null, [{
    key: 'tagName',
    get: function get() {
      return 'fa-content-promo';
    }
  }]);

  function ContentPromoHero(element) {
    _classCallCheck(this, ContentPromoHero);

    return _possibleConstructorReturn(this, (ContentPromoHero.__proto__ || Object.getPrototypeOf(ContentPromoHero)).call(this, element));
  }

  _createClass(ContentPromoHero, [{
    key: 'render',
    value: function render() {}
  }]);

  return ContentPromoHero;
}(_snappy2.default.BaseComponent);

(0, _jquery2.default)(function () {

  function repositionTextbox() {
    var containerHeight = (0, _jquery2.default)('.fa-content-promo.fa-content-promo--hero').height();
    var textboxHeight = (0, _jquery2.default)('.fa-content-promo__content--colour-overlay').height();
    var offsetPosition = (parseInt(containerHeight) - parseInt(textboxHeight)) / 2 - 25;

    (0, _jquery2.default)('.fa-content-promo__content--colour-overlay').css({ "bottom": Math.abs(offsetPosition) });
  }

  repositionTextbox();
  (0, _jquery2.default)(window).resize(repositionTextbox);
});

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.ContentPromoVideo = function (_Snappy$BaseComponent) {
	_inherits(ContentPromoVideo, _Snappy$BaseComponent);

	_createClass(ContentPromoVideo, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-content-promo';
		}
	}]);

	function ContentPromoVideo(element) {
		_classCallCheck(this, ContentPromoVideo);

		// Resize video
		var _this = _possibleConstructorReturn(this, (ContentPromoVideo.__proto__ || Object.getPrototypeOf(ContentPromoVideo)).call(this, element));

		_this.scaleVideoContainer();
		_this.initBannerVideoSize('.video-container .poster img');
		_this.initBannerVideoSize('.video-container .filter');
		//this.initBannerVideoSize('.video-container video');

		// Video Pause/Play 
		var video = document.getElementById("bgvid");
		(0, _jquery2.default)(video).click(function (e) {
			var $this = (0, _jquery2.default)(e.target);
			video[video.paused ? 'play' : 'pause']();
			$this.prev().toggleClass('hidden');
			//console.log('Paused:' + $(video).prop('paused'))
		});

		(0, _jquery2.default)('.play-video').click(function (e) {
			var $this = (0, _jquery2.default)(e.target);
			video[video.paused ? 'play' : 'pause']();
			$this.addClass('hidden');
			//console.log('Paused:' + $(video).prop('paused'))
		});
		return _this;
	}

	_createClass(ContentPromoVideo, [{
		key: 'render',
		value: function render() {}
	}, {
		key: 'scaleVideoContainer',
		value: function scaleVideoContainer() {
			var height = (0, _jquery2.default)(window).height() - 129;
			var unitHeight = parseInt(height) + 'px';
			(0, _jquery2.default)('.fa-content-promo--videocomponent').css('height', unitHeight);
		}
	}, {
		key: 'initBannerVideoSize',
		value: function initBannerVideoSize(element) {
			(0, _jquery2.default)(element).each(function (e) {
				var $this = (0, _jquery2.default)(e.target);
				$this.data('height', (0, _jquery2.default)(this).height());
				$this.data('width', (0, _jquery2.default)(this).width());
			});

			this.scaleBannerVideoSize(element);
		}
	}, {
		key: 'scaleBannerVideoSize',
		value: function scaleBannerVideoSize(element) {
			var windowWidth = (0, _jquery2.default)(window).width(),
			    windowHeight = (0, _jquery2.default)(window).height(),
			    videoWidth,
			    videoHeight;

			//console.log(windowHeight);

			(0, _jquery2.default)(element).each(function () {
				var videoAspectRatio = (0, _jquery2.default)(this).height() / (0, _jquery2.default)(this).width(),
				    windowAspectRatio = windowHeight / windowWidth;

				if (videoAspectRatio > windowAspectRatio) {
					videoWidth = windowWidth;
					videoHeight = videoWidth * videoAspectRatio;
					(0, _jquery2.default)(this).css({ 'top': -(videoHeight - windowHeight) / 2 + 'px', 'margin-left': 0 });
				} else {
					videoHeight = windowHeight;
					videoWidth = videoHeight / videoAspectRatio;
					(0, _jquery2.default)(this).css({ 'margin-top': 0, 'margin-left': -(videoWidth - windowWidth) / 2 + 'px' });
				}

				(0, _jquery2.default)(this).width(videoWidth).height(videoHeight);
				(0, _jquery2.default)('.fa-content-promo--videocomponent .video-container video').addClass('fadeIn animated');
			});
		}
	}]);

	return ContentPromoVideo;
}(_snappy2.default.BaseComponent);

(0, _jquery2.default)(function () {
	var cwContentPromoVideo = new _snappy2.default.Component.ContentPromoVideo();
});

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.EnquiryForm = function (_Snappy$BaseComponent) {
    _inherits(EnquiryForm, _Snappy$BaseComponent);

    _createClass(EnquiryForm, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-enquiry-form';
        }
    }]);

    function EnquiryForm(element) {
        _classCallCheck(this, EnquiryForm);

        var _this = _possibleConstructorReturn(this, (EnquiryForm.__proto__ || Object.getPrototypeOf(EnquiryForm)).call(this, element));

        (0, _jquery2.default)(".scrollTo").on('click', function (e) {
            e.preventDefault();
            var target = (0, _jquery2.default)(this).attr('href');
            (0, _jquery2.default)('html, body').animate({
                scrollTop: (0, _jquery2.default)(target).offset().top - 150
            }, 800);
        });

        return _this;
    }

    _createClass(EnquiryForm, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.addEventListeners();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.submited = false;
            this.$form = this.$element.find('.fa-enquiry-form__form');
            this.$messageContainer = this.$element.find('.message-container');
            this.errorClass = 'fa-input-field--error';
            this.messageClass = 'fa-input-field__error-message';
            this.firstNameInput = document.getElementById("firstName-field");
            this.lastNameInput = document.getElementById('lastName-field');
            this.telephoneInput = document.getElementById('telephone-field');
            this.postcodeInput = document.getElementById('postcode-field');
            this.promoInput = document.getElementById('promo-field');
            this.companyInput = document.getElementById('company-field');
            this.emailInput = document.getElementById('email-field-main');
            this.formTextInputs = document.querySelectorAll('.fa-enquiry-form__form input[type=text]');
            this.formdropInputs = document.querySelectorAll('.fa-enquiry-form__form select');
            this.memberCircleInput = document.querySelectorAll('.fa-enquiry-form__checkboxArea input[type=checkbox]');
            this.ageInput = document.getElementById('gdprConsentField');
        }
    }, {
        key: 'addEventListeners',
        value: function addEventListeners() {
            this.$form.on('submit', this.onFormSubmission.bind(this));
            this.firstNameInput.addEventListener('keypress', this.restrictNumber.bind(this));
            this.lastNameInput.addEventListener('keypress', this.restrictNumber.bind(this));
            this.telephoneInput.addEventListener('keypress', this.restrictAlphabet.bind(this));
            this.postcodeInput.addEventListener('keypress', this.restrictSpecialChar.bind(this));
            this.companyInput.addEventListener('keypress', this.checkFirstSpace.bind(this));
            this.emailInput.addEventListener('keyup', this.emailValidation.bind(this));
            this.ageInput.addEventListener('change', this.checkboxError.bind(this));

            for (var i = 0; i < this.formTextInputs.length; i++) {
                this.formTextInputs[i].addEventListener('keyup', this.removeError.bind(this));
            }
            for (var _i = 0; _i < this.formdropInputs.length; _i++) {
                this.formdropInputs[_i].addEventListener('change', this.removeError.bind(this));
            }
            for (var _i2 = 0; _i2 < this.memberCircleInput.length; _i2++) {
                this.memberCircleInput[_i2].addEventListener('change', this.radioCheckError.bind(this));
            }
        }
    }, {
        key: 'removeError',
        value: function removeError(event) {
            if (this.submited) {
                if (event.target.parentElement.getElementsByClassName('fa-input-field__error-message')[0].innerHTML != '') {
                    if (event.target.value.length > 0 || event.target.value != '') {
                        if (event.target.classList.contains('error')) {
                            event.target.classList.remove('error');
                            event.target.parentElement.getElementsByClassName('fa-input-field__error-message')[0].style.display = 'none';
                        }
                    } else {
                        event.target.classList.add('error');
                        event.target.parentElement.getElementsByClassName('fa-input-field__error-message')[0].style.display = 'block';
                    }
                } else {
                    // console.log('falsr');
                }
            } else {
                    // console.log('falsr');
                }
        }
    }, {
        key: 'checkboxError',
        value: function checkboxError(event) {
            if (this.submited) {
                if (event.target.parentElement.getElementsByClassName('fa-input-field__error-message')[0].innerHTML != '') {
                    if (event.target.checked) {
                        event.target.classList.remove('error');
                        event.target.parentElement.getElementsByClassName('fa-input-field__error-message')[0].style.display = 'none';
                    } else {
                        event.target.classList.add('error');
                        event.target.parentElement.getElementsByClassName('fa-input-field__error-message')[0].style.display = 'block';
                    }
                } else {
                    // console.log('false');
                }
            } else {
                    // console.log('false');
                }
        }
    }, {
        key: 'radioCheckError',
        value: function radioCheckError(event) {
            if (this.submited) {
                var ele = (0, _jquery2.default)('.group-message-container').find(".fa-input-field__error-message");
                var checkLength = document.querySelectorAll('.fa-enquiry-form__checkboxArea__content input:checked').length;
                if (checkLength != 0) {
                    ele.css('display', 'none');
                } else {
                    ele.css('display', 'block');
                }
            } else {
                // console.log('falsr');
            }
        }
    }, {
        key: 'emailValidation',
        value: function emailValidation(evt) {
            if (this.submited) {
                var theEvent = evt || window.event;
                var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (regex.test(theEvent.target.value)) {
                    if (theEvent.target.classList.contains('error')) {
                        theEvent.target.classList.remove('error');
                        theEvent.target.parentElement.getElementsByClassName('fa-input-field__error-message')[0].style.display = 'none';
                    } else {
                        // console.log('falsr');
                    }
                } else {
                    theEvent.target.classList.add('error');
                    theEvent.target.parentElement.getElementsByClassName('fa-input-field__error-message')[0].style.display = 'block';
                }
            }
        }
    }, {
        key: 'restrictNumber',
        value: function restrictNumber(evt) {
            var theEvent = evt || window.event;
            var keyCode = theEvent.keyCode || theEvent.which;
            var key = String.fromCharCode(keyCode);
            var regex = /[0-9]|\./;
            var checkSpace = this.checkFirstSpace(evt, theEvent.target.value);
            if (checkSpace) {
                if (keyCode == 46) {

                    if (!regex.test(key)) {
                        theEvent.returnValue = false;
                        if (theEvent.preventDefault) {

                            theEvent.preventDefault();
                        } else {
                            // console.log('true');
                        }
                    } else {
                            //console.log('no regex');
                        }
                } else {
                    if (regex.test(key)) {
                        theEvent.returnValue = false;
                        if (theEvent.preventDefault) {
                            theEvent.preventDefault();
                        } else {
                            // console.log('true');
                        }
                    } else {
                            //console.log('no regex');
                        }
                }
            } else {
                    //console.log('entered space at first');
                }
        }
    }, {
        key: 'restrictAlphabet',
        value: function restrictAlphabet(evt) {
            var theEvent = evt || window.event;
            var keyCode = theEvent.keyCode || theEvent.which;
            var key = String.fromCharCode(keyCode);

            var regex = /[a-zA-Z]|\./;
            var checkSpace = this.checkFirstSpace(evt, theEvent.target.value);
            if (checkSpace) {
                if (keyCode == 46) {

                    if (!regex.test(key)) {
                        theEvent.returnValue = false;
                        if (theEvent.preventDefault) {

                            theEvent.preventDefault();
                        } else {
                            // console.log('true');
                        }
                    } else {
                            //console.log('no regex');
                        }
                } else {
                    if (regex.test(key)) {
                        theEvent.returnValue = false;
                        if (theEvent.preventDefault) {
                            theEvent.preventDefault();
                        } else {
                            // console.log('true');
                        }
                    } else {
                            //console.log('no regex');
                        }
                }
            } else {
                    // console.log('entered space at first');
                }
        }
    }, {
        key: 'restrictSpecialChar',
        value: function restrictSpecialChar(evt) {
            var theEvent = evt || window.event;
            var key = theEvent.keyCode || theEvent.which;
            var keyCode = theEvent.keyCode || theEvent.which;
            key = String.fromCharCode(keyCode);
            var regex = /[a-zA-Z0-9 ]|\./;
            var checkSpace = this.checkFirstSpace(evt, theEvent.target.value);
            if (checkSpace) {
                if (keyCode == 46) {
                    if (regex.test(key)) {
                        theEvent.returnValue = false;
                        if (theEvent.preventDefault) {
                            theEvent.preventDefault();
                        } else {
                            // console.log('true');
                        }
                    } else {
                            //  console.log('no regex');
                        }
                } else {
                    if (!regex.test(key)) {
                        theEvent.returnValue = false;
                        if (theEvent.preventDefault) {
                            theEvent.preventDefault();
                        } else {
                            // console.log('true');
                        }
                    } else {
                            //  console.log('no regex');
                        }
                }
            } else {
                    // console.log('entered space at first');
                }
        }
    }, {
        key: 'checkFirstSpace',
        value: function checkFirstSpace(evt) {
            var theEvent = evt || window.event;
            var key = theEvent.keyCode || theEvent.which;

            if (key == 32 && theEvent.target.value.length <= 0) {
                theEvent.preventDefault();
                return false;
            } else {
                return true;
            }
        }
    }, {
        key: 'restrictFirstSpl',
        value: function restrictFirstSpl(evt) {
            var theEvent = evt || window.event;
            var key = theEvent.keyCode || theEvent.which;
            key = String.fromCharCode(key);
            var regex = /[a-zA-Z0-9]|\./;
            if (theEvent.target.value.length <= 0) {
                if (!regex.test(key)) {
                    theEvent.returnValue = false;
                    if (theEvent.preventDefault) {
                        theEvent.preventDefault();
                    } else {
                        //console.log('true');
                    }
                } else {
                        //console.log('no regex');
                    }
            } else {
                    // console.log('true reg');
                }
        }
    }, {
        key: 'onFormSubmission',
        value: function onFormSubmission(event) {

            event.preventDefault();
            this.submited = true;
            // check if recaptcha is valid
            var captachFlag = this.isRecaptchaValid();
            if (captachFlag) {
                (0, _jquery2.default)('html, body').animate({
                    scrollTop: (0, _jquery2.default)('.fa-enquiry-form__captcha-wrap').offset().top - 100
                }, 800);
                (0, _jquery2.default)(".loading-message-wrapper").delay(500).queue(function (next) {
                    (0, _jquery2.default)(this).removeClass('show').addClass('hide');
                    next();
                });
                return;
            }

            var innerCircleBool = false;
            if ((0, _jquery2.default)('#membership_Inner_Circle') && (0, _jquery2.default)('#membership_Inner_Circle:checked').length !== 0) {
                innerCircleBool = true;
            }

            var bobbyMooreBool = false;
            if ((0, _jquery2.default)('#membership_Bobby-Moore') && (0, _jquery2.default)('#membership_Bobby-Moore:checked').length !== 0) {
                bobbyMooreBool = true;
            }

            var membership_Centre_CircleBool = false;
            if ((0, _jquery2.default)('#membership_Centre_Circle') && (0, _jquery2.default)('#membership_Centre_Circle:checked').length !== 0) {
                membership_Centre_CircleBool = true;
            }

            var oneTwentyBool = false;
            if ((0, _jquery2.default)('#membership_One_Twenty') && (0, _jquery2.default)('#membership_One_Twenty:checked').length !== 0) {
                oneTwentyBool = true;
            }

            var membership_No9Bool = false;
            if ((0, _jquery2.default)('#membership_No9') && (0, _jquery2.default)('#membership_No9:checked').length !== 0) {
                membership_No9Bool = true;
            }

            var privateBoxBool = false;
            var privateBoxNumber = "";
            if ((0, _jquery2.default)('#membership_Private_Boxes') && (0, _jquery2.default)('#membership_Private_Boxes:checked').length !== 0) {
                privateBoxBool = true;
                if ((0, _jquery2.default)('#seats-field') && (0, _jquery2.default)('#seats-field option:selected').length !== 0) {
                    privateBoxNumber = (0, _jquery2.default)('#seats-field option:selected').val();
                }
            }

            // if ($('#membership_0') && $('#membership_0:checked').length !== 0) {
            //     oneTwentyBool = true;
            //     bobbyMooreBool = true;
            //     innerCircleBool = true;
            //     //privateBoxBool = true;
            //     membership_Centre_CircleBool = true;
            //     membership_No9Bool = true;
            // }

            var eventsInterest = "";
            if ((0, _jquery2.default)('#event-title')) {
                eventsInterest = (0, _jquery2.default)("#event-title :selected").text();
                if ((0, _jquery2.default)("#event-title :selected").val() == "0") {
                    eventsInterest = "";
                }
            }

            var offersUpdatesFieldVal = false;
            if ((0, _jquery2.default)('#offersUpdatesField') && (0, _jquery2.default)('#offersUpdatesField:checked').length !== 0) {
                offersUpdatesFieldVal = true;
            }

            var gdprConsentField = false;
            if ((0, _jquery2.default)('#gdprConsentField') && (0, _jquery2.default)('#gdprConsentField:checked').length !== 0) {
                gdprConsentField = true;
            }

            var preferredContactEmail = false;
            if ((0, _jquery2.default)('#email-contact') && (0, _jquery2.default)('#email-contact:checked').length !== 0) {
                preferredContactEmail = true;
            }

            var preferredContactPhone = false;
            if ((0, _jquery2.default)('#phone-contact') && (0, _jquery2.default)('#phone-contact:checked').length !== 0) {
                preferredContactPhone = true;
            }

            var ele = (0, _jquery2.default)('.group-message-container').find(".fa-input-field__error-message");
            if (innerCircleBool || bobbyMooreBool || oneTwentyBool || membership_Centre_CircleBool || membership_No9Bool || privateBoxBool) {
                ele.css('display', 'none');
            } else {
                ele.css('display', 'block');
            }

            var requestAuthorizationToken = (0, _jquery2.default)("#antiforgerytoken").val();
            var recaptchaVal = (0, _jquery2.default)("#g-recaptcha-response").val();

            var formData = {
                Title: { FieldName: "titleField", FieldValue: (0, _jquery2.default)("#title-field :selected").val() },
                FirstName: { FieldName: "firstNameField", FieldValue: (0, _jquery2.default)("#firstName-field").val() },
                LastName: { FieldName: "lastNameField", FieldValue: (0, _jquery2.default)("#lastName-field").val() },
                EmailAddress: { FieldName: "emailField", FieldValue: (0, _jquery2.default)("#email-field-main").val() },
                PhoneNumber: { FieldName: "telephoneField", FieldValue: (0, _jquery2.default)("#telephone-field").val() },
                Company: { FieldName: "companyField", FieldValue: (0, _jquery2.default)("#company-field").val() },
                Enquiry: { FieldName: "enquiryField", FieldValue: (0, _jquery2.default)("#enquiry-field").val() },
                AgeRange: { FieldName: "ageField", FieldValue: (0, _jquery2.default)("#age-field :selected").val() },
                Club: { FieldName: "teamField", FieldValue: (0, _jquery2.default)("#team-field :selected").val() },
                Postcode: { FieldName: "postcodeField", FieldValue: (0, _jquery2.default)("#postcode-field").val() },
                PromotionalCode: { FieldName: "promoField", FieldValue: (0, _jquery2.default)("#promo-field").val() },
                InnerCircle: innerCircleBool,
                BobbyMoore: bobbyMooreBool,
                OneTwenty: oneTwentyBool,
                CentreCircle: membership_Centre_CircleBool,
                No9: membership_No9Bool,
                PrivateBox: privateBoxBool,
                PrivateBoxNumber: { FieldName: "seatsField", FieldValue: privateBoxNumber },
                EventsInterest: { FieldName: "eventTitleField", FieldValue: eventsInterest },
                ReceiveOffers: offersUpdatesFieldVal,
                PreferredContactEmail: preferredContactEmail,
                PreferredContactPhone: preferredContactPhone,
                GDPRConsent: gdprConsentField,
                GRecaptchaResponse: recaptchaVal
            };

            var requiredFields = {
                title: 'titleField',
                postcodeField: 'postcodeField',
                firstNameField: 'firstNameField',
                lastNameField: 'lastNameField',
                ageField: 'ageField',
                emailField: 'emailField',
                telephoneField: 'telephoneField',
                gdprConsentField: "gdprConsentField"

            };

            var count = 0;
            var keysLength = Object.keys(requiredFields).length;
            // add errors to all required fields
            Object.keys(requiredFields).forEach(function (key) {
                var fieldName = document.getElementsByName('' + requiredFields[key]);

                for (var i = 0; i < fieldName.length; i++) {
                    var str = '';
                    if (fieldName[i].parentElement.getElementsByClassName('fa-dropdown__label') && fieldName[i].parentElement.getElementsByClassName('fa-dropdown__label').length > 0) {
                        str = fieldName[i].parentElement.getElementsByClassName('fa-dropdown__label')[0].innerHTML;
                        str = str.toString().replace(/[^a-zA-Z ]/g, "");
                    }
                    if (fieldName[i].parentElement.getElementsByClassName('fa-input-field__label') && fieldName[i].parentElement.getElementsByClassName('fa-input-field__label').length > 0) {
                        str = fieldName[i].parentElement.getElementsByClassName('fa-input-field__label')[0].innerHTML;
                        str = str.toString().replace(/[^a-zA-Z ]/g, "");
                    }
                    if (requiredFields[key] === 'gdprConsentField') {
                        var consentEle = document.getElementsByClassName("margin-top-3")[0];
                        var policyEle = document.getElementsByClassName("policy-para")[0];
                        console.log("in if :", consentEle);
                        if (fieldName[i].checked === false) {
                            count++;
                            if (requiredFields[key] == 'gdprConsentField') {
                                if (consentEle) {
                                    if (screen.width <= 767) {
                                        consentEle.style.marginTop = '13%';
                                    } else if (screen.width > 767 && screen.width <= 992) {
                                        consentEle.style.marginTop = '5%';
                                    } else {
                                        consentEle.style.marginTop = '3%';
                                    }
                                }
                                fieldName[i].parentElement.getElementsByClassName('fa-input-field__error-message')[0].textContent = 'Please confirm your age';
                            }

                            fieldName[i].parentElement.getElementsByClassName('fa-input-field__error-message')[0].style.display = 'block';
                        } else {
                            if (fieldName[i].checked && requiredFields[key] == 'gdprConsentField') {
                                if (consentEle) {
                                    if (screen.width <= 767) {
                                        consentEle.style.marginTop = '7%';
                                    } else if (screen.width > 767 && screen.width <= 992) {
                                        consentEle.style.marginTop = '2%';
                                    } else {
                                        consentEle.style.marginTop = '5px';
                                    }
                                }
                            }

                            fieldName[i].classList.remove('error');
                            fieldName[i].parentElement.getElementsByClassName('fa-input-field__error-message')[0].textContent = '';
                            fieldName[i].parentElement.getElementsByClassName('fa-input-field__error-message')[0].style.display = 'none';
                        }
                    } else {
                        if (fieldName[i].value === '') {
                            count++;
                            fieldName[i].classList.add('error');
                            fieldName[i].parentElement.getElementsByClassName('fa-input-field__error-message')[0].textContent = 'Please enter your ' + str.toLocaleLowerCase();
                            fieldName[i].parentElement.getElementsByClassName('fa-input-field__error-message')[0].style.display = 'block';
                        } else {
                            fieldName[i].classList.remove('error');
                            fieldName[i].parentElement.getElementsByClassName('fa-input-field__error-message')[0].textContent = '';
                            fieldName[i].parentElement.getElementsByClassName('fa-input-field__error-message')[0].style.display = 'none';
                        }
                    }
                }
            });
            if (!captachFlag) {
                if (oneTwentyBool || bobbyMooreBool || innerCircleBool || membership_Centre_CircleBool || membership_No9Bool || privateBoxBool) {
                    if (count == 0) {
                        console.log("formData : ", formData);
                        var emailTemp = false;
                        var emailEle = (0, _jquery2.default)('.cw-new-theme #email-field-main');
                        if ((0, _jquery2.default)('.cw-new-theme #email-field-main') && (0, _jquery2.default)('.cw-new-theme #email-field-main').val()) {
                            var expr = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                            emailTemp = expr.test((0, _jquery2.default)('.cw-new-theme #email-field-main').val());
                        }
                        if (emailTemp) {
                            emailEle.removeClass('error');
                            emailEle.parent().find(".fa-input-field__error-message").text("");
                            emailEle.parent().find(".fa-input-field__error-message").css('display', 'none');_jquery2.default.ajax({
                                beforeSend: function beforeSend() {
                                    (0, _jquery2.default)('.loading-message-wrapper').removeClass('hide').addClass('show');
                                },
                                url: this.formAction = this.$form.attr('action'),
                                method: this.formMethod = this.$form.attr('method'),
                                data: this.formData = formData,
                                headers: {
                                    'RequestVerificationToken': requestAuthorizationToken
                                }
                            }).always(this.handleValidationResponse.bind(this));
                        } else {
                            (0, _jquery2.default)('html, body').animate({
                                scrollTop: (0, _jquery2.default)('.cw-new-theme #email-field-main').offset().top - 100
                            }, 800);
                            emailEle.addClass('error');
                            emailEle.parent().find(".fa-input-field__error-message").text("Please enter your email");
                            emailEle.parent().find(".fa-input-field__error-message").css('display', 'block');
                            (0, _jquery2.default)(".loading-message-wrapper").delay(500).queue(function (next) {
                                (0, _jquery2.default)(this).removeClass('show').addClass('hide');
                                next();
                            });
                        }
                    } else {
                        this.scrollToFromTitle();
                    }
                } else {
                    this.scrollToFromTitle();
                }
            } else {
                (0, _jquery2.default)('html, body').animate({
                    scrollTop: (0, _jquery2.default)('.fa-enquiry-form__captcha-wrap').offset().top - 100
                }, 800);
                (0, _jquery2.default)(".loading-message-wrapper").delay(500).queue(function (next) {
                    (0, _jquery2.default)(this).removeClass('show').addClass('hide');
                    next();
                });
            }
        }
    }, {
        key: 'scrollToFromTitle',
        value: function scrollToFromTitle() {
            (0, _jquery2.default)('html, body').animate({
                scrollTop: (0, _jquery2.default)('.form-title').offset().top
            }, 800);
            (0, _jquery2.default)(".loading-message-wrapper").delay(500).queue(function (next) {
                (0, _jquery2.default)(this).removeClass('show').addClass('hide');
                next();
            });
        }
    }, {
        key: 'handleValidationResponse',
        value: function handleValidationResponse(response) {
            console.log("errors", response);
            // this.hideAllValidationErrors();
            (0, _jquery2.default)(".loading-message-wrapper").delay(500).queue(function (next) {
                (0, _jquery2.default)(this).removeClass('show').addClass('hide');
                next();
            });
            var newele2 = (0, _jquery2.default)(".error-message--backend");
            if (response.success) {
                if (newele2) {
                    newele2.css("display", "none");
                }
                this.handleSuccess(response);
            } else if (response && response.success == false) {
                if (newele2) {
                    newele2.css("display", "block");
                    if (response.fields && response.fields.length > 0) {
                        newele2.text(response.fields[0].Reason);
                    }
                }
            }
        }
    }, {
        key: 'hideAllValidationErrors',
        value: function hideAllValidationErrors() {
            (0, _jquery2.default)(".fa-input-field--error").each(function () {
                (0, _jquery2.default)(this).removeClass("fa-input-field--error");
            });
        }
    }, {
        key: 'showValidationError',
        value: function showValidationError(field) {
            var $element = this.$form.find('[name=' + field.FieldName + ']');
            $element.addClass(this.errorClass).parent().addClass(this.errorClass).find('.' + this.messageClass).text(field.Reason);
        }
    }, {
        key: 'removeValidationError',
        value: function removeValidationError(field) {
            var $element = this.$form.find('[name=' + field.element + ']');

            $element.removeClass(this.errorClass).parent().removeClass(this.errorClass).find('.' + this.messageClass).text('');
        }
    }, {
        key: 'handleSuccess',
        value: function handleSuccess(response) {
            var domain = document.location.origin;
            dataLayer.push({ 'crmUserId': response.CrmUserId });
            dataLayer.push({ 'thankYouURL': window.location.href + '/thankyou' });
            window.location.replace(domain + "/experiences/enquiry/confirmation");
            // window.location.replace(window.location.href + "/confirmation");
        }
    }, {
        key: 'isRecaptchaValid',
        value: function isRecaptchaValid() {
            var recaptcha = (0, _jquery2.default)("#g-recaptcha-response").val();
            var recaptchaError = document.querySelectorAll('.recaptcha-error')[0];
            var captchBool = false;
            if (recaptcha === "") {
                recaptchaError.innerHTML = 'Please check the recaptcha';
                recaptchaError.style.display = 'block';
                captchBool = true;
            } else {
                recaptchaError.style.display = 'none';
                captchBool = false;
            }
            return captchBool;
        }
    }, {
        key: 'resetForm',
        value: function resetForm() {
            this.$form.find('input, select, textarea').each(function (i, element) {
                element.value = '';
            });
        }
    }]);

    return EnquiryForm;
}(_snappy2.default.BaseComponent);

(0, _jquery2.default)(function () {
    var cwEnquiryForm = new _snappy2.default.Component.EnquiryForm();
    var consentEle = document.getElementsByClassName("margin-top-3")[0];
    var policyEle = document.getElementsByClassName("policy-para")[0];
    if (consentEle) {
        if (screen.width <= 767) {
            consentEle.style.marginTop = '7%';
        } else if (screen.width > 767 && screen.width <= 992) {
            consentEle.style.marginTop = '2%';
        } else {
            consentEle.style.marginTop = '5px';
        }
    }
    if (policyEle) {
        if (screen.width <= 767) {
            policyEle.style.marginTop = '5%';
            policyEle.style.marginBottom = '4%';
        } else if (screen.width > 767 && screen.width <= 992) {
            policyEle.style.marginTop = '3%';
            policyEle.style.marginBottom = '4%';
        } else {
            policyEle.style.marginTop = '5px';
        }
    }
    // $('#membership_0').change(function() {
    //     if ($(this).is(":checked")) {
    //         $('.membershipCheckbox').each(function() {
    //             $(this).prop('checked', false);
    //         });
    //     }
    // });

    // $('.membershipCheckbox').change(function() {
    //     if ($(this).hasClass("nonDefault")) {
    //         if ($(this).is(":checked")) {
    //             $('#membership_0').prop('checked', false);
    //         }
    //     }
    // });

    (0, _jquery2.default)('#membership_Private_Boxes').change(function () {
        (0, _jquery2.default)('#fa-dropdown--seats').toggleClass("hide");
    });

    //Event Dropdown
    var defaultDescription = (0, _jquery2.default)('ul.fa-dropdown-content li.description-default');
    var eventDescription = (0, _jquery2.default)('ul.fa-dropdown-content li.description');

    (0, _jquery2.default)(eventDescription).hide();
    (0, _jquery2.default)(defaultDescription).show();

    (0, _jquery2.default)('.fa-dropdown select#event-title').change(function () {
        (0, _jquery2.default)(defaultDescription).hide();
        (0, _jquery2.default)(eventDescription).hide();
        (0, _jquery2.default)('#' + this.value).show();

        if ((0, _jquery2.default)(this).val() == '0') {
            (0, _jquery2.default)(defaultDescription).show();
        }
    });
});

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.HospitalityEnquiryForm = function (_Snappy$BaseComponent) {
    _inherits(HospitalityEnquiryForm, _Snappy$BaseComponent);

    _createClass(HospitalityEnquiryForm, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-hospitality-enquiry-form';
        }
    }]);

    function HospitalityEnquiryForm(element) {
        _classCallCheck(this, HospitalityEnquiryForm);

        var _this = _possibleConstructorReturn(this, (HospitalityEnquiryForm.__proto__ || Object.getPrototypeOf(HospitalityEnquiryForm)).call(this, element));

        (0, _jquery2.default)(".scrollTo").on('click', function (e) {
            e.preventDefault();
            var target = (0, _jquery2.default)(this).attr('href');
            (0, _jquery2.default)('html, body').animate({
                scrollTop: (0, _jquery2.default)(target).offset().top - 150
            }, 800);

            var packageId = (0, _jquery2.default)(this).attr('name');
            (0, _jquery2.default)(".packageCheckbox").each(function (i, val) {
                (0, _jquery2.default)(this).prop('checked', val.name.toLowerCase() == "package_{" + packageId + "}");
            });
        });
        return _this;
    }

    _createClass(HospitalityEnquiryForm, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.addEventListeners();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.submited = false;
            this.$form = this.$element.find('.fa-hospitality-enquiry-form__form');
            this.$messageContainer = this.$element.find('.message-container');
            this.errorClass = 'fa-input-field--error';
            this.messageClass = 'fa-input-field__error-message';
            this.firstNameInput = document.getElementById("firstName-field");
            this.lastNameInput = document.getElementById('lastName-field');
            this.telephoneInput = document.getElementById('telephone-field');
            this.postcodeInput = document.getElementById('postcode-field');
            this.emailInput = document.getElementById('email-field-main');
            this.formTextInputs = document.querySelectorAll('.fa-hospitality-enquiry-form__form input[type=text]');
            this.formdropInputs = document.querySelectorAll('.fa-hospitality-enquiry-form__form select');
            this.memberCircleInput = document.querySelectorAll('.fa-hospitality-enquiry-form__checkboxArea input[type=checkbox]');
            this.ageInput = document.getElementById('gdprConsentField');
        }
    }, {
        key: 'addEventListeners',
        value: function addEventListeners() {
            this.$form.on('submit', this.onFormSubmission.bind(this));
            this.firstNameInput.addEventListener('keypress', this.restrictNumber.bind(this));
            this.lastNameInput.addEventListener('keypress', this.restrictNumber.bind(this));
            this.telephoneInput.addEventListener('keypress', this.restrictAlphabet.bind(this));
            this.postcodeInput.addEventListener('keypress', this.restrictSpecialChar.bind(this));
            this.emailInput.addEventListener('keyup', this.emailValidation.bind(this));
            this.ageInput.addEventListener('change', this.checkboxError.bind(this));

            for (var i = 0; i < this.formTextInputs.length; i++) {
                this.formTextInputs[i].addEventListener('keyup', this.removeError.bind(this));
            }

            for (var _i = 0; _i < this.formdropInputs.length; _i++) {
                this.formdropInputs[_i].addEventListener('change', this.removeError.bind(this));
            }

            for (var _i2 = 0; _i2 < this.memberCircleInput.length; _i2++) {
                this.memberCircleInput[_i2].addEventListener('change', this.radioCheckError.bind(this));
            }
        }
    }, {
        key: 'removeError',
        value: function removeError(event) {
            if (this.submited) {
                if (event.target.parentElement.getElementsByClassName('fa-input-field__error-message')[0].innerHTML != '') {
                    if (event.target.value.length > 0 || event.target.value != '') {
                        if (event.target.classList.contains('error')) {
                            event.target.classList.remove('error');
                            event.target.parentElement.getElementsByClassName('fa-input-field__error-message')[0].style.display = 'none';
                        }
                    } else {
                        event.target.classList.add('error');
                        event.target.parentElement.getElementsByClassName('fa-input-field__error-message')[0].style.display = 'block';
                    }
                } else {
                    // console.log('falsr');
                }
            } else {
                    // console.log('falsr');
                }
        }
    }, {
        key: 'checkboxError',
        value: function checkboxError(event) {
            if (this.submited) {
                if (event.target.parentElement.getElementsByClassName('fa-input-field__error-message')[0].innerHTML != '') {
                    if (event.target.checked) {
                        event.target.classList.remove('error');
                        event.target.parentElement.getElementsByClassName('fa-input-field__error-message')[0].style.display = 'none';
                    } else {
                        event.target.classList.add('error');
                        event.target.parentElement.getElementsByClassName('fa-input-field__error-message')[0].style.display = 'block';
                    }
                } else {
                    // console.log('false');
                }
            } else {
                    // console.log('false');
                }
        }
    }, {
        key: 'radioCheckError',
        value: function radioCheckError(event) {
            if (this.submited) {
                var ele = (0, _jquery2.default)('.group-message-container').find(".fa-input-field__error-message");
                var checkLength = document.querySelectorAll('.fa-hospitality-enquiry-form__checkboxArea__content input:checked').length;
                if (checkLength != 0) {
                    ele.css('display', 'none');
                } else {
                    ele.css('display', 'block');
                }
            } else {
                // console.log('falsr');
            }
        }
    }, {
        key: 'emailValidation',
        value: function emailValidation(evt) {
            if (this.submited) {
                var theEvent = evt || window.event;
                var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (regex.test(theEvent.target.value)) {
                    if (theEvent.target.classList.contains('error')) {
                        theEvent.target.classList.remove('error');
                        theEvent.target.parentElement.getElementsByClassName('fa-input-field__error-message')[0].style.display = 'none';
                    } else {
                        // console.log('falsr');
                    }
                } else {
                    theEvent.target.classList.add('error');
                    theEvent.target.parentElement.getElementsByClassName('fa-input-field__error-message')[0].style.display = 'block';
                }
            }
        }
    }, {
        key: 'restrictNumber',
        value: function restrictNumber(evt) {
            var theEvent = evt || window.event;
            var keyCode = theEvent.keyCode || theEvent.which;
            var key = String.fromCharCode(keyCode);
            var regex = /[0-9]|\./;
            var checkSpace = this.checkFirstSpace(evt, theEvent.target.value);
            if (checkSpace) {
                if (keyCode == 46) {

                    if (!regex.test(key)) {
                        theEvent.returnValue = false;
                        if (theEvent.preventDefault) {

                            theEvent.preventDefault();
                        } else {
                            // console.log('true');
                        }
                    } else {
                            //console.log('no regex');
                        }
                } else {
                    if (regex.test(key)) {
                        theEvent.returnValue = false;
                        if (theEvent.preventDefault) {

                            theEvent.preventDefault();
                        } else {
                            // console.log('true');
                        }
                    } else {
                            //console.log('no regex');
                        }
                }
            } else {
                    //console.log('entered space at first');
                }
        }
    }, {
        key: 'restrictAlphabet',
        value: function restrictAlphabet(evt) {
            var theEvent = evt || window.event;
            var keyCode = theEvent.keyCode || theEvent.which;
            var key = String.fromCharCode(keyCode);

            var regex = /[a-zA-Z]|\./;
            var checkSpace = this.checkFirstSpace(evt, theEvent.target.value);
            if (checkSpace) {
                if (keyCode == 46) {

                    if (!regex.test(key)) {
                        theEvent.returnValue = false;
                        if (theEvent.preventDefault) {

                            theEvent.preventDefault();
                        } else {
                            // console.log('true');
                        }
                    } else {
                            //console.log('no regex');
                        }
                } else {
                    if (regex.test(key)) {
                        theEvent.returnValue = false;
                        if (theEvent.preventDefault) {

                            theEvent.preventDefault();
                        } else {
                            // console.log('true');
                        }
                    } else {
                            //console.log('no regex');
                        }
                }
            } else {
                    // console.log('entered space at first');
                }
        }
    }, {
        key: 'restrictSpecialChar',
        value: function restrictSpecialChar(evt) {
            var theEvent = evt || window.event;
            var key = theEvent.keyCode || theEvent.which;
            var keyCode = theEvent.keyCode || theEvent.which;
            key = String.fromCharCode(keyCode);
            var regex = /[a-zA-Z0-9 ]|\./;
            var checkSpace = this.checkFirstSpace(evt, theEvent.target.value);
            if (checkSpace) {
                if (keyCode == 46) {
                    if (regex.test(key)) {
                        theEvent.returnValue = false;
                        if (theEvent.preventDefault) {
                            theEvent.preventDefault();
                        } else {
                            // console.log('true');
                        }
                    } else {
                            //  console.log('no regex');
                        }
                } else {
                    if (!regex.test(key)) {
                        theEvent.returnValue = false;
                        if (theEvent.preventDefault) {
                            theEvent.preventDefault();
                        } else {
                            // console.log('true');
                        }
                    } else {
                            //  console.log('no regex');
                        }
                }
            } else {
                    // console.log('entered space at first');
                }
        }
    }, {
        key: 'checkFirstSpace',
        value: function checkFirstSpace(evt) {
            var theEvent = evt || window.event;
            var key = theEvent.keyCode || theEvent.which;

            if (key == 32 && theEvent.target.value.length <= 0) {
                theEvent.preventDefault();
                return false;
            } else {
                return true;
            }
        }
    }, {
        key: 'restrictFirstSpl',
        value: function restrictFirstSpl(evt) {
            var theEvent = evt || window.event;
            var key = theEvent.keyCode || theEvent.which;
            key = String.fromCharCode(key);
            var regex = /[a-zA-Z0-9]|\./;
            if (theEvent.target.value.length <= 0) {
                if (!regex.test(key)) {
                    theEvent.returnValue = false;
                    if (theEvent.preventDefault) {
                        theEvent.preventDefault();
                    } else {
                        //console.log('true');
                    }
                } else {
                        //console.log('no regex');
                    }
            } else {
                    // console.log('true reg');
                }
        }
    }, {
        key: 'onFormSubmission',
        value: function onFormSubmission(event) {

            event.preventDefault();
            this.submited = true;

            var offersUpdatesFieldVal = false;
            if ((0, _jquery2.default)('#offersUpdatesField') && (0, _jquery2.default)('#offersUpdatesField:checked').length !== 0) {
                offersUpdatesFieldVal = true;
            }
            var gdprConsentField = false;
            if ((0, _jquery2.default)('#gdprConsentField') && (0, _jquery2.default)('#gdprConsentField:checked').length !== 0) {
                gdprConsentField = true;
            }

            var nflFieldVal = false;
            if ((0, _jquery2.default)('#nflField') && (0, _jquery2.default)('#nflField:checked').length !== 0) {
                nflFieldVal = true;
            }
            var ele1 = (0, _jquery2.default)('.group-message-container').find(".fa-input-field__error-message");
            if ((0, _jquery2.default)('.packageCheckbox') && (0, _jquery2.default)('.packageCheckbox:checked').length !== 0) {
                ele1.css('display', 'none');
            } else {
                ele1.css('display', 'block');
            }
            var formData = {
                Title: { FieldName: "titleField", FieldValue: (0, _jquery2.default)("#title-field :selected").val() },
                FirstName: { FieldName: "firstNameField", FieldValue: (0, _jquery2.default)("#firstName-field").val() },
                LastName: { FieldName: "lastNameField", FieldValue: (0, _jquery2.default)("#lastName-field").val() },
                EmailAddress: { FieldName: "emailField", FieldValue: (0, _jquery2.default)("#email-field-main").val() },
                PhoneNumber: { FieldName: "telephoneField", FieldValue: (0, _jquery2.default)("#telephone-field").val() },
                Enquiry: { FieldName: "enquiryField", FieldValue: (0, _jquery2.default)("#enquiry-field").val() },
                AgeRange: { FieldName: "ageField", FieldValue: (0, _jquery2.default)("#age-field :selected").val() },
                Club: { FieldName: "teamField", FieldValue: (0, _jquery2.default)("#team-field :selected").val() },
                Postcode: { FieldName: "postcodeField", FieldValue: (0, _jquery2.default)("#postcode-field").val() },
                EventsInterest: { FieldName: "eventsInterest", FieldValue: (0, _jquery2.default)("#hidEventName").val() },
                PackageInterest: { FieldName: "packageInterest", FieldValue: (0, _jquery2.default)("input.packageCheckbox:checked").val() },
                ReceiveOffers: offersUpdatesFieldVal,
                NFLConsent: nflFieldVal,
                GDPRConsent: gdprConsentField
            };

            var requiredFieldse = {
                title: 'titleField',
                postcodeField: 'postcodeField',
                firstNameField: 'firstNameField',
                lastNameField: 'lastNameField',
                ageField: 'ageField',
                emailField: 'emailField',
                telephoneField: 'telephoneField',
                packageCheckbox: 'packageCheckbox',
                gdprConsentField: "gdprConsentField"

            };

            var count = 0;
            var keysLength = Object.keys(requiredFieldse).length;
            // add errors to all required fields
            Object.keys(requiredFieldse).forEach(function (key) {
                var fieldName = document.getElementsByName('' + requiredFieldse[key]);

                for (var i = 0; i < fieldName.length; i++) {
                    var str = '';
                    if (fieldName[i].parentElement.getElementsByClassName('fa-dropdown__label') && fieldName[i].parentElement.getElementsByClassName('fa-dropdown__label').length > 0) {
                        str = fieldName[i].parentElement.getElementsByClassName('fa-dropdown__label')[0].innerHTML;
                        str = str.toString().replace(/[^a-zA-Z ]/g, "");
                    }
                    if (fieldName[i].parentElement.getElementsByClassName('fa-input-field__label') && fieldName[i].parentElement.getElementsByClassName('fa-input-field__label').length > 0) {
                        str = fieldName[i].parentElement.getElementsByClassName('fa-input-field__label')[0].innerHTML;
                        str = str.toString().replace(/[^a-zA-Z ]/g, "");
                    }

                    if (requiredFieldse[key] === 'gdprConsentField') {
                        var consentEle2 = document.getElementsByClassName("margin-top-3")[0];
                        var policyEle2 = document.getElementsByClassName("policy-para")[0];
                        console.log("in if :", consentEle2);
                        if (fieldName[i].checked === false) {
                            count++;
                            if (requiredFieldse[key] == 'gdprConsentField') {
                                if (consentEle2) {
                                    if (screen.width <= 767) {
                                        consentEle2.style.marginTop = '13%';
                                    } else if (screen.width > 767 && screen.width <= 992) {
                                        consentEle2.style.marginTop = '5%';
                                    } else {
                                        consentEle2.style.marginTop = '3%';
                                    }
                                }
                                fieldName[i].parentElement.getElementsByClassName('fa-input-field__error-message')[0].textContent = 'Please confirm your age';
                            }

                            fieldName[i].parentElement.getElementsByClassName('fa-input-field__error-message')[0].style.display = 'block';
                        } else {
                            if (fieldName[i].checked && requiredFieldse[key] == 'gdprConsentField') {
                                if (consentEle2) {
                                    if (screen.width <= 767) {
                                        consentEle2.style.marginTop = '7%';
                                    } else if (screen.width > 767 && screen.width <= 992) {
                                        consentEle2.style.marginTop = '2%';
                                    } else {
                                        consentEle2.style.marginTop = '5px';
                                    }
                                }
                            }

                            fieldName[i].classList.remove('error');
                            fieldName[i].parentElement.getElementsByClassName('fa-input-field__error-message')[0].textContent = '';
                            fieldName[i].parentElement.getElementsByClassName('fa-input-field__error-message')[0].style.display = 'none';
                        }
                    } else {
                        if (fieldName[i].value === '') {
                            count++;
                            fieldName[i].classList.add('error');
                            fieldName[i].parentElement.getElementsByClassName('fa-input-field__error-message')[0].textContent = 'Please enter your ' + str.toLocaleLowerCase();
                            fieldName[i].parentElement.getElementsByClassName('fa-input-field__error-message')[0].style.display = 'block';
                        } else {
                            fieldName[i].classList.remove('error');
                            fieldName[i].parentElement.getElementsByClassName('fa-input-field__error-message')[0].textContent = '';
                            fieldName[i].parentElement.getElementsByClassName('fa-input-field__error-message')[0].style.display = 'none';
                        }
                    }
                }
            });
            if (count == 0) {

                console.log("formData : ", formData);
                var emailTemp = false;
                var emailEle = (0, _jquery2.default)('.cw-new-theme #email-field-main');
                if ((0, _jquery2.default)('.cw-new-theme #email-field-main') && (0, _jquery2.default)('.cw-new-theme #email-field-main').val()) {
                    var expr = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    emailTemp = expr.test((0, _jquery2.default)('.cw-new-theme #email-field-main').val());
                }
                if (emailTemp) {
                    emailEle.removeClass('error');
                    emailEle.parent().find(".fa-input-field__error-message").text("");
                    emailEle.parent().find(".fa-input-field__error-message").css('display', 'none');
                    _jquery2.default.ajax({
                        beforeSend: function beforeSend() {
                            (0, _jquery2.default)('.loading-message-wrapper').removeClass('hide').addClass('show');
                        },
                        url: this.formAction = this.$form.attr('action'),
                        method: this.formMethod = this.$form.attr('method'),
                        data: this.formData = formData
                    }).always(this.handleValidationResponse.bind(this));
                } else {
                    (0, _jquery2.default)('html, body').animate({
                        scrollTop: (0, _jquery2.default)('.cw-new-theme #email-field-main').offset().top - 100
                    }, 800);
                    emailEle.addClass('error');
                    emailEle.parent().find(".fa-input-field__error-message").text("Please enter your email");
                    emailEle.parent().find(".fa-input-field__error-message").css('display', 'block');
                    (0, _jquery2.default)(".loading-message-wrapper").delay(500).queue(function (next) {
                        (0, _jquery2.default)(this).removeClass('show').addClass('hide');
                        next();
                    });
                }
            } else {
                this.scrollToFromTitle();
            }
        }
    }, {
        key: 'scrollToFromTitle',
        value: function scrollToFromTitle() {
            (0, _jquery2.default)('html, body').animate({
                scrollTop: (0, _jquery2.default)('.form-title').offset().top
            }, 800);
            (0, _jquery2.default)(".loading-message-wrapper").delay(500).queue(function (next) {
                (0, _jquery2.default)(this).removeClass('show').addClass('hide');
                next();
            });
        }
    }, {
        key: 'handleValidationResponse',
        value: function handleValidationResponse(response) {
            console.log("errors", response);
            // this.hideAllValidationErrors();
            (0, _jquery2.default)(".loading-message-wrapper").delay(500).queue(function (next) {
                (0, _jquery2.default)(this).removeClass('show').addClass('hide');
                next();
            });
            var newele2e = (0, _jquery2.default)(".error-message--backend");
            if (response.success) {
                if (newele2e) {
                    newele2e.css("display", "none");
                    console.log("Success redirect!");
                }
                this.handleSuccess(response);
            } else if (response && response.success == false) {
                if (newele2e) {
                    newele2e.css("display", "block");
                    console.log("Failed to redirect!");
                    if (response.fields && response.fields.length > 0) {
                        newele2e.text(response.fields[0].Reason);
                    }
                }
            }
        }
    }, {
        key: 'hideAllValidationErrors',
        value: function hideAllValidationErrors() {
            (0, _jquery2.default)(".fa-input-field--error").each(function () {
                (0, _jquery2.default)(this).removeClass("fa-input-field--error");
            });
        }
    }, {
        key: 'showValidationError',
        value: function showValidationError(field) {
            var $element = this.$form.find('[name=' + field.FieldName + ']');
            $element.addClass(this.errorClass).parent().addClass(this.errorClass).find('.' + this.messageClass).text(field.Reason);
        }
    }, {
        key: 'removeValidationError',
        value: function removeValidationError(field) {
            var $element = this.$form.find('[name=' + field.element + ']');

            $element.removeClass(this.errorClass).parent().removeClass(this.errorClass).find('.' + this.messageClass).text('');
        }
    }, {
        key: 'handleSuccess',
        value: function handleSuccess(response) {
            var domain = document.location.origin;
            console.log("Done");
            dataLayer.push({ 'crmUserId': response.CrmUserId });
            dataLayer.push({ 'thankYouURL': window.location.href + '/thankyou' });
            window.location.replace(domain + "/experiences/events/confirmation");
        }
    }, {
        key: 'resetForm',
        value: function resetForm() {
            this.$form.find('input, select, textarea').each(function (i, element) {
                element.value = '';
            });
        }
    }]);

    return HospitalityEnquiryForm;
}(_snappy2.default.BaseComponent);

(0, _jquery2.default)(function () {
    var CWHospitalityEnquiryForm = new _snappy2.default.Component.HospitalityEnquiryForm();

    (0, _jquery2.default)('.packageCheckbox').change(function () {
        (0, _jquery2.default)('.packageCheckbox').not(this).prop('checked', false);
    });
    var consentEle2 = document.getElementsByClassName("margin-top-3")[0];
    var policyEle2 = document.getElementsByClassName("policy-para")[0];
    if (consentEle2) {
        if (screen.width <= 767) {
            consentEle2.style.marginTop = '7%';
        } else if (screen.width > 767 && screen.width <= 992) {
            consentEle2.style.marginTop = '2%';
        } else {
            consentEle2.style.marginTop = '5px';
        }
    }
    if (policyEle2) {
        if (screen.width <= 767) {
            policyEle2.style.marginTop = '5%';
            policyEle2.style.marginBottom = '4%';
        } else if (screen.width > 767 && screen.width <= 992) {
            policyEle2.style.marginTop = '3%';
            policyEle2.style.marginBottom = '4%';
        } else {
            policyEle2.style.marginTop = '5px';
        }
    }
    //Event Dropdown
    var defaultDescription = (0, _jquery2.default)('ul.fa-dropdown-content li.description-default');
    var eventDescription = (0, _jquery2.default)('ul.fa-dropdown-content li.description');

    (0, _jquery2.default)(eventDescription).hide();
    (0, _jquery2.default)(defaultDescription).show();

    (0, _jquery2.default)('.fa-dropdown select#event-title').change(function () {
        (0, _jquery2.default)(defaultDescription).hide();
        (0, _jquery2.default)(eventDescription).hide();
        (0, _jquery2.default)('#' + this.value).show();

        if ((0, _jquery2.default)(this).val() == '0') {
            (0, _jquery2.default)(defaultDescription).show();
        }
    });
});

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
  var cwEnquiryformclass = (0, _jquery2.default)('.cw-new-theme .fa-enquiry-form').length;
  if (cwEnquiryformclass > 0) {
    _jquery2.default.fn.isOnScreen = function () {
      var win = (0, _jquery2.default)(window);
      var viewport = {
        top: win.scrollTop(),
        left: win.scrollLeft()
      };
      viewport.right = viewport.left + win.width();
      viewport.bottom = viewport.top + win.height();
      var bounds = this.offset();
      bounds.right = bounds.left + this.outerWidth();
      bounds.bottom = bounds.top + this.outerHeight();
      return !(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom);
    };
    (0, _jquery2.default)(window).scroll(function () {
      if ((0, _jquery2.default)('.cw-new-theme .fa-enquiry-form').isOnScreen() == true) {
        (0, _jquery2.default)(".enquiry-ribbon").hide();
        (0, _jquery2.default)('.cw-default-nav').addClass('cw-margin0');
      } else {
        (0, _jquery2.default)('.enquiry-ribbon').show();
        (0, _jquery2.default)('.cw-default-nav').removeClass('cw-margin0');
      }
    });
  }
});

// Hamburger toggle
(0, _jquery2.default)('.cw-default-nav #cw-navbar-toggle').on('click', function () {
  this.classList.toggle('active');
  (0, _jquery2.default)('.cw-default-nav .cw-nav').slideToggle();
});

if ((0, _jquery2.default)(window).width() < 1025) {
  (0, _jquery2.default)('.cw-default-nav ul.cw-nav li.cw-dropdown button.cw-icon-right-ar:not(:only-child)').click(function (e) {
    (0, _jquery2.default)(this).siblings('.cw-default-nav .cw-nav .cw-dropdown-content').slideToggle("slow");
    (0, _jquery2.default)(this).siblings('.cw-default-nav .cw-nav .cw-dropdown-content').parent('.cw-dropdown').toggleClass('active');
    // Close dropdown when select another dropdown
    (0, _jquery2.default)('.cw-default-nav .cw-nav .cw-dropdown-content').not((0, _jquery2.default)(this).siblings()).hide("slow");
    (0, _jquery2.default)('.cw-default-nav .cw-nav .cw-dropdown-content').not((0, _jquery2.default)(this).siblings()).parent('.cw-dropdown').removeClass("active");
    e.stopPropagation();
  });
}
if ((0, _jquery2.default)(window).width() > 1024) {
  (0, _jquery2.default)(window).scroll(function () {
    if ((0, _jquery2.default)(this).scrollTop() > 40) {
      (0, _jquery2.default)('.cw-default-nav').addClass('cw-default-nav-sticky');
      (0, _jquery2.default)('.cw-top-bar').hide();
    } else {
      (0, _jquery2.default)('.cw-default-nav').removeClass('cw-default-nav-sticky');
      (0, _jquery2.default)('.cw-top-bar').show();
    }
  });
}

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(document).ready(function () {
  var interval = 5000;
  var divs = (0, _jquery2.default)('.cw-new-theme .enquiry-ribbon h3 a');
  var currentIndex = 0;

  function showNextDiv() {
    divs.hide();
    divs.eq(currentIndex).fadeIn();
    currentIndex = (currentIndex + 1) % divs.length;
  }

  setInterval(showNextDiv, interval);
  divs.hide();
  showNextDiv();
});

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
    // Function to close the modal
    function closeModal() {
        var modal = (0, _jquery2.default)('.fa-modal.carousel-triggered-modal');
        modal.fadeOut(function () {
            modal.removeClass('carousel-triggered-modal');
            (0, _jquery2.default)(document).trigger('modalClosed'); // Trigger custom event when modal is closed
        });
    }

    // Close modal when the close button is clicked
    (0, _jquery2.default)(document).on('click', '.js-modal-close', closeModal);

    // Close modal when clicking outside the modal content
    (0, _jquery2.default)(document).on('click', function (e) {
        var modalContainer = (0, _jquery2.default)('.fa-modal.carousel-triggered-modal .container'); // Modal content container
        if (!modalContainer.is(e.target) && modalContainer.has(e.target).length === 0) {
            closeModal();
        }
    });

    // Prevent click event from propagating to the document when clicking inside the modal
    (0, _jquery2.default)(document).on('click', '.fa-modal.carousel-triggered-modal .container', function (e) {
        e.stopPropagation();
    });

    // Function to add "See More" link if content exceeds 88px in height
    function addSeeMoreLink() {
        (0, _jquery2.default)('.membership-slide-card__text').each(function () {
            var $list = (0, _jquery2.default)(this);
            var $listItems = $list.find('.list-item');
            var cumulativeHeight = 0;
            var lastVisibleIndex = 0;

            // Avoid adding multiple "See More" links to the same list
            if ($list.find('.see-more').length > 0) {
                return;
            }

            // Calculate the visible height of list items
            $listItems.each(function (index) {
                cumulativeHeight += (0, _jquery2.default)(this).outerHeight(true);
                if (cumulativeHeight <= 88) {
                    lastVisibleIndex = index;
                } else {
                    return false; // Stop iteration when the height exceeds 88px
                }
            });

            if (cumulativeHeight > 88) {
                // Hide items after the visible threshold
                $listItems.slice(lastVisibleIndex + 1).hide();

                // Add a "See More" link after the last visible item
                var seeMoreLink = (0, _jquery2.default)('<a href="javascript:void(0)" class="see-more">see more</a>');
                $listItems.eq(lastVisibleIndex).append(seeMoreLink);

                // Event handler for "See More" click to open modal
                seeMoreLink.on('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation(); // Prevent the click event from propagating

                    // Prevent carousel sliding during modal opening
                    (0, _jquery2.default)('.membership-card-wrapper .carousel-container').off('touchstart touchmove touchend');

                    (0, _jquery2.default)('.fa-modal').addClass('carousel-triggered-modal').fadeIn();

                    // Remove the modal title if not required
                    (0, _jquery2.default)('.js-modal-title').text('');

                    // Clone the ENTIRE card body (including all hidden content)
                    var fullContent = $list.closest('.membership-slide-card__body').clone();
                    fullContent.find('.see-more').remove(); // Remove the "See More" link completely
                    fullContent.find('.list-item').show(); // Ensure all list items are visible

                    // Add "See Less" link to the last list item's text content
                    var lastListItem = fullContent.find('.list-item').last();
                    var seeLessLink = (0, _jquery2.default)('<a href="javascript:void(0)" class="see-less"> see less</a>'); // Create See Less link
                    lastListItem.append(seeLessLink); // Append See Less to the end of the last list item's text

                    (0, _jquery2.default)('.js-modal-contents').html(fullContent); // Inject the cloned content into the modal

                    // Bind event for "See Less" to close modal
                    (0, _jquery2.default)('.see-less').on('click', function (e) {
                        e.preventDefault();
                        closeModal();
                    });

                    // Rebind the close button event
                    (0, _jquery2.default)('.js-modal-close').off('click').on('click', closeModal);
                });
            }
        });
    }

    // Call the function initially to add "See More" links
    addSeeMoreLink();

    // Reapply the "See More" logic when dynamic content is loaded
    (0, _jquery2.default)(document).on('contentLoaded', addSeeMoreLink);

    // Function to set all card heights to be the same
    function setEqualCardHeight() {
        var cards = (0, _jquery2.default)('.membership-slide-card'); // Select all cards
        var maxHeight = 0;

        // Reset heights to auto to recalculate accurately
        cards.css('height', 'auto');

        // Calculate the maximum height among all cards
        cards.each(function () {
            var height = (0, _jquery2.default)(this).outerHeight();
            if (height > maxHeight) {
                maxHeight = height;
            }
        });

        // Apply the maximum height to all cards
        cards.css('height', maxHeight + 'px');
    }

    // Call the function initially to ensure equal heights
    setEqualCardHeight();

    // Reapply the function on window resize for responsiveness
    (0, _jquery2.default)(window).on('resize', setEqualCardHeight);
});

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
    var carouselContainer = (0, _jquery2.default)('.membership-card-wrapper .carousel-container');
    var currentIndex = carouselContainer.data('currentIndex') || 0;

    function initializeCarousel() {
        var slides = carouselContainer.find('.carousel-slide');
        var indicatorsContainer = carouselContainer.find('#carousel-indicators');
        var slider = carouselContainer.find('.carousel-slider');

        // Clear existing indicators to prevent duplication
        indicatorsContainer.empty();

        // Handle single slide layout differently
        if (slides.length === 1) {
            carouselContainer.addClass('single-slide');
        } else {
            slides.each(function (index) {
                var indicator = (0, _jquery2.default)('<div class="indicator"></div>');
                if (index === currentIndex) {
                    indicator.addClass('active');
                }
                indicatorsContainer.append(indicator);
            });
        }

        // Cache indicators after generation
        var indicators = indicatorsContainer.find('.indicator');

        // Core slide display function
        function showSlide(index) {
            currentIndex = index;
            carouselContainer.data('currentIndex', currentIndex);

            // Calculate slide position
            var slideWidth = slides.eq(0).outerWidth(true);
            var offset = -index * slideWidth;

            // Apply transform with smooth transition
            slider.css({
                'transition': 'transform 0.3s ease-out',
                'transform': 'translateX(' + offset + 'px)'
            });

            // Update indicator states
            indicators.removeClass('active').eq(index).addClass('active');
        }

        // Next button click handler
        carouselContainer.find('.next').off('click').on('click', function (e) {
            e.preventDefault();
            showSlide((currentIndex + 1) % slides.length);
        });

        // Previous button click handler
        carouselContainer.find('.prev').off('click').on('click', function (e) {
            e.preventDefault();
            showSlide((currentIndex - 1 + slides.length) % slides.length);
        });

        // Indicator click handler
        indicators.off('click').on('click', function () {
            showSlide((0, _jquery2.default)(this).index());
        });

        // Touch event variables
        var startX = 0;
        var isDragging = false;
        var slideWidth = void 0;

        // Touch start handler
        carouselContainer.off('touchstart').on('touchstart', function (e) {
            var touch = e.originalEvent.touches[0];
            var target = (0, _jquery2.default)(touch.target);

            // Ignore drag on interactive elements
            if (target.is('a, .indicator, .prev, .next') || target.closest('a, .prev, .next').length) {
                return;
            }

            // Initialize drag values
            startX = touch.clientX;
            isDragging = true;

            // Get fresh slide width measurement
            slideWidth = slides.eq(0).outerWidth(true);

            // Disable transitions during drag
            slider.css('transition', 'none');
        });

        // Touch move handler
        carouselContainer.off('touchmove').on('touchmove', function (e) {
            if (!isDragging) return;

            // Calculate drag offset
            var currentX = e.originalEvent.touches[0].clientX;
            var diffX = currentX - startX;

            // Update slider position in real-time
            slider.css('transform', 'translateX(' + (diffX - currentIndex * slideWidth) + 'px)');
        });

        // Touch end handler
        carouselContainer.off('touchend').on('touchend', function () {
            if (!isDragging) return;
            isDragging = false;

            // Get final transform matrix values
            var finalTransform = slider.css('transform');
            var matrix = new DOMMatrix(finalTransform);

            // Calculate actual slide position
            var actualOffset = Math.round(matrix.m41 / slideWidth) * -1;

            // Clamp index to valid range
            var newIndex = Math.min(Math.max(actualOffset, 0), slides.length - 1);

            // Update to final slide position
            showSlide(newIndex);
        });
    }

    // Initial carousel setup
    initializeCarousel();

    // Popup open handler
    (0, _jquery2.default)('.popup-open').on('click', function () {
        carouselContainer.data('isPopupOpen', true);
    });

    // Popup close handler (critical fix area)
    (0, _jquery2.default)('.popup-close').on('click', function () {
        // Store previous state before reinitialization
        var prevIndex = currentIndex;

        // Reinitialize with fresh DOM references
        initializeCarousel();

        // Get updated slide measurements
        var slides = carouselContainer.find('.carousel-slide');
        var slider = carouselContainer.find('.carousel-slider');
        var slideWidth = slides.eq(0).outerWidth(true);

        // Immediately apply correct position without transition
        slider.css({
            'transform': 'translateX(' + -prevIndex * slideWidth + 'px)',
            'transition': 'none'
        });

        // Force synchronous layout update
        slider.get(0).offsetHeight;

        // Restore transitions
        slider.css('transition', '');

        // Update indicators to match position
        showSlide(prevIndex);
    });

    // Modal closed handler
    (0, _jquery2.default)(document).on('modalClosed', function () {
        initializeCarousel();
    });
});

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
    // Show more text option 
    var showChar = 340; // How many characters are shown by default
    var ellipsestext = "...";
    var moretext = '<span class="cta--text">Show More</span><span class="cta--down-arrow-icon icon"></span>';
    var lesstext = '<span class="cta--text">Show Less</span><span class="cta--down-arrow-icon icon"></span>';

    //Cut content based on showChar length
    if ((0, _jquery2.default)(".cwm-account-manager-1_content .cwm-account-manager-1_text").length) {
        (0, _jquery2.default)(".cwm-account-manager-1_content .cwm-account-manager-1_text").each(function () {

            var content = (0, _jquery2.default)(this).html();
            console.log(content);

            if (content.length > showChar) {

                var contentExcert = content.substr(0, showChar);
                var contentRest = content.substr(showChar, content.length - showChar);
                var html = contentExcert + '<span class="cwm-toggle-text-ellipses">' + ellipsestext + '</span><span class="cwm-toggle-text-content"><span>' + contentRest + '</span> <a href="javascript:;" class="cwm-toggle-text-link">' + moretext + '</a></span>';

                (0, _jquery2.default)(this).html(html);
            }
        });
    }

    //Toggle content when click on read more link
    (0, _jquery2.default)(".cwm-account-manager-1_content .cwm-toggle-text-link").click(function () {
        if ((0, _jquery2.default)(this).hasClass("less")) {
            (0, _jquery2.default)(this).removeClass("less");
            (0, _jquery2.default)(this).html(moretext);
        } else {
            (0, _jquery2.default)(this).addClass("less");
            (0, _jquery2.default)(this).html(lesstext);
        }
        (0, _jquery2.default)(this).parent().prev().toggle();
        (0, _jquery2.default)(this).prev().toggle();
        return false;
    });
});

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
    var subContactsData = null;
    (0, _jquery2.default)(".cwm-addsub-contacts").hide();

    (0, _jquery2.default)("a.subcontact").click(function () {
        (0, _jquery2.default)(".cwm-addsub-contacts").show();
        (0, _jquery2.default)('html,body').animate({
            scrollTop: (0, _jquery2.default)(".cwm-addsub-contacts").offset().top - 200 }, '2000');
    });

    // close button 
    (0, _jquery2.default)("#cwm-addsubcontacts-Close").on("click", function () {
        (0, _jquery2.default)(".cwm-addsub-contacts").animate({ height: "auto" }, function () {
            (0, _jquery2.default)(this).hide();
            window.location.reload();
        });
    });
    // enable and disable submit button
    (0, _jquery2.default)('#cwm_addsub_contactsform input.my-account_formControl').on('keyup', function () {
        if ((0, _jquery2.default)('#cwm_asc_mfirstName').val() != '' || (0, _jquery2.default)('#cwm_asc_msurName').val() != '' || (0, _jquery2.default)('#cwm_asc_Cname').val() != '' || (0, _jquery2.default)('#cwm_asc_Jtitle').val() != '' || (0, _jquery2.default)('#cwm_asc_Sdob').val() != '' || (0, _jquery2.default)('#cwm_asc_SemailAddress').val() != '' || (0, _jquery2.default)('#cwm_asc_phnumber').val() != '') {
            (0, _jquery2.default)('#cwmAddSubcontacts-submit').attr('disabled', false);
        } else {
            (0, _jquery2.default)('#cwmAddSubcontacts-submit').attr('disabled', true);
        }
    });
    //numbers not allowing
    (0, _jquery2.default)("#cwm_asc_mfirstName").keypress(function (e) {
        var numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
        var keynum;
        if (window.event) {
            // IE                    
            keynum = e.keyCode;
        } else if (e.which) {
            // Netscape/Firefox/Opera                   
            keynum = e.which;
        }
        if (numbers.indexOf(String.fromCharCode(keynum)) > -1) {
            e.preventDefault();
        }
    });
    (0, _jquery2.default)("#cwm_asc_msurName").keypress(function (e) {
        var numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
        var keynum;
        if (window.event) {
            // IE                    
            keynum = e.keyCode;
        } else if (e.which) {
            // Netscape/Firefox/Opera                   
            keynum = e.which;
        }
        if (numbers.indexOf(String.fromCharCode(keynum)) > -1) {
            e.preventDefault();
        }
    });
    //Edit SubContacts details form: ajax request
    (0, _jquery2.default)('#cwmAddSubcontacts-submit').on("click", function () {
        // assigning form values and names in to var
        subContactsData = {
            FirstName: { FieldName: "FirstName", FieldValue: (0, _jquery2.default)("#cwm_asc_mfirstName").val() },
            SurName: { FieldName: "SurName", FieldValue: (0, _jquery2.default)("#cwm_asc_msurName").val() },
            CompanyName: { FieldName: "CompanyName", FieldValue: (0, _jquery2.default)("#cwm_asc_Cname").val() },
            JobTitle: { FieldName: "JobTitle", FieldValue: (0, _jquery2.default)("#cwm_asc_Jtitle").val() },
            DateOfBirth: { FieldName: "DateOfBirth", FieldValue: (0, _jquery2.default)("#cwm_asc_Sdob").val() },
            SubContactEmail: { FieldName: "SubContactEmail", FieldValue: (0, _jquery2.default)("#cwm_asc_SemailAddress").val() },
            PhoneNumber: { FieldName: "PhoneNumber", FieldValue: (0, _jquery2.default)("#cwm_asc_phnumber").val() }

            //only accept letters /^[a-zA-Z\s]*$/
        };_jquery2.default.validator.addMethod("letters", function (value, element) {
            return this.optional(element) || value == value.match(/[A-Za-zÀ-ÖØ-öø-ÿ `~!@#$%\^&*)(+=._-]+'?[A-Za-zÀ-ÖØ-öø-ÿ `~!@#$%\^&*)(+=._-]+/g);
        });
        //onlynumbers and Phone number(/^[0-9 -.\s]+$/)
        _jquery2.default.validator.addMethod("telnumber", function (value, element) {
            return this.optional(element) || value == value.match(/^[0-9 + ]+$/);
        });
        //onlynumbers and Uppercase letters
        _jquery2.default.validator.addMethod("fanNumber", function (value, element) {
            return this.optional(element) || value == value.match(/^[0-9\s]*$/);
        });
        //Date dd/mm/yyyy validation
        _jquery2.default.validator.addMethod("subCvalidDate", function (value, element) {
            return value.match(/(?:0[1-9]|[12][0-9]|3[01])\/(?:0[1-9]|1[0-2])\/(?:19\d{2}|20\d{2})/);
        });
        //validation for 18 years old
        _jquery2.default.validator.addMethod("subCvalidDOB", function (value, element) {
            var from = value.split("/"); // DD/MM/YYYY
            var day = from[0];
            var month = from[1];
            var year = from[2];
            var age = 18;
            var mydate = new Date();
            mydate.setFullYear(year, month - 1, day);
            var currdate = new Date();
            var setDate = new Date();

            setDate.setFullYear(mydate.getFullYear() + age, month - 1, day);

            if (currdate - setDate > 0) {
                return true;
            } else {
                return false;
            }
        });
        (0, _jquery2.default)("#cwm_addsub_contactsform").validate({
            wrapper: 'span',
            errorPlacement: function errorPlacement(error, element) {
                error.addClass("my-account_errorlabel");
                error.insertAfter(element);
            },
            rules: {
                cwm_asc_mfirstName: {
                    required: true,
                    maxlength: 255,
                    letters: true
                },
                cwm_asc_msurName: {
                    required: true,
                    maxlength: 255,
                    letters: true
                },
                cwm_asc_Cname: {
                    maxlength: 255
                },
                cwm_asc_Jtitle: {
                    maxlength: 255
                },
                cwm_asc_Sdob: {
                    required: true,
                    subCvalidDate: true,
                    subCvalidDOB: true
                },
                cwm_asc_SemailAddress: {
                    required: true,
                    email: true
                },
                cwm_asc_phnumber: {
                    telnumber: true,
                    required: true,
                    maxlength: 18
                }
            },
            messages: {
                cwm_asc_mfirstName: {
                    required: "Please enter firstname.",
                    letters: "Please enter text only.",
                    maxlength: "Please enter no more than 255 characters."
                },
                cwm_asc_msurName: {
                    required: "Please enter surname.",
                    letters: "Please enter text only.",
                    maxlength: "Please enter no more than 255 characters."
                },
                cwm_asc_Cname: {
                    maxlength: "Please enter no more than 255 characters."
                },
                cwm_asc_Jtitle: {
                    maxlength: "Please enter no more than 255 characters."
                },
                cwm_asc_Sdob: {
                    required: "Please enter your DOB in the format DD/MM/YYYY.",
                    subCvalidDOB: "You must be age 18 or over.",
                    subCvalidDate: "Please enter your DOB in the format DD/MM/YYYY."
                },
                cwm_asc_SemailAddress: {
                    required: "Please enter email address.",
                    email: "Please enter a valid email address."
                },
                cwm_asc_phnumber: {
                    telnumber: "Please enter a valid phone number.",
                    required: "Please enter a phone number.",
                    maxlength: "Please enter no more than 15 numbers."
                }
            },

            submitHandler: function submitHandler(form) {
                (0, _jquery2.default)('html').css({ 'overflow-y': "hidden" });
                (0, _jquery2.default)("#cwm-overlay").show();
                _jquery2.default.ajax({
                    url: form.action,
                    type: form.method,
                    data: subContactsData,
                    dataType: "json",
                    success: function success(response) {
                        (0, _jquery2.default)('html').css({ 'overflow-y': "scroll" });
                        (0, _jquery2.default)("#cwm-overlay").hide();
                        (0, _jquery2.default)("#cwm_addcontact_form").hide();
                        (0, _jquery2.default)('#subContact-success-message').show();
                        console.log(JSON.stringify(subContactsData));
                        (0, _jquery2.default)('html,body').animate({
                            scrollTop: (0, _jquery2.default)("#subContact-success-message").offset().top - 100 }, '1000');
                    },
                    error: function error(response) {
                        (0, _jquery2.default)('html').css({ 'overflow-y': "scroll" });
                        (0, _jquery2.default)("#cwm-overlay").hide();
                        console.log(response.error);
                    }
                });
            }
        });
    });
});

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
    var declineRSVPBtn = (0, _jquery2.default)('#cwm-DeclineRSVP');
    var acceptRSVPBtn = (0, _jquery2.default)('#cwm-AcceptRSVP');
    var connectionAcceptRSVPBtn = (0, _jquery2.default)('#cwm-connectionAcceptRSVP');
    var memberRSVPModal = (0, _jquery2.default)("#memberRSVPModal");
    var guestFormModal = (0, _jquery2.default)('#addGuestRSVPFormModal');

    declineRSVPBtn.on("click", function () {
        (0, _jquery2.default)('html').css({ 'overflow-y': "hidden" });
        (0, _jquery2.default)("#cwm-overlay").show();
        var EventData = {
            SitecoreEventId: (0, _jquery2.default)("#SitecoreEventId").val()
        };
        _jquery2.default.ajax({
            url: '/api/sitecore/CWMEvents/ConnectionEventDeclineRSVP',
            data: EventData,
            type: "POST",
            dataType: "json",
            success: function success(response) {
                console.log(response.success);
                memberRSVPModal.modal('hide');
                location.reload();
            },
            error: function error(response) {
                (0, _jquery2.default)('html').css({ 'overflow-y': "scroll" });
                (0, _jquery2.default)("#cwm-overlay").hide();
                console.log(response.error);
            }
        });
    });
    acceptRSVPBtn.on("click", function () {
        memberRSVPModal.modal('hide');
        setTimeout(function () {
            guestFormModal.modal('show');
        }, 1000);
    });
    if (connectionAcceptRSVPBtn.hasClass("showModalDefault")) {
        memberRSVPModal.modal('show');
    }
});

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Register CTA AJAX CALL for  no guest 
(0, _jquery2.default)(function () {
    (0, _jquery2.default)("#cwm-registerCTA_noguest").on("click", function () {
        (0, _jquery2.default)('html').css({ 'overflow-y': "hidden" });
        (0, _jquery2.default)("#cwm-overlay").show();
        var RegisterData = {
            NumberOfAttendees: (0, _jquery2.default)("#maxNumberOfGuestAllowed").val(),
            SitecoreEventId: (0, _jquery2.default)("#SitecoreEventId").val()
        };
        _jquery2.default.ajax({
            type: "POST",
            url: "/api/sitecore/CWMEvents/ConnectionEventRegister",
            data: RegisterData,
            dataType: "json",
            success: function success(response) {
                console.log(response.success);
                window.location.reload();
            },
            error: function error(response) {
                (0, _jquery2.default)('html').css({ 'overflow-y': "scroll" });
                (0, _jquery2.default)("#cwm-overlay").hide();
                console.log(response.error);
            }
        });
    });

    //Register CTA AJAX CALL for  guest user
    (0, _jquery2.default)('#cwm-guest-submit').on("click", function () {

        // assigning form values and names in to var
        var RegisterData = {
            NumberOfAttendees: (0, _jquery2.default)("#cwm-guest-no").val(),
            SitecoreEventId: (0, _jquery2.default)("#SitecoreEventId").val()
        };

        (0, _jquery2.default)("#cwm-guest-selection-form").validate({
            submitHandler: function submitHandler(form) {
                (0, _jquery2.default)('html').css({ 'overflow-y': "hidden" });
                (0, _jquery2.default)("#cwm-overlay").show();
                _jquery2.default.ajax({
                    url: form.action,
                    type: form.method,
                    data: RegisterData,
                    dataType: "json",
                    success: function success(response) {
                        (0, _jquery2.default)('html').css({ 'overflow-y': "scroll" });
                        (0, _jquery2.default)("#cwm-overlay").hide();
                        (0, _jquery2.default)(".cwm-mdl-guest-content").hide();
                        (0, _jquery2.default)('.cwm-mdl-guest-selection .modal-confirmation__content').show();
                    },
                    error: function error(response) {
                        (0, _jquery2.default)('html').css({ 'overflow-y': "scroll" });
                        (0, _jquery2.default)("#cwm-overlay").hide();
                        console.log(response.success);
                    }
                });
            }
        });
    });

    // De-Register CTA AJAX call
    (0, _jquery2.default)("#cwm-de-RegisterCTA").on("click", function () {
        (0, _jquery2.default)('html').css({ 'overflow-y': "hidden" });
        (0, _jquery2.default)("#cwm-overlay").show();
        var EventData = {
            SitecoreEventId: (0, _jquery2.default)("#SitecoreEventId").val()
        };
        _jquery2.default.ajax({
            type: "POST",
            url: "/api/sitecore/CWMEvents/ConnectionEventDeregister",
            data: EventData,
            dataType: "json",
            success: function success(response) {
                console.log(response.success);
                window.location.reload();
            },
            error: function error(response) {
                (0, _jquery2.default)('html').css({ 'overflow-y': "scroll" });
                (0, _jquery2.default)("#cwm-overlay").hide();
                console.log(response.error);
            }
        });
    });

    // LeaveWaitingList AJAX call
    (0, _jquery2.default)("#cwm-LeaveWaitingList").on("click", function () {
        (0, _jquery2.default)('html').css({ 'overflow-y': "hidden" });
        (0, _jquery2.default)("#cwm-overlay").show();
        // assigning form values and names in to var
        var EventData = {
            SitecoreEventId: (0, _jquery2.default)("#SitecoreEventId").val()
        };
        _jquery2.default.ajax({
            type: "POST",
            url: "/api/sitecore/CWMEvents/ConnectionEventLeaveWaitingList",
            data: EventData,
            dataType: "json",
            success: function success(response) {
                console.log(response.success);
                window.location.reload();
            },
            error: function error(response) {
                (0, _jquery2.default)('html').css({ 'overflow-y': "scroll" });
                (0, _jquery2.default)("#cwm-overlay").hide();
                console.log(response.error);
            }
        });
    });

    // RejoinWaitingList AJAX call
    (0, _jquery2.default)("#cwm-RejoinWaitingList").on("click", function () {
        (0, _jquery2.default)('html').css({ 'overflow-y': "hidden" });
        (0, _jquery2.default)("#cwm-overlay").show();
        var EventData = {
            SitecoreEventId: (0, _jquery2.default)("#SitecoreEventId").val()
        };
        _jquery2.default.ajax({
            type: "POST",
            url: "/api/sitecore/CWMEvents/ConnectionEventRejoinWaitingList",
            data: EventData,
            dataType: "json",
            success: function success(response) {
                console.log(response.success);
                window.location.reload();
            },
            error: function error(response) {
                (0, _jquery2.default)('html').css({ 'overflow-y': "scroll" });
                (0, _jquery2.default)("#cwm-overlay").hide();
                console.log(response.error);
            }
        });
    });

    // CancelRSVP AJAX call
    (0, _jquery2.default)("#cwm-CancelRSVP").on("click", function () {
        (0, _jquery2.default)('html').css({ 'overflow-y': "hidden" });
        (0, _jquery2.default)("#cwm-overlay").show();
        var EventData = {
            SitecoreEventId: (0, _jquery2.default)("#SitecoreEventId").val()
        };
        _jquery2.default.ajax({
            type: "POST",
            url: "/api/sitecore/CWMEvents/ConnectionEventCancelRSVP",
            data: EventData,
            dataType: "json",
            success: function success(response) {
                console.log(response.success);
                window.location.reload();
            },
            error: function error(response) {
                (0, _jquery2.default)('html').css({ 'overflow-y': "scroll" });
                (0, _jquery2.default)("#cwm-overlay").hide();
                console.log(response.error);
            }
        });
    });
});

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Registration open date value getting from sitecore
var ceOpenDate = (0, _jquery2.default)("#registrationOpenDate").val();
// Registration close date value getting from sitecore
var ceEndDate = (0, _jquery2.default)("#registrationCloseDate").val();
// RSVP close date value getting from sitecore
var rsvpEndDate = (0, _jquery2.default)("#resvpCloseDate").val();

// Set the date we're counting down to
var countDownOpenDate = new Date(ceOpenDate).getTime();
var countDownCloseDate = new Date(ceEndDate).getTime();
var countDownRsvpDate = new Date(rsvpEndDate).getTime();
// Registration Open Timer Function

var ceX = setInterval(function () {

  // Get today's date and time
  var nowOpenReg = new Date().getTime();

  // Find the distance between now and the count down date
  var ceOpenTimer = countDownOpenDate - nowOpenReg;

  // Time calculations for days, hours, minutes and seconds
  var cedays = Math.floor(ceOpenTimer / (1000 * 60 * 60 * 24));
  var cehours = Math.floor(ceOpenTimer % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
  var ceminutes = Math.floor(ceOpenTimer % (1000 * 60 * 60) / (1000 * 60));
  var ceseconds = Math.floor(ceOpenTimer % (1000 * 60) / 1000);
  if ((0, _jquery2.default)("#cwm-open-timer").length > 0) {
    document.getElementById("cwm-open-timer").innerHTML = cedays + "days " + cehours + "hours " + ceminutes + "minutes " + ceseconds + "seconds ";
  } else {
    clearInterval(ceX);
  }

  // If the count down is over, write some text 
  if (ceOpenTimer < 0) {
    clearInterval(ceX);
    document.getElementById("cwm-open-timer").innerHTML = "00:00:00:00";
  }
}, 1000);

// Registration Close Date

var ceY = setInterval(function () {

  // Get today's date and time
  var nowCloseReg = new Date().getTime();

  // Find the distance between now and the count down date
  var ceCloseTimer = countDownCloseDate - nowCloseReg;

  // Time calculations for days, hours, minutes and seconds
  var ceClosedays = Math.floor(ceCloseTimer / (1000 * 60 * 60 * 24));
  var ceClosehours = Math.floor(ceCloseTimer % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
  var ceCloseminutes = Math.floor(ceCloseTimer % (1000 * 60 * 60) / (1000 * 60));
  var ceCloseseconds = Math.floor(ceCloseTimer % (1000 * 60) / 1000);

  if ((0, _jquery2.default)("#cwm-close-timer").length > 0) {
    document.getElementById("cwm-close-timer").innerHTML = ceClosedays + "days " + ceClosehours + "hours " + ceCloseminutes + "minutes " + ceCloseseconds + "seconds ";
  } else {
    clearInterval(ceY);
  }

  // If the count down is over, write some text 
  if (ceCloseTimer < 0) {
    clearInterval(ceY);
    document.getElementById("cwm-close-timer").innerHTML = "00:00:00:00";
  }
}, 1000);

// Registration Close Date

var ceRSVP = setInterval(function () {

  // Get today's date and time
  var nowRsvpClose = new Date().getTime();

  // Find the distance between now and the count down date
  var rsvpCloseTimer = countDownRsvpDate - nowRsvpClose;

  // Time calculations for days, hours, minutes and seconds
  var rsvpClosedays = Math.floor(rsvpCloseTimer / (1000 * 60 * 60 * 24));
  var rsvpClosehours = Math.floor(rsvpCloseTimer % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
  var rsvpCloseminutes = Math.floor(rsvpCloseTimer % (1000 * 60 * 60) / (1000 * 60));
  var rsvpCloseseconds = Math.floor(rsvpCloseTimer % (1000 * 60) / 1000);

  if ((0, _jquery2.default)("#cwm-rsvp-close").length > 0) {
    document.getElementById("cwm-rsvp-close").innerHTML = rsvpClosedays + "days " + rsvpClosehours + "hours " + rsvpCloseminutes + "minutes " + rsvpCloseseconds + "seconds ";
  } else {
    clearInterval(ceRSVP);
  }

  // If the count down is over, write some text 
  if (rsvpCloseTimer < 0) {
    clearInterval(ceRSVP);
    document.getElementById("cwm-rsvp-close").innerHTML = "00:00:00:00";
  }
}, 1000);

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var numberOfGuestAllowed = (0, _jquery2.default)("#maxNumberOfGuestAllowed").val();
(0, _jquery2.default)('.cwm-guest-input .svg-minus').addClass('cwm-disabled-svg');
// Guest No. Counter
(0, _jquery2.default)(document).ready(function () {

    (0, _jquery2.default)(document).on('click', '.svg-plus', function () {
        (0, _jquery2.default)('.cwm-guest-input .svg-minus').removeClass('cwm-disabled-svg');
        (0, _jquery2.default)('#cwm-guest-no').val(parseInt((0, _jquery2.default)('#cwm-guest-no').val()) + 1);
        if ((0, _jquery2.default)('#cwm-guest-no').val() == parseInt((0, _jquery2.default)('#maxNumberOfGuestAllowed').val()) + 1) {

            (0, _jquery2.default)('#cwm-guest-no').val(numberOfGuestAllowed);
        } else if ((0, _jquery2.default)('#cwm-guest-no').val() == parseInt((0, _jquery2.default)('#maxNumberOfGuestAllowed').val())) {
            (0, _jquery2.default)('.cwm-guest-input .svg-plus').addClass('cwm-disabled-svg');
        }
    });

    (0, _jquery2.default)(document).on('click', '.svg-minus', function () {
        (0, _jquery2.default)('.cwm-guest-input .svg-plus').removeClass('cwm-disabled-svg');
        (0, _jquery2.default)('#cwm-guest-no').val(parseInt((0, _jquery2.default)('.cwm-count').val()) - 1);
        if ((0, _jquery2.default)('#cwm-guest-no').val() == 0) {
            (0, _jquery2.default)('#cwm-guest-no').val(1);
        } else if ((0, _jquery2.default)('#cwm-guest-no').val() == '1') {
            (0, _jquery2.default)('.cwm-guest-input .svg-minus').addClass('cwm-disabled-svg');
        }
    });
});
(0, _jquery2.default)(".cwm-new-theme .cwm-reload").click(function () {
    window.location.reload();
});

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
  if ((0, _jquery2.default)('#addGuestRSVPFormModal').length > 0) {
    var cwm_showTab = function cwm_showTab(n) {
      // This function will display the specified tab of the form...
      var cwm_alltabs = document.getElementsByClassName("add-guest_tab");
      cwm_alltabs[n].style.display = "block";
      //... and fix the Previous/Next buttons:
      if (n == 0) {
        document.querySelector('#add-guest__prevBtn').disabled = true;
      } else {
        document.querySelector('#add-guest__prevBtn').disabled = false;
      }
      if (n == cwm_alltabs.length - 1) {
        document.querySelector('.add-guest__nextBtn').disabled = true;
        (0, _jquery2.default)('#attendeeFORMSubmitBtnnext').hide();
        (0, _jquery2.default)('#attendeeFORMSubmitBtn').show();
      } else {
        document.querySelector('.add-guest__nextBtn').disabled = false;
        (0, _jquery2.default)('#attendeeFORMSubmitBtn').hide();
        (0, _jquery2.default)('#attendeeFORMSubmitBtnnext').show();
      }
      document.getElementById("totalP").innerHTML = cwm_alltabs.length;
      //... and run a function that will display the correct step indicator:
      fixStepIndicator(n);
    };

    var validateForm = function validateForm() {
      // This function deals with validation of the form fields
      var cwm_alltabs,
          cwm_Input,
          i,
          valid = true;
      cwm_alltabs = document.getElementsByClassName("add-guest_tab");

      cwm_Input = cwm_alltabs[cwm_currentTab].querySelector("input.add-guest__member-name");
      // A loop that checks every input field in the current tab:
      for (i = 0; i < cwm_alltabs.length; i++) {
        // If a field is empty...
        if (cwm_Input.value == "") {
          // add an "invalid" class to the field:
          cwm_Input.className += " invalid";
          // and set the current valid status to false
          valid = false;
        } else {
          cwm_Input.classList.remove("invalid");
        }
        //removing disabled form validation 
        if (cwm_Input.disabled && cwm_Input.value == "") {
          cwm_Input.classList.remove("invalid");
          valid = true;
        }
      }
      return valid; // return the valid status
    };

    var fixStepIndicator = function fixStepIndicator(n) {
      document.getElementById("currentP").innerHTML = n + 1;
    };

    var nextPrev = function nextPrev(n) {
      // This function will figure out which tab to display
      var cwm_alltabs = document.getElementsByClassName("add-guest_tab");
      // Exit the function if any field in the current tab is invalid:
      if (n == 1 && !validateForm()) return false;

      cwm_alltabs[cwm_currentTab].style.display = "none";
      // Increase or decrease the current tab by 1:
      cwm_currentTab = cwm_currentTab + n;
      // if you have reached the end of the form...
      if (cwm_currentTab >= cwm_alltabs.length) {
        // ... the form gets submitted:
        ajaxCall();
        return false;
      }
      // Otherwise, display the correct tab:
      cwm_showTab(cwm_currentTab);
    };

    var lastTabvalid = function lastTabvalid(n) {
      if (n == 1 && !validateForm()) return false;
    };

    var ajaxCall = function ajaxCall() {
      var serialform = [];
      var guestTab = document.getElementsByClassName("add-guest_tab");
      var whelechairrequiredLength = (0, _jquery2.default)(".iswheelchair_required").length;

      for (var i = 0; i < guestTab.length; i++) {
        var input_MembersID = "id_" + i;
        var input_AttendeeTypeID = "AttendeeType_" + i;
        var input_MembersNameID = "add-guest__member-name_" + i;
        var input_DeputyMemberNameID = "add-Deputy__member-name_" + i;
        var textarea_DietaryReqID = "add-guest__dietary-req_" + i;
        var textarea_commentsID = "add-guest__other-info_" + i;
        var textarea_AttendeeGolfID = "add-guest__golf-handicap_" + i;
        var radiocheckedName = "input:radio" + "[name = addGuestWheelchairRadios_" + i + ']:checked ';
        var radioNotattendeeName = "input:radio" + "[name = notattendee_radio_" + i + ']';

        var input_ID = (0, _jquery2.default)("#" + input_MembersID);
        var input_AttendeeType = (0, _jquery2.default)("#" + input_AttendeeTypeID);
        var input_MembersName = (0, _jquery2.default)("#" + input_MembersNameID);
        var input_DeputyMemberName = (0, _jquery2.default)("#" + input_DeputyMemberNameID);
        var textarea_DietaryReq = (0, _jquery2.default)("#" + textarea_DietaryReqID);
        var textarea_comments = (0, _jquery2.default)("#" + textarea_commentsID);
        var textarea_AttendeeGolf = (0, _jquery2.default)("#" + textarea_AttendeeGolfID);
        var radiochecked = (0, _jquery2.default)(radiocheckedName);
        var radioNotattendeeValue = (0, _jquery2.default)(radioNotattendeeName);
        if (whelechairrequiredLength > 0) {
          var myArr = {
            Id: input_ID.val(),
            AttendeeType: input_AttendeeType.val(),
            IsAttending: radioNotattendeeValue.val(),
            DeputyAttendeeName: input_DeputyMemberName.val(),
            Name: input_MembersName.val(),
            Handicap: textarea_AttendeeGolf.val(),
            DietaryRequirements: textarea_DietaryReq.val(),
            WheelchairRequired: radiochecked.val(),
            Comments: textarea_comments.val()
          };
        } else {
          var myArr = {
            Id: input_ID.val(),
            AttendeeType: input_AttendeeType.val(),
            IsAttending: radioNotattendeeValue.val(),
            DeputyAttendeeName: input_DeputyMemberName.val(),
            Name: input_MembersName.val(),
            Handicap: textarea_AttendeeGolf.val(),
            DietaryRequirements: textarea_DietaryReq.val(),
            WheelchairRequired: false,
            Comments: textarea_comments.val()
          };
        }
        serialform.push(myArr);
      }
      var eventData = {
        SitecoreEventId: (0, _jquery2.default)("#SitecoreEventId").val(),
        Attendees: serialform
      };
      (0, _jquery2.default)('html').css({ 'overflow-y': "hidden" });
      (0, _jquery2.default)("#cwm-overlay").show();
      _jquery2.default.ajax({
        url: '/api/sitecore/CWMEvents/ConnectionEventAcceptRSVP',
        type: 'POST',
        data: JSON.stringify(eventData),
        processData: false, // tell jQuery not to process the data
        contentType: 'application/json',
        success: function success(response) {
          console.log(response.success);
          window.location.reload();
          addGuestFormModal.modal('hide');
        },
        // Error handling
        error: function error(response) {
          (0, _jquery2.default)('html').css({ 'overflow-y': "scroll" });
          (0, _jquery2.default)("#cwm-overlay").hide();
          console.log(response.error);
          addGuestFormModal.modal('hide');
        }
      });
    };

    var addImediateClassToTab = function addImediateClassToTab() {
      var guestTab = document.getElementsByClassName("add-guest_tab");
      guestTab[cwm_currentTab].classList.add("guest-not-attending");
    };

    var AcceptRSVPMemberOnlyBtn = (0, _jquery2.default)('#cwm-AcceptRSVPMemberOnly');
    var AttendeeFORMSubmitBtn = (0, _jquery2.default)('#attendeeFORMSubmitBtn');
    var prevBtn = (0, _jquery2.default)('#add-guest__prevBtn');
    var nextBtn = (0, _jquery2.default)('.add-guest__nextBtn');
    var addGuestFormModal = (0, _jquery2.default)('#addGuestRSVPFormModal');
    var guestNotAttendingLink = (0, _jquery2.default)('.add-guest__not-attendee-link');
    var nextRemoveDisableBtn = (0, _jquery2.default)('#attendeeFORMSubmitBtnnext');
    var deputyMemberCheckbox = (0, _jquery2.default)('.add-guest__checkbox--input');
    var deputyMemberContainer = (0, _jquery2.default)(".Deputy-member-container");
    deputyMemberContainer.hide(); // Hidden deputy field by default
    var cwm_currentTab = 0; // Current tab is set to be the first tab (0)
    cwm_showTab(cwm_currentTab); // Display the current tab

    prevBtn.click(function () {
      nextPrev(-1);
    });
    nextBtn.click(function () {
      nextPrev(1);
    });

    ;

    AcceptRSVPMemberOnlyBtn.on("click", function () {
      ajaxCall();
    });

    AttendeeFORMSubmitBtn.on("click", function () {
      lastTabvalid();
      (0, _jquery2.default)('.add-guest_tab:last-child').css('display', 'block');
    });

    guestNotAttendingLink.click(function () {
      addImediateClassToTab();
      var guestTab = document.getElementsByClassName("add-guest_tab");
      var cwm_Input = guestTab[cwm_currentTab].querySelector("input.add-guest__member-name");

      for (var i = 0; i < guestTab.length; i++) {
        if (cwm_Input.value != "") {
          cwm_Input.value = "";
        }
        var radioNotattendeeName = "input:radio" + "[name = notattendee_radio_" + i + ']';
        var radioNotattendeeValue = (0, _jquery2.default)(radioNotattendeeName);
        (0, _jquery2.default)('.guest-not-attending').find(radioNotattendeeValue).attr("value", 'false');
      }
      (0, _jquery2.default)('.guest-not-attending *').attr('disabled', true);
      nextBtn.attr('disabled', false);
      AttendeeFORMSubmitBtn.attr('disabled', false);
    });

    ;

    // Deputy member checkbox click function
    deputyMemberCheckbox.click(function () {
      var i = 0;
      var radioNotattendeeName = "input:radio" + "[name = notattendee_radio_" + i + ']';
      var radioNotattendeeValue = (0, _jquery2.default)(radioNotattendeeName);
      if ((0, _jquery2.default)(this).is(":checked")) {
        deputyMemberContainer.show();
        radioNotattendeeValue.attr("value", 'false');
      } else {
        deputyMemberContainer.hide();
        radioNotattendeeValue.attr("value", 'true');
      }
    });
  }
});

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
    var contactPrefValue = null;
    // Get the radio buttons and the submit button
    var contactPrefRadios = (0, _jquery2.default)("input.cwm-contact-pref-comp__radio--input[name='optionsRadios']");
    var contactPrefSubmit = (0, _jquery2.default)("#contactPrefSave");

    // Disable the submit button initially
    contactPrefSubmit.prop("disabled", true);

    // Add a change event handler for the radio buttons
    contactPrefRadios.change(function () {
        contactPrefSubmit.prop("disabled", false);
    });

    contactPrefSubmit.on("click", function () {
        // Send the value of the radio button to the database using ajax
        contactPrefValue = {
            DoNotEmail: contactPrefRadios.filter(":checked").val()
        };
        // Add a click event handler for the form save
        (0, _jquery2.default)("#contactPref_form").validate({
            submitHandler: function submitHandler(form) {
                _jquery2.default.ajax({
                    url: form.action,
                    type: form.method,
                    data: contactPrefValue,
                    dataType: "json",
                    error: function error() {
                        (0, _jquery2.default)(".cwm-status-msg__container.contact-pref-status-msg.status-error").css('display', 'flex').delay(3000).queue(function (n) {
                            (0, _jquery2.default)(this).hide();n();
                        });
                    },
                    success: function success(data) {
                        (0, _jquery2.default)(".cwm-status-msg__container.contact-pref-status-msg.status-success").css('display', 'flex').delay(3000).queue(function (n) {
                            (0, _jquery2.default)(this).hide();n();
                            contactPrefSubmit.prop("disabled", true);
                        });
                        (0, _jquery2.default)('html,body').animate({
                            scrollTop: (0, _jquery2.default)(".cwm-status-msg__container.contact-pref-status-msg").offset().top - 300 }, '1000');
                    }
                });
            }
        });
    });
});

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)("a.edit-view-details").click(function () {
    (0, _jquery2.default)(".cwm-account-form, .my-account_Wrapper").show();
    (0, _jquery2.default)("a.edit-view-details, #form-successful-messgae").hide();

    (0, _jquery2.default)('html,body').animate({
        scrollTop: (0, _jquery2.default)(".cwm-account-form").offset().top - 220 }, '2000');
});

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
    (0, _jquery2.default)('#cwm-user-name').text((0, _jquery2.default)('#currentUser').val());
});

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
    var myAccountDelete = (0, _jquery2.default)('#cwm_deleteAccount_yesdelete');
    myAccountDelete.on('click', function () {
        (0, _jquery2.default)('html').css({ 'overflow-y': "hidden" });
        (0, _jquery2.default)("#cwm-overlay").show();
        _jquery2.default.ajax({
            type: "DELETE",
            url: "/api/sitecore/CWMAccountManagement/DeleteBankDetails",
            success: function success(response) {
                console.log(response.success);
                window.location.reload();
            },
            error: function error(response) {
                (0, _jquery2.default)('html').css({ 'overflow-y': "scroll" });
                (0, _jquery2.default)("#cwm-overlay").hide();
                console.log(response.error);
            }
        });
    });
});

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)("a.edit-bank-details-uk").click(function () {
    (0, _jquery2.default)('.cwm-banking-details .view-bankdetails').hide();
    (0, _jquery2.default)('a.edit-bank-details-uk').hide();
    (0, _jquery2.default)(".cwm-editviewdeatails-form").show();
    (0, _jquery2.default)("#bankDetails_editForm").show();

    (0, _jquery2.default)('html,body').animate({
        scrollTop: (0, _jquery2.default)(".cwm-editviewdeatails-form").offset().top - 100 }, '2000');
});
(0, _jquery2.default)("a.edit-bank-details-int").click(function () {
    (0, _jquery2.default)('.cwm-banking-details .view-bankdetails').hide();
    (0, _jquery2.default)('a.edit-bank-details-int').hide();
    (0, _jquery2.default)(".cwm-editviewdeatails-form").show();
    (0, _jquery2.default)("#cwm-internationalbank-form").show();

    (0, _jquery2.default)('html,body').animate({
        scrollTop: (0, _jquery2.default)(".cwm-editviewdeatails-form").offset().top - 100 }, '2000');
});
(0, _jquery2.default)("a.uk-acc-link").click(function () {
    (0, _jquery2.default)('.cwm-banking-details .view-bankdetails').hide();
    (0, _jquery2.default)(".cwm-editviewdeatails-form").show();
    (0, _jquery2.default)("#bankDetails_editForm").show();
    (0, _jquery2.default)('html,body').animate({
        scrollTop: (0, _jquery2.default)(".cwm-editviewdeatails-form").offset().top - 100 }, '2000');
});

(0, _jquery2.default)("a.others-acc-link").click(function () {
    (0, _jquery2.default)('.cwm-banking-details .view-bankdetails').hide();
    (0, _jquery2.default)(".cwm-editviewdeatails-form").show();
    (0, _jquery2.default)("#cwm-internationalbank-form").show();
    (0, _jquery2.default)('html,body').animate({
        scrollTop: (0, _jquery2.default)(".cwm-editviewdeatails-form").offset().top - 100 }, '2000');
});

//masking for account  no. view
function accountMask() {

    var maskNumber = (0, _jquery2.default)("#cwm-account-no").text();

    var string = String(maskNumber);

    var sliced = string.slice(-4);

    var mask = String(sliced).padStart(string.length, "*");

    return mask;
}

var maskedNumber = accountMask();
(0, _jquery2.default)('#cwm-account-no').empty().append(maskedNumber);

function ibanMask() {

    var maskNumber1 = (0, _jquery2.default)("#cwm-iban-no").text();

    var string1 = String(maskNumber1);

    var sliced1 = string1.slice(-4);

    var mask1 = String(sliced1).padStart(string1.length, "*");

    return mask1;
}

var maskedNumber1 = ibanMask();
(0, _jquery2.default)('#cwm-iban-no').empty().append(maskedNumber1);

//  swiftMask
function swiftMask() {

    var maskNumber2 = (0, _jquery2.default)("#cwm-swiftbic-no").text();

    var string2 = String(maskNumber2);

    var sliced2 = string2.slice(-2);

    var mask2 = String(sliced2).padStart(string2.length, "*");

    return mask2;
}

var maskedNumber2 = swiftMask();
(0, _jquery2.default)('#cwm-swiftbic-no').empty().append(maskedNumber2);

//Masking for short code view

var mainStr = (0, _jquery2.default)("#cwm-short-code").text(),
    vis = mainStr.slice(-2),
    countNum = '';

for (var i = mainStr.length - 4; i > 0; i--) {

    countNum += '*';
}

var xsol = countNum + vis;

// alert(xsol);

function separateStr(str, divider, n) {

    var ret = [];

    for (var _i = 0; _i < str.length; _i = _i + n) {

        ret.push(str.substr(_i, n));
    };

    return ret.join(divider);
};
var solution = separateStr(xsol, '-', 2);

(0, _jquery2.default)("#cwm-short-code").text(solution);

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
    var bankDetailsData = null;
    var iBankDetailsData = null;

    (0, _jquery2.default)("#cwm_bd_sortCode").mask("00-00-00");
    //hiding edit form 
    (0, _jquery2.default)('.cwm-editviewdeatails-form').hide();
    // close button 
    (0, _jquery2.default)("#cwm-editbankDetails-formClose").on("click", function () {
        window.location.reload();
    });

    // enable and disable submit button
    (0, _jquery2.default)('#bankDetails_editForm input.my-account_formControl').on('keyup', function () {
        if ((0, _jquery2.default)("#cwm_bd_nameOfBank").val() != '' || (0, _jquery2.default)("#cwm_bd_nameOnAccount").val() != '' || (0, _jquery2.default)("#cwm_bd_accountNumber").val() != '' || (0, _jquery2.default)("#cwm_bd_sortCode").val() != '' || (0, _jquery2.default)("#cwm_bd_bankAddress").val() != '' || (0, _jquery2.default)("#cwm_bd_bankpostCode").val() != '') {
            (0, _jquery2.default)('#mybankDetailsedit-form').attr('disabled', false);
        } else {
            (0, _jquery2.default)('#mybankDetailsedit-form').attr('disabled', true);
        }
    });
    //for small to uppercase letters
    (0, _jquery2.default)('#cwm_bd_bankpostCode').keyup(function () {
        this.value = this.value.toLocaleUpperCase();
    });
    (0, _jquery2.default)('#cwm_Intbank_postCode').keyup(function () {
        this.value = this.value.toLocaleUpperCase();
    });
    (0, _jquery2.default)('#cwm_Intbank_bic').keyup(function () {
        this.value = this.value.toLocaleUpperCase();
    });
    // International Bank enable and disable submit button
    (0, _jquery2.default)('#cwm-internationalbank-form input.my-account_formControl').on('keyup', function () {
        if ((0, _jquery2.default)("#cwm_Intbank_nameOnAccount").val() != '' || (0, _jquery2.default)("#cwm_Intbank_Accountnum").val() != '' || (0, _jquery2.default)("#cwm_Intbank_iban").val() != '' || (0, _jquery2.default)("#cwm_Intbank_bic").val() != '' || (0, _jquery2.default)("#cwm_Intbank_bankName").val() != '' || (0, _jquery2.default)("#cwm_Intbank_houseName").val() != '' || (0, _jquery2.default)("cwm_Intbank_postCode").val() != '') {
            (0, _jquery2.default)('#cwm_IntbankSubmit-form').attr('disabled', false);
        } else {
            (0, _jquery2.default)('#cwm_IntbankSubmit-form').attr('disabled', true);
        }
    });

    //Edit Bank details form: ajax request
    (0, _jquery2.default)('#mybankDetailsedit-form').on("click", function () {

        // assigning Bank details form values and names in to var
        bankDetailsData = {
            BankName: (0, _jquery2.default)("#cwm_bd_nameOfBank").val(),
            NameOfAccountHolder: (0, _jquery2.default)("#cwm_bd_nameOnAccount").val(),
            AccountNumber: (0, _jquery2.default)("#cwm_bd_accountNumber").val(),
            SortCode: (0, _jquery2.default)("#cwm_bd_sortCode").val(),
            AddressLine1: (0, _jquery2.default)("#cwm_bd_bankAddress").val(),
            PostCode: (0, _jquery2.default)("#cwm_bd_bankpostCode").val(),
            BankDetailType: 0,
            BankDetailId: (0, _jquery2.default)("#BankDetailId").val(),
            BankAddressId: (0, _jquery2.default)("#BankAddressId").val(),
            AccountName: (0, _jquery2.default)("#cwm_bd_nameOnAccount").val()
        };

        //onlynumbers and Uppercase letters
        _jquery2.default.validator.addMethod("postalcode", function (value, element) {
            return this.optional(element) || value == value.match(/^[A-Z0-9\s]*$/);
        });

        (0, _jquery2.default)("#bankDetails_editForm").validate({
            wrapper: 'span',
            errorPlacement: function errorPlacement(error, element) {
                error.addClass("my-account_errorlabel");
                error.insertAfter(element);
            },
            rules: {
                cwm_bd_nameOfBank: {
                    maxlength: 255
                },
                cwm_bd_bankAddress: {
                    maxlength: 255
                },
                cwm_bd_bankpostCode: {
                    postalcode: true,
                    maxlength: 8
                },
                cwm_bd_nameOnAccount: {
                    required: true,
                    maxlength: 255
                },
                cwm_bd_accountNumber: {
                    required: true,
                    number: true,
                    maxlength: 8,
                    minlength: 8
                },
                cwm_bd_sortCode: {
                    required: true,
                    minlength: 8,
                    maxlength: 8

                }
            },
            messages: {
                cwm_bd_nameOfBank: {
                    maxlength: "Please enter no more than 255 characters."
                },
                cwm_bd_bankAddress: {
                    maxlength: "Please enter no more than 255 characters."
                },
                cwm_bd_bankpostCode: {
                    postalcode: "Please enter a valid postcode.",
                    maxlength: "Please enter no more than 8 characters."
                },
                cwm_bd_nameOnAccount: {
                    required: "Please enter name on account.",
                    maxlength: "Please enter no more than 255 characters."
                },
                cwm_bd_accountNumber: {
                    required: "Please enter account number.",
                    number: "Please enter a valid account number.",
                    minlength: "Please enter a valid account number.",
                    maxlength: "Please enter no more than 8 characters."
                },
                cwm_bd_sortCode: {
                    required: "Please enter sort code.",
                    minlength: "Please enter a valid sortcode.",
                    maxlength: "Please enter a valid sortcode."
                }
            },

            submitHandler: function submitHandler(form) {
                (0, _jquery2.default)('html').css({ 'overflow-y': "hidden" });
                (0, _jquery2.default)("#cwm-overlay").show();
                _jquery2.default.ajax({
                    url: form.action,
                    type: form.method,
                    data: bankDetailsData,
                    dataType: "json",
                    success: function success(response) {
                        (0, _jquery2.default)('html').css({ 'overflow-y': "scroll" });
                        (0, _jquery2.default)("#cwm-overlay").hide();
                        (0, _jquery2.default)(".cwm-status-msg__container.status-success").css('display', 'flex').delay(3000).queue(function (n) {
                            (0, _jquery2.default)(this).hide();n();
                            (0, _jquery2.default)('.cwm-view-details').show();
                            window.location.reload();
                        });
                        (0, _jquery2.default)('html,body').animate({
                            scrollTop: (0, _jquery2.default)(".cwm-status-msg__container").offset().top - 300 }, '1000');
                        (0, _jquery2.default)('html,body').animate({
                            scrollTop: (0, _jquery2.default)(".cwm-view-details.view-bankdetails'").offset().top - 300 }, '1000');
                    },
                    error: function error(response) {
                        (0, _jquery2.default)('html').css({ 'overflow-y': "scroll" });
                        (0, _jquery2.default)("#cwm-overlay").hide();
                        console.log(response.success);
                        (0, _jquery2.default)(".cwm-status-msg__container.status-error").css('display', 'flex').delay(3000).queue(function (n) {
                            (0, _jquery2.default)(this).hide();n();
                        });
                        (0, _jquery2.default)('html,body').animate({
                            scrollTop: (0, _jquery2.default)(".cwm-status-msg__container").offset().top - 300 }, '1000');
                    }
                });
            }
        });
    });

    (0, _jquery2.default)("#cwm_Intbank_Accountnum").keyup(function () {
        if ((0, _jquery2.default)("#cwm_Intbank_Accountnum").val().length != '' || (0, _jquery2.default)("#cwm_Intbank_iban").val().length != '') {
            (0, _jquery2.default)("#cwm_Intbank_iban").removeClass('error');
            (0, _jquery2.default)('#cwm_Intbank_iban-error').hide();
            (0, _jquery2.default)('#cwm_Intbank_iban-error').parent('span.my-account_errorlabel').hide();
        }
    });
    (0, _jquery2.default)("#cwm_Intbank_iban").keyup(function () {
        if ((0, _jquery2.default)("#cwm_Intbank_Accountnum").val().length != '' || (0, _jquery2.default)("#cwm_Intbank_iban").val().length != '') {
            (0, _jquery2.default)("#cwm_Intbank_Accountnum").removeClass('error');
            (0, _jquery2.default)("#cwm_Intbank_Accountnum-error").hide();
            (0, _jquery2.default)("#cwm_Intbank_Accountnum-error").parent().hide();
        }
    });
    //International Bank Edit Bank details form: ajax request
    (0, _jquery2.default)('#cwm_IntbankSubmit-form').on("click", function () {

        iBankDetailsData = {
            BankName: (0, _jquery2.default)("#cwm_Intbank_bankName").val(),
            NameOfAccountHolder: (0, _jquery2.default)("#cwm_Intbank_nameOnAccount").val(),
            AccountNumber: (0, _jquery2.default)("#cwm_Intbank_Accountnum").val(),
            Iban: (0, _jquery2.default)("#cwm_Intbank_iban").val(),
            Swift_Bic_Code: (0, _jquery2.default)("#cwm_Intbank_bic").val(),
            AddressLine1: (0, _jquery2.default)("#cwm_Intbank_houseName").val(),
            PostCode: (0, _jquery2.default)("#cwm_Intbank_postCode").val(),
            BankDetailType: 1,
            BankDetailId: (0, _jquery2.default)("#BankDetailId").val(),
            BankAddressId: (0, _jquery2.default)("#BankAddressId").val(),
            AccountName: (0, _jquery2.default)("#cwm_Intbank_nameOnAccount").val()

            //onlynumbers and Uppercase letters and symbol/^[A-Z0-9\s]*$/
        };_jquery2.default.validator.addMethod("postalcode", function (value, element) {
            return this.optional(element) || value == value.match(/^[A-Z0-9 -_]*$/);
        });
        //only accept letters and numbers 
        _jquery2.default.validator.addMethod("bicletters", function (value, element) {
            return this.optional(element) || value == value.match(/^[a-zA-Z0-9\s]*$/);
        });

        (0, _jquery2.default)("#cwm-internationalbank-form").validate({
            wrapper: 'span',
            errorPlacement: function errorPlacement(error, element) {
                error.addClass("my-account_errorlabel");
                error.insertAfter(element);
            },
            rules: {
                cwm_Intbank_nameOnAccount: {
                    required: true,
                    maxlength: 255
                },
                cwm_Intbank_bic: {
                    required: true,
                    bicletters: true,
                    maxlength: 11
                },
                cwm_Intbank_Accountnum: {
                    required: function required(element) {
                        if ((0, _jquery2.default)("#cwm_Intbank_Accountnum").val() == '' && (0, _jquery2.default)("#cwm_Intbank_iban").val() == '') {
                            return true;
                        } else {
                            return false;
                        }
                    },
                    maxlength: 20,
                    number: true
                },
                cwm_Intbank_iban: {
                    required: function required(element) {
                        if ((0, _jquery2.default)("#cwm_Intbank_Accountnum").val() == '' && (0, _jquery2.default)("#cwm_Intbank_iban").val() == '') {
                            return true;
                        } else {
                            return false;
                        }
                    },
                    maxlength: 34,
                    number: true
                },
                cwm_Intbank_bankName: {
                    maxlength: 255
                },
                cwm_Intbank_houseName: {
                    maxlength: 255
                },
                cwm_Intbank_postCode: {
                    postalcode: true,
                    maxlength: 12
                }
            },
            messages: {
                cwm_Intbank_nameOnAccount: {
                    required: "Please enter name on account.",
                    maxlength: "Please enter no more than 255 characters."
                },
                cwm_Intbank_bic: {
                    required: "Please enter SWIFT/BIC/Routing number.",
                    bicletters: "Please enter a valid SWIFT/BIC/Routing number.",
                    maxlength: "Please enter no more than 11 characters."
                },
                cwm_Intbank_Accountnum: {
                    maxlength: "Please enter no more than 20 characters.",
                    number: "Please enter a valid account number.",
                    required: "Please enter either IBAN or account number."
                },
                cwm_Intbank_iban: {
                    required: "Please enter either IBAN or account number.",
                    maxlength: "Please enter no more than 34 characters.",
                    number: "Please enter a valid IBAN numbers."
                },
                cwm_Intbank_bankName: {
                    maxlength: "Please enter no more than 255 characters."
                },
                cwm_Intbank_houseName: {
                    maxlength: "Please enter no more than 255 characters."
                },
                cwm_Intbank_postCode: {
                    postalcode: "Please enter a valid postcode/zipcode.",
                    maxlength: "Please enter no more than 12 characters."
                }
            },

            submitHandler: function submitHandler(form) {
                (0, _jquery2.default)('html').css({ 'overflow-y': "hidden" });
                (0, _jquery2.default)("#cwm-overlay").show();
                _jquery2.default.ajax({
                    url: form.action,
                    type: form.method,
                    data: iBankDetailsData,
                    dataType: "json",
                    success: function success(response) {
                        (0, _jquery2.default)('html').css({ 'overflow-y': "scroll" });
                        (0, _jquery2.default)("#cwm-overlay").hide();
                        (0, _jquery2.default)(".cwm-status-msg__container.status-success").css('display', 'flex').delay(3000).queue(function (n) {
                            (0, _jquery2.default)(this).hide();n();
                            (0, _jquery2.default)('.cwm-view-details').show();
                            window.location.reload();
                        });
                        (0, _jquery2.default)('html,body').animate({
                            scrollTop: (0, _jquery2.default)(".cwm-status-msg__container").offset().top - 300 }, '1000');
                        (0, _jquery2.default)('html,body').animate({
                            scrollTop: (0, _jquery2.default)('.cwm-view-details.view-bankdetails').offset().top - 300 }, '1000');
                    },
                    error: function error(response) {
                        (0, _jquery2.default)('html').css({ 'overflow-y': "scroll" });
                        (0, _jquery2.default)("#cwm-overlay").hide();
                        console.log(response.success);
                        (0, _jquery2.default)(".cwm-status-msg__container.status-error").css('display', 'flex').delay(3000).queue(function (n) {
                            (0, _jquery2.default)(this).hide();n();
                        });
                        (0, _jquery2.default)('html,body').animate({
                            scrollTop: (0, _jquery2.default)(".cwm-status-msg__container").offset().top - 300 }, '1000');
                    }
                });
            }
        });
    });
});

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * jquery.mask.js
 * @version: v1.14.10
 * @author: Igor Escobar
 *
 * Created by Igor Escobar on 2012-03-10. Please report any bug at http://blog.igorescobar.com
 *
 * Copyright (c) 2012 Igor Escobar http://blog.igorescobar.com
 *
 * The MIT License (http://www.opensource.org/licenses/mit-license.php)
 *
 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following
 * conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 * OTHER DEALINGS IN THE SOFTWARE.
 */

/* jshint laxbreak: true */
/* jshint maxcomplexity:17 */
/* global define */



// UMD (Universal Module Definition) patterns for JavaScript modules that work everywhere.
// https://github.com/umdjs/umd/blob/master/jqueryPluginCommonjs.js

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (factory, jQuery, Zepto) {

    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery || Zepto);
    }
})(function ($) {

    var Mask = function Mask(el, mask, options) {

        var p = {
            invalid: [],
            getCaret: function getCaret() {
                try {
                    var sel,
                        pos = 0,
                        ctrl = el.get(0),
                        dSel = document.selection,
                        cSelStart = ctrl.selectionStart;

                    // IE Support
                    if (dSel && navigator.appVersion.indexOf('MSIE 10') === -1) {
                        sel = dSel.createRange();
                        sel.moveStart('character', -p.val().length);
                        pos = sel.text.length;
                    }
                    // Firefox support
                    else if (cSelStart || cSelStart === '0') {
                            pos = cSelStart;
                        }

                    return pos;
                } catch (e) {}
            },
            setCaret: function setCaret(pos) {
                try {
                    if (el.is(':focus')) {
                        var range,
                            ctrl = el.get(0);

                        // Firefox, WebKit, etc..
                        if (ctrl.setSelectionRange) {
                            ctrl.setSelectionRange(pos, pos);
                        } else {
                            // IE
                            range = ctrl.createTextRange();
                            range.collapse(true);
                            range.moveEnd('character', pos);
                            range.moveStart('character', pos);
                            range.select();
                        }
                    }
                } catch (e) {}
            },
            events: function events() {
                el.on('keydown.mask', function (e) {
                    el.data('mask-keycode', e.keyCode || e.which);
                    el.data('mask-previus-value', el.val());
                }).on($.jMaskGlobals.useInput ? 'input.mask' : 'keyup.mask', p.behaviour).on('paste.mask drop.mask', function () {
                    setTimeout(function () {
                        el.keydown().keyup();
                    }, 100);
                }).on('change.mask', function () {
                    el.data('changed', true);
                }).on('blur.mask', function () {
                    if (oldValue !== p.val() && !el.data('changed')) {
                        el.trigger('change');
                    }
                    el.data('changed', false);
                })
                // it's very important that this callback remains in this position
                // otherwhise oldValue it's going to work buggy
                .on('blur.mask', function () {
                    oldValue = p.val();
                })
                // select all text on focus
                .on('focus.mask', function (e) {
                    if (options.selectOnFocus === true) {
                        $(e.target).select();
                    }
                })
                // clear the value if it not complete the mask
                .on('focusout.mask', function () {
                    if (options.clearIfNotMatch && !regexMask.test(p.val())) {
                        p.val('');
                    }
                });
            },
            getRegexMask: function getRegexMask() {
                var maskChunks = [],
                    translation,
                    pattern,
                    optional,
                    recursive,
                    oRecursive,
                    r;

                for (var i = 0; i < mask.length; i++) {
                    translation = jMask.translation[mask.charAt(i)];

                    if (translation) {

                        pattern = translation.pattern.toString().replace(/.{1}$|^.{1}/g, '');
                        optional = translation.optional;
                        recursive = translation.recursive;

                        if (recursive) {
                            maskChunks.push(mask.charAt(i));
                            oRecursive = { digit: mask.charAt(i), pattern: pattern };
                        } else {
                            maskChunks.push(!optional && !recursive ? pattern : pattern + '?');
                        }
                    } else {
                        maskChunks.push(mask.charAt(i).replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'));
                    }
                }

                r = maskChunks.join('');

                if (oRecursive) {
                    r = r.replace(new RegExp('(' + oRecursive.digit + '(.*' + oRecursive.digit + ')?)'), '($1)?').replace(new RegExp(oRecursive.digit, 'g'), oRecursive.pattern);
                }

                return new RegExp(r);
            },
            destroyEvents: function destroyEvents() {
                el.off(['input', 'keydown', 'keyup', 'paste', 'drop', 'blur', 'focusout', ''].join('.mask '));
            },
            val: function val(v) {
                var isInput = el.is('input'),
                    method = isInput ? 'val' : 'text',
                    r;

                if (arguments.length > 0) {
                    if (el[method]() !== v) {
                        el[method](v);
                    }
                    r = el;
                } else {
                    r = el[method]();
                }

                return r;
            },
            calculateCaretPosition: function calculateCaretPosition(caretPos, newVal) {
                var newValL = newVal.length,
                    oValue = el.data('mask-previus-value') || '',
                    oValueL = oValue.length;

                // edge cases when erasing digits
                if (el.data('mask-keycode') === 8 && oValue !== newVal) {
                    caretPos = caretPos - (newVal.slice(0, caretPos).length - oValue.slice(0, caretPos).length);

                    // edge cases when typing new digits
                } else if (oValue !== newVal) {
                    // if the cursor is at the end keep it there
                    if (caretPos >= oValueL) {
                        caretPos = newValL;
                    } else {
                        caretPos = caretPos + (newVal.slice(0, caretPos).length - oValue.slice(0, caretPos).length);
                    }
                }

                return caretPos;
            },
            behaviour: function behaviour(e) {
                e = e || window.event;
                p.invalid = [];

                var keyCode = el.data('mask-keycode');

                if ($.inArray(keyCode, jMask.byPassKeys) === -1) {
                    var newVal = p.getMasked(),
                        caretPos = p.getCaret();

                    setTimeout(function (caretPos, newVal) {
                        p.setCaret(p.calculateCaretPosition(caretPos, newVal));
                    }, 10, caretPos, newVal);

                    p.val(newVal);
                    p.setCaret(caretPos);
                    return p.callbacks(e);
                }
            },
            getMasked: function getMasked(skipMaskChars, val) {
                var buf = [],
                    value = val === undefined ? p.val() : val + '',
                    m = 0,
                    maskLen = mask.length,
                    v = 0,
                    valLen = value.length,
                    offset = 1,
                    addMethod = 'push',
                    resetPos = -1,
                    lastMaskChar,
                    check;

                if (options.reverse) {
                    addMethod = 'unshift';
                    offset = -1;
                    lastMaskChar = 0;
                    m = maskLen - 1;
                    v = valLen - 1;
                    check = function check() {
                        return m > -1 && v > -1;
                    };
                } else {
                    lastMaskChar = maskLen - 1;
                    check = function check() {
                        return m < maskLen && v < valLen;
                    };
                }

                var lastUntranslatedMaskChar;
                while (check()) {
                    var maskDigit = mask.charAt(m),
                        valDigit = value.charAt(v),
                        translation = jMask.translation[maskDigit];

                    if (translation) {
                        if (valDigit.match(translation.pattern)) {
                            buf[addMethod](valDigit);
                            if (translation.recursive) {
                                if (resetPos === -1) {
                                    resetPos = m;
                                } else if (m === lastMaskChar) {
                                    m = resetPos - offset;
                                }

                                if (lastMaskChar === resetPos) {
                                    m -= offset;
                                }
                            }
                            m += offset;
                        } else if (valDigit === lastUntranslatedMaskChar) {
                            // matched the last untranslated (raw) mask character that we encountered
                            // likely an insert offset the mask character from the last entry; fall
                            // through and only increment v
                            lastUntranslatedMaskChar = undefined;
                        } else if (translation.optional) {
                            m += offset;
                            v -= offset;
                        } else if (translation.fallback) {
                            buf[addMethod](translation.fallback);
                            m += offset;
                            v -= offset;
                        } else {
                            p.invalid.push({ p: v, v: valDigit, e: translation.pattern });
                        }
                        v += offset;
                    } else {
                        if (!skipMaskChars) {
                            buf[addMethod](maskDigit);
                        }

                        if (valDigit === maskDigit) {
                            v += offset;
                        } else {
                            lastUntranslatedMaskChar = maskDigit;
                        }

                        m += offset;
                    }
                }

                var lastMaskCharDigit = mask.charAt(lastMaskChar);
                if (maskLen === valLen + 1 && !jMask.translation[lastMaskCharDigit]) {
                    buf.push(lastMaskCharDigit);
                }

                return buf.join('');
            },
            callbacks: function callbacks(e) {
                var val = p.val(),
                    changed = val !== oldValue,
                    defaultArgs = [val, e, el, options],
                    callback = function callback(name, criteria, args) {
                    if (typeof options[name] === 'function' && criteria) {
                        options[name].apply(this, args);
                    }
                };

                callback('onChange', changed === true, defaultArgs);
                callback('onKeyPress', changed === true, defaultArgs);
                callback('onComplete', val.length === mask.length, defaultArgs);
                callback('onInvalid', p.invalid.length > 0, [val, e, el, p.invalid, options]);
            }
        };

        el = $(el);
        var jMask = this,
            oldValue = p.val(),
            regexMask;

        mask = typeof mask === 'function' ? mask(p.val(), undefined, el, options) : mask;

        // public methods
        jMask.mask = mask;
        jMask.options = options;
        jMask.remove = function () {
            var caret = p.getCaret();
            p.destroyEvents();
            p.val(jMask.getCleanVal());
            p.setCaret(caret);
            return el;
        };

        // get value without mask
        jMask.getCleanVal = function () {
            return p.getMasked(true);
        };

        // get masked value without the value being in the input or element
        jMask.getMaskedVal = function (val) {
            return p.getMasked(false, val);
        };

        jMask.init = function (onlyMask) {
            onlyMask = onlyMask || false;
            options = options || {};

            jMask.clearIfNotMatch = $.jMaskGlobals.clearIfNotMatch;
            jMask.byPassKeys = $.jMaskGlobals.byPassKeys;
            jMask.translation = $.extend({}, $.jMaskGlobals.translation, options.translation);

            jMask = $.extend(true, {}, jMask, options);

            regexMask = p.getRegexMask();

            if (onlyMask) {
                p.events();
                p.val(p.getMasked());
            } else {
                if (options.placeholder) {
                    el.attr('placeholder', options.placeholder);
                }

                // this is necessary, otherwise if the user submit the form
                // and then press the "back" button, the autocomplete will erase
                // the data. Works fine on IE9+, FF, Opera, Safari.
                if (el.data('mask')) {
                    el.attr('autocomplete', 'off');
                }

                // detect if is necessary let the user type freely.
                // for is a lot faster than forEach.
                for (var i = 0, maxlength = true; i < mask.length; i++) {
                    var translation = jMask.translation[mask.charAt(i)];
                    if (translation && translation.recursive) {
                        maxlength = false;
                        break;
                    }
                }

                if (maxlength) {
                    el.attr('maxlength', mask.length);
                }

                p.destroyEvents();
                p.events();

                var caret = p.getCaret();
                p.val(p.getMasked());
                p.setCaret(caret);
            }
        };

        jMask.init(!el.is('input'));
    };

    $.maskWatchers = {};
    var HTMLAttributes = function HTMLAttributes() {
        var input = $(this),
            options = {},
            prefix = 'data-mask-',
            mask = input.attr('data-mask');

        if (input.attr(prefix + 'reverse')) {
            options.reverse = true;
        }

        if (input.attr(prefix + 'clearifnotmatch')) {
            options.clearIfNotMatch = true;
        }

        if (input.attr(prefix + 'selectonfocus') === 'true') {
            options.selectOnFocus = true;
        }

        if (notSameMaskObject(input, mask, options)) {
            return input.data('mask', new Mask(this, mask, options));
        }
    },
        notSameMaskObject = function notSameMaskObject(field, mask, options) {
        options = options || {};
        var maskObject = $(field).data('mask'),
            stringify = JSON.stringify,
            value = $(field).val() || $(field).text();
        try {
            if (typeof mask === 'function') {
                mask = mask(value);
            }
            return (typeof maskObject === 'undefined' ? 'undefined' : _typeof(maskObject)) !== 'object' || stringify(maskObject.options) !== stringify(options) || maskObject.mask !== mask;
        } catch (e) {}
    },
        eventSupported = function eventSupported(eventName) {
        var el = document.createElement('div'),
            isSupported;

        eventName = 'on' + eventName;
        isSupported = eventName in el;

        if (!isSupported) {
            el.setAttribute(eventName, 'return;');
            isSupported = typeof el[eventName] === 'function';
        }
        el = null;

        return isSupported;
    };

    $.fn.mask = function (mask, options) {
        options = options || {};
        var selector = this.selector,
            globals = $.jMaskGlobals,
            interval = globals.watchInterval,
            watchInputs = options.watchInputs || globals.watchInputs,
            maskFunction = function maskFunction() {
            if (notSameMaskObject(this, mask, options)) {
                return $(this).data('mask', new Mask(this, mask, options));
            }
        };

        $(this).each(maskFunction);

        if (selector && selector !== '' && watchInputs) {
            clearInterval($.maskWatchers[selector]);
            $.maskWatchers[selector] = setInterval(function () {
                $(document).find(selector).each(maskFunction);
            }, interval);
        }
        return this;
    };

    $.fn.masked = function (val) {
        return this.data('mask').getMaskedVal(val);
    };

    $.fn.unmask = function () {
        clearInterval($.maskWatchers[this.selector]);
        delete $.maskWatchers[this.selector];
        return this.each(function () {
            var dataMask = $(this).data('mask');
            if (dataMask) {
                dataMask.remove().removeData('mask');
            }
        });
    };

    $.fn.cleanVal = function () {
        return this.data('mask').getCleanVal();
    };

    $.applyDataMask = function (selector) {
        selector = selector || $.jMaskGlobals.maskElements;
        var $selector = selector instanceof $ ? selector : $(selector);
        $selector.filter($.jMaskGlobals.dataMaskAttr).each(HTMLAttributes);
    };

    var globals = {
        maskElements: 'input,td,span,div',
        dataMaskAttr: '*[data-mask]',
        dataMask: true,
        watchInterval: 300,
        watchInputs: true,
        // old versions of chrome dont work great with input event
        useInput: !/Chrome\/[2-4][0-9]|SamsungBrowser/.test(window.navigator.userAgent) && eventSupported('input'),
        watchDataMask: false,
        byPassKeys: [9, 16, 17, 18, 36, 37, 38, 39, 40, 91],
        translation: {
            '0': { pattern: /\d/ },
            '9': { pattern: /\d/, optional: true },
            '#': { pattern: /\d/, recursive: true },
            'A': { pattern: /[a-zA-Z0-9]/ },
            'S': { pattern: /[a-zA-Z]/ }
        }
    };

    $.jMaskGlobals = $.jMaskGlobals || {};
    globals = $.jMaskGlobals = $.extend(true, {}, globals, $.jMaskGlobals);

    // looking for inputs with data-mask attribute
    if (globals.dataMask) {
        $.applyDataMask();
    }

    setInterval(function () {
        if ($.jMaskGlobals.watchDataMask) {
            $.applyDataMask();
        }
    }, globals.watchInterval);
}, window.jQuery, window.Zepto);

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {

    var minHeight = parseInt(0);

    (0, _jquery2.default)(".event-card__title").each(function () {
        if ((0, _jquery2.default)(this).outerHeight() > minHeight) {
            minHeight = (0, _jquery2.default)(this).outerHeight();
        }
    });
    (0, _jquery2.default)('.event-card__title').css('height', minHeight);

    (0, _jquery2.default)(".event-card__text").each(function () {
        if ((0, _jquery2.default)(this).outerHeight() > minHeight) {
            minHeight = (0, _jquery2.default)(this).outerHeight();
        }
    });
    (0, _jquery2.default)('.event-card__text').css('height', minHeight);
});

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
  (0, _jquery2.default)('.cta-show-more').on('click', function () {
    (0, _jquery2.default)('.event-desc__hide').toggle("slide");
    if ((0, _jquery2.default)('.cta-show-more').find('.cta--text').text() == "Show More") {
      (0, _jquery2.default)(this).find('.cta--text').text("Show Less");
      (0, _jquery2.default)(this).find('.cta--down-arrow-icon').css('transform', 'rotate(180deg)');
    } else {
      (0, _jquery2.default)(this).find('.cta--text').text("Show More");
      (0, _jquery2.default)(this).find('.cta--down-arrow-icon').css('transform', 'rotate(0deg)');
    }
  });
});

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(window).on('load', function () {
    var cwmPageSize = parseInt((0, _jquery2.default)('.cwm-fa-filter-content').first().data('page-size'));
    var cwmCurrentVisibleItems = cwmPageSize;
    var cwmTotalFiltered = 0;

    function cwmFilter(e, scroll) {
        var $allElements = (0, _jquery2.default)('.cwm-fa-filter-content').find('.cwm-fa-filter-content__item');
        cwmTotalFiltered = $allElements.length;
        var $visibleElements = $allElements.slice(0, cwmCurrentVisibleItems);
        var scrollTo = (0, _jquery2.default)(".show-more-wrapper #showMore");
        if (scrollTo.length) {
            var newTop = scrollTo.offset().top;
        }
        var x = 0;
        (0, _jquery2.default)('.cwm-fa-filter-content').find('.cwm-fa-filter-content__item').hide();
        $visibleElements.fadeIn(10, function () {
            if (x < $visibleElements.length - 1) {
                x++;
            } else {
                if (scroll) {
                    (0, _jquery2.default)('body,html').animate({ scrollTop: newTop }, 500);
                }
            }
        });
    }

    function cwmShowHideButtons() {
        if (cwmCurrentVisibleItems >= cwmTotalFiltered) {
            (0, _jquery2.default)('.show-more-wrapper #showMore').hide();
        } else {
            (0, _jquery2.default)('.show-more-wrapper #showMore').show();
        }
    }

    (0, _jquery2.default)('.show-more-wrapper #showMore').click(function (e) {
        cwmCurrentVisibleItems += cwmPageSize;
        cwmFilter(e, true);
        cwmShowHideButtons();
    });
    cwmFilter();
    cwmShowHideButtons();
});

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
    var urlString = window.location.href;
    var paramString = urlString.split('?')[1];
    var queryString = new URLSearchParams(paramString);
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = queryString.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var pair = _step.value;

            (0, _jquery2.default)("#" + pair[0]).val(pair[1]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    if (queryString != "") {

        (0, _jquery2.default)('html,body').animate({
            scrollTop: (0, _jquery2.default)(".cwm-fa-form-filters").offset().top - 150 }, '2000');
    }

    (0, _jquery2.default)(".cwm-fa-form-filters select.cwm-filter-data").change(function () {
        var url = window.location.href;
        var currentUrl = new URL(url);
        currentUrl.searchParams.set((0, _jquery2.default)(this).attr("id"), (0, _jquery2.default)(this).val());
        window.location.replace(currentUrl);
        if ((0, _jquery2.default)("#eventCategory").val() == "connection-event") {
            var index_val = document.getElementById("eventType").selectedIndex = "1";
            var _queryString = currentUrl.search; // get url parameters
            var params = new URLSearchParams(_queryString); // create url search params object
            params.delete('eventType'); // delete eventtype parameter if it exists, in case you change the dropdown more then once
            document.location.href = "?" + params.toString(); // refresh the page with new url
        } else {
            var _index_val = document.getElementById("eventType").selectedIndex = "1";
            var queryString1 = currentUrl.search; // get url parameters
            var params1 = new URLSearchParams(queryString1); // create url search params objec
            params1.delete('eventType'); // delete eventtype parameter if it exists, in case you change the dropdown more then once
            params1.append('eventType', _index_val.val());
            document.location.href = "?" + params1.toString(); // refresh the page with new url;
        }
    });
});

(0, _jquery2.default)(window).on('load', function () {
    if ((0, _jquery2.default)("#eventCategory").val() == "connection-event") {
        (0, _jquery2.default)("#eventType").prop('disabled', true);
    } else {
        (0, _jquery2.default)("#eventType").prop('disabled', false);
    }
});

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _typeof(obj) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == _typeof2(Symbol.iterator) ? function (obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = _interopRequireDefault(__webpack_require__(283));
var _glide = _interopRequireDefault(__webpack_require__(239));
var _excluded = ["carouselGlideElement", "responsive"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {
    var res = prim.call(input, hint || "default");if (_typeof(res) !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");
  }return (hint === "string" ? String : Number)(input);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}
var _default = function _default(_ref) {
  var carouselGlideElement = _ref.carouselGlideElement,
      _ref$responsive = _ref.responsive,
      responsive = _ref$responsive === void 0 ? [] : _ref$responsive,
      options = _objectWithoutProperties(_ref, _excluded);
  var slides = carouselGlideElement.querySelectorAll('.glide__slides > li');
  var carouselLoop = carouselGlideElement.getAttribute('data-carousel-loop');
  var MOBILE_BREAKPOINT = 1024;
  var glide;
  var glideType4 = slides.length <= 4 ? 'slider' : 'carousel';
  var glideType2 = slides.length <= 2 ? 'slider' : 'carousel';
  // eslint-disable-next-line no-unneeded-ternary
  var isSwipe4 = slides.length <= 4 ? false : true;
  // eslint-disable-next-line no-unneeded-ternary
  var isSwipe2 = slides.length <= 2 ? false : true;
  var breakpointSettings = _objectSpread({
    500: {
      perView: 1,
      peek: {
        before: 40,
        after: 30
      }
    },
    900: {
      perView: 2,
      type: glideType2,
      swipeThreshold: isSwipe2,
      dragThreshold: isSwipe2
    },
    1200: {
      perView: 4,
      type: glideType4,
      swipeThreshold: isSwipe4,
      dragThreshold: isSwipe4
    }
  }, responsive);
  var getCurrentSettings = function getCurrentSettings() {
    var screenWidth = window.innerWidth;

    // Because the `perView` changes at different breakpoints, find
    // the relevant setting for the current screensize.
    // Filter out any settings that are smaller than the current size, and
    // then use the first in the list, as this will be the most relevant.
    // If none are available, assume we are using the biggest setting.

    // TODO: We should be able to reuse this, if we want to change the pagination
    // to scroll full pages, rather than individual items
    var breakpointSettingsForCurrentSize = Object.keys(breakpointSettings).filter(function (i) {
      return parseInt(i, 10) > screenWidth;
    })[0] || Object.keys(breakpointSettings).slice(-1);
    return breakpointSettings[breakpointSettingsForCurrentSize];
  };
  var enablePrevButton = function enablePrevButton() {
    carouselGlideElement.querySelector('.carousel__prev').classList.remove('disabled');
    carouselGlideElement.querySelector('.carousel__prev').removeAttribute('disabled');
  };
  var enableNextButton = function enableNextButton() {
    carouselGlideElement.querySelector('.carousel__next').classList.remove('disabled');
    carouselGlideElement.querySelector('.carousel__next').removeAttribute('disabled');
  };
  var disablePrevButton = function disablePrevButton() {
    carouselGlideElement.querySelector('.carousel__prev').classList.add('disabled');
    carouselGlideElement.querySelector('.carousel__prev').setAttribute('disabled', true);
  };
  var disableNextButton = function disableNextButton() {
    carouselGlideElement.querySelector('.carousel__next').classList.add('disabled');
    carouselGlideElement.querySelector('.carousel__next').setAttribute('disabled', true);
  };
  var showPaginationByPage = function showPaginationByPage() {
    // Glide shows a pagination button for each item, and doesn't provide
    // an option to navigate whole pages at a time.
    // This function hides extra individual dots, so that only the first item of
    // each page is shown. (Based on the `perView` setting).
    var _getCurrentSettings = getCurrentSettings(),
        perView = _getCurrentSettings.perView;
    var paginationElements = carouselGlideElement.querySelectorAll(".glide-carousel__pagination button:not(:nth-child(".concat(perView, "n + 1))"));
    paginationElements.forEach(function (item) {
      item.classList.add('hidden');
    });
    if (carouselLoop && window.innerWidth > MOBILE_BREAKPOINT) {
      return;
    }
    // disabling prev button by default
    disablePrevButton();
  };
  var slideToNext = function slideToNext() {
    var maxPerView = getCurrentSettings().perView;
    carouselGlideElement.querySelector('.carousel__next').addEventListener('click', function (event) {
      var target = event.target;
      var activeDots = 0;
      carouselGlideElement.querySelectorAll('.glide-carousel__pagination > *').forEach(function (dot, index) {
        if (dot.getAttribute('class') === 'glide__bullet--active') {
          activeDots = index;
        }
      });
      var nextSlide = activeDots + maxPerView;
      if (carouselLoop && window.innerWidth > MOBILE_BREAKPOINT) {
        if (nextSlide >= slides.length) {
          glide.go("=0");
        } else {
          glide.go("=".concat(nextSlide));
        }
      } else {
        glide.go("=".concat(nextSlide));
        if (nextSlide + maxPerView >= slides.length) {
          target.closest('button').classList.add('disabled');
          target.closest('button').setAttribute('disabled', true);
        }
        enablePrevButton();
      }
    });
  };
  var slideToPrevious = function slideToPrevious() {
    var maxPerView = getCurrentSettings().perView;
    carouselGlideElement.querySelector('.carousel__prev').addEventListener('click', function (event) {
      var target = event.target;
      var activeDots = 0;
      carouselGlideElement.querySelectorAll('.glide-carousel__pagination > *').forEach(function (dot, index) {
        if (dot.getAttribute('class') === 'glide__bullet--active') {
          activeDots = index;
        }
      });
      var prevSlide = activeDots - maxPerView;
      if (carouselLoop && window.innerWidth > MOBILE_BREAKPOINT) {
        if (prevSlide < 0) {
          var lastslide = Math.floor(slides.length / maxPerView) * maxPerView;
          glide.go("=".concat(lastslide));
        } else {
          glide.go("=".concat(prevSlide));
        }
      } else {
        if (prevSlide >= 0) {
          glide.go("=".concat(prevSlide));
        }
        if (prevSlide - maxPerView < 0) {
          target.closest('button').classList.add('disabled');
          target.closest('button').setAttribute('disabled', true);
        }
        enableNextButton();
      }
    });
  };
  var enableNextPrev = function enableNextPrev() {
    var maxPerView = getCurrentSettings().perView;
    carouselGlideElement.querySelectorAll('.glide-carousel__pagination > *').forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        if (index > 0) {
          enablePrevButton();
        }
        if (index === 0) {
          enableNextButton();
          disablePrevButton();
        }
        if (index + maxPerView >= slides.length) {
          disableNextButton();
        }
        if (index + maxPerView < slides.length) {
          enableNextButton();
        }
      });
    });
  };
  var showHideNavigation = function showHideNavigation() {
    var maxPerView = getCurrentSettings().perView;
    var navigationElements = carouselGlideElement.querySelectorAll('[data-glide-dir]');
    if (!slides || slides.length <= maxPerView) {
      navigationElements.forEach(function (item) {
        return item.classList.add('hidden');
      });
      // eslint-disable-next-line no-param-reassign
      carouselGlideElement.querySelector('.carousel-navigation').style.display = 'none';
      return;
    }
    navigationElements.forEach(function (item) {
      return item.classList.remove('hidden');
    });
    showPaginationByPage();
    // added manual arrow next/previous button action
    slideToNext();
    slideToPrevious();
    enableNextPrev();
  };
  var createPagination = function createPagination() {
    var bulletContainer = document.createElement('div');
    bulletContainer.classList.add('glide-carousel__pagination');
    bulletContainer.dataset.glideEl = 'controls[nav]';
    slides.forEach(function (slide, index) {
      var button = document.createElement('button');
      button.dataset.glideDir = "=".concat(index);
      bulletContainer.appendChild(button);
    });
    carouselGlideElement.querySelector('.carousel-nav-wrapper').appendChild(bulletContainer);
    showHideNavigation();
  };
  createPagination();
  window.addEventListener('resize', (0, _lodash["default"])(function () {
    // Hide the navigation when we don't have more items than we can show on screen
    showHideNavigation();
  }, 250));
  glide = new _glide["default"](carouselGlideElement, _objectSpread({
    perView: 4,
    breakpoints: breakpointSettings,
    type: glideType4,
    swipeThreshold: isSwipe4,
    dragThreshold: isSwipe4
  }, options)).mount();
  return glide;
};
exports["default"] = _default;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _typeof(obj) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == _typeof2(Symbol.iterator) ? function (obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodashDebounce = _interopRequireDefault(__webpack_require__(283));
var _glide = _interopRequireDefault(__webpack_require__(239));
var _excluded = ["imageGalleryElement", "responsive"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {
    var res = prim.call(input, hint || "default");if (_typeof(res) !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");
  }return (hint === "string" ? String : Number)(input);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}
var _default = function _default(_ref) {
  var imageGalleryElement = _ref.imageGalleryElement,
      _ref$responsive = _ref.responsive,
      responsive = _ref$responsive === void 0 ? [] : _ref$responsive,
      options = _objectWithoutProperties(_ref, _excluded);
  var slides = imageGalleryElement.querySelectorAll('.glide__slides > li');
  var glide = '';
  var transformCount = 0;
  var breakpointSettings = _objectSpread({
    500: {
      perView: 1,
      peek: {
        before: 0,
        after: 0
      }
    },
    954: {
      perView: 1,
      peek: {
        before: 0,
        after: 0
      }
    },
    1025: {
      perView: 1,
      peek: {
        before: 'auto',
        after: 'auto'
      },
      slideWidth: 834
    },
    1200: {
      perView: 1,
      peek: {
        before: 'auto',
        after: 'auto'
      },
      slideWidth: 954
    },
    1600: {
      perView: 1,
      peek: {
        before: 'auto',
        after: 'auto'
      },
      slideWidth: 1354
    },
    1900: {
      perView: 1,
      peek: {
        before: 'auto',
        after: 'auto'
      },
      slideWidth: 1754
    }
  }, responsive);
  var getCurrentSettings = function getCurrentSettings() {
    var screenWidth = window.innerWidth;

    // Because the `perView` changes at different breakpoints, find
    // the relevant setting for the current screensize.
    // Filter out any settings that are smaller than the current size, and
    // then use the first in the list, as this will be the most relevant.
    // If none are available, assume we are using the biggest setting.

    // TODO: We should be able to reuse this, if we want to change the pagination
    // to scroll full pages, rather than individual items
    var breakpointSettingsForCurrentSize = Object.keys(breakpointSettings).filter(function (i) {
      return parseInt(i, 10) > screenWidth;
    })[0] || Object.keys(breakpointSettings).slice(-1);
    return breakpointSettings[breakpointSettingsForCurrentSize];
  };
  var updateBulletSize = function updateBulletSize(dot, action) {
    if (action === 'add') {
      imageGalleryElement.querySelector(".glide-carousel__pagination > [data-slide-no='".concat(dot, "']")).classList.add('small');
    } else {
      imageGalleryElement.querySelector(".glide-carousel__pagination > [data-slide-no='".concat(dot, "']")).classList.remove('small');
    }
  };
  var setBulletDefaultSize = function setBulletDefaultSize() {
    var maxDots = 5;
    var totalCount = slides.length;
    var navigationElements = imageGalleryElement.querySelectorAll(".glide-carousel__pagination > [data-slide-no]");
    if (totalCount > maxDots) {
      navigationElements.forEach(function (item) {
        item.classList.remove('small');
      });
      transformCount = 0;
      // eslint-disable-next-line no-param-reassign
      imageGalleryElement.querySelector('.glide-carousel__pagination').style.transform = 'translateX(0)';
      updateBulletSize(4, 'add');
    }
  };
  var setBulletSize = function setBulletSize(currentSlide, nextSlide) {
    var maxDots = 5;
    var transformXIntervalNext = -24;
    var transformXIntervalPrev = 24;
    var totalCount = slides.length;
    if (totalCount > maxDots) {
      if (nextSlide > currentSlide) {
        if (imageGalleryElement.querySelector(".glide-carousel__pagination > [data-slide-no='".concat(nextSlide, "']")).classList.contains('small')) {
          if (!imageGalleryElement.querySelector(".glide-carousel__pagination > [data-slide-no]:last-child").classList.contains('small')) {
            // eslint-disable-next-line operator-assignment
            transformCount = transformCount + transformXIntervalNext;
            updateBulletSize(nextSlide, 'remove');
            var nextSlidePlusOne = nextSlide + 1;
            updateBulletSize(nextSlidePlusOne, 'add');
            // eslint-disable-next-line no-param-reassign
            imageGalleryElement.querySelector('.glide-carousel__pagination').style.transform = "translateX(".concat(transformCount, "px)");
            var pPointer = nextSlide - 3;
            var pPointerMinusOne = pPointer - 1;
            updateBulletSize(pPointerMinusOne, 'remove');
            updateBulletSize(pPointer, 'add');
          }
        } else {
          // eslint-disable-next-line no-lonely-if
          if (nextSlide === slides.length - 1) {
            var navigationElements = imageGalleryElement.querySelectorAll(".glide-carousel__pagination > [data-slide-no]");
            navigationElements.forEach(function (item) {
              item.classList.remove('small');
            });
            updateBulletSize(slides.length - 5, 'add');
            transformCount = (slides.length - 5) * transformXIntervalNext;
            // eslint-disable-next-line no-param-reassign
            imageGalleryElement.querySelector('.glide-carousel__pagination').style.transform = "translateX(".concat(transformCount, "px)");
          }
        }
      } else {
        // eslint-disable-next-line no-lonely-if
        if (imageGalleryElement.querySelector(".glide-carousel__pagination > [data-slide-no='".concat(nextSlide, "']")).classList.contains('small')) {
          if (!imageGalleryElement.querySelector(".glide-carousel__pagination > [data-slide-no]:first-child").classList.contains('small')) {
            // eslint-disable-next-line operator-assignment
            transformCount = transformCount + transformXIntervalPrev;
            updateBulletSize(nextSlide, 'remove');
            var _nextSlidePlusOne = nextSlide - 1;
            updateBulletSize(_nextSlidePlusOne, 'add');
            // eslint-disable-next-line no-param-reassign
            imageGalleryElement.querySelector('.glide-carousel__pagination').style.transform = "translateX(".concat(transformCount, "px)");
            var nPointer = currentSlide + 3;
            var nPointerMinusOne = nPointer - 1;

            // console.log(`${nPointer} - ${nPointerMinusOne}`);
            updateBulletSize(nPointer, 'remove');
            updateBulletSize(nPointerMinusOne, 'add');
          }
        } else {
          // eslint-disable-next-line no-lonely-if
          if (nextSlide === 0) {
            setBulletDefaultSize();
          }
        }
      }
    }
  };
  var countLeftPad = function countLeftPad(number) {
    var slideCount = number.toString();

    // eslint-disable-next-line no-undef
    return slideCount.padStart(2, '0');
  };
  var setSlideCount = function setSlideCount(currentIndex) {
    var slideCountBlock = imageGalleryElement.querySelector('.image-gallery__totalslides--count');
    slideCountBlock.innerHTML = " ".concat("Image ").concat(countLeftPad(currentIndex + 1), "/").concat(countLeftPad(slides.length));
    // slideCountBlock.innerHTML ="<img src=\'../../assets/svg/image-icon.svg\' width=\'16px\' height=\'16px\'>".concat(" ", "Image ").concat(countLeftPad(currentIndex + 1), "/").concat(countLeftPad(slides.length));
  };
  var showPaginationByPage = function showPaginationByPage() {
    // Glide shows a pagination button for each item, and doesn't provide
    // an option to navigate whole pages at a time.
    // This function hides extra individual dots, so that only the first item of
    // each page is shown. (Based on the `perView` setting).
    var _getCurrentSettings = getCurrentSettings(),
        perView = _getCurrentSettings.perView;
    var paginationElements = imageGalleryElement.querySelectorAll(".glide-carousel__pagination button:not(:nth-child(".concat(perView, "n + 1))"));
    paginationElements.forEach(function (item) {
      item.classList.add('hidden');
    });
    setSlideCount(0);
    setBulletDefaultSize();
  };
  var showHideNavigation = function showHideNavigation() {
    var maxPerView = getCurrentSettings().perView;
    var navigationElements = imageGalleryElement.querySelectorAll('[data-slide-no]');
    if (!slides || slides.length <= maxPerView) {
      navigationElements.forEach(function (item) {
        return item.classList.add('hidden');
      });
      // eslint-disable-next-line no-param-reassign
      imageGalleryElement.querySelector('.image-gallery__navigation').style.display = 'none';
      // eslint-disable-next-line no-param-reassign
      imageGalleryElement.querySelector('.image-gallery__totalslides').style.display = 'none';
      imageGalleryElement.querySelector('.glide__slides').classList.add('singleslide');
      return;
    }
    navigationElements.forEach(function (item) {
      return item.classList.remove('hidden');
    });
    showPaginationByPage();
  };
  var createPagination = function createPagination() {
    var bulletContainer = document.createElement('div');
    bulletContainer.classList.add('glide-carousel__pagination');
    bulletContainer.dataset.glideEl = 'controls[nav]';
    slides.forEach(function (slide, index) {
      var button = document.createElement('button');
      button.dataset.slideNo = "".concat(index);
      button.tabIndex = '-1';
      bulletContainer.appendChild(button);
    });
    imageGalleryElement.querySelector('.carousel-nav-wrapper').appendChild(bulletContainer);
    showHideNavigation();
  };
  var setPeekVal = function setPeekVal() {
    var peekVal = 0;
    if (document.body.clientWidth > 1025 && document.body.clientWidth < 1200) {
      peekVal = (document.body.clientWidth - 834) / 2;
    } else if (document.body.clientWidth > 1200 && document.body.clientWidth < 1280) {
      peekVal = (document.body.clientWidth - 954) / 2;
    } else if (document.body.clientWidth > 1281) {
      peekVal = 154;
    }
    glide.update({
      peek: {
        before: peekVal,
        after: peekVal
      }
    });
  };
  createPagination();
  window.addEventListener('resize', (0, _lodashDebounce["default"])(function () {
    // Hide the navigation when we don't have more items than we can show on screen
    showHideNavigation();
    setPeekVal();
  }, 250));
  glide = new _glide["default"](imageGalleryElement, _objectSpread({
    perView: 1,
    type: 'carousel',
    breakpoints: breakpointSettings,
    // Remove draggable property for desktop
    dragThreshold: false,
    // Remove swipe property for smaller devices
    // swipeThreshold: false,
    peek: {
      before: 100,
      after: 100
    }
  }, options)).mount();
  glide.on('run', function () {
    var currentSlide = imageGalleryElement.querySelector('.glide-carousel__pagination > [data-slide-no].glide__bullet--active').getAttribute('data-slide-no');
    var nextSlide = glide.index;

    // console.log(`${currentSlide} - ${nextSlide}`);
    // eslint-disable-next-line radix
    setBulletSize(parseInt(currentSlide), nextSlide);
    setSlideCount(nextSlide);
    updateBulletSize(nextSlide, 'remove');
  });
  if (slides.length === 1) {
    glide.update({
      type: 'slider',
      peek: {
        before: 0,
        after: 0
      }
    });
  } else {
    setPeekVal();
  }
  return glide;
};
exports["default"] = _default;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _typeof(obj) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == _typeof2(Symbol.iterator) ? function (obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _gliderJs = _interopRequireDefault(__webpack_require__(787));
var _excluded = ["carouselElement", "responsive"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {
    var res = prim.call(input, hint || "default");if (_typeof(res) !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");
  }return (hint === "string" ? String : Number)(input);
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }return arr2;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}
var _default = function _default(_ref) {
  var carouselElement = _ref.carouselElement,
      _ref$responsive = _ref.responsive,
      responsive = _ref$responsive === void 0 ? [] : _ref$responsive,
      options = _objectWithoutProperties(_ref, _excluded);
  var defaultOptions = {
    slidesToShow: 1,
    slidesToScroll: 1,
    scrollLock: true,
    draggable: true,
    arrows: {
      prev: '.carousel__prev',
      next: '.carousel__next'
    },
    dots: '.carousel__pagination',
    responsive: [{
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }, {
      breakpoint: 900,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }, {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    }].concat(_toConsumableArray(responsive))
  };
  return new _gliderJs["default"](carouselElement, _objectSpread(_objectSpread({}, defaultOptions), options));
};
exports["default"] = _default;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Hamburger toggle
(0, _jquery2.default)('#navbar-toggle').on('click', function () {
  this.classList.toggle('active');
  (0, _jquery2.default)('.cwm-nav').slideToggle();
  (0, _jquery2.default)('.cwm-navbar-right .cwm-dropdown-content').hide("slow");
});

(0, _jquery2.default)(function () {
  if ((0, _jquery2.default)('.cwm-enquiry-ribbon').length > 0) {
    (0, _jquery2.default)('.default-nav').addClass('nav-margin-top');
  }
});
(0, _jquery2.default)(function () {
  (0, _jquery2.default)('.cwm-navbar-right .cwm-dropdown').each().on('focus', '.cwm-navbar-right .cwm-dropdown-content a', function () {
    (0, _jquery2.default)(this).closest('.cwm-dropdown').addClass('focus');
  }).on('blur', '.cwm-navbar-right .cwm-dropdown-content a', function () {
    (0, _jquery2.default)(this).closest('.cwm-dropdown').removeClass('focus');
  });
});

if ((0, _jquery2.default)(window).width() < 1025) {
  (0, _jquery2.default)(' ul.cwm-nav li.cwm-dropdown button.icon-right-ar:not(:only-child)').click(function (e) {
    (0, _jquery2.default)(this).siblings('.cwm-nav .cwm-dropdown-content').slideToggle("slow");
    (0, _jquery2.default)(this).siblings('.cwm-nav .cwm-dropdown-content').parent('.cwm-dropdown').toggleClass('active');
    // Close dropdown when select another dropdown
    (0, _jquery2.default)('.cwm-nav .cwm-dropdown-content').not((0, _jquery2.default)(this).siblings()).hide("slow");
    (0, _jquery2.default)('.cwm-nav .cwm-dropdown-content').not((0, _jquery2.default)(this).siblings()).parent('.cwm-dropdown').removeClass("active");
    e.stopPropagation();
  });
  (0, _jquery2.default)(' ul.cwm-navbar-right li.cwm-dropdown a:not(:only-child)').click(function (e) {
    (0, _jquery2.default)(this).siblings('.cwm-navbar-right .cwm-dropdown-content').slideToggle("slow");
    (0, _jquery2.default)('.cwm-nav').hide(200);
    (0, _jquery2.default)('#navbar-toggle').removeClass("active");
    // Close dropdown when select another dropdown
    (0, _jquery2.default)('.cwm-navbar-right .cwm-dropdown-content').not((0, _jquery2.default)(this).siblings()).hide("slow");
    e.stopPropagation();
  });
}
if ((0, _jquery2.default)(window).width() > 1025) {
  (0, _jquery2.default)(window).scroll(function () {
    if ((0, _jquery2.default)(this).scrollTop() > 40) {
      (0, _jquery2.default)('.default-nav').addClass('default-nav-sticky');
    } else {
      (0, _jquery2.default)('.default-nav').removeClass('default-nav-sticky');
    }
  });
}

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
    // Skip link script for focus
    // add tabindex attribute to the main section
    (0, _jquery2.default)("#main-content").attr("tabindex", "-1");
    // bind click event to the skip link
    (0, _jquery2.default)("#skip-link").click(function (e) {
        // prevent default behavior of the link
        e.preventDefault();
        // move focus to the main section
        (0, _jquery2.default)("#main-content").focus();
    });
});

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
    (0, _jquery2.default)('.cwm-membershipholder').text((0, _jquery2.default)('#currentUser').val());
    if ((0, _jquery2.default)('.BobbyMoore').length > 0) {
        (0, _jquery2.default)("a.cwm-membership[name='BMC']").addClass('active');
    }
    if ((0, _jquery2.default)('.InnerCircle').length > 0) {
        (0, _jquery2.default)("a.cwm-membership[name='CWN']").addClass('active');
    }
    if ((0, _jquery2.default)('.NumberNine').length > 0) {
        (0, _jquery2.default)("a.cwm-membership[name='NIN']").addClass('active');
    }
    if ((0, _jquery2.default)('.CentreCircle').length > 0) {
        (0, _jquery2.default)("a.cwm-membership[name='CEN']").addClass('active');
    }
    if ((0, _jquery2.default)('.OneTwenty').length > 0) {
        (0, _jquery2.default)("a.cwm-membership[name='ONE']").addClass('active');
    }
    if ((0, _jquery2.default)('.PrivateBox').length > 0) {
        (0, _jquery2.default)("a.cwm-membership[name='BOX']").addClass('active');
    }
});

(0, _jquery2.default)(document).ready(function () {
    (0, _jquery2.default)("a.cwm-membership").click(function () {
        var membershipType = (0, _jquery2.default)(this).attr('name');
        var priceplan = (0, _jquery2.default)(this).attr('priceplan');
        var noOfParkingPass = (0, _jquery2.default)(this).attr('noOfParkingPass');
        var residencyPlan = (0, _jquery2.default)(this).attr('residencyPlan');
        _jquery2.default.ajax({
            url: '/CWMAccountManagement/UpdatePatternAndPriceCard/' + membershipType + "/" + priceplan + "/" + noOfParkingPass + "/" + residencyPlan,
            type: 'GET',
            data: {},
            error: function error(xhr, status, _error) {
                console.log('error' + JSON.stringify(_error));
            },
            success: function success(response, status, xhr) {
                location.reload();
            }
        });
    });
});

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
    var modal = (0, _jquery2.default)(".modal");
    modal.on('shown.bs.modal', function () {
        (0, _jquery2.default)('html').css({ 'overflow-y': "hidden" });
    }).on('hidden.bs.modal', function () {
        (0, _jquery2.default)('html').css({ 'overflow-y': "scroll" });
    });
});

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
	var formData = null;
	// close button 
	(0, _jquery2.default)("#cwm-myaccountformClose").on("click", function () {
		(0, _jquery2.default)(".cwm-account-form").animate({ height: "auto" }, function () {
			(0, _jquery2.default)(this).hide();
			window.location.reload();
		});
		(0, _jquery2.default)("a.edit-view-details").show();
		(0, _jquery2.default)('html,body').animate({
			scrollTop: (0, _jquery2.default)(".cwm-view-details").offset().top - 100 }, '1000');
	});
	// enable and disable submit button
	(0, _jquery2.default)('#my-account_Detailsform input.my-account_formControl').on('keyup', function () {
		if ((0, _jquery2.default)("#cwmaf_firstName").val() != '' || (0, _jquery2.default)("#cwmaf_surName").val() != '' || (0, _jquery2.default)("#cwmaf_email").val() != '' || (0, _jquery2.default)("#cwmaf_date").val() != '' || (0, _jquery2.default)("#cwmaf_addressOne").val() != '' || (0, _jquery2.default)("#cwmaf_postcode").val() != '' || (0, _jquery2.default)("#cwmaf_telnumber").val() != '' || (0, _jquery2.default)("#cwmaf_addressTwo").val() != '' || (0, _jquery2.default)("#cwmaf_city").val() != '' || (0, _jquery2.default)("#cwmaf_county").val() != '') {

			(0, _jquery2.default)('#myaccountdetailsSubmit').attr('disabled', false);
		} else {
			(0, _jquery2.default)('#myaccountdetailsSubmit').attr('disabled', true);
		}
	});
	//Select Dropdown
	(0, _jquery2.default)('#my-account_Detailsform select#cwmaf_country').on('change', function () {
		var val = this.value;
		if (val != '') {
			(0, _jquery2.default)('#myaccountdetailsSubmit').attr('disabled', false);
		} else {
			(0, _jquery2.default)('#myaccountdetailsSubmit').attr('disabled', true);
		}
	});
	(0, _jquery2.default)('#cwmaf_postcode').keyup(function () {
		this.value = this.value.toLocaleUpperCase();
	});

	(0, _jquery2.default)("#cwmaf_surName").keypress(function (e) {
		var numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
		var keynum;
		if (window.event) {
			// IE                    
			keynum = e.keyCode;
		} else if (e.which) {
			// Netscape/Firefox/Opera                   
			keynum = e.which;
		}
		if (numbers.indexOf(String.fromCharCode(keynum)) > -1) {
			e.preventDefault();
		}
	});
	(0, _jquery2.default)("#cwmaf_firstName").keypress(function (e) {
		var numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
		var keynum;
		if (window.event) {
			// IE                    
			keynum = e.keyCode;
		} else if (e.which) {
			// Netscape/Firefox/Opera                   
			keynum = e.which;
		}
		if (numbers.indexOf(String.fromCharCode(keynum)) > -1) {
			e.preventDefault();
		}
	});

	//CONTACT FORM: ajax request
	(0, _jquery2.default)('#myaccountdetailsSubmit').on("click", function () {

		// assigning form values and names in to var
		formData = {
			FirstName: { FieldName: "firstName", FieldValue: (0, _jquery2.default)("#cwmaf_firstName").val() },
			LastName: { FieldName: "surName", FieldValue: (0, _jquery2.default)("#cwmaf_surName").val() },
			Email: { FieldName: "email", FieldValue: (0, _jquery2.default)("#cwmaf_email").val() },
			//JobTittle: { FieldName: "jobTitle", FieldValue: $("#jobTitle").val() },
			DateOfBirth: { FieldName: "date", FieldValue: (0, _jquery2.default)("#cwmaf_date").val() },
			Address1: { FieldName: "addressOne", FieldValue: (0, _jquery2.default)("#cwmaf_addressOne").val() },
			Address2: { FieldName: "addressTwo", FieldValue: (0, _jquery2.default)("#cwmaf_addressTwo").val() },
			City: { FieldName: "city", FieldValue: (0, _jquery2.default)("#cwmaf_city").val() },
			County: { FieldName: "county", FieldValue: (0, _jquery2.default)("#cwmaf_county").val() },
			Country: { FieldName: "country", FieldValue: (0, _jquery2.default)("#cwmaf_country").val() },
			PostCode: { FieldName: "postcode", FieldValue: (0, _jquery2.default)("#cwmaf_postcode").val() },
			Phone: { FieldName: "telnumber", FieldValue: (0, _jquery2.default)("#cwmaf_telnumber").val() }

			//onlynumbers and Uppercase letters
		};_jquery2.default.validator.addMethod("postalcode", function (value, element) {
			return this.optional(element) || value == value.match(/^[A-Z0-9\s]*$/);
		});
		//onlynumbers and Phone number(/^[0-9 -.\s]+$/)
		_jquery2.default.validator.addMethod("phonenumber", function (value, element) {
			return this.optional(element) || value == value.match(/^[0-9 + ]+$/);
		});
		//only accept letters  /^[A-Za-zÀ-ÖØ-öø-ÿ `!@#$%\^&*)(+=._-\s]*$/
		_jquery2.default.validator.addMethod("letters", function (value, element) {
			return this.optional(element) || value == value.match(/[A-Za-zÀ-ÖØ-öø-ÿ `~!@#$%\^&*)(+=._-]+'?[A-Za-zÀ-ÖØ-öø-ÿ `~!@#$%\^&*)(+=._-]+/g);
		});
		//Date dd/mm/yyyy validation
		_jquery2.default.validator.addMethod("validDate", function (value, element) {
			return value.match(/(?:0[1-9]|[12][0-9]|3[01])\/(?:0[1-9]|1[0-2])\/(?:19\d{2}|20\d{2})/);
		});
		//validation for 18 years old
		_jquery2.default.validator.addMethod("validDOB", function (value, element) {
			var from = value.split("/"); // DD/MM/YYYY
			var day = from[0];
			var month = from[1];
			var year = from[2];
			var age = 18;
			var mydate = new Date();
			mydate.setFullYear(year, month - 1, day);
			var currdate = new Date();
			var setDate = new Date();

			setDate.setFullYear(mydate.getFullYear() + age, month - 1, day);

			if (currdate - setDate > 0) {
				return true;
			} else {
				return false;
			}
		});

		//FORM VALIDATION: validates on submit
		(0, _jquery2.default)("#my-account_Detailsform").validate({
			// error message adding in span with class name 
			wrapper: 'span',
			errorPlacement: function errorPlacement(error, element) {
				error.addClass("my-account_errorlabel");
				error.insertAfter(element);
			},
			rules: {
				cwmaf_firstName: { //input name: firstName
					required: true, //required boolean: true/false
					maxlength: 255,
					letters: true
				},
				cwmaf_surName: {
					required: true, //required boolean: true/false
					maxlength: 255,
					letters: true
				},
				cwmaf_email: {
					required: true,
					email: true
				},
				cwmaf_date: {
					required: true,
					validDate: true,
					validDOB: true
				},
				cwmaf_addressOne: {
					required: true,
					maxlength: 255
				},
				cwmaf_country: {
					required: true
				},
				cwmaf_postcode: {
					required: true,
					postalcode: true,
					maxlength: 8
				},
				cwmaf_telnumber: {
					required: true,
					phonenumber: true,
					maxlength: 18
				},
				cwmaf_addressTwo: {
					maxlength: 255
				},
				cwmaf_county: {
					maxlength: 255
				},
				cwmaf_city: {
					maxlength: 255
				}
			},
			messages: {
				cwmaf_firstName: {
					required: "Please enter first name.",
					letters: "Please enter text only.",
					maxlength: "Please enter no more than 255 charaters."
				},
				cwmaf_surName: {
					required: "Please enter surname.",
					letters: "Please enter text only.",
					maxlength: "Please enter no more than 255 charaters."
				},
				cwmaf_email: {
					required: "Please enter email address.",
					email: "Please enter a valid email address."
				},
				cwmaf_date: {
					required: "Please enter your DOB in the format DD/MM/YYYY.",
					validDOB: "You must be age 18 or over.",
					validDate: "Please enter your DOB in the format DD/MM/YYYY"

				},
				cwmaf_addressOne: {
					required: "Please enter the 1st line of your address.",
					maxlength: "Please enter no more than 255 characters."
				},
				cwmaf_country: {
					required: "Please select country."
				},
				cwmaf_postcode: {
					required: "Please enter postcode.",
					postalcode: "Please enter a valid postcode.",
					maxlength: "Please enter no more than 8 characters."
				},
				cwmaf_telnumber: {
					required: "Please enter a phone number.",
					phonenumber: "Please enter a valid phone number.",
					maxlength: "Please enter no more than 15 numbers."
				},
				cwmaf_addressTwo: {
					maxlength: "Please enter no more than 255 characters."
				},
				cwmaf_county: {
					maxlength: "Please enter no more than 255 characters."
				},
				cwmaf_city: {
					maxlength: "Please enter no more than 255 characters."
				}
			},

			submitHandler: function submitHandler(form) {
				(0, _jquery2.default)('html').css({ 'overflow-y': "hidden" });
				(0, _jquery2.default)("#cwm-overlay").show();
				_jquery2.default.ajax({
					url: form.action,
					type: form.method,
					data: this.formData = formData,
					dataType: "json",
					success: function success(response) {
						(0, _jquery2.default)('html').css({ 'overflow-y': "scroll" });
						(0, _jquery2.default)("#cwm-overlay").hide();
						(0, _jquery2.default)(".my-account_Wrapper").hide();
						(0, _jquery2.default)('#form-successful-messgae').show();
						(0, _jquery2.default)("a.edit-view-details").show();
						console.log(JSON.stringify(formData));
						(0, _jquery2.default)('html,body').animate({
							scrollTop: (0, _jquery2.default)("#form-successful-messgae").offset().top - 100 }, '1000');
					},
					error: function error(response) {
						(0, _jquery2.default)('html').css({ 'overflow-y': "scroll" });
						(0, _jquery2.default)("#cwm-overlay").hide();
						console.log(response.error);
					}
				});
			}
		});
	});
});

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
    // Show more text option 
    var showChar_c = 250; // How many characters are shown by default
    var ellipsestext_c = "...";
    var moretext_c = '<span class="cta--text">Show More</span><span class="cta--down-arrow-icon icon"></span>';
    var lesstext_c = '<span class="cta--text">Show Less</span><span class="cta--down-arrow-icon icon"></span>';

    //Cut content based on showChar_c length
    if ((0, _jquery2.default)(".other-contacts-cmp__body .other-contacts-cmp__text").length) {
        (0, _jquery2.default)(".other-contacts-cmp__body .other-contacts-cmp__text").each(function () {

            var content_c = (0, _jquery2.default)(this).html();
            console.log(content_c);

            if (content_c.length > showChar_c) {

                var contentExcert_c = content_c.substr(0, showChar_c);
                var contentRest_c = content_c.substr(showChar_c, content_c.length - showChar_c);
                var html_c = contentExcert_c + '<span class="cwm-toggle-text-ellipses">' + ellipsestext_c + '</span><span class="cwm-toggle-text-content"><span>' + contentRest_c + '</span> <a href="javascript:;" class="cwm-toggle-text-link">' + moretext_c + '</a></span>';

                (0, _jquery2.default)(this).html(html_c);
            }
        });
    }

    var minHeight = parseInt(0);
    // setting height of each card body text
    (0, _jquery2.default)(".other-contacts-cmp__card .other-contacts-cmp__text").each(function () {
        if ((0, _jquery2.default)(this).outerHeight() > minHeight) {
            minHeight = (0, _jquery2.default)(this).outerHeight();
        }
    });
    (0, _jquery2.default)('.other-contacts-cmp__card .other-contacts-cmp__text').css('min-height', minHeight);

    var footerMinHeight = parseInt(0);
    //setting height of each card footer links
    (0, _jquery2.default)(".other-contacts-cmp__card .other-contacts-cmp__footer").each(function () {
        if ((0, _jquery2.default)(this).outerHeight() > footerMinHeight) {
            footerMinHeight = (0, _jquery2.default)(this).outerHeight();
        }
    });
    (0, _jquery2.default)('.other-contacts-cmp__card .other-contacts-cmp__footer').css('min-height', footerMinHeight);

    //Toggle content when click on read more link
    (0, _jquery2.default)(".other-contacts-cmp__card .cwm-toggle-text-link").click(function () {
        var contactCard = (0, _jquery2.default)(this).closest(".other-contacts-cmp__card-wrapper");
        var contactCardRow = contactCard.parent();

        if ((0, _jquery2.default)(this).hasClass("less")) {
            (0, _jquery2.default)(this).removeClass("less");
            (0, _jquery2.default)(this).html(moretext_c);
            (0, _jquery2.default)('.other-contacts-cmp__card .other-contacts-cmp__text').css('min-height', minHeight);
        } else {
            (0, _jquery2.default)(this).addClass("less");
            (0, _jquery2.default)(this).html(lesstext_c);
            (0, _jquery2.default)(this).closest('.other-contacts-cmp__card .other-contacts-cmp__text').css('min-height', 'auto');
            contactCardRow.css("align-items", "flex-start");
        }

        (0, _jquery2.default)(this).parent().prev().toggle();
        (0, _jquery2.default)(this).prev().toggle();
        return false;
    });
});

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(".pd-accordion").on("click keypress", function (event) {
    if (event.which == 13 || event.type == "click") {
      (0, _jquery2.default)(this).toggleClass("active");
      (0, _jquery2.default)(this).next().slideToggle(200);
    }
  });
});

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {

    var minHeight = parseInt(0);

    (0, _jquery2.default)(".partner-signpost-cmp .event-card__title").each(function () {
        if ((0, _jquery2.default)(this).outerHeight() > minHeight) {
            minHeight = (0, _jquery2.default)(this).outerHeight();
        }
    });
    (0, _jquery2.default)('.partner-signpost-cmp .event-card__title').css('height', minHeight);

    (0, _jquery2.default)(".partner-signpost-cmp .event-card__text").each(function () {
        if ((0, _jquery2.default)(this).outerHeight() > minHeight) {
            minHeight = (0, _jquery2.default)(this).outerHeight();
        }
    });
    (0, _jquery2.default)('.partner-signpost-cmp .event-card__text').css('height', minHeight);
});

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.Dropdown = function (_Snappy$BaseComponent) {
	_inherits(Dropdown, _Snappy$BaseComponent);

	_createClass(Dropdown, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-dropdown';
		}
	}]);

	function Dropdown(element) {
		_classCallCheck(this, Dropdown);

		return _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, element));
	}

	_createClass(Dropdown, [{
		key: 'render',
		value: function render() {}
	}]);

	return Dropdown;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _handlebars = __webpack_require__(21);

var _handlebars2 = _interopRequireDefault(_handlebars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.Faqs = function (_Snappy$BaseComponent) {
	_inherits(Faqs, _Snappy$BaseComponent);

	_createClass(Faqs, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-faqs';
		}
	}]);

	function Faqs(element) {
		_classCallCheck(this, Faqs);

		return _possibleConstructorReturn(this, (Faqs.__proto__ || Object.getPrototypeOf(Faqs)).call(this, element));
	}

	_createClass(Faqs, [{
		key: 'render',
		value: function render() {
			this.setVars();
			this.prepareFaqsTemplate();
			this.addEventListeners();
			this.initDropdown();
		}
	}, {
		key: 'setVars',
		value: function setVars() {
			this.$searchForm = this.$element.find('.fa-faqs__search-form');
			this.$searchFilter = this.$searchForm.find('#faq-query');
			this.$faqFolderId = this.$searchForm.find('#faq-FolderId');
			this.$searchFilterParent = this.$searchFilter.closest('.filter-container');
			this.$dropdownMenu = this.$searchForm.find('.fa-dropdown__select');
			this.$dropdownMenuParent = this.$dropdownMenu.closest('.filter-container');
			this.$faqAccordion = this.$element.find('#faq-accordion');
			this.queryServiceUrl = this.$searchForm.attr('action');
			this.activeFilerClass = 'active';
			this.errorClass = 'error-faqs';
			this.errorElement = this.$element.find('.fa-faqs__error-display');
		}
	}, {
		key: 'prepareFaqsTemplate',
		value: function prepareFaqsTemplate() {
			var source = this.$element.find('#accordion-item-template').html();
			this.faqsTemplate = _handlebars2.default.compile(source);
		}
	}, {
		key: 'addEventListeners',
		value: function addEventListeners() {
			this.$dropdownMenu.on('change', this.onTopicChange.bind(this));
			this.$searchForm.on('submit', this.onSearchFormSubmit.bind(this));
		}
	}, {
		key: 'initDropdown',
		value: function initDropdown() {
			this.defaultOption = this.$dropdownMenu.find('option').eq(0).val();
			this.$firstSelectableOption = this.$dropdownMenu.find('option').eq(1);
			this.$dropdownMenu.val(this.$firstSelectableOption.val());
			this.onTopicChange();
		}
	}, {
		key: 'resetDropdown',
		value: function resetDropdown() {
			this.$dropdownMenu.val(this.defaultOption);
		}
	}, {
		key: 'onTopicChange',
		value: function onTopicChange() {
			var queryObj = {
				topic: this.$dropdownMenu.val(),
				faqFolderId: this.$faqFolderId.val()
			};

			this.$dropdownMenuParent.addClass(this.activeFilerClass);
			this.$searchFilterParent.removeClass(this.activeFilerClass);
			this.clearSearchForm();
			this.clearFaqAccordion();
			this.makeRequestForData(queryObj);
		}
	}, {
		key: 'onSearchFormSubmit',
		value: function onSearchFormSubmit(event) {
			var queryObj = {
				searchTerm: this.$searchFilter.val(),
				faqFolderId: this.$faqFolderId.val()
			};

			event.preventDefault();

			this.resetDropdown();
			this.$searchFilterParent.addClass(this.activeFilerClass);
			this.$dropdownMenuParent.removeClass(this.activeFilerClass);
			this.clearFaqAccordion();
			this.makeRequestForData(queryObj);
		}
	}, {
		key: 'clearSearchForm',
		value: function clearSearchForm() {
			this.$searchFilter.val('');
		}
	}, {
		key: 'clearFaqAccordion',
		value: function clearFaqAccordion() {
			this.$faqAccordion.empty();
		}
	}, {
		key: 'makeRequestForData',
		value: function makeRequestForData(query) {
			this.isLoadingData = true;
			this.toggleIsLoadingData();
			this.errorElement.removeClass(this.errorClass);

			_jquery2.default.ajax({
				method: 'GET',
				url: this.queryServiceUrl,
				data: query
			}).then(this.handleQuerySuccessResponse.bind(this), this.handleQueryError.bind(this));
		}
	}, {
		key: 'handleQuerySuccessResponse',
		value: function handleQuerySuccessResponse(data) {
			window.setTimeout(function () {
				var _this2 = this;

				var markup = void 0;

				this.isLoadingData = false;
				this.toggleIsLoadingData();

				if (data && data.faqItems && data.faqItems.length) {
					markup = data.faqItems.map(function (item, index) {
						var modifiedMarkup = _this2.faqsTemplate(item);
						return modifiedMarkup.replace(/<%index%>/g, index);
					});

					markup = markup.join('');
					this.$faqAccordion.append(markup);
				} else {
					this.handleQueryError();
				}
			}.bind(this), 2000);
		}
	}, {
		key: 'handleQueryError',
		value: function handleQueryError() {
			this.isLoadingData = false;
			this.toggleIsLoadingData();
			this.errorElement.addClass(this.errorClass);
		}
	}, {
		key: 'toggleIsLoadingData',
		value: function toggleIsLoadingData() {
			this.$element.toggleClass('loading-faqs', this.isLoadingData);
		}
	}]);

	return Faqs;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.Filters = function (_Snappy$BaseComponent) {
    _inherits(Filters, _Snappy$BaseComponent);

    _createClass(Filters, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-form-filters';
        }
    }]);

    function Filters(element) {
        _classCallCheck(this, Filters);

        return _possibleConstructorReturn(this, (Filters.__proto__ || Object.getPrototypeOf(Filters)).call(this, element));
    }

    _createClass(Filters, [{
        key: 'render',
        value: function render() {

            (0, _jquery2.default)("#pastEventsBtn").parent().removeClass("active");
            (0, _jquery2.default)("#upcomingEventsBtn").parent().removeClass("active");
            if (location.search == "?past=true") {
                (0, _jquery2.default)("#pastEventsBtn").parent().addClass("active");
                (0, _jquery2.default)("#upcomingEventsBtn").parent().removeClass("active");
            } else {
                (0, _jquery2.default)("#pastEventsBtn").parent().removeClass("active");
                (0, _jquery2.default)("#upcomingEventsBtn").parent().addClass("active");
            }

            (0, _jquery2.default)("#pastEventsBtn").on("click", function () {
                window.location = '/events?past=true';
            });

            (0, _jquery2.default)("#upcomingEventsBtn").on("click", function () {
                window.location = '/events';
            });

            var PAGE_SIZE = parseInt((0, _jquery2.default)('.fa-filter-content').first().data('page-size'));
            var currentVisibleItems = PAGE_SIZE;
            var totalFiltered = 0;
            (0, _jquery2.default)('select.filter-data').bind('change', function (e) {
                currentVisibleItems = PAGE_SIZE;
                filter(e);
                showHideButtons();
            });

            function filter(e, scroll) {
                (0, _jquery2.default)('select.filter-data').attr('disabled', 'disabled');
                var filterAttribute = '';

                (0, _jquery2.default)('select.filter-data').each(function () {
                    if ((0, _jquery2.default)(this).val() != '0') {
                        filterAttribute += '[data-' + (0, _jquery2.default)(this).data('attribute') + '="' + (0, _jquery2.default)(this).val() + '"]';
                    }
                });

                var $allElements = (0, _jquery2.default)('.fa-filter-content').find('.fa-filter-content__item' + filterAttribute);
                totalFiltered = $allElements.length;
                if (totalFiltered == 0) {
                    (0, _jquery2.default)('.fa-filter-content').find('.fa-filter-content__item').hide();
                    (0, _jquery2.default)('select.filter-data').removeAttr('disabled');
                    (0, _jquery2.default)('.counter').html('There are no events available for your selected filter');
                    return;
                }

                var $visibleElements = $allElements.slice(0, currentVisibleItems);
                var newTop = currentVisibleItems == PAGE_SIZE ? $visibleElements.first().offset().top - ((0, _jquery2.default)(window).width() < 991 ? 50 : 150) : (0, _jquery2.default)($visibleElements[currentVisibleItems - PAGE_SIZE - 1]).offset().top + (0, _jquery2.default)($visibleElements[currentVisibleItems - PAGE_SIZE - 1]).height() - ((0, _jquery2.default)(window).width() < 991 ? 50 : 150);
                var x = 0;
                (0, _jquery2.default)('.fa-filter-content').find('.fa-filter-content__item').hide();
                $visibleElements.fadeIn(10, function () {
                    if (x < $visibleElements.length - 1) {
                        x++;
                    } else {
                        if (scroll) {
                            (0, _jquery2.default)('body,html').animate({ scrollTop: newTop }, 500);
                        }
                    }
                });

                var event_visible = (0, _jquery2.default)('.fa-filter-content .fa-filter-content__item:visible');
                if ((0, _jquery2.default)(event_visible).length > 0) {
                    (0, _jquery2.default)('.counter').html(totalFiltered + ' events available');
                }
                (0, _jquery2.default)('select.filter-data').removeAttr('disabled');
            }

            function showHideButtons() {

                console.log('hi');
                if (currentVisibleItems >= totalFiltered) {
                    (0, _jquery2.default)('#showMore').hide();
                } else {
                    (0, _jquery2.default)('#showMore').show();
                }

                if (currentVisibleItems <= PAGE_SIZE) {
                    (0, _jquery2.default)('#showLess').hide();
                } else {
                    (0, _jquery2.default)('#showLess').show();
                }
            }

            (0, _jquery2.default)('#showMore').click(function (e) {
                currentVisibleItems += PAGE_SIZE;
                filter(e, true);
                showHideButtons();
            });

            (0, _jquery2.default)('#showLess').click(function (e) {
                currentVisibleItems -= PAGE_SIZE;
                filter(e, true);
                showHideButtons();
            });

            // this is to stop filter and showHidebuttons
            // from executing on meeting and events page. 
            if ((0, _jquery2.default)('.fa-form-meeting-events').length) {
                return false;
            }

            filter();
            showHideButtons();
        }
    }]);

    return Filters;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.Gallery = function (_Snappy$BaseComponent) {
	_inherits(Gallery, _Snappy$BaseComponent);

	_createClass(Gallery, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-gallery';
		}
	}]);

	function Gallery(element) {
		_classCallCheck(this, Gallery);

		return _possibleConstructorReturn(this, (Gallery.__proto__ || Object.getPrototypeOf(Gallery)).call(this, element));
	}

	_createClass(Gallery, [{
		key: 'setVars',
		value: function setVars() {
			this.$mediaFrame = this.$element.find('.media-frame');
			this.$thumbnailBtns = this.$element.find('.media-carousel__thumbnail-button');
			this.activeSlide = null;
			this.$allAssets = this.$element.find('.media-carousel__asset');
			this.activeThumbnailClass = 'active';
		}
	}, {
		key: 'addEventListeners',
		value: function addEventListeners() {
			this.$thumbnailBtns.on('click', this.handleThumbnailBtnClick.bind(this));
		}
	}, {
		key: 'render',
		value: function render() {
			this.setVars();
			this.addEventListeners();
			this.initiateSnappyTracker();
			this.initiateGallery();
		}
	}, {
		key: 'initiateSnappyTracker',
		value: function initiateSnappyTracker() {
			this.SnappyComponents = [];
		}
	}, {
		key: 'handleThumbnailBtnClick',
		value: function handleThumbnailBtnClick(event) {
			var $thumbnail = (0, _jquery2.default)(event.currentTarget);
			this.setActiveSlide($thumbnail);
		}
	}, {
		key: 'initiateGallery',
		value: function initiateGallery() {
			var $firstThumnail = this.$element.find('.carousel__slide[data-slick-index="0"] .media-carousel__thumbnail-button[data-asset="0"]');
			this.setActiveSlide($firstThumnail);
		}
	}, {
		key: 'setActiveSlide',
		value: function setActiveSlide($thumbnail) {
			var $asset = $thumbnail.siblings('.media-carousel__asset');
			var slickIndex = $thumbnail.parents('.slick-slide').data('slick-index');

			if (slickIndex !== this.slickIndex) {
				this.emptyFrame();
				this.setActiveClasses($thumbnail);
				this.injectViewIntoFrame($asset);
				this.activeSlide = slickIndex;
			}
		}
	}, {
		key: 'setActiveClasses',
		value: function setActiveClasses($thumbnail) {
			this.$thumbnailBtns.removeClass(this.activeThumbnailClass);
			$thumbnail.addClass(this.activeThumbnailClass);
		}
	}, {
		key: 'injectViewIntoFrame',
		value: function injectViewIntoFrame($asset) {
			var $clone = $asset.clone();
			var $pageMedia = $clone.find('.fa-page-media');
			this.$mediaFrame.append($clone);
			this.activeFrame = new _snappy2.default.Component.PageMedia($pageMedia[0]);
			this.activeFrame.render();
			this.SnappyComponents.push(this.activeFrame);
		}
	}, {
		key: 'emptyFrame',
		value: function emptyFrame() {
			this.SnappyComponents = [];
			this.$mediaFrame.empty();
		}
	}]);

	return Gallery;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(789);

__webpack_require__(790);

__webpack_require__(237);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LazyImages = function LazyImages() {
    _classCallCheck(this, LazyImages);
};

exports.default = LazyImages;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(76);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//import App from 'resizement/scripts/resize';

_snappy2.default.Component.MediaGallery = function (_Snappy$BaseComponent) {
    _inherits(MediaGallery, _Snappy$BaseComponent);

    _createClass(MediaGallery, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-media-gallery';
        }
    }]);

    function MediaGallery(element) {
        _classCallCheck(this, MediaGallery);

        return _possibleConstructorReturn(this, (MediaGallery.__proto__ || Object.getPrototypeOf(MediaGallery)).call(this, element));
    }

    _createClass(MediaGallery, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();

            this.init();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.mainCarouselNode = this.$element.find('.js-mg-main-carousel');
            this.navCarouselNode = this.$element.find('.js-mg-nav-carousel');
            this.navArrowsNode = this.$element.find('.js-mg-nav-arrows');
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {}
    }, {
        key: 'init',
        value: function init() {
            //debugger;
            this.mainCarouselNode.slick({
                asNavFor: this.navCarouselNode,
                touchThreshold: 10,
                arrows: false
            });
            this.navCarouselNode.slick({
                asNavFor: this.mainCarouselNode,
                slidesToShow: 4,
                slidesToScroll: 1,
                focusOnSelect: true,
                touchThreshold: 10,
                appendArrows: this.navArrowsNode,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                }],
                prevArrow: '<button type="button" class="slick-prev" title="Previous Slide" aria-label="Previous Slide">\n                            <svg class="icon icon-arrow" width="12" height="20" aria-hidden="true" focusable="false">\n                                <use  xlink:href="#icon-chevron-left"></use>\n                            </svg>\n                        </button>',
                nextArrow: '<button type="button" class="slick-next" title="Next Slide" aria-label="Next Slide">\n                            <svg class="icon icon-arrow" width="12" height="20" aria-hidden="true" focusable="false">\n                                <use  xlink:href="#icon-chevron-right"></use>\n                            </svg>\n                        </button>'

            });

            this.navCarouselNode.on('beforeChange', function () {
                (0, _jquery2.default)(document).trigger('responsiveVideo:stopVideo');
            });
        }
    }]);

    return MediaGallery;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.PageMedia = function (_Snappy$BaseComponent) {
	_inherits(PageMedia, _Snappy$BaseComponent);

	_createClass(PageMedia, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-page-media';
		}
	}]);

	function PageMedia(element) {
		_classCallCheck(this, PageMedia);

		return _possibleConstructorReturn(this, (PageMedia.__proto__ || Object.getPrototypeOf(PageMedia)).call(this, element));
	}

	_createClass(PageMedia, [{
		key: 'render',
		value: function render() {
			this.setVars();
			this.addEventListeners();

			if (this.isDeferred && this.isVideoMedia) {
				this.activeVideo = new _snappy2.default.Component.VideoPromo(this.element);
				this.activeVideo.render();
			}
		}
	}, {
		key: 'setVars',
		value: function setVars() {
			this.$expandButton = !this.$element.data('videoUrl') && this.$element.find('.featured-media__expand');
			this.title = this.$element.data('title');
			this.isDeferred = this.element.hasAttribute('data-defer-snappy');
			this.isVideoMedia = this.element.hasAttribute('data-fa-video-promo');
		}
	}, {
		key: 'addEventListeners',
		value: function addEventListeners() {
			if (this.$expandButton) {
				this.$expandButton.on('click', this.onExpandClick.bind(this));
			}
		}
	}, {
		key: 'onExpandClick',
		value: function onExpandClick() {
			var $template = this.constructImageElement();

			this.$window.trigger('modal:openModal', {
				title: this.title,
				$view: $template,
				$prevElement: this.$expandButton,
				fullscreen: true
			});
		}
	}, {
		key: 'constructImageElement',
		value: function constructImageElement() {
			var $copy = this.$element.find('picture').clone();
			var $element = (0, _jquery2.default)('<div>').append($copy);

			return $element;
		}
	}]);

	return PageMedia;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.Quote = function (_Snappy$BaseComponent) {
	_inherits(Quote, _Snappy$BaseComponent);

	_createClass(Quote, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-quote';
		}
	}]);

	function Quote(element) {
		_classCallCheck(this, Quote);

		return _possibleConstructorReturn(this, (Quote.__proto__ || Object.getPrototypeOf(Quote)).call(this, element));
	}

	_createClass(Quote, [{
		key: 'setVars',
		value: function setVars() {
			this.$tweetBtn = this.$element.find('.fa-quote__twitter');
			this.$tweenAnchor = this.$tweetBtn.find('a');
		}
	}, {
		key: 'initTwitter',
		value: function initTwitter() {
			if (this.$body.hasClass('live-mode') && this.$tweetBtn) {
				this.$tweenAnchor.addClass('twitter-share-button');

				//window.twttr.widgets.load();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			this.setVars();
			this.initTwitter();
		}
	}]);

	return Quote;
}(_snappy2.default.BaseComponent);

/** To show Testimonials Quotes count */
(0, _jquery2.default)(function () {
	var allQuotes = (0, _jquery2.default)(this).find(".cw-new-theme .fa-video-carousel .carousel-container").find('.fa-quote');
	var quoteCountTriangle = (0, _jquery2.default)('.cw-new-theme').find(".quote-count-triangle-down p");
	var totalCountTriangle = (0, _jquery2.default)('.cw-new-theme').find(".quote-count-triangle-up p");

	function quoteCountFn() {
		var currentIndex = 0;
		var count = 0;
		var totalCount = 0;
		allQuotes.each(function () {
			totalCount++;
			if ((0, _jquery2.default)(this).hasClass('slick-active')) {
				currentIndex = (0, _jquery2.default)(this).data('slick-index') + 1;
			}
			if ((0, _jquery2.default)(this).hasClass('slick-cloned')) {
				count++;
			}
		});
		quoteCountTriangle.text('' + currentIndex);
		totalCountTriangle.text('' + (totalCount - count));
	}

	(0, _jquery2.default)('.cw-new-theme  .fa-video-carousel .carousel-container .fa-carousel').on('afterChange', function () {
		quoteCountFn();
	});

	(0, _jquery2.default)('.cw-new-theme  .fa-video-carousel .carousel-container .fa-carousel').on('swipe', function () {
		quoteCountFn();
	});

	quoteCountFn();

	(0, _jquery2.default)('.cw-new-theme  .fa-video-carousel .carousel-container .fa-carousel .carousel .slick-next').click(function () {
		console.log("function called");
		quoteCountFn();
	});
	(0, _jquery2.default)('.cw-new-theme  .fa-video-carousel .carousel-container .fa-carousel .carousel .slick-prev').click(function () {
		console.log("function called");
		quoteCountFn();
	});
});

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.RelatedContent = function (_Snappy$BaseComponent) {
	_inherits(RelatedContent, _Snappy$BaseComponent);

	_createClass(RelatedContent, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-related-content';
		}
	}]);

	function RelatedContent(element) {
		_classCallCheck(this, RelatedContent);

		return _possibleConstructorReturn(this, (RelatedContent.__proto__ || Object.getPrototypeOf(RelatedContent)).call(this, element));
	}

	_createClass(RelatedContent, [{
		key: 'render',
		value: function render() {
			this.setVars();
			this.trackCarousels();
			this.addEventListeners();
			this.activateDefaultTab();
		}
	}, {
		key: 'setVars',
		value: function setVars() {
			this.activeClass = 'active';
			this.$singleMenuTabs = this.$element.find('.content-tabs-menu__item');
			this.$singleMenuTabButtons = this.$element.find('.content-tabs-menu__button');
			this.$contentTabs = this.$element.find('.tabs-container__single-tab');
		}
	}, {
		key: 'trackCarousels',
		value: function trackCarousels() {
			this.carousels = Array.from(this.$contentTabs).map(function (tab, index) {
				var $component = (0, _jquery2.default)(tab).find('.fa-carousel');

				return {
					initiated: false,
					index: index,
					$carousel: $component,
					component: $component[0].component
				};
			});
		}
	}, {
		key: 'addEventListeners',
		value: function addEventListeners() {
			this.$singleMenuTabButtons.on('click', this.onMenuTabClick.bind(this));
		}
	}, {
		key: 'activateDefaultTab',
		value: function activateDefaultTab() {
			var defaultIndex = 0;

			this.setActiveTabMenuItem((0, _jquery2.default)(this.$singleMenuTabButtons[defaultIndex]));
			this.activateTab(defaultIndex);
			this.activateCarousel(defaultIndex);
		}
	}, {
		key: 'onMenuTabClick',
		value: function onMenuTabClick(event) {
			var $el = (0, _jquery2.default)(event.currentTarget);
			var tabIndex = $el.data('tab');

			this.setActiveTabMenuItem($el);
			this.activateTab(tabIndex);
			this.activateCarousel(tabIndex);
		}
	}, {
		key: 'setActiveTabMenuItem',
		value: function setActiveTabMenuItem($el) {
			this.$singleMenuTabs.removeClass(this.activeClass);
			$el.parent().addClass(this.activeClass);
		}
	}, {
		key: 'activateTab',
		value: function activateTab(index) {
			var $activeTab = this.$contentTabs.filter('[data-tab="' + index + '"]');

			this.$contentTabs.removeClass(this.activeClass);
			$activeTab.addClass(this.activeClass);
		}
	}, {
		key: 'activateCarousel',
		value: function activateCarousel(index) {
			var carousel = (0, _underscore.findWhere)(this.carousels, { index: index });

			if (!carousel.initiated) {
				carousel.component.$carousel.slick(carousel.component.options);
				carousel.initiated = true;
			}
		}
	}]);

	return RelatedContent;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _videoHelpers = __webpack_require__(575);

var _videoHelpers2 = _interopRequireDefault(_videoHelpers);

var _playerBridge = __webpack_require__(572);

var _playerBridge2 = _interopRequireDefault(_playerBridge);

var _youtubeWrapper = __webpack_require__(574);

var _youtubeWrapper2 = _interopRequireDefault(_youtubeWrapper);

var _vimeoWrapper = __webpack_require__(573);

var _vimeoWrapper2 = _interopRequireDefault(_vimeoWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.ResponsiveVideo = function (_Snappy$BaseComponent) {
    _inherits(ResponsiveVideo, _Snappy$BaseComponent);

    _createClass(ResponsiveVideo, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-responsive-video';
        }
    }]);

    function ResponsiveVideo(element) {
        _classCallCheck(this, ResponsiveVideo);

        return _possibleConstructorReturn(this, (ResponsiveVideo.__proto__ || Object.getPrototypeOf(ResponsiveVideo)).call(this, element));
    }

    _createClass(ResponsiveVideo, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.init();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.player = null;
            this.$thumbnailNode = this.$element.find('.js-rv-thumbnail');
            this.$videoNode = this.$element.find('.js-rv-video');
            this.$durationNode = this.$element.find('.js-rv-duration');
            this.caption = this.$element.data('videoCaption');
            this.videoUrl = this.$element.data('videoUrl');
            this.currentSection = this.$element.data('currentSection');
            this.isTracked = false;
            this.videoHost = this.detectVideoHost();
            this.videoId = this.getVideoId();
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            (0, _jquery2.default)(document).on('responsiveVideo:stopVideo', this.onEventStopVideo.bind(this));
            this.$thumbnailNode.on('click', this.onClickThumbnailHandler.bind(this));
        }
    }, {
        key: 'init',
        value: function init() {

            this.playerBridge = new _playerBridge2.default();

            var options = {
                videoNode: this.$videoNode[0],
                videoId: this.videoId,
                videoUrl: this.videoUrl,
                onReadyCallback: this.onPlayerReadyCallback.bind(this),
                onPlayCallback: this.onPlayCallback.bind(this)
            };

            var playerWrapper = void 0;

            if (this.videoHost === 'youtube') {
                playerWrapper = new _youtubeWrapper2.default();
            } else if (this.videoHost === 'vimeo') {
                playerWrapper = new _vimeoWrapper2.default();
            }

            this.playerBridge.setImplementation(playerWrapper);
            this.playerBridge.initPlayer(options);

            if (this.$durationNode.length) {
                this.updateMetaData();
            }
        }
    }, {
        key: 'onPlayerReadyCallback',
        value: function onPlayerReadyCallback() {
            this.setEventListeners();
        }
    }, {
        key: 'onPlayCallback',
        value: function onPlayCallback() {
            this.$thumbnailNode.fadeOut(200);

            if (!this.isTracked) {
                this.trackPlay();
            }
        }
    }, {
        key: 'detectVideoHost',
        value: function detectVideoHost() {
            if (this.$element.hasClass('is-vimeo')) {
                return 'vimeo';
            }
            if (this.$element.hasClass('is-youtube')) {
                return 'youtube';
            }

            if (this.videoUrl) {
                return this.videoUrl.indexOf("youtu") > -1 ? 'youtube' : 'vimeo';
            }

            return 'youtube';
        }
    }, {
        key: 'getVideoId',
        value: function getVideoId() {
            if (this.$element.data('videoId')) {
                return this.$element.data('videoId');
            }

            if (this.videoHost === 'youtube' && this.videoUrl) {
                return _videoHelpers2.default.parseYoutubeId(this.videoUrl);
            }

            if (this.videoHost === 'vimeo' && this.videoUrl) {
                return _videoHelpers2.default.parseVimeoId(this.videoUrl);
            }
        }
    }, {
        key: 'updateMetaData',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var duration, formattedDuration;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.playerBridge.getDuration();

                            case 2:
                                duration = _context.sent;
                                formattedDuration = _videoHelpers2.default.getFomattedDuration(duration);

                                this.$durationNode.text(formattedDuration);

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function updateMetaData() {
                return _ref.apply(this, arguments);
            }

            return updateMetaData;
        }()
    }, {
        key: 'onEventStopVideo',
        value: function onEventStopVideo() {
            this.playerBridge.stop();
        }
    }, {
        key: 'trackPlay',
        value: function trackPlay() {
            this.isTracked = true;
            if (this.$body.hasClass('eduhub-layout')) {
                this.$window.trigger('gtm:send', [this.currentSection, 'View Video', window.location.href + ' > ' + this.caption]);
            } else {
                this.$window.trigger('gtm:send', ['Video', 'Play', this.caption]);
            }
        }

        //IE FIX; Doesn't support pointer-events property

    }, {
        key: 'onClickThumbnailHandler',
        value: function onClickThumbnailHandler() {
            this.$thumbnailNode.fadeOut(200);
            this.playerBridge.play();
        }
    }]);

    return ResponsiveVideo;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.RowHeading = function (_Snappy$BaseComponent) {
	_inherits(RowHeading, _Snappy$BaseComponent);

	_createClass(RowHeading, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-row-heading';
		}
	}]);

	function RowHeading(element) {
		_classCallCheck(this, RowHeading);

		return _possibleConstructorReturn(this, (RowHeading.__proto__ || Object.getPrototypeOf(RowHeading)).call(this, element));
	}

	_createClass(RowHeading, [{
		key: 'render',
		value: function render() {}
	}]);

	return RowHeading;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _resize = __webpack_require__(17);

var _resize2 = _interopRequireDefault(_resize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.Scrollto = function (_Snappy$BaseComponent) {
    _inherits(Scrollto, _Snappy$BaseComponent);

    _createClass(Scrollto, null, [{
        key: 'tagName',
        get: function get() {
            return 'cfa-scrollto';
        }
    }]);

    function Scrollto(element) {
        _classCallCheck(this, Scrollto);

        return _possibleConstructorReturn(this, (Scrollto.__proto__ || Object.getPrototypeOf(Scrollto)).call(this, element));
    }

    _createClass(Scrollto, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();
            this.onResize();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            var name = this.$element.attr('data-name');
            this.$links = (0, _jquery2.default)(document).find('.js-scroll-link[data-target="' + name + '"]');
            this.$desktopNav = (0, _jquery2.default)(document).find('.js-sticky-nav-container');
            this.$mobilenav = (0, _jquery2.default)(document).find('.cfa-nav-mobile');
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            (0, _jquery2.default)(window).on('resize:finished', this.bindedResize = this.onResize.bind(this));
            this.$links.on('click', this.scrollToTarget.bind(this));
        }
    }, {
        key: 'scrollToTarget',
        value: function scrollToTarget(e) {
            if (e.target.hasAttribute('data-push-state') && 'replaceState' in history) {
                history.replaceState({}, document.title, e.target.getAttribute('data-push-state') + location.hash);
                var evt = document.createEvent('UIEvents');
                evt.initUIEvent('popstate', true, false, window, 0);
                window.dispatchEvent(evt);
            }
            var topOffset = this.$element[0].getBoundingClientRect().top;
            var scrollVal = topOffset + (0, _jquery2.default)(window).scrollTop() - this.menuHeight;
            (0, _jquery2.default)("html, body").animate({ scrollTop: scrollVal }, 300);
        }
    }, {
        key: 'onResize',
        value: function onResize(e) {
            if (!this.$desktopNav.length || !this.$mobilenav.length) {
                this.menuHeight = 0;
                return;
            }

            if (_resize2.default.isDesktop) {
                this.menuHeight = this.$desktopNav.height();
            } else {
                this.menuHeight = this.$mobilenav.height();
            };
        }
    }]);

    return Scrollto;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.SignpostContentPromo = function (_Snappy$BaseComponent) {
	_inherits(SignpostContentPromo, _Snappy$BaseComponent);

	_createClass(SignpostContentPromo, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-content-promo-signpost';
		}
	}]);

	function SignpostContentPromo(element) {
		_classCallCheck(this, SignpostContentPromo);

		return _possibleConstructorReturn(this, (SignpostContentPromo.__proto__ || Object.getPrototypeOf(SignpostContentPromo)).call(this, element));
	}

	_createClass(SignpostContentPromo, [{
		key: 'render',
		value: function render() {
			this.setVars();
			this.setEventListeners();
		}
	}, {
		key: 'setVars',
		value: function setVars() {
			this.$anchorableElement = this.$element.find('.fa-content-promo__block-link');
			this.elementHasFocusClass = 'fa-content-promo--has-focus';
		}
	}, {
		key: 'setEventListeners',
		value: function setEventListeners() {
			this.$anchorableElement.on('mouseover focus', this.onElementFocusState.bind(this));
			this.$anchorableElement.on('mouseout focusout', this.onElementBlur.bind(this));
		}
	}, {
		key: 'onElementFocusState',
		value: function onElementFocusState() {
			this.$element.addClass(this.elementHasFocusClass);
		}
	}, {
		key: 'onElementBlur',
		value: function onElementBlur(event) {
			var toElement = event.toElement || event.relatedTarget;
			var toElementIsRelated = _jquery2.default.contains(this.$element[0], toElement);

			if (!toElementIsRelated) {
				this.$element.removeClass(this.elementHasFocusClass);
			}
		}
	}]);

	return SignpostContentPromo;
}(_snappy2.default.BaseComponent);

(0, _jquery2.default)(function () {
	var cwSignpostContentPromo = new _snappy2.default.Component.SignpostContentPromo();

	//Image Gallery
	(0, _jquery2.default)('.prev, .next').css('cursor', 'pointer');

	//Hide all images except the first one
	(0, _jquery2.default)(".slide-content").each(function () {
		(0, _jquery2.default)(this).find('.slide-content__items picture:gt(0)').hide();
	});

	(0, _jquery2.default)('.prev').on("click keypress", function (event) {
		if (event.which == 13 || event.type == "click") {
			(0, _jquery2.default)(this).parent().find('.slide-content__items picture:first-child').hide();
			(0, _jquery2.default)(this).parent().find('.slide-content__items picture:last-child').prependTo((0, _jquery2.default)(this).parent().find('.slide-content__items')).hide();
			(0, _jquery2.default)(this).parent().find('.slide-content__items picture:first-child').show();
		}
	});

	(0, _jquery2.default)('.next').on("click keypress", function (event) {
		if (event.which == 13 || event.type == "click") {
			(0, _jquery2.default)(this).parent().find('.slide-content__items picture:first-child').hide().next().show().end().appendTo((0, _jquery2.default)(this).parent().find('.slide-content__items'));
		}
	});
});

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.SignpostContentPromoHero = function (_Snappy$BaseComponent) {
	_inherits(SignpostContentPromoHero, _Snappy$BaseComponent);

	_createClass(SignpostContentPromoHero, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-content-promo-signpost-hero';
		}
	}]);

	function SignpostContentPromoHero(element) {
		_classCallCheck(this, SignpostContentPromoHero);

		return _possibleConstructorReturn(this, (SignpostContentPromoHero.__proto__ || Object.getPrototypeOf(SignpostContentPromoHero)).call(this, element));
	}

	_createClass(SignpostContentPromoHero, [{
		key: 'render',
		value: function render() {}
	}]);

	return SignpostContentPromoHero;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.SignpostContentPromoLinkList = function (_Snappy$BaseComponent) {
	_inherits(SignpostContentPromoLinkList, _Snappy$BaseComponent);

	_createClass(SignpostContentPromoLinkList, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-content-promo-signpost-linklist';
		}
	}]);

	function SignpostContentPromoLinkList(element) {
		_classCallCheck(this, SignpostContentPromoLinkList);

		return _possibleConstructorReturn(this, (SignpostContentPromoLinkList.__proto__ || Object.getPrototypeOf(SignpostContentPromoLinkList)).call(this, element));
	}

	_createClass(SignpostContentPromoLinkList, [{
		key: 'render',
		value: function render() {}
	}]);

	return SignpostContentPromoLinkList;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.SignpostContentPromoQuote = function (_Snappy$BaseComponent) {
	_inherits(SignpostContentPromoQuote, _Snappy$BaseComponent);

	_createClass(SignpostContentPromoQuote, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-content-promo-signpost--quote';
		}
	}]);

	function SignpostContentPromoQuote(element) {
		_classCallCheck(this, SignpostContentPromoQuote);

		return _possibleConstructorReturn(this, (SignpostContentPromoQuote.__proto__ || Object.getPrototypeOf(SignpostContentPromoQuote)).call(this, element));
	}

	_createClass(SignpostContentPromoQuote, [{
		key: 'render',
		value: function render() {}
	}]);

	return SignpostContentPromoQuote;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.StickyMenu = function (_Snappy$BaseComponent) {
    _inherits(StickyMenu, _Snappy$BaseComponent);

    _createClass(StickyMenu, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-sticky-menu';
        }
    }]);

    function StickyMenu(element) {
        _classCallCheck(this, StickyMenu);

        return _possibleConstructorReturn(this, (StickyMenu.__proto__ || Object.getPrototypeOf(StickyMenu)).call(this, element));
    }

    _createClass(StickyMenu, [{
        key: 'setVars',
        value: function setVars() {}
    }, {
        key: 'render',
        value: function render() {}
    }]);

    return StickyMenu;
}(_snappy2.default.BaseComponent);

(0, _jquery2.default)(function () {
    var cwStickyMenu = new _snappy2.default.Component.StickyMenu();

    /* Smooth Scrolling */
    (0, _jquery2.default)(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();

        (0, _jquery2.default)('html, body').animate({
            scrollTop: (0, _jquery2.default)(_jquery2.default.attr(this, 'href')).offset().top - 75
        }, 500);
    });

    /**********
    STICKY MENU
    **********/
    var stickyMenu = (0, _jquery2.default)('#sticky-menu');

    (0, _jquery2.default)(window).scroll(function () {
        if ((0, _jquery2.default)(this).scrollTop() > 125) {
            stickyMenu.addClass('fixed-nav');
        } else {
            stickyMenu.removeClass('fixed-nav');
        }
    });

    (0, _jquery2.default)(window).on('scroll', function () {
        (0, _jquery2.default)('.tab-content').each(function () {
            if ((0, _jquery2.default)(window).scrollTop() >= (0, _jquery2.default)(this).position().top - 100) {
                var id = (0, _jquery2.default)(this).attr('id');
                (0, _jquery2.default)('.subMenu li a').removeClass('active');
                (0, _jquery2.default)('.subMenu li a[href="#' + id + '"]').addClass('active');
            }
        });
    });
});

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _handlebars = __webpack_require__(21);

var _handlebars2 = _interopRequireDefault(_handlebars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.Tabs = function (_Snappy$BaseComponent) {
    _inherits(Tabs, _Snappy$BaseComponent);

    _createClass(Tabs, null, [{
        key: 'tagName',
        get: function get() {
            return 'cfa-tabs';
        }
    }]);

    function Tabs(element) {
        _classCallCheck(this, Tabs);

        return _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, element));
    }

    _createClass(Tabs, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();
            this.setDefaultState();
            if (this.hasDropdown) {
                this.renderDropdown();
            }
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.$links = this.$element.find('.js-tab-link');
            this.$tabs = this.$element.find('.js-tab');
            this.checkForUnsavedData = this.$element.is('[data-check-for-unsaved-data]');
            this.unsavedLocalStorage = this.$element.attr('data-check-for-unsaved-data');
            this.hasDropdown = this.$element.is('[data-has-dropdown]');
            this.$dropdownContainer = this.$element.find('[data-dropdown-container]');
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            this.$links.on('click', this.clickProcess.bind(this));
        }
    }, {
        key: 'setDefaultState',
        value: function setDefaultState() {
            var $activeLink = this.$links.filter('.is-active').length ? this.$links.filter('.is-active') : this.$links.eq(0);
            var target = $activeLink.attr('href').substr(1);

            $activeLink.addClass('is-active');
            $activeLink.attr('aria-selected', 'true');

            this.selectTab(target);
        }
    }, {
        key: 'renderDropdown',
        value: function renderDropdown() {
            var dropdownOptions = [];
            var dropdownTemplate = (0, _jquery2.default)('#dropdown-template').html();
            var dropdownTemplateFn = _handlebars2.default.compile(dropdownTemplate);

            this.$links.each(function (index, link) {
                dropdownOptions.push({
                    selected: false,
                    value: link.getAttribute('href').substr(1),
                    text: link.textContent
                });
            });

            var dropdownHtml = dropdownTemplateFn(dropdownOptions);

            this.$dropdownContainer.html(dropdownHtml);

            this.$dropdown = this.$element.find('[data-dropdown]');
            this.$dropdown.on('click', this.onDropdownClick.bind(this));
            this.$dropdown.on('change', this.changeProcess.bind(this));
        }
    }, {
        key: 'onDropdownClick',
        value: function onDropdownClick(e) {
            this.dropdownPreviousSelection = (0, _jquery2.default)(e.target).find('option:selected');
            this.dropdownPreviousValue = (0, _jquery2.default)(e.target).val();
        }
    }, {
        key: 'preventClick',
        value: function preventClick(target) {
            var targets = JSON.parse(localStorage.getItem(this.unsavedLocalStorage));

            if (targets && typeof targets[target] !== 'undefined') {
                if (targets[target]) {
                    if (confirm(targets['unsavedDataWarnMessage'])) {
                        return false;
                    } else {
                        return true;
                    }
                }
            } else {
                return false;
            }
        }
    }, {
        key: 'clickProcess',
        value: function clickProcess(e) {
            e.preventDefault();

            var $previousActive = this.$links.filter('.is-active');

            var $previousActiveTarget = $previousActive.attr('href').substr(1);

            var $activeLink = (0, _jquery2.default)(e.target);

            if ($activeLink === $previousActive) return;

            var target = $activeLink.attr('href').substr(1);

            if (this.checkForUnsavedData && this.preventClick($previousActiveTarget)) {
                $activeLink.blur();
                return;
            }

            if (this.hasDropdown) {
                this.$dropdown.find('option').filter('[value=\'' + target + '\']').prop('selected', true);
            }

            this.changeActiveLink($activeLink);

            this.selectTab(target);
        }
    }, {
        key: 'changeProcess',
        value: function changeProcess(e) {
            var target = e.target.value;

            if (this.checkForUnsavedData && this.preventClick(this.dropdownPreviousValue)) {
                this.dropdownPreviousSelection.prop('selected', true);
                return false;
            }

            var $activeLink = this.$links.filter('[href=\'#' + target + '\']');

            this.changeActiveLink($activeLink);

            this.selectTab(target);
        }
    }, {
        key: 'changeActiveLink',
        value: function changeActiveLink($activeLink) {
            this.$links.removeClass('is-active');
            this.$links.attr('aria-selected', 'false');

            $activeLink.addClass('is-active');
            $activeLink.attr('aria-selected', 'true');
        }
    }, {
        key: 'selectTab',
        value: function selectTab(name) {
            var $activeTab = this.$tabs.filter('[data-target=\'' + name + '\']');
            this.$tabs.removeClass('is-active');
            this.$tabs.attr('aria-hidden', 'true');

            $activeTab.addClass('is-active');
            $activeTab.attr('aria-hidden', 'false');
        }
    }]);

    return Tabs;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.Tickets = function (_Snappy$BaseComponent) {
	_inherits(Tickets, _Snappy$BaseComponent);

	_createClass(Tickets, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-tickets';
		}
	}]);

	function Tickets(element) {
		_classCallCheck(this, Tickets);

		return _possibleConstructorReturn(this, (Tickets.__proto__ || Object.getPrototypeOf(Tickets)).call(this, element));
	}

	_createClass(Tickets, [{
		key: 'render',
		value: function render() {
			this.setVars();
			this.setEventListeners();
			this.fitContext();
			this.initCarousel();
		}
	}, {
		key: 'setVars',
		value: function setVars() {
			this.isBelowFullWidthComponent = this.determineComponentContext();
			this.$carouselComponent = this.$element.find('.fa-carousel');
			this.$carousel = this.$carouselComponent.find('.carousel');
			this.carouselInstance = this.$carouselComponent.get(0).component;
		}
	}, {
		key: 'setEventListeners',
		value: function setEventListeners() {
			window.addEventListener('fa.viewportResize', this.onViewportResize.bind(this));
		}
	}, {
		key: 'determineComponentContext',
		value: function determineComponentContext() {
			this.$parentElement = this.$element.parent();

			return this.$parentElement.hasClass('col-sm-4');
		}
	}, {
		key: 'fitContext',
		value: function fitContext() {
			var containerClass = 'container';
			var narrowClass = 'narrow-variation';

			if (this.isBelowFullWidthComponent) {
				this.$element.find('.' + containerClass).removeClass(containerClass).addClass(narrowClass);
				this.$element.addClass(narrowClass);
				this.carouselInstance.options.slidesToShow = 1;
				this.setElementWidth();
			}
		}
	}, {
		key: 'setElementWidth',
		value: function setElementWidth() {
			this.parentWidth = this.$parentElement.width();
			this.$element.width(this.parentWidth);
		}
	}, {
		key: 'initCarousel',
		value: function initCarousel() {
			this.$carousel.slick(this.carouselInstance.options);
			this.carouselInitialized = true;
		}
	}, {
		key: 'onViewportResize',
		value: function onViewportResize() {
			this.setElementWidth();
		}
	}]);

	return Tickets;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.Topbar = function (_Snappy$BaseComponent) {
	_inherits(Topbar, _Snappy$BaseComponent);

	_createClass(Topbar, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-topbar';
		}
	}]);

	function Topbar(element) {
		_classCallCheck(this, Topbar);

		return _possibleConstructorReturn(this, (Topbar.__proto__ || Object.getPrototypeOf(Topbar)).call(this, element));
	}

	_createClass(Topbar, [{
		key: 'render',
		value: function render() {
			this.setVars();
			this.setEventListeners();
			this.setEventListenersOnLargeViewport();
			this.queryUserStatus();
		}
	}, {
		key: 'setEventListeners',
		value: function setEventListeners() {
			window.addEventListener('fa.viewportResize', this.onViewportResize.bind(this));
			this.$menuToggle.on('click', this.onMenuToggleClick.bind(this));
			this.$expandableLinks.on('click', this.onLinkItemClick.bind(this));
			this.$returnButtons.on('click', this.onReturnButtonClick.bind(this));
			this.$moreSitesButton.on('mouseover focus', this.onMoreSitesBtnHover.bind(this));
			this.$faSitesPrimaryLink.on('mouseover focus', this.onPrimaryLinkMoreAvailableHover.bind(this));
			this.$userButton.on('click', this.onUserButtonClick.bind(this));
		}
	}, {
		key: 'setEventListenersOnLargeViewport',
		value: function setEventListenersOnLargeViewport() {
			if (!globalConfigs.viewportIsBelowLarge) {
				this.$moreSitesButton.on('mouseout focusout', this.onMenuBlur.bind(this, this.$moreFaSitesParent));
				this.$parentLinksContainer.on('mouseout focusout', this.onMenuBlur.bind(this, this.$moreFaSitesParent));
			}
		}
	}, {
		key: 'onLinkItemClick',
		value: function onLinkItemClick(event) {
			if (globalConfigs.viewportIsBelowLarge) {
				var $link = (0, _jquery2.default)(event.currentTarget);

				$link.closest(this.moreClass).addClass(this.expandedClass);
				event.preventDefault();
			}
		}
	}, {
		key: 'onViewportResize',
		value: function onViewportResize() {
			this.setEventListenersOnLargeViewport();
			this.menuIsActive = false;
			this.toggleMenu();
		}
	}, {
		key: 'onReturnButtonClick',
		value: function onReturnButtonClick(event) {
			var $returnCta = (0, _jquery2.default)(event.currentTarget);

			$returnCta.closest(this.moreClass).removeClass(this.expandedClass);
		}
	}, {
		key: 'setVars',
		value: function setVars() {
			this.menuIsActive = false;
			this.$menuToggle = this.$element.find('.controls__menu-toggle');
			this.$expandableLinks = this.$element.find('.more-available');
			this.$returnButtons = this.$element.find('.more-fa-sites__link--go-back');
			this.$moreSitesButton = this.$element.find('.more-fa-item__button');
			this.$moreFaSitesParent = this.$element.find('.topbar__primary-item.more-fa-item');
			this.$faSitesPrimaryLink = this.$element.find('.more-fa-sites__link.more-available');
			this.$parentLinksContainer = this.$element.find('.parent-links');
			this.menuActiveClass = 'menu-active';
			this.expandedClass = 'expanded';
			this.moreClass = '.more-fa-item';
			this.$userDetailsContainer = this.$element.find('.controls');
			this.$userButton = this.$userDetailsContainer.find('.controls__sign-in');
		}
	}, {
		key: 'onMenuToggleClick',
		value: function onMenuToggleClick() {
			this.menuIsActive = !this.menuIsActive;
			this.toggleMenu();
		}
	}, {
		key: 'toggleMenu',
		value: function toggleMenu() {
			this.$element.toggleClass(this.menuActiveClass, this.menuIsActive);
		}
	}, {
		key: 'onMoreSitesBtnHover',
		value: function onMoreSitesBtnHover() {
			this.$moreFaSitesParent.addClass(this.menuActiveClass);
		}
	}, {
		key: 'onPrimaryLinkMoreAvailableHover',
		value: function onPrimaryLinkMoreAvailableHover(event) {
			var target = event && event.currentTarget;
			this.$activePrimaryLink = (0, _jquery2.default)(target).parent('.more-fa-sites__list-item');

			this.$activePrimaryLink.addClass(this.menuActiveClass);
			this.$activePrimaryLink.children().on('mouseout focusout', this.onMenuBlur.bind(this, this.$activePrimaryLink));
		}
	}, {
		key: 'onMenuBlur',
		value: function onMenuBlur($parent, event) {
			var toElement = event.toElement || event.relatedTarget;
			var toElementIsInContainingParent = _jquery2.default.contains($parent[0], toElement);

			if (!toElementIsInContainingParent) {
				$parent.removeClass(this.menuActiveClass);
			}
		}
	}, {
		key: 'queryUserStatus',
		value: function queryUserStatus() {
			var signInUrl = this.$userButton.data('isSignedInUrl');

			var currentHost = window.location.hostname;

			if (currentHost == "www.thefa.com" || currentHost == "beta.thefa.dev" || currentHost == "beta.thefa.test") {

				_jquery2.default.ajax({
					method: 'GET',
					cache: false,
					url: signInUrl
				}).then(this.onUserStatusResponse.bind(this), this.onUserStatusError.bind(this));
			}
		}
	}, {
		key: 'onUserStatusResponse',
		value: function onUserStatusResponse(response) {
			if (response && response.isLoggedIn) {
				this.$userButton.text(response.Html);
				this.$userDetailsContainer.addClass('user-signed-in');
			}
		}
	}, {
		key: 'onUserStatusError',
		value: function onUserStatusError() {}
	}, {
		key: 'onUserButtonClick',
		value: function onUserButtonClick() {
			this.userMenuIsActive = !this.userMenuIsActive;

			this.toggleUserMenu();
		}
	}, {
		key: 'toggleUserMenu',
		value: function toggleUserMenu() {
			this.$userDetailsContainer.toggleClass('account-menu-active', this.userMenuIsActive);
		}
	}]);

	return Topbar;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _domUtils = __webpack_require__(576);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Tracking = function () {
    function Tracking() {
        _classCallCheck(this, Tracking);

        this.opts = {
            events: ['click', 'change', 'keyup'],
            attributePrefix: 'data-gtm-',
            eventName: 'eventTrack'
        };

        this.init();
    }

    _createClass(Tracking, [{
        key: 'init',
        value: function init() {
            var _this = this;

            this.handleEvents = this.handleEvents.bind(this);
            this.send = this.send.bind(this);

            var selector = '[' + this.opts.attributePrefix + 'on]';

            var $mailLinks = (0, _jquery2.default)('a[href^="mailto"]');
            var $externalLinks = (0, _jquery2.default)('a').filter(function () {
                return this.hostname && !this.href.match(/^mailto\:/) && this.hostname !== location.hostname && !this.hasAttribute('data-gtm-on');
            });

            this.delegates = {};

            this.opts.events.forEach(function (event) {
                _this.delegates[event] = (0, _domUtils.delegate)(document, event, selector, _this.handleEvents, {
                    composed: true,
                    useCapture: true
                });
            });

            // <button
            // data-gtm-on="click"
            // data-gtm-event-category="category"
            // data-gtm-event-action="action"
            // data-gtm-event-label="label">
            //btn </button>


            (0, _jquery2.default)(window).on('gtm:send', this.send); // $(window).trigger('gtm:send', [ 'category', 'action', 'label']);
            $mailLinks.on('click', this.onClickMailto.bind(this));
            $externalLinks.on('click', this.onExternalLinkClick.bind(this));
        }
    }, {
        key: 'getAttributeFields',
        value: function getAttributeFields(element, prefix) {
            var _this2 = this;

            var attributes = (0, _domUtils.getAttributes)(element);
            var attributeFields = {};

            Object.keys(attributes).forEach(function (attribute) {
                if (attribute.indexOf(prefix) === 0 && attribute !== prefix + 'on') {
                    var value = attributes[attribute];
                    if (value === 'true') value = true;
                    if (value === 'false') value = false;
                    var field = _this2.constructor.camelCase(attribute.slice(prefix.length));
                    attributeFields[field] = value;
                }
            });

            return attributeFields;
        }
    }, {
        key: 'handleEvents',
        value: function handleEvents(event, element) {

            if (typeof dataLayer === 'undefined') return;

            var prefix = this.opts.attributePrefix;
            var events = element.getAttribute(prefix + 'on').split(/\s*,\s*/);

            if (events.indexOf(event.type) < 0) return;

            var attributeFields = this.getAttributeFields(element, prefix);

            attributeFields.event = this.opts.eventName;

            dataLayer.push(attributeFields);
        }
    }, {
        key: 'send',
        value: function send() {

            if (typeof dataLayer === 'undefined') return;

            var _ref = [].concat(Array.prototype.slice.call(arguments)),
                e = _ref[0],
                category = _ref[1],
                action = _ref[2],
                label = _ref[3];

            dataLayer.push(_extends({}, { 'event': this.opts.eventName }, category && { 'eventCategory': category }, action && { 'eventAction': action }, label && { 'eventLabel': label }));
        }
    }, {
        key: 'onClickMailto',
        value: function onClickMailto(e) {
            var $link = (0, _jquery2.default)(e.target).closest('a');
            var email = $link.attr('href').substr(7);
            (0, _jquery2.default)(window).trigger('gtm:send', ['Email', 'Click', email]);
        }
    }, {
        key: 'onExternalLinkClick',
        value: function onExternalLinkClick(e) {
            var linkDestination = (0, _jquery2.default)(e.target).closest('a').attr('href');
            (0, _jquery2.default)(window).trigger('gtm:send', ['Link', 'Click', window.location.href + ' > ' + linkDestination]);
        }
    }], [{
        key: 'camelCase',
        value: function camelCase(str) {
            return str.replace(/[\-\_]+(\w?)/g, function (match, p1) {
                return p1.toUpperCase();
            });
        }
    }]);

    return Tracking;
}();

var tracking = new Tracking();

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.UsefulResources = function (_Snappy$BaseComponent) {
	_inherits(UsefulResources, _Snappy$BaseComponent);

	_createClass(UsefulResources, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-useful-resources';
		}
	}]);

	function UsefulResources(element) {
		_classCallCheck(this, UsefulResources);

		return _possibleConstructorReturn(this, (UsefulResources.__proto__ || Object.getPrototypeOf(UsefulResources)).call(this, element));
	}

	_createClass(UsefulResources, [{
		key: 'setVars',
		value: function setVars() {
			this.$expandButton = this.$element.find('.resources__load-more');
			this.$resources = this.$element.find('.single-resource');
			this.$resourcesList = this.$element.find('.resources__list');
			this.resourcesLength = this.$resources.length;
			this.$amountSpan = this.$expandButton.find('.amount');
			this.$expandButtonCopy = this.$expandButton.find('.copy');
		}
	}, {
		key: 'addEventListeners',
		value: function addEventListeners() {
			this.$expandButton.on('click', this.onExpandButtonClick.bind(this));
		}
	}, {
		key: 'onExpandButtonClick',
		value: function onExpandButtonClick() {
			this.expanded = !this.expanded;

			if (this.expanded) {
				this.$resourcesList.css('height', this.totalHeight);
				this.$amountSpan.text('');
				this.$expandButtonCopy.text('collapse');
			} else {
				this.$resourcesList.css('height', this.collapseHeight);
				this.$amountSpan.text(this.extrasLength);
				this.$expandButtonCopy.text('more files');
			}

			this.$element.toggleClass('expanded', this.expanded);
		}
	}, {
		key: 'showExpandButton',
		value: function showExpandButton() {
			this.expanded = false;
			this.$expandButton.addClass('active');
			this.$amountSpan.text(this.extrasLength);
		}
	}, {
		key: 'calculateComponentHeight',
		value: function calculateComponentHeight() {
			this.totalHeight = this.$resourcesList.height();
			this.extrasLength = this.resourcesLength - 3;
			this.collapseHeight = this.calculateCollapseHeight();
			this.$resourcesList.css('height', this.collapseHeight);
		}
	}, {
		key: 'calculateCollapseHeight',
		value: function calculateCollapseHeight() {
			var total = 0;

			this.$resources.slice(0, 3).each(function (index, item) {
				var amount = (0, _jquery2.default)(item).height();

				total += amount;
			});

			return total + 3;
		}
	}, {
		key: 'render',
		value: function render() {
			this.setVars();

			if (this.resourcesLength > 3) {
				this.calculateComponentHeight();
				this.showExpandButton();
				this.addEventListeners();
			}
		}
	}]);

	return UsefulResources;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.SeatVideoPromo = function (_Snappy$BaseComponent) {
	_inherits(SeatVideoPromo, _Snappy$BaseComponent);

	_createClass(SeatVideoPromo, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-seat-video-promo';
		}
	}]);

	function SeatVideoPromo(element) {
		_classCallCheck(this, SeatVideoPromo);

		return _possibleConstructorReturn(this, (SeatVideoPromo.__proto__ || Object.getPrototypeOf(SeatVideoPromo)).call(this, element));
	}

	_createClass(SeatVideoPromo, [{
		key: 'render',
		value: function render() {
			this.setVars();
			this.setVideoData();
			this.addVideoEventListeners();
		}
	}, {
		key: 'setVars',
		value: function setVars() {
			this.$videoPlayIcon = this.$element.find('.featured-media__expand--video');
			this.$videoThumbnailLink = this.$element.find('.responsive-image');
			this.$videoThumbnailBlock = this.$element.find('.fa-content-promo__block-link');
			this.$videoLinkBlock = this.$element.find('.video-link__block-link');
		}
	}, {
		key: 'addVideoEventListeners',
		value: function addVideoEventListeners() {
			this.$videoThumbnailLink.on('click', this.onVideoThumbnailClick.bind(this));
			this.$videoThumbnailBlock.on('click', this.onVideoThumbnailClick.bind(this));
			this.$videoLinkBlock.on('click', this.onVideoThumbnailClick.bind(this));
			if (this.$videoPlayIcon) {
				this.$videoPlayIcon.on('click', this.onVideoThumbnailClick.bind(this));
			}
		}
	}, {
		key: 'onVideoThumbnailClick',
		value: function onVideoThumbnailClick(event) {
			this.$window.trigger('modal:openModal', {
				title: this.videoTitle,
				$view: this.$videoTemplate,
				$prevElement: this.$element
			});

			event.preventDefault();
		}
	}, {
		key: 'formatVideoUrl',
		value: function formatVideoUrl(url) {
			return url += '';
		}
	}, {
		key: 'setVideoData',
		value: function setVideoData() {
			var videoUrl = this.formatVideoUrl(this.$element.data('videoUrl'));

			this.videoTitle = this.$element.data('videoTitle');
			this.$videoTemplate = (0, _jquery2.default)(window.videoTemplate({
				videoUrl: videoUrl
			}));
		}
	}]);

	return SeatVideoPromo;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _settings;

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(76);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//video popup
var cards = document.querySelectorAll('.video-card');
var popup = document.querySelector('.popup');

var popupContent = document.getElementById('popup-content');

cards.forEach(function (card) {
   card.addEventListener('click', function () {
      var content = card.getAttribute('data-content');
      popupContent.innerHTML = content;
      popup.style.display = 'flex';
      body.style.overflow = 'hidden';
   });
});
(0, _jquery2.default)(".vid-close-btn").click(function () {
   (0, _jquery2.default)(".popup").hide();
   (0, _jquery2.default)("body").css('overflow', '');
});

//video popup end

// carousel

var $carousel = (0, _jquery2.default)('.slider');
var slideCount = (0, _jquery2.default)('.slider .slick-slide').length;
var numSlide = $carousel.attr("data-slidesToShow");
var settings = (_settings = {
   dots: true,
   arrows: true,
   //slide: '.slide-item',
   slidesToShow: numSlide
}, _defineProperty(_settings, 'arrows', true), _defineProperty(_settings, 'appendArrows', (0, _jquery2.default)(".vid_arrows")), _defineProperty(_settings, 'prevArrow', '<div class="vid_arrow vid_arrow_dir_left"><svg  width="44" height="43" viewBox="0 0 45 45" fill="none"><path d="M17.6171 21.6452L24.5241 14.7382C24.9957 14.2666 25.7609 14.2666 26.2336 14.7382C26.7052 15.2098 26.7052 15.976 26.2336 16.4477L20.1814 22.4998L26.2336 28.552C26.7052 29.0236 26.7052 29.7899 26.2336 30.2615C25.7609 30.7331 24.9957 30.7331 24.5241 30.2615L17.6171 23.3545C17.1444 22.8829 17.1444 22.1166 17.6171 21.645V21.6452Z" fill="#202020"/></svg></div>'), _defineProperty(_settings, 'nextArrow', '<div class="vid_arrow vid_arrow_dir_right"><svg  width="44" height="43" viewBox="0 0 44 43" fill="none"><path d="M26.7719 22.3354L20.0219 29.0854C19.561 29.5463 18.8132 29.5463 18.3513 29.0854C17.8904 28.6245 17.8904 27.8757 18.3513 27.4148L24.2659 21.5002L18.3513 15.5856C17.8904 15.1247 17.8904 14.3758 18.3513 13.9149C18.8132 13.4541 19.561 13.4541 20.0219 13.9149L26.7719 20.6649C27.2339 21.1258 27.2339 21.8747 26.7719 22.3356V22.3354Z" fill="#202020"/></svg></div>'), _defineProperty(_settings, 'dots', true), _defineProperty(_settings, 'appendDots', (0, _jquery2.default)('.slider-dots-box')), _defineProperty(_settings, 'dotsClass', 'slider-dots'), _defineProperty(_settings, 'responsive', [{
   breakpoint: 1024, // Desktop and larger screens
   settings: slideCount < numSlide ? "unslick" : {}
}, {
   breakpoint: 769,
   settings: {
      slidesToShow: 1,
      centerMode: true,
      centerPadding: '80px'

   }
}]), _settings);

function setSlideVisibility() {
   //Find the visible slides i.e. where aria-hidden="false"
   var visibleSlides = $carousel.find('.slider .slick-slide[aria-hidden="false"]');
   //Make sure all of the visible slides have an opacity of 1
   (0, _jquery2.default)(visibleSlides).each(function () {
      (0, _jquery2.default)(this).css('opacity', 1);
   });
}

$carousel.slick(settings);
$carousel.slick('slickGoTo', 0);
setSlideVisibility();

$carousel.on('afterChange', function () {
   setSlideVisibility();
});

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _handlebars = __webpack_require__(21);

var _handlebars2 = _interopRequireDefault(_handlebars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.Video = function (_Snappy$BaseComponent) {
	_inherits(Video, _Snappy$BaseComponent);

	_createClass(Video, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-video';
		}
	}]);

	function Video(element) {
		_classCallCheck(this, Video);

		return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).call(this, element));
	}

	_createClass(Video, [{
		key: 'render',
		value: function render() {
			this.setVideoTemplate();
		}
	}, {
		key: 'setVideoTemplate',
		value: function setVideoTemplate() {
			var source = (0, _jquery2.default)('#video-template').html();

			window.videoTemplate = _handlebars2.default.compile(source);
		}
	}]);

	return Video;
}(_snappy2.default.BaseComponent);

_snappy2.default.Component.VideoPromo = function (_Snappy$BaseComponent2) {
	_inherits(VideoPromo, _Snappy$BaseComponent2);

	_createClass(VideoPromo, null, [{
		key: 'tagName',
		get: function get() {
			return 'fa-video-promo';
		}
	}]);

	function VideoPromo(element) {
		_classCallCheck(this, VideoPromo);

		return _possibleConstructorReturn(this, (VideoPromo.__proto__ || Object.getPrototypeOf(VideoPromo)).call(this, element));
	}

	_createClass(VideoPromo, [{
		key: 'render',
		value: function render() {
			this.setVars();
			this.setVideoData();
			this.addVideoEventListeners();
		}
	}, {
		key: 'setVars',
		value: function setVars() {
			this.$videoPlayIcon = this.$element.find('.featured-media__expand--video');
			this.$videoThumbnailLink = this.$element.find('.responsive-image');
			this.$videoThumbnailBlock = this.$element.find('.fa-content-promo__block-link');
			this.$videoLinkBlock = this.$element.find('.video-link__block-link');
		}
	}, {
		key: 'addVideoEventListeners',
		value: function addVideoEventListeners() {
			this.$videoThumbnailLink.on('click', this.onVideoThumbnailClick.bind(this));
			this.$videoThumbnailBlock.on('click', this.onVideoThumbnailClick.bind(this));
			this.$videoLinkBlock.on('click', this.onVideoThumbnailClick.bind(this));
			if (this.$videoPlayIcon) {
				this.$videoPlayIcon.on('click', this.onVideoThumbnailClick.bind(this));
			}
		}
	}, {
		key: 'onVideoThumbnailClick',
		value: function onVideoThumbnailClick(event) {
			this.$window.trigger('modal:openModal', {
				title: this.videoTitle,
				$view: this.$videoTemplate,
				$prevElement: this.$element
			});

			if (this.$body.hasClass('cfa-generic')) {
				this.$window.trigger('gtm:send', ['Video', 'Play', this.videoTitle]);
			}

			event.preventDefault();
		}
	}, {
		key: 'formatYoutubeUrl',
		value: function formatYoutubeUrl(url) {
			return url += '?autoplay=1';
		}
	}, {
		key: 'setVideoData',
		value: function setVideoData() {
			var videoUrl = this.formatYoutubeUrl(this.$element.data('videoUrl'));
			var videoRel = this.$element.data('videoRel');

			if (videoRel !== "") {
				videoUrl += '&rel=' + videoRel;
			}

			this.videoTitle = this.$element.data('videoTitle');
			this.$videoTemplate = (0, _jquery2.default)(window.videoTemplate({
				videoUrl: videoUrl
			}));
		}
	}]);

	return VideoPromo;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.WembleyStadiumEnquiryForm = function (_Snappy$BaseComponent) {
    _inherits(WembleyStadiumEnquiryForm, _Snappy$BaseComponent);

    _createClass(WembleyStadiumEnquiryForm, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-ws-enquiry-form';
        }
    }]);

    function WembleyStadiumEnquiryForm(element) {
        _classCallCheck(this, WembleyStadiumEnquiryForm);

        return _possibleConstructorReturn(this, (WembleyStadiumEnquiryForm.__proto__ || Object.getPrototypeOf(WembleyStadiumEnquiryForm)).call(this, element));
    }

    _createClass(WembleyStadiumEnquiryForm, [{
        key: 'setVars',
        value: function setVars() {
            this.errorMessage = document.getElementsByClassName('fa-input-field__error-message');
            this.preferredDateInput = document.getElementById('preferred-date');
            this.checkedCheckboxes = [];
            this.checkboxContainers = document.querySelectorAll('.checkbox__input');
            this.preferredDateField = document.getElementsByName('preferred_date');
            this.numberOfGuestField = document.getElementsByName('guest_numbers');
            this.titleField = document.getElementsByName('title');
            this.firstNameField = document.getElementsByName('first_name');
            this.surnameField = document.getElementsByName('surname');
            this.emailField = document.getElementsByName('email');
            this.companyNameField = document.getElementsByName('company_name');
            this.contactNumberField = document.getElementsByName('contact_number');
            this.otherRequirementsField = document.getElementsByName('other_requirements');
            this.jobTitleField = document.getElementsByName('job_title');
            this.eventTimeField = document.getElementsByName('event_time');
            this.hearAboutUsField = document.getElementsByName('hear_about_us');
            this.formTextInputs = document.querySelectorAll('.fa-enquiry-form__form input[type=text]');
            this.submitBtn = document.getElementById('ws-enquiry-form-submit');
        }
    }, {
        key: 'addEventListeners',
        value: function addEventListeners() {
            this.submitBtn.addEventListener('click', this.validateForm.bind(this));
            this.preferredDateInput.addEventListener('keydown', this.addForwardSlash.bind(this));
            for (var i = 0; i < this.formTextInputs.length; i++) {
                this.formTextInputs[i].addEventListener('keyup', this.removeErrors.bind(this));
            }
        }
    }, {
        key: 'removeErrors',
        value: function removeErrors(event) {
            if (event.target.classList.contains('error')) {
                event.target.classList.remove('error');
                event.target.nextSibling.nextElementSibling.style.display = 'none';
            }
        }
    }, {
        key: 'addForwardSlash',
        value: function addForwardSlash(event) {
            var inputLength = event.target.value.length;

            if (event.keyCode === 8) {
                return false;
            }

            if (inputLength === 2 || inputLength === 5) {
                event.target.value += '/';
            }
        }
    }, {
        key: 'validateForm',
        value: function validateForm(event) {
            event.preventDefault();
            var isValidDate = void 0;
            var isEmailValid = void 0;
            var allInputsComplete = false;
            var requiredFields = {
                preferredDate: 'preferred_date',
                guestNumbers: 'guest_numbers',
                title: 'title',
                firstName: 'first_name',
                surname: 'surname',
                email: 'email',
                companyName: 'company_name',
                contactNumber: 'contact_number'

                // add errors to all required fields
            };Object.keys(requiredFields).forEach(function (key) {
                var fieldName = document.getElementsByName('' + requiredFields[key]);

                for (var i = 0; i < fieldName.length; i++) {
                    if (fieldName[i].value === '') {
                        fieldName[i].classList.add('error');
                        fieldName[i].nextSibling.nextElementSibling.innerHTML = 'Please enter a ' + fieldName[i].previousSibling.previousElementSibling.innerHTML.toLowerCase();
                        fieldName[i].nextSibling.nextElementSibling.style.display = 'block';
                    } else if (fieldName[i].value) {
                        fieldName[i].classList.remove('error');
                        fieldName[i].nextSibling.nextElementSibling.innerHTML = '';
                        fieldName[i].nextSibling.nextElementSibling.style.display = 'none';
                    }
                }
            });

            // check if recaptcha is valid
            this.isRecaptchaValid();

            // check if event type is checked
            this.isEventTypeChecked(this.checkboxContainers);

            // scroll up to div if error exists
            if ((0, _jquery2.default)('.error').length) {
                (0, _jquery2.default)('html, body').animate({
                    scrollTop: (0, _jquery2.default)('.error:visible:first').offset().top - 130
                }, 1000);
            }

            // check if date is valid
            if (!this.preferredDateField[0].value) {
                return false;
            }

            isValidDate = (0, _moment2.default)(this.preferredDateField[0].value, 'DD/MM/YYYY', true).isValid();

            if (isValidDate) {
                this.preferredDateField[0].classList.remove('error');
                this.preferredDateField[0].nextSibling.nextElementSibling.innerHTML = '';
                this.preferredDateField[0].nextSibling.nextElementSibling.style.display = 'none';
            } else {
                this.preferredDateField[0].classList.add('error');
                this.preferredDateField[0].nextSibling.nextElementSibling.innerHTML = 'Please enter a valid date';
                this.preferredDateField[0].nextSibling.nextElementSibling.style.display = 'block';
            }

            // check if email is valid
            if (!this.emailField[0].value) {
                return false;
            }

            isEmailValid = this.validateEmail(this.emailField[0].value);

            if (isEmailValid) {
                this.emailField[0].classList.remove('error');
                this.emailField[0].nextSibling.nextElementSibling.innerHTML = '';
                this.emailField[0].nextSibling.nextElementSibling.style.display = 'none';
            } else {
                this.emailField[0].classList.add('error');
                this.emailField[0].nextSibling.nextElementSibling.innerHTML = 'Please enter a valid email address';
                this.emailField[0].nextSibling.nextElementSibling.style.display = 'block';
            }

            // final check on inputs
            if (!this.numberOfGuestField[0].value || !this.titleField[1].value || !this.firstNameField[0].value || !this.surnameField[0].value || !this.surnameField[0].value || !this.companyNameField[0].value || !this.contactNumberField[0].value || !this.checkedCheckboxes.length || !isValidDate || (0, _jquery2.default)("#g-recaptcha-response").val() === '') {
                return false;
            }

            this.postFormData();
        }
    }, {
        key: 'isRecaptchaValid',
        value: function isRecaptchaValid() {
            var recaptcha = (0, _jquery2.default)("#g-recaptcha-response").val();
            var recaptchaError = document.querySelectorAll('.recaptcha-error')[0];

            if (recaptcha === "") {
                recaptchaError.innerHTML = 'Please check the recaptcha';
                recaptchaError.style.display = 'block';
            } else {
                recaptchaError.style.display = 'none';
            }
        }
    }, {
        key: 'postFormData',
        value: function postFormData() {
            var eventTime = void 0;
            var hearAboutUs = void 0;
            var endpoint = document.getElementsByClassName('fa-enquiry-form__form')[0].getAttribute('action');
            for (var i = 0; i < this.eventTimeField.length; i++) {
                eventTime = this.eventTimeField[i];
            }
            for (var i = 0; i < this.hearAboutUsField.length; i++) {
                hearAboutUs = this.hearAboutUsField[i];
            }

            //construct form object
            var formPayload = {
                'selectedEventTypes': this.checkedCheckboxes,
                'preferredDate': this.preferredDateField[0].value,
                'guestNumber': this.numberOfGuestField[0].value,
                'title': this.titleField[1].value,
                'firstName': this.firstNameField[0].value,
                'surname': this.surnameField[0].value,
                'email': this.emailField[0].value,
                'eventTime': eventTime.value,
                'otherRequirements': this.otherRequirementsField[0].value,
                'jobTitle': this.jobTitleField[0].value,
                'companyName': this.companyNameField[0].value,
                'contactNumber': this.contactNumberField[0].value,
                'hearAboutUs': hearAboutUs.value
            };

            //show loading GIF
            (0, _jquery2.default)('.loading-message-wrapper').removeClass('hide').addClass('show');

            _jquery2.default.ajax({
                url: endpoint,
                type: "POST",
                data: JSON.stringify(formPayload),
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                error: function error(response) {
                    document.querySelectorAll('.submission__error')[0].style.display = 'block';
                    (0, _jquery2.default)('.fa-enquiry-form__form').slideUp('slow');
                },
                success: function success(response) {
                    //hide loading GIF animation
                    (0, _jquery2.default)('.loading-message-wrapper').removeClass('show').addClass('hide');
                    document.querySelectorAll('.submission__success')[0].style.display = 'block';
                    (0, _jquery2.default)('.fa-enquiry-form__form').slideUp('slow');
                }
            });
        }
    }, {
        key: 'validateEmail',
        value: function validateEmail(email) {
            var expr = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return expr.test(email);
        }
    }, {
        key: 'isEventTypeChecked',
        value: function isEventTypeChecked(checkboxInputs) {
            var checkBoxError = document.querySelector('.event-type-error');
            var atleastOneChecked = false;

            for (var i = 0; i < checkboxInputs.length; i++) {
                if (!checkboxInputs[i].checked) {
                    checkBoxError.innerHTML = 'Please select at least one event type';
                    checkBoxError.style.display = 'block';
                    checkBoxError.classList.add('error');
                } else {
                    atleastOneChecked = true;

                    this.checkedCheckboxes.indexOf(checkboxInputs[i].name) === -1 ? this.checkedCheckboxes.push(checkboxInputs[i].name) : console.log('item already exists!!');
                }
            }

            if (atleastOneChecked) {
                checkBoxError.innerHTML = '';
                checkBoxError.style.display = 'none';
                checkBoxError.classList.remove('error');
            }
        }
    }, {
        key: 'render',
        value: function render() {
            this.setVars();
            this.addEventListeners();
        }
    }]);

    return WembleyStadiumEnquiryForm;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
    // Function to equalize heights within each set of three cards or single card per row on mobile

    function equalizeHeights() {
        // Clear existing heights
        (0, _jquery2.default)("#wsFilterEvents .col-sm-4.fa-filter-content__item .fa-content-promo, " + "#wsFilterEvents .col-sm-4.fa-filter-content__item .fa-content-promo__content, " + "#wsFilterEvents .col-sm-4.fa-filter-content__item .fa-content-promo__content h2").css('height', '');

        // Determine if the device is mobile based on window width
        var isMobile = (0, _jquery2.default)(window).width() < 768;

        // Process cards
        (0, _jquery2.default)("#wsFilterEvents .col-sm-4.fa-filter-content__item").each(function (index) {
            if (isMobile || index % 3 === 0) {
                var maxHeightPromo = 0;
                var maxHeightContent = 0;
                var maxHeightH2 = 0;
                var cardSet = [];

                // Collect the next set of cards (3 for desktop, 1 for mobile)
                for (var i = 0; i < (isMobile ? 1 : 3); i++) {
                    var card = (0, _jquery2.default)("#wsFilterEvents .col-sm-4.fa-filter-content__item").eq(index + i);
                    if (card.length > 0) {
                        cardSet.push(card);

                        var promoHeight = card.find(".fa-content-promo").outerHeight();
                        var contentHeight = card.find(".fa-content-promo__content").outerHeight();
                        var h2Height = card.find(".fa-content-promo__content h2").outerHeight();

                        if (promoHeight > maxHeightPromo) {
                            maxHeightPromo = promoHeight;
                        }
                        if (contentHeight > maxHeightContent) {
                            maxHeightContent = contentHeight;
                        }
                        if (h2Height > maxHeightH2) {
                            maxHeightH2 = h2Height;
                        }
                    }
                }

                // Set the height of each element to the maximum height
                for (var i = 0; i < cardSet.length; i++) {
                    cardSet[i].find(".fa-content-promo").css('height', maxHeightPromo);
                    cardSet[i].find(".fa-content-promo__content").css('height', maxHeightContent);
                    cardSet[i].find(".fa-content-promo__content h2").css('height', maxHeightH2);
                }
            }
        });
    }

    // Call the equalizeHeights function initially
    equalizeHeights();

    // Recalculate heights on window resize
    (0, _jquery2.default)(window).resize(function () {
        equalizeHeights();
    });
});

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
    var events = [];
    (0, _jquery2.default)(".fa-filter-content .fa-filter-content__item").each(function () {
        var doRefresh = (0, _jquery2.default)(this).data("refresh");
        if (doRefresh == "True") {
            var event = new Object();
            event.EventId = (0, _jquery2.default)(this).data("eventid");
            event.EventDayId = (0, _jquery2.default)(this).data("eventdayid");
            events.push(event);
        }
    });
    //console.log(events);

    if (events.length > 0) {
        _jquery2.default.ajax({
            url: '/api/sitecore/WSTickets/RefreshBuyButton',
            type: 'POST',
            data: JSON.stringify(events),
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            success: function success(response) {

                _jquery2.default.each(response.Data, function (index, item) {
                    if (item.SoldOut) {
                        (0, _jquery2.default)("#btn-" + item.EventDayId).attr("href", "javascript:void(0)");
                        (0, _jquery2.default)("#btn-" + item.EventDayId).attr("class", "cta cta--alt cta--primary cta--primary-btn event-disabled-btn");
                        (0, _jquery2.default)("#sp-" + item.EventDayId).text("sold out");
                        if ((0, _jquery2.default)(".event-bundle").length > 0) {
                            (0, _jquery2.default)("#btn-" + item.EventDayId).attr("class", "cta cta--primary cta--standard cta--white disabled-btn");
                        }
                    } else if (item.IsOnSale && !item.SoldOut) {
                        (0, _jquery2.default)("#btn-" + item.EventDayId).attr("href", item.TicketsUrl);
                        (0, _jquery2.default)("#btn-" + item.EventDayId).attr("class", "cta cta--alt cta--primary cta--primary-btn");
                        (0, _jquery2.default)("#sp-" + item.EventDayId).text(item.BuyButtonText);
                        if ((0, _jquery2.default)(".event-bundle").length > 0) {
                            (0, _jquery2.default)("#btn-" + item.EventDayId).attr("class", "cta cta--primary cta--standard cta--white");
                        }
                    } else if (!item.IsOnSale && item.SaleStatus != "") {
                        (0, _jquery2.default)("#btn-" + item.EventDayId).attr("href", "javascript:void(0)");
                        (0, _jquery2.default)("#btn-" + item.EventDayId).attr("class", "cta cta--alt cta--primary cta--primary-btn event-disabled-btn");
                        (0, _jquery2.default)("#sp-" + item.EventDayId).text(item.SaleStatus);
                        if ((0, _jquery2.default)(".event-bundle").length > 0) {
                            (0, _jquery2.default)("#btn-" + item.EventDayId).attr("class", "cta cta--primary cta--standard cta--white disabled-btn");
                        }
                    }
                });
            },
            failure: function failure(response) {
                console.log(response.responseText);
            },
            error: function error(response) {
                console.log(response.responseText);
            },
            async: true,
            cache: false
        });
    }
});

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.MeetingsEvents = function (_Snappy$BaseComponent) {
    _inherits(MeetingsEvents, _Snappy$BaseComponent);

    _createClass(MeetingsEvents, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-meeting-events';
        }
    }]);

    function MeetingsEvents(element) {
        _classCallCheck(this, MeetingsEvents);

        return _possibleConstructorReturn(this, (MeetingsEvents.__proto__ || Object.getPrototypeOf(MeetingsEvents)).call(this, element));
    }

    _createClass(MeetingsEvents, [{
        key: 'setVars',
        value: function setVars() {
            this.eventSelect = document.getElementById('ws-event-type');
            this.guestSelect = document.getElementById('ws-guests');
        }
    }, {
        key: 'addEventListeners',
        value: function addEventListeners() {
            this.eventSelect.addEventListener('change', this.filterItems.bind(this));
            this.guestSelect.addEventListener('change', this.filterItems.bind(this));
        }
    }, {
        key: 'filterItems',
        value: function filterItems() {
            var roomItem = document.getElementsByClassName('fa-filter-content__item');
            var eventTypeFilter = document.getElementById("ws-event-type").value;

            for (var i = 0; i < roomItem.length; i++) {
                if (document.getElementById('ws-event-type').selectedIndex == 0 || roomItem[i].getAttribute('data-event-capacity').includes(eventTypeFilter)) {
                    if (document.getElementById('ws-guests').selectedIndex == 0 || this.filterByGuest(roomItem[i].getAttribute('data-event-capacity'), eventTypeFilter, (0, _jquery2.default)(roomItem[i]).find('h2').html())) {
                        roomItem[i].classList.remove('hidden');
                    } else {
                        roomItem[i].classList.add('hidden');
                    }
                } else {
                    roomItem[i].classList.add('hidden');
                }
            }

            this.updateCounter();
        }
    }, {
        key: 'filterByGuest',
        value: function filterByGuest(dataeventcapacity, eventTypeFilter, roomName) {
            var eventTypes = dataeventcapacity.split('&');
            var min = parseInt(document.getElementById("ws-guests").value.split('-')[0]);
            var max = parseInt(document.getElementById("ws-guests").value.split('-')[1]);

            for (var i = 0; i < eventTypes.length; i++) {
                var guests = parseInt(eventTypes[i].split('=')[0]);
                if ((eventTypeFilter == 0 || eventTypes[i].split('=')[1] == eventTypeFilter) && guests >= min && guests <= max) {
                    return true;
                }
            }

            return false;
        }
    }, {
        key: 'updateCounter',
        value: function updateCounter() {
            var itemCount = (0, _jquery2.default)('.fa-filter-content__item:not(.hidden)').length;

            if (itemCount > 0) {
                (0, _jquery2.default)('.counter').html(itemCount + ' Rooms Available');
            } else {
                (0, _jquery2.default)('.counter').html('Sorry there are no rooms available for your selected filter');
            }
        }
    }, {
        key: 'render',
        value: function render() {
            this.updateCounter();
            this.setVars();
            this.addEventListeners();
        }
    }]);

    return MeetingsEvents;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.WembleyStadiumSignUpForm = function (_Snappy$BaseComponent) {
    _inherits(WembleyStadiumSignUpForm, _Snappy$BaseComponent);

    _createClass(WembleyStadiumSignUpForm, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-ws-signup-form';
        }
    }]);

    function WembleyStadiumSignUpForm(element) {
        _classCallCheck(this, WembleyStadiumSignUpForm);

        return _possibleConstructorReturn(this, (WembleyStadiumSignUpForm.__proto__ || Object.getPrototypeOf(WembleyStadiumSignUpForm)).call(this, element));
    }

    _createClass(WembleyStadiumSignUpForm, [{
        key: 'setVars',
        value: function setVars() {
            this.errorMessage = document.getElementsByClassName('fa-input-field__error-message');
            this.firstName = document.getElementsByName('FirstName');
            this.surname = document.getElementsByName('LastName');
            this.dateOfBirth = document.getElementsByName('DateOfBirth');
            this.email = document.getElementsByName('Email');
            this.emailConfirm = document.getElementsByName('EmailConfirm');
            this.phone = document.getElementsByName('Phone');
            this.otherPhone = document.getElementsByName('OtherPhone');
            this.postcode = document.getElementsByName('Postcode');
            this.address1 = document.getElementsByName('Address1');
            this.address2 = document.getElementsByName('Address2');
            this.address3 = document.getElementsByName('Address3');
            this.city = document.getElementsByName('City');
            this.county = document.getElementsByName('County');
            this.country = document.getElementsByName('Country');
            this.password = document.getElementsByName('Password');
            this.passwordConfirm = document.getElementsByName('PasswordConfirm');
            this.agreeToTsAndCs = document.querySelectorAll('[name="TermsAndConditionsAcceptance"][type=checkbox]');
            this.agreeToMarketing = document.querySelectorAll('[name="MarketingAcceptance"][type=checkbox]');
            this.formTextInputs = document.querySelectorAll('.fa-signup-form__form input[type=text]');
            this.submitBtn = document.getElementById('ws-signup-form-submit');
            this.findAddressLink = document.getElementById('ws-find-address-submit');
            this.manualAddressLink = document.getElementById('ws-manual-address-submit');
            this.addressFieldSetContainer = document.getElementById('ws-address-field-set');
            this.addressSearchResultContainer = document.getElementsByClassName('ws-address-results')[0];
        }
    }, {
        key: 'addEventListeners',
        value: function addEventListeners() {
            this.submitBtn.addEventListener('click', this.validateForm.bind(this));
            this.findAddressLink.addEventListener('click', this.findAddress.bind(this));
            this.manualAddressLink.addEventListener('click', this.enterAddressManually.bind(this));

            for (var i = 0; i < this.formTextInputs.length; i++) {
                this.formTextInputs[i].addEventListener('keyup', this.removeErrors.bind(this));
            }
        }
    }, {
        key: 'removeErrors',
        value: function removeErrors(event) {
            if (event.target.classList.contains('error')) {
                event.target.classList.remove('error');
                event.target.nextSibling.nextElementSibling.style.display = 'none';
            }
        }
    }, {
        key: 'validateForm',
        value: function validateForm(event) {
            event.preventDefault();
            var isValidDate = void 0;
            var isEmailValid = void 0;
            var isSubmissionValid = true;
            var requiredFields = {
                dateOfBirth: 'DateOfBirth',
                firstName: 'FirstName',
                surname: 'LastName',
                email: 'Email',
                phone: 'Phone',
                postcode: 'Postcode',
                addressLine1: 'Address1',
                city: 'City',
                county: 'County',
                country: 'Country',
                password: 'Password'

                // add errors to all required fields
            };for (var k in requiredFields) {
                var domElement = document.getElementsByName(requiredFields[k]);
                if (domElement[0].value === '') {
                    isSubmissionValid = false;
                    this.setDomElementOnInvalidState(domElement[0], 'Please enter a ' + domElement[0].previousSibling.previousElementSibling.innerHTML.toLowerCase());
                } else {
                    this.setDomElementOnValidState(domElement[0]);
                }
            }

            // check if recaptcha is valid
            isSubmissionValid = this.isRecaptchaValid();

            // scroll up to div if error exists
            if ((0, _jquery2.default)('.error').length) {
                (0, _jquery2.default)('html, body').animate({
                    scrollTop: (0, _jquery2.default)('.error:visible:first').offset().top - 130
                }, 1000);
            }

            if (this.agreeToTsAndCs[0].checked === false) {
                isSubmissionValid = false;
                this.setDomElementOnInvalidState(this.agreeToTsAndCs[0].parentElement, 'Please agree to the terms and conditions');
            } else {
                this.setDomElementOnValidState(this.agreeToTsAndCs[0].parentElement);
            }

            isValidDate = (0, _moment2.default)(this.dateOfBirth[0].value, 'DD/MM/YYYY', true).isValid();
            if (isValidDate) {
                this.setDomElementOnValidState(this.dateOfBirth[0]);
            } else {
                isSubmissionValid = false;
                this.setDomElementOnInvalidState(this.dateOfBirth[0], 'Please enter a valid date');
            }

            this.setDomElementOnValidState(this.emailConfirm[0]);
            if (this.email[0].value !== '') {
                isEmailValid = this.validateEmail(this.email[0].value);
                if (isEmailValid) {
                    if (this.email[0].value === this.emailConfirm[0].value) {
                        this.setDomElementOnValidState(this.email[0]);
                        this.setDomElementOnValidState(this.emailConfirm[0]);
                    } else {
                        isSubmissionValid = false;
                        this.setDomElementOnInvalidState(this.email[0], 'Emails do not match');
                        this.setDomElementOnInvalidState(this.emailConfirm[0], 'Emails do not match');
                    }
                } else {
                    isSubmissionValid = false;
                    this.setDomElementOnInvalidState(this.email[0], 'Please enter a valid email address');
                }
            }

            if (this.firstName[0].value !== '') {
                if (this.firstName[0].value.length <= 1) {
                    isSubmissionValid = false;
                    this.setDomElementOnInvalidState(this.firstName[0], 'Oops! Your first name should have at least two characters');
                }
            }

            if (this.surname[0].value !== '') {
                if (this.surname[0].value.length <= 1) {
                    isSubmissionValid = false;
                    this.setDomElementOnInvalidState(this.surname[0], 'Oops! Your last name should have at least two characters');
                }
            }

            this.setDomElementOnValidState(this.passwordConfirm[0]);
            if (this.password[0].value !== '') {
                if (this.password[0].value === this.passwordConfirm[0].value) {
                    this.setDomElementOnValidState(this.password[0]);
                    this.setDomElementOnValidState(this.passwordConfirm[0]);
                } else {
                    isSubmissionValid = false;
                    this.setDomElementOnInvalidState(this.password[0], 'Passwords do not match');
                    this.setDomElementOnInvalidState(this.passwordConfirm[0], 'Passwords do not match');
                }
            }

            if (isSubmissionValid) {
                // call ajax service
                this.postFormData();
                return false;
            }

            return false;
        }
    }, {
        key: 'isRecaptchaValid',
        value: function isRecaptchaValid() {
            var recaptcha = (0, _jquery2.default)("#g-recaptcha-response").val();
            var recaptchaError = document.querySelectorAll('.recaptcha-error')[0];
            var isValid = true;

            if (recaptcha === "") {
                isValid = false;
                recaptchaError.innerHTML = 'Please check the recaptcha';
                recaptchaError.style.display = 'block';
            } else {
                recaptchaError.style.display = 'none';
            }

            return isValid;
        }
    }, {
        key: 'enterAddressManually',
        value: function enterAddressManually(event) {
            this.address1[0].value = '';
            this.address2[0].value = '';
            this.address3[0].value = '';
            this.city[0].value = '';
            this.county[0].value = '';
            this.country[0].value = '';
            this.addressSearchResultContainer.style.display = 'none';
            this.addressFieldSetContainer.style.display = 'block';
            return false;
        }
    }, {
        key: 'findAddress',
        value: function findAddress(event) {
            event.preventDefault();

            //show loading GIF
            (0, _jquery2.default)('.loading-message-wrapper').removeClass('hide').addClass('show');

            var endpoint = '/accounts/postcode?postcode=' + this.postcode[0].value;
            this.addressFieldSetContainer.style.display = 'none';
            this.addressSearchResultContainer.style.display = 'none';
            (0, _jquery2.default)(".ws-address-results ul").html('');
            var postcodeErrorControl = document.getElementsByName('Postcode')[0].parentNode.getElementsByClassName('fa-input-field__error-message')[0];

            if (postcodeErrorControl !== undefined && postcodeErrorControl !== null) {
                postcodeErrorControl.innerText = '';
                postcodeErrorControl.style.display = 'none';
            }

            _jquery2.default.ajax({
                url: endpoint,
                type: "GET",
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: function success(response) {
                    (0, _jquery2.default)('.loading-message-wrapper').removeClass('show').addClass('hide');
                    if (response != null) {

                        var addresses = response["Addresses"];
                        if (addresses.length > 0) {
                            _jquery2.default.each(addresses, function (index, value) {
                                // RDSN: Taken from IR js
                                var address = value["Address"].split("|");
                                var addressShortName = "";
                                if (address[0] !== "") addressShortName = addressShortName + address[0];
                                if (address[1] !== "") addressShortName = addressShortName + ", " + address[1];

                                var addressBlock = value["Address"].replace(/\'/g, "");
                                (0, _jquery2.default)(".ws-address-results ul").append("<li class='addressClick'><a " + " address='" + addressBlock + "'>" + addressShortName + "</a></li>");
                                (0, _jquery2.default)('.ws-address-results').show();
                                var addressResultLinks = document.getElementsByClassName('addressClick');
                            });
                        } else {
                            if (postcodeErrorControl !== undefined && postcodeErrorControl !== null) {
                                postcodeErrorControl.innerText = "Are you sure? We can't find your address. Can you try enter your address manually please?";
                                postcodeErrorControl.style.display = 'block';
                            }
                        }
                    }
                },
                error: function error(response) {
                    (0, _jquery2.default)('.loading-message-wrapper').removeClass('show').addClass('hide');
                }
            });
        }
    }, {
        key: 'postFormData',
        value: function postFormData() {
            var endpoint = document.getElementsByClassName('fa-signup-form__form')[0].getAttribute('action');

            //build json
            var jsonRequest = {
                'FirstName': this.firstName[0].value,
                'LastName': this.surname[0].value,
                'DateOfBirth': this.dateOfBirth[0].value,
                'Email': this.email[0].value,
                'EmailConfirm': this.emailConfirm[0].value,
                'Phone': this.phone[0].value,
                'OtherPhone': this.otherPhone[0].value,
                'Postcode': this.postcode[0].value,
                'Address1': this.address1[0].value,
                'Address2': this.address2[0].value,
                'Address3': this.address3[0].value,
                'City': this.city[0].value,
                'County': this.county[0].value,
                'Country': this.country[0].value,
                'Password': this.password[0].value,
                'PasswordConfirm': this.passwordConfirm[0].value,
                'TermsAndConditionsAcceptance': this.agreeToTsAndCs[0].checked,
                'MarketingAcceptance': this.agreeToMarketing[0].checked
            };

            //show loading GIF
            (0, _jquery2.default)('.loading-message-wrapper').removeClass('hide').addClass('show');
            document.querySelectorAll('.submission__success')[0].style.display = 'none';
            document.querySelectorAll('.submission__error')[0].style.display = 'none';

            _jquery2.default.ajax({
                url: endpoint,
                type: "POST",
                data: JSON.stringify(jsonRequest),
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: function success(response) {
                    (0, _jquery2.default)('.loading-message-wrapper').removeClass('show').addClass('hide');

                    if (response != undefined) {
                        if (response.IsValid) {
                            executeValidResponse(response);
                        } else {
                            executeInvalidResponse(response);
                        }
                    }

                    function executeValidResponse(apiResponse) {
                        document.querySelectorAll('.submission__success')[0].style.display = 'block';
                        (0, _jquery2.default)('html, body').animate({
                            scrollTop: (0, _jquery2.default)('.submission__success').offset().top - 130
                        }, 1000);

                        var allFormTextInputs = document.querySelectorAll('.fa-signup-form__form input[type=text]');
                        for (var i = 0; i < allFormTextInputs.length; i++) {
                            allFormTextInputs[i].value = '';
                        }

                        var allFormPasswordInputs = document.querySelectorAll('.fa-signup-form__form input[type=password]');
                        for (var x = 0; x < allFormPasswordInputs.length; x++) {
                            allFormPasswordInputs[x].value = '';
                        }

                        var allFormCheckboxInputs = document.querySelectorAll('.fa-signup-form__form input[type=checkbox]');
                        for (var y = 0; y < allFormCheckboxInputs.length; y++) {
                            allFormCheckboxInputs[y].checked = false;
                        }

                        var form = document.querySelectorAll('.fa-signup-form__form');
                        if (form != undefined && form.length > 0) {
                            form[0].style.display = 'none';
                        }
                    }

                    function executeInvalidResponse(apiResponse) {
                        document.querySelectorAll('.submission__error')[0].style.display = 'block';

                        var errorMessageSummary = document.getElementById('errorMessageSummary');
                        if (errorMessageSummary != undefined) {
                            errorMessageSummary.innerHTML = '';
                        }

                        if (apiResponse != undefined && !apiResponse.IsValid) {
                            for (var key in apiResponse.Errors) {
                                var inputDomElement = document.getElementsByName(key);
                                if (inputDomElement.length > 0) {
                                    inputDomElement[0].classList.add('error');
                                    inputDomElement[0].nextSibling.nextElementSibling.innerHTML = response.Errors[key];
                                    inputDomElement[0].nextSibling.nextElementSibling.style.display = 'block';
                                } else {
                                    if (errorMessageSummary !== undefined) {
                                        errorMessageSummary.innerHTML += response.Errors[key];
                                    }
                                }
                            }
                        }

                        (0, _jquery2.default)('html, body').animate({
                            scrollTop: (0, _jquery2.default)('.submission__error').offset().top - 130
                        }, 1000);
                    }
                }
            });
        }
    }, {
        key: 'validateEmail',
        value: function validateEmail(email) {
            var expr = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return expr.test(email);
        }
    }, {
        key: 'setDomElementOnInvalidState',
        value: function setDomElementOnInvalidState(domElement, errorMessage) {
            domElement.classList.add('error');
            domElement.nextSibling.nextElementSibling.innerHTML = errorMessage;
            domElement.nextSibling.nextElementSibling.style.display = 'block';
        }
    }, {
        key: 'setDomElementOnValidState',
        value: function setDomElementOnValidState(domElement) {
            domElement.classList.remove('error');
            domElement.nextSibling.nextElementSibling.innerHTML = '';
            domElement.nextSibling.nextElementSibling.style.display = 'none';
        }
    }, {
        key: 'render',
        value: function render() {
            this.setVars();
            this.addEventListeners();

            (0, _jquery2.default)(document).delegate('.addressClick a', 'click', function () {
                var addressAsArray = (0, _jquery2.default)(this).attr('address').split('|');
                document.getElementsByName('Address1')[0].value = addressAsArray[0];
                document.getElementsByName('Address2')[0].value = addressAsArray[1];
                document.getElementsByName('Address3')[0].value = addressAsArray[2];
                document.getElementsByName('Postcode')[0].value = addressAsArray[3];
                document.getElementsByName('City')[0].value = addressAsArray[4];
                document.getElementsByName('County')[0].value = addressAsArray[5];
                document.getElementsByName('Country')[0].value = addressAsArray[6];
                document.getElementById('ws-address-field-set').style.display = 'block';
                document.getElementsByClassName('ws-address-results')[0].style.display = 'none';
            });

            (0, _jquery2.default)(document).ready(function () {
                (0, _jquery2.default)('#DateOfBirth').bind('keyup', 'keydown', function (event) {
                    var inputLength = event.target.value.length;
                    if (event.keyCode != 8) {
                        if (inputLength === 2 || inputLength === 5) {
                            var thisVal = event.target.value;
                            thisVal += '/';
                            (0, _jquery2.default)(event.target).val(thisVal);
                        }
                    }
                });
            });
        }
    }]);

    return WembleyStadiumSignUpForm;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(document).ready(function () {
    var welcomeDataLoaded = false; // Flag to check if welcome data is loaded
    var welcomeEndpoint = '/accounts/welcome';
    var accountAreaMyAccount, accountAreaSignIn, accountAreaUserName, accountAreaDropdown, authenticatedLinks;

    function setVars() {
        accountAreaMyAccount = (0, _jquery2.default)('.accountArea__myAccount a');
        accountAreaSignIn = (0, _jquery2.default)('.accountArea__signIn');
        accountAreaUserName = (0, _jquery2.default)('.accountArea__userName');
        accountAreaDropdown = (0, _jquery2.default)('.accountArea__dropdownItems');
        authenticatedLinks = accountAreaDropdown.find('li').filter(function () {
            return !(0, _jquery2.default)(this).hasClass('accountArea__signIn') && !(0, _jquery2.default)(this).hasClass('accountArea__userName');
        });
    }

    function addEventListeners() {
        (0, _jquery2.default)(document).on('DOMContentLoaded', onLoad);
        accountAreaMyAccount.on('click', onAccountClick);
        (0, _jquery2.default)(document).on('click', onDocumentClick);
    }

    function onLoad() {
        hideDropdown(); // Initially hide the dropdown
        accountAreaSignIn.css('display', 'none'); // Initially hide sign in
        accountAreaUserName.css('display', 'none'); // Initially hide user name
        authenticatedLinks.css('display', 'none'); // Initially hide authenticated links
    }

    function onAccountClick(event) {
        event.preventDefault(); // Prevent default link behavior
        event.stopPropagation(); // Prevent click event from propagating to document
        if (!welcomeDataLoaded) {
            getWelcomeData();
        } else if (accountAreaDropdown.length) {
            toggleDropdown(accountAreaDropdown);
        }
    }

    function onDocumentClick(event) {
        if (accountAreaDropdown.length) {
            var isClickInside = accountAreaMyAccount[0].contains(event.target) || accountAreaDropdown[0].contains(event.target);
            if (!isClickInside) {
                hideDropdown();
            }
        }
    }

    function toggleDropdown(dropdown) {
        var displayValue = dropdown.css('display') === 'none' ? 'block' : 'none';
        dropdown.css('display', displayValue);
    }

    function hideDropdown() {
        if (accountAreaDropdown.length) {
            accountAreaDropdown.css('display', 'none');
        }
    }

    function getWelcomeData() {
        _jquery2.default.ajax({
            url: welcomeEndpoint,
            cache: false,
            type: "GET",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function success(response) {
                welcomeDataLoaded = true; // Set flag to true once data is loaded
                if (response.IsAuthenticated) {
                    accountAreaSignIn.css('display', 'none'); // Hide sign in
                    accountAreaUserName.css('display', 'block'); // Show user name
                    setSignedInName(response);
                    authenticatedLinks.css('display', 'block'); // Show authenticated links
                } else {
                    accountAreaSignIn.css('display', 'block'); // Show sign in
                    accountAreaUserName.css('display', 'none'); // Hide user name
                    authenticatedLinks.css('display', 'none'); // Hide authenticated links
                }
                if (accountAreaDropdown.length) {
                    toggleDropdown(accountAreaDropdown); // Show the dropdown after loading data
                }
            },
            error: function error() {
                welcomeDataLoaded = true; // Ensure flag is set even on error to prevent repeated calls
                if (accountAreaDropdown.length) {
                    toggleDropdown(accountAreaDropdown); // Show the dropdown regardless
                }
            }
        });
    }

    function setSignedInName(response) {
        var signedInNameElement = (0, _jquery2.default)('.signedInName');
        if (signedInNameElement.length) {
            signedInNameElement.html(response.FirstName + ' ' + response.LastName);
        }
    }

    // Initialize
    setVars();
    addEventListeners();
    onLoad(); // Ensure initial load state is set
});

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.SofaToSeat = function (_Snappy$BaseComponent) {
    _inherits(SofaToSeat, _Snappy$BaseComponent);

    _createClass(SofaToSeat, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-sofa-to-seat';
        }
    }]);

    function SofaToSeat(element) {
        _classCallCheck(this, SofaToSeat);

        return _possibleConstructorReturn(this, (SofaToSeat.__proto__ || Object.getPrototypeOf(SofaToSeat)).call(this, element));
    }

    _createClass(SofaToSeat, [{
        key: 'setVars',
        value: function setVars() {
            this.$showDirectionsBtn = this.$element.find('.directions__button')[0];
            this.$panel = this.$element.find('.content__panel');
            this.$panelClose = this.$element.find('.panel__controls-button')[0];
            this.$innerPanel = this.$element.find('.panel__right');
            this.$mapInput = this.$element.find('.origin__input')[0];
        }
    }, {
        key: 'addEventListeners',
        value: function addEventListeners() {
            this.$showDirectionsBtn.addEventListener('click', this.toggleDirections.bind(this));
            this.$panelClose.addEventListener('click', this.togglePanel.bind(this));
            this.$mapInput.addEventListener('focus', this.moveAutoComplete.bind(this));
        }
    }, {
        key: 'moveAutoComplete',
        value: function moveAutoComplete(event) {
            var pacContainer = (0, _jquery2.default)('.pac-container');
            (0, _jquery2.default)(event.target).parent().append(pacContainer);
        }
    }, {
        key: 'toggleDirections',
        value: function toggleDirections(event) {
            var $this = event.target;
            this.$panel.toggleClass('transition-in');

            if (this.$panel.hasClass('transition-in')) {
                console.log((0, _jquery2.default)($this).find('span').text('Hide Directions'));
            } else {
                console.log((0, _jquery2.default)($this).find('span').text('Show Directions'));
            }
        }
    }, {
        key: 'togglePanel',
        value: function togglePanel(event) {
            this.$innerPanel.toggleClass('transition-in');
            (0, _jquery2.default)(event.target).toggleClass('panel__controls-button--opened');
        }
    }, {
        key: 'render',
        value: function render() {
            this.setVars();
            this.addEventListeners();
        }
    }]);

    return SofaToSeat;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _jquery3 = __webpack_require__(788);

var _jquery4 = _interopRequireDefault(_jquery3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.ViewFromSeat = function (_Snappy$BaseComponent) {
    _inherits(ViewFromSeat, _Snappy$BaseComponent);

    _createClass(ViewFromSeat, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-view-from-seat';
        }
    }]);

    function ViewFromSeat(element) {
        _classCallCheck(this, ViewFromSeat);

        return _possibleConstructorReturn(this, (ViewFromSeat.__proto__ || Object.getPrototypeOf(ViewFromSeat)).call(this, element));
    }

    _createClass(ViewFromSeat, [{
        key: 'setVars',
        value: function setVars() {
            this.$eventTypeSelect = this.$element.find('.fa-dropdown__select--vfs')[0];
            this.$eventTypeSelectMobile = this.$element.find('.fa-dropdown__select--vfs-mobile');
            this.$sportsBlocks = this.$element.find('.vfs-sports-blocks');
            this.$sportsBoxes = this.$element.find('.vfs-sports-boxes');
            this.$musicBlocks = this.$element.find('.vfs-music-west-blocks');
            this.$musicBoxes = this.$element.find('.vfs-music-west-boxes');
            this.$seatLocationRadio = this.$element.find('.toggle-seat-type__input');
            this.seatingLocation = 'blocks';
            this.$mapPreviews = this.$element.find('map.previews area');
            this.$mapBoxes = this.$element.find('map.boxes');
            this.$mapSportsBlocks = this.$element.find('map.previews.map-sports-blocks area');
            this.$mapMusicBlocks = this.$element.find('map.previews.map-music-west-blocks area');
            this.$selectLevelMobile = this.$element.find('#select-your-level-mobile');
            this.$selectBlockMobile = this.$element.find('#select-your-block-mobile');
            this.$selectBoxRangeSportsMobile = this.$element.find('#select-box-range-sports-mobile');
            this.$selectBoxRangeMusicMobile = this.$element.find('#select-box-range-music-west-mobile');
            this.$selectBoxNumber = this.$element.find('#select-box-number');
            this.$closeBtn = this.$element.find('.vfs-viewport .vfs-viewport__close-btn');
            this.$backButton = this.$element.find('.cta--back');
            this.$zoomContainer = this.$element.find('.vfs-viewport__zoom-container');
        }
    }, {
        key: 'addEventListeners',
        value: function addEventListeners() {
            // Desktop event listeners
            if ((0, _jquery2.default)(window).width() > 768) {
                this.$eventTypeSelect.addEventListener('change', this.updateDesktopViewport.bind(this));
                for (var i = 0; i < this.$seatLocationRadio.length; i++) {
                    this.$seatLocationRadio[i].addEventListener('change', this.updateDesktopViewport.bind(this));
                }
                for (var i = 0; i < this.$mapPreviews.length; i++) {
                    this.$mapPreviews[i].addEventListener('click', this.displayBlockView.bind(this));
                }

                for (var i = 0; i < this.$closeBtn.length; i++) {
                    this.$closeBtn[i].addEventListener('click', this.closeBlockView.bind(this));
                }

                for (var i = 0; i < this.$mapBoxes.length; i++) {
                    this.$mapBoxes[i].addEventListener('click', this.displayBoxView.bind(this));
                }

                for (var i = 0; i < this.$backButton.length; i++) {
                    this.$backButton[i].addEventListener('click', this.backToStadiumBoxes.bind(this));
                }
            }
            // Mobile event listeners
            if ((0, _jquery2.default)(window).width() < 768) {
                this.$eventTypeSelectMobile[0].addEventListener('change', this.updateMobileViewport.bind(this));

                for (var i = 0; i < this.$seatLocationRadio.length; i++) {
                    this.$seatLocationRadio[i].addEventListener('change', this.updateMobileViewport.bind(this));
                }

                this.$selectBoxRangeSportsMobile[0].addEventListener('change', this.displaySelectYourBoxNumbers.bind(this));
                this.$selectBoxRangeMusicMobile[0].addEventListener('change', this.displaySelectYourBoxNumbers.bind(this));
                this.$selectLevelMobile[0].addEventListener('change', this.displaySelectYourBlock.bind(this));
            }
        }
    }, {
        key: 'backToStadiumBoxes',
        value: function backToStadiumBoxes(event) {
            var eventType = this.$eventTypeSelect.value;
            var activeVfsViewport = this.$element.find('.vfs-viewport .active');
            this.$closeBtn.addClass('hidden');
            this.$zoomContainer.addClass('hidden');
            activeVfsViewport.removeClass('active');
            (0, _jquery2.default)('.vfs-' + eventType + '-boxes').addClass('active');
        }
    }, {
        key: 'displayBlockView',
        value: function displayBlockView(event) {
            var $this = event.target;
            var vfsViewport = this.$element.find('.vfs-viewport');
            var eventType = this.$eventTypeSelect.value;
            var blockNumber = (0, _jquery2.default)($this).attr('alt').split(' ')[1];
            var activeVfsViewport = this.$element.find('.vfs-viewport .active');
            var blockView = activeVfsViewport.find('.viewport__block-view');
            var mapView = activeVfsViewport.find('.viewport__map-view');
            var mapViewImg = mapView.find('img');
            var imgURL = '//cdn.thefa.com/viewFromYourSeat/views/' + eventType + '/' + blockNumber + '.jpg';
            mapViewImg.attr('src', imgURL);

            this.$closeBtn.removeClass('hidden');
            this.$zoomContainer.removeClass('hidden');
            blockView.fadeOut(function () {
                mapView.fadeIn();
            });
        }
    }, {
        key: 'closeBlockView',
        value: function closeBlockView(event) {
            var activeVfsViewport = this.$element.find('.vfs-viewport .active');
            var blockView = activeVfsViewport.find('.viewport__block-view');
            var mapView = activeVfsViewport.find('.viewport__map-view');
            var mapViewImg = mapView.find('img');

            var $this = (0, _jquery2.default)(event.target);
            mapView.fadeOut(function () {
                blockView.fadeIn();
            });
            this.$closeBtn.addClass('hidden');
            this.$zoomContainer.addClass('hidden');
        }
    }, {
        key: 'displayBoxView',
        value: function displayBoxView(event) {
            var $this = event.target;
            var eventType = this.$eventTypeSelect.value;
            var area = (0, _jquery2.default)($this).data('quadrant');
            var nextMap = (0, _jquery2.default)('.vfs-' + eventType + '-boxes-' + area);
            var activeVfsViewport = this.$element.find('.vfs-viewport .active');

            activeVfsViewport.removeClass('active');
            nextMap.addClass('active');
        }
    }, {
        key: 'updateDesktopViewport',
        value: function updateDesktopViewport(event) {
            var value = event.target.value;
            var vfsViewport = this.$element.find('.vfs-viewport');
            var currentView = vfsViewport.find('.active');

            if (value === 'boxes' || value === 'blocks') {
                this.seatingLocation = value;
            }

            this.$zoomContainer.addClass('hidden');
            this.$closeBtn.addClass('hidden');

            switch (value) {
                case 'boxes':
                    currentView.removeClass('active');
                    vfsViewport.addClass('vfs-viewport--boxes');
                    this.$eventTypeSelect.value === 'sports' ? this.$sportsBoxes.addClass('active') : '';
                    this.$eventTypeSelect.value === 'music-west' ? this.$musicBoxes.addClass('active') : '';
                    break;
                case 'blocks':
                    currentView.removeClass('active');
                    vfsViewport.removeClass('vfs-viewport--boxes');
                    this.$eventTypeSelect.value === 'sports' ? this.$sportsBlocks.addClass('active') : '';
                    this.$eventTypeSelect.value === 'music-west' ? this.$musicBlocks.addClass('active') : '';
                    break;
                case 'music-west':
                    currentView.find('.viewport__block-view').css('display', 'block');
                    currentView.find('.viewport__map-view').css('display', 'none');
                    currentView.removeClass('active');
                    this.seatingLocation === 'boxes' ? this.$musicBoxes.addClass('active') : '';
                    this.seatingLocation === 'blocks' ? this.$musicBlocks.addClass('active') : '';
                    break;
                case 'sports':
                    currentView.find('.viewport__block-view').css('display', 'block');
                    currentView.find('.viewport__map-view').css('display', 'none');
                    currentView.removeClass('active');
                    this.seatingLocation === 'boxes' ? this.$sportsBoxes.addClass('active') : '';
                    this.seatingLocation === 'blocks' ? this.$sportsBlocks.addClass('active') : '';
                    break;
                default:
                    break;
            }

            if ((0, _jquery2.default)('.viewport__block-view').hasClass('hidden')) {
                (0, _jquery2.default)('.viewport__block-view').removeClass('hidden');
                (0, _jquery2.default)('.viewport__map-view').addClass('hidden');
            }
        }
    }, {
        key: 'displaySelectYourBoxNumbers',
        value: function displaySelectYourBoxNumbers() {
            var selectVal = event.target.value;
            var eventTypeVal = this.$eventTypeSelectMobile.val();
            var boxNumbers = this.getBoxNumbers(selectVal);
            var displayImageMob = this.displayImageMob;
            this.$selectBoxNumber.prop('selectedIndex', 0);
            this.$selectBoxNumber.parents('.form-group').removeClass('hidden');

            (0, _jquery2.default)('html, body').animate({ scrollTop: this.$selectBoxNumber.offset().top - 80 }, 1000);
            (0, _jquery2.default)('#select-box-number option:not(:first)').remove();

            this.$selectBoxNumber.append(boxNumbers.map(function (value) {
                return (0, _jquery2.default)('<option/>', {
                    value: value,
                    text: value
                });
            })).change(function () {
                displayImageMob(eventTypeVal, this.value);
            });
        }
    }, {
        key: 'getBoxNumbers',
        value: function getBoxNumbers(selectVal) {
            var boxRangeBoxes = this.$element.find('.' + selectVal + ' area');
            var boxNumbers = void 0;
            var boxNumbersArray = [];

            for (var i = 0; i < boxRangeBoxes.length; i++) {
                var box = boxRangeBoxes[i];
                if ((0, _jquery2.default)(box).attr('alt').length < 9) {
                    boxNumbers = (0, _jquery2.default)(box).attr('alt').split(' ')[1];
                } else {
                    boxNumbers = (0, _jquery2.default)(box).attr('alt');
                }

                boxNumbersArray.push(boxNumbers);
            }

            return boxNumbersArray;
        }
    }, {
        key: 'displaySelectYourBlock',
        value: function displaySelectYourBlock() {
            var eventTypeVal = this.$eventTypeSelectMobile.val();
            var levelVal = this.$selectLevelMobile.val();
            var displayImageMob = this.displayImageMob;
            var blockNumbers = this.getAllBlockNumbers(eventTypeVal, levelVal);

            if ((0, _jquery2.default)('.viewport__block-view').hasClass('hidden')) {
                (0, _jquery2.default)('.viewport__block-view').removeClass('hidden');
                (0, _jquery2.default)('.viewport__map-view').addClass('hidden');
            }

            this.$selectBlockMobile.parents('.fa-dropdown--mobile').removeClass('hidden').addClass('active');
            (0, _jquery2.default)('html, body').animate({ scrollTop: this.$selectBlockMobile.offset().top - 80 }, 1000);
            this.$selectBlockMobile.prop('selectedIndex', 0);
            (0, _jquery2.default)('#select-your-block-mobile option:not(:first)').remove();
            this.$selectBlockMobile.append(blockNumbers.map(function (value) {
                return (0, _jquery2.default)('<option/>', {
                    value: value,
                    text: value
                });
            })).change(function () {
                displayImageMob(eventTypeVal, this.value);
            });
        }
    }, {
        key: 'displayImageMob',
        value: function displayImageMob(eventType, blockNumber) {
            var imgURL = '//cdn.thefa.com/viewFromYourSeat/views/' + eventType + '/' + blockNumber + '.jpg';
            (0, _jquery2.default)('.vfs-viewport__zoom-container').removeClass('hidden');

            (0, _jquery2.default)('.viewport__map-view img').attr('src', imgURL);
            (0, _jquery2.default)('.viewport__block-view').fadeOut("slow", function () {
                (0, _jquery2.default)('.viewport__map-view').fadeIn();
            });
        }
    }, {
        key: 'getAllBlockNumbers',
        value: function getAllBlockNumbers(eventType, level) {
            var blockNumbers = void 0;
            var blockNumbersArray = [];
            var finalBlockNumbers = [];

            if (eventType === 'sports') {
                for (var i = 0; i < this.$mapSportsBlocks.length; i++) {
                    var area = this.$mapSportsBlocks[i];
                    blockNumbers = (0, _jquery2.default)(area).attr('alt').split(' ')[1];
                    blockNumbersArray.push(blockNumbers);
                }
            } else {
                for (var i = 0; i < this.$mapMusicBlocks.length; i++) {
                    var _area = this.$mapMusicBlocks[i];
                    blockNumbers = (0, _jquery2.default)(_area).attr('alt').split(' ')[1];
                    blockNumbersArray.push(blockNumbers);
                }
            }

            switch (level) {
                case '1':
                    blockNumbersArray.forEach(function (entry) {
                        if (entry.match(/^1/)) {
                            finalBlockNumbers.push(entry);
                        }
                    });
                    break;
                case '2':
                    blockNumbersArray.forEach(function (entry) {
                        if (entry.match(/^2/)) {
                            finalBlockNumbers.push(entry);
                        }
                    });
                    break;
                case '5':
                    blockNumbersArray.forEach(function (entry) {
                        if (entry.match(/^5/)) {
                            finalBlockNumbers.push(entry);
                        }
                    });
                    break;
                default:
                    break;
            }
            return finalBlockNumbers;
        }
    }, {
        key: 'updateMobileViewport',
        value: function updateMobileViewport(event) {
            var value = event.target.value;
            var vfsViewport = this.$element.find('.vfs-viewport');
            var currentView = vfsViewport.find('.active');
            var eventTypeVal = this.$eventTypeSelectMobile.val();

            if (value === 'boxes' || value === 'blocks') {
                this.seatingLocation = value;
            }

            switch (value) {
                case 'boxes':
                    currentView.removeClass('active');
                    this.$selectLevelMobile.parents('.form-group').addClass('hidden');
                    this.$selectBlockMobile.parents('.form-group').addClass('hidden');

                    if (this.$eventTypeSelectMobile[0].value === 'sports') {
                        this.$sportsBoxes.addClass('active');
                        this.$selectBoxRangeMusicMobile.parents('.form-group').addClass('hidden');
                        this.$selectBoxRangeSportsMobile.parents('.form-group').removeClass('hidden');
                    }

                    if (this.$eventTypeSelectMobile[0].value === 'music-west') {
                        this.$musicBoxes.addClass('active');
                        this.$selectBoxRangeSportsMobile.parents('.form-group').addClass('hidden');
                        this.$selectBoxRangeMusicMobile.parents('.form-group').removeClass('hidden');
                    }
                    break;
                case 'blocks':
                    currentView.removeClass('active');
                    this.$selectBoxRangeSportsMobile.parents('.form-group').addClass('hidden');
                    this.$selectBoxRangeMusicMobile.parents('.form-group').addClass('hidden');
                    this.$selectBoxNumber.parents('.form-group').addClass('hidden');

                    if (this.$eventTypeSelectMobile[0].value === 'sports') {
                        this.$sportsBlocks.addClass('active');
                    }

                    if (this.$eventTypeSelectMobile[0].value === 'music-west') {
                        this.$musicBlocks.addClass('active');
                    }

                    this.$selectLevelMobile.parents('.form-group').removeClass('hidden');
                    this.$selectBlockMobile.parents('.form-group').removeClass('hidden');
                    break;
                case 'music-west':
                    currentView.removeClass('active');
                    if (this.seatingLocation === 'boxes') {
                        this.$musicBoxes.addClass('active');
                        this.$selectBoxRangeSportsMobile.parents('.form-group').addClass('hidden');
                        this.$selectBoxRangeMusicMobile.parents('.form-group').removeClass('hidden');
                    }

                    if (this.seatingLocation === 'blocks') {
                        this.$musicBlocks.addClass('active');
                        this.$selectBoxRangeMusicMobile.parents('.form-group').addClass('hidden');
                    }
                    break;
                case 'sports':
                    currentView.removeClass('active');
                    if (this.seatingLocation === 'boxes') {
                        this.$sportsBoxes.addClass('active');
                        this.$selectBoxRangeMusicMobile.parents('.form-group').addClass('hidden');
                        this.$selectBoxRangeSportsMobile.parents('.form-group').removeClass('hidden');
                    }

                    if (this.seatingLocation === 'blocks') {
                        this.$sportsBlocks.addClass('active');
                        this.$selectBoxRangeSportsMobile.parents('.form-group').addClass('hidden');
                    }
                    break;
                default:
                    break;
            }

            this.$selectLevelMobile.prop('selectedIndex', 0);
            this.$selectBlockMobile.prop('selectedIndex', 0);
            this.$selectBoxRangeSportsMobile.prop('selectedIndex', 0);
            this.$selectBoxRangeMusicMobile.prop('selectedIndex', 0);
            this.$selectBoxNumber.prop('selectedIndex', 0);
            this.$selectBlockMobile.parents('.fa-dropdown--mobile').removeClass('active').addClass('hidden');

            if ((0, _jquery2.default)('.viewport__block-view').hasClass('hidden')) {
                (0, _jquery2.default)('.viewport__block-view').removeClass('hidden');
                (0, _jquery2.default)('.viewport__map-view').addClass('hidden');
            }
        }
    }, {
        key: 'render',
        value: function render() {
            this.setVars();
            this.addEventListeners();
            // initialize panzoom on render();
            (0, _jquery2.default)('.viewport__map-view img').panzoom({
                disableZoom: false,
                transition: true,
                cursor: 'hand',
                contain: 'invert',
                $zoomIn: (0, _jquery2.default)('.vfs-viewport__zoom--in'),
                $zoomOut: (0, _jquery2.default)('.vfs-viewport__zoom--out'),
                $reset: (0, _jquery2.default)('.vfs-viewport__close-btn'),
                increment: 0.1,
                minScale: 1
            });
        }
    }]);

    return ViewFromSeat;
}(_snappy2.default.BaseComponent);

/***/ }),
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 516 */,
/* 517 */,
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/*! @vimeo/player v2.18.0 | (c) 2022 Vimeo | MIT License | https://github.com/vimeo/player.js */
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/**
 * @module lib/functions
 */

/**
 * Check to see this is a node environment.
 * @type {Boolean}
 */

/* global global */
var isNode = typeof global !== 'undefined' && {}.toString.call(global) === '[object global]';
/**
 * Get the name of the method for a given getter or setter.
 *
 * @param {string} prop The name of the property.
 * @param {string} type Either “get” or “set”.
 * @return {string}
 */

function getMethodName(prop, type) {
  if (prop.indexOf(type.toLowerCase()) === 0) {
    return prop;
  }

  return "".concat(type.toLowerCase()).concat(prop.substr(0, 1).toUpperCase()).concat(prop.substr(1));
}
/**
 * Check to see if the object is a DOM Element.
 *
 * @param {*} element The object to check.
 * @return {boolean}
 */

function isDomElement(element) {
  return Boolean(element && element.nodeType === 1 && 'nodeName' in element && element.ownerDocument && element.ownerDocument.defaultView);
}
/**
 * Check to see whether the value is a number.
 *
 * @see http://dl.dropboxusercontent.com/u/35146/js/tests/isNumber.html
 * @param {*} value The value to check.
 * @param {boolean} integer Check if the value is an integer.
 * @return {boolean}
 */

function isInteger(value) {
  // eslint-disable-next-line eqeqeq
  return !isNaN(parseFloat(value)) && isFinite(value) && Math.floor(value) == value;
}
/**
 * Check to see if the URL is a Vimeo url.
 *
 * @param {string} url The url string.
 * @return {boolean}
 */

function isVimeoUrl(url) {
  return /^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/.test(url);
}
/**
 * Check to see if the URL is for a Vimeo embed.
 *
 * @param {string} url The url string.
 * @return {boolean}
 */

function isVimeoEmbed(url) {
  var expr = /^https:\/\/player\.vimeo\.com\/video\/\d+/;
  return expr.test(url);
}
/**
 * Get the Vimeo URL from an element.
 * The element must have either a data-vimeo-id or data-vimeo-url attribute.
 *
 * @param {object} oEmbedParameters The oEmbed parameters.
 * @return {string}
 */

function getVimeoUrl() {
  var oEmbedParameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var id = oEmbedParameters.id;
  var url = oEmbedParameters.url;
  var idOrUrl = id || url;

  if (!idOrUrl) {
    throw new Error('An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.');
  }

  if (isInteger(idOrUrl)) {
    return "https://vimeo.com/".concat(idOrUrl);
  }

  if (isVimeoUrl(idOrUrl)) {
    return idOrUrl.replace('http:', 'https:');
  }

  if (id) {
    throw new TypeError("\u201C".concat(id, "\u201D is not a valid video id."));
  }

  throw new TypeError("\u201C".concat(idOrUrl, "\u201D is not a vimeo.com url."));
}

var arrayIndexOfSupport = typeof Array.prototype.indexOf !== 'undefined';
var postMessageSupport = typeof window !== 'undefined' && typeof window.postMessage !== 'undefined';

if (!isNode && (!arrayIndexOfSupport || !postMessageSupport)) {
  throw new Error('Sorry, the Vimeo Player API is not available in this browser.');
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/*!
 * weakmap-polyfill v2.0.4 - ECMAScript6 WeakMap polyfill
 * https://github.com/polygonplanet/weakmap-polyfill
 * Copyright (c) 2015-2021 polygonplanet <polygon.planet.aqua@gmail.com>
 * @license MIT
 */
(function (self) {

  if (self.WeakMap) {
    return;
  }

  var hasOwnProperty = Object.prototype.hasOwnProperty;

  var hasDefine = Object.defineProperty && function () {
    try {
      // Avoid IE8's broken Object.defineProperty
      return Object.defineProperty({}, 'x', {
        value: 1
      }).x === 1;
    } catch (e) {}
  }();

  var defineProperty = function (object, name, value) {
    if (hasDefine) {
      Object.defineProperty(object, name, {
        configurable: true,
        writable: true,
        value: value
      });
    } else {
      object[name] = value;
    }
  };

  self.WeakMap = function () {
    // ECMA-262 23.3 WeakMap Objects
    function WeakMap() {
      if (this === void 0) {
        throw new TypeError("Constructor WeakMap requires 'new'");
      }

      defineProperty(this, '_id', genId('_WeakMap')); // ECMA-262 23.3.1.1 WeakMap([iterable])

      if (arguments.length > 0) {
        // Currently, WeakMap `iterable` argument is not supported
        throw new TypeError('WeakMap iterable is not supported');
      }
    } // ECMA-262 23.3.3.2 WeakMap.prototype.delete(key)


    defineProperty(WeakMap.prototype, 'delete', function (key) {
      checkInstance(this, 'delete');

      if (!isObject(key)) {
        return false;
      }

      var entry = key[this._id];

      if (entry && entry[0] === key) {
        delete key[this._id];
        return true;
      }

      return false;
    }); // ECMA-262 23.3.3.3 WeakMap.prototype.get(key)

    defineProperty(WeakMap.prototype, 'get', function (key) {
      checkInstance(this, 'get');

      if (!isObject(key)) {
        return void 0;
      }

      var entry = key[this._id];

      if (entry && entry[0] === key) {
        return entry[1];
      }

      return void 0;
    }); // ECMA-262 23.3.3.4 WeakMap.prototype.has(key)

    defineProperty(WeakMap.prototype, 'has', function (key) {
      checkInstance(this, 'has');

      if (!isObject(key)) {
        return false;
      }

      var entry = key[this._id];

      if (entry && entry[0] === key) {
        return true;
      }

      return false;
    }); // ECMA-262 23.3.3.5 WeakMap.prototype.set(key, value)

    defineProperty(WeakMap.prototype, 'set', function (key, value) {
      checkInstance(this, 'set');

      if (!isObject(key)) {
        throw new TypeError('Invalid value used as weak map key');
      }

      var entry = key[this._id];

      if (entry && entry[0] === key) {
        entry[1] = value;
        return this;
      }

      defineProperty(key, this._id, [key, value]);
      return this;
    });

    function checkInstance(x, methodName) {
      if (!isObject(x) || !hasOwnProperty.call(x, '_id')) {
        throw new TypeError(methodName + ' method called on incompatible receiver ' + typeof x);
      }
    }

    function genId(prefix) {
      return prefix + '_' + rand() + '.' + rand();
    }

    function rand() {
      return Math.random().toString().substring(2);
    }

    defineProperty(WeakMap, '_polyfill', true);
    return WeakMap;
  }();

  function isObject(x) {
    return Object(x) === x;
  }
})(typeof globalThis !== 'undefined' ? globalThis : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : commonjsGlobal);

var npo_src = createCommonjsModule(function (module) {
/*! Native Promise Only
    v0.8.1 (c) Kyle Simpson
    MIT License: http://getify.mit-license.org
*/
(function UMD(name, context, definition) {
  // special form of UMD for polyfilling across evironments
  context[name] = context[name] || definition();

  if ( module.exports) {
    module.exports = context[name];
  }
})("Promise", typeof commonjsGlobal != "undefined" ? commonjsGlobal : commonjsGlobal, function DEF() {

  var builtInProp,
      cycle,
      scheduling_queue,
      ToString = Object.prototype.toString,
      timer = typeof setImmediate != "undefined" ? function timer(fn) {
    return setImmediate(fn);
  } : setTimeout; // dammit, IE8.

  try {
    Object.defineProperty({}, "x", {});

    builtInProp = function builtInProp(obj, name, val, config) {
      return Object.defineProperty(obj, name, {
        value: val,
        writable: true,
        configurable: config !== false
      });
    };
  } catch (err) {
    builtInProp = function builtInProp(obj, name, val) {
      obj[name] = val;
      return obj;
    };
  } // Note: using a queue instead of array for efficiency


  scheduling_queue = function Queue() {
    var first, last, item;

    function Item(fn, self) {
      this.fn = fn;
      this.self = self;
      this.next = void 0;
    }

    return {
      add: function add(fn, self) {
        item = new Item(fn, self);

        if (last) {
          last.next = item;
        } else {
          first = item;
        }

        last = item;
        item = void 0;
      },
      drain: function drain() {
        var f = first;
        first = last = cycle = void 0;

        while (f) {
          f.fn.call(f.self);
          f = f.next;
        }
      }
    };
  }();

  function schedule(fn, self) {
    scheduling_queue.add(fn, self);

    if (!cycle) {
      cycle = timer(scheduling_queue.drain);
    }
  } // promise duck typing


  function isThenable(o) {
    var _then,
        o_type = typeof o;

    if (o != null && (o_type == "object" || o_type == "function")) {
      _then = o.then;
    }

    return typeof _then == "function" ? _then : false;
  }

  function notify() {
    for (var i = 0; i < this.chain.length; i++) {
      notifyIsolated(this, this.state === 1 ? this.chain[i].success : this.chain[i].failure, this.chain[i]);
    }

    this.chain.length = 0;
  } // NOTE: This is a separate function to isolate
  // the `try..catch` so that other code can be
  // optimized better


  function notifyIsolated(self, cb, chain) {
    var ret, _then;

    try {
      if (cb === false) {
        chain.reject(self.msg);
      } else {
        if (cb === true) {
          ret = self.msg;
        } else {
          ret = cb.call(void 0, self.msg);
        }

        if (ret === chain.promise) {
          chain.reject(TypeError("Promise-chain cycle"));
        } else if (_then = isThenable(ret)) {
          _then.call(ret, chain.resolve, chain.reject);
        } else {
          chain.resolve(ret);
        }
      }
    } catch (err) {
      chain.reject(err);
    }
  }

  function resolve(msg) {
    var _then,
        self = this; // already triggered?


    if (self.triggered) {
      return;
    }

    self.triggered = true; // unwrap

    if (self.def) {
      self = self.def;
    }

    try {
      if (_then = isThenable(msg)) {
        schedule(function () {
          var def_wrapper = new MakeDefWrapper(self);

          try {
            _then.call(msg, function $resolve$() {
              resolve.apply(def_wrapper, arguments);
            }, function $reject$() {
              reject.apply(def_wrapper, arguments);
            });
          } catch (err) {
            reject.call(def_wrapper, err);
          }
        });
      } else {
        self.msg = msg;
        self.state = 1;

        if (self.chain.length > 0) {
          schedule(notify, self);
        }
      }
    } catch (err) {
      reject.call(new MakeDefWrapper(self), err);
    }
  }

  function reject(msg) {
    var self = this; // already triggered?

    if (self.triggered) {
      return;
    }

    self.triggered = true; // unwrap

    if (self.def) {
      self = self.def;
    }

    self.msg = msg;
    self.state = 2;

    if (self.chain.length > 0) {
      schedule(notify, self);
    }
  }

  function iteratePromises(Constructor, arr, resolver, rejecter) {
    for (var idx = 0; idx < arr.length; idx++) {
      (function IIFE(idx) {
        Constructor.resolve(arr[idx]).then(function $resolver$(msg) {
          resolver(idx, msg);
        }, rejecter);
      })(idx);
    }
  }

  function MakeDefWrapper(self) {
    this.def = self;
    this.triggered = false;
  }

  function MakeDef(self) {
    this.promise = self;
    this.state = 0;
    this.triggered = false;
    this.chain = [];
    this.msg = void 0;
  }

  function Promise(executor) {
    if (typeof executor != "function") {
      throw TypeError("Not a function");
    }

    if (this.__NPO__ !== 0) {
      throw TypeError("Not a promise");
    } // instance shadowing the inherited "brand"
    // to signal an already "initialized" promise


    this.__NPO__ = 1;
    var def = new MakeDef(this);

    this["then"] = function then(success, failure) {
      var o = {
        success: typeof success == "function" ? success : true,
        failure: typeof failure == "function" ? failure : false
      }; // Note: `then(..)` itself can be borrowed to be used against
      // a different promise constructor for making the chained promise,
      // by substituting a different `this` binding.

      o.promise = new this.constructor(function extractChain(resolve, reject) {
        if (typeof resolve != "function" || typeof reject != "function") {
          throw TypeError("Not a function");
        }

        o.resolve = resolve;
        o.reject = reject;
      });
      def.chain.push(o);

      if (def.state !== 0) {
        schedule(notify, def);
      }

      return o.promise;
    };

    this["catch"] = function $catch$(failure) {
      return this.then(void 0, failure);
    };

    try {
      executor.call(void 0, function publicResolve(msg) {
        resolve.call(def, msg);
      }, function publicReject(msg) {
        reject.call(def, msg);
      });
    } catch (err) {
      reject.call(def, err);
    }
  }

  var PromisePrototype = builtInProp({}, "constructor", Promise,
  /*configurable=*/
  false); // Note: Android 4 cannot use `Object.defineProperty(..)` here

  Promise.prototype = PromisePrototype; // built-in "brand" to signal an "uninitialized" promise

  builtInProp(PromisePrototype, "__NPO__", 0,
  /*configurable=*/
  false);
  builtInProp(Promise, "resolve", function Promise$resolve(msg) {
    var Constructor = this; // spec mandated checks
    // note: best "isPromise" check that's practical for now

    if (msg && typeof msg == "object" && msg.__NPO__ === 1) {
      return msg;
    }

    return new Constructor(function executor(resolve, reject) {
      if (typeof resolve != "function" || typeof reject != "function") {
        throw TypeError("Not a function");
      }

      resolve(msg);
    });
  });
  builtInProp(Promise, "reject", function Promise$reject(msg) {
    return new this(function executor(resolve, reject) {
      if (typeof resolve != "function" || typeof reject != "function") {
        throw TypeError("Not a function");
      }

      reject(msg);
    });
  });
  builtInProp(Promise, "all", function Promise$all(arr) {
    var Constructor = this; // spec mandated checks

    if (ToString.call(arr) != "[object Array]") {
      return Constructor.reject(TypeError("Not an array"));
    }

    if (arr.length === 0) {
      return Constructor.resolve([]);
    }

    return new Constructor(function executor(resolve, reject) {
      if (typeof resolve != "function" || typeof reject != "function") {
        throw TypeError("Not a function");
      }

      var len = arr.length,
          msgs = Array(len),
          count = 0;
      iteratePromises(Constructor, arr, function resolver(idx, msg) {
        msgs[idx] = msg;

        if (++count === len) {
          resolve(msgs);
        }
      }, reject);
    });
  });
  builtInProp(Promise, "race", function Promise$race(arr) {
    var Constructor = this; // spec mandated checks

    if (ToString.call(arr) != "[object Array]") {
      return Constructor.reject(TypeError("Not an array"));
    }

    return new Constructor(function executor(resolve, reject) {
      if (typeof resolve != "function" || typeof reject != "function") {
        throw TypeError("Not a function");
      }

      iteratePromises(Constructor, arr, function resolver(idx, msg) {
        resolve(msg);
      }, reject);
    });
  });
  return Promise;
});
});

/**
 * @module lib/callbacks
 */
var callbackMap = new WeakMap();
/**
 * Store a callback for a method or event for a player.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name.
 * @param {(function(this:Player, *): void|{resolve: function, reject: function})} callback
 *        The callback to call or an object with resolve and reject functions for a promise.
 * @return {void}
 */

function storeCallback(player, name, callback) {
  var playerCallbacks = callbackMap.get(player.element) || {};

  if (!(name in playerCallbacks)) {
    playerCallbacks[name] = [];
  }

  playerCallbacks[name].push(callback);
  callbackMap.set(player.element, playerCallbacks);
}
/**
 * Get the callbacks for a player and event or method.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name
 * @return {function[]}
 */

function getCallbacks(player, name) {
  var playerCallbacks = callbackMap.get(player.element) || {};
  return playerCallbacks[name] || [];
}
/**
 * Remove a stored callback for a method or event for a player.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name
 * @param {function} [callback] The specific callback to remove.
 * @return {boolean} Was this the last callback?
 */

function removeCallback(player, name, callback) {
  var playerCallbacks = callbackMap.get(player.element) || {};

  if (!playerCallbacks[name]) {
    return true;
  } // If no callback is passed, remove all callbacks for the event


  if (!callback) {
    playerCallbacks[name] = [];
    callbackMap.set(player.element, playerCallbacks);
    return true;
  }

  var index = playerCallbacks[name].indexOf(callback);

  if (index !== -1) {
    playerCallbacks[name].splice(index, 1);
  }

  callbackMap.set(player.element, playerCallbacks);
  return playerCallbacks[name] && playerCallbacks[name].length === 0;
}
/**
 * Return the first stored callback for a player and event or method.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name.
 * @return {function} The callback, or false if there were none
 */

function shiftCallbacks(player, name) {
  var playerCallbacks = getCallbacks(player, name);

  if (playerCallbacks.length < 1) {
    return false;
  }

  var callback = playerCallbacks.shift();
  removeCallback(player, name, callback);
  return callback;
}
/**
 * Move callbacks associated with an element to another element.
 *
 * @param {HTMLElement} oldElement The old element.
 * @param {HTMLElement} newElement The new element.
 * @return {void}
 */

function swapCallbacks(oldElement, newElement) {
  var playerCallbacks = callbackMap.get(oldElement);
  callbackMap.set(newElement, playerCallbacks);
  callbackMap.delete(oldElement);
}

/**
 * @module lib/postmessage
 */
/**
 * Parse a message received from postMessage.
 *
 * @param {*} data The data received from postMessage.
 * @return {object}
 */

function parseMessageData(data) {
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch (error) {
      // If the message cannot be parsed, throw the error as a warning
      console.warn(error);
      return {};
    }
  }

  return data;
}
/**
 * Post a message to the specified target.
 *
 * @param {Player} player The player object to use.
 * @param {string} method The API method to call.
 * @param {object} params The parameters to send to the player.
 * @return {void}
 */

function postMessage(player, method, params) {
  if (!player.element.contentWindow || !player.element.contentWindow.postMessage) {
    return;
  }

  var message = {
    method: method
  };

  if (params !== undefined) {
    message.value = params;
  } // IE 8 and 9 do not support passing messages, so stringify them


  var ieVersion = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, '$1'));

  if (ieVersion >= 8 && ieVersion < 10) {
    message = JSON.stringify(message);
  }

  player.element.contentWindow.postMessage(message, player.origin);
}
/**
 * Parse the data received from a message event.
 *
 * @param {Player} player The player that received the message.
 * @param {(Object|string)} data The message data. Strings will be parsed into JSON.
 * @return {void}
 */

function processData(player, data) {
  data = parseMessageData(data);
  var callbacks = [];
  var param;

  if (data.event) {
    if (data.event === 'error') {
      var promises = getCallbacks(player, data.data.method);
      promises.forEach(function (promise) {
        var error = new Error(data.data.message);
        error.name = data.data.name;
        promise.reject(error);
        removeCallback(player, data.data.method, promise);
      });
    }

    callbacks = getCallbacks(player, "event:".concat(data.event));
    param = data.data;
  } else if (data.method) {
    var callback = shiftCallbacks(player, data.method);

    if (callback) {
      callbacks.push(callback);
      param = data.value;
    }
  }

  callbacks.forEach(function (callback) {
    try {
      if (typeof callback === 'function') {
        callback.call(player, param);
        return;
      }

      callback.resolve(param);
    } catch (e) {// empty
    }
  });
}

/**
 * @module lib/embed
 */
var oEmbedParameters = ['autopause', 'autoplay', 'background', 'byline', 'color', 'controls', 'dnt', 'height', 'id', 'interactive_params', 'keyboard', 'loop', 'maxheight', 'maxwidth', 'muted', 'playsinline', 'portrait', 'responsive', 'speed', 'texttrack', 'title', 'transparent', 'url', 'width'];
/**
 * Get the 'data-vimeo'-prefixed attributes from an element as an object.
 *
 * @param {HTMLElement} element The element.
 * @param {Object} [defaults={}] The default values to use.
 * @return {Object<string, string>}
 */

function getOEmbedParameters(element) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return oEmbedParameters.reduce(function (params, param) {
    var value = element.getAttribute("data-vimeo-".concat(param));

    if (value || value === '') {
      params[param] = value === '' ? 1 : value;
    }

    return params;
  }, defaults);
}
/**
 * Create an embed from oEmbed data inside an element.
 *
 * @param {object} data The oEmbed data.
 * @param {HTMLElement} element The element to put the iframe in.
 * @return {HTMLIFrameElement} The iframe embed.
 */

function createEmbed(_ref, element) {
  var html = _ref.html;

  if (!element) {
    throw new TypeError('An element must be provided');
  }

  if (element.getAttribute('data-vimeo-initialized') !== null) {
    return element.querySelector('iframe');
  }

  var div = document.createElement('div');
  div.innerHTML = html;
  element.appendChild(div.firstChild);
  element.setAttribute('data-vimeo-initialized', 'true');
  return element.querySelector('iframe');
}
/**
 * Make an oEmbed call for the specified URL.
 *
 * @param {string} videoUrl The vimeo.com url for the video.
 * @param {Object} [params] Parameters to pass to oEmbed.
 * @param {HTMLElement} element The element.
 * @return {Promise}
 */

function getOEmbedData(videoUrl) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var element = arguments.length > 2 ? arguments[2] : undefined;
  return new Promise(function (resolve, reject) {
    if (!isVimeoUrl(videoUrl)) {
      throw new TypeError("\u201C".concat(videoUrl, "\u201D is not a vimeo.com url."));
    }

    var url = "https://vimeo.com/api/oembed.json?url=".concat(encodeURIComponent(videoUrl));

    for (var param in params) {
      if (params.hasOwnProperty(param)) {
        url += "&".concat(param, "=").concat(encodeURIComponent(params[param]));
      }
    }

    var xhr = 'XDomainRequest' in window ? new XDomainRequest() : new XMLHttpRequest();
    xhr.open('GET', url, true);

    xhr.onload = function () {
      if (xhr.status === 404) {
        reject(new Error("\u201C".concat(videoUrl, "\u201D was not found.")));
        return;
      }

      if (xhr.status === 403) {
        reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
        return;
      }

      try {
        var json = JSON.parse(xhr.responseText); // Check api response for 403 on oembed

        if (json.domain_status_code === 403) {
          // We still want to create the embed to give users visual feedback
          createEmbed(json, element);
          reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
          return;
        }

        resolve(json);
      } catch (error) {
        reject(error);
      }
    };

    xhr.onerror = function () {
      var status = xhr.status ? " (".concat(xhr.status, ")") : '';
      reject(new Error("There was an error fetching the embed code from Vimeo".concat(status, ".")));
    };

    xhr.send();
  });
}
/**
 * Initialize all embeds within a specific element
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */

function initializeEmbeds() {
  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  var elements = [].slice.call(parent.querySelectorAll('[data-vimeo-id], [data-vimeo-url]'));

  var handleError = function handleError(error) {
    if ('console' in window && console.error) {
      console.error("There was an error creating an embed: ".concat(error));
    }
  };

  elements.forEach(function (element) {
    try {
      // Skip any that have data-vimeo-defer
      if (element.getAttribute('data-vimeo-defer') !== null) {
        return;
      }

      var params = getOEmbedParameters(element);
      var url = getVimeoUrl(params);
      getOEmbedData(url, params, element).then(function (data) {
        return createEmbed(data, element);
      }).catch(handleError);
    } catch (error) {
      handleError(error);
    }
  });
}
/**
 * Resize embeds when messaged by the player.
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */

function resizeEmbeds() {
  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  // Prevent execution if users include the player.js script multiple times.
  if (window.VimeoPlayerResizeEmbeds_) {
    return;
  }

  window.VimeoPlayerResizeEmbeds_ = true;

  var onMessage = function onMessage(event) {
    if (!isVimeoUrl(event.origin)) {
      return;
    } // 'spacechange' is fired only on embeds with cards


    if (!event.data || event.data.event !== 'spacechange') {
      return;
    }

    var iframes = parent.querySelectorAll('iframe');

    for (var i = 0; i < iframes.length; i++) {
      if (iframes[i].contentWindow !== event.source) {
        continue;
      } // Change padding-bottom of the enclosing div to accommodate
      // card carousel without distorting aspect ratio


      var space = iframes[i].parentElement;
      space.style.paddingBottom = "".concat(event.data.data[0].bottom, "px");
      break;
    }
  };

  window.addEventListener('message', onMessage);
}
/**
 * Add chapters to existing metadata for Google SEO
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */

function initAppendVideoMetadata() {
  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  //  Prevent execution if users include the player.js script multiple times.
  if (window.VimeoSeoMetadataAppended) {
    return;
  }

  window.VimeoSeoMetadataAppended = true;

  var onMessage = function onMessage(event) {
    if (!isVimeoUrl(event.origin)) {
      return;
    }

    var data = parseMessageData(event.data);

    if (!data || data.event !== 'ready') {
      return;
    }

    var iframes = parent.querySelectorAll('iframe');

    for (var i = 0; i < iframes.length; i++) {
      var iframe = iframes[i]; // Initiate appendVideoMetadata if iframe is a Vimeo embed

      var isValidMessageSource = iframe.contentWindow === event.source;

      if (isVimeoEmbed(iframe.src) && isValidMessageSource) {
        var player = new Player(iframe);
        player.callMethod('appendVideoMetadata', window.location.href);
      }
    }
  };

  window.addEventListener('message', onMessage);
}
/**
 * Seek to time indicated by vimeo_t query parameter if present in URL
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */

function checkUrlTimeParam() {
  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  //  Prevent execution if users include the player.js script multiple times.
  if (window.VimeoCheckedUrlTimeParam) {
    return;
  }

  window.VimeoCheckedUrlTimeParam = true;

  var handleError = function handleError(error) {
    if ('console' in window && console.error) {
      console.error("There was an error getting video Id: ".concat(error));
    }
  };

  var onMessage = function onMessage(event) {
    if (!isVimeoUrl(event.origin)) {
      return;
    }

    var data = parseMessageData(event.data);

    if (!data || data.event !== 'ready') {
      return;
    }

    var iframes = parent.querySelectorAll('iframe');

    for (var i = 0; i < iframes.length; i++) {
      var iframe = iframes[i];
      var isValidMessageSource = iframe.contentWindow === event.source;

      if (isVimeoEmbed(iframe.src) && isValidMessageSource) {
        (function () {
          var player = new Player(iframe);
          player.getVideoId().then(function (videoId) {
            var matches = new RegExp("[?&]vimeo_t_".concat(videoId, "=([^&#]*)")).exec(window.location.href);

            if (matches && matches[1]) {
              var sec = decodeURI(matches[1]);
              player.setCurrentTime(sec);
            }

            return;
          }).catch(handleError);
        })();
      }
    }
  };

  window.addEventListener('message', onMessage);
}

/* MIT License

Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
Terms */
function initializeScreenfull() {
  var fn = function () {
    var val;
    var fnMap = [['requestFullscreen', 'exitFullscreen', 'fullscreenElement', 'fullscreenEnabled', 'fullscreenchange', 'fullscreenerror'], // New WebKit
    ['webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitFullscreenElement', 'webkitFullscreenEnabled', 'webkitfullscreenchange', 'webkitfullscreenerror'], // Old WebKit
    ['webkitRequestFullScreen', 'webkitCancelFullScreen', 'webkitCurrentFullScreenElement', 'webkitCancelFullScreen', 'webkitfullscreenchange', 'webkitfullscreenerror'], ['mozRequestFullScreen', 'mozCancelFullScreen', 'mozFullScreenElement', 'mozFullScreenEnabled', 'mozfullscreenchange', 'mozfullscreenerror'], ['msRequestFullscreen', 'msExitFullscreen', 'msFullscreenElement', 'msFullscreenEnabled', 'MSFullscreenChange', 'MSFullscreenError']];
    var i = 0;
    var l = fnMap.length;
    var ret = {};

    for (; i < l; i++) {
      val = fnMap[i];

      if (val && val[1] in document) {
        for (i = 0; i < val.length; i++) {
          ret[fnMap[0][i]] = val[i];
        }

        return ret;
      }
    }

    return false;
  }();

  var eventNameMap = {
    fullscreenchange: fn.fullscreenchange,
    fullscreenerror: fn.fullscreenerror
  };
  var screenfull = {
    request: function request(element) {
      return new Promise(function (resolve, reject) {
        var onFullScreenEntered = function onFullScreenEntered() {
          screenfull.off('fullscreenchange', onFullScreenEntered);
          resolve();
        };

        screenfull.on('fullscreenchange', onFullScreenEntered);
        element = element || document.documentElement;
        var returnPromise = element[fn.requestFullscreen]();

        if (returnPromise instanceof Promise) {
          returnPromise.then(onFullScreenEntered).catch(reject);
        }
      });
    },
    exit: function exit() {
      return new Promise(function (resolve, reject) {
        if (!screenfull.isFullscreen) {
          resolve();
          return;
        }

        var onFullScreenExit = function onFullScreenExit() {
          screenfull.off('fullscreenchange', onFullScreenExit);
          resolve();
        };

        screenfull.on('fullscreenchange', onFullScreenExit);
        var returnPromise = document[fn.exitFullscreen]();

        if (returnPromise instanceof Promise) {
          returnPromise.then(onFullScreenExit).catch(reject);
        }
      });
    },
    on: function on(event, callback) {
      var eventName = eventNameMap[event];

      if (eventName) {
        document.addEventListener(eventName, callback);
      }
    },
    off: function off(event, callback) {
      var eventName = eventNameMap[event];

      if (eventName) {
        document.removeEventListener(eventName, callback);
      }
    }
  };
  Object.defineProperties(screenfull, {
    isFullscreen: {
      get: function get() {
        return Boolean(document[fn.fullscreenElement]);
      }
    },
    element: {
      enumerable: true,
      get: function get() {
        return document[fn.fullscreenElement];
      }
    },
    isEnabled: {
      enumerable: true,
      get: function get() {
        // Coerce to boolean in case of old WebKit
        return Boolean(document[fn.fullscreenEnabled]);
      }
    }
  });
  return screenfull;
}

var playerMap = new WeakMap();
var readyMap = new WeakMap();
var screenfull = {};

var Player = /*#__PURE__*/function () {
  /**
   * Create a Player.
   *
   * @param {(HTMLIFrameElement|HTMLElement|string|jQuery)} element A reference to the Vimeo
   *        player iframe, and id, or a jQuery object.
   * @param {object} [options] oEmbed parameters to use when creating an embed in the element.
   * @return {Player}
   */
  function Player(element) {
    var _this = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Player);

    /* global jQuery */
    if (window.jQuery && element instanceof jQuery) {
      if (element.length > 1 && window.console && console.warn) {
        console.warn('A jQuery object with multiple elements was passed, using the first element.');
      }

      element = element[0];
    } // Find an element by ID


    if (typeof document !== 'undefined' && typeof element === 'string') {
      element = document.getElementById(element);
    } // Not an element!


    if (!isDomElement(element)) {
      throw new TypeError('You must pass either a valid element or a valid id.');
    } // Already initialized an embed in this div, so grab the iframe


    if (element.nodeName !== 'IFRAME') {
      var iframe = element.querySelector('iframe');

      if (iframe) {
        element = iframe;
      }
    } // iframe url is not a Vimeo url


    if (element.nodeName === 'IFRAME' && !isVimeoUrl(element.getAttribute('src') || '')) {
      throw new Error('The player element passed isn’t a Vimeo embed.');
    } // If there is already a player object in the map, return that


    if (playerMap.has(element)) {
      return playerMap.get(element);
    }

    this._window = element.ownerDocument.defaultView;
    this.element = element;
    this.origin = '*';
    var readyPromise = new npo_src(function (resolve, reject) {
      _this._onMessage = function (event) {
        if (!isVimeoUrl(event.origin) || _this.element.contentWindow !== event.source) {
          return;
        }

        if (_this.origin === '*') {
          _this.origin = event.origin;
        }

        var data = parseMessageData(event.data);
        var isError = data && data.event === 'error';
        var isReadyError = isError && data.data && data.data.method === 'ready';

        if (isReadyError) {
          var error = new Error(data.data.message);
          error.name = data.data.name;
          reject(error);
          return;
        }

        var isReadyEvent = data && data.event === 'ready';
        var isPingResponse = data && data.method === 'ping';

        if (isReadyEvent || isPingResponse) {
          _this.element.setAttribute('data-ready', 'true');

          resolve();
          return;
        }

        processData(_this, data);
      };

      _this._window.addEventListener('message', _this._onMessage);

      if (_this.element.nodeName !== 'IFRAME') {
        var params = getOEmbedParameters(element, options);
        var url = getVimeoUrl(params);
        getOEmbedData(url, params, element).then(function (data) {
          var iframe = createEmbed(data, element); // Overwrite element with the new iframe,
          // but store reference to the original element

          _this.element = iframe;
          _this._originalElement = element;
          swapCallbacks(element, iframe);
          playerMap.set(_this.element, _this);
          return data;
        }).catch(reject);
      }
    }); // Store a copy of this Player in the map

    readyMap.set(this, readyPromise);
    playerMap.set(this.element, this); // Send a ping to the iframe so the ready promise will be resolved if
    // the player is already ready.

    if (this.element.nodeName === 'IFRAME') {
      postMessage(this, 'ping');
    }

    if (screenfull.isEnabled) {
      var exitFullscreen = function exitFullscreen() {
        return screenfull.exit();
      };

      this.fullscreenchangeHandler = function () {
        if (screenfull.isFullscreen) {
          storeCallback(_this, 'event:exitFullscreen', exitFullscreen);
        } else {
          removeCallback(_this, 'event:exitFullscreen', exitFullscreen);
        } // eslint-disable-next-line


        _this.ready().then(function () {
          postMessage(_this, 'fullscreenchange', screenfull.isFullscreen);
        });
      };

      screenfull.on('fullscreenchange', this.fullscreenchangeHandler);
    }

    return this;
  }
  /**
   * Get a promise for a method.
   *
   * @param {string} name The API method to call.
   * @param {Object} [args={}] Arguments to send via postMessage.
   * @return {Promise}
   */


  _createClass(Player, [{
    key: "callMethod",
    value: function callMethod(name) {
      var _this2 = this;

      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return new npo_src(function (resolve, reject) {
        // We are storing the resolve/reject handlers to call later, so we
        // can’t return here.
        // eslint-disable-next-line promise/always-return
        return _this2.ready().then(function () {
          storeCallback(_this2, name, {
            resolve: resolve,
            reject: reject
          });
          postMessage(_this2, name, args);
        }).catch(reject);
      });
    }
    /**
     * Get a promise for the value of a player property.
     *
     * @param {string} name The property name
     * @return {Promise}
     */

  }, {
    key: "get",
    value: function get(name) {
      var _this3 = this;

      return new npo_src(function (resolve, reject) {
        name = getMethodName(name, 'get'); // We are storing the resolve/reject handlers to call later, so we
        // can’t return here.
        // eslint-disable-next-line promise/always-return

        return _this3.ready().then(function () {
          storeCallback(_this3, name, {
            resolve: resolve,
            reject: reject
          });
          postMessage(_this3, name);
        }).catch(reject);
      });
    }
    /**
     * Get a promise for setting the value of a player property.
     *
     * @param {string} name The API method to call.
     * @param {mixed} value The value to set.
     * @return {Promise}
     */

  }, {
    key: "set",
    value: function set(name, value) {
      var _this4 = this;

      return new npo_src(function (resolve, reject) {
        name = getMethodName(name, 'set');

        if (value === undefined || value === null) {
          throw new TypeError('There must be a value to set.');
        } // We are storing the resolve/reject handlers to call later, so we
        // can’t return here.
        // eslint-disable-next-line promise/always-return


        return _this4.ready().then(function () {
          storeCallback(_this4, name, {
            resolve: resolve,
            reject: reject
          });
          postMessage(_this4, name, value);
        }).catch(reject);
      });
    }
    /**
     * Add an event listener for the specified event. Will call the
     * callback with a single parameter, `data`, that contains the data for
     * that event.
     *
     * @param {string} eventName The name of the event.
     * @param {function(*)} callback The function to call when the event fires.
     * @return {void}
     */

  }, {
    key: "on",
    value: function on(eventName, callback) {
      if (!eventName) {
        throw new TypeError('You must pass an event name.');
      }

      if (!callback) {
        throw new TypeError('You must pass a callback function.');
      }

      if (typeof callback !== 'function') {
        throw new TypeError('The callback must be a function.');
      }

      var callbacks = getCallbacks(this, "event:".concat(eventName));

      if (callbacks.length === 0) {
        this.callMethod('addEventListener', eventName).catch(function () {// Ignore the error. There will be an error event fired that
          // will trigger the error callback if they are listening.
        });
      }

      storeCallback(this, "event:".concat(eventName), callback);
    }
    /**
     * Remove an event listener for the specified event. Will remove all
     * listeners for that event if a `callback` isn’t passed, or only that
     * specific callback if it is passed.
     *
     * @param {string} eventName The name of the event.
     * @param {function} [callback] The specific callback to remove.
     * @return {void}
     */

  }, {
    key: "off",
    value: function off(eventName, callback) {
      if (!eventName) {
        throw new TypeError('You must pass an event name.');
      }

      if (callback && typeof callback !== 'function') {
        throw new TypeError('The callback must be a function.');
      }

      var lastCallback = removeCallback(this, "event:".concat(eventName), callback); // If there are no callbacks left, remove the listener

      if (lastCallback) {
        this.callMethod('removeEventListener', eventName).catch(function (e) {// Ignore the error. There will be an error event fired that
          // will trigger the error callback if they are listening.
        });
      }
    }
    /**
     * A promise to load a new video.
     *
     * @promise LoadVideoPromise
     * @fulfill {number} The video with this id or url successfully loaded.
     * @reject {TypeError} The id was not a number.
     */

    /**
     * Load a new video into this embed. The promise will be resolved if
     * the video is successfully loaded, or it will be rejected if it could
     * not be loaded.
     *
     * @param {number|string|object} options The id of the video, the url of the video, or an object with embed options.
     * @return {LoadVideoPromise}
     */

  }, {
    key: "loadVideo",
    value: function loadVideo(options) {
      return this.callMethod('loadVideo', options);
    }
    /**
     * A promise to perform an action when the Player is ready.
     *
     * @todo document errors
     * @promise LoadVideoPromise
     * @fulfill {void}
     */

    /**
     * Trigger a function when the player iframe has initialized. You do not
     * need to wait for `ready` to trigger to begin adding event listeners
     * or calling other methods.
     *
     * @return {ReadyPromise}
     */

  }, {
    key: "ready",
    value: function ready() {
      var readyPromise = readyMap.get(this) || new npo_src(function (resolve, reject) {
        reject(new Error('Unknown player. Probably unloaded.'));
      });
      return npo_src.resolve(readyPromise);
    }
    /**
     * A promise to add a cue point to the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point to use for removeCuePoint.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */

    /**
     * Add a cue point to the player.
     *
     * @param {number} time The time for the cue point.
     * @param {object} [data] Arbitrary data to be returned with the cue point.
     * @return {AddCuePointPromise}
     */

  }, {
    key: "addCuePoint",
    value: function addCuePoint(time) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.callMethod('addCuePoint', {
        time: time,
        data: data
      });
    }
    /**
     * A promise to remove a cue point from the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point that was removed.
     * @reject {InvalidCuePoint} The cue point with the specified id was not
     *         found.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */

    /**
     * Remove a cue point from the video.
     *
     * @param {string} id The id of the cue point to remove.
     * @return {RemoveCuePointPromise}
     */

  }, {
    key: "removeCuePoint",
    value: function removeCuePoint(id) {
      return this.callMethod('removeCuePoint', id);
    }
    /**
     * A representation of a text track on a video.
     *
     * @typedef {Object} VimeoTextTrack
     * @property {string} language The ISO language code.
     * @property {string} kind The kind of track it is (captions or subtitles).
     * @property {string} label The human‐readable label for the track.
     */

    /**
     * A promise to enable a text track.
     *
     * @promise EnableTextTrackPromise
     * @fulfill {VimeoTextTrack} The text track that was enabled.
     * @reject {InvalidTrackLanguageError} No track was available with the
     *         specified language.
     * @reject {InvalidTrackError} No track was available with the specified
     *         language and kind.
     */

    /**
     * Enable the text track with the specified language, and optionally the
     * specified kind (captions or subtitles).
     *
     * When set via the API, the track language will not change the viewer’s
     * stored preference.
     *
     * @param {string} language The two‐letter language code.
     * @param {string} [kind] The kind of track to enable (captions or subtitles).
     * @return {EnableTextTrackPromise}
     */

  }, {
    key: "enableTextTrack",
    value: function enableTextTrack(language, kind) {
      if (!language) {
        throw new TypeError('You must pass a language.');
      }

      return this.callMethod('enableTextTrack', {
        language: language,
        kind: kind
      });
    }
    /**
     * A promise to disable the active text track.
     *
     * @promise DisableTextTrackPromise
     * @fulfill {void} The track was disabled.
     */

    /**
     * Disable the currently-active text track.
     *
     * @return {DisableTextTrackPromise}
     */

  }, {
    key: "disableTextTrack",
    value: function disableTextTrack() {
      return this.callMethod('disableTextTrack');
    }
    /**
     * A promise to pause the video.
     *
     * @promise PausePromise
     * @fulfill {void} The video was paused.
     */

    /**
     * Pause the video if it’s playing.
     *
     * @return {PausePromise}
     */

  }, {
    key: "pause",
    value: function pause() {
      return this.callMethod('pause');
    }
    /**
     * A promise to play the video.
     *
     * @promise PlayPromise
     * @fulfill {void} The video was played.
     */

    /**
     * Play the video if it’s paused. **Note:** on iOS and some other
     * mobile devices, you cannot programmatically trigger play. Once the
     * viewer has tapped on the play button in the player, however, you
     * will be able to use this function.
     *
     * @return {PlayPromise}
     */

  }, {
    key: "play",
    value: function play() {
      return this.callMethod('play');
    }
    /**
     * Request that the player enters fullscreen.
     * @return {Promise}
     */

  }, {
    key: "requestFullscreen",
    value: function requestFullscreen() {
      if (screenfull.isEnabled) {
        return screenfull.request(this.element);
      }

      return this.callMethod('requestFullscreen');
    }
    /**
     * Request that the player exits fullscreen.
     * @return {Promise}
     */

  }, {
    key: "exitFullscreen",
    value: function exitFullscreen() {
      if (screenfull.isEnabled) {
        return screenfull.exit();
      }

      return this.callMethod('exitFullscreen');
    }
    /**
     * Returns true if the player is currently fullscreen.
     * @return {Promise}
     */

  }, {
    key: "getFullscreen",
    value: function getFullscreen() {
      if (screenfull.isEnabled) {
        return npo_src.resolve(screenfull.isFullscreen);
      }

      return this.get('fullscreen');
    }
    /**
     * Request that the player enters picture-in-picture.
     * @return {Promise}
     */

  }, {
    key: "requestPictureInPicture",
    value: function requestPictureInPicture() {
      return this.callMethod('requestPictureInPicture');
    }
    /**
     * Request that the player exits picture-in-picture.
     * @return {Promise}
     */

  }, {
    key: "exitPictureInPicture",
    value: function exitPictureInPicture() {
      return this.callMethod('exitPictureInPicture');
    }
    /**
     * Returns true if the player is currently picture-in-picture.
     * @return {Promise}
     */

  }, {
    key: "getPictureInPicture",
    value: function getPictureInPicture() {
      return this.get('pictureInPicture');
    }
    /**
     * A promise to unload the video.
     *
     * @promise UnloadPromise
     * @fulfill {void} The video was unloaded.
     */

    /**
     * Return the player to its initial state.
     *
     * @return {UnloadPromise}
     */

  }, {
    key: "unload",
    value: function unload() {
      return this.callMethod('unload');
    }
    /**
     * Cleanup the player and remove it from the DOM
     *
     * It won't be usable and a new one should be constructed
     *  in order to do any operations.
     *
     * @return {Promise}
     */

  }, {
    key: "destroy",
    value: function destroy() {
      var _this5 = this;

      return new npo_src(function (resolve) {
        readyMap.delete(_this5);
        playerMap.delete(_this5.element);

        if (_this5._originalElement) {
          playerMap.delete(_this5._originalElement);

          _this5._originalElement.removeAttribute('data-vimeo-initialized');
        }

        if (_this5.element && _this5.element.nodeName === 'IFRAME' && _this5.element.parentNode) {
          // If we've added an additional wrapper div, remove that from the DOM.
          // If not, just remove the iframe element.
          if (_this5.element.parentNode.parentNode && _this5._originalElement && _this5._originalElement !== _this5.element.parentNode) {
            _this5.element.parentNode.parentNode.removeChild(_this5.element.parentNode);
          } else {
            _this5.element.parentNode.removeChild(_this5.element);
          }
        } // If the clip is private there is a case where the element stays the
        // div element. Destroy should reset the div and remove the iframe child.


        if (_this5.element && _this5.element.nodeName === 'DIV' && _this5.element.parentNode) {
          _this5.element.removeAttribute('data-vimeo-initialized');

          var iframe = _this5.element.querySelector('iframe');

          if (iframe && iframe.parentNode) {
            // If we've added an additional wrapper div, remove that from the DOM.
            // If not, just remove the iframe element.
            if (iframe.parentNode.parentNode && _this5._originalElement && _this5._originalElement !== iframe.parentNode) {
              iframe.parentNode.parentNode.removeChild(iframe.parentNode);
            } else {
              iframe.parentNode.removeChild(iframe);
            }
          }
        }

        _this5._window.removeEventListener('message', _this5._onMessage);

        if (screenfull.isEnabled) {
          screenfull.off('fullscreenchange', _this5.fullscreenchangeHandler);
        }

        resolve();
      });
    }
    /**
     * A promise to get the autopause behavior of the video.
     *
     * @promise GetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */

    /**
     * Get the autopause behavior for this player.
     *
     * @return {GetAutopausePromise}
     */

  }, {
    key: "getAutopause",
    value: function getAutopause() {
      return this.get('autopause');
    }
    /**
     * A promise to set the autopause behavior of the video.
     *
     * @promise SetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */

    /**
     * Enable or disable the autopause behavior of this player.
     *
     * By default, when another video is played in the same browser, this
     * player will automatically pause. Unless you have a specific reason
     * for doing so, we recommend that you leave autopause set to the
     * default (`true`).
     *
     * @param {boolean} autopause
     * @return {SetAutopausePromise}
     */

  }, {
    key: "setAutopause",
    value: function setAutopause(autopause) {
      return this.set('autopause', autopause);
    }
    /**
     * A promise to get the buffered property of the video.
     *
     * @promise GetBufferedPromise
     * @fulfill {Array} Buffered Timeranges converted to an Array.
     */

    /**
     * Get the buffered property of the video.
     *
     * @return {GetBufferedPromise}
     */

  }, {
    key: "getBuffered",
    value: function getBuffered() {
      return this.get('buffered');
    }
    /**
     * @typedef {Object} CameraProperties
     * @prop {number} props.yaw - Number between 0 and 360.
     * @prop {number} props.pitch - Number between -90 and 90.
     * @prop {number} props.roll - Number between -180 and 180.
     * @prop {number} props.fov - The field of view in degrees.
     */

    /**
     * A promise to get the camera properties of the player.
     *
     * @promise GetCameraPromise
     * @fulfill {CameraProperties} The camera properties.
     */

    /**
     * For 360° videos get the camera properties for this player.
     *
     * @return {GetCameraPromise}
     */

  }, {
    key: "getCameraProps",
    value: function getCameraProps() {
      return this.get('cameraProps');
    }
    /**
     * A promise to set the camera properties of the player.
     *
     * @promise SetCameraPromise
     * @fulfill {Object} The camera was successfully set.
     * @reject {RangeError} The range was out of bounds.
     */

    /**
     * For 360° videos set the camera properties for this player.
     *
     * @param {CameraProperties} camera The camera properties
     * @return {SetCameraPromise}
     */

  }, {
    key: "setCameraProps",
    value: function setCameraProps(camera) {
      return this.set('cameraProps', camera);
    }
    /**
     * A representation of a chapter.
     *
     * @typedef {Object} VimeoChapter
     * @property {number} startTime The start time of the chapter.
     * @property {object} title The title of the chapter.
     * @property {number} index The place in the order of Chapters. Starts at 1.
     */

    /**
     * A promise to get chapters for the video.
     *
     * @promise GetChaptersPromise
     * @fulfill {VimeoChapter[]} The chapters for the video.
     */

    /**
     * Get an array of all the chapters for the video.
     *
     * @return {GetChaptersPromise}
     */

  }, {
    key: "getChapters",
    value: function getChapters() {
      return this.get('chapters');
    }
    /**
     * A promise to get the currently active chapter.
     *
     * @promise GetCurrentChaptersPromise
     * @fulfill {VimeoChapter|undefined} The current chapter for the video.
     */

    /**
     * Get the currently active chapter for the video.
     *
     * @return {GetCurrentChaptersPromise}
     */

  }, {
    key: "getCurrentChapter",
    value: function getCurrentChapter() {
      return this.get('currentChapter');
    }
    /**
     * A promise to get the color of the player.
     *
     * @promise GetColorPromise
     * @fulfill {string} The hex color of the player.
     */

    /**
     * Get the color for this player.
     *
     * @return {GetColorPromise}
     */

  }, {
    key: "getColor",
    value: function getColor() {
      return this.get('color');
    }
    /**
     * A promise to set the color of the player.
     *
     * @promise SetColorPromise
     * @fulfill {string} The color was successfully set.
     * @reject {TypeError} The string was not a valid hex or rgb color.
     * @reject {ContrastError} The color was set, but the contrast is
     *         outside of the acceptable range.
     * @reject {EmbedSettingsError} The owner of the player has chosen to
     *         use a specific color.
     */

    /**
     * Set the color of this player to a hex or rgb string. Setting the
     * color may fail if the owner of the video has set their embed
     * preferences to force a specific color.
     *
     * @param {string} color The hex or rgb color string to set.
     * @return {SetColorPromise}
     */

  }, {
    key: "setColor",
    value: function setColor(color) {
      return this.set('color', color);
    }
    /**
     * A representation of a cue point.
     *
     * @typedef {Object} VimeoCuePoint
     * @property {number} time The time of the cue point.
     * @property {object} data The data passed when adding the cue point.
     * @property {string} id The unique id for use with removeCuePoint.
     */

    /**
     * A promise to get the cue points of a video.
     *
     * @promise GetCuePointsPromise
     * @fulfill {VimeoCuePoint[]} The cue points added to the video.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */

    /**
     * Get an array of the cue points added to the video.
     *
     * @return {GetCuePointsPromise}
     */

  }, {
    key: "getCuePoints",
    value: function getCuePoints() {
      return this.get('cuePoints');
    }
    /**
     * A promise to get the current time of the video.
     *
     * @promise GetCurrentTimePromise
     * @fulfill {number} The current time in seconds.
     */

    /**
     * Get the current playback position in seconds.
     *
     * @return {GetCurrentTimePromise}
     */

  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.get('currentTime');
    }
    /**
     * A promise to set the current time of the video.
     *
     * @promise SetCurrentTimePromise
     * @fulfill {number} The actual current time that was set.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     */

    /**
     * Set the current playback position in seconds. If the player was
     * paused, it will remain paused. Likewise, if the player was playing,
     * it will resume playing once the video has buffered.
     *
     * You can provide an accurate time and the player will attempt to seek
     * to as close to that time as possible. The exact time will be the
     * fulfilled value of the promise.
     *
     * @param {number} currentTime
     * @return {SetCurrentTimePromise}
     */

  }, {
    key: "setCurrentTime",
    value: function setCurrentTime(currentTime) {
      return this.set('currentTime', currentTime);
    }
    /**
     * A promise to get the duration of the video.
     *
     * @promise GetDurationPromise
     * @fulfill {number} The duration in seconds.
     */

    /**
     * Get the duration of the video in seconds. It will be rounded to the
     * nearest second before playback begins, and to the nearest thousandth
     * of a second after playback begins.
     *
     * @return {GetDurationPromise}
     */

  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.get('duration');
    }
    /**
     * A promise to get the ended state of the video.
     *
     * @promise GetEndedPromise
     * @fulfill {boolean} Whether or not the video has ended.
     */

    /**
     * Get the ended state of the video. The video has ended if
     * `currentTime === duration`.
     *
     * @return {GetEndedPromise}
     */

  }, {
    key: "getEnded",
    value: function getEnded() {
      return this.get('ended');
    }
    /**
     * A promise to get the loop state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the player is set to loop.
     */

    /**
     * Get the loop state of the player.
     *
     * @return {GetLoopPromise}
     */

  }, {
    key: "getLoop",
    value: function getLoop() {
      return this.get('loop');
    }
    /**
     * A promise to set the loop state of the player.
     *
     * @promise SetLoopPromise
     * @fulfill {boolean} The loop state that was set.
     */

    /**
     * Set the loop state of the player. When set to `true`, the player
     * will start over immediately once playback ends.
     *
     * @param {boolean} loop
     * @return {SetLoopPromise}
     */

  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      return this.set('loop', loop);
    }
    /**
     * A promise to set the muted state of the player.
     *
     * @promise SetMutedPromise
     * @fulfill {boolean} The muted state that was set.
     */

    /**
     * Set the muted state of the player. When set to `true`, the player
     * volume will be muted.
     *
     * @param {boolean} muted
     * @return {SetMutedPromise}
     */

  }, {
    key: "setMuted",
    value: function setMuted(muted) {
      return this.set('muted', muted);
    }
    /**
     * A promise to get the muted state of the player.
     *
     * @promise GetMutedPromise
     * @fulfill {boolean} Whether or not the player is muted.
     */

    /**
     * Get the muted state of the player.
     *
     * @return {GetMutedPromise}
     */

  }, {
    key: "getMuted",
    value: function getMuted() {
      return this.get('muted');
    }
    /**
     * A promise to get the paused state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the video is paused.
     */

    /**
     * Get the paused state of the player.
     *
     * @return {GetLoopPromise}
     */

  }, {
    key: "getPaused",
    value: function getPaused() {
      return this.get('paused');
    }
    /**
     * A promise to get the playback rate of the player.
     *
     * @promise GetPlaybackRatePromise
     * @fulfill {number} The playback rate of the player on a scale from 0.5 to 2.
     */

    /**
     * Get the playback rate of the player on a scale from `0.5` to `2`.
     *
     * @return {GetPlaybackRatePromise}
     */

  }, {
    key: "getPlaybackRate",
    value: function getPlaybackRate() {
      return this.get('playbackRate');
    }
    /**
     * A promise to set the playbackrate of the player.
     *
     * @promise SetPlaybackRatePromise
     * @fulfill {number} The playback rate was set.
     * @reject {RangeError} The playback rate was less than 0.5 or greater than 2.
     */

    /**
     * Set the playback rate of the player on a scale from `0.5` to `2`. When set
     * via the API, the playback rate will not be synchronized to other
     * players or stored as the viewer's preference.
     *
     * @param {number} playbackRate
     * @return {SetPlaybackRatePromise}
     */

  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(playbackRate) {
      return this.set('playbackRate', playbackRate);
    }
    /**
     * A promise to get the played property of the video.
     *
     * @promise GetPlayedPromise
     * @fulfill {Array} Played Timeranges converted to an Array.
     */

    /**
     * Get the played property of the video.
     *
     * @return {GetPlayedPromise}
     */

  }, {
    key: "getPlayed",
    value: function getPlayed() {
      return this.get('played');
    }
    /**
     * A promise to get the qualities available of the current video.
     *
     * @promise GetQualitiesPromise
     * @fulfill {Array} The qualities of the video.
     */

    /**
     * Get the qualities of the current video.
     *
     * @return {GetQualitiesPromise}
     */

  }, {
    key: "getQualities",
    value: function getQualities() {
      return this.get('qualities');
    }
    /**
     * A promise to get the current set quality of the video.
     *
     * @promise GetQualityPromise
     * @fulfill {string} The current set quality.
     */

    /**
     * Get the current set quality of the video.
     *
     * @return {GetQualityPromise}
     */

  }, {
    key: "getQuality",
    value: function getQuality() {
      return this.get('quality');
    }
    /**
     * A promise to set the video quality.
     *
     * @promise SetQualityPromise
     * @fulfill {number} The quality was set.
     * @reject {RangeError} The quality is not available.
     */

    /**
     * Set a video quality.
     *
     * @param {string} quality
     * @return {SetQualityPromise}
     */

  }, {
    key: "setQuality",
    value: function setQuality(quality) {
      return this.set('quality', quality);
    }
    /**
     * A promise to get the seekable property of the video.
     *
     * @promise GetSeekablePromise
     * @fulfill {Array} Seekable Timeranges converted to an Array.
     */

    /**
     * Get the seekable property of the video.
     *
     * @return {GetSeekablePromise}
     */

  }, {
    key: "getSeekable",
    value: function getSeekable() {
      return this.get('seekable');
    }
    /**
     * A promise to get the seeking property of the player.
     *
     * @promise GetSeekingPromise
     * @fulfill {boolean} Whether or not the player is currently seeking.
     */

    /**
     * Get if the player is currently seeking.
     *
     * @return {GetSeekingPromise}
     */

  }, {
    key: "getSeeking",
    value: function getSeeking() {
      return this.get('seeking');
    }
    /**
     * A promise to get the text tracks of a video.
     *
     * @promise GetTextTracksPromise
     * @fulfill {VimeoTextTrack[]} The text tracks associated with the video.
     */

    /**
     * Get an array of the text tracks that exist for the video.
     *
     * @return {GetTextTracksPromise}
     */

  }, {
    key: "getTextTracks",
    value: function getTextTracks() {
      return this.get('textTracks');
    }
    /**
     * A promise to get the embed code for the video.
     *
     * @promise GetVideoEmbedCodePromise
     * @fulfill {string} The `<iframe>` embed code for the video.
     */

    /**
     * Get the `<iframe>` embed code for the video.
     *
     * @return {GetVideoEmbedCodePromise}
     */

  }, {
    key: "getVideoEmbedCode",
    value: function getVideoEmbedCode() {
      return this.get('videoEmbedCode');
    }
    /**
     * A promise to get the id of the video.
     *
     * @promise GetVideoIdPromise
     * @fulfill {number} The id of the video.
     */

    /**
     * Get the id of the video.
     *
     * @return {GetVideoIdPromise}
     */

  }, {
    key: "getVideoId",
    value: function getVideoId() {
      return this.get('videoId');
    }
    /**
     * A promise to get the title of the video.
     *
     * @promise GetVideoTitlePromise
     * @fulfill {number} The title of the video.
     */

    /**
     * Get the title of the video.
     *
     * @return {GetVideoTitlePromise}
     */

  }, {
    key: "getVideoTitle",
    value: function getVideoTitle() {
      return this.get('videoTitle');
    }
    /**
     * A promise to get the native width of the video.
     *
     * @promise GetVideoWidthPromise
     * @fulfill {number} The native width of the video.
     */

    /**
     * Get the native width of the currently‐playing video. The width of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoWidthPromise}
     */

  }, {
    key: "getVideoWidth",
    value: function getVideoWidth() {
      return this.get('videoWidth');
    }
    /**
     * A promise to get the native height of the video.
     *
     * @promise GetVideoHeightPromise
     * @fulfill {number} The native height of the video.
     */

    /**
     * Get the native height of the currently‐playing video. The height of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoHeightPromise}
     */

  }, {
    key: "getVideoHeight",
    value: function getVideoHeight() {
      return this.get('videoHeight');
    }
    /**
     * A promise to get the vimeo.com url for the video.
     *
     * @promise GetVideoUrlPromise
     * @fulfill {number} The vimeo.com url for the video.
     * @reject {PrivacyError} The url isn’t available because of the video’s privacy setting.
     */

    /**
     * Get the vimeo.com url for the video.
     *
     * @return {GetVideoUrlPromise}
     */

  }, {
    key: "getVideoUrl",
    value: function getVideoUrl() {
      return this.get('videoUrl');
    }
    /**
     * A promise to get the volume level of the player.
     *
     * @promise GetVolumePromise
     * @fulfill {number} The volume level of the player on a scale from 0 to 1.
     */

    /**
     * Get the current volume level of the player on a scale from `0` to `1`.
     *
     * Most mobile devices do not support an independent volume from the
     * system volume. In those cases, this method will always return `1`.
     *
     * @return {GetVolumePromise}
     */

  }, {
    key: "getVolume",
    value: function getVolume() {
      return this.get('volume');
    }
    /**
     * A promise to set the volume level of the player.
     *
     * @promise SetVolumePromise
     * @fulfill {number} The volume was set.
     * @reject {RangeError} The volume was less than 0 or greater than 1.
     */

    /**
     * Set the volume of the player on a scale from `0` to `1`. When set
     * via the API, the volume level will not be synchronized to other
     * players or stored as the viewer’s preference.
     *
     * Most mobile devices do not support setting the volume. An error will
     * *not* be triggered in that situation.
     *
     * @param {number} volume
     * @return {SetVolumePromise}
     */

  }, {
    key: "setVolume",
    value: function setVolume(volume) {
      return this.set('volume', volume);
    }
  }]);

  return Player;
}(); // Setup embed only if this is not a node environment


if (!isNode) {
  screenfull = initializeScreenfull();
  initializeEmbeds();
  resizeEmbeds();
  initAppendVideoMetadata();
  checkUrlTimeParam();
}

/* harmony default export */ __webpack_exports__["default"] = (Player);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(16), __webpack_require__(799).setImmediate))

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

function makeFocusableForeignObject() {
  var fragment = document.createElement('div');
  fragment.innerHTML = '<svg><foreignObject width="30" height="30">\n      <input type="text"/>\n  </foreignObject></svg>';

  return fragment.firstChild.firstChild;
}

/* harmony default export */ __webpack_exports__["a"] = (function (element) {
  // Edge13, Edge14: foreignObject focus hack
  // https://jsbin.com/kunehinugi/edit?html,js,output
  // https://jsbin.com/fajagi/3/edit?html,js,output
  var isSvgElement = element.ownerSVGElement || element.nodeName.toLowerCase() === 'svg';
  if (!isSvgElement) {
    return false;
  }

  // inject and focus an <input> element into the SVG element to receive focus
  var foreignObject = makeFocusableForeignObject();
  element.appendChild(foreignObject);
  var input = foreignObject.querySelector('input');
  input.focus();

  // upon disabling the activeElement, IE and Edge
  // will not shift focus to <body> like all the other
  // browsers, but instead find the first focusable
  // ancestor and shift focus to that
  input.disabled = true;

  // clean up
  element.removeChild(foreignObject);
  return true;
});
//# sourceMappingURL=focus.svg-foreign-object-hack.js.map

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__get_active_elements__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_decorate_service__ = __webpack_require__(244);

/*
  Utility to observe focus changes within ShadowDOMs.

  USAGE:
    engage();
    document.body.addEventListener('shadow-focus', function(event) {
      // event.detail.elements: complete focus ancestry (array of nodes)
      // event.detail.active: the actually focused element within the ShadowDOM
      // event.detail.hosts: the shadow host ancestry of the active element
    }, false);

  Alternate implementation: https://github.com/cdata/focus-observer
*/




var engage = void 0;
var disengage = void 0;

if (typeof document === 'undefined' || !document.documentElement.createShadowRoot) {
  // no need to initialize any of this if we don't have ShadowDOM available
  engage = disengage = function disengage() {};
} else {
  (function () {
    var blurTimer = void 0;
    var blurElement = void 0;

    var handleElementBlurEvent = function handleElementBlurEvent() {
      stopHandleElementBlurEvent();
      // abort any handlers that come from document blur handler
      (window.clearImmediate || window.clearTimeout)(blurTimer);
      blurTimer = (window.setImmediate || window.setTimeout)(function () {
        handleFocusChange();
      });
    };

    var observeElementBlurEvent = function observeElementBlurEvent(element) {
      // call us when we're leaving the element
      element.addEventListener('blur', handleElementBlurEvent, true);
      blurElement = element;
    };

    var stopHandleElementBlurEvent = function stopHandleElementBlurEvent() {
      // once() - sometimes I miss jQuery's simplicity…
      blurElement && blurElement.removeEventListener('blur', handleElementBlurEvent, true);
      blurElement = null;
    };

    var handleFocusChange = function handleFocusChange() {
      var _active = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__get_active_elements__["a" /* default */])();
      if (_active.length === 1) {
        stopHandleElementBlurEvent();
        return;
      }

      // listen for blur so we know when to re-validate
      observeElementBlurEvent(_active[0]);
      var shadowFocusEvent = new CustomEvent('shadow-focus', {
        bubbles: false,
        cancelable: false,
        detail: {
          // complete focus ancestry
          elements: _active,
          // the actually focused element
          active: _active[0],
          // shadow host ancestry
          hosts: _active.slice(1)
        }
      });

      document.dispatchEvent(shadowFocusEvent);
    };

    var handleDocumentFocusEvent = function handleDocumentFocusEvent() {
      (window.clearImmediate || window.clearTimeout)(blurTimer);
      handleFocusChange();
    };

    engage = function engage() {
      document.addEventListener('focus', handleDocumentFocusEvent, true);
    };

    disengage = function disengage() {
      (window.clearImmediate || window.clearTimeout)(blurTimer);
      blurElement && blurElement.removeEventListener('blur', handleElementBlurEvent, true);
      document.removeEventListener('focus', handleDocumentFocusEvent, true);
    };
  })();
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_decorate_service__["a" /* default */])({ engage: engage, disengage: disengage }));
//# sourceMappingURL=shadow-focus.js.map

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_context_to_element__ = __webpack_require__(193);



// [elem, elem.parent, elem.parent.parent, …, html]
// will not contain the shadowRoot (DOCUMENT_FRAGMENT_NODE) and shadowHost
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref.context;

  var list = [];
  var element = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_context_to_element__["a" /* default */])({
    label: 'get/parents',
    context: context
  });

  while (element) {
    list.push(element);
    // IE does know support parentElement on SVGElement
    element = element.parentNode;
    if (element && element.nodeType !== Node.ELEMENT_NODE) {
      element = null;
    }
  }

  return list;
});
//# sourceMappingURL=parents.js.map

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shadow_host__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_context_to_element__ = __webpack_require__(193);




/* harmony default export */ __webpack_exports__["a"] = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref.context;

  var list = [];
  var element = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_context_to_element__["a" /* default */])({
    label: 'get/shadow-host-parents',
    context: context
  });

  while (element) {
    element = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shadow_host__["a" /* default */])({ context: element });
    if (!element) {
      break;
    }

    list.push(element);
  }

  return list;
});
//# sourceMappingURL=shadow-host-parents.js.map

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_context_to_element__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_shadow_host__ = __webpack_require__(241);

// determine if an element is the child of a ShadowRoot




/* harmony default export */ __webpack_exports__["a"] = (function (context) {
  var element = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_context_to_element__["a" /* default */])({
    label: 'is/shadowed',
    resolveDocument: true,
    context: context
  });

  return Boolean(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__get_shadow_host__["a" /* default */])({ context: element }));
});
//# sourceMappingURL=shadowed.js.map

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_toggle_class__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_shadow_focus__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__get_active_elements__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__get_parents__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_decorate_service__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_select_in_shadows__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__supports_supports__ = __webpack_require__(565);

/*
  add .ally-focus-within class to parents of document.activeElement,
  to provide the functionality of :focus-within where it's not available
  see https://dev.w3.org/csswg/selectors-4/#the-focus-within-pseudo

  USAGE:
    style/focus-within()
*/









var supports = void 0;

// preferring focusin/out because they are synchronous in IE10+11
var supportsFocusIn = typeof document !== 'undefined' && 'onfocusin' in document;
var focusEventName = supportsFocusIn ? 'focusin' : 'focus';
var blurEventName = supportsFocusIn ? 'focusout' : 'blur';

var className = 'ally-focus-within';
// defined in engage();
var selector = void 0;
var blurTimer = void 0;
var shadowHandle = void 0;

function applyFocusWithinClass(active) {
  var _active = active || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__get_active_elements__["a" /* default */])();
  if (!supports.cssShadowPiercingDeepCombinator) {
    // no shadow-piercing descendant selector, no joy
    _active = _active.slice(-1);
  }

  // identify the elements that currently have :focus-within
  var _current = [].slice.call(document.querySelectorAll(selector), 0);
  // get the path (ancestry) of each ShadowRoot and merge them into a flat list
  var elements = _active.map(function (context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__get_parents__["a" /* default */])({ context: context });
  }).reduce(function (previous, current) {
    return current.concat(previous);
  }, []);

  // remove the class only from elements that would not receive it again (minimize dom action)
  _current.forEach(function (element) {
    if (elements.indexOf(element) !== -1) {
      return;
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_toggle_class__["a" /* removeClass */])(element, className);
  });

  // apply the class only to elements that do not yet have it (minimize dom action)
  elements.forEach(function (element) {
    if (_current.indexOf(element) !== -1) {
      return;
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_toggle_class__["b" /* addClass */])(element, className);
  });
}

function handleDocumentBlurEvent() {
  // we won't get a focus for <body>, but a delayed blur handler will achieve
  // the same thing listening for focus would've done, unless we get a focus, of course
  blurTimer = (window.setImmediate || window.setTimeout)(function () {
    applyFocusWithinClass();
  });
}

function handleDocumentFocusEvent() {
  // abort any handlers that come from document or element blur handlers
  (window.clearImmediate || window.clearTimeout)(blurTimer);
  // NOTE: we could overcome Firefox 34 issue of not supporting ShadowRoot.host by
  // passing event.target (which references the first-level ShadowHost), but that
  // would require applyFocusWithinClass() to distinguish between the argument and
  // getActiveElements().
  applyFocusWithinClass();
}

function handleShadowFocusEvent(event) {
  applyFocusWithinClass(event.detail.elements);
}

function disengage() {
  shadowHandle && shadowHandle.disengage();
  (window.clearImmediate || window.clearTimeout)(blurTimer);
  document.removeEventListener(blurEventName, handleDocumentBlurEvent, true);
  document.removeEventListener(focusEventName, handleDocumentFocusEvent, true);
  document.removeEventListener('shadow-focus', handleShadowFocusEvent, true);

  // remove any remaining ally-within-focus occurrences
  [].forEach.call(document.querySelectorAll(selector), function (element) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_toggle_class__["a" /* removeClass */])(element, className);
  });
}

function engage() {
  if (!supports) {
    supports = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__supports_supports__["a" /* default */])();
    selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_select_in_shadows__["a" /* default */])('.' + className);
  }

  shadowHandle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__event_shadow_focus__["a" /* default */])();
  document.addEventListener(blurEventName, handleDocumentBlurEvent, true);
  document.addEventListener(focusEventName, handleDocumentFocusEvent, true);
  document.addEventListener('shadow-focus', handleShadowFocusEvent, true);
  applyFocusWithinClass();
}

/* harmony default export */ __webpack_exports__["default"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_decorate_service__["a" /* default */])({ engage: engage, disengage: disengage }));
//# sourceMappingURL=focus-within.js.map

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_platform__ = __webpack_require__(40);



function before() {
  var data = {
    // remember what had focus to restore after test
    activeElement: document.activeElement,
    // remember scroll positions to restore after test
    windowScrollTop: window.scrollTop,
    windowScrollLeft: window.scrollLeft,
    bodyScrollTop: document.body.scrollTop,
    bodyScrollLeft: document.body.scrollLeft
  };

  // wrap tests in an element hidden from screen readers to prevent them
  // from announcing focus, which can be quite irritating to the user
  var iframe = document.createElement('iframe');
  iframe.setAttribute('style', 'position:absolute; position:fixed; top:0; left:-2px; width:1px; height:1px; overflow:hidden;');
  iframe.setAttribute('aria-live', 'off');
  iframe.setAttribute('aria-busy', 'true');
  iframe.setAttribute('aria-hidden', 'true');
  document.body.appendChild(iframe);

  var _window = iframe.contentWindow;
  var _document = _window.document;

  _document.open();
  _document.close();
  var wrapper = _document.createElement('div');
  _document.body.appendChild(wrapper);

  data.iframe = iframe;
  data.wrapper = wrapper;
  data.window = _window;
  data.document = _document;

  return data;
}

// options.element:
//  {string} element name
//  {function} callback(wrapper, document) to generate an element
// options.mutate: (optional)
//  {function} callback(element, wrapper, document) to manipulate element prior to focus-test.
//             Can return DOMElement to define focus target (default: element)
// options.validate: (optional)
//  {function} callback(element, focusTarget, document) to manipulate test-result
function test(data, options) {
  // make sure we operate on a clean slate
  data.wrapper.innerHTML = '';
  // create dummy element to test focusability of
  var element = typeof options.element === 'string' ? data.document.createElement(options.element) : options.element(data.wrapper, data.document);
  // allow callback to further specify dummy element
  // and optionally define element to focus
  var focus = options.mutate && options.mutate(element, data.wrapper, data.document);
  if (!focus && focus !== false) {
    focus = element;
  }
  // element needs to be part of the DOM to be focusable
  !element.parentNode && data.wrapper.appendChild(element);
  // test if the element with invalid tabindex can be focused
  focus && focus.focus && focus.focus();
  // validate test's result
  return options.validate ? options.validate(element, focus, data.document) : data.document.activeElement === focus;
}

function after(data) {
  // restore focus to what it was before test and cleanup
  if (data.activeElement === document.body) {
    document.activeElement && document.activeElement.blur && document.activeElement.blur();
    if (__WEBPACK_IMPORTED_MODULE_0__util_platform__["a" /* default */].is.IE10) {
      // IE10 does not redirect focus to <body> when the activeElement is removed
      document.body.focus();
    }
  } else {
    data.activeElement && data.activeElement.focus && data.activeElement.focus();
  }

  document.body.removeChild(data.iframe);

  // restore scroll position
  window.scrollTop = data.windowScrollTop;
  window.scrollLeft = data.windowScrollLeft;
  document.body.scrollTop = data.bodyScrollTop;
  document.body.scrollLeft = data.bodyScrollLeft;
}

/* harmony default export */ __webpack_exports__["a"] = (function (tests) {
  var data = before();

  var results = {};
  Object.keys(tests).map(function (key) {
    results[key] = test(data, tests[key]);
  });

  after(data);
  return results;
});
//# sourceMappingURL=detect-focus.js.map

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_gif__ = __webpack_require__(39);



// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-usemap
/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = '<map name="image-map-tabindex-test">' + '<area shape="rect" coords="63,19,144,45"></map>' + '<img usemap="#image-map-tabindex-test" tabindex="-1" alt="" src="' + __WEBPACK_IMPORTED_MODULE_0__media_gif__["a" /* default */] + '">';

    return element.querySelector('area');
  }
});
//# sourceMappingURL=focus-area-img-tabindex.js.map

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_gif__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_platform__ = __webpack_require__(40);




// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-usemap
/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = '<map name="image-map-tabindex-test">' + '<area href="#void" tabindex="-1" shape="rect" coords="63,19,144,45"></map>' + '<img usemap="#image-map-tabindex-test" alt="" src="' + __WEBPACK_IMPORTED_MODULE_0__media_gif__["a" /* default */] + '">';

    return false;
  },
  validate: function validate(element, focusTarget, _document) {
    if (__WEBPACK_IMPORTED_MODULE_1__util_platform__["a" /* default */].is.GECKO) {
      // fixes https://github.com/medialize/ally.js/issues/35
      // Firefox loads the DataURI asynchronously, causing a false-negative
      return true;
    }

    var focus = element.querySelector('area');
    focus.focus();
    return _document.activeElement === focus;
  }
});
//# sourceMappingURL=focus-area-tabindex.js.map

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_gif__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_platform__ = __webpack_require__(40);




// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-usemap
/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = '<map name="image-map-area-href-test">' + '<area shape="rect" coords="63,19,144,45"></map>' + '<img usemap="#image-map-area-href-test" alt="" src="' + __WEBPACK_IMPORTED_MODULE_0__media_gif__["a" /* default */] + '">';

    return element.querySelector('area');
  },
  validate: function validate(element, focusTarget, _document) {
    if (__WEBPACK_IMPORTED_MODULE_1__util_platform__["a" /* default */].is.GECKO) {
      // fixes https://github.com/medialize/ally.js/issues/35
      // Firefox loads the DataURI asynchronously, causing a false-negative
      return true;
    }

    return _document.activeElement === focusTarget;
  }
});
//# sourceMappingURL=focus-area-without-href.js.map

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_mp3__ = __webpack_require__(562);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'can-focus-audio-without-controls',
  element: 'audio',
  mutate: function mutate(element) {
    try {
      // invalid media file can trigger warning in console, data-uri to prevent HTTP request
      element.setAttribute('src', __WEBPACK_IMPORTED_MODULE_0__media_mp3__["a" /* default */]);
    } catch (e) {
      // IE9 may throw "Error: Not implemented"
    }
  }
});
//# sourceMappingURL=focus-audio-without-controls.js.map

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_gif_invalid__ = __webpack_require__(561);



// NOTE: https://github.com/medialize/ally.js/issues/35
// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-usemap
/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = '<map name="broken-image-map-test"><area href="#void" shape="rect" coords="63,19,144,45"></map>' + '<img usemap="#broken-image-map-test" alt="" src="' + __WEBPACK_IMPORTED_MODULE_0__media_gif_invalid__["a" /* default */] + '">';

    return element.querySelector('area');
  }
});
//# sourceMappingURL=focus-broken-image-map.js.map

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// Children of focusable elements with display:flex are focusable in IE10-11
/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.setAttribute('tabindex', '-1');
    element.setAttribute('style', 'display: -webkit-flex; display: -ms-flexbox; display: flex;');
    element.innerHTML = '<span style="display: block;">hello</span>';
    return element.querySelector('span');
  }
});
//# sourceMappingURL=focus-children-of-focusable-flexbox.js.map

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// fieldset[tabindex=0][disabled] should not be focusable, but Blink and WebKit disagree
// @specification https://www.w3.org/TR/html5/disabled-elements.html#concept-element-disabled
// @browser-issue Chromium https://crbug.com/453847
// @browser-issue WebKit https://bugs.webkit.org/show_bug.cgi?id=141086
/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'fieldset',
  mutate: function mutate(element) {
    element.setAttribute('tabindex', 0);
    element.setAttribute('disabled', 'disabled');
  }
});
//# sourceMappingURL=focus-fieldset-disabled.js.map

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'fieldset',
  mutate: function mutate(element) {
    element.innerHTML = '<legend>legend</legend><p>content</p>';
  }
});
//# sourceMappingURL=focus-fieldset.js.map

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// elements with display:flex are focusable in IE10-11
/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'span',
  mutate: function mutate(element) {
    element.setAttribute('style', 'display: -webkit-flex; display: -ms-flexbox; display: flex;');
    element.innerHTML = '<span style="display: block;">hello</span>';
  }
});
//# sourceMappingURL=focus-flexbox-container.js.map

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// form[tabindex=0][disabled] should be focusable as the
// specification doesn't know the disabled attribute on the form element
// @specification https://www.w3.org/TR/html5/forms.html#the-form-element
/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'form',
  mutate: function mutate(element) {
    element.setAttribute('tabindex', 0);
    element.setAttribute('disabled', 'disabled');
  }
});
//# sourceMappingURL=focus-form-disabled.js.map

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_gif__ = __webpack_require__(39);



// NOTE: https://github.com/medialize/ally.js/issues/35
// fixes https://github.com/medialize/ally.js/issues/20
// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-ismap
/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'a',
  mutate: function mutate(element) {
    element.href = '#void';
    element.innerHTML = '<img ismap src="' + __WEBPACK_IMPORTED_MODULE_0__media_gif__["a" /* default */] + '" alt="">';
    return element.querySelector('img');
  }
});
//# sourceMappingURL=focus-img-ismap.js.map

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_gif__ = __webpack_require__(39);



// NOTE: https://github.com/medialize/ally.js/issues/35
// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-usemap
/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = '<map name="image-map-tabindex-test"><area href="#void" shape="rect" coords="63,19,144,45"></map>' + '<img usemap="#image-map-tabindex-test" tabindex="-1" alt="" ' + 'src="' + __WEBPACK_IMPORTED_MODULE_0__media_gif__["a" /* default */] + '">';

    return element.querySelector('img');
  }
});
//# sourceMappingURL=focus-img-usemap-tabindex.js.map

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  element: function element(wrapper, _document) {
    var iframe = _document.createElement('iframe');

    // iframe must be part of the DOM before accessing the contentWindow is possible
    wrapper.appendChild(iframe);

    // create the iframe's default document (<html><head></head><body></body></html>)
    var iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.close();
    return iframe;
  },
  mutate: function mutate(iframe) {
    iframe.style.visibility = 'hidden';

    var iframeDocument = iframe.contentWindow.document;
    var input = iframeDocument.createElement('input');
    iframeDocument.body.appendChild(input);
    return input;
  },
  validate: function validate(iframe) {
    var iframeDocument = iframe.contentWindow.document;
    var focus = iframeDocument.querySelector('input');
    return iframeDocument.activeElement === focus;
  }
});
//# sourceMappingURL=focus-in-hidden-iframe.js.map

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_platform__ = __webpack_require__(40);



var result = !__WEBPACK_IMPORTED_MODULE_0__util_platform__["a" /* default */].is.WEBKIT;

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return result;
});
//# sourceMappingURL=focus-in-zero-dimension-object.js.map

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// Firefox allows *any* value and treats invalid values like tabindex="-1"
// @browser-issue Gecko https://bugzilla.mozilla.org/show_bug.cgi?id=1128054
/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.setAttribute('tabindex', 'invalid-value');
  }
});
//# sourceMappingURL=focus-invalid-tabindex.js.map

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'label',
  mutate: function mutate(element) {
    element.setAttribute('tabindex', '-1');
  },
  validate: function validate(element, focusTarget, _document) {
    // force layout in Chrome 49, otherwise the element won't be focusable
    /* eslint-disable no-unused-vars */
    var variableToPreventDeadCodeElimination = element.offsetHeight;
    /* eslint-enable no-unused-vars */
    element.focus();
    return _document.activeElement === element;
  }
});
//# sourceMappingURL=focus-label-tabindex.js.map

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_svg__ = __webpack_require__(243);



// Note: IE10 on BrowserStack does not like this test

/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'object',
  mutate: function mutate(element) {
    element.setAttribute('type', 'image/svg+xml');
    element.setAttribute('data', __WEBPACK_IMPORTED_MODULE_0__media_svg__["a" /* default */]);
    element.setAttribute('width', '200');
    element.setAttribute('height', '50');
    element.style.visibility = 'hidden';
  }
});
//# sourceMappingURL=focus-object-svg-hidden.js.map

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_svg__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_platform__ = __webpack_require__(40);




// Note: IE10 on BrowserStack does not like this test

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'can-focus-object-svg',
  element: 'object',
  mutate: function mutate(element) {
    element.setAttribute('type', 'image/svg+xml');
    element.setAttribute('data', __WEBPACK_IMPORTED_MODULE_0__media_svg__["a" /* default */]);
    element.setAttribute('width', '200');
    element.setAttribute('height', '50');
  },
  validate: function validate(element, focusTarget, _document) {
    if (__WEBPACK_IMPORTED_MODULE_1__util_platform__["a" /* default */].is.GECKO) {
      // Firefox seems to be handling the object creation asynchronously and thereby produces a false negative test result.
      // Because we know Firefox is able to focus object elements referencing SVGs, we simply cheat by sniffing the user agent string
      return true;
    }

    return _document.activeElement === element;
  }
});
//# sourceMappingURL=focus-object-svg.js.map

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_platform__ = __webpack_require__(40);



// Every Environment except IE9 considers SWF objects focusable
var result = !__WEBPACK_IMPORTED_MODULE_0__util_platform__["a" /* default */].is.IE9;

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return result;
});
//# sourceMappingURL=focus-object-swf.js.map

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_gif__ = __webpack_require__(39);



/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = '<map name="focus-redirect-img-usemap"><area href="#void" shape="rect" coords="63,19,144,45"></map>' + '<img usemap="#focus-redirect-img-usemap" alt="" ' + 'src="' + __WEBPACK_IMPORTED_MODULE_0__media_gif__["a" /* default */] + '">';

    // focus the <img>, not the <div>
    return element.querySelector('img');
  },
  validate: function validate(element, focusTarget, _document) {
    var target = element.querySelector('area');
    return _document.activeElement === target;
  }
});
//# sourceMappingURL=focus-redirect-img-usemap.js.map

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// see https://jsbin.com/nenirisage/edit?html,js,console,output

/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'fieldset',
  mutate: function mutate(element) {
    element.innerHTML = '<legend>legend</legend><input tabindex="-1"><input tabindex="0">';
    // take care of focus in validate();
    return false;
  },
  validate: function validate(element, focusTarget, _document) {
    var focusable = element.querySelector('input[tabindex="-1"]');
    var tabbable = element.querySelector('input[tabindex="0"]');

    // Firefox requires this test to focus the <fieldset> first, while this is not necessary in
    // https://jsbin.com/nenirisage/edit?html,js,console,output
    element.focus();

    element.querySelector('legend').focus();
    return _document.activeElement === focusable && 'focusable' || _document.activeElement === tabbable && 'tabbable' || '';
  }
});
//# sourceMappingURL=focus-redirect-legend.js.map

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// https://github.com/medialize/ally.js/issues/21
/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.setAttribute('style', 'width: 100px; height: 50px; overflow: auto;');
    element.innerHTML = '<div style="width: 500px; height: 40px;">scrollable content</div>';
    return element.querySelector('div');
  }
});
//# sourceMappingURL=focus-scroll-body.js.map

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// https://github.com/medialize/ally.js/issues/21
/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.setAttribute('style', 'width: 100px; height: 50px;');
    element.innerHTML = '<div style="width: 500px; height: 40px;">scrollable content</div>';
  }
});
//# sourceMappingURL=focus-scroll-container-without-overflow.js.map

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// https://github.com/medialize/ally.js/issues/21
/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.setAttribute('style', 'width: 100px; height: 50px; overflow: auto;');
    element.innerHTML = '<div style="width: 500px; height: 40px;">scrollable content</div>';
  }
});
//# sourceMappingURL=focus-scroll-container.js.map

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'details',
  mutate: function mutate(element) {
    element.innerHTML = '<summary>foo</summary><p>content</p>';
    return element.firstElementChild;
  }
});
//# sourceMappingURL=focus-summary.js.map

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_svg__ = __webpack_require__(77);



/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_svg__["a" /* generate */])('<text focusable="true">a</text>');
    return element.querySelector('text');
  },
  validate: __WEBPACK_IMPORTED_MODULE_0__helper_svg__["b" /* validate */]
});
//# sourceMappingURL=focus-svg-focusable-attribute.js.map

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_svg__ = __webpack_require__(77);



/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_svg__["a" /* generate */])('<foreignObject tabindex="-1"><input type="text" /></foreignObject>');
    // Safari 8's quersSelector() can't identify foreignObject, but getElementyByTagName() can
    return element.querySelector('foreignObject') || element.getElementsByTagName('foreignObject')[0];
  },
  validate: __WEBPACK_IMPORTED_MODULE_0__helper_svg__["b" /* validate */]

});
//# sourceMappingURL=focus-svg-foreignobject-tabindex.js.map

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_platform__ = __webpack_require__(40);



// Firefox seems to be handling the SVG-document-in-iframe creation asynchronously
// and thereby produces a false negative test result. Thus the test is pointless
// and we resort to UA sniffing once again.
// see http://jsbin.com/vunadohoko/1/edit?js,console,output

var result = Boolean(__WEBPACK_IMPORTED_MODULE_0__util_platform__["a" /* default */].is.GECKO && typeof SVGElement !== 'undefined' && SVGElement.prototype.focus);

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return result;
});
//# sourceMappingURL=focus-svg-in-iframe.js.map

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_svg__ = __webpack_require__(77);



/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_svg__["a" /* generate */])('<text tabindex="-1">a</text>');
    return element.querySelector('text');
  },
  validate: __WEBPACK_IMPORTED_MODULE_0__helper_svg__["b" /* validate */]
});
//# sourceMappingURL=focus-svg-negative-tabindex-attribute.js.map

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_svg__ = __webpack_require__(77);



/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_svg__["a" /* generate */])('<text tabindex="0">a</text>');
    return element.querySelector('text');
  },
  validate: __WEBPACK_IMPORTED_MODULE_0__helper_svg__["b" /* validate */]
});
//# sourceMappingURL=focus-svg-tabindex-attribute.js.map

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_svg__ = __webpack_require__(77);



/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_svg__["a" /* generate */])(['<g id="ally-test-target"><a xlink:href="#void"><text>link</text></a></g>', '<use xlink:href="#ally-test-target" x="0" y="0" tabindex="-1" />'].join(''));

    return element.querySelector('use');
  },
  validate: __WEBPACK_IMPORTED_MODULE_0__helper_svg__["b" /* validate */]
});
//# sourceMappingURL=focus-svg-use-tabindex.js.map

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_svg__ = __webpack_require__(77);



/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_svg__["a" /* generate */])('');
    return element.firstChild;
  },
  validate: __WEBPACK_IMPORTED_MODULE_0__helper_svg__["b" /* validate */]
});
//# sourceMappingURL=focus-svg.js.map

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// Firefox allows *any* value and treats invalid values like tabindex="-1"
// @browser-issue Gecko https://bugzilla.mozilla.org/show_bug.cgi?id=1128054
/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'div',
  mutate: function mutate(element) {
    element.setAttribute('tabindex', '3x');
  }
});
//# sourceMappingURL=focus-tabindex-trailing-characters.js.map

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'table',
  mutate: function mutate(element, wrapper, _document) {
    // IE9 has a problem replacing TBODY contents with innerHTML.
    // https://stackoverflow.com/a/8097055/515124
    // element.innerHTML = '<tr><td>cell</td></tr>';
    var fragment = _document.createDocumentFragment();
    fragment.innerHTML = '<tr><td>cell</td></tr>';
    element.appendChild(fragment);
  }
});
//# sourceMappingURL=focus-table.js.map

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_mp4__ = __webpack_require__(563);



/* harmony default export */ __webpack_exports__["a"] = ({
  element: 'video',
  mutate: function mutate(element) {
    try {
      // invalid media file can trigger warning in console, data-uri to prevent HTTP request
      element.setAttribute('src', __WEBPACK_IMPORTED_MODULE_0__media_mp4__["a" /* default */]);
    } catch (e) {
      // IE9 may throw "Error: Not implemented"
    }
  }
});
//# sourceMappingURL=focus-video-without-controls.js.map

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ('data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZ');
//# sourceMappingURL=gif.invalid.js.map

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gif__ = __webpack_require__(39);

// export default 'data:audio/mp3;base64,audio-focus-test';

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__gif__["a" /* default */]);
//# sourceMappingURL=mp3.js.map

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gif__ = __webpack_require__(39);

// export default 'data:video/mp4;base64,video-focus-test';

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__gif__["a" /* default */]);
//# sourceMappingURL=mp4.js.map

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__version__ = __webpack_require__(570);
/*
    Facility to cache test results in localStorage.

    USAGE:
      cache.get('key');
      cache.set('key', 'value');
 */



function readLocalStorage(key) {
  // allow reading from storage to retrieve previous support results
  // even while the document does not have focus
  var data = void 0;

  try {
    data = window.localStorage && window.localStorage.getItem(key);
    data = data ? JSON.parse(data) : {};
  } catch (e) {
    data = {};
  }

  return data;
}

function writeLocalStorage(key, value) {
  if (!document.hasFocus()) {
    // if the document does not have focus when tests are executed, focus() may
    // not be handled properly and events may not be dispatched immediately.
    // This can happen when a document is reloaded while Developer Tools have focus.
    try {
      window.localStorage && window.localStorage.removeItem(key);
    } catch (e) {
      // ignore
    }

    return;
  }

  try {
    window.localStorage && window.localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    // ignore
  }
}

var userAgent = typeof window !== 'undefined' && window.navigator.userAgent || '';
var cacheKey = 'ally-supports-cache';
var cache = readLocalStorage(cacheKey);

// update the cache if ally or the user agent changed (newer version, etc)
if (cache.userAgent !== userAgent || cache.version !== __WEBPACK_IMPORTED_MODULE_0__version__["a" /* default */]) {
  cache = {};
}

cache.userAgent = userAgent;
cache.version = __WEBPACK_IMPORTED_MODULE_0__version__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get() {
    return cache;
  },
  set: function set(values) {
    Object.keys(values).forEach(function (key) {
      cache[key] = values[key];
    });

    cache.time = new Date().toISOString();
    writeLocalStorage(cacheKey, cache);
  }
});
//# sourceMappingURL=supports-cache.js.map

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__detect_focus__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__supports_cache__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_shadow_piercing_deep_combinator__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__focus_area_img_tabindex__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__focus_area_tabindex__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__focus_area_without_href__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__focus_audio_without_controls__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__focus_broken_image_map__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__focus_children_of_focusable_flexbox__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__focus_fieldset_disabled__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__focus_fieldset__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__focus_flexbox_container__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__focus_form_disabled__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__focus_img_ismap__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__focus_img_usemap_tabindex__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__focus_in_hidden_iframe__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__focus_in_zero_dimension_object__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__focus_invalid_tabindex__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__focus_label_tabindex__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__focus_object_svg_hidden__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__focus_object_svg__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__focus_object_swf__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__focus_redirect_img_usemap__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__focus_redirect_legend__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__focus_scroll_body__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__focus_scroll_container_without_overflow__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__focus_scroll_container__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__focus_summary__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__focus_svg_focusable_attribute__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__focus_svg_tabindex_attribute__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__focus_svg_negative_tabindex_attribute__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__focus_svg_use_tabindex__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__focus_svg_foreignobject_tabindex__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__focus_svg_in_iframe__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__focus_svg__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__focus_tabindex_trailing_characters__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__focus_table__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__focus_video_without_controls__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__tabsequence_area_at_img_position__ = __webpack_require__(566);










































var testCallbacks = {
  cssShadowPiercingDeepCombinator: __WEBPACK_IMPORTED_MODULE_2__css_shadow_piercing_deep_combinator__["a" /* default */],
  focusInZeroDimensionObject: __WEBPACK_IMPORTED_MODULE_16__focus_in_zero_dimension_object__["a" /* default */],
  focusObjectSwf: __WEBPACK_IMPORTED_MODULE_21__focus_object_swf__["a" /* default */],
  focusSvgInIframe: __WEBPACK_IMPORTED_MODULE_33__focus_svg_in_iframe__["a" /* default */],
  tabsequenceAreaAtImgPosition: __WEBPACK_IMPORTED_MODULE_38__tabsequence_area_at_img_position__["a" /* default */]
};

var testDescriptions = {
  focusAreaImgTabindex: __WEBPACK_IMPORTED_MODULE_3__focus_area_img_tabindex__["a" /* default */],
  focusAreaTabindex: __WEBPACK_IMPORTED_MODULE_4__focus_area_tabindex__["a" /* default */],
  focusAreaWithoutHref: __WEBPACK_IMPORTED_MODULE_5__focus_area_without_href__["a" /* default */],
  focusAudioWithoutControls: __WEBPACK_IMPORTED_MODULE_6__focus_audio_without_controls__["a" /* default */],
  focusBrokenImageMap: __WEBPACK_IMPORTED_MODULE_7__focus_broken_image_map__["a" /* default */],
  focusChildrenOfFocusableFlexbox: __WEBPACK_IMPORTED_MODULE_8__focus_children_of_focusable_flexbox__["a" /* default */],
  focusFieldsetDisabled: __WEBPACK_IMPORTED_MODULE_9__focus_fieldset_disabled__["a" /* default */],
  focusFieldset: __WEBPACK_IMPORTED_MODULE_10__focus_fieldset__["a" /* default */],
  focusFlexboxContainer: __WEBPACK_IMPORTED_MODULE_11__focus_flexbox_container__["a" /* default */],
  focusFormDisabled: __WEBPACK_IMPORTED_MODULE_12__focus_form_disabled__["a" /* default */],
  focusImgIsmap: __WEBPACK_IMPORTED_MODULE_13__focus_img_ismap__["a" /* default */],
  focusImgUsemapTabindex: __WEBPACK_IMPORTED_MODULE_14__focus_img_usemap_tabindex__["a" /* default */],
  focusInHiddenIframe: __WEBPACK_IMPORTED_MODULE_15__focus_in_hidden_iframe__["a" /* default */],
  focusInvalidTabindex: __WEBPACK_IMPORTED_MODULE_17__focus_invalid_tabindex__["a" /* default */],
  focusLabelTabindex: __WEBPACK_IMPORTED_MODULE_18__focus_label_tabindex__["a" /* default */],
  focusObjectSvg: __WEBPACK_IMPORTED_MODULE_20__focus_object_svg__["a" /* default */],
  focusObjectSvgHidden: __WEBPACK_IMPORTED_MODULE_19__focus_object_svg_hidden__["a" /* default */],
  focusRedirectImgUsemap: __WEBPACK_IMPORTED_MODULE_22__focus_redirect_img_usemap__["a" /* default */],
  focusRedirectLegend: __WEBPACK_IMPORTED_MODULE_23__focus_redirect_legend__["a" /* default */],
  focusScrollBody: __WEBPACK_IMPORTED_MODULE_24__focus_scroll_body__["a" /* default */],
  focusScrollContainerWithoutOverflow: __WEBPACK_IMPORTED_MODULE_25__focus_scroll_container_without_overflow__["a" /* default */],
  focusScrollContainer: __WEBPACK_IMPORTED_MODULE_26__focus_scroll_container__["a" /* default */],
  focusSummary: __WEBPACK_IMPORTED_MODULE_27__focus_summary__["a" /* default */],
  focusSvgFocusableAttribute: __WEBPACK_IMPORTED_MODULE_28__focus_svg_focusable_attribute__["a" /* default */],
  focusSvgTabindexAttribute: __WEBPACK_IMPORTED_MODULE_29__focus_svg_tabindex_attribute__["a" /* default */],
  focusSvgNegativeTabindexAttribute: __WEBPACK_IMPORTED_MODULE_30__focus_svg_negative_tabindex_attribute__["a" /* default */],
  focusSvgUseTabindex: __WEBPACK_IMPORTED_MODULE_31__focus_svg_use_tabindex__["a" /* default */],
  focusSvgForeignobjectTabindex: __WEBPACK_IMPORTED_MODULE_32__focus_svg_foreignobject_tabindex__["a" /* default */],
  focusSvg: __WEBPACK_IMPORTED_MODULE_34__focus_svg__["a" /* default */],
  focusTabindexTrailingCharacters: __WEBPACK_IMPORTED_MODULE_35__focus_tabindex_trailing_characters__["a" /* default */],
  focusTable: __WEBPACK_IMPORTED_MODULE_36__focus_table__["a" /* default */],
  focusVideoWithoutControls: __WEBPACK_IMPORTED_MODULE_37__focus_video_without_controls__["a" /* default */]
};

function executeTests() {
  var results = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__detect_focus__["a" /* default */])(testDescriptions);
  Object.keys(testCallbacks).forEach(function (key) {
    results[key] = testCallbacks[key]();
  });

  return results;
}

var supportsCache = null;

/* harmony default export */ __webpack_exports__["a"] = (function () {
  if (supportsCache) {
    return supportsCache;
  }

  supportsCache = __WEBPACK_IMPORTED_MODULE_1__supports_cache__["a" /* default */].get();
  if (!supportsCache.time) {
    __WEBPACK_IMPORTED_MODULE_1__supports_cache__["a" /* default */].set(executeTests());
    supportsCache = __WEBPACK_IMPORTED_MODULE_1__supports_cache__["a" /* default */].get();
  }

  return supportsCache;
});
//# sourceMappingURL=supports.js.map

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_platform__ = __webpack_require__(40);



// https://jsbin.com/vafaba/3/edit?html,js,console,output
var result = __WEBPACK_IMPORTED_MODULE_0__util_platform__["a" /* default */].is.GECKO || __WEBPACK_IMPORTED_MODULE_0__util_platform__["a" /* default */].is.TRIDENT || __WEBPACK_IMPORTED_MODULE_0__util_platform__["a" /* default */].is.EDGE;

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return result;
});
//# sourceMappingURL=tabsequence-area-at-img-position.js.map

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// input may be undefined, selector-tring, Node, NodeList, HTMLCollection, array of Nodes
// yes, to some extent this is a bad replica of jQuery's constructor function
/* harmony default export */ __webpack_exports__["a"] = (function (input) {
  if (!input) {
    return [];
  }

  if (Array.isArray(input)) {
    return input;
  }

  // instanceof Node - does not work with iframes
  if (input.nodeType !== undefined) {
    return [input];
  }

  if (typeof input === 'string') {
    input = document.querySelectorAll(input);
  }

  if (input.length !== undefined) {
    return [].slice.call(input, 0);
  }

  throw new TypeError('unexpected input ' + String(input));
});
//# sourceMappingURL=node-array.js.map

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__supports_css_shadow_piercing_deep_combinator__ = __webpack_require__(242);

// convert a CSS selector so that it also pierces ShadowDOM
// takes ".a, #b" and turns it into ".a, #b, html >>> .a, html >>> #b"



var shadowPrefix = void 0;

/* harmony default export */ __webpack_exports__["a"] = (function (selector) {
  if (typeof shadowPrefix !== 'string') {
    var operator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__supports_css_shadow_piercing_deep_combinator__["a" /* default */])();
    if (operator) {
      shadowPrefix = ', html ' + operator + ' ';
    }
  }

  if (!shadowPrefix) {
    return selector;
  }

  return selector + shadowPrefix + selector.replace(/\s*,\s*/g, ',').split(',').join(shadowPrefix);
});
//# sourceMappingURL=select-in-shadows.js.map

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export toggleClass */
/* harmony export (immutable) */ __webpack_exports__["a"] = removeClass;
/* harmony export (immutable) */ __webpack_exports__["b"] = addClass;
//
// This util allows to easily add, remove or toggle classes.
//
// Using it is neccessary as IE 9 doesn't support element classList
// and IE 11 doesn't support classList for SVG elements
// see also https://developer.mozilla.org/en/docs/Web/API/Element/classList
//
// This file is a replacement for domtokenlist because of
// https://github.com/medialize/ally.js/issues/147
//
// Usage:
//
// toggleClass(div, 'demo'); // Toggles the class `demo`
// toggleClass(div, 'demo', true); // Adds the class `demo`
// toggleClass(div, 'demo', false); // removes the class `demo`
//
// removeClass(div, 'demo');
// addClass(div, 'demo');
//

/**
 * Extract an array of all classNames of the given DOM or SVG node
 */
function getClassNames(element) {
  var className = element.getAttribute && element.getAttribute('class') || '';
  return className === '' ? [] : className.split(' ');
}

function toggleClass(element, className, force) {
  var classNames = getClassNames(element);
  var idx = classNames.indexOf(className);
  var hasClass = idx !== -1;
  var shouldHaveClass = force !== undefined ? force : !hasClass;
  // Break if classes are already set/removed
  if (shouldHaveClass === hasClass) {
    return;
  }
  // Remove class
  if (!shouldHaveClass) {
    classNames.splice(idx, 1);
  }
  // Add class
  if (shouldHaveClass) {
    classNames.push(className);
  }
  element.setAttribute('class', classNames.join(' '));
}

function removeClass(element, className) {
  return toggleClass(element, className, false);
}

function addClass(element, className) {
  return toggleClass(element, className, true);
}
//# sourceMappingURL=toggle-class.js.map

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// this file is overwritten by `npm run build:pre`
var version = '1.4.1';
/* harmony default export */ __webpack_exports__["a"] = (version);
//# sourceMappingURL=version.js.map

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * THIS IS A FORK IN ORDER TO PROVIDE A NPM PACKAGE OF IT!
 *
 * ORIGINAL:
 * Copyright © 2016 Ben Kamens | MIT license | https://github.com/kamens/jQuery-menu-aim
 *
 * menu-aim is a jQuery plugin for dropdown menus that can differentiate
 * between a user trying hover over a dropdown item vs trying to navigate into
 * a submenu's contents.
 *
 * menu-aim assumes that you have are using a menu with submenus that expand
 * to the menu's right. It will fire events when the user's mouse enters a new
 * dropdown item *and* when that item is being intentionally hovered over.
 *
 * __________________________
 * | Monkeys  >|   Gorilla  |
 * | Gorillas >|   Content  |
 * | Chimps   >|   Here     |
 * |___________|____________|
 *
 * In the above example, "Gorillas" is selected and its submenu content is
 * being shown on the right. Imagine that the user's cursor is hovering over
 * "Gorillas." When they move their mouse into the "Gorilla Content" area, they
 * may briefly hover over "Chimps." This shouldn't close the "Gorilla Content"
 * area.
 *
 * This problem is normally solved using timeouts and delays. menu-aim tries to
 * solve this by detecting the direction of the user's mouse movement. This can
 * make for quicker transitions when navigating up and down the menu. The
 * experience is hopefully similar to amazon.com/'s "Shop by Department"
 * dropdown.
 *
 * Use like so:
 *
 *      $("#menu").menuAim({
 *          activate: $.noop,  // fired on row activation
 *          deactivate: $.noop  // fired on row deactivation
 *      });
 *
 *  ...to receive events when a menu's row has been purposefully (de)activated.
 *
 * The following options can be passed to menuAim. All functions execute with
 * the relevant row's HTML element as the execution context ('this'):
 *
 *      .menuAim({
 *          // Function to call when a row is purposefully activated. Use this
 *          // to show a submenu's content for the activated row.
 *          activate: function() {},
 *
 *          // Function to call when a row is deactivated.
 *          deactivate: function() {},
 *
 *          // Function to call when mouse enters a menu row. Entering a row
 *          // does not mean the row has been activated, as the user may be
 *          // mousing over to a submenu.
 *          enter: function() {},
 *
 *          // Function to call when mouse exits a menu row.
 *          exit: function() {},
 *
 *          // Selector for identifying which elements in the menu are rows
 *          // that can trigger the above events. Defaults to "> li".
 *          rowSelector: "> li",
 *
 *          // You may have some menu rows that aren't submenus and therefore
 *          // shouldn't ever need to "activate." If so, filter submenu rows w/
 *          // this selector. Defaults to "*" (all elements).
 *          submenuSelector: "*",
 *
 *          // Direction the submenu opens relative to the main menu. Can be
 *          // left, right, above, or below. Defaults to "right".
 *          submenuDirection: "right"
 *      });
 *
*/
(function (factory) {
    if (( false ? 'undefined' : _typeof(exports)) === 'object') {
        factory(__webpack_require__(4));
    } else if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {
        factory(jQuery);
    }
})(function ($) {
    "use strict";

    var MenuAim = function MenuAim(element, options) {
        this.$menu = this.activeRow = this.mouseLocs = this.lastDelayLoc = this.timeoutId = this.options = null;

        this.init(element, options);
    };

    MenuAim.DEFAULTS = {
        rowSelector: "> li",
        submenuSelector: "*",
        submenuDirection: "right",
        tolerance: 75, // bigger = more forgivey when entering submenu
        enter: $.noop,
        exit: $.noop,
        activate: $.noop,
        deactivate: $.noop,
        exitMenu: $.noop
    };

    MenuAim.prototype.getDefaults = function () {
        return MenuAim.DEFAULTS;
    };

    /**
     * Keep track of the last few locations of the mouse.
     */
    MenuAim.prototype.mousemoveDocument = function (e) {
        this.mouseLocs.push({ x: e.pageX, y: e.pageY });

        if (this.mouseLocs.length > this.MOUSE_LOCS_TRACKED) {
            this.mouseLocs.shift();
        }
    };

    /**
     * Cancel possible row activations when leaving the menu entirely
     */
    MenuAim.prototype.mouseleaveMenu = function () {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }

        // If exitMenu is supplied and returns true, deactivate the
        // currently active row on menu exit.
        if (this.options.exitMenu(this)) {
            if (this.activeRow) {
                this.options.deactivate(this.activeRow);
            }

            this.activeRow = null;
        }
    };

    /**
     * Trigger a possible row activation whenever entering a new row.
     */
    MenuAim.prototype.mouseenterRow = function (ev) {
        if (this.timeoutId) {
            // Cancel any previous activation delays
            clearTimeout(this.timeoutId);
        }

        this.options.enter(ev.currentTarget);
        this.possiblyActivate(ev.currentTarget);
    };

    MenuAim.prototype.mouseleaveRow = function (ev) {
        this.options.exit(ev.currentTarget);
    };

    /*
     * Immediately activate a row if the user clicks on it.
     */
    MenuAim.prototype.clickRow = function (ev) {
        this.activate(ev.currentTarget);
    };

    /**
     * Activate a menu row.
     */
    MenuAim.prototype.activate = function (row) {
        if (row == this.activeRow) {
            return;
        }

        if (this.activeRow) {
            this.options.deactivate(this.activeRow);
        }

        this.options.activate(row);
        this.activeRow = row;
    };

    /**
     * Possibly activate a menu row. If mouse movement indicates that we
     * shouldn't activate yet because user may be trying to enter
     * a submenu's content, then delay and check again later.
     */
    MenuAim.prototype.possiblyActivate = function (row) {
        var delay = this.activationDelay(),
            self = this;

        if (delay) {
            this.timeoutId = setTimeout(function () {
                self.possiblyActivate(row);
            }, delay);
        } else {
            this.activate(row);
        }
    };

    /**
     * Return the amount of time that should be used as a delay before the
     * currently hovered row is activated.
     *
     * Returns 0 if the activation should happen immediately. Otherwise,
     * returns the number of milliseconds that should be delayed before
     * checking again to see if the row should be activated.
     */
    MenuAim.prototype.activationDelay = function () {
        if (!this.activeRow || !$(this.activeRow).is(this.options.submenuSelector)) {
            // If there is no other submenu row already active, then
            // go ahead and activate immediately.
            return 0;
        }

        var offset = this.$menu.offset(),
            upperLeft = {
            x: offset.left,
            y: offset.top - this.options.tolerance
        },
            upperRight = {
            x: offset.left + this.$menu.outerWidth(),
            y: upperLeft.y
        },
            lowerLeft = {
            x: offset.left,
            y: offset.top + this.$menu.outerHeight() + this.options.tolerance
        },
            lowerRight = {
            x: offset.left + this.$menu.outerWidth(),
            y: lowerLeft.y
        },
            loc = this.mouseLocs[this.mouseLocs.length - 1],
            prevLoc = this.mouseLocs[0];

        if (!loc) {
            return 0;
        }

        if (!prevLoc) {
            prevLoc = loc;
        }

        if (prevLoc.x < offset.left || prevLoc.x > lowerRight.x || prevLoc.y < offset.top || prevLoc.y > lowerRight.y) {
            // If the previous mouse location was outside of the entire
            // menu's bounds, immediately activate.
            return 0;
        }

        if (this.lastDelayLoc && loc.x == this.lastDelayLoc.x && loc.y == this.lastDelayLoc.y) {
            // If the mouse hasn't moved since the last time we checked
            // for activation status, immediately activate.
            return 0;
        }

        // Detect if the user is moving towards the currently activated
        // submenu.
        //
        // If the mouse is heading relatively clearly towards
        // the submenu's content, we should wait and give the user more
        // time before activating a new row. If the mouse is heading
        // elsewhere, we can immediately activate a new row.
        //
        // We detect this by calculating the slope formed between the
        // current mouse location and the upper/lower right points of
        // the menu. We do the same for the previous mouse location.
        // If the current mouse location's slopes are
        // increasing/decreasing appropriately compared to the
        // previous's, we know the user is moving toward the submenu.
        //
        // Note that since the y-axis increases as the cursor moves
        // down the screen, we are looking for the slope between the
        // cursor and the upper right corner to decrease over time, not
        // increase (somewhat counterintuitively).
        function slope(a, b) {
            return (b.y - a.y) / (b.x - a.x);
        }

        var decreasingCorner = upperRight,
            increasingCorner = lowerRight;

        // Our expectations for decreasing or increasing slope values
        // depends on which direction the submenu opens relative to the
        // main menu. By default, if the menu opens on the right, we
        // expect the slope between the cursor and the upper right
        // corner to decrease over time, as explained above. If the
        // submenu opens in a different direction, we change our slope
        // expectations.
        if (this.options.submenuDirection == "left") {
            decreasingCorner = lowerLeft;
            increasingCorner = upperLeft;
        } else if (this.options.submenuDirection == "below") {
            decreasingCorner = lowerRight;
            increasingCorner = lowerLeft;
        } else if (this.options.submenuDirection == "above") {
            decreasingCorner = upperLeft;
            increasingCorner = upperRight;
        }

        var decreasingSlope = slope(loc, decreasingCorner),
            increasingSlope = slope(loc, increasingCorner),
            prevDecreasingSlope = slope(prevLoc, decreasingCorner),
            prevIncreasingSlope = slope(prevLoc, increasingCorner);

        if (decreasingSlope < prevDecreasingSlope && increasingSlope > prevIncreasingSlope) {
            // Mouse is moving from previous location towards the
            // currently activated submenu. Delay before activating a
            // new menu row, because user may be moving into submenu.
            this.lastDelayLoc = loc;
            return this.DELAY;
        }

        this.lastDelayLoc = null;
        return 0;
    };

    MenuAim.prototype.destroy = function () {
        this.$menu.removeData("jquery.menu-aim");

        this.$menu.off(".menu-aim").find(this.options.rowSelector).off(".menu-aim");

        $(document).off(".menu-aim");
    };

    MenuAim.prototype.reset = function (triggerDeactivate) {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }

        if (this.activeRow && triggerDeactivate) {
            this.options.deactivate(this.activeRow);
        }

        this.activeRow = null;
    };

    MenuAim.prototype.init = function (element, option) {
        this.$menu = $(element);
        this.activeRow = null;
        this.mouseLocs = [];
        this.lastDelayLoc = null;
        this.timeoutId = null;
        this.options = $.extend({}, this.getDefaults(), option);

        this.MOUSE_LOCS_TRACKED = 3; // number of past mouse locations to track
        this.DELAY = 300; // ms delay when user appears to be entering submenu

        /**
         * Hook up initial menu events
         */

        this.$menu.on("mouseleave.menu-aim", $.proxy(this.mouseleaveMenu, this)).find(this.options.rowSelector).on("mouseenter.menu-aim", $.proxy(this.mouseenterRow, this)).on("mouseleave.menu-aim", $.proxy(this.mouseleaveRow, this)).on("click.menu-aim", $.proxy(this.clickRow, this));

        $(document).on("mousemove.menu-aim", $.proxy(this.mousemoveDocument, this));
    };

    $.fn.menuAim = function (opts) {
        return this.each(function () {
            var $this = $(this),
                data = $this.data("jquery.menu-aim"),
                options = (typeof opts === 'undefined' ? 'undefined' : _typeof(opts)) == "object" && opts;

            if (!data) {
                $this.data("jquery.menu-aim", data = new MenuAim(this, options));
            }

            if (typeof opts == "string") {
                data[opts]();
            }
        });
    };
});

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PlayerBridge = function () {
    function PlayerBridge() {
        _classCallCheck(this, PlayerBridge);
    }

    _createClass(PlayerBridge, [{
        key: "setImplementation",
        value: function setImplementation(implementation) {
            this._implementation = implementation;
        }
    }, {
        key: "initPlayer",
        value: function initPlayer(options) {
            this._implementation.initPlayer(options);
        }
    }, {
        key: "play",
        value: function play() {
            this._implementation.play();
        }
    }, {
        key: "stop",
        value: function stop() {
            this._implementation.stop();
        }
    }, {
        key: "getDuration",
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this._implementation.getDuration();

                            case 2:
                                return _context.abrupt("return", _context.sent);

                            case 3:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function getDuration() {
                return _ref.apply(this, arguments);
            }

            return getDuration;
        }()
    }]);

    return PlayerBridge;
}();

exports.default = PlayerBridge;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _player = __webpack_require__(518);

var _player2 = _interopRequireDefault(_player);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VimeoWrapper = function () {
    function VimeoWrapper() {
        _classCallCheck(this, VimeoWrapper);
    }

    _createClass(VimeoWrapper, [{
        key: "initPlayer",
        value: function initPlayer(options) {
            this.videoUrl = options.videoUrl.replace(/[\u200B-\u200D\uFEFF]/g, '');
            this.metaEndpoint = 'https://vimeo.com/api/oembed.json';
            this.player = new _player2.default(options.videoNode, { id: options.videoId });

            this.player.ready().then(function () {
                options.onReadyCallback();
            });

            this.player.on('play', function () {
                options.onPlayCallback();
            });
        }
    }, {
        key: "play",
        value: function play() {
            this.player.play();
        }
    }, {
        key: "stop",
        value: function stop() {
            this.player.pause();
        }
    }, {
        key: "getDuration",
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var videoUrl, request, result;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                videoUrl = encodeURIComponent(this.videoUrl);
                                request = this.metaEndpoint + "?url=" + videoUrl;
                                _context.next = 4;
                                return _jquery2.default.get(request);

                            case 4:
                                result = _context.sent;
                                return _context.abrupt("return", result.duration);

                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function getDuration() {
                return _ref.apply(this, arguments);
            }

            return getDuration;
        }()
    }]);

    return VimeoWrapper;
}();

exports.default = VimeoWrapper;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _youtubePlayer = __webpack_require__(806);

var _youtubePlayer2 = _interopRequireDefault(_youtubePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var YoutubeWrapper = function () {
    function YoutubeWrapper() {
        _classCallCheck(this, YoutubeWrapper);
    }

    _createClass(YoutubeWrapper, [{
        key: 'initPlayer',
        value: function initPlayer(options) {
            this.player = (0, _youtubePlayer2.default)(options.videoNode, {
                videoId: options.videoId,
                playerVars: { rel: 0 }
            });

            this.player.on('ready', options.onReadyCallback);

            this.player.on('stateChange', function (event) {
                if (event.data === YT.PlayerState.BUFFERING || event.data === YT.PlayerState.PLAYING) {
                    options.onPlayCallback();
                }
            });
        }
    }, {
        key: 'play',
        value: function play() {
            this.player.playVideo();
        }
    }, {
        key: 'stop',
        value: function stop() {
            this.player.stopVideo();
        }
    }, {
        key: 'getDuration',
        value: function getDuration() {
            // not needed for youtube
        }
    }]);

    return YoutubeWrapper;
}();

exports.default = YoutubeWrapper;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VideoHelpers = function () {
    function VideoHelpers() {
        _classCallCheck(this, VideoHelpers);
    }

    _createClass(VideoHelpers, null, [{
        key: "getFomattedDuration",
        value: function getFomattedDuration(durationSeconds) {
            var minutes = Math.floor(durationSeconds / 60);
            var seconds = durationSeconds - minutes * 60;

            return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
        }
    }, {
        key: "parseYoutubeId",
        value: function parseYoutubeId(url) {
            var ID = '';
            url = url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
            if (url[2] !== undefined) {
                ID = url[2].split(/[^0-9a-z_\-]/i);
                ID = ID[0];
            }

            return ID;
        }
    }, {
        key: "parseVimeoId",
        value: function parseVimeoId(url) {
            var id = url.match(/\/\/[^\/]+\/([^\.]+)/)[1];
            if (typeof id === 'string') {
                id = id.split('/')[0];
            }
            return id;
        }
    }]);

    return VideoHelpers;
}();

exports.default = VideoHelpers;

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseUrl = exports.parents = exports.matches = exports.getAttributes = exports.dispatch = exports.delegate = exports.closest = undefined;

var _closest = __webpack_require__(245);

var _closest2 = _interopRequireDefault(_closest);

var _delegate = __webpack_require__(577);

var _delegate2 = _interopRequireDefault(_delegate);

var _dispatch = __webpack_require__(578);

var _dispatch2 = _interopRequireDefault(_dispatch);

var _getAttributes = __webpack_require__(579);

var _getAttributes2 = _interopRequireDefault(_getAttributes);

var _matches = __webpack_require__(209);

var _matches2 = _interopRequireDefault(_matches);

var _parents = __webpack_require__(246);

var _parents2 = _interopRequireDefault(_parents);

var _parseUrl = __webpack_require__(580);

var _parseUrl2 = _interopRequireDefault(_parseUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.closest = _closest2.default;
exports.delegate = _delegate2.default;
exports.dispatch = _dispatch2.default;
exports.getAttributes = _getAttributes2.default;
exports.matches = _matches2.default;
exports.parents = _parents2.default;
exports.parseUrl = _parseUrl2.default;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = delegate;

var _closest = __webpack_require__(245);

var _closest2 = _interopRequireDefault(_closest);

var _matches = __webpack_require__(209);

var _matches2 = _interopRequireDefault(_matches);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Delegates the handling of events for an element matching a selector to an
 * ancestor of the matching element.
 * @param {!Node} ancestor The ancestor element to add the listener to.
 * @param {string} eventType The event type to listen to.
 * @param {string} selector A CSS selector to match against child elements.
 * @param {!Function} callback A function to run any time the event happens.
 * @param {Object=} opts A configuration options object. The available options:
 *     - useCapture<boolean>: If true, bind to the event capture phase.
 *     - deep<boolean>: If true, delegate into shadow trees.
 * @return {Object} The delegate object. It contains a destroy method.
 */
function delegate(ancestor, eventType, selector, callback) {
  var opts = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  // Defines the event listener.
  var listener = function listener(event) {
    var delegateTarget = void 0;

    // If opts.composed is true and the event originated from inside a Shadow
    // tree, check the composed path nodes.
    if (opts.composed && typeof event.composedPath == 'function') {
      var composedPath = event.composedPath();
      for (var i = 0, node; node = composedPath[i]; i++) {
        if (node.nodeType == 1 && (0, _matches2.default)(node, selector)) {
          delegateTarget = node;
        }
      }
    } else {
      // Otherwise check the parents.
      delegateTarget = (0, _closest2.default)(event.target, selector, true);
    }

    if (delegateTarget) {
      callback.call(delegateTarget, event, delegateTarget);
    }
  };

  ancestor.addEventListener(eventType, listener, opts.useCapture);

  return {
    destroy: function destroy() {
      ancestor.removeEventListener(eventType, listener, opts.useCapture);
    }
  };
}

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = dispatch;
/**
 * Dispatches an event on the passed element.
 * @param {!Element} element The DOM element to dispatch the event on.
 * @param {string} eventType The type of event to dispatch.
 * @param {Object|string=} eventName A string name of the event constructor
 *     to use. Defaults to 'Event' if nothing is passed or 'CustomEvent' if
 *     a value is set on `initDict.detail`. If eventName is given an object
 *     it is assumed to be initDict and thus reassigned.
 * @param {Object=} initDict The initialization attributes for the
 *     event. A `detail` property can be used here to pass custom data.
 * @return {boolean} The return value of `element.dispatchEvent`, which will
 *     be false if any of the event listeners called `preventDefault`.
 */
function dispatch(element, eventType) {
  var eventName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Event';
  var initDict = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var event = void 0;
  var isCustom = void 0;

  // eventName is optional
  if ((typeof eventName === 'undefined' ? 'undefined' : _typeof(eventName)) == 'object') {
    initDict = eventName;
    eventName = 'Event';
  }

  initDict.bubbles = initDict.bubbles || false;
  initDict.cancelable = initDict.cancelable || false;
  initDict.composed = initDict.composed || false;

  // If a detail property is passed, this is a custom event.
  if ('detail' in initDict) isCustom = true;
  eventName = isCustom ? 'CustomEvent' : eventName;

  // Tries to create the event using constructors, if that doesn't work,
  // fallback to `document.createEvent()`.
  try {
    event = new window[eventName](eventType, initDict);
  } catch (err) {
    event = document.createEvent(eventName);
    var initMethod = 'init' + (isCustom ? 'Custom' : '') + 'Event';
    event[initMethod](eventType, initDict.bubbles, initDict.cancelable, initDict.detail);
  }

  return element.dispatchEvent(event);
}

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getAttributes;
/**
 * Gets all attributes of an element as a plain JavaScriot object.
 * @param {Element} element The element whose attributes to get.
 * @return {!Object} An object whose keys are the attribute keys and whose
 *     values are the attribute values. If no attributes exist, an empty
 *     object is returned.
 */
function getAttributes(element) {
  var attrs = {};

  // Validate input.
  if (!(element && element.nodeType == 1)) return attrs;

  // Return an empty object if there are no attributes.
  var map = element.attributes;
  if (map.length === 0) return {};

  for (var i = 0, attr; attr = map[i]; i++) {
    attrs[attr.name] = attr.value;
  }
  return attrs;
}

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parseUrl;
var HTTP_PORT = '80';
var HTTPS_PORT = '443';
var DEFAULT_PORT = RegExp(':(' + HTTP_PORT + '|' + HTTPS_PORT + ')$');

var a = document.createElement('a');
var cache = {};

/**
 * Parses the given url and returns an object mimicing a `Location` object.
 * @param {string} url The url to parse.
 * @return {!Object} An object with the same properties as a `Location`.
 */
function parseUrl(url) {
  // All falsy values (as well as ".") should map to the current URL.
  url = !url || url == '.' ? location.href : url;

  if (cache[url]) return cache[url];

  a.href = url;

  // When parsing file relative paths (e.g. `../index.html`), IE will correctly
  // resolve the `href` property but will keep the `..` in the `path` property.
  // It will also not include the `host` or `hostname` properties. Furthermore,
  // IE will sometimes return no protocol or just a colon, especially for things
  // like relative protocol URLs (e.g. "//google.com").
  // To workaround all of these issues, we reparse with the full URL from the
  // `href` property.
  if (url.charAt(0) == '.' || url.charAt(0) == '/') return parseUrl(a.href);

  // Don't include default ports.
  var port = a.port == HTTP_PORT || a.port == HTTPS_PORT ? '' : a.port;

  // PhantomJS sets the port to "0" when using the file: protocol.
  port = port == '0' ? '' : port;

  // Sometimes IE incorrectly includes a port for default ports
  // (e.g. `:80` or `:443`) even when no port is specified in the URL.
  // http://bit.ly/1rQNoMg
  var host = a.host.replace(DEFAULT_PORT, '');

  // Not all browser support `origin` so we have to build it.
  var origin = a.origin ? a.origin : a.protocol + '//' + host;

  // Sometimes IE doesn't include the leading slash for pathname.
  // http://bit.ly/1rQNoMg
  var pathname = a.pathname.charAt(0) == '/' ? a.pathname : '/' + a.pathname;

  return cache[url] = {
    hash: a.hash,
    host: host,
    hostname: a.hostname,
    href: a.href,
    origin: origin,
    pathname: pathname,
    port: port,
    protocol: a.protocol,
    search: a.search
  };
}

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _snappy = __webpack_require__(5);

var _snappy2 = _interopRequireDefault(_snappy);

var _objectFitImages = __webpack_require__(62);

var _objectFitImages2 = _interopRequireDefault(_objectFitImages);

__webpack_require__(17);

__webpack_require__(32);

__webpack_require__(515);

var _cwmCarousel = __webpack_require__(462);

var _cwmCarousel2 = _interopRequireDefault(_cwmCarousel);

var _cwmCarouselGlide = __webpack_require__(460);

var _cwmCarouselGlide2 = _interopRequireDefault(_cwmCarouselGlide);

var _cwmCarouselImageGallery = __webpack_require__(461);

var _cwmCarouselImageGallery2 = _interopRequireDefault(_cwmCarouselImageGallery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _objectFitImages2.default)(document.querySelectorAll('img:not(.lazyload)'));

__webpack_require__(57);
__webpack_require__(58);
__webpack_require__(60);
__webpack_require__(59);
__webpack_require__(61);
__webpack_require__(56);

__webpack_require__(238);
__webpack_require__(423);
__webpack_require__(424);
__webpack_require__(45);
__webpack_require__(46);
__webpack_require__(425);
__webpack_require__(47);
__webpack_require__(426);
__webpack_require__(427);
__webpack_require__(428);
__webpack_require__(429);
__webpack_require__(431);
__webpack_require__(432);
__webpack_require__(433);
__webpack_require__(434);
__webpack_require__(435);
__webpack_require__(48);
__webpack_require__(471);
__webpack_require__(472);
__webpack_require__(49);
__webpack_require__(473);
__webpack_require__(50);
__webpack_require__(474);
__webpack_require__(51);
__webpack_require__(475);
__webpack_require__(476);
__webpack_require__(52);
__webpack_require__(477);
__webpack_require__(478);
__webpack_require__(479);
__webpack_require__(480);
__webpack_require__(481);
__webpack_require__(53);
__webpack_require__(482);
__webpack_require__(483);
__webpack_require__(484);
__webpack_require__(485);
__webpack_require__(486);
__webpack_require__(54);
__webpack_require__(487);
__webpack_require__(488);
__webpack_require__(55);
__webpack_require__(496);
__webpack_require__(497);
__webpack_require__(498);
__webpack_require__(499);
__webpack_require__(502);
__webpack_require__(500);
__webpack_require__(503);
__webpack_require__(506);
__webpack_require__(509);
__webpack_require__(510);
__webpack_require__(507);
__webpack_require__(508);
__webpack_require__(436);
__webpack_require__(437);
__webpack_require__(430);
__webpack_require__(505);
__webpack_require__(504);
__webpack_require__(469);
__webpack_require__(456);
__webpack_require__(457);
__webpack_require__(463);
__webpack_require__(465);
__webpack_require__(459);
__webpack_require__(458);
__webpack_require__(451);
__webpack_require__(450);
__webpack_require__(467);
__webpack_require__(449);
__webpack_require__(454);
__webpack_require__(470);
__webpack_require__(468);
__webpack_require__(466);
__webpack_require__(446);
__webpack_require__(447);
__webpack_require__(445);
__webpack_require__(444);
__webpack_require__(455);
__webpack_require__(453);
__webpack_require__(443);
__webpack_require__(448);
__webpack_require__(452);
__webpack_require__(464);
__webpack_require__(442);
__webpack_require__(438);
__webpack_require__(439);
__webpack_require__(422);
__webpack_require__(501);
__webpack_require__(441);
__webpack_require__(440);

// CAROUSEL

var carouselElements = document.querySelectorAll('[data-behavior="carousel"]');
if (carouselElements) {
    carouselElements.forEach(function (carouselElement) {
        return (0, _cwmCarousel2.default)({ carouselElement: carouselElement });
    });
}

// CAROUSEL GLIDE
var carouselGlideObject = document.querySelectorAll('[data-behavior="carousel-glide"]');

if (carouselGlideObject) {
    carouselGlideObject.forEach(function (carouselGlideElement) {
        return (0, _cwmCarouselGlide2.default)({ carouselGlideElement: carouselGlideElement });
    });
}

// Image Gallery
var imageGalleryObject = document.querySelectorAll('[data-behavior="carousel-image-gallery"]');

if (imageGalleryObject) {
    imageGalleryObject.forEach(function (imageGalleryElement) {
        return (0, _cwmCarouselImageGallery2.default)({ imageGalleryElement: imageGalleryElement });
    });
}

_snappy2.default.init();

var files = __webpack_require__(44);
files.keys().forEach(files);

/***/ }),
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(786);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = __webpack_require__.i({"NODE_ENV":"production"}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(419)))

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(793);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* @preserve
    _____ __ _     __                _
   / ___// /(_)___/ /___  ____      (_)___
  / (_ // // // _  // -_)/ __/_    / /(_-<
  \___//_//_/ \_,_/ \__//_/  (_)__/ //___/
                              |___/

  Version: 1.7.4
  Author: Nick Piscitelli (pickykneee)
  Website: https://nickpiscitelli.com
  Documentation: http://nickpiscitelli.github.io/Glider.js
  License: MIT License
  Release Date: October 25th, 2018

*/

/* global define */

(function (factory) {
   true
    ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    : typeof exports === 'object'
      ? (module.exports = factory())
      : factory()
})(function () {
  ('use strict') // eslint-disable-line no-unused-expressions

  /* globals window:true */
  var _window = typeof window !== 'undefined' ? window : this

  var Glider = (_window.Glider = function (element, settings) {
    var _ = this

    if (element._glider) return element._glider

    _.ele = element
    _.ele.classList.add('glider')

    // expose glider object to its DOM element
    _.ele._glider = _

    // merge user setting with defaults
    _.opt = Object.assign(
      {},
      {
        slidesToScroll: 1,
        slidesToShow: 1,
        resizeLock: true,
        duration: 0.5,
        // easeInQuad
        easing: function (x, t, b, c, d) {
          return c * (t /= d) * t + b
        }
      },
      settings
    )

    // set defaults
    _.animate_id = _.page = _.slide = 0
    _.arrows = {}

    // preserve original options to
    // extend breakpoint settings
    _._opt = _.opt

    if (_.opt.skipTrack) {
      // first and only child is the track
      _.track = _.ele.children[0]
    } else {
      // create track and wrap slides
      _.track = document.createElement('div')
      _.ele.appendChild(_.track)
      while (_.ele.children.length !== 1) {
        _.track.appendChild(_.ele.children[0])
      }
    }

    _.track.classList.add('glider-track')

    // start glider
    _.init()

    // set events
    _.resize = _.init.bind(_, true)
    _.event(_.ele, 'add', {
      scroll: _.updateControls.bind(_)
    })
    _.event(_window, 'add', {
      resize: _.resize
    })
  })

  var gliderPrototype = Glider.prototype
  gliderPrototype.init = function (refresh, paging) {
    var _ = this

    var width = 0

    var height = 0

    _.slides = _.track.children;

    [].forEach.call(_.slides, function (_, i) {
      _.classList.add('glider-slide')
      _.setAttribute('data-gslide', i)
    })

    _.containerWidth = _.ele.clientWidth

    var breakpointChanged = _.settingsBreakpoint()
    if (!paging) paging = breakpointChanged

    if (
      _.opt.slidesToShow === 'auto' ||
      typeof _.opt._autoSlide !== 'undefined'
    ) {
      var slideCount = _.containerWidth / _.opt.itemWidth

      _.opt._autoSlide = _.opt.slidesToShow = _.opt.exactWidth
        ? slideCount
        : Math.max(1, Math.floor(slideCount))
    }
    if (_.opt.slidesToScroll === 'auto') {
      _.opt.slidesToScroll = Math.floor(_.opt.slidesToShow)
    }

    _.itemWidth = _.opt.exactWidth
      ? _.opt.itemWidth
      : _.containerWidth / _.opt.slidesToShow;

    // set slide dimensions
    [].forEach.call(_.slides, function (__) {
      __.style.height = 'auto'
      __.style.width = _.itemWidth + 'px'
      width += _.itemWidth
      height = Math.max(__.offsetHeight, height)
    })

    _.track.style.width = width + 'px'
    _.trackWidth = width
    _.isDrag = false
    _.preventClick = false

    _.opt.resizeLock && _.scrollTo(_.slide * _.itemWidth, 0)

    if (breakpointChanged || paging) {
      _.bindArrows()
      _.buildDots()
      _.bindDrag()
    }

    _.updateControls()

    _.emit(refresh ? 'refresh' : 'loaded')
  }

  gliderPrototype.bindDrag = function () {
    var _ = this
    _.mouse = _.mouse || _.handleMouse.bind(_)

    var mouseup = function () {
      _.mouseDown = undefined
      _.ele.classList.remove('drag')
      if (_.isDrag) {
        _.preventClick = true
      }
      _.isDrag = false
    }

    var events = {
      mouseup: mouseup,
      mouseleave: mouseup,
      mousedown: function (e) {
        e.preventDefault()
        e.stopPropagation()
        _.mouseDown = e.clientX
        _.ele.classList.add('drag')
      },
      mousemove: _.mouse,
      click: function (e) {
        if (_.preventClick) {
          e.preventDefault()
          e.stopPropagation()
        }
        _.preventClick = false
      }
    }

    _.ele.classList.toggle('draggable', _.opt.draggable === true)
    _.event(_.ele, 'remove', events)
    if (_.opt.draggable) _.event(_.ele, 'add', events)
  }

  gliderPrototype.buildDots = function () {
    var _ = this

    if (!_.opt.dots) {
      if (_.dots) _.dots.innerHTML = ''
      return
    }

    if (typeof _.opt.dots === 'string') {
      _.dots = document.querySelector(_.opt.dots)
    } else _.dots = _.opt.dots
    if (!_.dots) return

    _.dots.innerHTML = ''
    _.dots.classList.add('glider-dots')

    for (var i = 0; i < Math.ceil(_.slides.length / _.opt.slidesToShow); ++i) {
      var dot = document.createElement('button')
      dot.dataset.index = i
      dot.setAttribute('aria-label', 'Page ' + (i + 1))
      dot.setAttribute('role', 'tab')
      dot.className = 'glider-dot ' + (i ? '' : 'active')
      _.event(dot, 'add', {
        click: _.scrollItem.bind(_, i, true)
      })
      _.dots.appendChild(dot)
    }
  }

  gliderPrototype.bindArrows = function () {
    var _ = this
    if (!_.opt.arrows) {
      Object.keys(_.arrows).forEach(function (direction) {
        var element = _.arrows[direction]
        _.event(element, 'remove', { click: element._func })
      })
      return
    }
    ['prev', 'next'].forEach(function (direction) {
      var arrow = _.opt.arrows[direction]
      if (arrow) {
        if (typeof arrow === 'string') arrow = document.querySelector(arrow)
        if (arrow) {
          arrow._func = arrow._func || _.scrollItem.bind(_, direction)
          _.event(arrow, 'remove', {
            click: arrow._func
          })
          _.event(arrow, 'add', {
            click: arrow._func
          })
          _.arrows[direction] = arrow
        }
      }
    })
  }

  gliderPrototype.updateControls = function (event) {
    var _ = this

    if (event && !_.opt.scrollPropagate) {
      event.stopPropagation()
    }

    var disableArrows = _.containerWidth >= _.trackWidth

    if (!_.opt.rewind) {
      if (_.arrows.prev) {
        _.arrows.prev.classList.toggle(
          'disabled',
          _.ele.scrollLeft <= 0 || disableArrows
        )
        _.arrows.prev.classList.contains('disabled')
          ? _.arrows.prev.setAttribute('aria-disabled', true)
          : _.arrows.prev.setAttribute('aria-disabled', false)
      }
      if (_.arrows.next) {
        _.arrows.next.classList.toggle(
          'disabled',
          Math.ceil(_.ele.scrollLeft + _.containerWidth) >=
            Math.floor(_.trackWidth) || disableArrows
        )
        _.arrows.next.classList.contains('disabled')
          ? _.arrows.next.setAttribute('aria-disabled', true)
          : _.arrows.next.setAttribute('aria-disabled', false)
      }
    }

    _.slide = Math.round(_.ele.scrollLeft / _.itemWidth)
    _.page = Math.round(_.ele.scrollLeft / _.containerWidth)

    var middle = _.slide + Math.floor(Math.floor(_.opt.slidesToShow) / 2)

    var extraMiddle = Math.floor(_.opt.slidesToShow) % 2 ? 0 : middle + 1
    if (Math.floor(_.opt.slidesToShow) === 1) {
      extraMiddle = 0
    }

    // the last page may be less than one half of a normal page width so
    // the page is rounded down. when at the end, force the page to turn
    if (_.ele.scrollLeft + _.containerWidth >= Math.floor(_.trackWidth)) {
      _.page = _.dots ? _.dots.children.length - 1 : 0
    }

    [].forEach.call(_.slides, function (slide, index) {
      var slideClasses = slide.classList

      var wasVisible = slideClasses.contains('visible')

      var start = _.ele.scrollLeft

      var end = _.ele.scrollLeft + _.containerWidth

      var itemStart = _.itemWidth * index

      var itemEnd = itemStart + _.itemWidth;

      [].forEach.call(slideClasses, function (className) {
        /^left|right/.test(className) && slideClasses.remove(className)
      })
      slideClasses.toggle('active', _.slide === index)
      if (middle === index || (extraMiddle && extraMiddle === index)) {
        slideClasses.add('center')
      } else {
        slideClasses.remove('center')
        slideClasses.add(
          [
            index < middle ? 'left' : 'right',
            Math.abs(index - (index < middle ? middle : extraMiddle || middle))
          ].join('-')
        )
      }

      var isVisible =
        Math.ceil(itemStart) >= Math.floor(start) &&
        Math.floor(itemEnd) <= Math.ceil(end)
      slideClasses.toggle('visible', isVisible)
      if (isVisible !== wasVisible) {
        _.emit('slide-' + (isVisible ? 'visible' : 'hidden'), {
          slide: index
        })
      }
    })
    if (_.dots) {
      [].forEach.call(_.dots.children, function (dot, index) {
        dot.classList.toggle('active', _.page === index)
      })
    }

    if (event && _.opt.scrollLock) {
      clearTimeout(_.scrollLock)
      _.scrollLock = setTimeout(function () {
        clearTimeout(_.scrollLock)
        // dont attempt to scroll less than a pixel fraction - causes looping
        if (Math.abs(_.ele.scrollLeft / _.itemWidth - _.slide) > 0.02) {
          if (!_.mouseDown) {
            // Only scroll if not at the end (#94)
            if (_.trackWidth > _.containerWidth + _.ele.scrollLeft) {
              _.scrollItem(_.getCurrentSlide())
            }
          }
        }
      }, _.opt.scrollLockDelay || 250)
    }
  }

  gliderPrototype.getCurrentSlide = function () {
    var _ = this
    return _.round(_.ele.scrollLeft / _.itemWidth)
  }

  gliderPrototype.scrollItem = function (slide, dot, e) {
    if (e) e.preventDefault()

    var _ = this

    var originalSlide = slide
    ++_.animate_id

    if (dot === true) {
      slide = slide * _.containerWidth
      slide = Math.round(slide / _.itemWidth) * _.itemWidth
    } else {
      if (typeof slide === 'string') {
        var backwards = slide === 'prev'

        // use precise location if fractional slides are on
        if (_.opt.slidesToScroll % 1 || _.opt.slidesToShow % 1) {
          slide = _.getCurrentSlide()
        } else {
          slide = _.slide
        }

        if (backwards) slide -= _.opt.slidesToScroll
        else slide += _.opt.slidesToScroll

        if (_.opt.rewind) {
          var scrollLeft = _.ele.scrollLeft
          slide =
            backwards && !scrollLeft
              ? _.slides.length
              : !backwards &&
                scrollLeft + _.containerWidth >= Math.floor(_.trackWidth)
                ? 0
                : slide
        }
      }

      slide = Math.max(Math.min(slide, _.slides.length), 0)

      _.slide = slide
      slide = _.itemWidth * slide
    }

    _.scrollTo(
      slide,
      _.opt.duration * Math.abs(_.ele.scrollLeft - slide),
      function () {
        _.updateControls()
        _.emit('animated', {
          value: originalSlide,
          type:
            typeof originalSlide === 'string' ? 'arrow' : dot ? 'dot' : 'slide'
        })
      }
    )

    return false
  }

  gliderPrototype.settingsBreakpoint = function () {
    var _ = this

    var resp = _._opt.responsive

    if (resp) {
      // Sort the breakpoints in mobile first order
      resp.sort(function (a, b) {
        return b.breakpoint - a.breakpoint
      })

      for (var i = 0; i < resp.length; ++i) {
        var size = resp[i]
        if (_window.innerWidth >= size.breakpoint) {
          if (_.breakpoint !== size.breakpoint) {
            _.opt = Object.assign({}, _._opt, size.settings)
            _.breakpoint = size.breakpoint
            return true
          }
          return false
        }
      }
    }
    // set back to defaults in case they were overriden
    var breakpointChanged = _.breakpoint !== 0
    _.opt = Object.assign({}, _._opt)
    _.breakpoint = 0
    return breakpointChanged
  }

  gliderPrototype.scrollTo = function (scrollTarget, scrollDuration, callback) {
    var _ = this

    var start = new Date().getTime()

    var animateIndex = _.animate_id

    var animate = function () {
      var now = new Date().getTime() - start
      _.ele.scrollLeft =
        _.ele.scrollLeft +
        (scrollTarget - _.ele.scrollLeft) *
          _.opt.easing(0, now, 0, 1, scrollDuration)
      if (now < scrollDuration && animateIndex === _.animate_id) {
        _window.requestAnimationFrame(animate)
      } else {
        _.ele.scrollLeft = scrollTarget
        callback && callback.call(_)
      }
    }

    _window.requestAnimationFrame(animate)
  }

  gliderPrototype.removeItem = function (index) {
    var _ = this

    if (_.slides.length) {
      _.track.removeChild(_.slides[index])
      _.refresh(true)
      _.emit('remove')
    }
  }

  gliderPrototype.addItem = function (ele) {
    var _ = this

    _.track.appendChild(ele)
    _.refresh(true)
    _.emit('add')
  }

  gliderPrototype.handleMouse = function (e) {
    var _ = this
    if (_.mouseDown) {
      _.isDrag = true
      _.ele.scrollLeft +=
        (_.mouseDown - e.clientX) * (_.opt.dragVelocity || 3.3)
      _.mouseDown = e.clientX
    }
  }

  // used to round to the nearest 0.XX fraction
  gliderPrototype.round = function (double) {
    var _ = this
    var step = _.opt.slidesToScroll % 1 || 1
    var inv = 1.0 / step
    return Math.round(double * inv) / inv
  }

  gliderPrototype.refresh = function (paging) {
    var _ = this
    _.init(true, paging)
  }

  gliderPrototype.setOption = function (opt, global) {
    var _ = this

    if (_.breakpoint && !global) {
      _._opt.responsive.forEach(function (v) {
        if (v.breakpoint === _.breakpoint) {
          v.settings = Object.assign({}, v.settings, opt)
        }
      })
    } else {
      _._opt = Object.assign({}, _._opt, opt)
    }

    _.breakpoint = 0
    _.settingsBreakpoint()
  }

  gliderPrototype.destroy = function () {
    var _ = this

    var replace = _.ele.cloneNode(true)

    var clear = function (ele) {
      ele.removeAttribute('style');
      [].forEach.call(ele.classList, function (className) {
        /^glider/.test(className) && ele.classList.remove(className)
      })
    }
    // remove track
    replace.children[0].outerHTML = replace.children[0].innerHTML
    clear(replace);
    [].forEach.call(replace.getElementsByTagName('*'), clear)
    _.ele.parentNode.replaceChild(replace, _.ele)
    _.event(_window, 'remove', {
      resize: _.resize
    })
    _.emit('destroy')
  }

  gliderPrototype.emit = function (name, arg) {
    var _ = this

    var e = new _window.CustomEvent('glider-' + name, {
      bubbles: !_.opt.eventPropagate,
      detail: arg
    })
    _.ele.dispatchEvent(e)
  }

  gliderPrototype.event = function (ele, type, args) {
    var eventHandler = ele[type + 'EventListener'].bind(ele)
    Object.keys(args).forEach(function (k) {
      eventHandler(k, args[k])
    })
  }

  return Glider
})


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license jquery.panzoom.js v3.2.2
 * Updated: Wed May 08 2019
 * Add pan and zoom functionality to any element
 * Copyright (c) timmy willison
 * Released under the MIT license
 * https://github.com/timmywil/jquery.panzoom/blob/master/MIT-License.txt
 */

(function(global, factory) {
	// AMD
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(4) ], __WEBPACK_AMD_DEFINE_RESULT__ = function(jQuery) {
			return factory(global, jQuery);
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	// CommonJS/Browserify
	} else if (typeof exports === 'object') {
		factory(global, require('jquery'));
	// Global
	} else {
		factory(global, global.jQuery);
	}
}(typeof window !== 'undefined' ? window : this, function(window, $) {
	'use strict';

	var document = window.document;
	var datakey = '__pz__';
	var slice = Array.prototype.slice;
	var rIE11 = /trident\/7./i;
	var supportsInputEvent = (function() {
		// IE11 returns a false positive
		if (rIE11.test(navigator.userAgent)) {
			return false;
		}
		var input = document.createElement('input');
		input.setAttribute('oninput', 'return');
		return typeof input.oninput === 'function';
	})();

	// Regex
	var rupper = /([A-Z])/g;
	var rsvg = /^http:[\w\.\/]+svg$/;

	var floating = '(\\-?\\d[\\d\\.e-]*)';
	var commaSpace = '\\,?\\s*';
	var rmatrix = new RegExp(
		'^matrix\\(' +
		floating + commaSpace +
		floating + commaSpace +
		floating + commaSpace +
		floating + commaSpace +
		floating + commaSpace +
		floating + '\\)$'
	);

	/**
	 * Utility for determining transform matrix equality
	 * Checks backwards to test translation first
	 * @param {Array} first
	 * @param {Array} second
	 */
	function matrixEquals(first, second) {
		var i = first.length;
		while(--i) {
			if (Math.round(+first[i]) !== Math.round(+second[i])) {
				return false;
			}
		}
		return true;
	}

	/**
	 * Creates the options object for reset functions
	 * @param {Boolean|Object} opts See reset methods
	 * @returns {Object} Returns the newly-created options object
	 */
	function createResetOptions(opts) {
		var options = { range: true, animate: true };
		if (typeof opts === 'boolean') {
			options.animate = opts;
		} else {
			$.extend(options, opts);
		}
		return options;
	}

	/**
	 * Represent a transformation matrix with a 3x3 matrix for calculations
	 * Matrix functions adapted from Louis Remi's jQuery.transform (https://github.com/louisremi/jquery.transform.js)
	 * @param {Array|Number} a An array of six values representing a 2d transformation matrix
	 */
	function Matrix(a, b, c, d, e, f, g, h, i) {
		if ($.type(a) === 'array') {
			this.elements = [
				+a[0], +a[2], +a[4],
				+a[1], +a[3], +a[5],
				    0,     0,     1
			];
		} else {
			this.elements = [
				a, b, c,
				d, e, f,
				g || 0, h || 0, i || 1
			];
		}
	}

	Matrix.prototype = {
		/**
		 * Multiply a 3x3 matrix by a similar matrix or a vector
		 * @param {Matrix|Vector} matrix
		 * @return {Matrix|Vector} Returns a vector if multiplying by a vector
		 */
		x: function(matrix) {
			var isVector = matrix instanceof Vector;

			var a = this.elements,
				b = matrix.elements;

			if (isVector && b.length === 3) {
				// b is actually a vector
				return new Vector(
					a[0] * b[0] + a[1] * b[1] + a[2] * b[2],
					a[3] * b[0] + a[4] * b[1] + a[5] * b[2],
					a[6] * b[0] + a[7] * b[1] + a[8] * b[2]
				);
			} else if (b.length === a.length) {
				// b is a 3x3 matrix
				return new Matrix(
					a[0] * b[0] + a[1] * b[3] + a[2] * b[6],
					a[0] * b[1] + a[1] * b[4] + a[2] * b[7],
					a[0] * b[2] + a[1] * b[5] + a[2] * b[8],

					a[3] * b[0] + a[4] * b[3] + a[5] * b[6],
					a[3] * b[1] + a[4] * b[4] + a[5] * b[7],
					a[3] * b[2] + a[4] * b[5] + a[5] * b[8],

					a[6] * b[0] + a[7] * b[3] + a[8] * b[6],
					a[6] * b[1] + a[7] * b[4] + a[8] * b[7],
					a[6] * b[2] + a[7] * b[5] + a[8] * b[8]
				);
			}
			return false; // fail
		},
		/**
		 * Generates an inverse of the current matrix
		 * @returns {Matrix}
		 */
		inverse: function() {
			var d = 1 / this.determinant(),
				a = this.elements;
			return new Matrix(
				d * ( a[8] * a[4] - a[7] * a[5]),
				d * (-(a[8] * a[1] - a[7] * a[2])),
				d * ( a[5] * a[1] - a[4] * a[2]),

				d * (-(a[8] * a[3] - a[6] * a[5])),
				d * ( a[8] * a[0] - a[6] * a[2]),
				d * (-(a[5] * a[0] - a[3] * a[2])),

				d * ( a[7] * a[3] - a[6] * a[4]),
				d * (-(a[7] * a[0] - a[6] * a[1])),
				d * ( a[4] * a[0] - a[3] * a[1])
			);
		},
		/**
		 * Calculates the determinant of the current matrix
		 * @returns {Number}
		 */
		determinant: function() {
			var a = this.elements;
			return a[0] * (a[8] * a[4] - a[7] * a[5]) - a[3] * (a[8] * a[1] - a[7] * a[2]) + a[6] * (a[5] * a[1] - a[4] * a[2]);
		}
	};

	/**
	 * Create a vector containing three values
	 */
	function Vector(x, y, z) {
		this.elements = [ x, y, z ];
	}

	/**
	 * Get the element at zero-indexed index i
	 * @param {Number} i
	 */
	Vector.prototype.e = Matrix.prototype.e = function(i) {
		return this.elements[ i ];
	};

	/**
	 * Create a Panzoom object for a given element
	 * @constructor
	 * @param {Element} elem - Element to use pan and zoom
	 * @param {Object} [options] - An object literal containing options to override default options
	 *  (See Panzoom.defaults for ones not listed below)
	 * @param {jQuery} [options.$zoomIn] - zoom in buttons/links collection (you can also bind these yourself
	 *  e.g. $button.on('click', function(e) { e.preventDefault(); $elem.panzoom('zoomIn'); });)
	 * @param {jQuery} [options.$zoomOut] - zoom out buttons/links collection on which to bind zoomOut
	 * @param {jQuery} [options.$zoomRange] - zoom in/out with this range control
	 * @param {jQuery} [options.$reset] - Reset buttons/links collection on which to bind the reset method
	 * @param {Function} [options.on[Start|Change|Zoom|Pan|End|Reset] - Optional callbacks for panzoom events
	 */
	function Panzoom(elem, options) {

		// Allow instantiation without `new` keyword
		if (!(this instanceof Panzoom)) {
			return new Panzoom(elem, options);
		}

		// Sanity checks
		if (elem.nodeType !== 1) {
			$.error('Panzoom called on non-Element node');
		}
		if (!$.contains(document, elem)) {
			$.error('Panzoom element must be attached to the document');
		}

		// Don't remake
		var d = $.data(elem, datakey);
		if (d) {
			return d;
		}

		// Extend default with given object literal
		// Each instance gets its own options
		this.options = options = $.extend({}, Panzoom.defaults, options);
		this.elem = elem;
		var $elem = this.$elem = $(elem);
		this.$set = options.$set && options.$set.length ? options.$set : $elem;
		this.$doc = $(elem.ownerDocument || document);
		this.$parent = $elem.parent();
		this.parent = this.$parent[0];

		// This is SVG if the namespace is SVG
		// However, while <svg> elements are SVG, we want to treat those like other elements
		this.isSVG = rsvg.test(elem.namespaceURI) && elem.nodeName.toLowerCase() !== 'svg';

		this.panning = false;

		// Save the original transform value
		// Save the prefixed transform style key
		// Set the starting transform
		this._buildTransform();

		// Build the appropriately-prefixed transform style property name
		// De-camelcase
		this._transform = $.cssProps.transform ? $.cssProps.transform.replace(rupper, '-$1').toLowerCase() : 'transform';

		// Build the transition value
		this._buildTransition();

		// Build containment dimensions
		this.resetDimensions();

		// Add zoom and reset buttons to `this`
		var $empty = $();
		var self = this;
		$.each([ '$zoomIn', '$zoomOut', '$zoomRange', '$reset' ], function(i, name) {
			self[ name ] = options[ name ] || $empty;
		});

		this.enable();

		this.scale = this.getMatrix()[0];
		this._checkPanWhenZoomed();

		// Save the instance
		$.data(elem, datakey, this);
	}

	// Attach regex for possible use (immutable)
	Panzoom.rmatrix = rmatrix;

	Panzoom.defaults = {
		// Should always be non-empty
		// Used to bind jQuery events without collisions
		// A guid is not added here as different instantiations/versions of panzoom
		// on the same element is not supported, so don't do it.
		eventNamespace: '.panzoom',

		// Whether or not to transition the scale
		transition: true,

		// Default cursor style for the element
		cursor: 'move',

		// There may be some use cases for zooming without panning or vice versa
		disablePan: false,
		disableZoom: false,

		// Pan only on the X or Y axes
		disableXAxis: false,
		disableYAxis: false,

		// Set whether you'd like to pan on left (1), middle (2), or right click (3)
		which: 1,

		// The increment at which to zoom
		// Should be a number greater than 0
		increment: 0.3,

		// When no scale is passed, this option tells
		// the `zoom` method to increment
		// the scale *linearly* based on the increment option.
		// This often ends up looking like very little happened at larger zoom levels.
		// The default is to multiply/divide the scale based on the increment.
		linearZoom: false,

		// Pan only when the scale is greater than minScale
		panOnlyWhenZoomed: false,

		// min and max zoom scales
		minScale: 0.3,
		maxScale: 6,

		// The default step for the range input
		// Precendence: default < HTML attribute < option setting
		rangeStep: 0.05,

		// Animation duration (ms)
		duration: 200,
		// CSS easing used for scale transition
		easing: 'ease-in-out',

		// Indicate that the element should be contained within it's parent when panning
		// Note: this does not affect zooming outside of the parent
		// Set this value to 'invert' to only allow panning outside of the parent element (basically the opposite of the normal use of contain)
		// 'invert' is useful for a large panzoom element where you don't want to show anything behind it
		contain: false
	};

	Panzoom.prototype = {
		constructor: Panzoom,

		/**
		 * @returns {Panzoom} Returns the instance
		 */
		instance: function() {
			return this;
		},

		/**
		 * Enable or re-enable the panzoom instance
		 */
		enable: function() {
			// Unbind first
			this._initStyle();
			this._bind();
			this.disabled = false;
		},

		/**
		 * Disable panzoom
		 */
		disable: function() {
			this.disabled = true;
			this._resetStyle();
			this._unbind();
		},

		/**
		 * @returns {Boolean} Returns whether the current panzoom instance is disabled
		 */
		isDisabled: function() {
			return this.disabled;
		},

		/**
		 * Destroy the panzoom instance
		 */
		destroy: function() {
			this.disable();
			$.removeData(this.elem, datakey);
		},

		/**
		 * Builds the restricing dimensions from the containment element
		 * Also used with focal points
		 * Call this method whenever the dimensions of the element or parent are changed
		 */
		resetDimensions: function() {
			// Reset container properties
			this.container = this.parent.getBoundingClientRect();

			// Set element properties
			var elem = this.elem;
			// getBoundingClientRect() works with SVG, offsetWidth does not
			var dims = elem.getBoundingClientRect();
			var absScale = Math.abs(this.scale);
			this.dimensions = {
				width: dims.width,
				height: dims.height,
				left: $.css(elem, 'left', true) || 0,
				top: $.css(elem, 'top', true) || 0,
				// Borders and margins are scaled
				border: {
					top: $.css(elem, 'borderTopWidth', true) * absScale || 0,
					bottom: $.css(elem, 'borderBottomWidth', true) * absScale || 0,
					left: $.css(elem, 'borderLeftWidth', true) * absScale || 0,
					right: $.css(elem, 'borderRightWidth', true) * absScale || 0
				},
				margin: {
					top: $.css(elem, 'marginTop', true) * absScale || 0,
					left: $.css(elem, 'marginLeft', true) * absScale || 0
				}
			};
		},

		/**
		 * Return the element to it's original transform matrix
		 * @param {Boolean} [options] If a boolean is passed, animate the reset (default: true). If an options object is passed, simply pass that along to setMatrix.
		 * @param {Boolean} [options.silent] Silence the reset event
		 */
		reset: function(options) {
			options = createResetOptions(options);
			// Reset the transform to its original value
			var matrix = this.setMatrix(this._origTransform, options);
			if (!options.silent) {
				this._trigger('reset', matrix);
			}
		},

		/**
		 * Only resets zoom level
		 * @param {Boolean|Object} [options] Whether to animate the reset (default: true) or an object of options to pass to zoom()
		 */
		resetZoom: function(options) {
			options = createResetOptions(options);
			var origMatrix = this.getMatrix(this._origTransform);
			options.dValue = origMatrix[ 3 ];
			this.zoom(origMatrix[0], options);
		},

		/**
		 * Only reset panning
		 * @param {Boolean|Object} [options] Whether to animate the reset (default: true) or an object of options to pass to pan()
		 */
		resetPan: function(options) {
			var origMatrix = this.getMatrix(this._origTransform);
			this.pan(origMatrix[4], origMatrix[5], createResetOptions(options));
		},

		/**
		 * Sets a transform on the $set
		 * For SVG, the style attribute takes precedence
		 * and allows us to animate
		 * @param {String} transform
		 */
		setTransform: function(transform) {
			var $set = this.$set;
			var i = $set.length;
			while(i--) {
				$.style($set[i], 'transform', transform);

				// Support IE9-11, Edge 13-14+
				// Set attribute alongside style attribute
				// since IE and Edge do not respect style settings on SVG
				// See https://css-tricks.com/transforms-on-svg-elements/
				if (this.isSVG) {
					$set[i].setAttribute('transform', transform);
				}
			}
		},

		/**
		 * Retrieving the transform is different for SVG
		 *  (unless a style transform is already present)
		 * Uses the $set collection for retrieving the transform
		 * @param {String} [transform] Pass in an transform value (like 'scale(1.1)')
		 *  to have it formatted into matrix format for use by Panzoom
		 * @returns {String} Returns the current transform value of the element
		 */
		getTransform: function(transform) {
			var $set = this.$set;
			var transformElem = $set[0];
			if (transform) {
				this.setTransform(transform);
			} else {

				// IE and Edge still set the transform style properly
				// They just don't render it on SVG
				// So we get a correct value here
				transform = $.style(transformElem, 'transform');

				if (this.isSVG && (!transform || transform === 'none')) {
					transform = $.attr(transformElem, 'transform') || 'none';
				}
			}

			// Convert any transforms set by the user to matrix format
			// by setting to computed
			if (transform !== 'none' && !rmatrix.test(transform)) {

				// Get computed and set for next time
				this.setTransform(transform = $.css(transformElem, 'transform'));
			}

			return transform || 'none';
		},

		/**
		 * Retrieve the current transform matrix for $elem (or turn a transform into it's array values)
		 * @param {String} [transform] matrix-formatted transform value
		 * @returns {Array} Returns the current transform matrix split up into it's parts, or a default matrix
		 */
		getMatrix: function(transform) {
			var matrix = rmatrix.exec(transform || this.getTransform());
			if (matrix) {
				matrix.shift();
			}
			return matrix || [ 1, 0, 0, 1, 0, 0 ];
		},

		/**
		 * Get the current scale.
		 * @param {String} [transform] matrix-formatted transform value
		 * @returns {Number} Current scale relative to the initial scale (height / width = 1)
		 */
		getScale: function(matrix) {
			return Math.sqrt(Math.pow(matrix[0], 2) + Math.pow(matrix[1], 2));
		},

		/**
		 * Given a matrix object, quickly set the current matrix of the element
		 * @param {Array|String} matrix
		 * @param {Object} [options]
		 * @param {Boolean|String} [options.animate] Whether to animate the transform change, or 'skip' indicating that it is unnecessary to set
		 * @param {Boolean} [options.contain] Override the global contain option
		 * @param {Boolean} [options.range] If true, $zoomRange's value will be updated.
		 * @param {Boolean} [options.silent] If true, the change event will not be triggered
		 * @returns {Array} Returns the newly-set matrix
		 */
		setMatrix: function(matrix, options) {
			if (this.disabled) { return; }
			if (!options) { options = {}; }
			// Convert to array
			if (typeof matrix === 'string') {
				matrix = this.getMatrix(matrix);
			}
			var scale = this.getScale(matrix);
			var contain = typeof options.contain !== 'undefined' ? options.contain : this.options.contain;

			// Apply containment
			if (contain) {
				var dims = options.dims;
				if (!dims) {
					this.resetDimensions();
					dims = this.dimensions;
				}
				var spaceWLeft, spaceWRight, scaleDiff;
				var container = this.container;
				var width = dims.width;
				var height = dims.height;
				var conWidth = container.width;
				var conHeight = container.height;
				var zoomAspectW = conWidth / width;
				var zoomAspectH = conHeight / height;

				// If the element is not naturally centered,
				// assume full space right
				if (this.$parent.css('textAlign') !== 'center' || $.css(this.elem, 'display') !== 'inline') {
					// offsetWidth gets us the width without the transform
					scaleDiff = (width - this.elem.offsetWidth) / 2;
					spaceWLeft = scaleDiff - dims.border.left;
					spaceWRight = width - conWidth - scaleDiff + dims.border.right;
				} else {
					spaceWLeft = spaceWRight = ((width - conWidth) / 2);
				}
				var spaceHTop = ((height - conHeight) / 2) + dims.border.top;
				var spaceHBottom = ((height - conHeight) / 2) - dims.border.top - dims.border.bottom;

				if (contain === 'invert' || contain === 'automatic' && zoomAspectW < 1.01) {
					matrix[4] = Math.max(Math.min(matrix[4], spaceWLeft - dims.border.left), -spaceWRight);
				} else {
					matrix[4] = Math.min(Math.max(matrix[4], spaceWLeft), -spaceWRight);
				}

				if (contain === 'invert' || (contain === 'automatic' && zoomAspectH < 1.01)) {
					matrix[5] = Math.max(Math.min(matrix[5], spaceHTop - dims.border.top), -spaceHBottom);
				} else {
					matrix[5] = Math.min(Math.max(matrix[5], spaceHTop), -spaceHBottom);
				}
			}

			// Animate
			if (options.animate !== 'skip') {
				// Set transition
				this.transition(!options.animate);
			}

			// Update range element
			if (options.range) {
				this.$zoomRange.val(scale);
			}

			// Set the matrix on this.$set
			if (this.options.disableXAxis || this.options.disableYAxis) {
				var originalMatrix = this.getMatrix();
				if (this.options.disableXAxis) {
					matrix[4] = originalMatrix[4];
				}
				if (this.options.disableYAxis) {
					matrix[5] = originalMatrix[5];
				}
			}
			this.setTransform('matrix(' + matrix.join(',') + ')');

			this.scale = scale;

			// Disable/enable panning if zooming is at minimum and panOnlyWhenZoomed is true
			this._checkPanWhenZoomed(scale);

			if (!options.silent) {
				this._trigger('change', matrix);
			}

			return matrix;
		},

		/**
		 * @returns {Boolean} Returns whether the panzoom element is currently being dragged
		 */
		isPanning: function() {
			return this.panning;
		},

		/**
		 * Apply the current transition to the element, if allowed
		 * @param {Boolean} [off] Indicates that the transition should be turned off
		 */
		transition: function(off) {
			if (!this._transition) { return; }
			var transition = off || !this.options.transition ? 'none' : this._transition;
			var $set = this.$set;
			var i = $set.length;
			while(i--) {
				// Avoid reflows when zooming
				if ($.style($set[i], 'transition') !== transition) {
					$.style($set[i], 'transition', transition);
				}
			}
		},

		/**
		 * Pan the element to the specified translation X and Y
		 * Note: this is not the same as setting jQuery#offset() or jQuery#position()
		 * @param {Number} x
		 * @param {Number} y
		 * @param {Object} [options] These options are passed along to setMatrix
		 * @param {Array} [options.matrix] The matrix being manipulated (if already known so it doesn't have to be retrieved again)
		 * @param {Boolean} [options.silent] Silence the pan event. Note that this will also silence the setMatrix change event.
		 * @param {Boolean} [options.relative] Make the x and y values relative to the existing matrix
		 */
		pan: function(x, y, options) {
			if (this.options.disablePan) { return; }
			if (!options) { options = {}; }
			var matrix = options.matrix;
			if (!matrix) {
				matrix = this.getMatrix();
			}
			// Cast existing matrix values to numbers
			if (options.relative) {
				x += +matrix[4];
				y += +matrix[5];
			}
			matrix[4] = x;
			matrix[5] = y;
			this.setMatrix(matrix, options);
			if (!options.silent) {
				this._trigger('pan', matrix[4], matrix[5]);
			}
		},

		/**
		 * Zoom in/out the element using the scale properties of a transform matrix
		 * @param {Number|Boolean} [scale] The scale to which to zoom or a boolean indicating to transition a zoom out
		 * @param {Object} [opts] All global options can be overwritten by this options object. For example, override the default increment.
		 * @param {Boolean} [opts.noSetRange] Specify that the method should not set the $zoomRange value (as is the case when $zoomRange is calling zoom on change)
		 * @param {jQuery.Event|Object} [opts.focal] A focal point on the panzoom element on which to zoom.
		 *  If an object, set the clientX and clientY properties to the position relative to the parent
		 * @param {Boolean} [opts.animate] Whether to animate the zoom (defaults to true if scale is not a number, false otherwise)
		 * @param {Boolean} [opts.silent] Silence the zoom event
		 * @param {Array} [opts.matrix] Optionally pass the current matrix so it doesn't need to be retrieved
		 * @param {Number} [opts.dValue] Think of a transform matrix as four values a, b, c, d
		 *  where a/d are the horizontal/vertical scale values and b/c are the skew values
		 *  (5 and 6 of matrix array are the tx/ty transform values).
		 *  Normally, the scale is set to both the a and d values of the matrix.
		 *  This option allows you to specify a different d value for the zoom.
		 *  For instance, to flip vertically, you could set -1 as the dValue.
		 */
		zoom: function(scale, opts) {
			// Shuffle arguments
			if (typeof scale === 'object') {
				opts = scale;
				scale = null;
			} else if (!opts) {
				opts = {};
			}
			var options = $.extend({}, this.options, opts);
			// Check if disabled
			if (options.disableZoom) { return; }
			var animate = false;
			var matrix = options.matrix || this.getMatrix();
			var surfaceM = new Matrix(matrix);
			var startScale = this.getScale(matrix);

			// Calculate zoom based on increment
			if (typeof scale !== 'number') {
				if (options.linearZoom) {
					scale = 1 + (options.increment * (scale ? -1 : 1)) / startScale;
				} else {
					scale = scale ? (1 / (1 + options.increment)) : (1 + options.increment);
				}
				animate = true;
			} else {
				scale = 1 / startScale;
			}

			// Constrain scale
			scale = Math.max(Math.min(scale, options.maxScale / startScale), options.minScale / startScale);
			var m = surfaceM.x(new Matrix(scale, 0, 0, 0, (typeof options.dValue === 'number' ? options.dValue / startScale : scale), 0));

			// Calculate focal point based on scale
			var focal = options.focal;
			if (focal && !options.disablePan) {
				// Adapted from code by Florian Günther
				// https://github.com/florianguenther/zui53
				this.resetDimensions();
				var dims = options.dims = this.dimensions;
				var clientX = focal.clientX;
				var clientY = focal.clientY;

				// Adjust the focal point for transform-origin 50% 50%
				// SVG elements have a transform origin of 0 0
				if (!this.isSVG) {
					clientX -= (dims.width / startScale) / 2;
					clientY -= (dims.height / startScale) / 2;
				}

				var clientV = new Vector(clientX, clientY, 1);
				// Supply an offset manually if necessary
				var o = this.parentOffset || this.$parent.offset();
				var offsetM = new Matrix(1, 0, o.left - this.$doc.scrollLeft(), 0, 1, o.top - this.$doc.scrollTop());
				var surfaceV = surfaceM.inverse().x(offsetM.inverse().x(clientV));
				surfaceM = surfaceM.x(new Matrix([scale, 0, 0, scale, 0, 0]));
				clientV = offsetM.x(surfaceM.x(surfaceV));
				matrix[4] = +matrix[4] + (clientX - clientV.e(0));
				matrix[5] = +matrix[5] + (clientY - clientV.e(1));
			}

			// Set the scale
			matrix[0] = m.e(0);
			matrix[1] = m.e(3);
			matrix[2] = m.e(1);
			matrix[3] = m.e(4);

			// Calling zoom may still pan the element
			this.setMatrix(matrix, {
				animate: typeof options.animate !== 'undefined' ? options.animate : animate,
				// Set the zoomRange value
				range: !options.noSetRange
			});

			// Trigger zoom event
			if (!options.silent) {
				this._trigger('zoom', scale, options);
			}
		},

		/**
		 * Get/set option on an existing instance
		 * @returns {Array|undefined} If getting, returns an array of all values
		 *   on each instance for a given key. If setting, continue chaining by returning undefined.
		 */
		option: function(key, value) {
			var options;
			if (!key) {
				// Avoids returning direct reference
				return $.extend({}, this.options);
			}

			if (typeof key === 'string') {
				if (arguments.length === 1) {
					return this.options[ key ] !== undefined ?
						this.options[ key ] :
						null;
				}
				options = {};
				options[ key ] = value;
			} else {
				options = key;
			}

			this._setOptions(options);
		},

		/**
		 * Internally sets options
		 * @param {Object} options - An object literal of options to set
		 * @private
		 */
		_setOptions: function(options) {
			$.each(options, $.proxy(function(key, value) {
				switch(key) {
					case 'disablePan':
						this._resetStyle();
						/* falls through */
					case '$zoomIn':
					case '$zoomOut':
					case '$zoomRange':
					case '$reset':
					case 'disableZoom':
					case 'onStart':
					case 'onChange':
					case 'onZoom':
					case 'onPan':
					case 'onEnd':
					case 'onReset':
					case 'eventNamespace':
						this._unbind();
				}
				this.options[ key ] = value;
				switch(key) {
					case 'disablePan':
						this._initStyle();
						/* falls through */
					case '$zoomIn':
					case '$zoomOut':
					case '$zoomRange':
					case '$reset':
						// Set these on the instance
						this[ key ] = value;
						/* falls through */
					case 'disableZoom':
					case 'onStart':
					case 'onChange':
					case 'onZoom':
					case 'onPan':
					case 'onEnd':
					case 'onReset':
					case 'eventNamespace':
						this._bind();
						break;
					case 'cursor':
						$.style(this.elem, 'cursor', value);
						break;
					case 'minScale':
						this.$zoomRange.attr('min', value);
						break;
					case 'maxScale':
						this.$zoomRange.attr('max', value);
						break;
					case 'rangeStep':
						this.$zoomRange.attr('step', value);
						break;
					case 'startTransform':
						this._buildTransform();
						break;
					case 'duration':
					case 'easing':
						this._buildTransition();
						/* falls through */
					case 'transition':
						this.transition();
						break;
					case 'panOnlyWhenZoomed':
						this._checkPanWhenZoomed();
						break;
					case '$set':
						if (value instanceof $ && value.length) {
							this.$set = value;
							// Reset styles
							this._initStyle();
							this._buildTransform();
						}
				}
			}, this));
		},

		/**
		 * Disable/enable panning depending on whether the current scale
		 * matches the minimum
		 * @param {Number} [scale]
		 * @private
		 */
		_checkPanWhenZoomed: function(scale) {
			var options = this.options;
			if (options.panOnlyWhenZoomed) {
				if (!scale) {
					scale = this.getMatrix()[0];
				}
				var toDisable = scale <= options.minScale;
				if (options.disablePan !== toDisable) {
					this.option('disablePan', toDisable);
				}
			}
		},

		/**
		 * Initialize base styles for the element and its parent
		 * @private
		 */
		_initStyle: function() {
			var styles = {
				// Set the same default whether SVG or HTML
				// transform-origin cannot be changed to 50% 50% in IE9-11 or Edge 13-14+
				'transform-origin': this.isSVG ? '0 0' : '50% 50%'
			};
			// Set elem styles
			if (!this.options.disablePan) {
				styles.cursor = this.options.cursor;
			}
			this.$set.css(styles);

			// Set parent to relative if set to static
			var $parent = this.$parent;
			// No need to add styles to the body
			if ($parent.length && !$.nodeName(this.parent, 'body')) {
				styles = {
					overflow: 'hidden'
				};
				if ($parent.css('position') === 'static') {
					styles.position = 'relative';
				}
				$parent.css(styles);
			}
		},

		/**
		 * Undo any styles attached in this plugin
		 * @private
		 */
		_resetStyle: function() {
			this.$elem.css({
				'cursor': '',
				'transition': ''
			});
			this.$parent.css({
				'overflow': '',
				'position': ''
			});
		},

		/**
		 * Binds all necessary events
		 * @private
		 */
		_bind: function() {
			var self = this;
			var options = this.options;
			var ns = options.eventNamespace;
			var str_down = 'mousedown' + ns + ' pointerdown' + ns + ' MSPointerDown' + ns;
			var str_start = 'touchstart' + ns + ' ' + str_down;
			var str_click = 'touchend' + ns + ' click' + ns + ' pointerup' + ns + ' MSPointerUp' + ns;
			var events = {};
			var $reset = this.$reset;
			var $zoomRange = this.$zoomRange;

			// Bind panzoom events from options
			$.each([ 'Start', 'Change', 'Zoom', 'Pan', 'End', 'Reset' ], function() {
				var m = options[ 'on' + this ];
				if ($.isFunction(m)) {
					events[ 'panzoom' + this.toLowerCase() + ns ] = m;
				}
			});

			// Bind $elem drag and click/touchdown events
			// Bind touchstart if either panning or zooming is enabled
			if (!options.disablePan || !options.disableZoom) {
				events[ str_start ] = function(e) {
					var touches;
					if (e.type === 'touchstart' ?
						// Touch
						(touches = e.touches || e.originalEvent.touches) &&
							((touches.length === 1 && !options.disablePan) || touches.length === 2) :
						// Mouse/Pointer: Ignore unexpected click types
						// Support: IE10 only
						// IE10 does not support e.button for MSPointerDown, but does have e.which
						!options.disablePan && (e.which || e.originalEvent.which) === options.which) {

						e.preventDefault();
						e.stopPropagation();
						self._startMove(e, touches);
					}
				};
				// Prevent the contextmenu event
				// if we're binding to right-click
				if (options.which === 3) {
					events.contextmenu = false;
				}
			}
			this.$elem.on(events);

			// Bind reset
			if ($reset.length) {
				$reset.on(str_click, function(e) {
					e.preventDefault();
					self.reset();
				});
			}

			// Set default attributes for the range input
			if ($zoomRange.length) {
				$zoomRange.attr({
					// Only set the range step if explicit or
					// set the default if there is no attribute present
					step: options.rangeStep === Panzoom.defaults.rangeStep &&
						$zoomRange.attr('step') ||
						options.rangeStep,
					min: options.minScale,
					max: options.maxScale
				}).prop({
					value: this.getMatrix()[0]
				});
			}

			// No bindings if zooming is disabled
			if (options.disableZoom) {
				return;
			}

			var $zoomIn = this.$zoomIn;
			var $zoomOut = this.$zoomOut;

			// Bind zoom in/out
			// Don't bind one without the other
			if ($zoomIn.length && $zoomOut.length) {
				// preventDefault cancels future mouse events on touch events
				$zoomIn.on(str_click, function(e) {
					e.preventDefault();
					self.zoom();
				});
				$zoomOut.on(str_click, function(e) {
					e.preventDefault();
					self.zoom(true);
				});
			}

			if ($zoomRange.length) {
				events = {};
				// Cannot prevent default action here
				events[ str_down ] = function() {
					self.transition(true);
				};
				// Zoom on input events if available and change events
				// See https://github.com/timmywil/jquery.panzoom/issues/90
				events[ (supportsInputEvent ? 'input' : 'change') + ns ] = function() {
					self.zoom(+this.value, { noSetRange: true });
				};
				$zoomRange.on(events);
			}
		},

		/**
		 * Unbind all events
		 * @private
		 */
		_unbind: function() {
			this.$elem
				.add(this.$zoomIn)
				.add(this.$zoomOut)
				.add(this.$reset)
				.off(this.options.eventNamespace);
		},

		/**
		 * Builds the original transform value
		 * @private
		 */
		_buildTransform: function() {
			// Save the original transform
			// Retrieving this also adds the correct prefixed style name
			// to jQuery's internal $.cssProps
			return this._origTransform = this.getTransform(this.options.startTransform);
		},

		/**
		 * Set transition property for later use when zooming
		 * @private
		 */
		_buildTransition: function() {
			if (this._transform) {
				var options = this.options;
				this._transition = this._transform + ' ' + options.duration + 'ms ' + options.easing;
			}
		},

		/**
		 * Calculates the distance between two touch points
		 * Remember pythagorean?
		 * @param {Array} touches
		 * @returns {Number} Returns the distance
		 * @private
		 */
		_getDistance: function(touches) {
			var touch1 = touches[0];
			var touch2 = touches[1];
			return Math.sqrt(Math.pow(Math.abs(touch2.clientX - touch1.clientX), 2) + Math.pow(Math.abs(touch2.clientY - touch1.clientY), 2));
		},

		/**
		 * Constructs an approximated point in the middle of two touch points
		 * @returns {Object} Returns an object containing pageX and pageY
		 * @private
		 */
		_getMiddle: function(touches) {
			var touch1 = touches[0];
			var touch2 = touches[1];
			return {
				clientX: ((touch2.clientX - touch1.clientX) / 2) + touch1.clientX,
				clientY: ((touch2.clientY - touch1.clientY) / 2) + touch1.clientY
			};
		},

		/**
		 * Trigger a panzoom event on our element
		 * The event is passed the Panzoom instance
		 * @param {String|jQuery.Event} event
		 * @param {Mixed} arg1[, arg2, arg3, ...] Arguments to append to the trigger
		 * @private
		 */
		_trigger: function (event) {
			if (typeof event === 'string') {
				event = 'panzoom' + event;
			}
			this.$elem.triggerHandler(event, [this].concat(slice.call(arguments, 1)));
		},

		/**
		 * Starts the pan
		 * This is bound to mouse/touchmove on the element
		 * @param {jQuery.Event} event An event with pageX, pageY, and possibly the touches list
		 * @param {TouchList} [touches] The touches list if present
		 * @private
		 */
		_startMove: function(event, touches) {
			if (this.panning) {
				return;
			}
			var moveEvent, endEvent,
				startDistance, startScale, startMiddle,
				startPageX, startPageY, touch;
			var self = this;
			var options = this.options;
			var ns = options.eventNamespace;
			var matrix = this.getMatrix();
			var original = matrix.slice(0);
			var origPageX = +original[4];
			var origPageY = +original[5];
			var panOptions = { matrix: matrix, animate: 'skip' };
			var type = event.type;

			// Use proper events
			if (type === 'pointerdown') {
				moveEvent = 'pointermove';
				endEvent = 'pointerup';
			} else if (type === 'touchstart') {
				moveEvent = 'touchmove';
				endEvent = 'touchend';
			} else if (type === 'MSPointerDown') {
				moveEvent = 'MSPointerMove';
				endEvent = 'MSPointerUp';
			} else {
				moveEvent = 'mousemove';
				endEvent = 'mouseup';
			}

			// Add namespace
			moveEvent += ns;
			endEvent += ns;

			// Remove any transitions happening
			this.transition(true);

			// Indicate that we are currently panning
			this.panning = true;

			// Trigger start event
			this._trigger('start', event, touches);

			var setStart = function(event, touches) {
				if (touches) {
					if (touches.length === 2) {
						if (startDistance != null) {
							return;
						}
						startDistance = self._getDistance(touches);
						startScale = self.getScale(matrix);
						startMiddle = self._getMiddle(touches);
						return;
					}
					if (startPageX != null) {
						return;
					}
					if ((touch = touches[0])) {
						startPageX = touch.pageX;
						startPageY = touch.pageY;
					}
				}
				if (startPageX != null) {
					return;
				}
				startPageX = event.pageX;
				startPageY = event.pageY;
			};

			setStart(event, touches);

			var move = function(e) {
				var coords;
				e.preventDefault();
				touches = e.touches || e.originalEvent.touches;
				setStart(e, touches);

				if (touches) {
					if (touches.length === 2) {

						// Calculate move on middle point
						var middle = self._getMiddle(touches);
						var diff = self._getDistance(touches) - startDistance;

						// Set zoom
						self.zoom(diff * (options.increment / 100) + startScale, {
							focal: middle,
							matrix: matrix,
							animate: 'skip'
						});

						// Set pan
						self.pan(
							+matrix[4] + middle.clientX - startMiddle.clientX,
							+matrix[5] + middle.clientY - startMiddle.clientY,
							panOptions
						);
						startMiddle = middle;
						return;
					}
					coords = touches[0] || { pageX: 0, pageY: 0 };
				}

				if (!coords) {
					coords = e;
				}

				self.pan(
					origPageX + coords.pageX - startPageX,
					origPageY + coords.pageY - startPageY,
					panOptions
				);
			};

			// Bind the handlers
			$(document)
				.off(ns)
				.on(moveEvent, move)
				.on(endEvent, function(e) {
					e.preventDefault();
					// Unbind all document events
					$(this).off(ns);
					self.panning = false;
					// Trigger our end event
					// Simply set the type to "panzoomend" to pass through all end properties
					// jQuery's `not` is used here to compare Array equality
					e.type = 'panzoomend';
					self._trigger(e, matrix, !matrixEquals(matrix, original));
				});
		}
	};

	// Add Panzoom as a static property
	$.Panzoom = Panzoom;

	/**
	 * Extend jQuery
	 * @param {Object|String} options - The name of a method to call on the prototype
	 *  or an object literal of options
	 * @returns {jQuery|Mixed} jQuery instance for regular chaining or the return value(s) of a panzoom method call
	 */
	$.fn.panzoom = function(options) {
		var instance, args, m, ret;

		// Call methods widget-style
		if (typeof options === 'string') {
			ret = [];
			args = slice.call(arguments, 1);
			this.each(function() {
				instance = $.data(this, datakey);

				if (!instance) {
					ret.push(undefined);

				// Ignore methods beginning with `_`
				} else if (options.charAt(0) !== '_' &&
					typeof (m = instance[ options ]) === 'function' &&
					// If nothing is returned, do not add to return values
					(m = m.apply(instance, args)) !== undefined) {

					ret.push(m);
				}
			});

			// Return an array of values for the jQuery instances
			// Or the value itself if there is only one
			// Or keep chaining
			return ret.length ?
				(ret.length === 1 ? ret[0] : ret) :
				this;
		}

		return this.each(function() { new Panzoom(this, options); });
	};

	return Panzoom;
}));


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

(function(window, factory) {
	var globalInstall = function(initialEvent){
		factory(window.lazySizes, initialEvent);
		window.removeEventListener('lazyunveilread', globalInstall, true);
	};

	factory = factory.bind(null, window, window.document);

	if(typeof module == 'object' && module.exports){
		factory(__webpack_require__(237));
	} else if(window.lazySizes) {
		globalInstall();
	} else {
		window.addEventListener('lazyunveilread', globalInstall, true);
	}
}(window, function(window, document, lazySizes, initialEvent) {
	'use strict';
	var style = document.createElement('a').style;
	var fitSupport = 'objectFit' in style;
	var positionSupport = fitSupport && 'objectPosition' in style;
	var regCssFit = /object-fit["']*\s*:\s*["']*(contain|cover)/;
	var regCssPosition = /object-position["']*\s*:\s*["']*(.+?)(?=($|,|'|"|;))/;
	var blankSrc = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
	var regBgUrlEscape = /\(|\)|'/;
	var positionDefaults = {
		center: 'center',
		'50% 50%': 'center',
	};

	function getObject(element){
		var css = (getComputedStyle(element, null) || {});
		var content = css.fontFamily || '';
		var objectFit = content.match(regCssFit) || '';
		var objectPosition = objectFit && content.match(regCssPosition) || '';

		if(objectPosition){
			objectPosition = objectPosition[1];
		}

		return {
			fit: objectFit && objectFit[1] || '',
			position: positionDefaults[objectPosition] || objectPosition || 'center',
		};
	}

	function initFix(element, config){
		var switchClassesAdded;
		var lazysizesCfg = lazySizes.cfg;
		var styleElement = element.cloneNode(false);
		var styleElementStyle = styleElement.style;

		var onChange = function(){
			var src = element.currentSrc || element.src;

			if(src){
				styleElementStyle.backgroundImage = 'url(' + (regBgUrlEscape.test(src) ? JSON.stringify(src) : src ) + ')';

				if(!switchClassesAdded){
					switchClassesAdded = true;
					lazySizes.rC(styleElement, lazysizesCfg.loadingClass);
					lazySizes.aC(styleElement, lazysizesCfg.loadedClass);
				}
			}
		};

		element._lazysizesParentFit = config.fit;

		element.addEventListener('load', function(){
			lazySizes.rAF(onChange);
		}, true);

		styleElement.addEventListener('load', function(){
			var curSrc = styleElement.currentSrc || styleElement.src;

			if(curSrc && curSrc != blankSrc){
				styleElement.src = blankSrc;
				styleElement.srcset = '';
			}
		});

		lazySizes.rAF(function(){

			var hideElement = element;
			var container = element.parentNode;

			if(container.nodeName.toUpperCase() == 'PICTURE'){
				hideElement = container;
				container = container.parentNode;
			}

			lazySizes.rC(styleElement, lazysizesCfg.loadedClass);
			lazySizes.rC(styleElement, lazysizesCfg.lazyClass);
			lazySizes.aC(styleElement, lazysizesCfg.loadingClass);
			lazySizes.aC(styleElement, lazysizesCfg.objectFitClass || 'lazysizes-display-clone');

			if(styleElement.getAttribute(lazysizesCfg.srcsetAttr)){
				styleElement.setAttribute(lazysizesCfg.srcsetAttr, '');
			}

			if(styleElement.getAttribute(lazysizesCfg.srcAttr)){
				styleElement.setAttribute(lazysizesCfg.srcAttr, '');
			}

			styleElement.src = blankSrc;
			styleElement.srcset = '';

			styleElementStyle.backgroundRepeat = 'no-repeat';
			styleElementStyle.backgroundPosition = config.position;
			styleElementStyle.backgroundSize = config.fit;

			hideElement.style.display = 'none';

			element.setAttribute('data-parent-fit', config.fit);
			element.setAttribute('data-parent-container', 'prev');

			container.insertBefore(styleElement, hideElement);

			if(element._lazysizesParentFit){
				delete element._lazysizesParentFit;
			}

			if(element.complete){
				onChange();
			}
		});
	}

	if(!fitSupport || !positionSupport){
		var onRead = function(e){
			if(e.detail.instance != lazySizes){return;}

			var element = e.target;
			var obj = getObject(element);

			if(obj.fit && (!fitSupport || (obj.position != 'center'))){
				initFix(element, obj);
			}
		};

		window.addEventListener('lazyunveilread', onRead, true);

		if(initialEvent && initialEvent.detail){
			onRead(initialEvent);
		}
	}
}));


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

/*
This plugin extends lazySizes to lazyLoad:
background images, videos/posters and scripts

Background-Image:
For background images, use data-bg attribute:
<div class="lazyload" data-bg="bg-img.jpg"></div>

 Video:
 For video/audio use data-poster and preload="none":
 <video class="lazyload" data-poster="poster.jpg" preload="none">
 <!-- sources -->
 </video>

 Scripts:
 For scripts use data-script:
 <div class="lazyload" data-script="module-name.js"></div>


 Script modules using require:
 For modules using require use data-require:
 <div class="lazyload" data-require="module-name"></div>
*/

(function(window, factory) {
	var globalInstall = function(){
		factory(window.lazySizes);
		window.removeEventListener('lazyunveilread', globalInstall, true);
	};

	factory = factory.bind(null, window, window.document);

	if(typeof module == 'object' && module.exports){
		factory(__webpack_require__(237));
	} else if(window.lazySizes) {
		globalInstall();
	} else {
		window.addEventListener('lazyunveilread', globalInstall, true);
	}
}(window, function(window, document, lazySizes) {
	/*jshint eqnull:true */
	'use strict';
	var bgLoad, regBgUrlEscape;
	var uniqueUrls = {};

	if(document.addEventListener){
		regBgUrlEscape = /\(|\)|\s|'/;

		bgLoad = function (url, cb){
			var img = document.createElement('img');
			img.onload = function(){
				img.onload = null;
				img.onerror = null;
				img = null;
				cb();
			};
			img.onerror = img.onload;

			img.src = url;

			if(img && img.complete && img.onload){
				img.onload();
			}
		};

		addEventListener('lazybeforeunveil', function(e){
			if(e.detail.instance != lazySizes){return;}

			var tmp, load, bg, poster;
			if(!e.defaultPrevented) {

				if(e.target.preload == 'none'){
					e.target.preload = 'auto';
				}

				tmp = e.target.getAttribute('data-link');
				if(tmp){
					addStyleScript(tmp, true);
				}

				// handle data-script
				tmp = e.target.getAttribute('data-script');
				if(tmp){
					addStyleScript(tmp);
				}

				// handle data-require
				tmp = e.target.getAttribute('data-require');
				if(tmp){
					if(lazySizes.cfg.requireJs){
						lazySizes.cfg.requireJs([tmp]);
					} else {
						addStyleScript(tmp);
					}
				}

				// handle data-bg
				bg = e.target.getAttribute('data-bg');
				if (bg) {
					e.detail.firesLoad = true;
					load = function(){
						e.target.style.backgroundImage = 'url(' + (regBgUrlEscape.test(bg) ? JSON.stringify(bg) : bg ) + ')';
						e.detail.firesLoad = false;
						lazySizes.fire(e.target, '_lazyloaded', {}, true, true);
					};

					bgLoad(bg, load);
				}

				// handle data-poster
				poster = e.target.getAttribute('data-poster');
				if(poster){
					e.detail.firesLoad = true;
					load = function(){
						e.target.poster = poster;
						e.detail.firesLoad = false;
						lazySizes.fire(e.target, '_lazyloaded', {}, true, true);
					};

					bgLoad(poster, load);

				}
			}
		}, false);

	}

	function addStyleScript(src, style){
		if(uniqueUrls[src]){
			return;
		}
		var elem = document.createElement(style ? 'link' : 'script');
		var insertElem = document.getElementsByTagName('script')[0];

		if(style){
			elem.rel = 'stylesheet';
			elem.href = src;
		} else {
			elem.src = src;
		}
		uniqueUrls[src] = true;
		uniqueUrls[elem.src || elem.href] = true;
		insertElem.parentNode.insertBefore(elem, insertElem);
	}
}));


/***/ }),
/* 791 */
/***/ (function(module, exports) {


module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}


/***/ }),
/* 792 */,
/* 793 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Platform.js <https://mths.be/platform>
 * Copyright 2014-2016 Benjamin Tan <https://demoneaux.github.io/>
 * Copyright 2011-2013 John-David Dalton <http://allyoucanleet.com/>
 * Available under MIT license <https://mths.be/mit>
 */
;(function() {
  'use strict';

  /** Used to determine if values are of the language type `Object`. */
  var objectTypes = {
    'function': true,
    'object': true
  };

  /** Used as a reference to the global object. */
  var root = (objectTypes[typeof window] && window) || this;

  /** Backup possible global object. */
  var oldRoot = root;

  /** Detect free variable `exports`. */
  var freeExports = objectTypes[typeof exports] && exports;

  /** Detect free variable `module`. */
  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;

  /** Detect free variable `global` from Node.js or Browserified code and use it as `root`. */
  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global;
  if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal)) {
    root = freeGlobal;
  }

  /**
   * Used as the maximum length of an array-like object.
   * See the [ES6 spec](http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength)
   * for more details.
   */
  var maxSafeInteger = Math.pow(2, 53) - 1;

  /** Regular expression to detect Opera. */
  var reOpera = /\bOpera/;

  /** Possible global object. */
  var thisBinding = this;

  /** Used for native method references. */
  var objectProto = Object.prototype;

  /** Used to check for own properties of an object. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /** Used to resolve the internal `[[Class]]` of values. */
  var toString = objectProto.toString;

  /*--------------------------------------------------------------------------*/

  /**
   * Capitalizes a string value.
   *
   * @private
   * @param {string} string The string to capitalize.
   * @returns {string} The capitalized string.
   */
  function capitalize(string) {
    string = String(string);
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  /**
   * A utility function to clean up the OS name.
   *
   * @private
   * @param {string} os The OS name to clean up.
   * @param {string} [pattern] A `RegExp` pattern matching the OS name.
   * @param {string} [label] A label for the OS.
   */
  function cleanupOS(os, pattern, label) {
    // Platform tokens are defined at:
    // http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
    // http://web.archive.org/web/20081122053950/http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
    var data = {
      '10.0': '10',
      '6.4':  '10 Technical Preview',
      '6.3':  '8.1',
      '6.2':  '8',
      '6.1':  'Server 2008 R2 / 7',
      '6.0':  'Server 2008 / Vista',
      '5.2':  'Server 2003 / XP 64-bit',
      '5.1':  'XP',
      '5.01': '2000 SP1',
      '5.0':  '2000',
      '4.0':  'NT',
      '4.90': 'ME'
    };
    // Detect Windows version from platform tokens.
    if (pattern && label && /^Win/i.test(os) && !/^Windows Phone /i.test(os) &&
        (data = data[/[\d.]+$/.exec(os)])) {
      os = 'Windows ' + data;
    }
    // Correct character case and cleanup string.
    os = String(os);

    if (pattern && label) {
      os = os.replace(RegExp(pattern, 'i'), label);
    }

    os = format(
      os.replace(/ ce$/i, ' CE')
        .replace(/\bhpw/i, 'web')
        .replace(/\bMacintosh\b/, 'Mac OS')
        .replace(/_PowerPC\b/i, ' OS')
        .replace(/\b(OS X) [^ \d]+/i, '$1')
        .replace(/\bMac (OS X)\b/, '$1')
        .replace(/\/(\d)/, ' $1')
        .replace(/_/g, '.')
        .replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, '')
        .replace(/\bx86\.64\b/gi, 'x86_64')
        .replace(/\b(Windows Phone) OS\b/, '$1')
        .replace(/\b(Chrome OS \w+) [\d.]+\b/, '$1')
        .split(' on ')[0]
    );

    return os;
  }

  /**
   * An iteration utility for arrays and objects.
   *
   * @private
   * @param {Array|Object} object The object to iterate over.
   * @param {Function} callback The function called per iteration.
   */
  function each(object, callback) {
    var index = -1,
        length = object ? object.length : 0;

    if (typeof length == 'number' && length > -1 && length <= maxSafeInteger) {
      while (++index < length) {
        callback(object[index], index, object);
      }
    } else {
      forOwn(object, callback);
    }
  }

  /**
   * Trim and conditionally capitalize string values.
   *
   * @private
   * @param {string} string The string to format.
   * @returns {string} The formatted string.
   */
  function format(string) {
    string = trim(string);
    return /^(?:webOS|i(?:OS|P))/.test(string)
      ? string
      : capitalize(string);
  }

  /**
   * Iterates over an object's own properties, executing the `callback` for each.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} callback The function executed per own property.
   */
  function forOwn(object, callback) {
    for (var key in object) {
      if (hasOwnProperty.call(object, key)) {
        callback(object[key], key, object);
      }
    }
  }

  /**
   * Gets the internal `[[Class]]` of a value.
   *
   * @private
   * @param {*} value The value.
   * @returns {string} The `[[Class]]`.
   */
  function getClassOf(value) {
    return value == null
      ? capitalize(value)
      : toString.call(value).slice(8, -1);
  }

  /**
   * Host objects can return type values that are different from their actual
   * data type. The objects we are concerned with usually return non-primitive
   * types of "object", "function", or "unknown".
   *
   * @private
   * @param {*} object The owner of the property.
   * @param {string} property The property to check.
   * @returns {boolean} Returns `true` if the property value is a non-primitive, else `false`.
   */
  function isHostType(object, property) {
    var type = object != null ? typeof object[property] : 'number';
    return !/^(?:boolean|number|string|undefined)$/.test(type) &&
      (type == 'object' ? !!object[property] : true);
  }

  /**
   * Prepares a string for use in a `RegExp` by making hyphens and spaces optional.
   *
   * @private
   * @param {string} string The string to qualify.
   * @returns {string} The qualified string.
   */
  function qualify(string) {
    return String(string).replace(/([ -])(?!$)/g, '$1?');
  }

  /**
   * A bare-bones `Array#reduce` like utility function.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} callback The function called per iteration.
   * @returns {*} The accumulated result.
   */
  function reduce(array, callback) {
    var accumulator = null;
    each(array, function(value, index) {
      accumulator = callback(accumulator, value, index, array);
    });
    return accumulator;
  }

  /**
   * Removes leading and trailing whitespace from a string.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} The trimmed string.
   */
  function trim(string) {
    return String(string).replace(/^ +| +$/g, '');
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Creates a new platform object.
   *
   * @memberOf platform
   * @param {Object|string} [ua=navigator.userAgent] The user agent string or
   *  context object.
   * @returns {Object} A platform object.
   */
  function parse(ua) {

    /** The environment context object. */
    var context = root;

    /** Used to flag when a custom context is provided. */
    var isCustomContext = ua && typeof ua == 'object' && getClassOf(ua) != 'String';

    // Juggle arguments.
    if (isCustomContext) {
      context = ua;
      ua = null;
    }

    /** Browser navigator object. */
    var nav = context.navigator || {};

    /** Browser user agent string. */
    var userAgent = nav.userAgent || '';

    ua || (ua = userAgent);

    /** Used to flag when `thisBinding` is the [ModuleScope]. */
    var isModuleScope = isCustomContext || thisBinding == oldRoot;

    /** Used to detect if browser is like Chrome. */
    var likeChrome = isCustomContext
      ? !!nav.likeChrome
      : /\bChrome\b/.test(ua) && !/internal|\n/i.test(toString.toString());

    /** Internal `[[Class]]` value shortcuts. */
    var objectClass = 'Object',
        airRuntimeClass = isCustomContext ? objectClass : 'ScriptBridgingProxyObject',
        enviroClass = isCustomContext ? objectClass : 'Environment',
        javaClass = (isCustomContext && context.java) ? 'JavaPackage' : getClassOf(context.java),
        phantomClass = isCustomContext ? objectClass : 'RuntimeObject';

    /** Detect Java environments. */
    var java = /\bJava/.test(javaClass) && context.java;

    /** Detect Rhino. */
    var rhino = java && getClassOf(context.environment) == enviroClass;

    /** A character to represent alpha. */
    var alpha = java ? 'a' : '\u03b1';

    /** A character to represent beta. */
    var beta = java ? 'b' : '\u03b2';

    /** Browser document object. */
    var doc = context.document || {};

    /**
     * Detect Opera browser (Presto-based).
     * http://www.howtocreate.co.uk/operaStuff/operaObject.html
     * http://dev.opera.com/articles/view/opera-mini-web-content-authoring-guidelines/#operamini
     */
    var opera = context.operamini || context.opera;

    /** Opera `[[Class]]`. */
    var operaClass = reOpera.test(operaClass = (isCustomContext && opera) ? opera['[[Class]]'] : getClassOf(opera))
      ? operaClass
      : (opera = null);

    /*------------------------------------------------------------------------*/

    /** Temporary variable used over the script's lifetime. */
    var data;

    /** The CPU architecture. */
    var arch = ua;

    /** Platform description array. */
    var description = [];

    /** Platform alpha/beta indicator. */
    var prerelease = null;

    /** A flag to indicate that environment features should be used to resolve the platform. */
    var useFeatures = ua == userAgent;

    /** The browser/environment version. */
    var version = useFeatures && opera && typeof opera.version == 'function' && opera.version();

    /** A flag to indicate if the OS ends with "/ Version" */
    var isSpecialCasedOS;

    /* Detectable layout engines (order is important). */
    var layout = getLayout([
      { 'label': 'EdgeHTML', 'pattern': 'Edge' },
      'Trident',
      { 'label': 'WebKit', 'pattern': 'AppleWebKit' },
      'iCab',
      'Presto',
      'NetFront',
      'Tasman',
      'KHTML',
      'Gecko'
    ]);

    /* Detectable browser names (order is important). */
    var name = getName([
      'Adobe AIR',
      'Arora',
      'Avant Browser',
      'Breach',
      'Camino',
      'Epiphany',
      'Fennec',
      'Flock',
      'Galeon',
      'GreenBrowser',
      'iCab',
      'Iceweasel',
      'K-Meleon',
      'Konqueror',
      'Lunascape',
      'Maxthon',
      { 'label': 'Microsoft Edge', 'pattern': 'Edge' },
      'Midori',
      'Nook Browser',
      'PaleMoon',
      'PhantomJS',
      'Raven',
      'Rekonq',
      'RockMelt',
      'SeaMonkey',
      { 'label': 'Silk', 'pattern': '(?:Cloud9|Silk-Accelerated)' },
      'Sleipnir',
      'SlimBrowser',
      { 'label': 'SRWare Iron', 'pattern': 'Iron' },
      'Sunrise',
      'Swiftfox',
      'WebPositive',
      'Opera Mini',
      { 'label': 'Opera Mini', 'pattern': 'OPiOS' },
      'Opera',
      { 'label': 'Opera', 'pattern': 'OPR' },
      'Chrome',
      { 'label': 'Chrome Mobile', 'pattern': '(?:CriOS|CrMo)' },
      { 'label': 'Firefox', 'pattern': '(?:Firefox|Minefield)' },
      { 'label': 'Firefox for iOS', 'pattern': 'FxiOS' },
      { 'label': 'IE', 'pattern': 'IEMobile' },
      { 'label': 'IE', 'pattern': 'MSIE' },
      'Safari'
    ]);

    /* Detectable products (order is important). */
    var product = getProduct([
      { 'label': 'BlackBerry', 'pattern': 'BB10' },
      'BlackBerry',
      { 'label': 'Galaxy S', 'pattern': 'GT-I9000' },
      { 'label': 'Galaxy S2', 'pattern': 'GT-I9100' },
      { 'label': 'Galaxy S3', 'pattern': 'GT-I9300' },
      { 'label': 'Galaxy S4', 'pattern': 'GT-I9500' },
      'Google TV',
      'Lumia',
      'iPad',
      'iPod',
      'iPhone',
      'Kindle',
      { 'label': 'Kindle Fire', 'pattern': '(?:Cloud9|Silk-Accelerated)' },
      'Nexus',
      'Nook',
      'PlayBook',
      'PlayStation 3',
      'PlayStation 4',
      'PlayStation Vita',
      'TouchPad',
      'Transformer',
      { 'label': 'Wii U', 'pattern': 'WiiU' },
      'Wii',
      'Xbox One',
      { 'label': 'Xbox 360', 'pattern': 'Xbox' },
      'Xoom'
    ]);

    /* Detectable manufacturers. */
    var manufacturer = getManufacturer({
      'Apple': { 'iPad': 1, 'iPhone': 1, 'iPod': 1 },
      'Archos': {},
      'Amazon': { 'Kindle': 1, 'Kindle Fire': 1 },
      'Asus': { 'Transformer': 1 },
      'Barnes & Noble': { 'Nook': 1 },
      'BlackBerry': { 'PlayBook': 1 },
      'Google': { 'Google TV': 1, 'Nexus': 1 },
      'HP': { 'TouchPad': 1 },
      'HTC': {},
      'LG': {},
      'Microsoft': { 'Xbox': 1, 'Xbox One': 1 },
      'Motorola': { 'Xoom': 1 },
      'Nintendo': { 'Wii U': 1,  'Wii': 1 },
      'Nokia': { 'Lumia': 1 },
      'Samsung': { 'Galaxy S': 1, 'Galaxy S2': 1, 'Galaxy S3': 1, 'Galaxy S4': 1 },
      'Sony': { 'PlayStation 4': 1, 'PlayStation 3': 1, 'PlayStation Vita': 1 }
    });

    /* Detectable operating systems (order is important). */
    var os = getOS([
      'Windows Phone',
      'Android',
      'CentOS',
      { 'label': 'Chrome OS', 'pattern': 'CrOS' },
      'Debian',
      'Fedora',
      'FreeBSD',
      'Gentoo',
      'Haiku',
      'Kubuntu',
      'Linux Mint',
      'OpenBSD',
      'Red Hat',
      'SuSE',
      'Ubuntu',
      'Xubuntu',
      'Cygwin',
      'Symbian OS',
      'hpwOS',
      'webOS ',
      'webOS',
      'Tablet OS',
      'Linux',
      'Mac OS X',
      'Macintosh',
      'Mac',
      'Windows 98;',
      'Windows '
    ]);

    /*------------------------------------------------------------------------*/

    /**
     * Picks the layout engine from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected layout engine.
     */
    function getLayout(guesses) {
      return reduce(guesses, function(result, guess) {
        return result || RegExp('\\b' + (
          guess.pattern || qualify(guess)
        ) + '\\b', 'i').exec(ua) && (guess.label || guess);
      });
    }

    /**
     * Picks the manufacturer from an array of guesses.
     *
     * @private
     * @param {Array} guesses An object of guesses.
     * @returns {null|string} The detected manufacturer.
     */
    function getManufacturer(guesses) {
      return reduce(guesses, function(result, value, key) {
        // Lookup the manufacturer by product or scan the UA for the manufacturer.
        return result || (
          value[product] ||
          value[/^[a-z]+(?: +[a-z]+\b)*/i.exec(product)] ||
          RegExp('\\b' + qualify(key) + '(?:\\b|\\w*\\d)', 'i').exec(ua)
        ) && key;
      });
    }

    /**
     * Picks the browser name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected browser name.
     */
    function getName(guesses) {
      return reduce(guesses, function(result, guess) {
        return result || RegExp('\\b' + (
          guess.pattern || qualify(guess)
        ) + '\\b', 'i').exec(ua) && (guess.label || guess);
      });
    }

    /**
     * Picks the OS name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected OS name.
     */
    function getOS(guesses) {
      return reduce(guesses, function(result, guess) {
        var pattern = guess.pattern || qualify(guess);
        if (!result && (result =
              RegExp('\\b' + pattern + '(?:/[\\d.]+|[ \\w.]*)', 'i').exec(ua)
            )) {
          result = cleanupOS(result, pattern, guess.label || guess);
        }
        return result;
      });
    }

    /**
     * Picks the product name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected product name.
     */
    function getProduct(guesses) {
      return reduce(guesses, function(result, guess) {
        var pattern = guess.pattern || qualify(guess);
        if (!result && (result =
              RegExp('\\b' + pattern + ' *\\d+[.\\w_]*', 'i').exec(ua) ||
              RegExp('\\b' + pattern + '(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)', 'i').exec(ua)
            )) {
          // Split by forward slash and append product version if needed.
          if ((result = String((guess.label && !RegExp(pattern, 'i').test(guess.label)) ? guess.label : result).split('/'))[1] && !/[\d.]+/.test(result[0])) {
            result[0] += ' ' + result[1];
          }
          // Correct character case and cleanup string.
          guess = guess.label || guess;
          result = format(result[0]
            .replace(RegExp(pattern, 'i'), guess)
            .replace(RegExp('; *(?:' + guess + '[_-])?', 'i'), ' ')
            .replace(RegExp('(' + guess + ')[-_.]?(\\w)', 'i'), '$1 $2'));
        }
        return result;
      });
    }

    /**
     * Resolves the version using an array of UA patterns.
     *
     * @private
     * @param {Array} patterns An array of UA patterns.
     * @returns {null|string} The detected version.
     */
    function getVersion(patterns) {
      return reduce(patterns, function(result, pattern) {
        return result || (RegExp(pattern +
          '(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)', 'i').exec(ua) || 0)[1] || null;
      });
    }

    /**
     * Returns `platform.description` when the platform object is coerced to a string.
     *
     * @name toString
     * @memberOf platform
     * @returns {string} Returns `platform.description` if available, else an empty string.
     */
    function toStringPlatform() {
      return this.description || '';
    }

    /*------------------------------------------------------------------------*/

    // Convert layout to an array so we can add extra details.
    layout && (layout = [layout]);

    // Detect product names that contain their manufacturer's name.
    if (manufacturer && !product) {
      product = getProduct([manufacturer]);
    }
    // Clean up Google TV.
    if ((data = /\bGoogle TV\b/.exec(product))) {
      product = data[0];
    }
    // Detect simulators.
    if (/\bSimulator\b/i.test(ua)) {
      product = (product ? product + ' ' : '') + 'Simulator';
    }
    // Detect Opera Mini 8+ running in Turbo/Uncompressed mode on iOS.
    if (name == 'Opera Mini' && /\bOPiOS\b/.test(ua)) {
      description.push('running in Turbo/Uncompressed mode');
    }
    // Detect IE Mobile 11.
    if (name == 'IE' && /\blike iPhone OS\b/.test(ua)) {
      data = parse(ua.replace(/like iPhone OS/, ''));
      manufacturer = data.manufacturer;
      product = data.product;
    }
    // Detect iOS.
    else if (/^iP/.test(product)) {
      name || (name = 'Safari');
      os = 'iOS' + ((data = / OS ([\d_]+)/i.exec(ua))
        ? ' ' + data[1].replace(/_/g, '.')
        : '');
    }
    // Detect Kubuntu.
    else if (name == 'Konqueror' && !/buntu/i.test(os)) {
      os = 'Kubuntu';
    }
    // Detect Android browsers.
    else if ((manufacturer && manufacturer != 'Google' &&
        ((/Chrome/.test(name) && !/\bMobile Safari\b/i.test(ua)) || /\bVita\b/.test(product))) ||
        (/\bAndroid\b/.test(os) && /^Chrome/.test(name) && /\bVersion\//i.test(ua))) {
      name = 'Android Browser';
      os = /\bAndroid\b/.test(os) ? os : 'Android';
    }
    // Detect Silk desktop/accelerated modes.
    else if (name == 'Silk') {
      if (!/\bMobi/i.test(ua)) {
        os = 'Android';
        description.unshift('desktop mode');
      }
      if (/Accelerated *= *true/i.test(ua)) {
        description.unshift('accelerated');
      }
    }
    // Detect PaleMoon identifying as Firefox.
    else if (name == 'PaleMoon' && (data = /\bFirefox\/([\d.]+)\b/.exec(ua))) {
      description.push('identifying as Firefox ' + data[1]);
    }
    // Detect Firefox OS and products running Firefox.
    else if (name == 'Firefox' && (data = /\b(Mobile|Tablet|TV)\b/i.exec(ua))) {
      os || (os = 'Firefox OS');
      product || (product = data[1]);
    }
    // Detect false positives for Firefox/Safari.
    else if (!name || (data = !/\bMinefield\b/i.test(ua) && /\b(?:Firefox|Safari)\b/.exec(name))) {
      // Escape the `/` for Firefox 1.
      if (name && !product && /[\/,]|^[^(]+?\)/.test(ua.slice(ua.indexOf(data + '/') + 8))) {
        // Clear name of false positives.
        name = null;
      }
      // Reassign a generic name.
      if ((data = product || manufacturer || os) &&
          (product || manufacturer || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(os))) {
        name = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(os) ? os : data) + ' Browser';
      }
    }
    // Detect non-Opera (Presto-based) versions (order is important).
    if (!version) {
      version = getVersion([
        '(?:Cloud9|CriOS|CrMo|Edge|FxiOS|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|Silk(?!/[\\d.]+$))',
        'Version',
        qualify(name),
        '(?:Firefox|Minefield|NetFront)'
      ]);
    }
    // Detect stubborn layout engines.
    if ((data =
          layout == 'iCab' && parseFloat(version) > 3 && 'WebKit' ||
          /\bOpera\b/.test(name) && (/\bOPR\b/.test(ua) ? 'Blink' : 'Presto') ||
          /\b(?:Midori|Nook|Safari)\b/i.test(ua) && !/^(?:Trident|EdgeHTML)$/.test(layout) && 'WebKit' ||
          !layout && /\bMSIE\b/i.test(ua) && (os == 'Mac OS' ? 'Tasman' : 'Trident') ||
          layout == 'WebKit' && /\bPlayStation\b(?! Vita\b)/i.test(name) && 'NetFront'
        )) {
      layout = [data];
    }
    // Detect Windows Phone 7 desktop mode.
    if (name == 'IE' && (data = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(ua) || 0)[1])) {
      name += ' Mobile';
      os = 'Windows Phone ' + (/\+$/.test(data) ? data : data + '.x');
      description.unshift('desktop mode');
    }
    // Detect Windows Phone 8.x desktop mode.
    else if (/\bWPDesktop\b/i.test(ua)) {
      name = 'IE Mobile';
      os = 'Windows Phone 8.x';
      description.unshift('desktop mode');
      version || (version = (/\brv:([\d.]+)/.exec(ua) || 0)[1]);
    }
    // Detect IE 11.
    else if (name != 'IE' && layout == 'Trident' && (data = /\brv:([\d.]+)/.exec(ua))) {
      if (name) {
        description.push('identifying as ' + name + (version ? ' ' + version : ''));
      }
      name = 'IE';
      version = data[1];
    }
    // Leverage environment features.
    if (useFeatures) {
      // Detect server-side environments.
      // Rhino has a global function while others have a global object.
      if (isHostType(context, 'global')) {
        if (java) {
          data = java.lang.System;
          arch = data.getProperty('os.arch');
          os = os || data.getProperty('os.name') + ' ' + data.getProperty('os.version');
        }
        if (isModuleScope && isHostType(context, 'system') && (data = [context.system])[0]) {
          os || (os = data[0].os || null);
          try {
            data[1] = context.require('ringo/engine').version;
            version = data[1].join('.');
            name = 'RingoJS';
          } catch(e) {
            if (data[0].global.system == context.system) {
              name = 'Narwhal';
            }
          }
        }
        else if (
          typeof context.process == 'object' && !context.process.browser &&
          (data = context.process)
        ) {
          name = 'Node.js';
          arch = data.arch;
          os = data.platform;
          version = /[\d.]+/.exec(data.version)[0];
        }
        else if (rhino) {
          name = 'Rhino';
        }
      }
      // Detect Adobe AIR.
      else if (getClassOf((data = context.runtime)) == airRuntimeClass) {
        name = 'Adobe AIR';
        os = data.flash.system.Capabilities.os;
      }
      // Detect PhantomJS.
      else if (getClassOf((data = context.phantom)) == phantomClass) {
        name = 'PhantomJS';
        version = (data = data.version || null) && (data.major + '.' + data.minor + '.' + data.patch);
      }
      // Detect IE compatibility modes.
      else if (typeof doc.documentMode == 'number' && (data = /\bTrident\/(\d+)/i.exec(ua))) {
        // We're in compatibility mode when the Trident version + 4 doesn't
        // equal the document mode.
        version = [version, doc.documentMode];
        if ((data = +data[1] + 4) != version[1]) {
          description.push('IE ' + version[1] + ' mode');
          layout && (layout[1] = '');
          version[1] = data;
        }
        version = name == 'IE' ? String(version[1].toFixed(1)) : version[0];
      }
      os = os && format(os);
    }
    // Detect prerelease phases.
    if (version && (data =
          /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(version) ||
          /(?:alpha|beta)(?: ?\d)?/i.exec(ua + ';' + (useFeatures && nav.appMinorVersion)) ||
          /\bMinefield\b/i.test(ua) && 'a'
        )) {
      prerelease = /b/i.test(data) ? 'beta' : 'alpha';
      version = version.replace(RegExp(data + '\\+?$'), '') +
        (prerelease == 'beta' ? beta : alpha) + (/\d+\+?/.exec(data) || '');
    }
    // Detect Firefox Mobile.
    if (name == 'Fennec' || name == 'Firefox' && /\b(?:Android|Firefox OS)\b/.test(os)) {
      name = 'Firefox Mobile';
    }
    // Obscure Maxthon's unreliable version.
    else if (name == 'Maxthon' && version) {
      version = version.replace(/\.[\d.]+/, '.x');
    }
    // Detect Xbox 360 and Xbox One.
    else if (/\bXbox\b/i.test(product)) {
      os = null;
      if (product == 'Xbox 360' && /\bIEMobile\b/.test(ua)) {
        description.unshift('mobile mode');
      }
    }
    // Add mobile postfix.
    else if ((/^(?:Chrome|IE|Opera)$/.test(name) || name && !product && !/Browser|Mobi/.test(name)) &&
        (os == 'Windows CE' || /Mobi/i.test(ua))) {
      name += ' Mobile';
    }
    // Detect IE platform preview.
    else if (name == 'IE' && useFeatures && context.external === null) {
      description.unshift('platform preview');
    }
    // Detect BlackBerry OS version.
    // http://docs.blackberry.com/en/developers/deliverables/18169/HTTP_headers_sent_by_BB_Browser_1234911_11.jsp
    else if ((/\bBlackBerry\b/.test(product) || /\bBB10\b/.test(ua)) && (data =
          (RegExp(product.replace(/ +/g, ' *') + '/([.\\d]+)', 'i').exec(ua) || 0)[1] ||
          version
        )) {
      data = [data, /BB10/.test(ua)];
      os = (data[1] ? (product = null, manufacturer = 'BlackBerry') : 'Device Software') + ' ' + data[0];
      version = null;
    }
    // Detect Opera identifying/masking itself as another browser.
    // http://www.opera.com/support/kb/view/843/
    else if (this != forOwn && product != 'Wii' && (
          (useFeatures && opera) ||
          (/Opera/.test(name) && /\b(?:MSIE|Firefox)\b/i.test(ua)) ||
          (name == 'Firefox' && /\bOS X (?:\d+\.){2,}/.test(os)) ||
          (name == 'IE' && (
            (os && !/^Win/.test(os) && version > 5.5) ||
            /\bWindows XP\b/.test(os) && version > 8 ||
            version == 8 && !/\bTrident\b/.test(ua)
          ))
        ) && !reOpera.test((data = parse.call(forOwn, ua.replace(reOpera, '') + ';'))) && data.name) {
      // When "identifying", the UA contains both Opera and the other browser's name.
      data = 'ing as ' + data.name + ((data = data.version) ? ' ' + data : '');
      if (reOpera.test(name)) {
        if (/\bIE\b/.test(data) && os == 'Mac OS') {
          os = null;
        }
        data = 'identify' + data;
      }
      // When "masking", the UA contains only the other browser's name.
      else {
        data = 'mask' + data;
        if (operaClass) {
          name = format(operaClass.replace(/([a-z])([A-Z])/g, '$1 $2'));
        } else {
          name = 'Opera';
        }
        if (/\bIE\b/.test(data)) {
          os = null;
        }
        if (!useFeatures) {
          version = null;
        }
      }
      layout = ['Presto'];
      description.push(data);
    }
    // Detect WebKit Nightly and approximate Chrome/Safari versions.
    if ((data = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
      // Correct build number for numeric comparison.
      // (e.g. "532.5" becomes "532.05")
      data = [parseFloat(data.replace(/\.(\d)$/, '.0$1')), data];
      // Nightly builds are postfixed with a "+".
      if (name == 'Safari' && data[1].slice(-1) == '+') {
        name = 'WebKit Nightly';
        prerelease = 'alpha';
        version = data[1].slice(0, -1);
      }
      // Clear incorrect browser versions.
      else if (version == data[1] ||
          version == (data[2] = (/\bSafari\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
        version = null;
      }
      // Use the full Chrome version when available.
      data[1] = (/\bChrome\/([\d.]+)/i.exec(ua) || 0)[1];
      // Detect Blink layout engine.
      if (data[0] == 537.36 && data[2] == 537.36 && parseFloat(data[1]) >= 28 && layout == 'WebKit') {
        layout = ['Blink'];
      }
      // Detect JavaScriptCore.
      // http://stackoverflow.com/questions/6768474/how-can-i-detect-which-javascript-engine-v8-or-jsc-is-used-at-runtime-in-androi
      if (!useFeatures || (!likeChrome && !data[1])) {
        layout && (layout[1] = 'like Safari');
        data = (data = data[0], data < 400 ? 1 : data < 500 ? 2 : data < 526 ? 3 : data < 533 ? 4 : data < 534 ? '4+' : data < 535 ? 5 : data < 537 ? 6 : data < 538 ? 7 : data < 601 ? 8 : '8');
      } else {
        layout && (layout[1] = 'like Chrome');
        data = data[1] || (data = data[0], data < 530 ? 1 : data < 532 ? 2 : data < 532.05 ? 3 : data < 533 ? 4 : data < 534.03 ? 5 : data < 534.07 ? 6 : data < 534.10 ? 7 : data < 534.13 ? 8 : data < 534.16 ? 9 : data < 534.24 ? 10 : data < 534.30 ? 11 : data < 535.01 ? 12 : data < 535.02 ? '13+' : data < 535.07 ? 15 : data < 535.11 ? 16 : data < 535.19 ? 17 : data < 536.05 ? 18 : data < 536.10 ? 19 : data < 537.01 ? 20 : data < 537.11 ? '21+' : data < 537.13 ? 23 : data < 537.18 ? 24 : data < 537.24 ? 25 : data < 537.36 ? 26 : layout != 'Blink' ? '27' : '28');
      }
      // Add the postfix of ".x" or "+" for approximate versions.
      layout && (layout[1] += ' ' + (data += typeof data == 'number' ? '.x' : /[.+]/.test(data) ? '' : '+'));
      // Obscure version for some Safari 1-2 releases.
      if (name == 'Safari' && (!version || parseInt(version) > 45)) {
        version = data;
      }
    }
    // Detect Opera desktop modes.
    if (name == 'Opera' &&  (data = /\bzbov|zvav$/.exec(os))) {
      name += ' ';
      description.unshift('desktop mode');
      if (data == 'zvav') {
        name += 'Mini';
        version = null;
      } else {
        name += 'Mobile';
      }
      os = os.replace(RegExp(' *' + data + '$'), '');
    }
    // Detect Chrome desktop mode.
    else if (name == 'Safari' && /\bChrome\b/.exec(layout && layout[1])) {
      description.unshift('desktop mode');
      name = 'Chrome Mobile';
      version = null;

      if (/\bOS X\b/.test(os)) {
        manufacturer = 'Apple';
        os = 'iOS 4.3+';
      } else {
        os = null;
      }
    }
    // Strip incorrect OS versions.
    if (version && version.indexOf((data = /[\d.]+$/.exec(os))) == 0 &&
        ua.indexOf('/' + data + '-') > -1) {
      os = trim(os.replace(data, ''));
    }
    // Add layout engine.
    if (layout && !/\b(?:Avant|Nook)\b/.test(name) && (
        /Browser|Lunascape|Maxthon/.test(name) ||
        name != 'Safari' && /^iOS/.test(os) && /\bSafari\b/.test(layout[1]) ||
        /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Sleipnir|Web)/.test(name) && layout[1])) {
      // Don't add layout details to description if they are falsey.
      (data = layout[layout.length - 1]) && description.push(data);
    }
    // Combine contextual information.
    if (description.length) {
      description = ['(' + description.join('; ') + ')'];
    }
    // Append manufacturer to description.
    if (manufacturer && product && product.indexOf(manufacturer) < 0) {
      description.push('on ' + manufacturer);
    }
    // Append product to description.
    if (product) {
      description.push((/^on /.test(description[description.length - 1]) ? '' : 'on ') + product);
    }
    // Parse the OS into an object.
    if (os) {
      data = / ([\d.+]+)$/.exec(os);
      isSpecialCasedOS = data && os.charAt(os.length - data[0].length - 1) == '/';
      os = {
        'architecture': 32,
        'family': (data && !isSpecialCasedOS) ? os.replace(data[0], '') : os,
        'version': data ? data[1] : null,
        'toString': function() {
          var version = this.version;
          return this.family + ((version && !isSpecialCasedOS) ? ' ' + version : '') + (this.architecture == 64 ? ' 64-bit' : '');
        }
      };
    }
    // Add browser/OS architecture.
    if ((data = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(arch)) && !/\bi686\b/i.test(arch)) {
      if (os) {
        os.architecture = 64;
        os.family = os.family.replace(RegExp(' *' + data), '');
      }
      if (
          name && (/\bWOW64\b/i.test(ua) ||
          (useFeatures && /\w(?:86|32)$/.test(nav.cpuClass || nav.platform) && !/\bWin64; x64\b/i.test(ua)))
      ) {
        description.unshift('32-bit');
      }
    }
    // Chrome 39 and above on OS X is always 64-bit.
    else if (
        os && /^OS X/.test(os.family) &&
        name == 'Chrome' && parseFloat(version) >= 39
    ) {
      os.architecture = 64;
    }

    ua || (ua = null);

    /*------------------------------------------------------------------------*/

    /**
     * The platform object.
     *
     * @name platform
     * @type Object
     */
    var platform = {};

    /**
     * The platform description.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.description = ua;

    /**
     * The name of the browser's layout engine.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.layout = layout && layout[0];

    /**
     * The name of the product's manufacturer.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.manufacturer = manufacturer;

    /**
     * The name of the browser/environment.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.name = name;

    /**
     * The alpha/beta release indicator.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.prerelease = prerelease;

    /**
     * The name of the product hosting the browser.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.product = product;

    /**
     * The browser's user agent string.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.ua = ua;

    /**
     * The browser/environment version.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.version = name && version;

    /**
     * The name of the operating system.
     *
     * @memberOf platform
     * @type Object
     */
    platform.os = os || {

      /**
       * The CPU architecture the OS is built for.
       *
       * @memberOf platform.os
       * @type number|null
       */
      'architecture': null,

      /**
       * The family of the OS.
       *
       * Common values include:
       * "Windows", "Windows Server 2008 R2 / 7", "Windows Server 2008 / Vista",
       * "Windows XP", "OS X", "Ubuntu", "Debian", "Fedora", "Red Hat", "SuSE",
       * "Android", "iOS" and "Windows Phone"
       *
       * @memberOf platform.os
       * @type string|null
       */
      'family': null,

      /**
       * The version of the OS.
       *
       * @memberOf platform.os
       * @type string|null
       */
      'version': null,

      /**
       * Returns the OS string.
       *
       * @memberOf platform.os
       * @returns {string} The OS string.
       */
      'toString': function() { return 'null'; }
    };

    platform.parse = parse;
    platform.toString = toStringPlatform;

    if (platform.version) {
      description.unshift(version);
    }
    if (platform.name) {
      description.unshift(name);
    }
    if (os && name && !(os == String(os).split(' ')[0] && (os == name.split(' ')[0] || product))) {
      description.push(product ? '(' + os + ')' : 'on ' + os);
    }
    if (description.length) {
      platform.description = description.join(' ');
    }
    return platform;
  }

  /*--------------------------------------------------------------------------*/

  // Export platform.
  var platform = parse();

  // Some AMD build optimizers, like r.js, check for condition patterns like the following:
  if (true) {
    // Expose platform on the global object to prevent errors when platform is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    root.platform = platform;

    // Define as an anonymous module so platform can be aliased through path mapping.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return platform;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
  else if (freeExports && freeModule) {
    // Export for CommonJS support.
    forOwn(platform, function(value, key) {
      freeExports[key] = value;
    });
  }
  else {
    // Export to the global object.
    root.platform = platform;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)(module), __webpack_require__(16)))

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16), __webpack_require__(419)))

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Sister;

/**
* @link https://github.com/gajus/sister for the canonical source repository
* @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
*/
Sister = function () {
    var sister = {},
        events = {};

    /**
     * @name handler
     * @function
     * @param {Object} data Event data.
     */

    /**
     * @param {String} name Event name.
     * @param {handler} handler
     * @return {listener}
     */
    sister.on = function (name, handler) {
        var listener = {name: name, handler: handler};
        events[name] = events[name] || [];
        events[name].unshift(listener);
        return listener;
    };

    /**
     * @param {listener}
     */
    sister.off = function (listener) {
        var index = events[listener.name].indexOf(listener);

        if (index !== -1) {
            events[listener.name].splice(index, 1);
        }
    };

    /**
     * @param {String} name Event name.
     * @param {Object} data Event data.
     */
    sister.trigger = function (name, data) {
        var listeners = events[name],
            i;

        if (listeners) {
            i = listeners.length;
            while (i--) {
                listeners[i].handler(data);
            }
        }
    };

    return sister;
};

module.exports = Sister;


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(796);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),
/* 800 */,
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PlayerStates = __webpack_require__(803);

var _PlayerStates2 = _interopRequireDefault(_PlayerStates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  pauseVideo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PAUSED],
    stateChangeRequired: false
  },
  playVideo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING],
    stateChangeRequired: false
  },
  seekTo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING, _PlayerStates2.default.PAUSED],
    stateChangeRequired: true,

    // TRICKY: `seekTo` may not cause a state change if no buffering is
    // required.
    timeout: 3000
  }
};
module.exports = exports['default'];

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _debug = __webpack_require__(785);

var _debug2 = _interopRequireDefault(_debug);

var _functionNames = __webpack_require__(805);

var _functionNames2 = _interopRequireDefault(_functionNames);

var _eventNames = __webpack_require__(804);

var _eventNames2 = _interopRequireDefault(_eventNames);

var _FunctionStateMap = __webpack_require__(801);

var _FunctionStateMap2 = _interopRequireDefault(_FunctionStateMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debug = (0, _debug2.default)('youtube-player');

var YouTubePlayer = {};

/**
 * Construct an object that defines an event handler for all of the YouTube
 * player events. Proxy captured events through an event emitter.
 *
 * @todo Capture event parameters.
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 */
YouTubePlayer.proxyEvents = function (emitter) {
  var events = {};

  var _loop = function _loop(eventName) {
    var onEventName = 'on' + eventName.slice(0, 1).toUpperCase() + eventName.slice(1);

    events[onEventName] = function (event) {
      debug('event "%s"', onEventName, event);

      emitter.trigger(eventName, event);
    };
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _eventNames2.default[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var eventName = _step.value;

      _loop(eventName);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return events;
};

/**
 * Delays player API method execution until player state is ready.
 *
 * @todo Proxy all of the methods using Object.keys.
 * @todo See TRICKY below.
 * @param playerAPIReady Promise that resolves when player is ready.
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions.
 * @returns {Object}
 */
YouTubePlayer.promisifyPlayer = function (playerAPIReady) {
  var strictState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var functions = {};

  var _loop2 = function _loop2(functionName) {
    if (strictState && _FunctionStateMap2.default[functionName]) {
      functions[functionName] = function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return playerAPIReady.then(function (player) {
          var stateInfo = _FunctionStateMap2.default[functionName];
          var playerState = player.getPlayerState();

          // eslint-disable-next-line no-warning-comments
          // TODO: Just spread the args into the function once Babel is fixed:
          // https://github.com/babel/babel/issues/4270
          //
          // eslint-disable-next-line prefer-spread
          var value = player[functionName].apply(player, args);

          // TRICKY: For functions like `seekTo`, a change in state must be
          // triggered given that the resulting state could match the initial
          // state.
          if (stateInfo.stateChangeRequired ||

          // eslint-disable-next-line no-extra-parens
          Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerState) === -1) {
            return new Promise(function (resolve) {
              var onPlayerStateChange = function onPlayerStateChange() {
                var playerStateAfterChange = player.getPlayerState();

                var timeout = void 0;

                if (typeof stateInfo.timeout === 'number') {
                  timeout = setTimeout(function () {
                    player.removeEventListener('onStateChange', onPlayerStateChange);

                    resolve();
                  }, stateInfo.timeout);
                }

                if (Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerStateAfterChange) !== -1) {
                  player.removeEventListener('onStateChange', onPlayerStateChange);

                  clearTimeout(timeout);

                  resolve();
                }
              };

              player.addEventListener('onStateChange', onPlayerStateChange);
            }).then(function () {
              return value;
            });
          }

          return value;
        });
      };
    } else {
      functions[functionName] = function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return playerAPIReady.then(function (player) {
          // eslint-disable-next-line no-warning-comments
          // TODO: Just spread the args into the function once Babel is fixed:
          // https://github.com/babel/babel/issues/4270
          //
          // eslint-disable-next-line prefer-spread
          return player[functionName].apply(player, args);
        });
      };
    }
  };

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = _functionNames2.default[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var functionName = _step2.value;

      _loop2(functionName);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return functions;
};

exports.default = YouTubePlayer;
module.exports = exports['default'];

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  BUFFERING: 3,
  ENDED: 0,
  PAUSED: 2,
  PLAYING: 1,
  UNSTARTED: -1,
  VIDEO_CUED: 5
};
module.exports = exports["default"];

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 */
exports.default = ['ready', 'stateChange', 'playbackQualityChange', 'playbackRateChange', 'error', 'apiChange'];
module.exports = exports['default'];

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Functions
 */
exports.default = ['cueVideoById', 'loadVideoById', 'cueVideoByUrl', 'loadVideoByUrl', 'playVideo', 'pauseVideo', 'stopVideo', 'getVideoLoadedFraction', 'cuePlaylist', 'loadPlaylist', 'nextVideo', 'previousVideo', 'playVideoAt', 'setShuffle', 'setLoop', 'getPlaylist', 'getPlaylistIndex', 'setOption', 'mute', 'unMute', 'isMuted', 'setVolume', 'getVolume', 'seekTo', 'getPlayerState', 'getPlaybackRate', 'setPlaybackRate', 'getAvailablePlaybackRates', 'getPlaybackQuality', 'setPlaybackQuality', 'getAvailableQualityLevels', 'getCurrentTime', 'getDuration', 'removeEventListener', 'getVideoUrl', 'getVideoEmbedCode', 'getOptions', 'getOption', 'addEventListener', 'destroy', 'setSize', 'getIframe'];
module.exports = exports['default'];

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _sister = __webpack_require__(797);

var _sister2 = _interopRequireDefault(_sister);

var _loadYouTubeIframeApi = __webpack_require__(807);

var _loadYouTubeIframeApi2 = _interopRequireDefault(_loadYouTubeIframeApi);

var _YouTubePlayer = __webpack_require__(802);

var _YouTubePlayer2 = _interopRequireDefault(_YouTubePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @typedef YT.Player
 * @see https://developers.google.com/youtube/iframe_api_reference
 * */

/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
 */
var youtubeIframeAPI = void 0;

/**
 * A factory function used to produce an instance of YT.Player and queue function calls and proxy events of the resulting object.
 *
 * @param elementId Either An existing YT.Player instance,
 * the DOM element or the id of the HTML element where the API will insert an <iframe>.
 * @param options See `options` (Ignored when using an existing YT.Player instance).
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions. Default: `false`.
 * See `FunctionStateMap.js` for supported functions and acceptable states.
 */

exports.default = function (maybeElementId) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var strictState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var emitter = (0, _sister2.default)();

  if (!youtubeIframeAPI) {
    youtubeIframeAPI = (0, _loadYouTubeIframeApi2.default)();
  }

  if (options.events) {
    throw new Error('Event handlers cannot be overwritten.');
  }

  if (typeof maybeElementId === 'string' && !document.getElementById(maybeElementId)) {
    throw new Error('Element "' + maybeElementId + '" does not exist.');
  }

  options.events = _YouTubePlayer2.default.proxyEvents(emitter);

  var playerAPIReady = new Promise(function (resolve) {
    if (typeof maybeElementId === 'string' || maybeElementId instanceof HTMLElement) {
      // eslint-disable-next-line promise/catch-or-return
      youtubeIframeAPI.then(function (YT) {
        var player = new YT.Player(maybeElementId, options);

        emitter.on('ready', function () {
          resolve(player);
        });

        return null;
      });
    } else if ((typeof maybeElementId === 'undefined' ? 'undefined' : _typeof(maybeElementId)) === 'object' && maybeElementId.playVideo instanceof Function) {
      var player = maybeElementId;

      resolve(player);
    } else {
      throw new TypeError('Unexpected state.');
    }
  });

  var playerApi = _YouTubePlayer2.default.promisifyPlayer(playerAPIReady, strictState);

  playerApi.on = emitter.on;
  playerApi.off = emitter.off;

  return playerApi;
};

module.exports = exports['default'];

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loadScript = __webpack_require__(791);

var _loadScript2 = _interopRequireDefault(_loadScript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  /**
   * A promise that is resolved when window.onYouTubeIframeAPIReady is called.
   * The promise is resolved with a reference to window.YT object.
   */
  var iframeAPIReady = new Promise(function (resolve) {
    if (window.YT && window.YT.Player && window.YT.Player instanceof Function) {
      resolve(window.YT);

      return;
    }

    var previous = window.onYouTubeIframeAPIReady;

    // The API will call this function when page has finished downloading
    // the JavaScript for the player API.
    window.onYouTubeIframeAPIReady = function () {
      if (previous) {
        previous();
      }

      resolve(window.YT);
    };
  });

  var protocol = window.location.protocol === 'http:' ? 'http:' : 'https:';

  (0, _loadScript2.default)(protocol + '//www.youtube.com/iframe_api');

  return iframeAPIReady;
};

module.exports = exports['default'];

/***/ })
],[581]);


// WEBPACK FOOTER //
// main.js